import React__default, { memo, forwardRef, useState, useRef, useEffect, Children, Fragment, useLayoutEffect, useCallback, createElement, isValidElement, cloneElement, useMemo } from 'react';
import { AnimatePresence, motion, useAnimation } from 'framer-motion';
import mergeRefs from 'react-merge-refs';
import DOMPurify from 'dompurify';
import Lottie from 'lottie-web';
import ReactDOM__default, { createPortal } from 'react-dom';
import ReactResizeDetector, { useResizeDetector } from 'react-resize-detector';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import highchartsAccessibility from 'highcharts/modules/accessibility';
import { distance, clamp } from '@popmotion/popcorn';
import arrayMove from 'array-move';
import { FixedSizeList } from 'react-window';
import InfiniteLoader from 'react-window-infinite-loader';
/**
@license @nocompile
Copyright (c) 2018 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/

(function () {
  (function () {
    if (void 0 === window.Reflect || void 0 === window.customElements || window.customElements.polyfillWrapFlushCallback) return;
    const a = HTMLElement;
    window.HTMLElement = {
      HTMLElement: function HTMLElement() {
        return Reflect.construct(a, [], this.constructor);
      }
    }.HTMLElement, HTMLElement.prototype = a.prototype, HTMLElement.prototype.constructor = HTMLElement, Object.setPrototypeOf(HTMLElement, a);
  })();
})();
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise */


var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign2 = function __assign() {
  _assign2 = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return _assign2.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];

      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;

        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };

        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;

        case 7:
          op = _.ops.pop();

          _.trys.pop();

          continue;

        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }

          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }

          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }

          if (t && _.label < t[2]) {
            _.label = t[2];

            _.ops.push(op);

            break;
          }

          if (t[2]) _.ops.pop();

          _.trys.pop();

          continue;
      }

      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
}

function __spreadArray(to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];

  return to;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */


var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};
var reactJsxRuntime_production_min = createCommonjsModule(function (module, exports) {
  var g = 60103;
  exports.Fragment = 60107;

  if ("function" === typeof Symbol && Symbol.for) {
    var h = Symbol.for;
    g = h("react.element");
    exports.Fragment = h("react.fragment");
  }

  var m = React__default.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
      n = Object.prototype.hasOwnProperty,
      p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  };

  function q(c, a, k) {
    var b,
        d = {},
        e = null,
        l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);

    for (b in a) n.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);

    if (c && c.defaultProps) for (b in a = c.defaultProps, a) void 0 === d[b] && (d[b] = a[b]);
    return {
      $$typeof: g,
      type: c,
      key: e,
      ref: l,
      props: d,
      _owner: m.current
    };
  }

  exports.jsx = q;
  exports.jsxs = q;
});
var reactJsxRuntime_production_min_1 = reactJsxRuntime_production_min.Fragment;
var reactJsxRuntime_production_min_2 = reactJsxRuntime_production_min.jsx;
var reactJsxRuntime_production_min_3 = reactJsxRuntime_production_min.jsxs;
var reactJsxRuntime_development = createCommonjsModule(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      var React = React__default;
      var _assign = objectAssign; // ATTENTION
      // When adding new symbols to this file,
      // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.

      var REACT_ELEMENT_TYPE = 0xeac7;
      var REACT_PORTAL_TYPE = 0xeaca;
      exports.Fragment = 0xeacb;
      var REACT_STRICT_MODE_TYPE = 0xeacc;
      var REACT_PROFILER_TYPE = 0xead2;
      var REACT_PROVIDER_TYPE = 0xeacd;
      var REACT_CONTEXT_TYPE = 0xeace;
      var REACT_FORWARD_REF_TYPE = 0xead0;
      var REACT_SUSPENSE_TYPE = 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = 0xead8;
      var REACT_MEMO_TYPE = 0xead3;
      var REACT_LAZY_TYPE = 0xead4;
      var REACT_BLOCK_TYPE = 0xead9;
      var REACT_SERVER_BLOCK_TYPE = 0xeada;
      var REACT_FUNDAMENTAL_TYPE = 0xead5;
      var REACT_SCOPE_TYPE = 0xead7;
      var REACT_OPAQUE_ID_TYPE = 0xeae0;
      var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
      var REACT_OFFSCREEN_TYPE = 0xeae2;
      var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

      if (typeof Symbol === 'function' && Symbol.for) {
        var symbolFor = Symbol.for;
        REACT_ELEMENT_TYPE = symbolFor('react.element');
        REACT_PORTAL_TYPE = symbolFor('react.portal');
        exports.Fragment = symbolFor('react.fragment');
        REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
        REACT_PROFILER_TYPE = symbolFor('react.profiler');
        REACT_PROVIDER_TYPE = symbolFor('react.provider');
        REACT_CONTEXT_TYPE = symbolFor('react.context');
        REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
        REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
        REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
        REACT_MEMO_TYPE = symbolFor('react.memo');
        REACT_LAZY_TYPE = symbolFor('react.lazy');
        REACT_BLOCK_TYPE = symbolFor('react.block');
        REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
        REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
        REACT_SCOPE_TYPE = symbolFor('react.scope');
        REACT_OPAQUE_ID_TYPE = symbolFor('react.opaque.id');
        REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
        REACT_OFFSCREEN_TYPE = symbolFor('react.offscreen');
        REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
      }

      var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = '@@iterator';

      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') {
          return null;
        }

        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

        if (typeof maybeIterator === 'function') {
          return maybeIterator;
        }

        return null;
      }

      var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

      function error(format) {
        {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          printWarning('error', format, args);
        }
      }

      function printWarning(level, format, args) {
        // When changing this logic, you might want to also
        // update consoleWithStackDev.www.js as well.
        {
          var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame.getStackAddendum();

          if (stack !== '') {
            format += '%s';
            args = args.concat([stack]);
          }

          var argsWithFormat = args.map(function (item) {
            return '' + item;
          }); // Careful: RN currently depends on this prefix

          argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
          // breaks IE9: https://github.com/facebook/react/issues/13610
          // eslint-disable-next-line react-internal/no-production-logging

          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      } // Filter certain DOM attributes (e.g. src, href) if their values are empty strings.


      var enableScopeAPI = false; // Experimental Create Event Handle API.

      function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') {
          return true;
        } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


        if (type === exports.Fragment || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) {
          return true;
        }

        if (typeof type === 'object' && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
            return true;
          }
        }

        return false;
      }

      function getWrappedName(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || '';
        return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
      }

      function getContextName(type) {
        return type.displayName || 'Context';
      }

      function getComponentName(type) {
        if (type == null) {
          // Host root, text node or just invalid type.
          return null;
        }

        {
          if (typeof type.tag === 'number') {
            error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
          }
        }

        if (typeof type === 'function') {
          return type.displayName || type.name || null;
        }

        if (typeof type === 'string') {
          return type;
        }

        switch (type) {
          case exports.Fragment:
            return 'Fragment';

          case REACT_PORTAL_TYPE:
            return 'Portal';

          case REACT_PROFILER_TYPE:
            return 'Profiler';

          case REACT_STRICT_MODE_TYPE:
            return 'StrictMode';

          case REACT_SUSPENSE_TYPE:
            return 'Suspense';

          case REACT_SUSPENSE_LIST_TYPE:
            return 'SuspenseList';
        }

        if (typeof type === 'object') {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + '.Consumer';

            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + '.Provider';

            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, 'ForwardRef');

            case REACT_MEMO_TYPE:
              return getComponentName(type.type);

            case REACT_BLOCK_TYPE:
              return getComponentName(type._render);

            case REACT_LAZY_TYPE:
              {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;

                try {
                  return getComponentName(init(payload));
                } catch (x) {
                  return null;
                }
              }
          }
        }

        return null;
      } // Helpers to patch console.logs to avoid logging during side-effect free
      // replaying on render function. This currently only patches the object
      // lazily which won't cover if the log function was extracted eagerly.
      // We could also eagerly patch the method.


      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;

      function disabledLog() {}

      disabledLog.__reactDisabledLog = true;

      function disableLogs() {
        {
          if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            }; // $FlowFixMe Flow thinks console is immutable.

            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
            /* eslint-enable react-internal/no-production-logging */
          }

          disabledDepth++;
        }
      }

      function reenableLogs() {
        {
          disabledDepth--;

          if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            }; // $FlowFixMe Flow thinks console is immutable.

            Object.defineProperties(console, {
              log: _assign({}, props, {
                value: prevLog
              }),
              info: _assign({}, props, {
                value: prevInfo
              }),
              warn: _assign({}, props, {
                value: prevWarn
              }),
              error: _assign({}, props, {
                value: prevError
              }),
              group: _assign({}, props, {
                value: prevGroup
              }),
              groupCollapsed: _assign({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: _assign({}, props, {
                value: prevGroupEnd
              })
            });
            /* eslint-enable react-internal/no-production-logging */
          }

          if (disabledDepth < 0) {
            error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
          }
        }
      }

      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix;

      function describeBuiltInComponentFrame(name, source, ownerFn) {
        {
          if (prefix === undefined) {
            // Extract the VM specific prefix used by each line.
            try {
              throw Error();
            } catch (x) {
              var match = x.stack.trim().match(/\n( *(at )?)/);
              prefix = match && match[1] || '';
            }
          } // We use the prefix to ensure our stacks line up with native stack frames.


          return '\n' + prefix + name;
        }
      }

      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }

      function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) {
          return '';
        }

        {
          var frame = componentFrameCache.get(fn);

          if (frame !== undefined) {
            return frame;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
          // for warnings.

          ReactCurrentDispatcher.current = null;
          disableLogs();
        }

        try {
          // This should throw.
          if (construct) {
            // Something should be setting the props in the constructor.
            var Fake = function Fake() {
              throw Error();
            }; // $FlowFixMe


            Object.defineProperty(Fake.prototype, 'props', {
              set: function set() {
                // We use a throwing setter instead of frozen or non-writable props
                // because that won't throw in a non-strict mode function.
                throw Error();
              }
            });

            if (typeof Reflect === 'object' && Reflect.construct) {
              // We construct a different control for this case to include any extra
              // frames added by the construct call.
              try {
                Reflect.construct(Fake, []);
              } catch (x) {
                control = x;
              }

              Reflect.construct(fn, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x) {
                control = x;
              }

              fn.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x) {
              control = x;
            }

            fn();
          }
        } catch (sample) {
          // This is inlined manually because closure doesn't do it for us.
          if (sample && control && typeof sample.stack === 'string') {
            // This extracts the first frame from the sample that isn't also in the control.
            // Skipping one frame that we assume is the frame that calls the two.
            var sampleLines = sample.stack.split('\n');
            var controlLines = control.stack.split('\n');
            var s = sampleLines.length - 1;
            var c = controlLines.length - 1;

            while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
              // We expect at least one stack frame to be shared.
              // Typically this will be the root most one. However, stack frames may be
              // cut off due to maximum stack limits. In this case, one maybe cut off
              // earlier than the other. We assume that the sample is longer or the same
              // and there for cut off earlier. So we should find the root most frame in
              // the sample somewhere in the control.
              c--;
            }

            for (; s >= 1 && c >= 0; s--, c--) {
              // Next we find the first one that isn't the same which should be the
              // frame that called our sample function and the control.
              if (sampleLines[s] !== controlLines[c]) {
                // In V8, the first line is describing the message but other VMs don't.
                // If we're about to return the first line, and the control is also on the same
                // line, that's a pretty good indicator that our sample threw at same line as
                // the control. I.e. before we entered the sample frame. So we ignore this result.
                // This can happen if you passed a class to function component, or non-function.
                if (s !== 1 || c !== 1) {
                  do {
                    s--;
                    c--; // We may still have similar intermediate frames from the construct call.
                    // The next one that isn't the same should be our match though.

                    if (c < 0 || sampleLines[s] !== controlLines[c]) {
                      // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                      var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');

                      {
                        if (typeof fn === 'function') {
                          componentFrameCache.set(fn, _frame);
                        }
                      } // Return the line we found.

                      return _frame;
                    }
                  } while (s >= 1 && c >= 0);
                }

                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.


        var name = fn ? fn.displayName || fn.name : '';
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
        {
          if (typeof fn === 'function') {
            componentFrameCache.set(fn, syntheticFrame);
          }
        }
        return syntheticFrame;
      }

      function describeFunctionComponentFrame(fn, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn, false);
        }
      }

      function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
      }

      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return '';
        }

        if (typeof type === 'function') {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }

        if (typeof type === 'string') {
          return describeBuiltInComponentFrame(type);
        }

        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame('Suspense');

          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame('SuspenseList');
        }

        if (typeof type === 'object') {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);

            case REACT_MEMO_TYPE:
              // Memo may contain any component type so we recursively resolve it.
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

            case REACT_BLOCK_TYPE:
              return describeFunctionComponentFrame(type._render);

            case REACT_LAZY_TYPE:
              {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;

                try {
                  // Lazy may contain any component type so we recursively resolve it.
                  return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
              }
          }
        }

        return '';
      }

      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null);
          }
        }
      }

      function checkPropTypes(typeSpecs, values, location, componentName, element) {
        {
          // $FlowFixMe This is okay but Flow doesn't know it.
          var has = Function.call.bind(Object.prototype.hasOwnProperty);

          for (var typeSpecName in typeSpecs) {
            if (has(typeSpecs, typeSpecName)) {
              var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
              // fail the render phase where it didn't fail before. So we log it.
              // After these have been cleaned up, we'll let them throw.

              try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== 'function') {
                  var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                  err.name = 'Invariant Violation';
                  throw err;
                }

                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
              } catch (ex) {
                error$1 = ex;
              }

              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
              }

              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error('Failed %s type: %s', location, error$1.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }

      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
      };
      var specialPropKeyWarningShown;
      var specialPropRefWarningShown;
      var didWarnAboutStringRefs;
      {
        didWarnAboutStringRefs = {};
      }

      function hasValidRef(config) {
        {
          if (hasOwnProperty.call(config, 'ref')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.ref !== undefined;
      }

      function hasValidKey(config) {
        {
          if (hasOwnProperty.call(config, 'key')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.key !== undefined;
      }

      function warnIfStringRefCannotBeAutoConverted(config, self) {
        {
          if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
            var componentName = getComponentName(ReactCurrentOwner.current.type);

            if (!didWarnAboutStringRefs[componentName]) {
              error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentName(ReactCurrentOwner.current.type), config.ref);
              didWarnAboutStringRefs[componentName] = true;
            }
          }
        }
      }

      function defineKeyPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingKey = function warnAboutAccessingKey() {
            if (!specialPropKeyWarningShown) {
              specialPropKeyWarningShown = true;
              error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
            }
          };

          warnAboutAccessingKey.isReactWarning = true;
          Object.defineProperty(props, 'key', {
            get: warnAboutAccessingKey,
            configurable: true
          });
        }
      }

      function defineRefPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingRef = function warnAboutAccessingRef() {
            if (!specialPropRefWarningShown) {
              specialPropRefWarningShown = true;
              error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
            }
          };

          warnAboutAccessingRef.isReactWarning = true;
          Object.defineProperty(props, 'ref', {
            get: warnAboutAccessingRef,
            configurable: true
          });
        }
      }
      /**
       * Factory method to create a new React element. This no longer adheres to
       * the class pattern, so do not use new to call it. Also, instanceof check
       * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
       * if something is a React Element.
       *
       * @param {*} type
       * @param {*} props
       * @param {*} key
       * @param {string|object} ref
       * @param {*} owner
       * @param {*} self A *temporary* helper to detect places where `this` is
       * different from the `owner` when React.createElement is called, so that we
       * can warn. We want to get rid of owner and replace string `ref`s with arrow
       * functions, and as long as `this` and owner are the same, there will be no
       * change in behavior.
       * @param {*} source An annotation object (added by a transpiler or otherwise)
       * indicating filename, line number, and/or other information.
       * @internal
       */


      var ReactElement = function ReactElement(type, key, ref, self, source, owner, props) {
        var element = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: REACT_ELEMENT_TYPE,
          // Built-in properties that belong on the element
          type: type,
          key: key,
          ref: ref,
          props: props,
          // Record the component responsible for creating this element.
          _owner: owner
        };
        {
          // The validation flag is currently mutative. We put it on
          // an external backing store so that we can freeze the whole object.
          // This can be replaced with a WeakMap once they are implemented in
          // commonly used development environments.
          element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
          // the validation flag non-enumerable (where possible, which should
          // include every environment we run tests in), so the test framework
          // ignores it.

          Object.defineProperty(element._store, 'validated', {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
          }); // self and source are DEV only properties.

          Object.defineProperty(element, '_self', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
          }); // Two elements created in two different places should be considered
          // equal for testing purposes and therefore we hide it from enumeration.

          Object.defineProperty(element, '_source', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
          });

          if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
          }
        }
        return element;
      };
      /**
       * https://github.com/reactjs/rfcs/pull/107
       * @param {*} type
       * @param {object} props
       * @param {string} key
       */


      function jsxDEV(type, config, maybeKey, source, self) {
        {
          var propName; // Reserved names are extracted

          var props = {};
          var key = null;
          var ref = null; // Currently, key can be spread in as a prop. This causes a potential
          // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
          // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
          // but as an intermediary step, we will use jsxDEV for everything except
          // <div {...props} key="Hi" />, because we aren't currently able to tell if
          // key is explicitly declared to be undefined or not.

          if (maybeKey !== undefined) {
            key = '' + maybeKey;
          }

          if (hasValidKey(config)) {
            key = '' + config.key;
          }

          if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
          } // Remaining properties are added to a new props object


          for (propName in config) {
            if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
              props[propName] = config[propName];
            }
          } // Resolve default props


          if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;

            for (propName in defaultProps) {
              if (props[propName] === undefined) {
                props[propName] = defaultProps[propName];
              }
            }
          }

          if (key || ref) {
            var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

            if (key) {
              defineKeyPropWarningGetter(props, displayName);
            }

            if (ref) {
              defineRefPropWarningGetter(props, displayName);
            }
          }

          return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
        }
      }

      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

      function setCurrentlyValidatingElement$1(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame$1.setExtraStackFrame(null);
          }
        }
      }

      var propTypesMisspellWarningShown;
      {
        propTypesMisspellWarningShown = false;
      }
      /**
       * Verifies the object is a ReactElement.
       * See https://reactjs.org/docs/react-api.html#isvalidelement
       * @param {?object} object
       * @return {boolean} True if `object` is a ReactElement.
       * @final
       */

      function isValidElement(object) {
        {
          return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
      }

      function getDeclarationErrorAddendum() {
        {
          if (ReactCurrentOwner$1.current) {
            var name = getComponentName(ReactCurrentOwner$1.current.type);

            if (name) {
              return '\n\nCheck the render method of `' + name + '`.';
            }
          }

          return '';
        }
      }

      function getSourceInfoErrorAddendum(source) {
        {
          if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, '');
            var lineNumber = source.lineNumber;
            return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
          }

          return '';
        }
      }
      /**
       * Warn if there's no key explicitly set on dynamic arrays of children or
       * object keys are not valid. This allows us to keep track of children between
       * updates.
       */


      var ownerHasKeyUseWarning = {};

      function getCurrentComponentErrorInfo(parentType) {
        {
          var info = getDeclarationErrorAddendum();

          if (!info) {
            var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

            if (parentName) {
              info = "\n\nCheck the top-level render call using <" + parentName + ">.";
            }
          }

          return info;
        }
      }
      /**
       * Warn if the element doesn't have an explicit key assigned to it.
       * This element is in an array. The array could grow and shrink or be
       * reordered. All children that haven't already been validated are required to
       * have a "key" property assigned to it. Error statuses are cached so a warning
       * will only be shown once.
       *
       * @internal
       * @param {ReactElement} element Element that requires a key.
       * @param {*} parentType element's parent's type.
       */


      function validateExplicitKey(element, parentType) {
        {
          if (!element._store || element._store.validated || element.key != null) {
            return;
          }

          element._store.validated = true;
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }

          ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
          // property, it may be the creator of the child that's responsible for
          // assigning it a key.

          var childOwner = '';

          if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
            // Give the component that originally created this child.
            childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
          }

          setCurrentlyValidatingElement$1(element);
          error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
          setCurrentlyValidatingElement$1(null);
        }
      }
      /**
       * Ensure that every element either is passed in a static location, in an
       * array with an explicit keys property defined, or in an object literal
       * with valid key property.
       *
       * @internal
       * @param {ReactNode} node Statically passed child of any type.
       * @param {*} parentType node's parent's type.
       */


      function validateChildKeys(node, parentType) {
        {
          if (typeof node !== 'object') {
            return;
          }

          if (Array.isArray(node)) {
            for (var i = 0; i < node.length; i++) {
              var child = node[i];

              if (isValidElement(child)) {
                validateExplicitKey(child, parentType);
              }
            }
          } else if (isValidElement(node)) {
            // This element was passed in a valid location.
            if (node._store) {
              node._store.validated = true;
            }
          } else if (node) {
            var iteratorFn = getIteratorFn(node);

            if (typeof iteratorFn === 'function') {
              // Entry iterators used to provide implicit keys,
              // but now we print a separate warning for them later.
              if (iteratorFn !== node.entries) {
                var iterator = iteratorFn.call(node);
                var step;

                while (!(step = iterator.next()).done) {
                  if (isValidElement(step.value)) {
                    validateExplicitKey(step.value, parentType);
                  }
                }
              }
            }
          }
        }
      }
      /**
       * Given an element, validate that its props follow the propTypes definition,
       * provided by the type.
       *
       * @param {ReactElement} element
       */


      function validatePropTypes(element) {
        {
          var type = element.type;

          if (type === null || type === undefined || typeof type === 'string') {
            return;
          }

          var propTypes;

          if (typeof type === 'function') {
            propTypes = type.propTypes;
          } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          type.$$typeof === REACT_MEMO_TYPE)) {
            propTypes = type.propTypes;
          } else {
            return;
          }

          if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentName(type);
            checkPropTypes(propTypes, element.props, 'prop', name, element);
          } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

            var _name = getComponentName(type);

            error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
          }

          if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
            error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
          }
        }
      }
      /**
       * Given a fragment, validate that it can only be provided with fragment props
       * @param {ReactElement} fragment
       */


      function validateFragmentProps(fragment) {
        {
          var keys = Object.keys(fragment.props);

          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];

            if (key !== 'children' && key !== 'key') {
              setCurrentlyValidatingElement$1(fragment);
              error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);
              setCurrentlyValidatingElement$1(null);
              break;
            }
          }

          if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error('Invalid attribute `ref` supplied to `React.Fragment`.');
            setCurrentlyValidatingElement$1(null);
          }
        }
      }

      function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        {
          var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
          // succeed and there will likely be errors in render.

          if (!validType) {
            var info = '';

            if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
              info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
            }

            var sourceInfo = getSourceInfoErrorAddendum(source);

            if (sourceInfo) {
              info += sourceInfo;
            } else {
              info += getDeclarationErrorAddendum();
            }

            var typeString;

            if (type === null) {
              typeString = 'null';
            } else if (Array.isArray(type)) {
              typeString = 'array';
            } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
              typeString = "<" + (getComponentName(type.type) || 'Unknown') + " />";
              info = ' Did you accidentally export a JSX literal instead of a component?';
            } else {
              typeString = typeof type;
            }

            error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
          }

          var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
          // TODO: Drop this when these are no longer allowed as the type argument.

          if (element == null) {
            return element;
          } // Skip key warning if the type isn't valid since our key validation logic
          // doesn't expect a non-string/function type and can throw confusing errors.
          // We don't want exception behavior to differ between dev and prod.
          // (Rendering will throw with a helpful message and as soon as the type is
          // fixed, the key warnings will appear.)


          if (validType) {
            var children = props.children;

            if (children !== undefined) {
              if (isStaticChildren) {
                if (Array.isArray(children)) {
                  for (var i = 0; i < children.length; i++) {
                    validateChildKeys(children[i], type);
                  }

                  if (Object.freeze) {
                    Object.freeze(children);
                  }
                } else {
                  error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
                }
              } else {
                validateChildKeys(children, type);
              }
            }
          }

          if (type === exports.Fragment) {
            validateFragmentProps(element);
          } else {
            validatePropTypes(element);
          }

          return element;
        }
      } // These two functions exist to still get child warnings in dev
      // even with the prod transform. This means that jsxDEV is purely
      // opt-in behavior for better messages but that we won't stop
      // giving you warnings if you use production apis.


      function jsxWithValidationStatic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, true);
        }
      }

      function jsxWithValidationDynamic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, false);
        }
      }

      var jsx = jsxWithValidationDynamic; // we may want to special case jsxs internally to take advantage of static children.
      // for now we can ship identical prod functions

      var jsxs = jsxWithValidationStatic;
      exports.jsx = jsx;
      exports.jsxs = jsxs;
    })();
  }
});
var reactJsxRuntime_development_1 = reactJsxRuntime_development.Fragment;
var reactJsxRuntime_development_2 = reactJsxRuntime_development.jsx;
var reactJsxRuntime_development_3 = reactJsxRuntime_development.jsxs;
var jsxRuntime = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactJsxRuntime_production_min;
  } else {
    module.exports = reactJsxRuntime_development;
  }
});
var jsxRuntime_1 = jsxRuntime.jsx;
var jsxRuntime_2 = jsxRuntime.jsxs;
var jsxRuntime_3 = jsxRuntime.Fragment;
var XIColors = {
  admin: {
    light: {
      '15': '#296ab6',
      '30': '#5788c4',
      '40': '#719acc',
      '50': '#8bacd5',
      '60': '#a3bdde',
      '70': '#bbcfe6',
      '80': '#d2dfee',
      '90': '#e9eff7',
      '95': '#f4f6fb'
    },
    primary: '#024ea9',
    dark: {
      '15': '#014392',
      '40': '#012e6a',
      '55': '#002252'
    }
  },
  orca: {
    light: {
      '15': '#465562',
      '30': '#66737e',
      '40': '#7c8790',
      '50': '#929ba3',
      '60': '#a8afb5',
      '70': '#bec3c8',
      '80': '#d3d7da',
      '90': '#e9ebed',
      '95': '#f4f5f6'
    },
    primary: '#253746',
    dark: {
      '15': '#1f2f3c',
      '40': '#16212a',
      '55': '#111920'
    }
  },
  grey: {
    light: {
      '15': '#606060',
      '30': '#7c7c7c',
      '40': '#8f8f8f',
      '50': '#a2a2a2',
      '60': '#b4b4b4',
      '70': '#c7c7c7',
      '80': '#dadada',
      '90': '#ececec',
      '95': '#f6f6f6'
    },
    primary: '#444444',
    dark: {
      '15': '#3a3a3a',
      '40': '#292929',
      '55': '#1f1f1f'
    }
  },
  purple: {
    light: {
      '15': '#813fcc',
      '30': '#ae67ff',
      '40': '#ba7dff',
      '50': '#c592ff',
      '60': '#d1a8ff',
      '70': '#dcbeff',
      '80': '#e8d4ff',
      '90': '#f3e9ff',
      '95': '#f9f4ff'
    },
    primary: '#531799',
    dark: {
      '15': '#471482',
      '40': '#320e5c',
      '55': '#250a45'
    }
  },
  blue: {
    light: {
      '15': '#2671ff',
      '30': '#4d8aff',
      '40': '#669bff',
      '50': '#80acff',
      '60': '#99bcff',
      '70': '#b3cdff',
      '80': '#ccdeff',
      '90': '#e6eeff',
      '95': '#f2f7ff'
    },
    primary: '#0058ff',
    dark: {
      '15': '#004bd9',
      '40': '#003599',
      '55': '#002873'
    }
  },
  magenta: {
    light: {
      '15': '#a83877',
      '30': '#b85b8f',
      '40': '#c2739f',
      '50': '#cc8aaf',
      '60': '#d6a1bf',
      '70': '#e0b9cf',
      '80': '#ebd0df',
      '90': '#f5e8ef',
      '95': '#faf3f7'
    },
    primary: '#99155f',
    dark: {
      '15': '#821251',
      '40': '#5c0d39',
      '55': '#45092b'
    }
  },
  green: {
    light: {
      '15': '#198b67',
      '30': '#42a083',
      '40': '#5eaf95',
      '50': '#7abda8',
      '60': '#95cbba',
      '70': '#b1d9cd',
      '80': '#cce8df',
      '90': '#e8f6f2',
      '95': '#f3fbf9'
    },
    primary: '#147255',
    dark: {
      '15': '#116148',
      '40': '#0c4433',
      '55': '#093326'
    }
  },
  teal: {
    light: {
      '15': '#1a9b8a',
      '30': '#1eb6a2',
      '40': '#3ec0af',
      '50': '#5ecbbd',
      '60': '#7ed5ca',
      '70': '#9fe0d7',
      '80': '#bfeae4',
      '90': '#dff5f2',
      '95': '#effaf8'
    },
    primary: '#158072',
    dark: {
      '15': '#126d61',
      '40': '#0d4d44',
      '55': '#093a33'
    }
  },
  yellow: {
    light: {
      '15': '#e67300',
      '30': '#ec8b14',
      '40': '#ef9c21',
      '50': '#f3ac2e',
      '60': '#f6bf5d',
      '70': '#f9d28c',
      '80': '#fbe4bb',
      '90': '#fef7ea',
      '95': '#fffbf4'
    },
    primary: '#b15800',
    dark: {
      '15': '#964b00',
      '40': '#6a3500',
      '55': '#502800'
    }
  },
  red: {
    light: {
      '15': '#d43831',
      '30': '#dc5c56',
      '40': '#e2746f',
      '50': '#e88c88',
      '60': '#eda4a1',
      '70': '#f3bcb9',
      '80': '#f8d4d2',
      '90': '#feeceb',
      '95': '#fff6f5'
    },
    primary: '#ae2e29',
    dark: {
      '15': '#942723',
      '40': '#681c19',
      '55': '#4e1512'
    }
  },
  white: {
    light: {
      '15': 'rgba(255, 255, 255, 0.85)',
      '30': 'rgba(255, 255, 255, 0.7)',
      '40': 'rgba(255, 255, 255, 0.6)',
      '50': 'rgba(255, 255, 255, 0.5)',
      '60': 'rgba(255, 255, 255, 0.4)',
      '70': 'rgba(255, 255, 255, 0.3)',
      '80': 'rgba(255, 255, 255, 0.2)',
      '90': 'rgba(255, 255, 255, 0.1)',
      '95': 'rgba(255, 255, 255, 0.05)'
    },
    primary: '#ffffff',
    dark: {
      '15': '#fdfdfd',
      '40': '#f6f6f6',
      '55': '#ececec'
    }
  }
};
var XIColorUsage = {
  silver: '#f9fafb',
  cx: XIColors.blue.primary,
  mx: XIColors.teal.primary,
  ex: XIColors.purple.primary,
  px: XIColors.magenta.primary,
  cxic: XIColors.orca.primary,
  colorBorder: XIColors.grey.light[15],
  colorDivider: XIColors.orca.light[80],
  colorDisabled: XIColors.grey.light[80],
  colorOutline: XIColors.blue.light[15],
  colorFocus: XIColors.blue.light[95],
  colorPressed: XIColors.blue.light[90],
  colorSilver: XIColors.silver,
  colorWhite: XIColors.white.primary,
  colorHighlight: XIColors.yellow.light[80],
  colorNegative: XIColors.red.dark[15],
  colorError: XIColors.red.dark[15],
  colorNeutral: XIColors.orca.light[15],
  colorPositive: XIColors.green.dark[15],
  colorSuccess: XIColors.green.dark[15],
  colorWarning: XIColors.yellow.dark[40],
  disabledBackground: XIColors.grey.light[95],
  disabledBorder: XIColors.grey.light[80],
  disabledColor: XIColors.grey.light[15],
  disabledContrastColor: XIColors.grey.light[15],
  disabledBackgroundHigh: XIColors.white.light[15],
  disabledBorderHigh: XIColors.white.light[30]
};
var _TextInputTypeOptions = ['email', 'hidden', 'password', 'tel', 'text', 'url', 'search', 'number'];
var _ButtonInputType = ['button', 'reset', 'submit'];
var defaultLocalization = {
  hidePassword: 'Hide Password',
  showPassword: 'Show Password'
};
var cx = XIColorUsage.cx,
    mx = XIColorUsage.mx,
    ex = XIColorUsage.ex,
    px = XIColorUsage.px,
    colorSuccess = XIColorUsage.colorSuccess,
    colorWarning = XIColorUsage.colorWarning,
    colorError = XIColorUsage.colorError,
    colorDisabled = XIColorUsage.colorDisabled;
var orca = XIColors.orca,
    admin = XIColors.admin,
    white = XIColors.white;

var normalizeColor = function normalizeColor(color) {
  switch (color) {
    case 'CX':
    case 'CUSTOMER':
      return 'cx';

    case 'EX':
    case 'EMPLOYEE':
      return 'ex';

    case 'MX':
    case 'MARKETING':
      return 'mx';

    case 'CXIC':
    case 'system':
    case 'orca':
      return 'orca';

    case 'PX':
    case 'PRODUCT':
      return 'px';

    case 'success':
    case 'warning':
    case 'error':
    case 'positive':
    case 'negative':
    case 'neutral':
    case 'invalid':
      return "kxi-" + color;

    case 'disabled':
    case 'admin':
    case 'white':
      return color;

    default:
      devOnlyError("The Kitchen: An incorrect value, " + color + ", has been passed into the normalizeColor function.");
      return color;
  }
};

var getColor = function getColor(color) {
  switch (color) {
    case 'CX':
    case 'CUSTOMER':
      return cx;

    case 'EX':
    case 'EMPLOYEE':
      return ex;

    case 'MX':
    case 'MARKETING':
      return mx;

    case 'PX':
    case 'PRODUCT':
      return px;

    case 'CXIC':
      return orca.light[15];

    case 'system':
    case 'orca':
      return orca.primary;

    case 'admin':
      return admin.primary;

    case 'success':
      return colorSuccess;

    case 'warning':
      return colorWarning;

    case 'error':
      return colorError;

    case 'disabled':
      return colorDisabled;

    case 'white':
      return white.primary;

    default:
      devOnlyError("The Kitchen: An incorrect value, " + color + ", has been passed into the getColor function.");
      return color;
  }
}; // intentional fall through statements


var getLightCloudColor = function getLightCloudColor(cloud, num) {
  var blue = XIColors.blue,
      purple = XIColors.purple,
      teal = XIColors.teal,
      magenta = XIColors.magenta;

  switch (cloud) {
    case 'CX':
    case 'CUSTOMER':
      return blue.light[num];

    case 'EX':
    case 'EMPLOYEE':
      return purple.light[num];

    case 'MX':
    case 'MARKETING':
      return teal.light[num];

    case 'PX':
    case 'PRODUCT':
      return magenta.light[num];

    default:
      return blue.light[num];
  }
}; // intentional fall through statements


var getDarkCloudColor = function getDarkCloudColor(cloud, num) {
  var blue = XIColors.blue,
      purple = XIColors.purple,
      teal = XIColors.teal,
      magenta = XIColors.magenta;

  switch (cloud) {
    case 'CX':
    case 'CUSTOMER':
      return blue.dark[num];

    case 'EX':
    case 'EMPLOYEE':
      return purple.dark[num];

    case 'MX':
    case 'MARKETING':
      return teal.dark[num];

    case 'PX':
    case 'PRODUCT':
      return magenta.dark[num];

    default:
      return blue.dark[num];
  }
};

var capitalizeFirstLetter = function capitalizeFirstLetter(s) {
  var nameArr = s.split(' ');
  var capitalizedNameArr = [];
  nameArr.forEach(function (item) {
    if (item) {
      var firstLetter = item[0].toUpperCase();
      item = item.substring(1);
      var newItem = firstLetter + item;
      capitalizedNameArr.push(newItem);
    }
  });
  return capitalizedNameArr.join(' ');
};

var throwPropErrorMessage = function throwPropErrorMessage(componentName, props) {
  Object.keys(props).forEach(function (propName) {
    if (props[propName] === undefined) {
      throw new Error("The Kitchen: " + propName + " is a required prop - but it is omitted in " + componentName);
    }
  });
};

var warnIsDeprecated = function warnIsDeprecated(componentName, props, type) {
  if (type === 'component') {
    devOnlyWarn("The Kitchen: The component " + componentName + " will be removed in v15, please reach out to the Kitchen team with questions." + (props['component'].message ? " " + props['component'].message : '') + " RIP " + componentName + ".");
  } else {
    Object.keys(props).forEach(function (propName) {
      var _a, _b;

      if (((_a = props[propName]) === null || _a === void 0 ? void 0 : _a.value) !== undefined) {
        devOnlyWarn("The Kitchen: " + propName + " has been deprecated on " + componentName + ". " + ((_b = props[propName].message) !== null && _b !== void 0 ? _b : 'It may have unexpected behavior.') + " It will be removed in v15.");
      }
    });
  }
};

var warnIconRenamed = function warnIconRenamed(oldName, newName) {
  devOnlyWarn("The Kitchen: The icon '" + oldName + "' has been renamed to '" + newName + "'. In v15, the name '" + oldName + "' will no longer work.");
};

var checkIfButtonTypeIsValid = function checkIfButtonTypeIsValid(name, type) {
  var active = type && _ButtonInputType.includes(type || '');

  if (type && !_ButtonInputType.includes(type || '')) {
    devOnlyWarn("The Kitchen: You have passed in a type \"" + type + "\" that is not expected for " + name + ", this will have no effect.");
  }

  return active;
};

var checkIfTextInputTypeIsValid = function checkIfTextInputTypeIsValid(name, type) {
  var active = type && _TextInputTypeOptions.includes(type || '');

  if (type && !_TextInputTypeOptions.includes(type || '')) {
    devOnlyWarn("The Kitchen: You have passed in a type \"" + type + "\" that is not expected for " + name + ", this will have no effect.");
  }

  return active;
};

var watchForEvents = function watchForEvents() {
  document.addEventListener('mousedown', function () {
    document.body.classList.add('using-mouse');
  });
  document.addEventListener('keydown', function (event) {
    if (event.keyCode === 9) {
      document.body.classList.remove('using-mouse');
    }
  });
};

var switchIconBasedOnWarning = function switchIconBasedOnWarning(warningType) {
  switch (warningType) {
    case 'error':
      return 'cancel_circle';

    case 'success':
      return 'circle_check_filled';

    case 'warning':
      return 'cancel_circle';

    default:
      return undefined;
  }
};

var switchColorBasedOnWarning = function switchColorBasedOnWarning(warningType) {
  switch (warningType) {
    case 'error':
      return colorError;

    case 'success':
      return colorSuccess;

    case 'warning':
      return colorWarning;

    default:
      return orca.primary;
  }
};

var throwCharErrors = function throwCharErrors(_char) {
  if (!_char) {
    throw new Error('Char must be defined');
  }

  if (_char.length !== 1) {
    throw new Error('Input should be 1 char exactly.');
  }
};

var determineCharType = function determineCharType(_char2) {
  throwCharErrors(_char2);
  var alphaRegex = new RegExp(/[A-Za-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]/);

  if (Number.isInteger(+_char2) && _char2 !== ' ') {
    return 'numeric';
  } else if (_char2.match(alphaRegex)) {
    return 'alpha';
  } else if (_char2 === '*') {
    return 'alphanumeric';
  } else {
    return 'symbol';
  }
};

var switchMaskCharType = function switchMaskCharType(_char3) {
  throwCharErrors(_char3);

  switch (_char3) {
    case '9':
      return 'numeric';

    case 'a':
      return 'alpha';

    case '*':
      return 'alphanumeric';

    default:
      return 'symbol';
  }
};

var controlMaskInput = function controlMaskInput(value, mask) {
  var maskedValue = '';
  var lastCharIndex = value.length - 1;
  var nextMaskChar = mask[lastCharIndex + 1];
  var nextMaskCharType = nextMaskChar && switchMaskCharType(nextMaskChar);
  var nextMaskCharIsSymbol = nextMaskChar && nextMaskCharType === 'symbol';

  if (value.length > maskedValue.length) {
    var _char4 = value[lastCharIndex];
    var maskChar = mask[lastCharIndex];
    var maskType = switchMaskCharType(maskChar);
    var charType = determineCharType(_char4);
    var allowChange = charType && charType === maskType;

    if (value.length === 1 && maskType === 'symbol') {
      value = maskChar + value;

      if (charType === nextMaskCharType) {
        maskedValue += value;
      }
    } else {
      value = value.substring(0, lastCharIndex);
    }

    if (allowChange) {
      value += _char4;

      if (nextMaskCharIsSymbol) {
        value += nextMaskChar;
      }

      maskedValue += value;
    }
  } else {
    if (nextMaskCharIsSymbol) {
      value = value.substring(0, lastCharIndex);
    }

    maskedValue += value;
  }

  return maskedValue;
};

var lastChar = function lastChar(value) {
  return value[value.length - 1];
};

var countChars = function countChars(value) {
  var numOfNonSymbols = 0;

  for (var i = 0; i < value.length; i++) {
    if (determineCharType(value[i]) !== 'symbol') {
      numOfNonSymbols++;
    }
  }

  return numOfNonSymbols;
};

var hasChildren = function hasChildren(children) {
  return Array.isArray(children) && children.length > 0 || children;
};

var boldenSearchText = function boldenSearchText(value, searchTerm) {
  var splitArr = value.split(searchTerm);
  return splitArr.map(function (item, i) {
    if (i !== splitArr.length - 1) {
      return jsxRuntime_2(jsxRuntime_3, {
        children: [item, jsxRuntime_1("span", _assign2({
          className: "kxi-text-600"
        }, {
          children: searchTerm
        }), void 0)]
      }, void 0);
    } else {
      return item;
    }
  });
};

var isProdEnvironment = function isProdEnvironment() {
  var _a, _b;

  var envName = ((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.env) === null || _b === void 0 ? void 0 : _b.name) || '';

  if (envName === 'production' || envName === 'prod-euc1' || envName === 'prod-apse2') {
    return true;
  }

  return false;
};

var devOnlyWarn = function devOnlyWarn(message) {
  var optionalParams = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    optionalParams[_i - 1] = arguments[_i];
  }

  if (!isProdEnvironment()) {
    console.warn.apply(console, __spreadArray([message], __read(optionalParams)));
  }
};

var devOnlyError = function devOnlyError(message) {
  var optionalParams = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    optionalParams[_i - 1] = arguments[_i];
  }

  if (!isProdEnvironment()) {
    console.error.apply(console, __spreadArray([message], __read(optionalParams)));
  }
};

var escapeRegex = function escapeRegex(str) {
  var matches = Array.from(new Set(str.match(/([\^,\$,\$,\.,\|,\?,\+,\*,\{,\},\[,\],\(,\)]{1})/gm)));
  str = str.replace('\\', '\\\\');
  matches.forEach(function (specialChar) {
    str = str.replace(specialChar, "\\" + specialChar);
  });
  return str;
};

var fns = /*#__PURE__*/Object.freeze({
  __proto__: null,
  normalizeColor: normalizeColor,
  getColor: getColor,
  getLightCloudColor: getLightCloudColor,
  getDarkCloudColor: getDarkCloudColor,
  capitalizeFirstLetter: capitalizeFirstLetter,
  throwPropErrorMessage: throwPropErrorMessage,
  warnIsDeprecated: warnIsDeprecated,
  warnIconRenamed: warnIconRenamed,
  checkIfButtonTypeIsValid: checkIfButtonTypeIsValid,
  checkIfTextInputTypeIsValid: checkIfTextInputTypeIsValid,
  watchForEvents: watchForEvents,
  switchIconBasedOnWarning: switchIconBasedOnWarning,
  switchColorBasedOnWarning: switchColorBasedOnWarning,
  determineCharType: determineCharType,
  switchMaskCharType: switchMaskCharType,
  controlMaskInput: controlMaskInput,
  lastChar: lastChar,
  countChars: countChars,
  hasChildren: hasChildren,
  boldenSearchText: boldenSearchText,
  isProdEnvironment: isProdEnvironment,
  devOnlyWarn: devOnlyWarn,
  devOnlyError: devOnlyError,
  escapeRegex: escapeRegex
});
var _StatusColorNamesOptions = ['red', 'green', 'yellow'];
var _ColorNamesOptions = ['admin', 'orca', 'blue', 'purple', 'teal', 'white'];
var _EXOptions = ['EX', 'EMPLOYEE'];
var _CXOptions = ['CX', 'CUSTOMER'];
var _MXOptions = ['MX', 'MARKETING'];
var _PXOptions = ['PX', 'PRODUCT'];
var _CXICOptions = ['CXIC'];

var _CloudsOptions = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(_EXOptions)), __read(_MXOptions)), __read(_CXICOptions)), __read(_CXOptions)), __read(_PXOptions));

var _XICloudsOptions = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(_EXOptions)), __read(_MXOptions)), __read(_CXOptions)), __read(_PXOptions));

var _AdminOptions = ['admin'];
var _SystemOptions = ['system', 'orca'];
var _InvalidOptions = ['invalid'];

var _ColorsOptions = __spreadArray(__spreadArray(__spreadArray([], __read(_CloudsOptions)), __read(_AdminOptions)), __read(_SystemOptions));

var EnumClouds;

(function (EnumClouds) {
  EnumClouds["EX"] = "EX";
  EnumClouds["MX"] = "MX";
  EnumClouds["CX"] = "CX";
  EnumClouds["PX"] = "PX";
  EnumClouds["CUSTOMER"] = "CUSTOMER";
  EnumClouds["EMPLOYEE"] = "EMPLOYEE";
  EnumClouds["MARKETING"] = "MARKETING";
  EnumClouds["CXIC"] = "CXIC";
  EnumClouds["PRODUCT"] = "PRODUCT";
})(EnumClouds || (EnumClouds = {}));

var _ContrastsOptions = ['normal', 'high'];
var _DisabledOptions = ['disabled'];
var _ErrorStatesOptions = ['success', 'warning', 'error'];
var EnumErrorStates;

(function (EnumErrorStates) {
  EnumErrorStates["SUCCESS"] = "success";
  EnumErrorStates["WARNING"] = "warning";
  EnumErrorStates["ERROR"] = "error";
})(EnumErrorStates || (EnumErrorStates = {}));

var _ComponentSizesOptions = ['normal', 'large'];
var _LeftRightOptions = ['left', 'right'];
var _SentimentsOptions = ['negative', 'neutral', 'positive'];
var SentimentEnum;

(function (SentimentEnum) {
  SentimentEnum[SentimentEnum["negative"] = -1] = "negative";
  SentimentEnum[SentimentEnum["neutral"] = 0] = "neutral";
  SentimentEnum[SentimentEnum["positive"] = 1] = "positive";
})(SentimentEnum || (SentimentEnum = {}));

var _WhiteOptions = ['white'];
var _TextWeightsOptions = [300, 400, 600, 'light', 'normal', 'semi-bold'];
var _TextAlignmentsOptions = ['left', 'right', 'center', 'end', 'justify', 'match-parent', 'start', 'inherit', '-moz-initial', 'initial', 'revert', 'unset'];
var _TextLevelsOptions = [1, 2, 3, 4];
var _TextSizesOptions = ['small', 'normal', 'body', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];

var _TextColorsOptions = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(_ColorsOptions)), __read(_ErrorStatesOptions)), __read(_DisabledOptions)), __read(_WhiteOptions));

var _TextWrapsOptions = ['normal', 'inherit', 'pre', '-moz-initial', 'initial', 'revert', 'unset', 'nowrap', '-moz-pre-wrap', 'break-spaces', 'pre-line', 'pre-wrap'];
var radii = 90;
var XIGradients = {
  cxGradient: "linear-gradient(" + radii + "deg, " + XIColors.blue.primary + " 0%, " + XIColors.orca.primary + " 200%)",
  pxGradient: "linear-gradient(" + radii + "deg, " + XIColors.magenta.primary + " 0%, " + XIColors.orca.primary + " 200%)",
  exGradient: "linear-gradient(" + radii + "deg, " + XIColors.purple.primary + " 0%, " + XIColors.orca.primary + " 200%)",
  mxGradient: "linear-gradient(" + radii + "deg, " + XIColors.teal.primary + " 0%, " + XIColors.orca.primary + " 200%)",
  orcaGradient: "linear-gradient(" + radii + "deg, " + XIColors.orca.light[15] + " 0%, " + XIColors.orca.dark[40] + " 200%)",
  adminGradient: "linear-gradient(" + radii + "deg, " + XIColors.admin.primary + " 0%, " + XIColors.orca.primary + " 200%)"
};
var XIShadowsDown = {
  0: '0px 1px 2px 0px rgba(37, 55, 70, 0.0), 0px 0px 1px 0px rgba(37, 55, 70, 0.0)',
  1: '0px 1px 2px 0px rgba(37, 55, 70, 0.18), 0px 0px 1px 0px rgba(37, 55, 70, 0.06)',
  2: '0px 2px 3px 0px rgba(37, 55, 70, 0.18), 0px 0px 3px 0px rgba(37, 55, 70, 0.06)',
  3: '0px 6px 6px 0px rgba(37, 55, 70, 0.18), 0px 0px 6px 0px rgba(37, 55, 70, 0.06)',
  4: '0px 9px 9px 0px rgba(37, 55, 70, 0.18), 0px 0px 9px 0px rgba(37, 55, 70, 0.06)',
  5: '0px 12px 12px 0px rgba(37, 55, 70, 0.18), 0px 0px 12px 0px rgba(37, 55, 70, 0.06)',
  6: '0px 18px 18px 0px rgba(37, 55, 70, 0.18), 0px 0px 18px 0px rgba(37, 55, 70, 0.06)',
  7: '0px 24px 24px 0px rgba(37, 55, 70, 0.18), 0px 0px 24px 0px rgba(37, 55, 70, 0.06)'
};
var XIShadowsUp = {
  0: '0px -1px 2px 0px rgba(37, 55, 70, 0.0), 0px 0px 1px 0px rgba(37, 55, 70, 0.0)',
  1: '0px -1px 2px 0px rgba(37, 55, 70, 0.18), 0px 0px 1px 0px rgba(37, 55, 70, 0.06)',
  2: '0px -2px 3px 0px rgba(37, 55, 70, 0.18), 0px 0px 3px 0px rgba(37, 55, 70, 0.06)',
  3: '0px -6px 6px 0px rgba(37, 55, 70, 0.18), 0px 0px 6px 0px rgba(37, 55, 70, 0.06)',
  4: '0px -9px 9px 0px rgba(37, 55, 70, 0.18), 0px 0px 9px 0px rgba(37, 55, 70, 0.06)',
  5: '0px -12px 12px 0px rgba(37, 55, 70, 0.18), 0px 0px 12px 0px rgba(37, 55, 70, 0.06)',
  6: '0px -18px 18px 0px rgba(37, 55, 70, 0.18), 0px 0px 18px 0px rgba(37, 55, 70, 0.06)',
  7: '0px -24px 24px 0px rgba(37, 55, 70, 0.18), 0px 0px 24px 0px rgba(37, 55, 70, 0.06)'
};
var XIShadowsLeft = {
  0: '-1px 0px 2px 0px rgba(37, 55, 70, 0.0), 0px 0px 1px 0px rgba(37, 55, 70, 0.0)',
  1: '-1px 0px 2px 0px rgba(37, 55, 70, 0.24), 0px 0px 1px 0px rgba(37, 55, 70, 0.06)',
  2: '-2px 0px 3px 0px rgba(37, 55, 70, 0.24), 0px 0px 3px 0px rgba(37, 55, 70, 0.06)',
  3: '-6px 0px 6px 0px rgba(37, 55, 70, 0.24), 0px 0px 6px 0px rgba(37, 55, 70, 0.06)',
  4: '-9px 0px 9px 0px rgba(37, 55, 70, 0.24), 0px 0px 9px 0px rgba(37, 55, 70, 0.06)',
  5: '-12px 0px 12px 0px rgba(37, 55, 70, 0.24), 0px 0px 12px 0px rgba(37, 55, 70, 0.06)',
  6: '-18px 0px 18px 0px rgba(37, 55, 70, 0.24), 0px 0px 18px 0px rgba(37, 55, 70, 0.06)',
  7: '-24px 0px 24px 0px rgba(37, 55, 70, 0.24), 0px 0px 24px 0px rgba(37, 55, 70, 0.06)'
};
var XIShadowsRight = {
  0: '1px 0px 2px 0px rgba(37, 55, 70, 0.0), 0px 0px 1px 0px rgba(37, 55, 70, 0.0)',
  1: '1px 0px 2px 0px rgba(37, 55, 70, 0.24), 0px 0px 1px 0px rgba(37, 55, 70, 0.06)',
  2: '2px 0px 3px 0px rgba(37, 55, 70, 0.24), 0px 0px 3px 0px rgba(37, 55, 70, 0.06)',
  3: '6px 0px 6px 0px rgba(37, 55, 70, 0.24), 0px 0px 6px 0px rgba(37, 55, 70, 0.06)',
  4: '9px 0px 9px 0px rgba(37, 55, 70, 0.24), 0px 0px 9px 0px rgba(37, 55, 70, 0.06)',
  5: '12px 0px 12px 0px rgba(37, 55, 70, 0.24), 0px 0px 12px 0px rgba(37, 55, 70, 0.06)',
  6: '18px 0px 18px 0px rgba(37, 55, 70, 0.24), 0px 0px 18px 0px rgba(37, 55, 70, 0.06)',
  7: '24px 0px 24px 0px rgba(37, 55, 70, 0.24), 0px 0px 24px 0px rgba(37, 55, 70, 0.06)'
};
var _ShadowsOptions = [0, 1, 2, 3, 4, 5, 6, 7];
var XITransitions = {
  hover: 'border 0.1s, box-shadow 0.1s, font-weight 0.1s, color 0.1s, background 0.1s',
  formControlHover: '.075s all ease-in-out',
  modals: 'opacity 0.2s ease-in-out'
};
var AnimatePresenceStates = {
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1
  },
  exit: {
    opacity: 0
  }
};

function Bound() {
  return function (target, propertyKey) {
    Object.defineProperty(target, propertyKey, {
      value: null,
      enumerable: true,
      writable: true
    });
  };
}

var AriaAttributes = function () {
  function AriaAttributes() {}

  __decorate([Bound(), __metadata("design:type", String)], AriaAttributes.prototype, "aria-activedescendant");

  __decorate([Bound(), __metadata("design:type", Object)], AriaAttributes.prototype, "aria-atomic");

  __decorate([Bound(), __metadata("design:type", String)], AriaAttributes.prototype, "aria-autocomplete");

  __decorate([Bound(), __metadata("design:type", Object)], AriaAttributes.prototype, "aria-busy");

  __decorate([Bound(), __metadata("design:type", Object)], AriaAttributes.prototype, "aria-checked");

  __decorate([Bound(), __metadata("design:type", Number)], AriaAttributes.prototype, "aria-colcount");

  __decorate([Bound(), __metadata("design:type", Number)], AriaAttributes.prototype, "aria-colindex");

  __decorate([Bound(), __metadata("design:type", Number)], AriaAttributes.prototype, "aria-colspan");

  __decorate([Bound(), __metadata("design:type", String)], AriaAttributes.prototype, "aria-controls");

  __decorate([Bound(), __metadata("design:type", Object)], AriaAttributes.prototype, "aria-current");

  __decorate([Bound(), __metadata("design:type", String)], AriaAttributes.prototype, "aria-describedby");

  __decorate([Bound(), __metadata("design:type", String)], AriaAttributes.prototype, "aria-details");

  __decorate([Bound(), __metadata("design:type", Object)], AriaAttributes.prototype, "aria-disabled");

  __decorate([Bound(), __metadata("design:type", String)], AriaAttributes.prototype, "aria-dropeffect");

  __decorate([Bound(), __metadata("design:type", String)], AriaAttributes.prototype, "aria-errormessage");

  __decorate([Bound(), __metadata("design:type", Object)], AriaAttributes.prototype, "aria-expanded");

  __decorate([Bound(), __metadata("design:type", String)], AriaAttributes.prototype, "aria-flowto");

  __decorate([Bound(), __metadata("design:type", Object)], AriaAttributes.prototype, "aria-grabbed");

  __decorate([Bound(), __metadata("design:type", Object)], AriaAttributes.prototype, "aria-haspopup");

  __decorate([Bound(), __metadata("design:type", Object)], AriaAttributes.prototype, "aria-hidden");

  __decorate([Bound(), __metadata("design:type", Object)], AriaAttributes.prototype, "aria-invalid");

  __decorate([Bound(), __metadata("design:type", String)], AriaAttributes.prototype, "aria-keyshortcuts");

  __decorate([Bound(), __metadata("design:type", String)], AriaAttributes.prototype, "aria-label");

  __decorate([Bound(), __metadata("design:type", String)], AriaAttributes.prototype, "aria-labelledby");

  __decorate([Bound(), __metadata("design:type", Number)], AriaAttributes.prototype, "aria-level");

  __decorate([Bound(), __metadata("design:type", String)], AriaAttributes.prototype, "aria-live");

  __decorate([Bound(), __metadata("design:type", Object)], AriaAttributes.prototype, "aria-modal");

  __decorate([Bound(), __metadata("design:type", Object)], AriaAttributes.prototype, "aria-multiline");

  __decorate([Bound(), __metadata("design:type", Object)], AriaAttributes.prototype, "aria-multiselectable");

  __decorate([Bound(), __metadata("design:type", String)], AriaAttributes.prototype, "aria-orientation");

  __decorate([Bound(), __metadata("design:type", String)], AriaAttributes.prototype, "aria-owns");

  __decorate([Bound(), __metadata("design:type", String)], AriaAttributes.prototype, "aria-placeholder");

  __decorate([Bound(), __metadata("design:type", Number)], AriaAttributes.prototype, "aria-posinset");

  __decorate([Bound(), __metadata("design:type", Object)], AriaAttributes.prototype, "aria-pressed");

  __decorate([Bound(), __metadata("design:type", Object)], AriaAttributes.prototype, "aria-readonly");

  __decorate([Bound(), __metadata("design:type", String)], AriaAttributes.prototype, "aria-relevant");

  __decorate([Bound(), __metadata("design:type", Object)], AriaAttributes.prototype, "aria-required");

  __decorate([Bound(), __metadata("design:type", String)], AriaAttributes.prototype, "aria-roledescription");

  __decorate([Bound(), __metadata("design:type", Number)], AriaAttributes.prototype, "aria-rowcount");

  __decorate([Bound(), __metadata("design:type", Number)], AriaAttributes.prototype, "aria-rowindex");

  __decorate([Bound(), __metadata("design:type", Number)], AriaAttributes.prototype, "aria-rowspan");

  __decorate([Bound(), __metadata("design:type", Object)], AriaAttributes.prototype, "aria-selected");

  __decorate([Bound(), __metadata("design:type", Number)], AriaAttributes.prototype, "aria-setsize");

  __decorate([Bound(), __metadata("design:type", String)], AriaAttributes.prototype, "aria-sort");

  __decorate([Bound(), __metadata("design:type", Number)], AriaAttributes.prototype, "aria-valuemax");

  __decorate([Bound(), __metadata("design:type", Number)], AriaAttributes.prototype, "aria-valuemin");

  __decorate([Bound(), __metadata("design:type", Number)], AriaAttributes.prototype, "aria-valuenow");

  __decorate([Bound(), __metadata("design:type", String)], AriaAttributes.prototype, "aria-valuetext");

  return AriaAttributes;
}();

function DOMAttributes(SuperClass) {
  return function (_super) {
    __extends(class_1, _super);

    function class_1() {
      return _super !== null && _super.apply(this, arguments) || this;
    }

    return class_1;
  }(SuperClass);
}

var DOMEvents = function () {
  function DOMEvents() {}

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onCopy");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onCopyCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onCut");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onCutCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onPaste");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onPasteCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onCompositionEnd");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onCompositionEndCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onCompositionStart");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onCompositionStartCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onCompositionUpdate");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onCompositionUpdateCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onFocus");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onFocusCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onBlur");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onBlurCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onChange");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onChangeCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onBeforeInput");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onBeforeInputCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onInput");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onInputCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onReset");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onResetCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onSubmit");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onSubmitCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onInvalid");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onInvalidCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onLoad");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onLoadCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onError");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onErrorCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onKeyDown");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onKeyDownCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onKeyPress");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onKeyPressCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onKeyUp");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onKeyUpCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onAbort");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onAbortCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onCanPlay");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onCanPlayCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onCanPlayThrough");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onCanPlayThroughCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onDurationChange");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onDurationChangeCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onEmptied");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onEmptiedCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onEncrypted");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onEncryptedCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onEnded");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onEndedCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onLoadedData");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onLoadedDataCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onLoadedMetadata");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onLoadedMetadataCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onLoadStart");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onLoadStartCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onPause");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onPauseCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onPlay");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onPlayCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onPlaying");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onPlayingCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onProgress");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onProgressCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onRateChange");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onRateChangeCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onSeeked");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onSeekedCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onSeeking");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onSeekingCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onStalled");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onStalledCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onSuspend");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onSuspendCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onTimeUpdate");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onTimeUpdateCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onVolumeChange");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onVolumeChangeCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onWaiting");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onWaitingCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onAuxClick");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onAuxClickCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onClick");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onClickCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onContextMenu");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onContextMenuCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onDoubleClick");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onDoubleClickCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onDrag");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onDragCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onDragEnd");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onDragEndCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onDragEnter");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onDragEnterCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onDragExit");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onDragExitCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onDragLeave");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onDragLeaveCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onDragOver");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onDragOverCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onDragStart");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onDragStartCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onDrop");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onDropCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onMouseDown");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onMouseDownCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onMouseEnter");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onMouseLeave");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onMouseMove");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onMouseMoveCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onMouseOut");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onMouseOutCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onMouseOver");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onMouseOverCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onMouseUp");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onMouseUpCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onSelect");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onSelectCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onTouchCancel");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onTouchCancelCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onTouchEnd");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onTouchEndCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onTouchMove");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onTouchMoveCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onTouchStart");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onTouchStartCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onPointerDown");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onPointerDownCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onPointerMove");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onPointerMoveCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onPointerUp");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onPointerUpCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onPointerCancel");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onPointerCancelCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onPointerEnter");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onPointerLeave");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onPointerOver");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onPointerOverCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onPointerOut");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onPointerOutCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onGotPointerCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onGotPointerCaptureCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onLostPointerCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onLostPointerCaptureCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onScroll");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onScrollCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onWheel");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onWheelCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onAnimationStart");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onAnimationStartCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onAnimationEnd");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onAnimationEndCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onAnimationIteration");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onAnimationIterationCapture");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onTransitionEnd");

  __decorate([Bound(), __metadata("design:type", Function)], DOMEvents.prototype, "onTransitionEndCapture");

  return DOMEvents;
}();

var HTMLAttributes = function (_super) {
  __extends(HTMLAttributes, _super);

  function HTMLAttributes() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "data-qa");

  __decorate([Bound(), __metadata("design:type", Boolean)], HTMLAttributes.prototype, "defaultChecked");

  __decorate([Bound(), __metadata("design:type", Object)], HTMLAttributes.prototype, "defaultValue");

  __decorate([Bound(), __metadata("design:type", Boolean)], HTMLAttributes.prototype, "suppressContentEditableWarning");

  __decorate([Bound(), __metadata("design:type", Boolean)], HTMLAttributes.prototype, "suppressHydrationWarning");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "accessKey");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "className");

  __decorate([Bound(), __metadata("design:type", Object)], HTMLAttributes.prototype, "contentEditable");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "contextMenu");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "dir");

  __decorate([Bound(), __metadata("design:type", Object)], HTMLAttributes.prototype, "draggable");

  __decorate([Bound(), __metadata("design:type", Boolean)], HTMLAttributes.prototype, "hidden");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "id");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "lang");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "placeholder");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "slot");

  __decorate([Bound(), __metadata("design:type", Object)], HTMLAttributes.prototype, "spellCheck");

  __decorate([Bound(), __metadata("design:type", Object)], HTMLAttributes.prototype, "style");

  __decorate([Bound(), __metadata("design:type", Number)], HTMLAttributes.prototype, "tabIndex");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "title");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "translate");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "radioGroup");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "role");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "about");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "datatype");

  __decorate([Bound(), __metadata("design:type", Object)], HTMLAttributes.prototype, "inlist");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "prefix");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "property");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "resource");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "typeof");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "vocab");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "autoCapitalize");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "autoCorrect");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "autoSave");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "color");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "itemProp");

  __decorate([Bound(), __metadata("design:type", Boolean)], HTMLAttributes.prototype, "itemScope");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "itemType");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "itemID");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "itemRef");

  __decorate([Bound(), __metadata("design:type", Number)], HTMLAttributes.prototype, "results");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "security");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "unselectable");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "inputMode");

  __decorate([Bound(), __metadata("design:type", String)], HTMLAttributes.prototype, "is");

  return HTMLAttributes;
}(DOMAttributes(AriaAttributes));

var DivHTMLAttributes = function (_super) {
  __extends(DivHTMLAttributes, _super);

  function DivHTMLAttributes() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return DivHTMLAttributes;
}(HTMLAttributes);

var DivHTMLEvents = function (_super) {
  __extends(DivHTMLEvents, _super);

  function DivHTMLEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return DivHTMLEvents;
}(DOMEvents);

var Slot = /*#__PURE__*/memo(function (props) {
  var name = props.name,
      hasTranscludedContent = props.hasTranscludedContent,
      resetTransclusion = props.resetTransclusion,
      hasTranscluded = props.hasTranscluded,
      ingredients = __rest(props, ["name", "hasTranscludedContent", "resetTransclusion", "hasTranscluded"]);

  delete ingredients.propsToWatch; // do not want this to get applied to the slot.

  if (hasTranscludedContent && hasTranscluded) {
    resetTransclusion();
  }

  return jsxRuntime_1("slot", _assign2({
    name: name
  }, ingredients), void 0);
}, function (prevProps, nextProps) {
  return JSON.stringify(prevProps.propsToWatch) === JSON.stringify(nextProps.propsToWatch);
});

var AccordionProps = function (_super) {
  __extends(AccordionProps, _super);

  function AccordionProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Boolean)], AccordionProps.prototype, "hasSideBorders");

  return AccordionProps;
}(DivHTMLAttributes);

var AccordionEvents = function (_super) {
  __extends(AccordionEvents, _super);

  function AccordionEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return AccordionEvents;
}(DivHTMLEvents);
/**
 * Description: Navigation component with expandable sections.
 */


var Accordion = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      _a = props.hasSideBorders,
      hasSideBorders = _a === void 0 ? false : _a,
      children = props.children,
      resetTransclusion = props.resetTransclusion,
      hasTranscluded = props.hasTranscluded,
      hasTranscludedContent = props.hasTranscludedContent,
      ingredients = __rest(props, ["className", "hasSideBorders", "children", "resetTransclusion", "hasTranscluded", "hasTranscludedContent"]);

  delete ingredients.transclude;
  return jsxRuntime_1("div", _assign2({}, ingredients, {
    className: "kxi-accordion kxi-stretch-width " + (hasSideBorders ? 'kxi-accordion-borders' : '') + " orca " + (className || ''),
    ref: ref
  }, {
    children: hasChildren(children) ? children : jsxRuntime_1(Slot, {
      name: "children",
      hasTranscluded: hasTranscluded,
      hasTranscludedContent: hasTranscludedContent,
      resetTransclusion: resetTransclusion,
      propsToWatch: []
    }, void 0)
  }), void 0);
});

var SpanHTMLAttributes = function (_super) {
  __extends(SpanHTMLAttributes, _super);

  function SpanHTMLAttributes() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return SpanHTMLAttributes;
}(HTMLAttributes);

var SpanHTMLEvents = function (_super) {
  __extends(SpanHTMLEvents, _super);

  function SpanHTMLEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return SpanHTMLEvents;
}(DOMEvents);

var XIIconProps = function (_super) {
  __extends(XIIconProps, _super);

  function XIIconProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], XIIconProps.prototype, "icon");

  __decorate([Bound(), __metadata("design:type", String)], XIIconProps.prototype, "color");

  __decorate([Bound(), __metadata("design:type", String)], XIIconProps.prototype, "contrast");

  __decorate([Bound(), __metadata("design:type", Object)], XIIconProps.prototype, "iconSize");

  return XIIconProps;
}(SpanHTMLAttributes);

var XIIconEvents = function (_super) {
  __extends(XIIconEvents, _super);

  function XIIconEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return XIIconEvents;
}(SpanHTMLEvents);
/**
 * Description: Component that displays an Icon in the Icons category.
 */


var XIIcon = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _a = props.color,
      color = _a === void 0 ? 'orca' : _a,
      _b = props.icon,
      icon = _b === void 0 ? 'no_icon' : _b,
      _c = props.iconSize,
      iconSize = _c === void 0 ? 'normal' : _c,
      _d = props.contrast,
      contrast = _d === void 0 ? 'normal' : _d,
      style = props.style,
      className = props.className,
      ingredients = __rest(props, ["color", "icon", "iconSize", "contrast", "style", "className"]);

  React__default.useEffect(function () {
    if (icon === 'export_1') {
      warnIconRenamed('export_1', 'upload');
    } else if (icon === 'export_2') {
      warnIconRenamed('export_2', 'external_link');
    } else if (icon === 'export_2_filled') {
      warnIconRenamed('export_2_filled', 'external_link_filled');
    }
  }, [icon]);
  var internalIconSize;

  switch (iconSize) {
    case 'normal':
      internalIconSize = 24;
      break;

    case 'small':
      internalIconSize = 18;
      break;

    case 'large':
      internalIconSize = 30;
      break;

    case 'xxlarge':
      internalIconSize = 36;
      break;

    default:
      internalIconSize = isNaN(iconSize) || iconSize === '' ? 24 : +iconSize;
      break;
  }

  var classList = "" + normalizeColor(color);
  classList += contrast === 'normal' ? '' : ' kxi-high-contrast';
  return jsxRuntime_1("span", _assign2({
    role: "img",
    "aria-labelledby": "" + icon,
    "aria-label": "icon",
    ref: ref,
    className: "kxi-icon kxi-icon-" + icon + " " + classList + " " + (className || ''),
    style: _assign2({
      fontSize: internalIconSize,
      height: internalIconSize,
      width: internalIconSize
    }, style),
    "data-testid": icon + "_icon"
  }, ingredients), void 0);
});

function uuidv4() {
  var exponent;
  var emptyGuidv4 = '00000000-0000-4000-0000-000000000000';

  if (window.crypto) {
    exponent = function exponent() {
      return crypto.getRandomValues(new Uint8Array(1))[0] & 15;
    };
  } else {
    exponent = function exponent() {
      return Math.floor(Math.random() * 16);
    };
  }

  return emptyGuidv4.replace(/[0]/g, function (c) {
    return (c ^ exponent() >> c / 4).toString(16);
  });
}

var ObservableProps = function () {
  function ObservableProps() {
    this.observer = {};
  }

  return ObservableProps;
}();

function ObservablePropsMixin(SuperClass) {
  return function (_super) {
    __extends(ObservableProps, _super);

    function ObservableProps() {
      var _this = _super !== null && _super.apply(this, arguments) || this;

      _this.observer = {};
      return _this;
    }

    return ObservableProps;
  }(SuperClass);
}

function includeTestId(testId) {
  return globalThis.includeTestId ? testId : undefined;
}

var AccordionItemProps = function (_super) {
  __extends(AccordionItemProps, _super);

  function AccordionItemProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], AccordionItemProps.prototype, "title");

  __decorate([Bound(), __metadata("design:type", Boolean)], AccordionItemProps.prototype, "noPadding");

  __decorate([Bound(), __metadata("design:type", String)], AccordionItemProps.prototype, "color");

  __decorate([Bound(), __metadata("design:type", String)], AccordionItemProps.prototype, "id");

  __decorate([Bound(), __metadata("design:type", Boolean)], AccordionItemProps.prototype, "disabled");

  __decorate([Bound(), __metadata("design:type", Boolean)], AccordionItemProps.prototype, "open");

  __decorate([Bound(), __metadata("design:type", String)], AccordionItemProps.prototype, "icon");

  __decorate([Bound(), __metadata("design:type", String)], AccordionItemProps.prototype, "iconPlacement");

  return AccordionItemProps;
}(ObservablePropsMixin(DivHTMLAttributes));

var AccordionItemEvents = function (_super) {
  __extends(AccordionItemEvents, _super);

  function AccordionItemEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], AccordionItemEvents.prototype, "onItemClick");

  return AccordionItemEvents;
}(DivHTMLEvents);
/**
 * Description: Item to be used solely inside of the Accordion.
 */


var AccordionItem = function AccordionItem(props) {
  var _a = __read(useState(false), 2),
      openState = _a[0],
      setOpenState = _a[1];

  var _b = __read(useState(''), 2),
      overflowClass = _b[0],
      setOverflowClass = _b[1];

  var childRef = useRef(null);

  var idInput = props.id,
      _c = props.disabled,
      disabled = _c === void 0 ? false : _c,
      _d = props.open,
      open = _d === void 0 ? false : _d,
      title = props.title,
      _e = props.color,
      color = _e === void 0 ? 'orca' : _e,
      children = props.children,
      hasTranscluded = props.hasTranscluded,
      hasTranscludedContent = props.hasTranscludedContent,
      resetTransclusion = props.resetTransclusion,
      className = props.className,
      onClick = props.onClick,
      observer = props.observer,
      icon = props.icon,
      _f = props.iconPlacement,
      iconPlacement = _f === void 0 ? 'caret' : _f,
      onItemClick = props.onItemClick,
      noPadding = props.noPadding,
      ingredients = __rest(props, ["id", "disabled", "open", "title", "color", "children", "hasTranscluded", "hasTranscludedContent", "resetTransclusion", "className", "onClick", "observer", "icon", "iconPlacement", "onItemClick", "noPadding"]);

  var _g = __read(useState(idInput || uuidv4()), 1),
      id = _g[0];

  delete ingredients.transclude;
  useEffect(function () {
    setOpenState(open);
  }, [open]);

  var handleClick = function handleClick(e) {
    var _a;

    if (childRef.current && ((_a = e.nativeEvent.composedPath()) === null || _a === void 0 ? void 0 : _a.includes(childRef.current))) {
      return;
    }

    if (!disabled) {
      setOpenState(function (v) {
        if (observer) observer.open = !v;
        return !v;
      });
      if (onClick) onClick(e);
      if (onItemClick) onItemClick(id);
    }
  };

  useEffect(function () {
    if (disabled) {
      setOpenState(false);
    }
  }, [disabled]);
  useEffect(function () {
    if (openState) {
      setOverflowClass('kxi-accordion-visible');
    } else {
      setOverflowClass('');
    }
  }, [openState]);

  var handleKeyPress = function handleKeyPress(e) {
    if (!disabled) {
      if (e.key === 'Enter' || e.key === ' ') {
        setOpenState(function (v) {
          if (observer) observer.open = !v;
          return !v;
        });
        if (onClick) onClick(e);
        if (onItemClick) onItemClick(id);
      }
    }
  };

  return jsxRuntime_2("div", _assign2({
    className: "kxi-accordion-section-wrapper " + (disabled ? 'kxi-disabled' : '') + " kxi-text-normal " + (className || ''),
    onClick: handleClick,
    onKeyPress: handleKeyPress
  }, ingredients, {
    children: [jsxRuntime_2("div", _assign2({
      tabIndex: 0,
      className: "kxi-accordion-section " + (disabled ? 'kxi-disabled' : '')
    }, {
      children: [jsxRuntime_2("div", _assign2({
        className: "kxi-accordion-text kxi-title " + (noPadding ? 'kxi-accordion-no-padding' : '')
      }, {
        children: [icon && iconPlacement === 'text' && jsxRuntime_1(XIIcon, {
          icon: icon,
          className: "kxi-accordion-icon-left"
        }, void 0), jsxRuntime_1("p", _assign2({
          className: "" + normalizeColor(color),
          "data-testid": includeTestId('accordion-title')
        }, {
          children: title
        }), void 0)]
      }), void 0), jsxRuntime_2("div", _assign2({
        className: "kxi-title " + (noPadding ? 'kxi-accordion-no-padding' : '')
      }, {
        children: [icon && iconPlacement === 'caret' && jsxRuntime_1(XIIcon, {
          icon: icon,
          className: "kxi-accordion-icon"
        }, void 0), jsxRuntime_1(XIIcon, {
          icon: openState ? 'single_arrow_up' : 'single_arrow_down'
        }, void 0)]
      }), void 0)]
    }), void 0), jsxRuntime_1("div", _assign2({
      ref: childRef,
      id: id,
      className: "kxi-accordion-children " + overflowClass + " " + (openState ? 'kxi-accordion-open' : '') + " " + (noPadding ? 'kxi-accordion-no-padding' : '')
    }, {
      children: hasChildren(children) ? children : jsxRuntime_1(Slot, {
        name: "children",
        hasTranscluded: hasTranscluded,
        hasTranscludedContent: hasTranscludedContent,
        resetTransclusion: resetTransclusion,
        propsToWatch: []
      }, void 0)
    }), void 0)]
  }), void 0);
};

var defaults = {
  maxWidth: 320
};
var ToolTipWrapper = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
      stretch = props.stretch,
      text = props.text,
      title = props.title,
      _a = props.space,
      space = _a === void 0 ? 3 : _a,
      _b = props.direction,
      direction = _b === void 0 ? 6 : _b,
      opensOnClick = props.isOpenOnClick,
      maxWidth = props.maxWidth,
      _display = props._display,
      innerStyle = props.innerStyle,
      className = props.className,
      style = props.style,
      boldedText = props.boldedText,
      _c = props.usePortal,
      usePortal = _c === void 0 ? false : _c,
      _d = props.enabled,
      enabled = _d === void 0 ? true : _d,
      slotName = props.slotName,
      _hasTranscludedContent = props._hasTranscludedContent,
      _hasTranscluded = props._hasTranscluded,
      _reactSlot = props._reactSlot,
      _resetTransclusion = props._resetTransclusion,
      onOpenChange = props.onOpenChange,
      ingredients = __rest(props, ["children", "stretch", "text", "title", "space", "direction", "isOpenOnClick", "maxWidth", "_display", "innerStyle", "className", "style", "boldedText", "usePortal", "enabled", "slotName", "_hasTranscludedContent", "_hasTranscluded", "_reactSlot", "_resetTransclusion", "onOpenChange"]);

  var divRef = useRef(null);

  var _e = __read(useState(0), 2),
      childX = _e[0],
      setChildX = _e[1];

  var _f = __read(useState(0), 2),
      childY = _f[0],
      setChildY = _f[1];

  var _g = __read(useState(false), 2),
      hovered = _g[0],
      setHovered = _g[1];

  var _h = __read(useState(false), 2),
      clicked = _h[0],
      setClicked = _h[1];

  var _j = __read(useState(space), 2),
      spacing = _j[0],
      setSpacing = _j[1];

  var _k = __read(useState(uuidv4()), 1),
      uuid = _k[0];

  useEffect(function () {
    if (!opensOnClick) {
      setClicked(false);
    }
  }, [opensOnClick]);
  useEffect(function () {
    return function () {
      var tooltip = document.getElementById("tooltip-" + uuid);
      if (tooltip !== null) tooltip.remove();
    };
  }, []);
  useEffect(function () {
    setHovered(false);
  }, [enabled]);
  useEffect(function () {
    setSpacing(space);
  }, [space]);
  useEffect(function () {
    if (divRef.current && divRef.current.children[0]) {
      setChildX(divRef.current.children[0].clientWidth);
      setChildY(divRef.current.children[0].clientHeight);
    }
  }, [children]);
  useEffect(function () {
    var isOpen = opensOnClick ? clicked : hovered;

    if (usePortal) {
      if (isOpen) {
        var childElement = document.getElementById(uuid);
        var tooltipElement = document.getElementById("tooltip-" + uuid);
        var bodyElement = document.getElementsByTagName('body')[0];

        if (childElement && tooltipElement && bodyElement) {
          tooltipElement.classList.add('kxi-tooltip-wrapper');
          tooltipElement.style.top = childElement.getBoundingClientRect().top + document.documentElement.scrollTop + "px";
          tooltipElement.style.left = childElement.getBoundingClientRect().left + document.documentElement.scrollLeft + "px";
          bodyElement.appendChild(tooltipElement);
        }
      }
    }

    onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(isOpen);
  }, [clicked, hovered]);

  var getStyle = function getStyle() {
    switch (direction) {
      case 1:
        return {
          bottom: 0,
          right: 0,
          transform: "translate(" + childX + "px, -" + spacing + "px)"
        };

      case 2:
        return {
          top: 0,
          left: 0,
          transform: "translate(" + (childX + spacing) + "px, 0px)"
        };

      case 3:
        return {
          top: 0,
          left: 0,
          transform: "translateY(-50%) translate(" + (childX + spacing) + "px, " + childY / 2 + "px)"
        };

      case 4:
        return {
          bottom: 0,
          left: 0,
          transform: "translate(" + (childX + spacing) + "px, " + childY + "px)"
        };

      case 5:
        return {
          right: 0,
          top: 0,
          transform: "translate(" + childX + "px, " + (childY + spacing) + "px)"
        };

      case 6:
        return {
          top: 0,
          transform: "translateX(-50%) translate(" + childX / 2 + "px, " + (childY + spacing) + "px)"
        };

      case 7:
        return {
          left: 0,
          top: 0,
          transform: "translate(0px, " + (childY + spacing) + "px)"
        };

      case 8:
        return {
          left: 0,
          bottom: 0,
          transform: "translateX(-100%) translate(-" + spacing + "px, " + childY + "px)"
        };

      case 9:
        return {
          left: 0,
          top: 0,
          transform: "translate(-100%, -50%) translate(-" + spacing + "px, " + childY / 2 + "px)"
        };

      case 10:
        return {
          left: 0,
          top: 0,
          transform: "translateX(-100%) translate(-" + spacing + "px, 0px)"
        };

      case 11:
        return {
          bottom: 0,
          left: 0,
          transform: "translate(0px, -" + spacing + "px)"
        };

      case 12:
        return {
          bottom: 0,
          left: '50%',
          transform: "translateX(-50%) translate(" + childX / 2 + "px, -" + spacing + "px)"
        };
    }
  };

  var BoldText = function BoldText(text, bolded) {
    if (text) {
      var textArray_1 = text.split(bolded);
      return jsxRuntime_1("span", {
        children: textArray_1.map(function (item, index) {
          return jsxRuntime_2(jsxRuntime_3, {
            children: [item, index !== textArray_1.length - 1 && jsxRuntime_1("b", {
              children: bolded
            }, void 0)]
          }, void 0);
        })
      }, void 0);
    }
  };

  var generateTitle = function generateTitle() {
    if (title && boldedText) {
      return jsxRuntime_1("p", _assign2({
        className: "kxi-tooltip-title"
      }, {
        children: BoldText(title, boldedText)
      }), void 0);
    } else if (title) {
      return jsxRuntime_1("p", {
        className: "kxi-tooltip-title",
        dangerouslySetInnerHTML: {
          __html: DOMPurify.sanitize(title)
        }
      }, void 0);
    } else {
      return null;
    }
  };

  var generateBody = function generateBody() {
    if (text && boldedText) {
      return jsxRuntime_1("p", {
        children: BoldText(text, boldedText)
      }, void 0);
    } else if (text) {
      return jsxRuntime_1("p", {
        dangerouslySetInnerHTML: {
          __html: DOMPurify.sanitize(text)
        }
      }, void 0);
    } else {
      return null;
    }
  };

  var handleKeyPress = function handleKeyPress(e) {
    if (opensOnClick && hovered && e.key === 'Enter') {
      setClicked(!clicked);
    }
  };

  return jsxRuntime_1("div", _assign2({
    className: "kxi-tooltip-wrapper kxi-grey " + (className || '')
  }, ingredients, {
    style: _assign2({
      display: stretch ? 'block' : undefined
    }, style),
    onFocus: function onFocus() {
      return setHovered(true);
    },
    onBlur: function onBlur() {
      if (opensOnClick) {
        setClicked(false);
      }

      setHovered(false);
    },
    onKeyPress: handleKeyPress,
    ref: mergeRefs([ref, divRef])
  }, {
    children: jsxRuntime_2(AnimatePresence, {
      children: [jsxRuntime_1(motion.div, _assign2({
        exit: {
          opacity: 0,
          transition: {
            duration: 0.1
          }
        },
        onMouseOver: function onMouseOver() {
          return setHovered(true);
        },
        onMouseLeave: function onMouseLeave() {
          return setHovered(false);
        },
        onClick: function onClick() {
          if (opensOnClick) {
            setClicked(!clicked);
          }
        },
        style: stretch ? _assign2({}, innerStyle) : _assign2({
          display: 'inline-flex'
        }, innerStyle),
        "data-testid": 0,
        id: uuid
      }, {
        children: children
      }), void 0), jsxRuntime_1(motion.div, _assign2({
        "aria-disabled": !enabled,
        role: "tooltip",
        "aria-hidden": !hovered || !clicked,
        initial: {
          opacity: 0
        },
        animate: {
          opacity: 1,
          transition: {
            delay: opensOnClick ? 0 : 0.3,
            duration: 0.1
          }
        },
        exit: {
          opacity: 0,
          transition: {
            duration: 0.1
          }
        },
        style: {
          position: 'absolute',
          left: 0,
          top: 0,
          display: opensOnClick && clicked && enabled || !opensOnClick && hovered && enabled ? _display : 'none'
        },
        id: "tooltip-" + uuid
      }, {
        children: jsxRuntime_1("div", {
          children: jsxRuntime_1("div", _assign2({
            "aria-label": "tooltip text",
            className: "kxi-tooltip-text",
            style: _assign2(_assign2({}, getStyle()), {
              maxWidth: slotName ? undefined : maxWidth || defaults.maxWidth
            }),
            "data-testid": 1
          }, {
            children: slotName ? slotName.startsWith('_reactChild_') ? Children.toArray(_reactSlot).filter(function (item) {
              var _a;

              return ((_a = item.props) === null || _a === void 0 ? void 0 : _a['data-slotName']) === slotName.slice('_reactChild_'.length);
            }) : jsxRuntime_1(Slot, {
              name: slotName,
              hasTranscludedContent: _hasTranscludedContent,
              resetTransclusion: _resetTransclusion,
              propsToWatch: [],
              hasTranscluded: _hasTranscluded
            }, void 0) : jsxRuntime_2(jsxRuntime_3, {
              children: [generateTitle(), generateBody()]
            }, void 0)
          }), void 0)
        }, void 0)
      }), "tool_tip")]
    }, void 0)
  }), void 0);
});
var _SVGsOptions = ['binoculars', 'booking', 'browser_refresh', 'burger', 'camping', 'car', 'category', 'category_cycle', 'celebration', 'certificate', 'chart', 'chart_double', 'clapper_board', 'clipboard_planning', 'clothes_shopping', 'clothing_hung', 'cogs', 'colorful_wave', 'crane_illustration', 'crystal_ball', 'cx_background', 'cx_edit_dialog_left_bg', 'discount_tag', 'display_ab_running', 'display_app', 'display_banner', 'display_bottom_center', 'display_bottom_left', 'display_bottom_right', 'display_default', 'display_embedded', 'display_middle_center', 'display_middle_left', 'display_middle_right', 'display_popup', 'display_rating', 'display_tab', 'display_top_center', 'display_top_left', 'display_top_right', 'display_window', 'document_okay', 'document_section', 'email', 'employee_engagement', 'ex_background', 'ex_edit_dialog_left_bg', 'facebook', 'file_upload', 'four_square', 'fries', 'gift_card', 'globe', 'google', 'graph', 'graph_message', 'graph_mobile_web', 'graph_progress_search', 'graph_search', 'graph_web', 'groceries', 'group', 'hand_embrace', 'hand_favorite', 'hand_money', 'hand_security', 'hand_shake', 'health_grades', 'hospital', 'human_message', 'human_okay', 'inmoment_favicon_blue', 'inmoment_favicon_magenta', 'inmoment_favicon_orca', 'inmoment_favicon_purple', 'inmoment_favicon_teal', 'inmoment_favicon_white', 'inmoment_main_full_color', 'inmoment_main_white', 'inmoment_powered_by_horizontal_full_color', 'inmoment_powered_by_horizontal_gray', 'inmoment_powered_by_horizontal_orca', 'inmoment_powered_by_horizontal_white', 'inmoment_powered_by_vertical_full_color', 'inmoment_powered_by_vertical_gray', 'inmoment_powered_by_vertical_orca', 'inmoment_powered_by_vertical_white', 'instagram', 'international', 'late_rooms', 'location', 'location_map', 'message', 'message_group', 'mobile_touch', 'money', 'mx_background', 'mx_edit_dialog_left_bg', 'negative_sentiment', 'negative_sentiment_filled', 'negative_sentiment_outlined', 'neutral_sentiment', 'neutral_sentiment_filled', 'neutral_sentiment_outlined', 'no', 'none', 'numbers_graphic', 'open_table', 'other', 'outbound_call', 'outbound_email', 'people_boy', 'people_girl', 'person_favorite', 'planet_1', 'planet_2', 'plus', 'positive_sentiment', 'positive_sentiment_filled', 'positive_sentiment_outlined', 'post_transaction', 'product_offer', 'ramen', 'receipt', 'relationship', 'secret_code_graphic', 'security', 'skew_clock', 'skew_desktop_1', 'skew_desktop_2', 'skew_desktop_3', 'skew_phone_1', 'skew_phone_2', 'slide_widget_background', 'sms', 'spoof', 'spoof_2', 'star_circle', 'star_pointed', 'stethoscope', 'survey', 'target', 'thumbs_up', 'ticket', 'timeout_survey', 'trip_advisor', 'trophy', 'trust_pilot', 'twitter', 'user_categories', 'user_categories_complete', 'user_cycle', 'video', 'vitals', 'voice_of_employee', 'web', 'window_bank', 'window_banner', 'window_banner_above', 'window_banner_inline', 'window_default', 'window_embedded', 'window_feedback_default', 'window_popup', 'xi_icon', 'yelp', 'yes', 'zomato'];
var _IconsOptions = ['ab_testing', 'account', 'account_filled', 'action_planning', 'action_planning_filled', 'add_circle', 'add_circle_filled', 'analytics', 'analytics_filled', 'anomaly', 'anomaly_detection', 'anomaly_detection_filled', 'answer_distribution', 'answer_distribution_filled', 'app_admin', 'app_admin_filled', 'app_announcements', 'app_announcements_filled', 'app_benchmark', 'app_benchmark_filled', 'app_campaign_insights', 'app_campaign_insights_filled', 'app_case_management', 'app_case_management_filled', 'app_coach', 'app_coach_filled', 'app_cx_analyst', 'app_cx_analyst_filled', 'app_data_exploration', 'app_data_exploration_filled', 'app_discover', 'app_discover_filled', 'app_exec_reporting', 'app_exec_reporting_filled', 'app_explore', 'app_explore_filled', 'app_field_reporting', 'app_field_reporting_filled', 'app_home', 'app_home_filled', 'app_market_survey', 'app_market_survey_filled', 'app_metrics', 'app_metrics_filled', 'app_moments', 'app_moments_filled', 'app_reporting', 'app_reporting_filled', 'app_resolve', 'app_resolve_filled', 'app_seo', 'app_seo_filled', 'app_summary', 'app_summary_filled', 'app_textAnalytics', 'app_textAnalytics_filled', 'apps', 'arrow_down', 'arrow_left', 'arrow_link', 'arrow_right', 'arrow_up', 'attach', 'award', 'award_filled', 'barometer', 'barometer_filled', 'brackets', 'brand_survey', 'brand_survey_filled', 'calendar', 'calendar_filled', 'cancel', 'cancel_circle', 'cancel_circle_filled', 'case', 'case_complete', 'case_complete_filled', 'case_create', 'case_create_filled', 'case_filled', 'case_remove', 'case_remove_filled', 'category_closed', 'category_open', 'certificate', 'certificate_filled', 'chart', 'chart_1', 'chart_filled', 'chart_filled_1', 'check', 'checkmark', 'checkmark_18', 'circle_arrow_down', 'circle_arrow_down_filled', 'circle_arrow_left', 'circle_arrow_left_filled', 'circle_arrow_right', 'circle_arrow_right_filled', 'circle_arrow_up', 'circle_arrow_up_filled', 'circle_check', 'circle_check_filled', 'circle_navigation', 'circle_navigation_filled', 'city', 'clipboard', 'clipboard_2', 'clock', 'clock_2', 'clock_2_filled', 'clock_filled', 'coaching', 'coaching_filled', 'collections', 'collections_filled', 'comment', 'comment_filled', 'community', 'community_filled', 'condensed_card', 'condensed_card_filled', 'convert', 'cookies', 'cookies_filled', 'copy', 'copy_filled', 'crosstab', 'crosstab_filled', 'dark', 'dark_filled', 'database', 'database_connect', 'day', 'day_filled', 'desktop', 'desktop_filled', 'disable', 'divide', 'divide_filled', 'document', 'document_alert', 'document_alert_filled', 'document_bar_chart', 'document_bar_chart_filled', 'document_chart', 'document_chart_filled', 'document_coach', 'document_coach_filled', 'document_comment', 'document_comment_filled', 'document_crosstab', 'document_crosstab_filled', 'document_dashboard', 'document_dashboard_filled', 'document_export', 'document_export_filled', 'document_ext_csv', 'document_ext_excel', 'document_ext_excel_filled', 'document_ext_pdf', 'document_ext_pdf_filled', 'document_ext_txt', 'document_ext_xlm', 'document_ext_xls', 'document_ext_xml', 'document_ext_xml_filled', 'document_field_reporting', 'document_field_reporting_filled', 'document_filled', 'document_multiple', 'document_multiple_checked', 'document_multiple_checked_filled', 'document_multiple_filled', 'document_report', 'document_report_filled', 'document_resolve', 'document_resolve_filled', 'document_scorecard', 'document_scorecard_filled', 'document_settings', 'document_settings_filled', 'document_survey', 'document_survey_filled', 'document_trend', 'document_trend_filled', 'download', 'drag_handle', 'edit', 'edit_filled', 'edit_text', 'edit_text_filled', 'email', 'email_add', 'email_add_filled', 'email_checked', 'email_checked_filled', 'email_edit', 'email_edit_filled', 'email_filled', 'email_location', 'email_location_filled', 'email_location_filled_2', 'email_open', 'email_open_filled', 'email_remove', 'email_remove_filled', 'email_search', 'email_search_filled', 'email_send', 'email_send_filled', 'email_settings', 'email_settings_filled', 'enable', 'equal', 'exchange', 'exit', 'exit_filled', 'export_1', 'export_2', 'export_2_filled', 'external_link', 'external_link_filled', 'eye_scan', 'eye_scan_filled', 'fab_plus', 'favorite', 'favorite_filled', 'feedback', 'feedback_filled', 'filter', 'filter_add', 'filter_add_filled', 'filter_filled', 'filter_remove', 'filter_remove_filled', 'flag', 'flag_filled', 'folder', 'folder_filled', 'folder_private', 'folder_private_filled', 'forward_30', 'full_screen', 'game', 'game_filled', 'gender', 'gender_female', 'gender_male', 'globe', 'globe_filled', 'grid_view', 'grid_view_filled', 'history', 'hour_glass', 'hour_glass_filled', 'html', 'impact_analysis', 'indeterminate', 'indeterminate_18', 'info', 'info_filled', 'integrations', 'integrations_filled', 'invalid', 'kabob', 'kitchen', 'kitchen_filled', 'light', 'light_filled', 'lightbulb', 'lightbulb_filled', 'link', 'list_view', 'location', 'location_filled', 'lodge', 'lodge_filled_1', 'lodge_filled_2', 'logging', 'logging_filled', 'mapping', 'mapping_complete', 'mapping_complete_filled', 'market_survey', 'market_survey_filled', 'meatball', 'meatball_filled', 'menu', 'mobile', 'mobile_filled', 'monitor', 'monitor_filled', 'more', 'more_filled', 'multiple_layer', 'navigation', 'navigation_filled', 'new_window', 'new_window_filled', 'no_icon', 'notepad', 'notepad_filled', 'notification', 'notification_filled', 'notification_snooze', 'notification_snooze_filled', 'notifications_off', 'notifications_off_filled', 'organization', 'organization_filled', 'page_count', 'page_count_filled', 'parentheses', 'password', 'password_filled', 'password_open', 'password_open_filled', 'pause', 'pause_filled', 'permission', 'permission_filled', 'photo', 'photo_filled', 'pie_chart', 'pie_chart_filled', 'pin', 'pin_filled', 'play', 'play_control', 'play_control_filled', 'play_filled', 'plus', 'preview', 'preview_filled', 'previous_page', 'previous_page_filled', 'print', 'print_filled', 'product_survey', 'product_survey_filled', 'question_mark', 'receipt', 'receipt_filled', 'refresh', 'regional_summary', 'regional_summary_filled', 'remove_circle', 'remove_circle_filled', 'reply', 'reporting', 'reporting_filled', 'research_panel', 'research_panel_filled', 'rewind_15', 'rocket', 'rocket_filled', 'role', 'role_filled', 'save', 'save_filled', 'saved_views', 'saved_views_filled', 'schedule', 'schedule_filled', 'search', 'search_filled', 'search_suggestion', 'search_suggestion_filled', 'sentiment_negative', 'sentiment_negative_filled', 'sentiment_neutral', 'sentiment_neutral_filled', 'sentiment_positive', 'sentiment_positive_filled', 'settings', 'settings_filled', 'share', 'share_filled', 'shield', 'shield_filled', 'shield_remove', 'shield_remove_filled', 'shipping', 'shipping_filled', 'signature', 'signature_filled', 'single_arrow_down', 'single_arrow_left', 'single_arrow_right', 'single_arrow_up', 'single_layer', 'small_circle', 'small_circle_filled', 'small_down_triangle', 'small_down_triangle_filled', 'small_left_triangle', 'small_left_triangle_filled', 'small_right_triangle', 'small_right_triangle_filled', 'small_up_triangle', 'small_up_triangle_filled', 'sort', 'sort_order_asc', 'sort_order_desc', 'split', 'split_filled', 'star', 'star_filled', 'stethoscope', 'stethoscope_filled', 'style', 'style_filled', 'support', 'support_filled', 'survey_authoring', 'survey_authoring_filled', 'tag', 'tag_filled', 'text_formatting', 'theme', 'theme_filled', 'time', 'time_filled', 'tools', 'tools_filled', 'trash', 'trash_filled', 'tree_picker_collapse', 'tree_picker_expand', 'trend_flatten', 'trend_increase', 'upload', 'user_female', 'user_female_filled_1', 'user_female_filled_2', 'user_male', 'user_male_filled_1', 'user_male_filled_2', 'users', 'users_filled', 'video', 'video_filled', 'view_condensed', 'view_condensed_filled', 'view_normal', 'view_normal_filled', 'view_table', 'view_table_filled', 'visibility', 'visibility_filled', 'visibility_off', 'visibility_off_filled', 'volume_off', 'volume_off_filled', 'volume_on', 'volume_on_filled', 'warning', 'warning_filled', 'width', 'width_2', 'wifi'];
var _AppIconsOptions = ['admin', 'admin_white', 'announcements', 'announcements_white', 'benchmark', 'benchmark_white', 'campaign_insights', 'campaign_insights_white', 'case_management', 'case_management_white', 'coach', 'coach_location', 'coach_white', 'cx_analyst', 'cx_analyst_white', 'cxic_admin', 'cxic_reporting', 'dashboard', 'dashboard_white', 'data_exploration', 'data_exploration_white', 'discover', 'discover_insights', 'discover_insights_white', 'discover_white', 'exec_reporting', 'exec_reporting_white', 'explore', 'explore_white', 'field_reporting', 'field_reporting_white', 'home', 'home_white', 'invitation_management', 'invitation_management_white', 'kitchen', 'market_survey', 'market_survey_white', 'metrics', 'metrics_white', 'moments', 'moments_white', 'placeholder', 'placeholder_white', 'reporting', 'reporting_white', 'research', 'research_white', 'resolve', 'resolve_white', 'seo', 'seo_white', 'spotlight', 'spotlight_white', 'studio', 'studio_white', 'summary', 'summary_white', 'survey', 'survey_white', 'text_analytics', 'text_analytics_white', 'watch_list', 'watch_list_white', 'workflow'];
var _AppIconsWhiteOptions = ['admin_white', 'announcements_white', 'benchmark_white', 'campaign_insights_white', 'case_management_white', 'coach_white', 'cx_analyst_white', 'dashboard_white', 'data_exploration_white', 'discover_insights_white', 'discover_white', 'exec_reporting_white', 'explore_white', 'field_reporting_white', 'home_white', 'invitation_management_white', 'market_survey_white', 'metrics_white', 'moments_white', 'placeholder_white', 'reporting_white', 'research_white', 'resolve_white', 'seo_white', 'spotlight_white', 'studio_white', 'summary_white', 'survey_white', 'text_analytics_white', 'watch_list_white'];
var _AppIconsColorOptions = ['admin', 'announcements', 'benchmark', 'campaign_insights', 'case_management', 'coach', 'coach_location', 'cx_analyst', 'cxic_admin', 'cxic_reporting', 'dashboard', 'data_exploration', 'discover', 'discover_insights', 'exec_reporting', 'explore', 'field_reporting', 'home', 'invitation_management', 'kitchen', 'market_survey', 'metrics', 'moments', 'placeholder', 'reporting', 'research', 'resolve', 'seo', 'spotlight', 'studio', 'summary', 'survey', 'text_analytics', 'watch_list', 'workflow'];
var _LottiesOptions = ['admin_loader', 'confetti_hat', 'CUSTOMER_loader', 'cx_loader', 'EMPLOYEE_loader', 'ex_loader', 'MARKETING_loader', 'mx_loader', 'orca_loader', 'px_loader', 'PRODUCT_loader', 'planet_1'];
var EnumLottiesProd;

(function (EnumLottiesProd) {
  EnumLottiesProd["admin_loader"] = "admin_loader";
  EnumLottiesProd["confetti_hat"] = "confetti_hat";
  EnumLottiesProd["CUSTOMER_loader"] = "CUSTOMER_loader";
  EnumLottiesProd["cx_loader"] = "cx_loader";
  EnumLottiesProd["EMPLOYEE_loader"] = "EMPLOYEE_loader";
  EnumLottiesProd["ex_loader"] = "ex_loader";
  EnumLottiesProd["MARKETING_loader"] = "MARKETING_loader";
  EnumLottiesProd["mx_loader"] = "mx_loader";
  EnumLottiesProd["orca_loader"] = "orca_loader";
  EnumLottiesProd["px_loader"] = "px_loader";
  EnumLottiesProd["PRODUCT_loader"] = "PRODUCT_loader";
  EnumLottiesProd["planet_1"] = "planet_1";
})(EnumLottiesProd || (EnumLottiesProd = {}));

var _IconColorsOptions = __spreadArray(__spreadArray(__spreadArray([], __read(_ColorsOptions)), __read(_SentimentsOptions)), __read(_DisabledOptions));

var ButtonHTMLAttributes = function (_super) {
  __extends(ButtonHTMLAttributes, _super);

  function ButtonHTMLAttributes() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Boolean)], ButtonHTMLAttributes.prototype, "autoFocus");

  __decorate([Bound(), __metadata("design:type", Boolean)], ButtonHTMLAttributes.prototype, "disabled");

  __decorate([Bound(), __metadata("design:type", String)], ButtonHTMLAttributes.prototype, "form");

  __decorate([Bound(), __metadata("design:type", String)], ButtonHTMLAttributes.prototype, "formAction");

  __decorate([Bound(), __metadata("design:type", String)], ButtonHTMLAttributes.prototype, "formEncType");

  __decorate([Bound(), __metadata("design:type", String)], ButtonHTMLAttributes.prototype, "formMethod");

  __decorate([Bound(), __metadata("design:type", Boolean)], ButtonHTMLAttributes.prototype, "formNoValidate");

  __decorate([Bound(), __metadata("design:type", String)], ButtonHTMLAttributes.prototype, "formTarget");

  __decorate([Bound(), __metadata("design:type", String)], ButtonHTMLAttributes.prototype, "name");

  __decorate([Bound(), __metadata("design:type", String)], ButtonHTMLAttributes.prototype, "type");

  __decorate([Bound(), __metadata("design:type", Object)], ButtonHTMLAttributes.prototype, "value");

  return ButtonHTMLAttributes;
}(HTMLAttributes);

var ButtonHTMLEvents = function (_super) {
  __extends(ButtonHTMLEvents, _super);

  function ButtonHTMLEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return ButtonHTMLEvents;
}(DOMEvents);

var getViewBox = function getViewBox(lottieName) {
  switch (lottieName) {
    case 'cx_loader':
    case 'mx_loader':
    case 'ex_loader':
    case 'px_loader':
      return '0 0 600 600';

    case 'confetti_hat':
      return '0 0 360 360';

    case 'planet_1':
      return '0 0 200 200';

    default:
      return '0 0 600 600';
  }
};

function assetsRootPath() {
  var _a, _b;

  return ((_b = (_a = window.env) === null || _a === void 0 ? void 0 : _a.urls) === null || _b === void 0 ? void 0 : _b.resources) || 'https://assets.inmoment.com';
}

function kitchenRootPath() {
  var assetsRoot = assetsRootPath();
  return assetsRoot + "/assets/kitchen/v2";
}

var XIAnimationProps = function (_super) {
  __extends(XIAnimationProps, _super);

  function XIAnimationProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], XIAnimationProps.prototype, "animation");

  __decorate([Bound(), __metadata("design:type", Boolean)], XIAnimationProps.prototype, "loop");

  __decorate([Bound(), __metadata("design:type", Number)], XIAnimationProps.prototype, "height");

  __decorate([Bound(), __metadata("design:type", Number)], XIAnimationProps.prototype, "width");

  __decorate([Bound(), __metadata("design:type", Number)], XIAnimationProps.prototype, "animationDelay");

  return XIAnimationProps;
}(DivHTMLAttributes);

var XIAnimationEvents = function (_super) {
  __extends(XIAnimationEvents, _super);

  function XIAnimationEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return XIAnimationEvents;
}(DivHTMLEvents);

var animationSwitch = function animationSwitch(animation) {
  var normalizedName = animation.replace('CUSTOMER', 'cx').replace('EMPLOYEE', 'ex').replace('MARKETING', 'mx').replace('PRODUCT', 'px');
  var jsonUrl = kitchenRootPath() + "/lotties-jsons/" + normalizedName + ".json";
  var request = new XMLHttpRequest();
  request.open('GET', jsonUrl, false);
  request.send(null);

  if (request.status === 200) {
    var response = JSON.parse(request.responseText);
    return response;
  }

  return null;
};
/**
 * Description: Conveniently displays different Lottie animations we've preloaded into the platform.
 */


var XIAnimation = /*#__PURE__*/forwardRef(function (props, ref) {
  var animation = props.animation,
      height = props.height,
      width = props.width,
      loop = props.loop,
      _a = props.animationDelay,
      animationDelay = _a === void 0 ? 0 : _a,
      className = props.className,
      ingredients = __rest(props, ["animation", "height", "width", "loop", "animationDelay", "className"]);

  useEffect(function () {
    if (!animation) devOnlyWarn("The Kitchen: animation is a required prop - but it is omitted in XIAnimation");
  }, []);

  var _b = __read(useState(function () {
    return uuidv4();
  }), 1),
      uuid = _b[0];

  var _c = __read(useState(), 2),
      currAnimation = _c[0],
      setCurrAnimation = _c[1];

  var animate = function animate() {
    if (currAnimation) currAnimation.destroy();
    var animationData = animationSwitch(animation);
    var elem = document.getElementById(uuid);
    setTimeout(function () {
      if (elem) {
        var anim = Lottie.loadAnimation({
          container: elem,
          renderer: 'svg',
          loop: loop,
          autoplay: true,
          animationData: animationData,
          rendererSettings: {
            preserveAspectRatio: 'xMidYMid meet',
            viewBoxSize: getViewBox(animation)
          }
        });
        setCurrAnimation(anim);
      }
    }, animationDelay);
  };

  useEffect(function () {
    if (animation) animate();
  }, [animation, loop]);
  return jsxRuntime_1("div", _assign2({
    "data-testid": "xi-animation",
    className: "kxi-animation-wrapper " + (className || '')
  }, ingredients, {
    style: {
      height: height,
      width: width
    },
    id: uuid,
    ref: ref
  }), void 0);
});

var ImgHTMLAttributes = function (_super) {
  __extends(ImgHTMLAttributes, _super);

  function ImgHTMLAttributes() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return ImgHTMLAttributes;
}(HTMLAttributes);

var ImgHTMLEvents = function (_super) {
  __extends(ImgHTMLEvents, _super);

  function ImgHTMLEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return ImgHTMLEvents;
}(DOMEvents);

var XIAppIconProps = function (_super) {
  __extends(XIAppIconProps, _super);

  function XIAppIconProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], XIAppIconProps.prototype, "icon");

  __decorate([Bound(), __metadata("design:type", Number)], XIAppIconProps.prototype, "iconSize");

  __decorate([Bound(), __metadata("design:type", Boolean)], XIAppIconProps.prototype, "stretch");

  return XIAppIconProps;
}(ImgHTMLAttributes);

var XIAppIconEvents = function (_super) {
  __extends(XIAppIconEvents, _super);

  function XIAppIconEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return XIAppIconEvents;
}(ImgHTMLEvents);
/**
 * Description: Component that displays an Icon in the AppIcon category.
 */


var XIAppIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var icon = props.icon,
      _a = props.iconSize,
      iconSize = _a === void 0 ? 60 : _a,
      _b = props.stretch,
      stretch = _b === void 0 ? false : _b,
      className = props.className,
      ingredients = __rest(props, ["icon", "iconSize", "stretch", "className"]);

  useEffect(function () {
    throwPropErrorMessage('XIAppIcon', {
      icon: icon
    });
  }, [icon]);

  var style = _assign2({}, ingredients.style);

  var classList = "" + (className || '');

  if (!stretch) {
    style = _assign2({
      width: iconSize,
      height: iconSize
    }, style);
  } else {
    classList += ' kxi-stretch';
  }

  return jsxRuntime_1("img", _assign2({
    className: classList,
    "data-testid": icon + "_app_icon",
    src: kitchenRootPath() + "/app-icons/" + icon + ".svg",
    alt: icon
  }, ingredients, {
    style: style,
    ref: ref
  }), void 0);
});

var XISVGProps = function (_super) {
  __extends(XISVGProps, _super);

  function XISVGProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], XISVGProps.prototype, "svg");

  return XISVGProps;
}(ImgHTMLAttributes);

var XISVGEvents = function (_super) {
  __extends(XISVGEvents, _super);

  function XISVGEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return XISVGEvents;
}(ImgHTMLEvents);
/**
 * Description: Component that displays an svg.
 */


var XISVG = /*#__PURE__*/forwardRef(function (props, ref) {
  var svg = props.svg,
      className = props.className,
      ingredients = __rest(props, ["svg", "className"]);

  useEffect(function () {
    throwPropErrorMessage('XISVG', {
      svg: svg
    });
  }, [svg]);
  return jsxRuntime_1("img", _assign2({
    className: "kxi-stretch " + (className || ''),
    "data-testid": svg + "_SVG",
    src: kitchenRootPath() + "/svgs/" + svg + ".svg"
  }, ingredients, {
    alt: svg,
    ref: ref
  }), void 0);
});

var CloseIcon = function CloseIcon(props) {
  var cancelHover = props.cancelHover,
      className = props.className,
      setCancelHover = props.setCancelHover,
      changeOutline = props.changeOutline,
      cancelFn = props.cancelFn,
      disabled = props.disabled,
      contrast = props.contrast,
      _a = props.size,
      size = _a === void 0 ? 24 : _a,
      icon = props.icon;

  var handleClick = function handleClick(e) {
    if (cancelFn) cancelFn();
    e.stopPropagation();
    changeOutline(false);
  };

  var getIcon = function getIcon() {
    var _a, _b;

    if (icon) {
      if (cancelHover) {
        if (!icon.endsWith('_filled') && _IconsOptions.includes(icon + "_filled")) {
          return icon + "_filled";
        } else if (icon.endsWith('_filled') && _IconsOptions.includes((_a = icon.split('_filled')) === null || _a === void 0 ? void 0 : _a[0])) {
          return ((_b = icon.split('_filled')) === null || _b === void 0 ? void 0 : _b[0]) || icon;
        } else {
          devOnlyWarn("The Kitchen: The icon '" + icon + "' does not have a matching filled version. This icon will not have any hovered indication");
          return icon;
        }
      } else {
        return icon;
      }
    } else {
      return cancelHover ? 'cancel_circle_filled' : 'cancel_circle';
    }
  };

  var usedIcon = getIcon();
  return jsxRuntime_1(Fragment, {
    children: !disabled ? jsxRuntime_1("div", _assign2({
      role: "button",
      "aria-label": "cancel icon",
      "aria-disabled": disabled,
      className: className,
      style: {
        cursor: 'pointer'
      },
      onMouseEnter: function onMouseEnter() {
        return setCancelHover(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setCancelHover(false);
      },
      onClick: handleClick
    }, {
      children: _IconsOptions.includes(usedIcon) ? jsxRuntime_1(XIIcon, {
        iconSize: size,
        icon: usedIcon,
        contrast: contrast
      }, void 0) : jsxRuntime_1(XIAppIcon, {
        iconSize: size,
        icon: usedIcon,
        contrast: contrast
      }, void 0)
    }), void 0) : ''
  }, void 0);
};

var MotionDiv = function MotionDiv(props) {
  var error = props.error,
      hasAnimation = props.hasAnimation,
      stretch = props.stretch,
      className = props.className;
  var controls = useAnimation();

  var sequence = function sequence() {
    return new Promise(function (resolve) {
      controls.start({
        x: -6,
        transition: {
          duration: 0.08
        }
      }).then(function () {
        controls.start({
          x: 6,
          transition: {
            duration: 0.08
          }
        }).then(function () {
          controls.start({
            x: 0,
            transition: {
              type: 'spring',
              stiffness: 1000,
              damping: 10
            }
          }).then(function (reason) {
            resolve(reason);
          });
        });
      });
    });
  };

  if (hasAnimation) {
    return jsxRuntime_1(motion.div, _assign2({
      className: "kxi-animated-button " + (!stretch ? 'kxi-inline-block' : '') + " " + (className || ''),
      whileHover: {
        scale: 1.01
      },
      whileTap: {
        scale: 0.95
      },
      transition: {
        scale: {
          type: 'spring',
          stiffness: 800,
          damping: 20
        }
      },
      onClick: sequence,
      animate: error ? controls : {},
      "data-testid": "default-button-animation"
    }, {
      children: props.children
    }), void 0);
  } else {
    return jsxRuntime_1("div", _assign2({
      className: "" + (className || '')
    }, {
      children: props.children
    }), void 0);
  }
};

var DefaultButtonProps = function (_super) {
  __extends(DefaultButtonProps, _super);

  function DefaultButtonProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], DefaultButtonProps.prototype, "text");

  __decorate([Bound(), __metadata("design:type", String)], DefaultButtonProps.prototype, "fill");

  __decorate([Bound(), __metadata("design:type", String)], DefaultButtonProps.prototype, "buttonSize");

  __decorate([Bound(), __metadata("design:type", String)], DefaultButtonProps.prototype, "color");

  __decorate([Bound(), __metadata("design:type", String)], DefaultButtonProps.prototype, "sentimentIndicator");

  __decorate([Bound(), __metadata("design:type", String)], DefaultButtonProps.prototype, "contrast");

  __decorate([Bound(), __metadata("design:type", Boolean)], DefaultButtonProps.prototype, "hasAnimation");

  __decorate([Bound(), __metadata("design:type", Boolean)], DefaultButtonProps.prototype, "hasShadows");

  __decorate([Bound(), __metadata("design:type", String)], DefaultButtonProps.prototype, "icon");

  __decorate([Bound(), __metadata("design:type", Boolean)], DefaultButtonProps.prototype, "isIconLeft");

  __decorate([Bound(), __metadata("design:type", String)], DefaultButtonProps.prototype, "iconLeft");

  __decorate([Bound(), __metadata("design:type", String)], DefaultButtonProps.prototype, "iconRight");

  __decorate([Bound(), __metadata("design:type", Boolean)], DefaultButtonProps.prototype, "isIconRightButton");

  __decorate([Bound(), __metadata("design:type", Boolean)], DefaultButtonProps.prototype, "isIconLeftButton");

  __decorate([Bound(), __metadata("design:type", Object)], DefaultButtonProps.prototype, "status");

  __decorate([Bound(), __metadata("design:type", String)], DefaultButtonProps.prototype, "tone");

  __decorate([Bound(), __metadata("design:type", String)], DefaultButtonProps.prototype, "wrap");

  __decorate([Bound(), __metadata("design:type", Object)], DefaultButtonProps.prototype, "tooltip");

  __decorate([Bound(), __metadata("design:type", Boolean)], DefaultButtonProps.prototype, "stretch");

  __decorate([Bound(), __metadata("design:type", String)], DefaultButtonProps.prototype, "tag");

  return DefaultButtonProps;
}(ButtonHTMLAttributes);

var DefaultButtonEvents = function (_super) {
  __extends(DefaultButtonEvents, _super);

  function DefaultButtonEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], DefaultButtonEvents.prototype, "onIconClick");

  return DefaultButtonEvents;
}(ButtonHTMLEvents);
/**
 * Description: This is standard button and should be used whenever possible. A small button is also acceptable. Don't use all caps in buttons. Status will override all colors.
 */


var DefaultButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var _a = __read(useState(false), 2),
      hasErrorState = _a[0],
      setHasErrorState = _a[1];

  var _b = props.fill,
      fill = _b === void 0 ? 'fill' : _b,
      text = props.text,
      _c = props.color,
      color = _c === void 0 ? 'orca' : _c,
      sentimentIndicator = props.sentimentIndicator,
      _d = props.buttonSize,
      buttonSize = _d === void 0 ? 'normal' : _d,
      icon = props.icon,
      isIconLeft = props.isIconLeft,
      _e = props.hasAnimation,
      hasAnimation = _e === void 0 ? true : _e,
      _f = props.hasShadows,
      hasShadows = _f === void 0 ? false : _f,
      stretch = props.stretch,
      tooltip = props.tooltip,
      disabled = props.disabled,
      tabIndex = props.tabIndex,
      type = props.type,
      status = props.status,
      _g = props.contrast,
      contrast = _g === void 0 ? 'normal' : _g,
      _h = props.wrap,
      wrap = _h === void 0 ? 'nowrap' : _h,
      onClick = props.onClick,
      className = props.className,
      style = props.style,
      tag = props.tag,
      _j = props.tone,
      tone = _j === void 0 ? 'normal' : _j,
      isIconLeftButton = props.isIconLeftButton,
      isIconRightButton = props.isIconRightButton,
      iconLeft = props.iconLeft,
      iconRight = props.iconRight,
      onIconClick = props.onIconClick,
      ingredients = __rest(props, ["fill", "text", "color", "sentimentIndicator", "buttonSize", "icon", "isIconLeft", "hasAnimation", "hasShadows", "stretch", "tooltip", "disabled", "tabIndex", "type", "status", "contrast", "wrap", "onClick", "className", "style", "tag", "tone", "isIconLeftButton", "isIconRightButton", "iconLeft", "iconRight", "onIconClick"]);

  var _k = __read(useState(false), 2),
      leftIconHover = _k[0],
      setLeftIconHover = _k[1];

  var _l = __read(useState(false), 2),
      rightIconHover = _l[0],
      setRightIconHover = _l[1];

  useEffect(function () {
    warnIsDeprecated('DefaultButton', {
      icon: {
        message: 'Please iconLeft or iconRight instead',
        value: props.icon
      }
    }, 'prop');
    warnIsDeprecated('DefaultButton', {
      isIconLeft: {
        message: 'Please iconLeft or iconRight instead',
        value: props.isIconLeft
      }
    }, 'prop');
  }, []);
  useEffect(function () {
    if (status) {
      if (status === 'error') {
        setHasErrorState(true);
      } else {
        setHasErrorState(false);
      }
    } else {
      setHasErrorState(false);
    }
  }, [status]);
  /**
   * Error Messages for Required Props
   */

  var validType = checkIfButtonTypeIsValid('DefaultButton', type);
  var iconSize = buttonSize === 'small' ? 20 : buttonSize === 'large' ? 30 : buttonSize === 'xxlarge' ? 42 : 24;

  var handleClick = function handleClick(e) {
    if (!hasErrorState && !disabled) {
      if (onClick) onClick(e);
    }
  };

  var tagAndText = function tagAndText() {
    return jsxRuntime_2(jsxRuntime_3, {
      children: [tag && jsxRuntime_2("span", _assign2({
        className: "kxi-tag"
      }, {
        children: [tag, ":"]
      }), void 0), jsxRuntime_1("pre", {
        dangerouslySetInnerHTML: {
          __html: DOMPurify.sanitize(text || '')
        }
      }, void 0)]
    }, void 0);
  };

  var insertIconIfExists = function insertIconIfExists() {
    if (icon) {
      return jsxRuntime_1(jsxRuntime_3, {
        children: isIconLeft ? jsxRuntime_2(jsxRuntime_3, {
          children: [jsxRuntime_1(XIIcon, {
            icon: icon,
            iconSize: iconSize,
            style: {
              marginRight: text && text.trim() !== '' ? 6 : 0
            }
          }, void 0), tagAndText()]
        }, void 0) : jsxRuntime_2(jsxRuntime_3, {
          children: [tagAndText(), jsxRuntime_1(XIIcon, {
            icon: icon,
            iconSize: iconSize,
            style: {
              marginLeft: text && text.trim() !== '' ? 6 : 0
            }
          }, void 0)]
        }, void 0)
      }, void 0);
    } else if (iconLeft || iconRight) {
      var leftIcon = iconLeft ? isIconLeftButton ? jsxRuntime_1(CloseIcon, {
        icon: iconLeft,
        size: iconSize,
        className: 'kxi-default-icon-button kxi-icon-left',
        disabled: disabled || false,
        contrast: contrast,
        cancelFn: function cancelFn() {
          if (onIconClick) onIconClick('Left');
        },
        changeOutline: function changeOutline() {
          return false;
        },
        cancelHover: leftIconHover,
        setCancelHover: setLeftIconHover
      }, void 0) : jsxRuntime_1("div", _assign2({
        className: "kxi-default-icon-button kxi-icon-left"
      }, {
        children: _IconsOptions.includes(iconLeft) ? jsxRuntime_1(XIIcon, {
          icon: iconLeft,
          iconSize: iconSize
        }, void 0) : jsxRuntime_1(XIAppIcon, {
          icon: iconLeft,
          iconSize: iconSize
        }, void 0)
      }), void 0) : undefined;
      var rightIcon = iconRight ? isIconRightButton ? jsxRuntime_1(CloseIcon, {
        icon: iconRight,
        size: iconSize,
        className: 'kxi-default-icon-button kxi-icon-right',
        disabled: disabled || false,
        contrast: contrast,
        cancelFn: function cancelFn() {
          if (onIconClick) onIconClick('Right');
        },
        changeOutline: function changeOutline() {
          return false;
        },
        cancelHover: rightIconHover,
        setCancelHover: setRightIconHover
      }, void 0) : jsxRuntime_1("div", _assign2({
        className: "kxi-default-icon-button kxi-icon-right"
      }, {
        children: _IconsOptions.includes(iconRight) ? jsxRuntime_1(XIIcon, {
          icon: iconRight,
          iconSize: iconSize
        }, void 0) : jsxRuntime_1(XIAppIcon, {
          icon: iconRight,
          iconSize: iconSize
        }, void 0)
      }), void 0) : undefined;
      return jsxRuntime_2(jsxRuntime_3, {
        children: [leftIcon, tagAndText(), rightIcon]
      }, void 0);
    } else {
      return tagAndText();
    }
  };

  var getClassList = function getClassList() {
    var classList = "kxi-button";
    classList += buttonSize ? " kxi-" + buttonSize : '';
    classList += text && text.trim() !== '' || tag && tag.trim() !== '' ? ' kxi-text-button' : '';
    classList += (icon && isIconLeft || iconLeft) && text && text.trim() !== '' ? " kxi-icon-left " : ' ';
    classList += (icon && !isIconLeft || iconRight) && text && text.trim() !== '' ? " kxi-icon-right " : ' ';
    classList += status ? " kxi-" + status : '';
    classList += fill ? " kxi-button-" + fill : '';
    classList += contrast === 'high' ? ' kxi-high-contrast' : '';
    classList += wrap ? " kxi-text-wrap-" + wrap : '';
    classList += stretch ? " kxi-stretch-width" : '';

    if (!disabled) {
      classList += hasShadows ? ' kxi-shadows' : '';
      classList += tone === 'light' ? ' kxi-tone-light' : '';
    }

    return classList;
  }; // Only use the position elements on the outer style, pass other style elements through to button


  var _m = style || {},
      position = _m.position,
      top = _m.top,
      left = _m.left,
      right = _m.right,
      bottom = _m.bottom,
      display = _m.display,
      otherStyles = __rest(_m, ["position", "top", "left", "right", "bottom", "display"]);

  var stretchDisplay = stretch ? 'inherit' : 'inline-flex';
  var button = jsxRuntime_1("div", _assign2({
    className: color ? normalizeColor(color) : '',
    style: {
      position: position,
      top: top,
      left: left,
      right: right,
      bottom: bottom,
      display: display || stretchDisplay
    }
  }, {
    children: jsxRuntime_2(MotionDiv, _assign2({
      stretch: true,
      error: hasErrorState,
      hasAnimation: disabled ? false : hasAnimation
    }, {
      children: [jsxRuntime_1("button", _assign2({
        className: getClassList() + " " + (className || ''),
        style: _assign2({}, otherStyles),
        type: validType ? type : undefined,
        onClick: handleClick
      }, ingredients, {
        ref: ref,
        disabled: disabled,
        tabIndex: tabIndex
      }, {
        children: insertIconIfExists()
      }), void 0), sentimentIndicator && jsxRuntime_1("div", {
        className: "kxi-btn-sentiment-indicator " + normalizeColor(sentimentIndicator)
      }, void 0)]
    }), void 0)
  }), void 0);
  var renderButton = disabled || !tooltip ? button : jsxRuntime_1(ToolTipWrapper, _assign2({
    stretch: stretch
  }, tooltip, {
    children: button
  }), void 0);
  return jsxRuntime_1(jsxRuntime_3, {
    children: renderButton
  }, void 0);
});

var AlertInlineMainProps = function (_super) {
  __extends(AlertInlineMainProps, _super);

  function AlertInlineMainProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], AlertInlineMainProps.prototype, "subtitle");

  __decorate([Bound(), __metadata("design:type", String)], AlertInlineMainProps.prototype, "title");

  __decorate([Bound(), __metadata("design:type", String)], AlertInlineMainProps.prototype, "color");

  __decorate([Bound(), __metadata("design:type", Boolean)], AlertInlineMainProps.prototype, "isVisible");

  __decorate([Bound(), __metadata("design:type", Object)], AlertInlineMainProps.prototype, "buttons");

  return AlertInlineMainProps;
}(DivHTMLAttributes);

var AlertInlineMainEvents = function (_super) {
  __extends(AlertInlineMainEvents, _super);

  function AlertInlineMainEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return AlertInlineMainEvents;
}(DivHTMLEvents);
/**
 * Description: Give the user feedback that is good, bad, or a warning.
 */


var AlertInlineMain = /*#__PURE__*/forwardRef(function (props, ref) {
  var _a = props.isVisible,
      isVisible = _a === void 0 ? true : _a,
      _b = props.color,
      color = _b === void 0 ? 'orca' : _b,
      title = props.title,
      subtitle = props.subtitle,
      buttons = props.buttons,
      ingredients = __rest(props, ["isVisible", "color", "title", "subtitle", "buttons"]);

  var highlightColor = normalizeColor(color);
  useEffect(function () {
    throwPropErrorMessage('AlertInlineMain', {
      title: title,
      subtitle: subtitle
    });
  }, [title, subtitle]);
  return jsxRuntime_1("div", _assign2({
    role: "alert",
    "aria-hidden": !isVisible,
    className: highlightColor + " kxi-alert-inline-main-wrapper"
  }, ingredients, {
    ref: ref
  }, {
    children: jsxRuntime_1(AnimatePresence, {
      children: isVisible && jsxRuntime_1(motion.div, _assign2({
        animate: {
          maxHeight: 750,
          opacity: 1
        },
        initial: {
          maxHeight: 0,
          opacity: 0
        },
        exit: {
          maxHeight: 0,
          opacity: 0
        },
        transition: {
          duration: 0.3,
          ease: 'easeInOut'
        },
        "data-testid": 0
      }, {
        children: jsxRuntime_1("div", _assign2({
          className: "kxi-color-accent"
        }, {
          children: jsxRuntime_2("div", _assign2({
            className: "kxi-alert-inline-main-content kxi-grey"
          }, {
            children: [jsxRuntime_1("p", _assign2({
              className: "kxi-text-large kxi-text-600"
            }, {
              children: title
            }), void 0), jsxRuntime_1("p", _assign2({
              className: "kxi-text-normal"
            }, {
              children: subtitle
            }), void 0), buttons && jsxRuntime_2("div", _assign2({
              className: "kxi-alert-inline-main-button-container kxi-stretch-width"
            }, {
              children: [buttons.secondary && buttons.secondary.text && jsxRuntime_1(DefaultButton, {
                fill: "text",
                color: "orca",
                text: buttons.secondary.text,
                buttonSize: "normal",
                onClick: buttons.secondary.onClick,
                "data-testid": 1
              }, void 0), buttons.primary.text && jsxRuntime_1("div", _assign2({
                className: "kxi-alert-inline-main-primary-button"
              }, {
                children: jsxRuntime_1(DefaultButton, {
                  fill: "outline",
                  color: color,
                  text: buttons.primary.text,
                  buttonSize: "normal",
                  onClick: buttons.primary.onClick,
                  "data-testid": 2
                }, void 0)
              }), void 0)]
            }), void 0)]
          }), void 0)
        }), void 0)
      }), void 0)
    }, void 0)
  }), void 0);
}); // eslint-disable-next-line @typescript-eslint/ban-types

var debounce = function debounce(fn, ms) {
  if (ms === void 0) {
    ms = 100;
  }

  var timeoutId;
  return function () {
    var _this = this;

    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    clearTimeout(timeoutId);
    timeoutId = setTimeout(function () {
      return fn.apply(_this, args);
    }, ms);
  };
};

var useInterval = function useInterval(callback, delay) {
  var savedCallback = useRef();
  var callBackCopy;

  if (savedCallback) {
    callBackCopy = savedCallback;
  }

  useEffect(function () {
    savedCallback.current = callback;
  }, [callback]);
  useEffect(function () {
    var tick = function tick() {
      callBackCopy.current();
    };

    if (delay !== null) {
      var id_1 = setInterval(tick, delay);
      return function () {
        return clearInterval(id_1);
      };
    }
  }, [delay]);
};

var useWindowSize = function useWindowSize() {
  var _a = __read(useState({
    height: window.innerHeight,
    width: window.innerWidth,
    size: window.innerWidth >= 960 ? 'desktop' : window.innerWidth >= 480 ? 'tablet' : 'mobile'
  }), 2),
      dimensions = _a[0],
      setDimensions = _a[1];

  useEffect(function () {
    var handleResize = debounce(function () {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
        size: window.innerWidth >= 960 ? 'desktop' : window.innerWidth >= 480 ? 'tablet' : 'mobile'
      });
    });
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return dimensions;
};

var usePrevious = function usePrevious(value) {
  var baseValue = typeof value === 'number' ? 0 : '';
  var ref = useRef(baseValue);
  useEffect(function () {
    ref.current = value;
  });
  return ref.current;
};

var useMaskedInput = function useMaskedInput(mask, observer) {
  var _a = __read(useState(''), 2),
      maskedValue = _a[0],
      setMaskedValue = _a[1];

  useEffect(function () {
    if (observer && mask) {
      observer.value = maskedValue;
    }
  }, [observer, maskedValue]);
  var maskRef = useRef(null);
  useEffect(function () {
    var remainingChars = mask.substr(maskedValue.length, mask.length).split('');
    var hasOnlySymbolsLeft = true;

    if (!remainingChars.length) {
      hasOnlySymbolsLeft = false;
    }

    remainingChars.forEach(function (item) {
      if (switchMaskCharType(item) !== 'symbol') {
        hasOnlySymbolsLeft = false;
      }
    });

    if (hasOnlySymbolsLeft) {
      setMaskedValue(maskedValue + remainingChars.join(''));
    }
  }, [maskedValue]);

  var findNewCursorIndex = function findNewCursorIndex(value, selectionEnd, toGo, isDeleted) {
    var hasGone = 0; // due to selectionEnd being the value AFTER something is typed, need to account for extra shift based on deletion or addition of string

    var shift = isDeleted ? 0 : 1;

    for (var i = selectionEnd; i < value.length; i++) {
      if (hasGone < toGo) {
        if (determineCharType(value[i]) !== 'symbol') {
          hasGone++;
        }
      } else {
        return i - shift;
      }
    }

    return -1;
  };

  var getMinCursor = function getMinCursor(mask) {
    for (var i = 0; i < mask.length; i++) {
      if (switchMaskCharType(mask[i]) !== 'symbol') {
        return i + 1;
      }
    }

    return -1;
  };

  var buildValue = function buildValue(value) {
    var typedCharIndex = value.length - 1;
    var currVal = value[typedCharIndex];
    var currMask = mask[typedCharIndex];

    if (currVal && currMask) {
      value = value.substring(0, typedCharIndex);
      var maskType = switchMaskCharType(currMask);
      var valType = determineCharType(currVal);
      var isTypeSame = maskType === valType;
      var valIsAlphaNumeric = valType === 'alpha' || valType === 'numeric';
      var isAlphaNumeric = maskType === 'alphanumeric' && valIsAlphaNumeric;

      if (isTypeSame || isAlphaNumeric) {
        if (maskType === 'symbol' && valType === 'symbol') {
          if (currVal === currMask) {
            return value += currVal;
          } else {
            return value;
          }
        }

        return value += currVal;
      } else {
        if (maskType === 'symbol') {
          value = value + currMask + currVal;
          value = buildValue(value);
        }

        return value;
      }
    } else {
      return '';
    }
  };

  var simulateTyping = function simulateTyping(value) {
    var letters = value.split(''); // masked value is currently as previous value

    var diff = maskedValue.length - value.length;
    var isDeleted = diff > 0; // on deletion

    if (isDeleted) {
      var lastMaskedChar = lastChar(maskedValue);

      if (determineCharType(lastMaskedChar) === 'symbol' && diff === 1) {
        letters.pop();
      }

      letters = letters.filter(function (letter) {
        return determineCharType(letter) === 'alpha' || determineCharType(letter) === 'numeric';
      });
    }

    var newValue = '';
    letters.forEach(function (letter) {
      newValue += letter;
      newValue = buildValue(newValue);
    });
    return [newValue, isDeleted];
  };

  var handleChange = function handleChange(e, onChange, onInputEnter) {
    var _a = e.target,
        value = _a.value,
        selectionEnd = _a.selectionEnd;

    if (value.length <= mask.length) {
      var _b = __read(simulateTyping(value), 2),
          newValue_1 = _b[0],
          isDeleted_1 = _b[1];

      var newNonSymbolValueCount_1 = countChars(newValue_1);
      var newNonSymbolMaskedCount = countChars(maskedValue);
      var nonSymbolDiff_1 = newNonSymbolValueCount_1 - newNonSymbolMaskedCount;
      setMaskedValue(newValue_1); // here to ensure it runs after everything (callbacks as well as the selection)

      setTimeout(function () {
        var _a;

        var newCursor = findNewCursorIndex(newValue_1, selectionEnd, nonSymbolDiff_1, isDeleted_1);

        if (newCursor !== -1) {
          var minCursor = getMinCursor(mask);

          if (minCursor > newCursor && newNonSymbolValueCount_1 === 1) {
            newCursor = minCursor;
          }

          (_a = maskRef.current) === null || _a === void 0 ? void 0 : _a.setSelectionRange(newCursor, newCursor);
        }

        if (onChange) onChange(e);
        if (onInputEnter) onInputEnter(newValue_1);
      }, 0);
    }
  };

  return [handleChange, maskedValue, setMaskedValue, simulateTyping, maskRef];
};

var useNotes = function useNotes(notesData, hasNotes, isCondensedExperienceCard) {
  if (isCondensedExperienceCard === void 0) {
    isCondensedExperienceCard = false;
  }

  var notes = notesData.notes,
      _a = notesData.placeholder,
      placeholder = _a === void 0 ? 'Type a note and press enter to add.' : _a;

  var _b = __read(useState(notes), 2),
      notesState = _b[0],
      setNotesState = _b[1];

  var _c = __read(useState(false), 2),
      isNotesOpen = _c[0],
      setIsNotesOpen = _c[1];

  var _d = __read(useState(false), 2),
      isAddingNote = _d[0],
      setIsAddingNotes = _d[1];

  var notesRef = useRef(null);
  var notesWrapperRef = useRef(null);
  useEffect(function () {
    setNotesState(notes);
  }, [notes]);
  var showNotes = hasNotes && isNotesOpen;
  var notesExist = notesData.notes && !!notesData.notes.length;
  var displayCondensedNotes = showNotes;
  var displayExpCardNotes = hasNotes || notesExist;
  return {
    notesState: notesState,
    setNotesState: setNotesState,
    setIsNotesOpen: setIsNotesOpen,
    isAddingNote: isAddingNote,
    setIsAddingNotes: setIsAddingNotes,
    notesRef: notesRef,
    notesWrapperRef: notesWrapperRef,
    placeholder: placeholder,
    displayNotes: isCondensedExperienceCard ? displayCondensedNotes : displayExpCardNotes
  };
};

var useHighlightText = function useHighlightText(highlightedText, textContainer) {
  var _a = __read(useState([]), 2),
      highlightedCommentText = _a[0],
      setHighlightedCommentText = _a[1];

  var _b = __read(useState(''), 2),
      rawText = _b[0],
      setRawText = _b[1];

  var rawTextRef = useRef(null);
  useLayoutEffect(function () {
    var _a;

    setRawText(((_a = rawTextRef.current) === null || _a === void 0 ? void 0 : _a.innerText) || '');
  }, [textContainer, rawTextRef, highlightedText]);
  useEffect(function () {
    if (highlightedText) {
      var delimiter = uuidv4();
      var highlightedTextArr_1 = !Array.isArray(highlightedText) ? [highlightedText.trim()] : __spreadArray([], __read(highlightedText)).map(function (x) {
        return x.trim();
      });
      highlightedTextArr_1 = highlightedTextArr_1.map(function (value) {
        return escapeRegex(value);
      }); // look for any of the highlighted search words within the raw text

      var regex = new RegExp("(" + highlightedTextArr_1.join('|') + ")", 'gi');
      var foundLetters = rawText.replace(regex, delimiter + "$1" + delimiter).split(delimiter);
      var mapped = foundLetters.map(function (item, i) {
        if (highlightedTextArr_1.find(function (text) {
          return text.toLowerCase() === escapeRegex(item).toLowerCase();
        })) {
          return jsxRuntime_1("mark", {
            children: item
          }, i);
        } else {
          return jsxRuntime_1(Fragment, {
            children: item
          }, i);
        }
      });
      setHighlightedCommentText(mapped);
    } else {
      setHighlightedCommentText([]);
    }
  }, [highlightedText, rawText]);
  return [rawTextRef, highlightedCommentText];
};

var SnackBarItem = function SnackBarItem(props) {
  var index = props.index,
      externalProps = __rest(props, ["index"]);

  delete externalProps.height;
  delete externalProps.width;
  var text = externalProps.text,
      actionText = externalProps.actionText,
      isActionTextBelow = externalProps.isActionTextBelow,
      mode = externalProps.mode,
      onInternalDismiss = externalProps.onInternalDismiss,
      onDismiss = externalProps.onDismiss,
      onActionClick = externalProps.onActionClick;

  var handleClick = function handleClick() {
    if (onInternalDismiss) {
      onInternalDismiss(index);

      if (onActionClick) {
        onActionClick(externalProps);
      }

      if (onDismiss) {
        onDismiss(externalProps);
      }
    }
  };

  var getClassList = function getClassList() {
    return "kxi-snackbar-item kxi-snackbar-" + mode + "-wrapper ";
  };

  var getActionClassList = function getActionClassList() {
    return "cx kxi-snackbar-dismiss-wrapper " + (mode === 'error' ? 'kxi-snackbar-action-error' : '');
  };

  var isError = mode === 'error';
  return jsxRuntime_2("div", _assign2({
    className: getClassList(),
    "data-testid": isError ? 1 : 0
  }, {
    children: [isError ? jsxRuntime_1("div", {
      className: "kxi-snackbar-error-sidebar kxi-error"
    }, void 0) : null, jsxRuntime_2("div", _assign2({
      className: "kxi-snackbar-action " + (isActionTextBelow ? 'kxi-snackbar-action-below' : '')
    }, {
      children: [jsxRuntime_1("div", {
        className: "kxi-snackbar-text",
        dangerouslySetInnerHTML: {
          __html: DOMPurify.sanitize(text || '')
        }
      }, void 0), jsxRuntime_1("div", _assign2({
        className: getActionClassList(),
        onClick: handleClick
      }, {
        children: jsxRuntime_1("span", _assign2({
          className: "pointer"
        }, {
          children: actionText
        }), void 0)
      }), void 0)]
    }), void 0)]
  }), void 0);
};

var animations = {
  show: {
    // x: 0,
    y: 0,
    opacity: 1,
    scale: 1,
    transition: {
      type: 'spring',
      damping: 40,
      mass: 0.2,
      stiffness: 100 // velocity: 2

    }
  },
  dismiss: {
    opacity: 0,
    scale: 1,
    height: 48,
    transition: {
      ease: 'circOut',
      duration: 0.15
    }
  }
};
var SnackBarList = /*#__PURE__*/forwardRef(function (props, ref) {
  var snackBars = props.snackBars,
      deleteItem = props.deleteItem,
      className = props.className,
      ingredients = __rest(props, ["snackBars", "deleteItem", "className"]);

  var toBeDisplayed = snackBars.map(function (item, i) {
    return jsxRuntime_1(motion.li, _assign2({
      initial: {
        opacity: 0,
        rotate: 180
      },
      animate: animations.show,
      exit: animations.dismiss,
      style: {
        margin: 12
      }
    }, {
      children: jsxRuntime_1(SnackBarItem, _assign2({}, item, {
        text: item.text || '',
        index: i,
        onInternalDismiss: deleteItem
      }), void 0)
    }), item.id);
  });
  return jsxRuntime_1("ul", _assign2({
    className: "kxi-snackbar-wrapper orca " + (className || ''),
    ref: ref
  }, ingredients, {
    role: "log",
    "aria-label": "snackbar list"
  }, {
    children: jsxRuntime_1(AnimatePresence, _assign2({
      initial: false
    }, {
      children: toBeDisplayed
    }), void 0)
  }), void 0);
});

var UListHTMLAttributes = function (_super) {
  __extends(UListHTMLAttributes, _super);

  function UListHTMLAttributes() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return UListHTMLAttributes;
}(HTMLAttributes);

var UListHTMLEvents = function (_super) {
  __extends(UListHTMLEvents, _super);

  function UListHTMLEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return UListHTMLEvents;
}(DOMEvents);

var SnackBarProps = function (_super) {
  __extends(SnackBarProps, _super);

  function SnackBarProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Boolean)], SnackBarProps.prototype, "autoDismiss");

  __decorate([Bound(), __metadata("design:type", String)], SnackBarProps.prototype, "mode");

  __decorate([Bound(), __metadata("design:type", String)], SnackBarProps.prototype, "text");

  __decorate([Bound(), __metadata("design:type", String)], SnackBarProps.prototype, "id");

  __decorate([Bound(), __metadata("design:type", Number)], SnackBarProps.prototype, "dismissTime");

  __decorate([Bound(), __metadata("design:type", String)], SnackBarProps.prototype, "dismissText");

  __decorate([Bound(), __metadata("design:type", String)], SnackBarProps.prototype, "actionText");

  __decorate([Bound(), __metadata("design:type", Boolean)], SnackBarProps.prototype, "isActionTextBelow");

  return SnackBarProps;
}(UListHTMLAttributes);

var SnackBarEvents = function (_super) {
  __extends(SnackBarEvents, _super);

  function SnackBarEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], SnackBarEvents.prototype, "onDismiss");

  __decorate([Bound(), __metadata("design:type", Function)], SnackBarEvents.prototype, "onActionClick");

  return SnackBarEvents;
}(UListHTMLEvents);
/**
 * Description: Replaced (in most cases) our ErrorToaster. 'error' will never auto-dismiss. dismissTime is in milliseconds
 */


var SnackBar = /*#__PURE__*/forwardRef(function (props, ref) {
  var _a = props.autoDismiss,
      autoDismiss = _a === void 0 ? false : _a,
      _b = props.mode,
      mode = _b === void 0 ? 'default' : _b,
      text = props.text,
      id = props.id,
      dismissText = props.dismissText,
      _c = props.actionText,
      actionText = _c === void 0 ? 'Dismiss' : _c,
      _d = props.dismissTime,
      dismissTime = _d === void 0 ? 5000 : _d,
      _e = props.isActionTextBelow,
      isActionTextBelow = _e === void 0 ? false : _e,
      onDismiss = props.onDismiss,
      onActionClick = props.onActionClick,
      ingredients = __rest(props, ["autoDismiss", "mode", "text", "id", "dismissText", "actionText", "dismissTime", "isActionTextBelow", "onDismiss", "onActionClick"]);

  var _f = __read(useState([]), 2),
      snackbars = _f[0],
      setSnackbars = _f[1];

  useEffect(function () {
    warnIsDeprecated('SnackBar', {
      dismissText: {
        message: 'Please use actionText instead.',
        value: props.dismissText
      }
    }, 'prop');
  }, []);
  useInterval(function () {
    for (var i = 0; i < snackbars.length; i++) {
      var dismissMS = snackbars[i].dismissTime;

      if (!dismissMS) {
        dismissMS = 5000;
      }

      if (snackbars[i].autoDismiss && parseInt(snackbars[i].addedTime, 10) + Number(dismissMS) <= new Date().getTime()) {
        if (snackbars[i].mode === 'default') {
          var onDismiss_1 = snackbars[i].onDismiss;
          if (onDismiss_1) onDismiss_1(snackbars[i]);
          deleteItem(i);
        }
      }
    }
  }, 200);
  useEffect(function () {
    if (id) {
      addSnackBar();
    }
  }, [id]);

  var deleteItem = function deleteItem(i) {
    var copy = __spreadArray([], __read(snackbars));

    copy.splice(i, 1);
    setSnackbars(copy);
  };

  var addSnackBar = function addSnackBar() {
    var copy = __spreadArray([], __read(snackbars));

    var snackObject = {
      mode: mode || 'default',
      text: text,
      autoDismiss: autoDismiss,
      id: id,
      dismissTime: dismissTime,
      actionText: dismissText !== null && dismissText !== void 0 ? dismissText : actionText,
      isActionTextBelow: isActionTextBelow,
      onDismiss: onDismiss,
      onActionClick: onActionClick,
      addedTime: new Date().getTime().toString()
    };
    copy.unshift(snackObject);
    setSnackbars(copy);
  };

  return /*#__PURE__*/createPortal(jsxRuntime_1(SnackBarList, _assign2({
    deleteItem: deleteItem,
    snackBars: snackbars
  }, ingredients, {
    ref: ref
  }), void 0), document.body);
});
var initial = AnimatePresenceStates.initial,
    animate = AnimatePresenceStates.animate,
    exit = AnimatePresenceStates.exit;

var SuccessToasterProps = function (_super) {
  __extends(SuccessToasterProps, _super);

  function SuccessToasterProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], SuccessToasterProps.prototype, "title");

  __decorate([Bound(), __metadata("design:type", String)], SuccessToasterProps.prototype, "subtitle");

  __decorate([Bound(), __metadata("design:type", Boolean)], SuccessToasterProps.prototype, "isVisible");

  return SuccessToasterProps;
}(DivHTMLAttributes);

var SuccessToasterEvents = function (_super) {
  __extends(SuccessToasterEvents, _super);

  function SuccessToasterEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return SuccessToasterEvents;
}(DivHTMLEvents);
/**
 * Description: Toaster that pops up and displays a success message displaying to them a good time.
 */


var SuccessToaster = /*#__PURE__*/forwardRef(function (props, ref) {
  var title = props.title,
      subtitle = props.subtitle,
      isVisible = props.isVisible,
      className = props.className,
      ingredients = __rest(props, ["title", "subtitle", "isVisible", "className"]);

  useEffect(function () {
    throwPropErrorMessage('SuccessToaster', {
      title: title,
      subtitle: subtitle,
      isVisible: isVisible
    });
  }, []);
  return /*#__PURE__*/createPortal(jsxRuntime_1(AnimatePresence, {
    children: isVisible && jsxRuntime_1(motion.div, _assign2({
      initial: initial,
      animate: animate,
      exit: exit,
      role: "dialog",
      "aria-hidden": !isVisible
    }, {
      children: jsxRuntime_2("div", _assign2({
        className: (className || '') + " kxi-grey kxi-toaster-wrapper kxi-flex-center"
      }, ingredients, {
        ref: ref
      }, {
        children: [jsxRuntime_2("div", _assign2({
          className: "kxi-header-wrapper"
        }, {
          children: [jsxRuntime_1(XIIcon, {
            iconSize: 100,
            icon: "circle_check",
            className: "kxi-success kxi-toaster-icon"
          }, void 0), jsxRuntime_1("div", _assign2({
            className: "kxi-toaster-title kxi-text-xlarge kxi-flex-center kxi-text-center"
          }, {
            children: title
          }), void 0)]
        }), void 0), jsxRuntime_1("div", _assign2({
          className: "kxi-toaster-footer kxi-flex-center kxi-text-normal kxi-text-center"
        }, {
          children: subtitle
        }), void 0)]
      }), void 0)
    }), "modal")
  }, void 0), document.body);
});
var initial$1 = AnimatePresenceStates.initial,
    animate$1 = AnimatePresenceStates.animate,
    exit$1 = AnimatePresenceStates.exit;

var WarningPopupProps = function (_super) {
  __extends(WarningPopupProps, _super);

  function WarningPopupProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Boolean)], WarningPopupProps.prototype, "isVisible");

  __decorate([Bound(), __metadata("design:type", Object)], WarningPopupProps.prototype, "buttons");

  __decorate([Bound(), __metadata("design:type", String)], WarningPopupProps.prototype, "title");

  __decorate([Bound(), __metadata("design:type", String)], WarningPopupProps.prototype, "subtitle");

  __decorate([Bound(), __metadata("design:type", Boolean)], WarningPopupProps.prototype, "stretch");

  return WarningPopupProps;
}(DivHTMLAttributes);

var WarningPopupEvents = function (_super) {
  __extends(WarningPopupEvents, _super);

  function WarningPopupEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], WarningPopupEvents.prototype, "onClose");

  __decorate([Bound(), __metadata("design:type", Function)], WarningPopupEvents.prototype, "onProceed");

  __decorate([Bound(), __metadata("design:type", Function)], WarningPopupEvents.prototype, "onCancel");

  return WarningPopupEvents;
}(DivHTMLEvents);
/**
 * Description: Modal when you want to warn the user of something. Can be used as an 'Are you sure?' reminder.
 */


var WarningPopup = /*#__PURE__*/forwardRef(function (props, ref) {
  var _a = props.title,
      title = _a === void 0 ? 'Warning' : _a,
      className = props.className,
      style = props.style,
      subtitle = props.subtitle,
      buttons = props.buttons,
      onProceed = props.onProceed,
      onCancel = props.onCancel,
      onClose = props.onClose,
      isVisible = props.isVisible,
      _b = props.stretch,
      stretch = _b === void 0 ? false : _b,
      ingredients = __rest(props, ["title", "className", "style", "subtitle", "buttons", "onProceed", "onCancel", "onClose", "isVisible", "stretch"]);

  var bg = useRef(null);
  useEffect(function () {
    warnIsDeprecated('WarningPopup', {
      onClose: {
        value: onClose
      }
    }, 'prop');
  }, []);

  var handleProceed = function handleProceed(e) {
    if (buttons.proceed.onClick) {
      buttons.proceed.onClick(e);
    }

    if (onProceed) {
      onProceed(e);
    }
  };

  var handleCancel = function handleCancel(e) {
    if (buttons.cancel.onClick) {
      buttons.cancel.onClick(e);
    }

    if (onCancel) {
      onCancel(e);
    }
  };

  useEffect(function () {
    throwPropErrorMessage('WarningPopUp', {
      isVisible: isVisible,
      buttons: buttons
    });
  }, [isVisible, buttons]);
  var wrapperStyle = {
    maxWidth: stretch ? '' : '720px',
    maxHeight: stretch ? '' : '360px'
  };
  var styledTextStyle = {
    maxHeight: stretch ? '220px' : '140px'
  };
  return /*#__PURE__*/createPortal(jsxRuntime_1(AnimatePresence, {
    children: isVisible && jsxRuntime_1("div", _assign2({
      className: "kxi-overlay"
    }, {
      children: jsxRuntime_1(motion.div, _assign2({
        "data-testid": "warning-popup",
        initial: initial$1,
        animate: animate$1,
        exit: exit$1,
        role: "alert",
        "aria-hidden": !isVisible
      }, {
        children: jsxRuntime_1("div", _assign2({
          className: "kxi-grey-overlay",
          ref: bg
        }, {
          children: jsxRuntime_2("div", _assign2({
            className: (className || '') + " kxi-warning-popup-wrapper"
          }, ingredients, {
            ref: ref,
            style: _assign2(_assign2({}, style), wrapperStyle)
          }, {
            children: [jsxRuntime_1("div", _assign2({
              className: "kxi-warning-popup-styled-header"
            }, {
              children: jsxRuntime_1("div", _assign2({
                className: "kxi-text-xlarge kxi-text-600"
              }, {
                children: title
              }), void 0)
            }), void 0), jsxRuntime_1("div", _assign2({
              className: "kxi-warning-popup-styled-text",
              style: styledTextStyle
            }, {
              children: jsxRuntime_1("div", {
                className: "kxi-text-normal",
                dangerouslySetInnerHTML: {
                  __html: DOMPurify.sanitize(subtitle)
                }
              }, void 0)
            }), void 0), jsxRuntime_2("div", _assign2({
              className: "kxi-warning-popup-button-container"
            }, {
              children: [buttons.cancel.text && jsxRuntime_1("div", _assign2({
                className: "kxi-warning-popup-proceed-cancel-wrapper"
              }, {
                children: jsxRuntime_1(DefaultButton, {
                  color: "orca",
                  fill: "text",
                  text: buttons.cancel.text,
                  onClick: handleCancel,
                  buttonSize: "normal"
                }, void 0)
              }), void 0), buttons.proceed.text && jsxRuntime_1("div", _assign2({
                className: "kxi-warning-popup-proceed-button-wrapper"
              }, {
                children: jsxRuntime_1(DefaultButton, {
                  color: "orca",
                  fill: "fill",
                  text: buttons.proceed.text,
                  onClick: handleProceed,
                  buttonSize: "normal"
                }, void 0)
              }), void 0)]
            }), void 0)]
          }), void 0)
        }), void 0)
      }), "warning-modal")
    }), void 0)
  }, void 0), document.body);
}); // alert inline main

var _SnackBarModesOptions = ['error', 'default'];

var _AlertsColorsOptions = __spreadArray(__spreadArray([], __read(_ColorsOptions)), __read(_ErrorStatesOptions));

var InputHTMLAttributes = function (_super) {
  __extends(InputHTMLAttributes, _super);

  function InputHTMLAttributes() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], InputHTMLAttributes.prototype, "accept");

  __decorate([Bound(), __metadata("design:type", String)], InputHTMLAttributes.prototype, "alt");

  __decorate([Bound(), __metadata("design:type", String)], InputHTMLAttributes.prototype, "autoComplete");

  __decorate([Bound(), __metadata("design:type", Boolean)], InputHTMLAttributes.prototype, "autoFocus");

  __decorate([Bound(), __metadata("design:type", Object)], InputHTMLAttributes.prototype, "capture");

  __decorate([Bound(), __metadata("design:type", Boolean)], InputHTMLAttributes.prototype, "checked");

  __decorate([Bound(), __metadata("design:type", String)], InputHTMLAttributes.prototype, "crossOrigin");

  __decorate([Bound(), __metadata("design:type", Boolean)], InputHTMLAttributes.prototype, "disabled");

  __decorate([Bound(), __metadata("design:type", String)], InputHTMLAttributes.prototype, "form");

  __decorate([Bound(), __metadata("design:type", String)], InputHTMLAttributes.prototype, "formAction");

  __decorate([Bound(), __metadata("design:type", String)], InputHTMLAttributes.prototype, "formEncType");

  __decorate([Bound(), __metadata("design:type", String)], InputHTMLAttributes.prototype, "formMethod");

  __decorate([Bound(), __metadata("design:type", Boolean)], InputHTMLAttributes.prototype, "formNoValidate");

  __decorate([Bound(), __metadata("design:type", String)], InputHTMLAttributes.prototype, "formTarget");

  __decorate([Bound(), __metadata("design:type", Object)], InputHTMLAttributes.prototype, "height");

  __decorate([Bound(), __metadata("design:type", String)], InputHTMLAttributes.prototype, "list");

  __decorate([Bound(), __metadata("design:type", Object)], InputHTMLAttributes.prototype, "max");

  __decorate([Bound(), __metadata("design:type", Number)], InputHTMLAttributes.prototype, "maxLength");

  __decorate([Bound(), __metadata("design:type", Object)], InputHTMLAttributes.prototype, "min");

  __decorate([Bound(), __metadata("design:type", Number)], InputHTMLAttributes.prototype, "minLength");

  __decorate([Bound(), __metadata("design:type", Boolean)], InputHTMLAttributes.prototype, "multiple");

  __decorate([Bound(), __metadata("design:type", String)], InputHTMLAttributes.prototype, "name");

  __decorate([Bound(), __metadata("design:type", String)], InputHTMLAttributes.prototype, "pattern");

  __decorate([Bound(), __metadata("design:type", String)], InputHTMLAttributes.prototype, "placeholder");

  __decorate([Bound(), __metadata("design:type", Boolean)], InputHTMLAttributes.prototype, "readOnly");

  __decorate([Bound(), __metadata("design:type", Boolean)], InputHTMLAttributes.prototype, "required");

  __decorate([Bound(), __metadata("design:type", Number)], InputHTMLAttributes.prototype, "size");

  __decorate([Bound(), __metadata("design:type", String)], InputHTMLAttributes.prototype, "src");

  __decorate([Bound(), __metadata("design:type", Object)], InputHTMLAttributes.prototype, "step");

  __decorate([Bound(), __metadata("design:type", String)], InputHTMLAttributes.prototype, "type");

  __decorate([Bound(), __metadata("design:type", Object)], InputHTMLAttributes.prototype, "value");

  __decorate([Bound(), __metadata("design:type", Object)], InputHTMLAttributes.prototype, "width");

  return InputHTMLAttributes;
}(HTMLAttributes);

var InputHTMLEvents = function (_super) {
  __extends(InputHTMLEvents, _super);

  function InputHTMLEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], InputHTMLEvents.prototype, "onChange");

  return InputHTMLEvents;
}(DOMEvents);

var CheckboxProps = function (_super) {
  __extends(CheckboxProps, _super);

  function CheckboxProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Boolean)], CheckboxProps.prototype, "checked");

  __decorate([Bound(), __metadata("design:type", String)], CheckboxProps.prototype, "color");

  __decorate([Bound(), __metadata("design:type", String)], CheckboxProps.prototype, "contrast");

  __decorate([Bound(), __metadata("design:type", String)], CheckboxProps.prototype, "label");

  __decorate([Bound(), __metadata("design:type", Boolean)], CheckboxProps.prototype, "isLabelLeft");

  __decorate([Bound(), __metadata("design:type", Boolean)], CheckboxProps.prototype, "isIndeterminate");

  __decorate([Bound(), __metadata("design:type", Object)], CheckboxProps.prototype, "status");

  __decorate([Bound(), __metadata("design:type", String)], CheckboxProps.prototype, "inputId");

  return CheckboxProps;
}(ObservablePropsMixin(InputHTMLAttributes));

var CheckboxEvents = function (_super) {
  __extends(CheckboxEvents, _super);

  function CheckboxEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return CheckboxEvents;
}(InputHTMLEvents);

var mouseDown = false;
/**
 * Description: Your friendly standard InMoment neighborhood Checkbox. Does not support the 'text' attribute in status.
 */

var Checkbox = /*#__PURE__*/forwardRef(function (props, ref) {
  var _a;

  var inputEl = useRef(null);
  var styledCheckboxEl = useRef(null);

  var disabled = props.disabled,
      status = props.status,
      _b = props.color,
      color = _b === void 0 ? 'orca' : _b,
      className = props.className,
      _c = props.contrast,
      contrast = _c === void 0 ? 'normal' : _c,
      label = props.label,
      isLabelLeft = props.isLabelLeft,
      checked = props.checked,
      isIndeterminate = props.isIndeterminate,
      id = props.id,
      inputId = props.inputId,
      onChange = props.onChange,
      tabIndex = props.tabIndex,
      internalProps = props.internalProps,
      type = props.type,
      observer = props.observer,
      ingredients = __rest(props, ["disabled", "status", "color", "className", "contrast", "label", "isLabelLeft", "checked", "isIndeterminate", "id", "inputId", "onChange", "tabIndex", "internalProps", "type", "observer"]);

  var wrapper = (internalProps || {}).wrapper;

  var _d = wrapper || {},
      divRef = _d.ref,
      divIngredients = __rest(_d, ["ref"]);

  if (type) {
    devOnlyWarn("The Kitchen: You have passed in a type \"" + type + "\" that is not expected for Checkbox, this will have no effect as the type is permanently set to checkbox.");
  } // nested ternary warning
  // using first a custom inputId for the label if specified, and otherwise defaulting to a generic identifier.


  var finalInputId = inputId ? inputId : (id ? id : uuidv4()) + "-input";

  var _e = __read(useState(false), 2),
      internalChecked = _e[0],
      setInternalChecked = _e[1];

  var _f = __read(useState(false), 2),
      labelMouseDown = _f[0],
      setLabelMouseDown = _f[1];

  var _g = __read(useState(false), 2),
      labelMouseOver = _g[0],
      setLabelMouseOver = _g[1];

  useLayoutEffect(function () {
    setInternalChecked(checked || false);
  }, [checked]); // this is used to disable the focus state on click (we want active not focus)

  useEffect(function () {
    var forceMouseUp = function forceMouseUp() {
      setLabelMouseDown(false);
    };

    if (styledCheckboxEl && styledCheckboxEl.current) {
      styledCheckboxEl.current.addEventListener('focus', function () {
        if (mouseDown && styledCheckboxEl && styledCheckboxEl.current) {
          styledCheckboxEl.current.blur();
        }
      });
    }

    document.addEventListener('mouseup', forceMouseUp);
    return function () {
      document.removeEventListener('mouseup', forceMouseUp);
    };
  }, []);

  var handleChange = function handleChange(e) {
    var target = e.target;

    if (target.checked) {
      setInternalChecked(true);
    } else {
      setInternalChecked(false);
    }

    if (observer) {
      observer.checked = target.checked;
    }

    if (onChange) onChange(e);
  };

  var marginSide = isLabelLeft ? 'marginRight' : 'marginLeft';
  var textStyle = (_a = {
    color: contrast === 'high' ? 'white' : ''
  }, _a[marginSide] = 12, _a);

  var handleKeyPress = function handleKeyPress(e) {
    if (disabled === true) return;

    if (inputEl && inputEl.current) {
      if (e.key === 'Enter' || e.keyCode === 32 || e.key === ' ') {
        if (inputEl.current.checked) {
          setInternalChecked(false);
        } else {
          setInternalChecked(true);
        }

        if (observer) {
          observer.checked = !inputEl.current.checked;
        }

        if (onChange) onChange(e);
      }
    }
  };

  var errorState = typeof status === 'object' ? status === null || status === void 0 ? void 0 : status.state : status;
  var contrastClass = contrast === 'high' ? ' kxi-high-contrast' : '';
  var errorStateClass = errorState ? " kxi-" + errorState : '';

  var getCheckboxClassList = function getCheckboxClassList() {
    var classList = (className || '') + " kxi-border";
    classList += " kxi-checkbox-styled";
    classList += labelMouseDown && !disabled ? " kxi-border-active" : '';
    classList += labelMouseOver && !disabled ? " kxi-border-hovered" : '';
    classList += contrastClass;
    classList += typeof status !== 'object' ? errorStateClass : '';
    classList += disabled ? ' disabled' : '';
    classList += internalChecked ? ' kxi-checkbox-checked' : '';
    classList += color ? " " + normalizeColor(color) : '';
    classList += internalChecked ? errorStateClass : '';
    return classList;
  };

  return jsxRuntime_2(jsxRuntime_3, {
    children: [jsxRuntime_2("label", _assign2({
      id: id,
      htmlFor: finalInputId,
      className: "kxi-checkbox " + (disabled ? 'disabled' : '') + " " + (typeof status === 'object' && (status === null || status === void 0 ? void 0 : status.state) ? "kxi-border" : '') + " " + errorStateClass + " " + contrastClass,
      onMouseDown: function onMouseDown() {
        return setLabelMouseDown(true);
      },
      onMouseUp: function onMouseUp() {
        return setLabelMouseDown(false);
      },
      onMouseOver: function onMouseOver() {
        return setLabelMouseOver(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setLabelMouseOver(false);
      }
    }, {
      children: [jsxRuntime_1("input", _assign2({
        className: "kxi-hidden-checkbox",
        ref: mergeRefs([inputEl, ref]),
        type: "checkbox",
        id: finalInputId,
        onChange: handleChange,
        checked: internalChecked,
        disabled: disabled || false
      }, ingredients), void 0), jsxRuntime_2("div", _assign2({
        className: "kxi-checkbox-styled" + (isLabelLeft ? '-row-reverse' : '-row') + " " + errorStateClass
      }, divIngredients, {
        ref: divRef
      }, {
        children: [jsxRuntime_1("div", _assign2({
          ref: styledCheckboxEl,
          className: getCheckboxClassList(),
          onKeyPress: handleKeyPress,
          onMouseDown: function onMouseDown() {
            return mouseDown = true;
          },
          onMouseUp: function onMouseUp() {
            return mouseDown = false;
          },
          tabIndex: tabIndex || 0
        }, {
          children: internalChecked && jsxRuntime_1(XIIcon, {
            icon: isIndeterminate ? 'indeterminate' : 'checkmark',
            "data-qa": isIndeterminate ? 'indeterminate' : 'checkmark',
            color: status ? typeof status === 'string' ? status : status.state : color,
            contrast: contrast === 'high' ? 'normal' : 'high',
            iconSize: 18
          }, void 0)
        }), void 0), label && jsxRuntime_1("p", _assign2({
          style: textStyle
        }, {
          children: label
        }), void 0)]
      }), void 0)]
    }), void 0), status && typeof status === 'object' ? jsxRuntime_2("div", _assign2({
      className: "kxi-status-container " + contrastClass
    }, {
      children: [status.state === 'error' && status.text && jsxRuntime_1(XIIcon, {
        iconSize: "normal",
        icon: "warning_filled",
        color: status === null || status === void 0 ? void 0 : status.state
      }, void 0), ' ', jsxRuntime_1("div", _assign2({
        className: "kxi-status-label kxi-left " + errorStateClass
      }, {
        children: status.text
      }), void 0)]
    }), void 0) : '']
  }, void 0);
});

var FABProps = function (_super) {
  __extends(FABProps, _super);

  function FABProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], FABProps.prototype, "icon");

  __decorate([Bound(), __metadata("design:type", String)], FABProps.prototype, "color");

  __decorate([Bound(), __metadata("design:type", String)], FABProps.prototype, "contrast");

  __decorate([Bound(), __metadata("design:type", Object)], FABProps.prototype, "tooltip");

  __decorate([Bound(), __metadata("design:type", String)], FABProps.prototype, "buttonSize");

  return FABProps;
}(ButtonHTMLAttributes);

var FABEvents = function (_super) {
  __extends(FABEvents, _super);

  function FABEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FABEvents;
}(ButtonHTMLEvents);
/**
 * Description: Floating Action Button - used to put over the flow of the document.
 */


var FAB = /*#__PURE__*/forwardRef(function (props, ref) {
  var icon = props.icon,
      _a = props.color,
      color = _a === void 0 ? 'CX' : _a,
      _b = props.contrast,
      contrast = _b === void 0 ? 'normal' : _b,
      _c = props.buttonSize,
      buttonSize = _c === void 0 ? 'xxlarge' : _c,
      type = props.type,
      disabled = props.disabled,
      tooltip = props.tooltip,
      hideTooltip = props.hideTooltip,
      // internal only prop used by the dropdown component
  className = props.className,
      style = props.style,
      ingredients = __rest(props, ["icon", "color", "contrast", "buttonSize", "type", "disabled", "tooltip", "hideTooltip", "className", "style"]);

  var validType = checkIfButtonTypeIsValid('FAB', type);
  useEffect(function () {
    if (!icon) devOnlyWarn('The Kitchen - FAB: You have not passed in an icon to use with this component.');
  }, [icon]);

  var getClassList = function getClassList() {
    var classList = "kxi-fab kxi-button kxi-" + buttonSize + " kxi-shadows-deep kxi-button-fill";
    classList += contrast === 'high' ? ' kxi-high-contrast' : '';
    return classList;
  };

  var getIconSize = function getIconSize() {
    switch (buttonSize) {
      case 'normal':
        return 24;

      case 'xlarge':
        return 27;

      case 'xxlarge':
        return 30;
    }
  };

  var component = jsxRuntime_1("button", _assign2({
    className: (color ? normalizeColor(color) : '') + " " + getClassList() + " " + (className || ''),
    style: _assign2({}, style),
    type: validType ? type : undefined
  }, ingredients, {
    ref: ref,
    disabled: disabled
  }, {
    children: jsxRuntime_1(XIIcon, {
      iconSize: getIconSize(),
      icon: icon
    }, void 0)
  }), void 0);
  if (tooltip && !hideTooltip) return jsxRuntime_1(ToolTipWrapper, _assign2({}, tooltip, {
    children: component
  }), void 0);
  return component;
});

var FilterButtonProps = function (_super) {
  __extends(FilterButtonProps, _super);

  function FilterButtonProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Boolean)], FilterButtonProps.prototype, "isActive");

  __decorate([Bound(), __metadata("design:type", Boolean)], FilterButtonProps.prototype, "isFocused");

  __decorate([Bound(), __metadata("design:type", String)], FilterButtonProps.prototype, "text");

  __decorate([Bound(), __metadata("design:type", String)], FilterButtonProps.prototype, "color");

  __decorate([Bound(), __metadata("design:type", Object)], FilterButtonProps.prototype, "status");

  __decorate([Bound(), __metadata("design:type", String)], FilterButtonProps.prototype, "contrast");

  __decorate([Bound(), __metadata("design:type", Boolean)], FilterButtonProps.prototype, "disabled");

  __decorate([Bound(), __metadata("design:type", String)], FilterButtonProps.prototype, "label");

  __decorate([Bound(), __metadata("design:type", Boolean)], FilterButtonProps.prototype, "hasRemoveIcon");

  __decorate([Bound(), __metadata("design:type", Boolean)], FilterButtonProps.prototype, "isRemoveIconInline");

  __decorate([Bound(), __metadata("design:type", String)], FilterButtonProps.prototype, "wrap");

  return FilterButtonProps;
}(ButtonHTMLAttributes);

var FilterButtonEvents = function (_super) {
  __extends(FilterButtonEvents, _super);

  function FilterButtonEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], FilterButtonEvents.prototype, "onCancelClick");

  return FilterButtonEvents;
}(ButtonHTMLEvents);
/**
 * Description: Used for the filter row, has options to indicate the status of a filter.
 */


var FilterButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var _a = props.contrast,
      contrast = _a === void 0 ? 'normal' : _a,
      _b = props.label,
      label = _b === void 0 ? '' : _b,
      _c = props.hasRemoveIcon,
      hasRemoveIcon = _c === void 0 ? false : _c,
      _d = props.isRemoveIconInline,
      isRemoveIconInline = _d === void 0 ? false : _d,
      text = props.text,
      _e = props.disabled,
      disabled = _e === void 0 ? false : _e,
      isActive = props.isActive,
      isFocused = props.isFocused,
      tabIndex = props.tabIndex,
      type = props.type,
      _f = props.wrap,
      wrap = _f === void 0 ? 'nowrap' : _f,
      className = props.className,
      style = props.style,
      _g = props.color,
      color = _g === void 0 ? 'orca' : _g,
      status = props.status,
      onCancelClick = props.onCancelClick,
      ingredients = __rest(props, ["contrast", "label", "hasRemoveIcon", "isRemoveIconInline", "text", "disabled", "isActive", "isFocused", "tabIndex", "type", "wrap", "className", "style", "color", "status", "onCancelClick"]);

  var active = checkIfButtonTypeIsValid('FilterButton', type);

  var _h = __read(useState(false), 2),
      cancelHover = _h[0],
      setCancelHover = _h[1];

  var getClassList = function getClassList() {
    return (className || '') + " kxi-button kxi-filter-button " + (contrast === 'high' ? 'kxi-high-contrast' : '') + " " + (isActive ? 'kxi-filter-active' : !isFocused ? 'kxi-button-outline' : '') + " " + (status ? "kxi-" + status : '') + " " + (isFocused ? 'kxi-filter-focused' : '') + " " + (isRemoveIconInline && hasRemoveIcon ? 'kxi-filter-remove-inline' : '');
  };

  var generateCloseIcon = function generateCloseIcon() {
    return jsxRuntime_1(CloseIcon, {
      disabled: disabled,
      contrast: contrast,
      cancelFn: onCancelClick,
      changeOutline: function changeOutline() {
        return false;
      },
      cancelHover: cancelHover,
      setCancelHover: setCancelHover
    }, void 0);
  };

  var FilterButtonItem = function FilterButtonItem(filterLabel, close) {
    if (filterLabel.length > 0 || close) {
      return jsxRuntime_2("div", _assign2({
        className: "kxi-filter-label-assembly"
      }, {
        children: [filterLabel.length > 0 && jsxRuntime_1("div", _assign2({
          className: "kxi-label"
        }, {
          children: filterLabel
        }), void 0), hasRemoveIcon && !isRemoveIconInline && generateCloseIcon()]
      }), void 0);
    }

    return '';
  };

  return jsxRuntime_2("div", _assign2({
    className: normalizeColor(color) + " " + (contrast === 'high' ? 'kxi-high-contrast' : '')
  }, {
    children: [FilterButtonItem(label, hasRemoveIcon), jsxRuntime_1(MotionDiv, _assign2({
      error: false,
      hasAnimation: !disabled
    }, {
      children: jsxRuntime_2("button", _assign2({
        disabled: disabled,
        ref: ref,
        tabIndex: tabIndex || 0,
        type: active ? type : undefined,
        className: getClassList(),
        style: _assign2({
          whiteSpace: wrap
        }, style)
      }, ingredients, {
        children: [hasRemoveIcon && isRemoveIconInline && jsxRuntime_1("div", _assign2({
          className: "kxi-filter-remove-inline"
        }, {
          children: generateCloseIcon()
        }), void 0), text]
      }), void 0)
    }), void 0)]
  }), void 0);
});

var HeadingButtonProps = function (_super) {
  __extends(HeadingButtonProps, _super);

  function HeadingButtonProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], HeadingButtonProps.prototype, "title");

  __decorate([Bound(), __metadata("design:type", String)], HeadingButtonProps.prototype, "color");

  __decorate([Bound(), __metadata("design:type", Object)], HeadingButtonProps.prototype, "dangerouslySetInnerHTML");

  __decorate([Bound(), __metadata("design:type", String)], HeadingButtonProps.prototype, "contrast");

  return HeadingButtonProps;
}(ButtonHTMLAttributes);

var HeadingButtonEvents = function (_super) {
  __extends(HeadingButtonEvents, _super);

  function HeadingButtonEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return HeadingButtonEvents;
}(ButtonHTMLEvents);
/**
 * Description: A clickable button with the only visual being text, commonly used in Headings.
 */


var HeadingButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var title = props.title,
      _a = props.color,
      color = _a === void 0 ? 'orca' : _a,
      _b = props.contrast,
      contrast = _b === void 0 ? 'normal' : _b,
      tabIndex = props.tabIndex,
      type = props.type,
      disabled = props.disabled,
      className = props.className,
      dangerouslySetInnerHTML = props.dangerouslySetInnerHTML,
      ingredients = __rest(props, ["title", "color", "contrast", "tabIndex", "type", "disabled", "className", "dangerouslySetInnerHTML"]);

  var active = checkIfButtonTypeIsValid('HeadingButton', type);

  var getClassList = function getClassList() {
    var classList = "kxi-button " + normalizeColor(color);
    classList += contrast === 'high' ? ' kxi-high-contrast' : '';
    return classList;
  };

  var dangerousString = dangerouslySetInnerHTML ? {
    __html: DOMPurify.sanitize(dangerouslySetInnerHTML.__html)
  } : undefined;
  return jsxRuntime_1("button", _assign2({
    className: getClassList() + " " + (className || ''),
    tabIndex: tabIndex || 0,
    type: active ? type : undefined,
    ref: ref,
    disabled: disabled,
    dangerouslySetInnerHTML: dangerousString
  }, ingredients, {
    children: dangerouslySetInnerHTML ? null : title
  }), void 0);
});

var IconButtonProps = function (_super) {
  __extends(IconButtonProps, _super);

  function IconButtonProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], IconButtonProps.prototype, "icon");

  __decorate([Bound(), __metadata("design:type", String)], IconButtonProps.prototype, "color");

  __decorate([Bound(), __metadata("design:type", String)], IconButtonProps.prototype, "fill");

  __decorate([Bound(), __metadata("design:type", String)], IconButtonProps.prototype, "contrast");

  __decorate([Bound(), __metadata("design:type", Boolean)], IconButtonProps.prototype, "hasAnimation");

  __decorate([Bound(), __metadata("design:type", Boolean)], IconButtonProps.prototype, "disabled");

  __decorate([Bound(), __metadata("design:type", Boolean)], IconButtonProps.prototype, "hasState");

  __decorate([Bound(), __metadata("design:type", Boolean)], IconButtonProps.prototype, "active");

  __decorate([Bound(), __metadata("design:type", String)], IconButtonProps.prototype, "buttonSize");

  __decorate([Bound(), __metadata("design:type", Object)], IconButtonProps.prototype, "tooltip");

  return IconButtonProps;
}(ObservablePropsMixin(ButtonHTMLAttributes));

var IconButtonEvents = function (_super) {
  __extends(IconButtonEvents, _super);

  function IconButtonEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], IconButtonEvents.prototype, "onActiveChange");

  return IconButtonEvents;
}(ButtonHTMLEvents);
/**
 * Description: Button for when you want to use one of our icons, and make it clickable! Has an on and off state.
 */


var IconButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var _a = props.color,
      color = _a === void 0 ? 'orca' : _a,
      _b = props.contrast,
      contrast = _b === void 0 ? 'normal' : _b,
      _c = props.hasAnimation,
      hasAnimation = _c === void 0 ? true : _c,
      icon = props.icon,
      disabled = props.disabled,
      _d = props.hasState,
      hasState = _d === void 0 ? false : _d,
      _e = props.active,
      active = _e === void 0 ? false : _e,
      _f = props.buttonSize,
      buttonSize = _f === void 0 ? 'normal' : _f,
      tooltip = props.tooltip,
      hideTooltip = props.hideTooltip,
      // internal only prop used by the dropdown component
  tabIndex = props.tabIndex,
      id = props.id,
      type = props.type,
      onKeyPress = props.onKeyPress,
      onClick = props.onClick,
      onActiveChange = props.onActiveChange,
      _g = props.fill,
      fill = _g === void 0 ? 'text' : _g,
      className = props.className,
      observer = props.observer,
      ingredients = __rest(props, ["color", "contrast", "hasAnimation", "icon", "disabled", "hasState", "active", "buttonSize", "tooltip", "hideTooltip", "tabIndex", "id", "type", "onKeyPress", "onClick", "onActiveChange", "fill", "className", "observer"]);

  var activeType = checkIfButtonTypeIsValid('IconButton', type);

  var _h = __read(useState(false), 2),
      isActive = _h[0],
      setIsActive = _h[1];

  var onActiveChangeHandler = function onActiveChangeHandler(active) {
    if (onActiveChange) {
      onActiveChange(active);
    }

    if (observer) {
      observer.active = active;
    }
  };

  useEffect(function () {
    if (hasState) {
      setIsActive(active);
      onActiveChangeHandler(active);
    }
  }, [active]);
  useEffect(function () {
    if (!icon) {
      devOnlyWarn('The Kitchen - IconButton: You have not passed in an icon to use with this component.');
    }
  }, [icon]);

  var handleClick = function handleClick(e) {
    if (hasState) {
      setIsActive(!isActive);
      onActiveChangeHandler(!isActive);
    }

    if (onClick) {
      onClick(e);
    }
  };

  var handleKeyPress = function handleKeyPress(e) {
    if (e.key === 'Enter' && !disabled) {
      if (hasState) {
        setIsActive(!isActive);
        onActiveChangeHandler(!isActive);
      }

      if (onKeyPress) {
        onKeyPress(e);
      }
    }
  };

  var getClassList = function getClassList() {
    var classList = "kxi-icon-button kxi-button kxi-circle kxi-" + buttonSize;
    classList += contrast === 'high' ? ' kxi-high-contrast' : '';
    classList += " " + (color ? normalizeColor(color) : '');
    classList += " " + (fill ? "kxi-button-" + fill : '');
    classList += " " + (isActive && hasState ? "kxi-button-state-active" : '');
    if (className) classList += " " + className;
    return classList;
  };

  var iconButton = jsxRuntime_1(MotionDiv, _assign2({
    className: className,
    hasAnimation: disabled ? false : hasAnimation
  }, {
    children: jsxRuntime_1("button", _assign2({
      id: id,
      className: getClassList(),
      disabled: disabled,
      tabIndex: tabIndex || 0,
      type: activeType ? type : undefined,
      ref: ref,
      onKeyPress: handleKeyPress,
      onClick: handleClick,
      "data-testid": "kxi-icon-button"
    }, ingredients, {
      children: jsxRuntime_1(XIIcon, {
        icon: icon,
        iconSize: buttonSize === 'large' ? 30 : buttonSize === 'normal' ? 24 : 18,
        contrast: contrast
      }, void 0)
    }), void 0)
  }), void 0);
  var button = tooltip && !hideTooltip ? jsxRuntime_1(ToolTipWrapper, _assign2({}, tooltip, {
    style: {
      position: 'relative'
    }
  }, {
    children: iconButton
  }), void 0) : iconButton;
  return button;
});

var SentimentButtonProps = function (_super) {
  __extends(SentimentButtonProps, _super);

  function SentimentButtonProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], SentimentButtonProps.prototype, "sentiment");

  __decorate([Bound(), __metadata("design:type", String)], SentimentButtonProps.prototype, "text");

  __decorate([Bound(), __metadata("design:type", Boolean)], SentimentButtonProps.prototype, "isFocused");

  __decorate([Bound(), __metadata("design:type", String)], SentimentButtonProps.prototype, "wrap");

  return SentimentButtonProps;
}(ObservablePropsMixin(ButtonHTMLAttributes));

var SentimentButtonEvents = function (_super) {
  __extends(SentimentButtonEvents, _super);

  function SentimentButtonEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return SentimentButtonEvents;
}(ButtonHTMLEvents);
/**
 * Description: Button for displaying our various sentiments. Has an focused and non-focused state.
 */


var SentimentButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var _a = __read(useState(false), 2),
      focused = _a[0],
      setFocused = _a[1];

  var className = props.className,
      observer = props.observer,
      _b = props.sentiment,
      sentiment = _b === void 0 ? 'neutral' : _b,
      isFocused = props.isFocused,
      onClick = props.onClick,
      text = props.text,
      _c = props.wrap,
      wrap = _c === void 0 ? 'nowrap' : _c,
      ingredients = __rest(props, ["className", "observer", "sentiment", "isFocused", "onClick", "text", "wrap"]);

  useEffect(function () {
    if (isFocused !== undefined) {
      setFocused(isFocused);
    }
  }, [isFocused]);

  var handleClick = function handleClick(e) {
    setFocused(function (v) {
      return !v;
    });

    if (observer) {
      observer.isFocused = !focused;
    }

    if (onClick) onClick(e);
  };

  useEffect(function () {
    throwPropErrorMessage('SentimentButton', {
      sentiment: sentiment
    });
  }, [sentiment]);
  return jsxRuntime_1("div", {
    children: jsxRuntime_2("button", _assign2({
      className: (className || '') + " kxi-button kxi-sentiment-button kxi-text-wrap-" + wrap + " " + normalizeColor(sentiment) + " " + (focused ? "kxi-high-contrast" : '') + " ",
      onClick: handleClick,
      ref: ref,
      "data-testid": 0,
      onKeyDown: function onKeyDown(event) {
        event.preventDefault();
        if (event.key === 'Enter' || event.key === ' ') setFocused(!focused);
      }
    }, ingredients, {
      children: [jsxRuntime_1("div", _assign2({
        className: "kxi-sentiment-button-svg-wrapper"
      }, {
        children: jsxRuntime_1(XISVG, {
          svg: sentiment.toLowerCase() + "_sentiment_outlined"
        }, void 0)
      }), void 0), text || capitalizeFirstLetter(sentiment)]
    }), void 0)
  }, void 0);
});
var _ButtonTypesOptions = ['fill', 'no-fill', 'outline', 'text'];
var _ButtonSizesOptions = ['small', 'normal', 'large', 'xxlarge'];
var _FilterButtonTypes = ['active', 'inactive'];
var _FilterButtonFocus = ['focus', 'blur'];

var _ButtonColorsOptions = __spreadArray(__spreadArray([], __read(_ColorsOptions)), __read(_ErrorStatesOptions));

var _MenuButtonSizesOptions = ['normal', 'large'];
var _TonesOptions = ['normal', 'light'];
var _FabSizesOptions = ['normal', 'xlarge', 'xxlarge'];
var _ClockDirectionOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
var _DropdownButtonTypesOptions = ['pill', 'layered', 'fab', 'icon', 'text'];
var _DropdownSelectsOptions = ['none', 'single', 'multi', 'multiple', 'multiSelectAll'];
var SelectAllState;

(function (SelectAllState) {
  SelectAllState[SelectAllState["SELECTED"] = 0] = "SELECTED";
  SelectAllState[SelectAllState["UNSPECIFIED"] = 1] = "UNSPECIFIED";
  SelectAllState[SelectAllState["UNSELECTED"] = 2] = "UNSELECTED";
})(SelectAllState || (SelectAllState = {}));

var DropdownButtonAlignment;

(function (DropdownButtonAlignment) {
  DropdownButtonAlignment["left"] = "left";
  DropdownButtonAlignment["right"] = "right";
})(DropdownButtonAlignment || (DropdownButtonAlignment = {}));

var CustomPillProps = function (_super) {
  __extends(CustomPillProps, _super);

  function CustomPillProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], CustomPillProps.prototype, "text");

  __decorate([Bound(), __metadata("design:type", String)], CustomPillProps.prototype, "color");

  __decorate([Bound(), __metadata("design:type", String)], CustomPillProps.prototype, "contrast");

  return CustomPillProps;
}(DivHTMLAttributes);

var CustomPillEvents = function (_super) {
  __extends(CustomPillEvents, _super);

  function CustomPillEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return CustomPillEvents;
}(DivHTMLEvents);
/**
 * Description: Small pill containing arbitrary strings
 */


var CustomPill = /*#__PURE__*/forwardRef(function (props, ref) {
  var text = props.text,
      _a = props.color,
      color = _a === void 0 ? 'orca' : _a,
      style = props.style,
      className = props.className,
      _b = props.contrast,
      contrast = _b === void 0 ? 'normal' : _b,
      ingredients = __rest(props, ["text", "color", "style", "className", "contrast"]);

  useEffect(function () {
    throwPropErrorMessage('CustomPill', {
      text: text
    });
  }, []);
  var colorClass = normalizeColor(color);
  return jsxRuntime_1("div", _assign2({
    className: (className || '') + " kxi-custom-pill " + (contrast === 'high' ? 'kxi-high-contrast' : '') + " " + colorClass + " kxi-text-no-margin kxi-text-size-small kxi-text-left kxi-text-600 kxi-text-wrap-unset kxi-text-line-height-unset",
    style: _assign2({}, style)
  }, ingredients, {
    ref: ref
  }, {
    children: text
  }), void 0);
});

var CloudPillProps = function (_super) {
  __extends(CloudPillProps, _super);

  function CloudPillProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], CloudPillProps.prototype, "cloud");

  __decorate([Bound(), __metadata("design:type", String)], CloudPillProps.prototype, "contrast");

  return CloudPillProps;
}(DivHTMLAttributes);

var CloudPillEvents = function (_super) {
  __extends(CloudPillEvents, _super);

  function CloudPillEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return CloudPillEvents;
}(DivHTMLEvents);
/**
 * Description: Small pill indicating one of the three clouds.
 */


var CloudPill = /*#__PURE__*/forwardRef(function (props, ref) {
  var _a = props.cloud,
      cloud = _a === void 0 ? 'CX' : _a,
      ingredients = __rest(props, ["cloud"]);

  useEffect(function () {
    throwPropErrorMessage('CloudPill', {
      cloud: cloud
    });
  }, [cloud]);

  var getInitials = function getInitials() {
    switch (cloud) {
      case 'EMPLOYEE':
      case 'EX':
        return 'EX';

      case 'MARKETING':
      case 'MX':
        return 'MX';

      case 'PRODUCT':
      case 'PX':
        return 'PX';

      case 'CUSTOMER':
      case 'CX':
      default:
        return 'CX';
    }
  };

  return jsxRuntime_1(CustomPill, _assign2({}, ingredients, {
    color: cloud,
    text: getInitials(),
    ref: ref
  }), void 0);
});
var defaultLocalization$1 = {
  noResultsFound: 'No Results Found',
  selected: 'Selected',
  selectAll: 'Select All',
  more: 'more',
  search: 'Search'
};

var calculateIndexFromKey = function calculateIndexFromKey(key, dropdownButton, dropdownButtonIcon, idString, ids) {
  var isDropdownItem = document.activeElement && !(document.activeElement === dropdownButton.current || document.activeElement === dropdownButtonIcon.current) && document.activeElement.id && document.activeElement.id.includes('kxi-dropdown-input');

  switch (key) {
    case 'ArrowUp':
      if (isDropdownItem && idString) {
        var index = parseInt(idString[1]);
        return index === 0 ? ids.length - 1 : index - 1;
      } else return ids.length - 1;

    case 'ArrowDown':
      if (isDropdownItem && idString) {
        var index = parseInt(idString[1]);
        return index === ids.length - 1 ? 0 : index + 1;
      } else return 0;

    case 'home':
      return 0;

    case 'End':
      return ids.length - 1;
  }
};

var checkIfMultiple = function checkIfMultiple(select) {
  return select === 'multi' || select === 'multiple' || select === 'multiSelectAll';
};

var checkHasVisualConflict = function checkHasVisualConflict(submenu, select) {
  var conflict = false;
  if (submenu && checkIfMultiple(select)) submenu.forEach(function (obj) {
    if (obj.visual && obj.submenu && obj.submenu.length > 0) conflict = true;
  });
  return conflict;
};

var setDefaultLocalization = function setDefaultLocalization(localization) {
  if (!localization.noResultsFound) localization.noResultsFound = defaultLocalization$1.noResultsFound;
  if (!localization.selectAll) localization.selectAll = defaultLocalization$1.selectAll;
  if (!localization.selected) localization.selected = defaultLocalization$1.selected;
  if (!localization.more) localization.more = defaultLocalization$1.more;
  if (!localization.search) localization.search = defaultLocalization$1.search;
  return localization;
};

var getObjectById = function getObjectById(id, menu) {
  var item;

  var searchThroughMenu = function searchThroughMenu(m) {
    m.forEach(function (i) {
      if (i.submenu) searchThroughMenu(i.submenu);else {
        if (i.id === id) {
          item = i;
          return;
        }
      }
    });
  };

  searchThroughMenu(menu);
  return item;
};

var getAllIds = function getAllIds(m) {
  var ids = [];
  m.forEach(function (item) {
    if (item.submenu) ids = __spreadArray(__spreadArray([], __read(ids)), __read(getAllIds(item.submenu)));
    if (item.id && item.id !== 'kxi-dropdown-group') ids = __spreadArray(__spreadArray([], __read(ids)), [item.id]);
  });
  return ids;
};

var DropdownSubmenu = function DropdownSubmenu(props) {
  var color = props.color,
      hasSubConflictingVisual = props.hasSubConflictingVisual,
      index = props.index,
      isDirectDescendant = props.isDirectDescendant,
      isMultiple = props.isMultiple,
      parentItemsCount = props.parentItemsCount,
      scrollHeight = props.scrollHeight,
      scrollTop = props.scrollTop,
      select = props.select,
      selectAllState = props.selectAllState,
      selectedIds = props.selectedIds,
      submenu = props.submenu,
      textSize = props.textSize,
      parentRef = props.parentRef,
      tabIndex = props.tabIndex,
      onMenuItemClicked = props.onMenuItemClicked;
  var menuRef = useRef(null);

  var determineDirection = function determineDirection() {
    var _a, _b;

    var submenuBounds = (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    var parentBounds = (_b = parentRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();

    if (submenuBounds && parentBounds) {
      var toTheLeft = parentBounds.right + submenuBounds.width - 15 > document.documentElement.clientWidth;

      if (!toTheLeft) {
        return 'right';
      }

      var toTheOver = parentBounds.left - submenuBounds.width + 15 < 0;
      return toTheOver ? 'over' : 'left';
    }
  };

  if (submenu && submenu.length > 0) {
    return jsxRuntime_1(Fragment, {
      children: jsxRuntime_1("div", _assign2({
        className: "kxi-dropdown-submenu kxi-dropdown-submenu-" + determineDirection(),
        style: {
          top: scrollTop
        }
      }, {
        children: submenu.map(function (obj, i) {
          return jsxRuntime_1(DropdownMenuItem, {
            ref: menuRef,
            className: "kxi-menu-item-submenu",
            color: color,
            hasConflictingVisual: hasSubConflictingVisual,
            index: i,
            textSize: textSize,
            isGroupTitle: false,
            isWithinGroup: false,
            menuObject: obj,
            isMultiple: isMultiple,
            onMenuItemClicked: onMenuItemClicked,
            parentItemsCount: parentItemsCount,
            scrollHeight: scrollHeight + scrollTop - index * 48,
            select: select,
            selectAllState: selectAllState,
            selectedIds: selectedIds,
            tabIndex: tabIndex
          }, "dropdown_submenu_" + i);
        })
      }), void 0)
    }, void 0);
  }

  return jsxRuntime_1(Fragment, {}, void 0);
};

var DropdownMenuItem = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      color = props.color,
      _a = props.textSize,
      textSize = _a === void 0 ? 'normal' : _a,
      hasConflictingVisual = props.hasConflictingVisual,
      index = props.index,
      isDirectDescendant = props.isDirectDescendant,
      isGroupTitle = props.isGroupTitle,
      isMultiple = props.isMultiple,
      isWithinGroup = props.isWithinGroup,
      menuObject = props.menuObject,
      parentItemsCount = props.parentItemsCount,
      scrollHeight = props.scrollHeight,
      select = props.select,
      selectAllState = props.selectAllState,
      selectedIds = props.selectedIds,
      tabIndex = props.tabIndex,
      onMenuItemClicked = props.onMenuItemClicked;

  var _b = __read(useState(0), 2),
      scrollTop = _b[0],
      setScrollTop = _b[1];

  var _c = __read(useState(), 2),
      isSelected = _c[0],
      setIsSelected = _c[1];

  useEffect(function () {
    setIsSelected(!!(menuObject.id && selectedIds.includes(menuObject.id)));
  }, [selectedIds]);
  var submenu = menuObject.submenu,
      subtitle = menuObject.subtitle,
      title = menuObject.title,
      menuTextColor = menuObject.color,
      visual = menuObject.visual,
      disabled = menuObject.disabled,
      id = menuObject.id;
  var menuItemRef = useRef(null);
  var isSubmenu = submenu && submenu.length > 0;
  var hasSubConflictingVisual = checkHasVisualConflict(submenu, select);
  useEffect(function () {
    if (menuItemRef.current) setScrollTop(menuItemRef.current.offsetTop - scrollHeight);
  }, [scrollHeight]);

  var determineVisual = function determineVisual() {
    if (visual) {
      if (_IconsOptions.includes(visual)) {
        return jsxRuntime_1(XIIcon, {
          icon: visual,
          color: menuTextColor ? menuTextColor : 'orca',
          className: "kxi-menu-item-icon" + (disabled ? ' kxi-menu-item-disabled' : '')
        }, void 0);
      } else if (Object.keys(EnumClouds).includes(visual)) {
        return jsxRuntime_1(CloudPill, {
          cloud: visual,
          className: "kxi-menu-item-pill" + (disabled ? ' kxi-menu-item-disabled' : '')
        }, void 0);
      } else return jsxRuntime_1("img", {
        src: visual,
        className: disabled ? ' kxi-menu-item-disabled' : undefined,
        alt: "dropdown-visual"
      }, void 0);
    }
  };

  var onDropdownClick = function onDropdownClick() {
    if (isGroupTitle || isSubmenu) return;
    if (isMultiple && !disabled && menuItemRef.current) menuItemRef.current.blur();
    if (!disabled) onMenuItemClicked(menuObject);
  };

  var visualComponent = determineVisual();

  var determineLeftVisual = function determineLeftVisual() {
    if (!isMultiple) return visualComponent;else {
      return jsxRuntime_1("div", _assign2({
        className: "kxi-left-visual"
      }, {
        children: !isGroupTitle && !isSubmenu && jsxRuntime_1(Checkbox, {
          disabled: disabled,
          checked: menuObject.id !== undefined && isSelected,
          color: color,
          tabIndex: -1,
          onClick: function onClick(e) {
            return e.stopPropagation();
          }
        }, void 0)
      }), void 0);
    }
  };

  var determineRightVisual = function determineRightVisual() {
    var arrow, activeIcon;

    if (isSubmenu) {
      arrow = jsxRuntime_1(XIIcon, {
        className: hasConflictingVisual && isMultiple ? 'kxi-conflicting-visual' : undefined,
        icon: "single_arrow_right"
      }, void 0);
    } else if (menuObject.id !== undefined && isSelected && !isMultiple && select !== 'none') {
      activeIcon = jsxRuntime_1(XIIcon, {
        style: {
          marginLeft: -6,
          marginRight: 6
        },
        icon: "circle_check_filled",
        color: color
      }, void 0);
    } else if (hasConflictingVisual) {
      activeIcon = jsxRuntime_1("div", {
        style: {
          width: 24
        }
      }, void 0);
    }

    return isMultiple && visualComponent || arrow || activeIcon ? jsxRuntime_2("div", _assign2({
      className: "kxi-flex-center"
    }, {
      children: [isMultiple && visualComponent, arrow, activeIcon]
    }), void 0) : jsxRuntime_1(jsxRuntime_3, {}, void 0);
  };

  var disabledClass = disabled ? ' kxi-disabled' : '';
  return jsxRuntime_2("div", _assign2({
    className: "kxi-menu-item " + normalizeColor(color) + " " + (isGroupTitle ? ' kxi-menu-item-group' : '') + (isSubmenu ? ' kxi-submenu-title' : '') + disabledClass + " " + (className || '') + " " + (menuObject.id !== undefined && isSelected && !isMultiple && select !== 'none' ? 'kxi-active' : ''),
    style: {
      paddingLeft: isWithinGroup && !isGroupTitle ? 32 : undefined
    },
    ref: mergeRefs([menuItemRef, ref]),
    onClick: function onClick(e) {
      e.stopPropagation();
      if (!isGroupTitle) onDropdownClick();
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.stopPropagation();
        e.preventDefault();
        if (!isGroupTitle) onDropdownClick();
      }
    },
    tabIndex: isGroupTitle ? -1 : tabIndex,
    id: id
  }, {
    children: [jsxRuntime_2("div", _assign2({
      className: "kxi-flex-center"
    }, {
      children: [determineLeftVisual(), jsxRuntime_2("div", _assign2({
        className: "kxi-menu-item-text" + (hasConflictingVisual && isMultiple ? ' kxi-conflicting-visual' : '')
      }, {
        children: [jsxRuntime_1("p", _assign2({
          className: "kxi-title kxi-text-" + textSize + disabledClass
        }, {
          children: title
        }), void 0), subtitle && jsxRuntime_1("p", _assign2({
          className: "kxi-subtitle" + disabledClass
        }, {
          children: subtitle
        }), void 0)]
      }), void 0)]
    }), void 0), determineRightVisual(), jsxRuntime_1(DropdownSubmenu, {
      color: color,
      hasSubConflictingVisual: hasSubConflictingVisual,
      index: index,
      isDirectDescendant: isDirectDescendant,
      isMultiple: isMultiple,
      onMenuItemClicked: onMenuItemClicked,
      parentItemsCount: parentItemsCount,
      scrollHeight: scrollHeight,
      scrollTop: scrollTop,
      select: select,
      textSize: textSize,
      selectAllState: selectAllState,
      selectedIds: selectedIds,
      submenu: submenu,
      parentRef: menuItemRef,
      tabIndex: tabIndex
    }, void 0)]
  }), void 0);
});

var DropdownMenu = function DropdownMenu(props) {
  var dropdownId = props.dropdownId,
      isOpen = props.isOpen,
      boundingBox = props.boundingBox,
      buttonAlignment = props.buttonAlignment,
      buttons = props.buttons,
      color = props.color,
      container = props.container,
      data = props.data,
      direction = props.direction,
      dropdownButton = props.dropdownButton,
      dropdownButtonIcon = props.dropdownButtonIcon,
      elementsToDisableScroll = props.elementsToDisableScroll,
      groups = props.groups,
      hasPortal = props.hasPortal,
      hasSearch = props.hasSearch,
      id = props.id,
      inMenuSearch = props.inMenuSearch,
      isMultiple = props.isMultiple,
      labelHeight = props.labelHeight,
      localization = props.localization,
      query = props.query,
      select = props.select,
      selectAllState = props.selectAllState,
      selectedIds = props.selectedIds,
      style = props.style,
      type = props.type,
      forceMobileWidth = props.forceMobileWidth,
      parentRef = props.parentRef,
      cancelValue = props.cancelValue,
      confirmValue = props.confirmValue,
      onMenuItemClicked = props.onMenuItemClicked,
      resize = props.resize,
      setIsSearching = props.setIsSearching,
      setQuery = props.setQuery,
      setSelectedIdList = props.setSelectedIdList,
      onOpenChange = props.onOpenChange,
      setIsOpen = props.setIsOpen,
      tabIndex = props.tabIndex,
      _a = props.textSize,
      textSize = _a === void 0 ? 'normal' : _a,
      inputIngredients = props.inputIngredients,
      internalProps = __rest(props, ["dropdownId", "isOpen", "boundingBox", "buttonAlignment", "buttons", "color", "container", "data", "direction", "dropdownButton", "dropdownButtonIcon", "elementsToDisableScroll", "groups", "hasPortal", "hasSearch", "id", "inMenuSearch", "isMultiple", "labelHeight", "localization", "query", "select", "selectAllState", "selectedIds", "style", "type", "forceMobileWidth", "parentRef", "cancelValue", "confirmValue", "onMenuItemClicked", "resize", "setIsSearching", "setQuery", "setSelectedIdList", "onOpenChange", "setIsOpen", "tabIndex", "textSize", "inputIngredients"]);

  var maxHeight = 336 + (hasSearch ? 48 : 0) + (buttons ? 48 : 0);
  var minHeight = 108 + (hasSearch ? 48 : 0) + (buttons ? 48 : 0);
  var margin = 6;

  var _b = __read(useState(false), 2),
      isVisible = _b[0],
      setIsVisible = _b[1];

  var _c = __read(useState(direction), 2),
      directionState = _c[0],
      setDirectionState = _c[1];

  var _d = __read(useState(maxHeight), 2),
      menuMaxHeight = _d[0],
      setMenuMaxHeight = _d[1];

  var _e = __read(useState(0), 2),
      scrollTop = _e[0],
      setScrollTop = _e[1];

  var _f = __read(useState(jsxRuntime_1(jsxRuntime_3, {}, void 0)), 2),
      innerMenu = _f[0],
      setInnerMenu = _f[1];

  var hasInMenuSearch = (type === 'fab' || type === 'icon' || inMenuSearch) && hasSearch;

  var _g = __read(useState(false), 2),
      isMobile = _g[0],
      setIsMobile = _g[1];

  var _h = __read(useState(), 2),
      hiddenWidth = _h[0],
      setHiddenWidth = _h[1];

  useEffect(function () {
    function handleResize() {
      var _a, _b;

      if ((_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) {
        setIsMobile(document.documentElement.clientWidth <= ((_b = menuRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().width));
      }
    }

    function handleFocusOut(e) {
      var rt = e.relatedTarget;
      if (menuRef.current && parentRef.current && rt && !menuRef.current.contains(rt) && !parentRef.current.contains(rt)) setIsOpen(false);
    }

    function handleKeyDown(e) {
      if (e.key === 'Escape') setIsOpen(false);
    }

    window.addEventListener('resize', handleResize);
    window.addEventListener('focusout', handleFocusOut);
    window.addEventListener('keydown', handleKeyDown);
    return function () {
      if (onOpenChange) onOpenChange(false);
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('focusout', handleFocusOut);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  useEffect(function () {
    if (onOpenChange) onOpenChange(isOpen);
  }, [isOpen]);
  useLayoutEffect(function () {
    var _a, _b;

    if (!((_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width)) {
      return;
    }

    if (document.documentElement.clientWidth > ((_b = menuRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().width) && !isMobile) {
      setIsMobile(false);
      var newDirection = calcDirection();
      setDirectionState(newDirection);
      shrinkDropdown(newDirection);
      if (directionState === newDirection) setIsVisible(isOpen);
    } else {
      setIsMobile(true);
      var newDirection = calcMobileDirection();
      setDirectionState(newDirection);
      shrinkDropdown(newDirection);
      if (directionState === newDirection) setIsVisible(isOpen);
    }
  }, [isOpen, directionState]);
  useEffect(function () {
    setIsSearching(query.length > 0);
  }, [query]);
  useEffect(function () {
    var _a;

    var filteredObjects = __spreadArray([], __read(data)).filter(function (obj) {
      return obj.title.toLowerCase().includes(query.toLowerCase());
    });

    var hasConflictingVisual = checkHasVisualConflict(data, select);
    var ids = [];
    var filteredMenuItems = filteredObjects.map(function (menuObject, i) {
      var _a;

      var isGroupTitle = ((_a = menuObject.id) === null || _a === void 0 ? void 0 : _a.includes('kxi-dropdown-group')) || false;
      var id = "kxi-dropdown-input-" + i + "_" + menuObject.id;
      ids.push(id);

      var isWithinGroup = function isWithinGroup() {
        var isWithin = false;
        if (groups) groups.forEach(function (group) {
          if ((menuObject === null || menuObject === void 0 ? void 0 : menuObject.id) && group.ids.includes(menuObject === null || menuObject === void 0 ? void 0 : menuObject.id)) isWithin = true;
        });
        return isWithin;
      };

      return jsxRuntime_1(DropdownMenuItem, {
        color: color,
        hasConflictingVisual: hasConflictingVisual,
        index: select === 'multiSelectAll' ? i + 1 : i,
        isDirectDescendant: true,
        isGroupTitle: isGroupTitle,
        isMultiple: isMultiple,
        textSize: textSize,
        isWithinGroup: isWithinGroup(),
        menuObject: menuObject,
        onMenuItemClicked: onMenuItemClicked,
        parentItemsCount: filteredObjects.length,
        scrollHeight: scrollTop,
        select: select,
        selectAllState: selectAllState,
        selectedIds: selectedIds,
        tabIndex: tabIndex
      }, "DropdownMenuItem_" + id);
    });
    var inner = filteredObjects.length > 0 ? jsxRuntime_1("div", _assign2({
      className: "kxi-overflow-y",
      style: {
        maxHeight: menuMaxHeight || 'unset'
      },
      onScroll: function onScroll(e) {
        return setScrollTop(e.target.scrollTop);
      },
      tabIndex: -1
    }, {
      children: filteredMenuItems
    }), void 0) : jsxRuntime_1("div", _assign2({
      className: "kxi-no-results"
    }, {
      children: localization.noResultsFound
    }), void 0);
    setInnerMenu(inner);

    var keyListener = function keyListener(e) {
      var _a, _b;

      if (e.key === 'ArrowUp' || e.key === 'ArrowDown' || e.key === 'Home' || e.key === 'End' || e.key === 'Enter') {
        var menuItemIndex = -1;
        var idString = (_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.id.match(/([0-9]*)_/);
        var focusedId_1 = (_b = document.activeElement) === null || _b === void 0 ? void 0 : _b.id.match(/_([a-zA-Z0-9-]*)/);

        if (e.key === 'Enter') {
          if (focusedId_1 && selectedIds.includes(focusedId_1[1])) {
            setSelectedIdList(isMultiple ? selectedIds.filter(function (x) {
              return x !== focusedId_1[1];
            }) : selectedIds);
          } else if (focusedId_1) {
            setSelectedIdList(isMultiple ? __spreadArray(__spreadArray([], __read(selectedIds)), [focusedId_1[1]]) : [focusedId_1[1]]);
          }
        } else {
          var x = calculateIndexFromKey(e.key, dropdownButton, dropdownButtonIcon, idString, ids);
          menuItemIndex = x ? x : menuItemIndex;
        }

        if (menuItemIndex !== -1) {
          var item = document.getElementById(ids[menuItemIndex]);
          item === null || item === void 0 ? void 0 : item.focus();
        }
      }
    };

    setHiddenWidth((_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth);
    document.addEventListener('keydown', keyListener);
    return function () {
      document.removeEventListener('keydown', keyListener);
    };
  }, [query, data, menuMaxHeight, selectedIds, scrollTop, color]);

  var calcMobileDirection = function calcMobileDirection() {
    var upDirs = [1, 3, 4, 8, 11, 12];

    if (upDirs.includes(direction)) {
      if (canShrinkDropdown(12)) {
        return 12;
      } else {
        return 6;
      }
    } else {
      if (canShrinkDropdown(6)) {
        return 6;
      } else {
        return 12;
      }
    }
  };

  var calcDirection = function calcDirection() {
    var i = 0;
    var newDirection = direction;

    for (i = 0; i < 12; i++) {
      var overlap = willOverlap(newDirection);

      if ((overlap.isTooFarAbove || overlap.isTooFarBelow) && !(overlap.isTooFarLeft || overlap.isTooFarRight)) {
        if (canShrinkDropdown(newDirection)) {
          return newDirection;
        }
      } else if (!(overlap.isTooFarLeft || overlap.isTooFarRight || overlap.isTooFarAbove || overlap.isTooFarBelow)) {
        return newDirection;
      }

      newDirection++;

      if (newDirection >= 12) {
        newDirection = 1;
      }
    }

    return direction;
  };

  var canShrinkDropdown = function canShrinkDropdown(direction) {
    var _a;

    var upDirs = [11, 12, 1];
    var downDirs = [7, 6, 5];
    var bottomUpDirs = [8, 4];
    var bottomDownDirs = [2, 10];
    var parentElement = (_a = document.getElementById(dropdownId)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();

    if (!parentElement || !menuRef.current) {
      return false;
    }

    if (upDirs.includes(direction)) {
      return parentElement.top - margin > minHeight;
    } else if (downDirs.includes(direction)) {
      return document.documentElement.clientHeight - parentElement.bottom - margin > minHeight;
    } else if (bottomUpDirs.includes(direction)) {
      return parentElement.top + parentElement.height - margin > minHeight;
    } else if (bottomDownDirs.includes(direction)) {
      return document.documentElement.clientHeight - parentElement.bottom - margin + parentElement.height > minHeight;
    }

    return false;
  };

  var shrinkDropdown = function shrinkDropdown(direction) {
    var _a;

    var upDirs = isMobile ? [1, 3, 4, 8, 11, 12] : [11, 12, 1];
    var bottomUpDirs = [8, 4];
    var downDirs = isMobile ? [2, 5, 6, 7, 9, 10] : [7, 6, 5];
    var bottomDownDirs = [2, 10];
    var parentElement = (_a = document.getElementById(dropdownId)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();

    if (!parentElement || !menuRef.current) {
      return;
    }

    if (upDirs.includes(direction)) {
      var heightAvailable = parentElement.top - margin;
      var setHeight = heightAvailable > maxHeight ? maxHeight : heightAvailable > minHeight ? heightAvailable : minHeight;
      setMenuMaxHeight(setHeight);
    } else if (downDirs.includes(direction)) {
      var heightAvailable = document.documentElement.clientHeight - parentElement.bottom - margin;
      var setHeight = heightAvailable > maxHeight ? maxHeight : heightAvailable > minHeight ? heightAvailable : minHeight;
      setMenuMaxHeight(setHeight);
    } else if (bottomUpDirs.includes(direction)) {
      var heightAvailable = parentElement.top + parentElement.height - margin;
      var setHeight = heightAvailable > maxHeight ? maxHeight : heightAvailable > minHeight ? heightAvailable : minHeight;
      setMenuMaxHeight(setHeight);
    } else if (bottomDownDirs.includes(direction)) {
      var heightAvailable = document.documentElement.clientHeight - parentElement.bottom - margin + parentElement.height;
      var setHeight = heightAvailable > maxHeight ? maxHeight : heightAvailable > minHeight ? heightAvailable : minHeight;
      setMenuMaxHeight(setHeight);
    } else {
      setMenuMaxHeight(maxHeight);
    }
  };

  var willOverlap = function willOverlap(direction) {
    var _a, _b;

    var scrollBarWidth = document.documentElement.offsetWidth - document.documentElement.clientWidth || margin; //note: calc does not work on macs because scroll bar is an overlay

    var parentElement = (_a = document.getElementById(dropdownId)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();

    if (!parentElement || !menuRef.current) {
      return {
        isTooFarAbove: false,
        isTooFarLeft: false,
        isTooFarRight: false,
        isTooFarBelow: false
      };
    }

    var pos = getMenuPosition(direction);
    var menuHeight = menuRef.current.clientHeight;
    var menuWidth = hiddenWidth || ((_b = menuRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth);
    var isTooFarAbove, isTooFarBelow, isTooFarLeft, isTooFarRight;

    if (hasPortal) {
      isTooFarAbove = pos.top - document.documentElement.scrollTop < 0;
      isTooFarBelow = pos.top + menuHeight + scrollBarWidth > document.documentElement.clientHeight + document.documentElement.scrollTop;
      isTooFarRight = pos.left + menuWidth + scrollBarWidth > document.documentElement.clientWidth + document.documentElement.scrollLeft;
      isTooFarLeft = pos.left < document.documentElement.scrollLeft;
    } else {
      isTooFarAbove = pos.top + parentElement.top < 0;
      isTooFarBelow = parentElement.top + pos.top + menuHeight + scrollBarWidth > document.documentElement.clientHeight;
      isTooFarRight = parentElement.left + pos.left + menuWidth + scrollBarWidth > document.documentElement.clientWidth;
      isTooFarLeft = pos.left + parentElement.left < 0;
    }

    return {
      isTooFarAbove: isTooFarAbove,
      isTooFarBelow: isTooFarBelow,
      isTooFarRight: isTooFarRight,
      isTooFarLeft: isTooFarLeft
    };
  };

  var getMobileMenuPosition = function getMobileMenuPosition(direction) {
    var _a;

    var upDirs = [1, 3, 4, 8, 11, 12];
    var parentElement = (_a = document.getElementById(dropdownId)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    var menuStartTop = ((parentElement === null || parentElement === void 0 ? void 0 : parentElement.top) || 0) + document.documentElement.scrollTop;
    var dropdownHeight = (parentElement === null || parentElement === void 0 ? void 0 : parentElement.height) || 0;
    var menuHeight = menuRef.current.clientHeight;

    if (upDirs.includes(direction)) {
      return {
        top: menuStartTop - menuHeight - margin * 2,
        left: forceMobileWidth ? ((parentElement === null || parentElement === void 0 ? void 0 : parentElement.left) || 0) + document.documentElement.scrollLeft : 0
      };
    } else {
      return {
        top: menuStartTop + dropdownHeight,
        left: forceMobileWidth ? ((parentElement === null || parentElement === void 0 ? void 0 : parentElement.left) || 0) + document.documentElement.scrollLeft : 0
      };
    }
  };

  var getMenuPosition = function getMenuPosition(direction) {
    if (!menuRef.current) {
      return {
        top: 0,
        left: 0
      };
    }

    if (isMobile) {
      return getMobileMenuPosition(direction);
    }

    var parentElement = document.getElementById(dropdownId);
    var menuStartTop = 0;
    var menuStartLeft = 0;

    if (hasPortal) {
      menuStartTop = ((parentElement === null || parentElement === void 0 ? void 0 : parentElement.getBoundingClientRect().top) || 0) + document.documentElement.scrollTop;
      menuStartLeft = ((parentElement === null || parentElement === void 0 ? void 0 : parentElement.getBoundingClientRect().left) || 0) + document.documentElement.scrollLeft;
    }

    var dropdownWidth = (parentElement === null || parentElement === void 0 ? void 0 : parentElement.getBoundingClientRect().width) || 0;
    var dropdownHeight = (parentElement === null || parentElement === void 0 ? void 0 : parentElement.getBoundingClientRect().height) || 0;
    var _a = menuRef.current,
        menuWidth = _a.clientWidth,
        menuHeight = _a.clientHeight; //vertical alignments

    var bottomAbove = menuHeight * -1 + menuStartTop - margin * 2;
    var topLevel = menuStartTop - margin;
    var middle = menuStartTop + dropdownHeight / 2 - menuHeight / 2 - margin;
    var bottomLevel = bottomAbove + dropdownHeight + margin;
    var topBelow = menuStartTop + dropdownHeight + margin; //horizontal alignments

    var rightAligned = menuStartLeft - menuWidth + dropdownWidth - margin;
    var rightEdge = menuStartLeft + dropdownWidth + margin;
    var centered = menuStartLeft + dropdownWidth / 2 - menuWidth / 2 - margin;
    var leftAligned = menuStartLeft - margin;
    var leftEdge = menuStartLeft - menuWidth - margin * 2;

    switch (direction) {
      case 1:
        return {
          top: bottomAbove,
          left: rightAligned
        };

      case 2:
        return {
          top: topLevel,
          left: rightEdge
        };

      case 3:
        return {
          top: middle,
          left: rightEdge
        };

      case 4:
        return {
          top: bottomLevel,
          left: rightEdge
        };

      case 5:
        return {
          top: topBelow,
          left: rightAligned
        };

      case 6:
        return {
          top: topBelow,
          left: centered
        };

      case 7:
        return {
          top: topBelow,
          left: leftAligned
        };

      case 8:
        return {
          top: bottomLevel,
          left: leftEdge
        };

      case 9:
        return {
          top: middle,
          left: leftEdge
        };

      case 10:
        return {
          top: topLevel,
          left: leftEdge
        };

      case 11:
        return {
          top: bottomAbove,
          left: leftAligned
        };

      case 12:
        return {
          top: bottomAbove,
          left: centered
        };

      default:
        return {
          top: topBelow,
          left: leftAligned
        };
    }
  };

  var getMenuStyle = function getMenuStyle() {
    var _a;

    var pos = getMenuPosition(directionState);
    return _assign2(_assign2({}, style), {
      top: pos.top,
      left: isMobile && !forceMobileWidth ? 0 : pos.left,
      maxWidth: isMobile ? forceMobileWidth ? boundingBox === null || boundingBox === void 0 ? void 0 : boundingBox.width : document.documentElement.clientWidth - margin * 2 : style === null || style === void 0 ? void 0 : style.maxWidth,
      maxHeight: menuMaxHeight,
      minWidth: [11, 12, 1, 5, 6, 7].includes(directionState) ? (_a = document.getElementById(dropdownId)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width : undefined
    });
  };

  var menuRef = useRef(null);
  var innerSearchRef = useRef(null);

  if (container) {
    var menuComponent = jsxRuntime_1(AnimatePresence, {
      children: jsxRuntime_2(motion.div, _assign2({
        initial: {
          opacity: 0
        },
        animate: {
          opacity: 1
        },
        exit: {
          opacity: 0
        },
        transition: {
          duration: 0.2
        },
        className: "kxi-dropdown-menu orca kxi-normal-contrast",
        ref: menuRef,
        style: getMenuStyle(),
        id: id
      }, internalProps, {
        children: [hasInMenuSearch && jsxRuntime_2("div", _assign2({
          className: "kxi-menu-search",
          onClick: function onClick(e) {
            return e.stopPropagation();
          }
        }, {
          children: [jsxRuntime_1(XIIcon, {
            icon: "search",
            color: "disabled",
            iconSize: 30,
            style: {
              padding: 9
            }
          }, void 0), jsxRuntime_1("input", _assign2({
            "aria-label": localization.search,
            placeholder: localization.search,
            type: "text",
            tabIndex: tabIndex
          }, inputIngredients, {
            ref: innerSearchRef,
            onChange: function onChange(e) {
              return setQuery(e.target.value);
            }
          }), void 0)]
        }), void 0), innerMenu, (isMultiple || buttons) && jsxRuntime_2("div", _assign2({
          className: "kxi-menu-buttons kxi-align-" + (buttonAlignment === 'left' ? 'left' : 'right')
        }, {
          children: [isMultiple && jsxRuntime_1(jsxRuntime_3, {
            children: selectedIds.filter(function (i) {
              return i !== 'SelectAll';
            }).length + " " + localization.selected
          }, void 0), jsxRuntime_2("div", _assign2({
            style: {
              display: 'flex',
              flexDirection: buttonAlignment === 'left' ? 'row-reverse' : 'row'
            }
          }, {
            children: [(isMultiple || buttons && buttons.secondary) && jsxRuntime_1(DefaultButton, {
              style: {
                marginRight: margin
              },
              fill: "no-fill",
              hasAnimation: false,
              text: buttons && buttons.secondary ? buttons.secondary.text : 'Cancel',
              buttonSize: "small",
              tabIndex: tabIndex,
              onClick: function onClick(e) {
                e.stopPropagation();
                cancelValue();
                if (buttons && buttons.secondary && buttons.secondary.onClick) buttons.secondary.onClick(e);
              }
            }, void 0), (isMultiple || buttons && buttons.primary) && jsxRuntime_1(DefaultButton, {
              fill: "fill",
              hasAnimation: false,
              text: buttons && buttons.primary ? buttons.primary.text : 'Apply',
              buttonSize: "small",
              tabIndex: tabIndex,
              onClick: function onClick(e) {
                if (buttons && buttons.primary && buttons.primary.onClick) buttons.primary.onClick(e);
                confirmValue();
              }
            }, void 0)]
          }), void 0)]
        }), void 0)]
      }), void 0)
    }, void 0);
    return isVisible ? hasPortal || isMobile ? /*#__PURE__*/createPortal(menuComponent, container) : menuComponent : jsxRuntime_1("div", _assign2({
      className: "kxi-dropdown-menu-hidden-wrapper"
    }, {
      children: jsxRuntime_1("div", _assign2({
        className: "kxi-dropdown-menu-hidden"
      }, {
        children: menuComponent
      }), void 0)
    }), void 0);
  } else {
    return jsxRuntime_1(jsxRuntime_3, {}, void 0);
  }
};

var ErrorStateUI = function ErrorStateUI(props) {
  var prePopulateStatus = props.prePopulateStatus,
      errorState = props.errorState,
      disabled = props.disabled,
      maxCharsAllowed = props.maxCharsAllowed,
      contrastClass = props.contrastClass,
      errorStateClass = props.errorStateClass,
      text = props.text;
  var preStatus = prePopulateStatus ? jsxRuntime_1("div", _assign2({
    className: "kxi-status-wrapper"
  }, {
    children: jsxRuntime_1("div", _assign2({
      className: "kxi-status-hidden"
    }, {
      children: "x"
    }), void 0)
  }), void 0) : '';

  var switchIcon = function switchIcon(state) {
    switch (state) {
      case 'success':
        return 'circle_check_filled';

      default:
        return 'warning_filled';
    }
  };

  var charCount = (maxCharsAllowed === null || maxCharsAllowed === void 0 ? void 0 : maxCharsAllowed.max) ? jsxRuntime_1("div", _assign2({
    className: "kxi-status-label " + errorStateClass
  }, {
    children: ((text === null || text === void 0 ? void 0 : text.length) || 0) + "/" + maxCharsAllowed.max
  }), void 0) : null;
  return jsxRuntime_1(jsxRuntime_3, {
    children: errorState && !disabled && errorState.text || maxCharsAllowed ? jsxRuntime_1("div", _assign2({
      className: "kxi-status-wrapper " + contrastClass
    }, {
      children: jsxRuntime_1("div", _assign2({
        className: "kxi-status-container " + errorStateClass + " " + contrastClass
      }, {
        children: (errorState === null || errorState === void 0 ? void 0 : errorState.state) ? jsxRuntime_2(jsxRuntime_3, {
          children: [jsxRuntime_2("div", _assign2({
            className: "kxi-status-label kxi-flex-center " + errorStateClass
          }, {
            children: [errorState && errorState.state ? jsxRuntime_1(XIIcon, {
              iconSize: "normal",
              icon: switchIcon(errorState.state),
              color: errorState.state
            }, void 0) : null, jsxRuntime_1("p", _assign2({
              className: "kxi-error-state-text"
            }, {
              children: errorState.text
            }), void 0)]
          }), void 0), charCount]
        }, void 0) : charCount
      }), void 0)
    }), void 0) : preStatus
  }, void 0);
};

var useTextFieldStatus = function useTextFieldStatus(text, component, status, maxCharsAllowed) {
  var _a = __read(useState(status), 2),
      errorState = _a[0],
      setErrorState = _a[1];

  var errorStateClass = (errorState === null || errorState === void 0 ? void 0 : errorState.state) ? " kxi-" + errorState.state : ' kxi-no-error';
  useEffect(function () {
    if (maxCharsAllowed) {
      if (Number.isInteger(+maxCharsAllowed.max)) {
        if (text.length > maxCharsAllowed.max) {
          setErrorState({
            state: 'error',
            text: maxCharsAllowed.errorMessage
          });
        } else {
          setErrorState(status);
        }
      } else {
        devOnlyWarn("The Kitchen: You have provided an object to maxCharsAllowed (" + component + "), but an incorrect / undefined max property. Please provide a correct max property.");
      }
    } else {
      setErrorState(status);
    }
  }, [text, maxCharsAllowed, status]);
  return [errorState, setErrorState, errorStateClass];
};

var useTextFieldWarning = function useTextFieldWarning(component, _controlledState, onChange) {
  useEffect(function () {
    if (!onChange && _controlledState) {
      devOnlyWarn("The Kitchen: You've chosen to set _controlledState to true, and have not provided a callback function to update the text. You won't be able to type in the " + component + " until you provide one.");
    }
  }, [_controlledState, onChange]);
};

var DropdownProps = function (_super) {
  __extends(DropdownProps, _super);

  function DropdownProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Object)], DropdownProps.prototype, "data");

  __decorate([Bound(), __metadata("design:type", Array)], DropdownProps.prototype, "groups");

  __decorate([Bound(), __metadata("design:type", Object)], DropdownProps.prototype, "textSize");

  __decorate([Bound(), __metadata("design:type", Object)], DropdownProps.prototype, "buttons");

  __decorate([Bound(), __metadata("design:type", String)], DropdownProps.prototype, "buttonAlignment");

  __decorate([Bound(), __metadata("design:type", String)], DropdownProps.prototype, "color");

  __decorate([Bound(), __metadata("design:type", HTMLElement)], DropdownProps.prototype, "container");

  __decorate([Bound(), __metadata("design:type", Object)], DropdownProps.prototype, "elementsToDisableScroll");

  __decorate([Bound(), __metadata("design:type", Object)], DropdownProps.prototype, "status");

  __decorate([Bound(), __metadata("design:type", String)], DropdownProps.prototype, "label");

  __decorate([Bound(), __metadata("design:type", Number)], DropdownProps.prototype, "direction");

  __decorate([Bound(), __metadata("design:type", Boolean)], DropdownProps.prototype, "hasPortal");

  __decorate([Bound(), __metadata("design:type", Boolean)], DropdownProps.prototype, "disabled");

  __decorate([Bound(), __metadata("design:type", String)], DropdownProps.prototype, "placeholder");

  __decorate([Bound(), __metadata("design:type", String)], DropdownProps.prototype, "visualState");

  __decorate([Bound(), __metadata("design:type", String)], DropdownProps.prototype, "select");

  __decorate([Bound(), __metadata("design:type", Boolean)], DropdownProps.prototype, "stretch");

  __decorate([Bound(), __metadata("design:type", String)], DropdownProps.prototype, "type");

  __decorate([Bound(), __metadata("design:type", Boolean)], DropdownProps.prototype, "fullWidthMobileMenu");

  __decorate([Bound(), __metadata("design:type", String)], DropdownProps.prototype, "contrast");

  __decorate([Bound(), __metadata("design:type", Object)], DropdownProps.prototype, "localization");

  __decorate([Bound(), __metadata("design:type", Boolean)], DropdownProps.prototype, "inMenuSearch");

  __decorate([Bound(), __metadata("design:type", Object)], DropdownProps.prototype, "internalProps");

  __decorate([Bound(), __metadata("design:type", Number)], DropdownProps.prototype, "itemSearchCount");

  __decorate([Bound(), __metadata("design:type", Object)], DropdownProps.prototype, "inMenuSearchProps");

  __decorate([Bound(), __metadata("design:type", Object)], DropdownProps.prototype, "tooltip");

  return DropdownProps;
}(ObservablePropsMixin(InputHTMLAttributes));

var DropdownEvents = function (_super) {
  __extends(DropdownEvents, _super);

  function DropdownEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], DropdownEvents.prototype, "onValueChange");

  __decorate([Bound(), __metadata("design:type", Function)], DropdownEvents.prototype, "onOpenChange");

  return DropdownEvents;
}(InputHTMLEvents);
/**
 * Description: One stop shop for all your dropdown needs.
 */


var Dropdown = /*#__PURE__*/forwardRef(function (props, ref) {
  var _a;

  var _b = props.autoComplete,
      autoComplete = _b === void 0 ? 'off' : _b,
      _c = props.buttonAlignment,
      buttonAlignment = _c === void 0 ? DropdownButtonAlignment.right : _c,
      buttons = props.buttons,
      className = props.className,
      _d = props.color,
      color = _d === void 0 ? 'CX' : _d,
      _e = props.container,
      container = _e === void 0 ? document.getElementsByTagName('body')[0] : _e,
      _f = props.contrast,
      contrast = _f === void 0 ? 'normal' : _f,
      _g = props.textSize,
      textSize = _g === void 0 ? 'normal' : _g,
      _h = props.direction,
      direction = _h === void 0 ? 7 : _h,
      disabled = props.disabled,
      initialData = props.data,
      _j = props.elementsToDisableScroll,
      elementsToDisableScroll = _j === void 0 ? document.getElementsByTagName('body')[0] : _j,
      groups = props.groups,
      _k = props.hasPortal,
      hasPortal = _k === void 0 ? false : _k,
      _l = props.inMenuSearch,
      inMenuSearch = _l === void 0 ? false : _l,
      internalProps = props.internalProps,
      _m = props.itemSearchCount,
      itemSearchCount = _m === void 0 ? 7 : _m,
      label = props.label,
      _o = props.name,
      name = _o === void 0 ? 'dropdown' : _o,
      observer = props.observer,
      placeholder = props.placeholder,
      _p = props.select,
      select = _p === void 0 ? 'single' : _p,
      status = props.status,
      _q = props.stretch,
      stretch = _q === void 0 ? false : _q,
      _r = props.type,
      type = _r === void 0 ? 'pill' : _r,
      value = props.value,
      readOnly = props.readOnly,
      _s = props.visualState,
      visualState = _s === void 0 ? 'normal' : _s,
      inMenuSearchProps = props.inMenuSearchProps,
      tooltip = props.tooltip,
      _t = props.fullWidthMobileMenu,
      fullWidthMobileMenu = _t === void 0 ? true : _t,
      _u = props.tabIndex,
      tabIndex = _u === void 0 ? 0 : _u,
      onClick = props.onClick,
      _onChange = props.onChange,
      onValueChange = props.onValueChange,
      onOpenChange = props.onOpenChange,
      ingredients = __rest(props, ["autoComplete", "buttonAlignment", "buttons", "className", "color", "container", "contrast", "textSize", "direction", "disabled", "data", "elementsToDisableScroll", "groups", "hasPortal", "inMenuSearch", "internalProps", "itemSearchCount", "label", "name", "observer", "placeholder", "select", "status", "stretch", "type", "value", "readOnly", "visualState", "inMenuSearchProps", "tooltip", "fullWidthMobileMenu", "tabIndex", "onClick", "onChange", "onValueChange", "onOpenChange"]); // Check whether `value` is undefined to determine whether the user is using the `value` property.
  // If they aren't, we don't want to set it on `observer`, because that causes it to be set
  // on `DropdownComponent`, which will pass it into this component forever after, despite the
  // user not using the `value` property.


  var setObserverValue = value !== undefined && observer ? function (val) {
    observer.value = val;
  } : function noop() {};
  var _v = props.localization,
      localization = _v === void 0 ? {} : _v;
  localization = setDefaultLocalization(localization);
  var widthRef = useRef(null);
  var dataQa = ingredients['data-qa'];
  delete ingredients['data-qa'];

  var _w = internalProps || {},
      fab = _w.fab,
      iconButton = _w.iconButton,
      wrapper = _w.wrapper,
      menuInternalProps = _w.menu,
      defaultButton = _w.defaultButton;

  var _x = __read(useState(initialData ? initialData : []), 2),
      data = _x[0],
      setData = _x[1];

  var _y = __read(useState(false), 2),
      isOpen = _y[0],
      setIsOpen = _y[1];

  var _z = __read(useState(''), 2),
      query = _z[0],
      setQuery = _z[1];

  var _0 = __read(useState(false), 2),
      isSearching = _0[0],
      setIsSearching = _0[1];

  var _1 = __read(useState(data), 2),
      menu = _1[0],
      setMenu = _1[1];

  var _2 = __read(useState(), 2),
      boundingBox = _2[0],
      setBoundingBox = _2[1];

  var _3 = __read(useState(true), 2),
      canceling = _3[0],
      setCanceling = _3[1];

  var _4 = __read(useState(SelectAllState.UNSELECTED), 2),
      selectAllState = _4[0],
      setSelectAllState = _4[1];

  var _5 = __read(useState([]), 2),
      selectedIdList = _5[0],
      setSelectedIdList = _5[1];

  var _6 = __read(useState([]), 2),
      previousSelectedIds = _6[0],
      setPreviousSelectedIds = _6[1];

  var _7 = __read(useState(selectAllState), 2),
      previousSelectAllState = _7[0],
      setPreviousSelectAllState = _7[1];

  var _8 = __read(useState(uuidv4()), 1),
      menuId = _8[0];

  var _9 = __read(useState(false), 2),
      hasTooltip = _9[0],
      setHasTooltip = _9[1];

  var _10 = __read(useState(''), 2),
      previewText = _10[0],
      setPreviewText = _10[1];

  var dropdownButton = useRef(null);
  var dropdownButtonIcon = useRef(null);
  var dropdownButtonDetector = useRef(null);
  var dropdownSizeDetector = useRef(null);
  var dropdownLabel = useRef(null);
  var dropdownId = useRef(uuidv4());
  var shouldStretch = type === 'fab' || type === 'icon' ? false : stretch;
  var isMultiple = checkIfMultiple(select);
  var hasSearch = menu.length >= itemSearchCount;

  var _11 = __read(useTextFieldStatus('', 'Dropdown', status), 3),
      errorState = _11[0],
      errorStateClass = _11[2];

  useEffect(function () {
    if (initialData) {
      setData(initialData);
    }
  }, [initialData]);
  useEffect(function () {
    if (isSearching && dropdownButton.current && !inMenuSearch) {
      dropdownButton.current.value = query;
    } else {
      setSelectedIdList(__spreadArray([], __read(selectedIdList)));
    }
  }, [query]);
  useEffect(function () {
    if (direction && (direction > 12 || direction < 1)) devOnlyWarn('The Kitchen: Dropbox direction property out of bounds. Please provide a direction between 1-12, default is 7');
  }, [direction]);
  useEffect(function () {
    //This prevents an infinite update loop
    if (!data || data.length === 0) {
      return;
    }

    setPreviousSelectedIds(__spreadArray([], __read(selectedIdList)));

    var setInnerIds = function setInnerIds(menu) {
      return menu.map(function (innerItem) {
        if (innerItem.id === undefined) innerItem.id = uuidv4();
        if (innerItem.submenu && innerItem.submenu.length > 0) innerItem.submenu = setInnerIds(innerItem.submenu);
        return innerItem;
      });
    };

    var menu = setInnerIds(data);

    if (groups) {
      var newMenu_1 = [];
      var groupItems_1 = [];
      groups.forEach(function (group) {
        var x = menu.filter(function (x) {
          return x.id && group.ids.includes(x.id);
        });
        groupItems_1.push(__spreadArray([{
          title: group.title,
          id: "kxi-dropdown-group"
        }], __read(x)));
      });
      menu.forEach(function (item) {
        groupItems_1.forEach(function (group) {
          if (group.includes(item) && !newMenu_1.includes(item)) newMenu_1 = __spreadArray(__spreadArray([], __read(newMenu_1)), __read(group));
        });
        if (!newMenu_1.includes(item)) newMenu_1.push(item);
      });
      menu = newMenu_1;
    }

    if (select === 'multiSelectAll') {
      menu = __spreadArray([{
        title: localization.selectAll ? localization.selectAll : defaultLocalization$1.selectAll,
        id: 'SelectAll',
        isSelected: selectAllState === SelectAllState.SELECTED
      }], __read(menu));
    }

    setMenu(menu);
  }, [data, select, groups]);
  useEffect(function () {
    //This prevents an infinite update loop
    if (!data || data.length === 0) {
      return;
    }

    var selectedIdsInValue = getSelectedIds(data);

    if (selectedIdsInValue.length > 0) {
      setObserverValue(isMultiple ? selectedIdsInValue : selectedIdsInValue[0]);
    }

    setSelectedIdList(selectedIdsInValue);
    setPreviousSelectedIds(selectedIdsInValue);
  }, [data]);
  useLayoutEffect(function () {
    if (!data || data.length === 0) {
      setSelectedIdList([]);
      setPreviousSelectedIds([]);
      setMenu([]);
    }
  }, [data]);
  useEffect(function () {
    if (!value) return;
    var selectedIdsInValue = [];

    if (Array.isArray(value)) {
      selectedIdsInValue = __spreadArray([], __read(value));
    } else {
      selectedIdsInValue = [value];
    }

    selectedIdsInValue = selectedIdsInValue.filter(function (id) {
      return data.findIndex(function (item) {
        return item.id === id;
      }) >= 0;
    }); // remove invalid selected IDs

    selectedIdsInValue = __spreadArray(__spreadArray([], __read(selectedIdsInValue)), __read(data.filter(function (dataObj) {
      return dataObj.isSelected && dataObj.id;
    }).map(function (item) {
      return item.id;
    }).filter(function (item) {
      if (!item) return false;
      return !selectedIdsInValue.includes(item);
    })));
    setSelectedIdList(selectedIdsInValue);
    setPreviousSelectedIds(selectedIdsInValue);
  }, [value, data]);
  useLayoutEffect(function () {
    if (dropdownButton.current && dropdownButtonDetector.current && dropdownButton.current.offsetWidth <= dropdownButtonDetector.current.offsetWidth) {
      setHasTooltip(true);
    } else {
      setHasTooltip(false);
    }
  }, [previewText]);

  var onWindowClick = function onWindowClick(e) {
    var eventPath = e.composedPath();
    var dropdownWrapper = widthRef.current;
    var eventPathIds = eventPath.map(function (value) {
      return value.id;
    });

    if (!(eventPath === null || eventPath === void 0 ? void 0 : eventPath.includes(dropdownWrapper)) && !eventPathIds.includes(menuId)) {
      setIsOpen(false);
    }
  };

  useEffect(function () {
    if (isOpen) window.addEventListener('click', onWindowClick);else {
      window.removeEventListener('click', onWindowClick);
      confirmValue();
      stopSearching();
    }

    var setScroll = function setScroll(overflow) {
      if (elementsToDisableScroll) if (elementsToDisableScroll.length > 0) {
        elementsToDisableScroll.forEach(function (element) {
          if (element) element.style.overflow = overflow;
        });
      } else if (!Array.isArray(elementsToDisableScroll)) elementsToDisableScroll.style.overflow = overflow;
    };

    setScroll(isOpen ? 'hidden' : 'auto');
    return function () {
      setScroll('auto');
      window.removeEventListener('click', onWindowClick);
    };
  }, [isOpen]); // gets the selected ids of a passed in value. Not applicaable to component as a whole

  var getSelectedIds = function getSelectedIds(menu) {
    var selectedIds = [];
    menu.forEach(function (item) {
      if (item.submenu) selectedIds = __spreadArray(__spreadArray([], __read(selectedIds)), __read(getSelectedIds(item.submenu)));
      if (item.isSelected && item.id) selectedIds = __spreadArray(__spreadArray([], __read(selectedIds)), [item.id]);
    });
    return selectedIds;
  };

  var setInputText = function setInputText(text) {
    if (dropdownButton.current && dropdownButtonDetector.current) {
      setPreviewText(text);
      dropdownButton.current.value = text;
    }
  };

  useEffect(function () {
    if (dropdownButton.current && dropdownButtonDetector.current) {
      var filteredIds = selectedIdList.filter(function (i) {
        return i !== 'SelectAll';
      });

      var idsCopy = __spreadArray([], __read(filteredIds));

      if (isMultiple) {
        var _loop_1 = function _loop_1() {
          var valueText = '';
          idsCopy.forEach(function (dropdownId) {
            if (getObjectById(dropdownId, menu)) valueText = "" + valueText + getObjectById(dropdownId, menu).title + ", ";
          });
          valueText = valueText.substring(0, valueText.length - 2);
          if (filteredIds.length > idsCopy.length) valueText = valueText + ", (+" + (filteredIds.length - idsCopy.length) + " " + localization.more + ")";
          setInputText(valueText);
          idsCopy.splice(idsCopy.length - 1, 1);
        };

        do {
          _loop_1();
        } while (dropdownButton.current.offsetWidth <= dropdownButtonDetector.current.offsetWidth && idsCopy.length !== 0);

        if (dropdownButton.current.offsetWidth <= dropdownButtonDetector.current.offsetWidth) setInputText(filteredIds.length + " " + localization.selected);
      } else if (select !== 'none') {
        var result = getObjectById(filteredIds[0], menu);
        setInputText(result ? result.title : '');
      }

      dropdownButton.current.dispatchEvent(new Event('input', {
        bubbles: true
      }));
    }
  }, [selectedIdList, isMultiple]);

  var resize = function resize() {
    if ((type === 'icon' || type === 'fab') && dropdownButtonIcon.current) {
      return dropdownButtonIcon.current.getBoundingClientRect();
    } else if (dropdownButton.current) {
      return dropdownButton.current.getBoundingClientRect();
    }
  };

  var stopSearching = function stopSearching() {
    setIsSearching(false);
    setQuery('');
  };

  var onMenuItemClicked = function onMenuItemClicked(menuObject) {
    var selected = undefined;
    var id = menuObject.id;
    var newSelectAll;
    if (id) if (isMultiple) {
      if (id === 'SelectAll') {
        var isSelected = selectAllState === SelectAllState.SELECTED;
        selected = isSelected ? [] : getAllIds(menu);
        newSelectAll = isSelected ? SelectAllState.UNSELECTED : SelectAllState.SELECTED;
      } else {
        var idExists = selectedIdList.includes(id);
        selected = idExists ? __spreadArray([], __read(selectedIdList)).filter(function (x) {
          return x !== id;
        }) : __spreadArray(__spreadArray([], __read(selectedIdList)), [id]);

        if (selected.length === data.length && selectAllState !== SelectAllState.SELECTED) {
          newSelectAll = SelectAllState.SELECTED;
          selected.push('SelectAll');
        } else {
          newSelectAll = SelectAllState.UNSELECTED;
          selected = __spreadArray([], __read(selected)).filter(function (x) {
            return x !== 'SelectAll';
          });
        }
      }

      setSelectAllState(newSelectAll);
    } else {
      selected = [id];
      if (select === 'single' && onValueChange && !selectedIdList.includes(id)) onValueChange(getObjectById(id, menu));else if (onValueChange && select === 'none') onValueChange(getObjectById(id, menu));
      setObserverValue(selected[0]);
      setIsOpen(false);
    }

    if (selected) {
      setSelectedIdList(selected);
    }
  };

  var confirmValue = function confirmValue() {
    var _a;

    if (isMultiple && !canceling) {
      var sameValue = false;

      if (previousSelectedIds.length === selectedIdList.length) {
        sameValue = true;

        for (var i = 0; i < selectedIdList.length; i++) {
          if (selectedIdList[i] !== previousSelectedIds[i]) sameValue = false;
        }
      }

      if (!sameValue) {
        var sanitizedList = selectedIdList.filter(function (i) {
          return i !== 'SelectAll';
        });
        if (onValueChange) onValueChange(sanitizedList.map(function (x) {
          return getObjectById(x, menu);
        }));
        setObserverValue(sanitizedList);
      }

      setPreviousSelectedIds(__spreadArray([], __read(selectedIdList)));
    } else if (select === 'single' && selectedIdList.length > 0) {
      setInputText((_a = getObjectById(selectedIdList[0], menu)) === null || _a === void 0 ? void 0 : _a.title);
    }

    setCanceling(false);
    setIsOpen(false);
  };

  var cancelValue = function cancelValue() {
    setCanceling(true);
    setIsOpen(false);
    setSelectedIdList(previousSelectedIds);
    setSelectAllState(previousSelectAllState);
  };

  var menuDom = jsxRuntime_1(DropdownMenu, _assign2({
    dropdownId: dropdownId.current,
    isOpen: isOpen,
    id: menuId,
    labelHeight: ((_a = dropdownLabel.current) === null || _a === void 0 ? void 0 : _a.clientHeight) || 0,
    dropdownButton: dropdownButton,
    dropdownButtonIcon: dropdownButtonIcon,
    setSelectedIdList: setSelectedIdList,
    container: container,
    hasSearch: hasSearch,
    color: color === 'white' ? 'orca' : color,
    direction: direction,
    hasPortal: hasPortal,
    buttons: buttons,
    buttonAlignment: buttonAlignment,
    data: menu,
    onMenuItemClicked: onMenuItemClicked,
    query: query,
    type: type,
    select: select,
    boundingBox: boundingBox,
    selectedIds: selectedIdList,
    resize: resize,
    cancelValue: cancelValue,
    isMultiple: isMultiple,
    confirmValue: confirmValue,
    elementsToDisableScroll: elementsToDisableScroll,
    setIsSearching: setIsSearching,
    setQuery: setQuery,
    selectAllState: selectAllState,
    localization: localization,
    groups: groups,
    inMenuSearch: inMenuSearch,
    textSize: textSize,
    style: menuInternalProps === null || menuInternalProps === void 0 ? void 0 : menuInternalProps.style,
    onOpenChange: onOpenChange,
    inputIngredients: inMenuSearchProps,
    forceMobileWidth: !fullWidthMobileMenu,
    parentRef: type === 'icon' || type === 'fab' || type === 'button' ? dropdownButtonIcon : dropdownButton,
    setIsOpen: setIsOpen,
    tabIndex: tabIndex
  }, menuInternalProps), void 0);

  var getDropdownButton = function getDropdownButton() {
    if (type === 'fab' || type === 'icon' || type === 'button') {
      var button = jsxRuntime_1(jsxRuntime_3, {}, void 0);
      var buttonProps = {
        color: color === 'white' ? undefined : color,
        contrast: color === 'white' ? 'high' : contrast,
        disabled: disabled,
        ref: dropdownButtonIcon,
        onClick: function onClick(e) {
          return onDropdownClick(e);
        }
      };

      if (type === 'fab') {
        if (!fab) {
          devOnlyWarn('The Kitchen: <Dropdown /> with FAB must have FABProps with icon passed.');
        } else if (!fab.icon) {
          devOnlyWarn('The Kitchen - Dropdown (with FAB): You have not passed in an icon to use with this component.');
        }

        button = jsxRuntime_2("div", _assign2({
          style: {
            position: 'relative'
          }
        }, {
          children: [jsxRuntime_1(FAB, _assign2({}, fab, buttonProps, {
            hideTooltip: isOpen,
            id: dropdownId.current
          }), void 0), menuDom]
        }), void 0);
      } else if (type === 'icon') {
        if (!iconButton) {
          devOnlyWarn('The Kitchen: <Dropdown /> with IconButton must have IconButtonProps with icon passed.');
        } else if (!iconButton.icon) {
          devOnlyWarn('The Kitchen - Dropdown (with IconButton): You have not passed in an icon to use with this component.');
        }

        button = jsxRuntime_2("div", _assign2({
          style: {
            position: 'relative'
          }
        }, {
          children: [jsxRuntime_1(IconButton, _assign2({}, iconButton, buttonProps, {
            hideTooltip: isOpen,
            id: dropdownId.current
          }), void 0), menuDom]
        }), void 0);
      } else {
        if (!defaultButton) {
          devOnlyWarn('The Kitchen: <Dropdown /> with DefaultButton must have DefaultButton props passed.');
        }

        button = jsxRuntime_2("div", _assign2({
          style: {
            position: 'relative'
          }
        }, {
          children: [jsxRuntime_1(DefaultButton, _assign2({}, defaultButton, buttonProps, {
            tooltip: isOpen ? undefined : defaultButton === null || defaultButton === void 0 ? void 0 : defaultButton.tooltip,
            id: dropdownId.current
          }), void 0), menuDom]
        }), void 0);
      }

      return button;
    } else return jsxRuntime_1("button", {
      style: {
        display: 'none'
      },
      ref: dropdownButtonIcon
    }, void 0);
  };

  var contrastClass = contrast === 'high' ? ' kxi-high-contrast' : '';
  var layeredClass = type === 'layered' ? ' kxi-layered' : '';

  var onDropdownClick = function onDropdownClick(e) {
    if (!disabled && !readOnly) {
      setIsOpen(!isOpen);
      if (onClick && e) onClick(e);

      if (!isOpen) {
        setPreviousSelectAllState(selectAllState);
      }
    }
  };

  return jsxRuntime_1(ReactResizeDetector, _assign2({
    onResize: useCallback(function () {
      return setBoundingBox(resize());
    }, []),
    handleHeight: true,
    handleWidth: stretch,
    targetRef: widthRef
  }, {
    children: jsxRuntime_2("div", _assign2({
      ref: widthRef,
      className: "kxi-dropdown" + (type === 'icon' && !label ? ' kxi-dropdown-inline' : ''),
      style: {
        width: shouldStretch ? '100%' : undefined
      }
    }, wrapper, {
      "data-qa": dataQa
    }, {
      children: [label && jsxRuntime_1("label", _assign2({
        className: "" + (type === 'layered' ? 'kxi-layered-label' : 'kxi-label') + (color === 'white' ? ' kxi-high-contrast' : contrastClass),
        htmlFor: name,
        ref: dropdownLabel
      }, {
        children: label
      }), void 0), (type === 'pill' || type === 'text' || type === 'layered') && jsxRuntime_1(ToolTipWrapper, _assign2({
        enabled: hasTooltip && !isOpen,
        text: previewText,
        stretch: shouldStretch
      }, tooltip, {
        children: jsxRuntime_2("div", _assign2({
          "data-testid": "kxi-dropdown-input-container",
          className: "kxi-input-container orca " + (shouldStretch ? 'kxi-stretch-width' : '')
        }, {
          children: [jsxRuntime_1(XIIcon, {
            iconSize: 24,
            className: "kxi-arrow-" + (isOpen ? 'open' : 'closed') + (type === 'layered' ? ' kxi-layered' : '') + (disabled ? ' kxi-arrow-disabled' : '') + " " + (visualState === 'condensed' && type !== 'layered' ? 'kxi-condensed' : '') + " " + (readOnly ? ' kxi-readonly' : ''),
            contrast: contrast,
            icon: "single_arrow_down",
            onClick: function onClick(e) {
              e.stopPropagation();
              onDropdownClick(e);
            }
          }, void 0), jsxRuntime_1("div", _assign2({
            className: "kxi-dropdown-span kxi-input" + layeredClass,
            ref: dropdownButtonDetector
          }, {
            children: isSearching && !inMenuSearch ? query : previewText
          }), void 0), !shouldStretch && placeholder && jsxRuntime_1("div", _assign2({
            className: "kxi-dropdown-span kxi-input" + layeredClass,
            ref: dropdownSizeDetector
          }, {
            children: placeholder
          }), void 0), jsxRuntime_1("input", _assign2({
            className: (type === 'text' ? ' kxi-text-dropdown' : ' kxi-border') + " " + (color === 'white' ? 'kxi-white' : '') + " kxi-input" + layeredClass + contrastClass + errorStateClass + (readOnly ? ' kxi-grey kxi-readonly' : '') + " " + (className || '') + " kxi-text-" + textSize + " " + (visualState === 'condensed' ? 'kxi-condensed' : '') + (!hasSearch || inMenuSearch || readOnly ? ' kxi-readonly-border' : '')
          }, ingredients, {
            tabIndex: tabIndex,
            disabled: disabled,
            ref: mergeRefs([dropdownButton, ref]),
            placeholder: placeholder,
            type: "text",
            value: previewText,
            onChange: function onChange(e) {
              if (e.target.value === ' ') {
                return;
              }

              setQuery(e.target.value);
              setIsOpen(true);
              setIsSearching(true);

              if (dropdownButtonDetector.current) {
                setPreviewText(e.target.value);
                if (_onChange) _onChange(e);
              }
            },
            onKeyDown: function onKeyDown(e) {
              if (e.key === 'Enter' || e.key === ' ') {
                onDropdownClick();
              }
            },
            readOnly: !hasSearch || inMenuSearch || readOnly,
            onClick: onDropdownClick,
            onFocus: hasSearch ? function () {
              var _a;

              return (_a = dropdownButton.current) === null || _a === void 0 ? void 0 : _a.select();
            } : undefined,
            autoComplete: autoComplete.toString(),
            "data-lpignore": "true",
            id: dropdownId.current
          }), void 0), menuDom]
        }), void 0)
      }), void 0), getDropdownButton(), jsxRuntime_1(ErrorStateUI, {
        errorStateClass: errorStateClass,
        errorState: errorState,
        prePopulateStatus: false,
        contrastClass: contrastClass,
        disabled: disabled || false
      }, void 0)]
    }), void 0)
  }), void 0);
});

var IconButtons = function IconButtons(props) {
  var dropdownDirection = props.dropdownDirection,
      iconButtons = props.iconButtons,
      isAddingNote = props.isAddingNote,
      isCondensedExperienceCard = props.isCondensedExperienceCard,
      isFavorite = props.isFavorite,
      isNotesOpen = props.isNotesOpen,
      limitedIconButtonNumber = props.limitedIconButtonNumber,
      limitIconButtonOverride = props.limitIconButtonOverride,
      notesRef = props.notesRef,
      notesWrapperRef = props.notesWrapperRef,
      setIsAddingNote = props.setIsAddingNote,
      setIsNotesOpen = props.setIsNotesOpen,
      setKabobActiveClick = props.setKabobActiveClick,
      _a = props.tooltipDirection,
      tooltipDirection = _a === void 0 ? 1 : _a;

  var _b = __read(useState([]), 2),
      mappedIconButtons = _b[0],
      setMappedIconButtons = _b[1];

  useEffect(function () {
    var alwaysDisplayCount = iconButtons.filter(function (item) {
      return item.alwaysDisplay;
    }).length;

    var focusTextArea = function focusTextArea(textAreaFocused) {
      if (!textAreaFocused) {
        setTimeout(function () {
          if (notesWrapperRef === null || notesWrapperRef === void 0 ? void 0 : notesWrapperRef.current) {
            notesWrapperRef.current.scrollIntoView();
          }

          if (notesRef === null || notesRef === void 0 ? void 0 : notesRef.current) {
            notesRef.current.focus();
          }
        }, 100);
      }
    };

    iconButtons.sort(function (a, b) {
      var isTrueNum = a.alwaysDisplay ? -1 : 1;
      return a.alwaysDisplay === b.alwaysDisplay ? 0 : isTrueNum;
    });

    var handleNotesClick = function handleNotesClick(e, onClick) {
      if (onClick) onClick(e);

      if (isCondensedExperienceCard) {
        if (setIsNotesOpen) {
          setIsNotesOpen(function (isNotesOpen) {
            if (setIsAddingNote) {
              setIsAddingNote(!isNotesOpen);
            }

            focusTextArea(isNotesOpen);
            return !isNotesOpen;
          });
        }
      } else {
        if (setIsAddingNote) {
          setIsAddingNote(function (isAddingNote) {
            focusTextArea(isAddingNote);
            return !isAddingNote;
          });
        }
      }
    };

    var handleOnValueChange = function handleOnValueChange(item) {
      item.onClick(item);
    };

    var tempArrIconButtons = [];
    var kabobItems = [];

    var addVisibleItems = function addVisibleItems(j) {
      var _a = iconButtons[j],
          type = _a.type,
          title = _a.title,
          dropdownData = _a.dropdownData,
          onClick = _a.onClick;
      var icon = iconButtons[j].icon;

      if (type === 'dropdown') {
        tempArrIconButtons.push(jsxRuntime_1(Dropdown, {
          color: "orca",
          select: "none",
          type: "icon",
          internalProps: {
            iconButton: {
              icon: icon
            }
          },
          data: dropdownData || [],
          onValueChange: onClick
        }, j));
      } else {
        if (type === 'favorite') {
          icon = isFavorite ? 'favorite_filled' : 'favorite';
        }

        if (type === 'notes') {
          var determineFilledState = isCondensedExperienceCard ? isNotesOpen : isAddingNote;
          icon = determineFilledState ? 'comment_filled' : 'comment';
        }

        var handleClick = type === 'notes' ? function (e) {
          return handleNotesClick(e, onClick);
        } : onClick;
        tempArrIconButtons.push(jsxRuntime_1(IconButton, {
          icon: icon,
          tooltip: {
            text: title,
            direction: tooltipDirection
          },
          onClick: handleClick
        }, j));
      }

      if (j !== iconButtons.length - 1) {
        tempArrIconButtons.push(jsxRuntime_1("p", _assign2({
          className: "kxi-pipe"
        }, {
          children: "|"
        }), 'kxi-pipe-' + j));
      }
    };

    var addHiddenItems = function addHiddenItems(j) {
      var _a = iconButtons[j],
          type = _a.type,
          icon = _a.icon,
          title = _a.title,
          onClick = _a.onClick;

      if (type === 'dropdown') {
        devOnlyWarn("The Kitchen: You have passed an iconButton into the ExperienceCard with a type of \"dropdown\" that is either not one of the first 4 items, or does not have \"alwaysDisplay\" set to true \u2013 this will render under the kabob icon dropdown, and the self contained dropdown items related to the \"" + icon + "\" icon will not show. It must be one of the first four icons in the array, or have the alwaysDisplay set to true, to take advantage of the \"dropdown\" type functionality. Reach out to the Kitchen team for questions.");
      }

      kabobItems.push({
        title: title || icon,
        // Couldn't get TS to cooperate on this one
        onClick: type === 'notes' ? function (e) {
          return handleNotesClick(e, onClick);
        } : onClick
      });
    }; // depending on the responsiveness and space left on the card


    if (limitIconButtonOverride) {
      var numberOfVisibleIcons = limitedIconButtonNumber > 0 ? limitedIconButtonNumber : 4;
      var showRemainder = iconButtons.length - numberOfVisibleIcons <= 1;

      for (var j = 0; j < iconButtons.length; j++) {
        if (j < numberOfVisibleIcons || showRemainder) {
          addVisibleItems(j);
        } else {
          addHiddenItems(j);
        }
      }
    } else {
      for (var j = 0; j < iconButtons.length; j++) {
        var showRemainder = iconButtons.length < 6 || iconButtons.length - alwaysDisplayCount <= 1;

        if (j < 4 || iconButtons[j].alwaysDisplay || showRemainder) {
          addVisibleItems(j);
        } else {
          addHiddenItems(j);
        }
      }
    }

    if (kabobItems.length) {
      tempArrIconButtons.push(jsxRuntime_1(Dropdown, {
        color: "orca",
        select: "none",
        type: "icon",
        internalProps: {
          iconButton: {
            icon: 'kabob'
          }
        },
        data: kabobItems,
        direction: dropdownDirection,
        itemSearchCount: Infinity,
        onOpenChange: function onOpenChange(state) {
          return setKabobActiveClick(state);
        },
        // Couldn't get TS to cooperate on this one ... might be a better implementation involving dropdown submenus?
        onValueChange: function onValueChange(item) {
          return handleOnValueChange(item);
        }
      }, "leftover_items_kabob_dropdown"));
    }

    setMappedIconButtons(tempArrIconButtons);
  }, [isFavorite, iconButtons, dropdownDirection, limitIconButtonOverride, limitedIconButtonNumber, isNotesOpen, isAddingNote]);
  return jsxRuntime_1(jsxRuntime_3, {
    children: mappedIconButtons
  }, void 0);
};

var mapMeta = function mapMeta(meta) {
  return meta.map(function (metaTag, i) {
    var pipe = meta.length - 1 !== i ? ' | ' : ' ';
    return jsxRuntime_2("span", {
      children: [metaTag, pipe]
    }, i);
  });
};

var ExperienceHeaderProps = function (_super) {
  __extends(ExperienceHeaderProps, _super);

  function ExperienceHeaderProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], ExperienceHeaderProps.prototype, "title");

  __decorate([Bound(), __metadata("design:type", Number)], ExperienceHeaderProps.prototype, "titleScore");

  __decorate([Bound(), __metadata("design:type", String)], ExperienceHeaderProps.prototype, "sentiment");

  __decorate([Bound(), __metadata("design:type", Object)], ExperienceHeaderProps.prototype, "viewDetailsButton");

  __decorate([Bound(), __metadata("design:type", Object)], ExperienceHeaderProps.prototype, "localization");

  __decorate([Bound(), __metadata("design:type", Object)], ExperienceHeaderProps.prototype, "headerButton");

  __decorate([Bound(), __metadata("design:type", Boolean)], ExperienceHeaderProps.prototype, "selectable");

  __decorate([Bound(), __metadata("design:type", Array)], ExperienceHeaderProps.prototype, "iconButtons");

  __decorate([Bound(), __metadata("design:type", String)], ExperienceHeaderProps.prototype, "subtitleLogo");

  __decorate([Bound(), __metadata("design:type", String)], ExperienceHeaderProps.prototype, "subtitle");

  __decorate([Bound(), __metadata("design:type", Boolean)], ExperienceHeaderProps.prototype, "isFavorite");

  __decorate([Bound(), __metadata("design:type", Number)], ExperienceHeaderProps.prototype, "dropdownDirection");

  __decorate([Bound(), __metadata("design:type", Array)], ExperienceHeaderProps.prototype, "meta");

  __decorate([Bound(), __metadata("design:type", Boolean)], ExperienceHeaderProps.prototype, "selected");

  __decorate([Bound(), __metadata("design:type", Boolean)], ExperienceHeaderProps.prototype, "hasSeparator");

  return ExperienceHeaderProps;
}(ObservablePropsMixin(DivHTMLAttributes));

var ExperienceHeaderEvents = function (_super) {
  __extends(ExperienceHeaderEvents, _super);

  function ExperienceHeaderEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], ExperienceHeaderEvents.prototype, "onMarkValidClick");

  __decorate([Bound(), __metadata("design:type", Function)], ExperienceHeaderEvents.prototype, "onSelectionChange");

  return ExperienceHeaderEvents;
}(DivHTMLEvents);
/**
 * Description: The header for the experience card, to be used in areas where experience card styling is needed, but where the experience card does not fill that need.
 */


var ExperienceHeader = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      dropdownDirection = props.dropdownDirection,
      headerButton = props.headerButton,
      _a = props.iconButtons,
      iconButtons = _a === void 0 ? [] : _a,
      isFavorite = props.isFavorite,
      localization = props.localization,
      _b = props.meta,
      meta = _b === void 0 ? [] : _b,
      _notesData = props._notesData,
      observer = props.observer,
      _c = props.selectable,
      selectable = _c === void 0 ? true : _c,
      selected = props.selected,
      _d = props.sentiment,
      sentiment = _d === void 0 ? '' : _d,
      subtitle = props.subtitle,
      subtitleLogo = props.subtitleLogo,
      title = props.title,
      titleScore = props.titleScore,
      viewDetailsButton = props.viewDetailsButton,
      _e = props.hasSeparator,
      hasSeparator = _e === void 0 ? true : _e,
      onMarkValidClick = props.onMarkValidClick,
      onSelectionChange = props.onSelectionChange,
      ingredients = __rest(props, ["className", "dropdownDirection", "headerButton", "iconButtons", "isFavorite", "localization", "meta", "_notesData", "observer", "selectable", "selected", "sentiment", "subtitle", "subtitleLogo", "title", "titleScore", "viewDetailsButton", "hasSeparator", "onMarkValidClick", "onSelectionChange"]);

  var hasHeader = headerButton === null || headerButton === void 0 ? void 0 : headerButton.text;

  var _f = __read(useState(0), 2),
      limitedIconButtonNumber = _f[0],
      setLimitedIconButtonNumber = _f[1];

  var _g = __read(useState(false), 2),
      kabobActiveClick = _g[0],
      setKabobActiveClick = _g[1];

  var _h = __read(useState(false), 2),
      limitIconButtonOverride = _h[0],
      setLimitIconButtonOverride = _h[1];

  var _j = __read(useState(false), 2),
      checkedState = _j[0],
      setCheckedState = _j[1];

  var _k = useResizeDetector(),
      subtitleWidth = _k.width,
      subtitleRef = _k.ref;

  var _l = useResizeDetector(),
      cardWidth = _l.width,
      cardWidthRef = _l.ref;

  useEffect(function () {
    // preventing a bug that changes icon number based on dropdown opening
    if (!kabobActiveClick) {
      if (cardWidth && subtitleWidth && iconButtons.length) {
        var iconButtonsWithAlwaysDisplay = iconButtons.filter(function (i) {
          return i.alwaysDisplay;
        }).length;
        var iconButtonCount = iconButtonsWithAlwaysDisplay <= 4 ? 4 : iconButtonsWithAlwaysDisplay; // all of these sizes correlate with our scss files

        var cardWithPadding = cardWidth - 48;
        var checkboxWidth = selectable ? 36 : 0;
        var logoWidth = subtitleWidth ? 30 : 0; // 36 + 5

        var iconAndPipeWidth = 41;
        var maxIconButtonLength = iconButtons.length * iconAndPipeWidth;
        var sumOfLeftSide = subtitleWidth + checkboxWidth + logoWidth;
        var sumOfInternals = sumOfLeftSide + maxIconButtonLength;
        var availableSpace = cardWithPadding - sumOfLeftSide;
        var numberOfIconsThatCanFit = availableSpace / iconAndPipeWidth;

        if (maxIconButtonLength < sumOfInternals) {
          setLimitIconButtonOverride(true);
        } else {
          setLimitIconButtonOverride(false);
        }

        setLimitedIconButtonNumber(Math.min(Math.floor(numberOfIconsThatCanFit - 1), iconButtonCount));
      }
    }
  }, [cardWidth]);
  useEffect(function () {
    setCheckedState(!!selected);
  }, [selected]);

  var handleCheck = function handleCheck(e) {
    setCheckedState(function (v) {
      if (observer) {
        observer.selected = !v;
      }

      if (onSelectionChange) onSelectionChange(e);
      return !v;
    });
  };

  return jsxRuntime_2("div", _assign2({}, ingredients, {
    className: "kxi-experience-header orca " + (sentiment === 'invalid' ? 'kxi-invalid' : !sentiment ? 'kxi-no-sentiment' : ''),
    ref: mergeRefs([cardWidthRef, ref])
  }, {
    children: [jsxRuntime_2("div", _assign2({
      className: "kxi-score-bar  " + (!sentiment ? 'kxi-white' : normalizeColor(sentiment))
    }, {
      children: [jsxRuntime_2("div", _assign2({
        className: "kxi-score-bar-text"
      }, {
        children: [jsxRuntime_1("h3", _assign2({
          className: "kxi-nps-score"
        }, {
          children: titleScore
        }), void 0), " ", jsxRuntime_1("p", _assign2({
          className: "kxi-nps-title"
        }, {
          children: title
        }), void 0)]
      }), void 0), sentiment === 'invalid' ? jsxRuntime_2("div", _assign2({
        className: "kxi-invalid-sentiment-actions"
      }, {
        children: [jsxRuntime_1(DefaultButton, {
          color: "CX",
          fill: "text",
          size: "small",
          text: (localization === null || localization === void 0 ? void 0 : localization.markValid) ? localization === null || localization === void 0 ? void 0 : localization.markValid : 'Mark Valid',
          onClick: function onClick() {
            return onMarkValidClick && onMarkValidClick();
          },
          style: {
            margin: '0 12px'
          }
        }, void 0), (viewDetailsButton === null || viewDetailsButton === void 0 ? void 0 : viewDetailsButton.text) ? jsxRuntime_2(jsxRuntime_3, {
          children: [jsxRuntime_1("p", _assign2({
            className: "kxi-pipe"
          }, {
            children: "|"
          }), void 0), jsxRuntime_1(DefaultButton, {
            style: {
              margin: '0 12px'
            },
            fill: "text",
            color: "CX",
            size: "small",
            text: viewDetailsButton.text,
            onClick: viewDetailsButton.onClick
          }, void 0)]
        }, void 0) : null]
      }), void 0) : hasHeader ? jsxRuntime_1("div", _assign2({
        className: "kxi-score-card-button"
      }, {
        children: jsxRuntime_1(DefaultButton, _assign2({
          style: {
            margin: '0 12px'
          },
          fill: "text",
          color: "CX",
          size: "small"
        }, headerButton), void 0)
      }), void 0) : null]
    }), void 0), jsxRuntime_1("div", _assign2({
      className: "kxi-inner-wrapper " + (limitedIconButtonNumber <= 0 && limitIconButtonOverride ? 'kxi-stacked-view' : '')
    }, {
      children: jsxRuntime_2("div", _assign2({
        className: "kxi-subtitle-wrapper " + (hasSeparator ? 'kxi-experience-header-separator' : '')
      }, {
        children: [jsxRuntime_2("div", _assign2({
          className: "kxi-checkbox-wrapper"
        }, {
          children: [selectable ? jsxRuntime_1(Checkbox, {
            checked: checkedState,
            onChange: handleCheck
          }, void 0) : null, jsxRuntime_2("div", _assign2({
            className: "kxi-text-wrapper " + (selectable ? 'kxi-experience-card-selectable' : '')
          }, {
            children: [jsxRuntime_2("p", _assign2({
              className: "kxi-experience-card-subtitle orca kxi-text-medium"
            }, {
              children: [subtitleLogo ? jsxRuntime_1("span", _assign2({
                className: "kxi-logo-wrapper"
              }, {
                children: jsxRuntime_1(XISVG, {
                  svg: subtitleLogo
                }, void 0)
              }), void 0) : null, jsxRuntime_1("span", _assign2({
                ref: subtitleRef
              }, {
                children: subtitle
              }), void 0)]
            }), void 0), jsxRuntime_1("p", _assign2({
              className: "kxi-meta kxi-text-small"
            }, {
              children: mapMeta(meta)
            }), void 0)]
          }), void 0)]
        }), void 0), jsxRuntime_1("div", _assign2({
          className: "kxi-icon-buttons-wrapper"
        }, {
          children: jsxRuntime_1(IconButtons, {
            isAddingNote: _notesData ? _notesData.isAddingNote : false,
            isCondensedExperienceCard: false,
            limitIconButtonOverride: limitIconButtonOverride,
            limitedIconButtonNumber: limitedIconButtonNumber,
            isNotesOpen: _notesData ? _notesData.isNotesOpen : false,
            iconButtons: iconButtons,
            dropdownDirection: dropdownDirection,
            isFavorite: isFavorite,
            notesRef: _notesData === null || _notesData === void 0 ? void 0 : _notesData.notesRef,
            notesWrapperRef: _notesData === null || _notesData === void 0 ? void 0 : _notesData.notesWrapperRef,
            setIsAddingNote: _notesData === null || _notesData === void 0 ? void 0 : _notesData.setIsAddingNote,
            setIsNotesOpen: _notesData === null || _notesData === void 0 ? void 0 : _notesData.setIsNotesOpen,
            setKabobActiveClick: setKabobActiveClick
          }, void 0)
        }), void 0)]
      }), void 0)
    }), void 0)]
  }), void 0);
});

var SentimentSection = function SentimentSection(props) {
  var highlightedSentiments = props.highlightedSentiments,
      onSentimentClick = props.onSentimentClick,
      hasSeparator = props.hasSeparator,
      localization = props.localization,
      sentimentAnnotations = props.sentimentAnnotations;

  var _a = __read(useState([]), 2),
      highlightedSentimentsState = _a[0],
      setHighlightedSentimentsState = _a[1];

  var hasAnnotation = {
    positive: sentimentAnnotations === null || sentimentAnnotations === void 0 ? void 0 : sentimentAnnotations.findIndex(function (item) {
      return item.sentiment === 1;
    }),
    neutral: sentimentAnnotations === null || sentimentAnnotations === void 0 ? void 0 : sentimentAnnotations.findIndex(function (item) {
      return item.sentiment === 0;
    }),
    negative: sentimentAnnotations === null || sentimentAnnotations === void 0 ? void 0 : sentimentAnnotations.findIndex(function (item) {
      return item.sentiment === -1;
    })
  };
  useEffect(function () {
    setHighlightedSentimentsState(highlightedSentiments || []);
  }, [highlightedSentiments]);

  var mappedSentiments = _SentimentsOptions.map(function (sentiment) {
    var isFocused = highlightedSentimentsState.includes(sentiment);
    var text;

    if (localization) {
      text = localization[sentiment];
    }

    return jsxRuntime_1(SentimentButton, {
      disabled: hasAnnotation[sentiment] === -1,
      className: "kxi-sentiment-button " + normalizeColor(sentiment),
      sentiment: sentiment,
      isFocused: isFocused,
      text: text,
      onClick: function onClick() {
        if (onSentimentClick) onSentimentClick(sentiment);
      },
      "data-testid": "sentiment-button-" + sentiment
    }, sentiment);
  });

  return jsxRuntime_2(jsxRuntime_3, {
    children: [hasSeparator ? jsxRuntime_1("div", {
      style: {
        borderBottom: '1px solid',
        borderColor: XIColors.grey.light[80],
        marginTop: -14,
        marginBottom: 6,
        marginLeft: -3
      }
    }, void 0) : null, jsxRuntime_1("div", _assign2({
      className: "kxi-sentiment-section-wrapper"
    }, {
      children: mappedSentiments
    }), void 0)]
  }, void 0);
};

var TagItem = function TagItem(props) {
  var tagName = props.tagName,
      sentiment = props.sentiment,
      _a = props.userAdded,
      userAdded = _a === void 0 ? false : _a,
      onTagClick = props.onTagClick,
      selected = props.selected;
  return jsxRuntime_1("div", {
    children: userAdded ? jsxRuntime_1("div", _assign2({
      className: "kxi-tag-item-user-tag-wrapper"
    }, {
      children: jsxRuntime_1(DefaultButton, {
        color: "orca",
        text: tagName,
        fill: "fill",
        buttonSize: "small",
        onClick: function onClick() {
          if (onTagClick) onTagClick(props);
        },
        className: "kxi-tag-item-user-tag kxi-tag-item-button"
      }, void 0)
    }), void 0) : jsxRuntime_2(jsxRuntime_3, {
      children: [jsxRuntime_1(DefaultButton, {
        color: "orca",
        text: tagName,
        fill: selected ? 'fill' : 'outline',
        style: selected ? {
          marginLeft: 1,
          marginRight: 1
        } : undefined,
        buttonSize: "small",
        onClick: function onClick() {
          if (onTagClick) onTagClick(props);
        },
        className: "kxi-tag-item-button"
      }, void 0), jsxRuntime_1("div", {
        className: "kxi-tag-item-sentiment-bar kxi-" + sentiment,
        "data-testid": "tagSentimentBar"
      }, void 0)]
    }, void 0)
  }, void 0);
};

var EditableTextProps = function (_super) {
  __extends(EditableTextProps, _super);

  function EditableTextProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], EditableTextProps.prototype, "contrast");

  __decorate([Bound(), __metadata("design:type", String)], EditableTextProps.prototype, "placeholder");

  __decorate([Bound(), __metadata("design:type", Boolean)], EditableTextProps.prototype, "prePopulateStatus");

  __decorate([Bound(), __metadata("design:type", String)], EditableTextProps.prototype, "value");

  __decorate([Bound(), __metadata("design:type", Boolean)], EditableTextProps.prototype, "stretch");

  __decorate([Bound(), __metadata("design:type", Boolean)], EditableTextProps.prototype, "disabled");

  __decorate([Bound(), __metadata("design:type", Object)], EditableTextProps.prototype, "status");

  __decorate([Bound(), __metadata("design:type", String)], EditableTextProps.prototype, "type");

  return EditableTextProps;
}(ObservablePropsMixin(InputHTMLAttributes));

var EditableTextEvents = function (_super) {
  __extends(EditableTextEvents, _super);

  function EditableTextEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], EditableTextEvents.prototype, "onInputEnter");

  return EditableTextEvents;
}(InputHTMLEvents);
/**
 * Description: TextField where the input grows with the text typed.
 */


var EditableText = /*#__PURE__*/forwardRef(function (props, ref) {
  var placeholder = props.placeholder,
      _a = props.contrast,
      contrast = _a === void 0 ? 'normal' : _a,
      _b = props.stretch,
      stretch = _b === void 0 ? false : _b,
      status = props.status,
      value = props.value,
      disabled = props.disabled,
      type = props.type,
      className = props.className,
      style = props.style,
      observer = props.observer,
      onChange = props.onChange,
      onClick = props.onClick,
      onInputEnter = props.onInputEnter,
      _c = props.prePopulateStatus,
      prePopulateStatus = _c === void 0 ? false : _c,
      ingredients = __rest(props, ["placeholder", "contrast", "stretch", "status", "value", "disabled", "type", "className", "style", "observer", "onChange", "onClick", "onInputEnter", "prePopulateStatus"]);

  var validType = checkIfTextInputTypeIsValid('EditableText', type);

  if (status) {
    if (!status.state && status.text) {
      devOnlyWarn('The Kitchen: You must pass a state into EditableText.');
    }
  }

  var inputEl = useRef(null);

  var _d = __read(useState(''), 2),
      text = _d[0],
      setText = _d[1];

  useEffect(function () {
    setText(value || '');
  }, [value]);

  var _e = __read(useTextFieldStatus(text, 'EditableText', status), 3),
      errorState = _e[0],
      errorStateClass = _e[2];

  var contrastClass = contrast === 'high' ? ' kxi-high-contrast' : '';

  var handleChange = function handleChange(e) {
    var newText = e.target.value;
    setText(newText);

    if (observer) {
      observer.value = newText;
    }

    if (onChange) onChange(e);
  };

  var handleEnter = function handleEnter(e) {
    if (e.key === 'Enter' || e.which === 13 || e.keyCode === 13) {
      inputEl.current.blur();
      if (onInputEnter) onInputEnter(text);
    }
  };

  var handleClick = function handleClick(e) {
    inputEl.current.select();
    if (onClick) onClick(e);
  };

  var state;

  if (status) {
    state = status.state;
  }

  var inputClasses = 'kxi-editable-text-input kxi-text-normal orca';
  var inputWrapperClasses = 'kxi-editable-text-input-wrapper orca';

  if (disabled) {
    inputClasses += ' disabled';
    inputWrapperClasses += ' kxi-disabled disabled';
  }

  if (state) {
    inputWrapperClasses += " kxi-status kxi-" + state;
  }

  if (contrast === 'high') {
    inputWrapperClasses += ' kxi-high-contrast';
    inputClasses += ' kxi-high-contrast';
  }

  if (className) inputClasses += " " + className;

  if (stretch) {
    inputWrapperClasses += ' kxi-stretch-width';
  }

  return jsxRuntime_2("div", _assign2({
    className: "kxi-editable-text " + (stretch ? 'kxi-stretch-width' : '')
  }, {
    children: [jsxRuntime_1("div", _assign2({
      className: inputWrapperClasses
    }, {
      children: jsxRuntime_1("input", _assign2({
        className: inputClasses,
        style: _assign2({}, style),
        ref: mergeRefs([inputEl, ref]),
        value: text,
        placeholder: placeholder,
        disabled: disabled,
        readOnly: disabled,
        type: validType ? type : undefined,
        "data-testid": "input"
      }, ingredients, {
        onClick: handleClick,
        onKeyPress: handleEnter,
        onChange: handleChange
      }), void 0)
    }), void 0), jsxRuntime_1(ErrorStateUI, {
      prePopulateStatus: prePopulateStatus,
      errorStateClass: errorStateClass,
      contrastClass: contrastClass,
      errorState: errorState,
      disabled: disabled || false,
      text: text
    }, void 0)]
  }), void 0);
});

var Label = function Label(props) {
  var contrast = props.contrast,
      inputId = props.inputId,
      label = props.label;
  return jsxRuntime_1(jsxRuntime_3, {
    children: label ? jsxRuntime_1("label", _assign2({
      className: "kxi-input-label kxi-" + contrast + "-contrast",
      htmlFor: inputId
    }, {
      children: label
    }), void 0) : null
  }, void 0);
};

var handleInput = function handleInput(disabled, _controlledState, e, setErrorState, setText, maxCharsAllowed, observer, mask) {
  if (!disabled && !mask) {
    var newText = e.currentTarget.value;

    if (!_controlledState) {
      if (maxCharsAllowed && !maxCharsAllowed.allowOvertype) {
        if (newText.length <= maxCharsAllowed.max) {
          setText(newText);

          if (observer) {
            observer.value = newText;
          }

          return true;
        } else {
          setErrorState({
            state: 'error',
            text: maxCharsAllowed.errorMessage
          });
          return false;
        }
      } else {
        setText(newText);

        if (observer) {
          observer.value = newText;
        }

        return true;
      }
    } else {
      if (observer) {
        observer.value = newText;
      }

      return true;
    }
  } else {
    return false;
  }
};

var InputFieldProps = function (_super) {
  __extends(InputFieldProps, _super);

  function InputFieldProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], InputFieldProps.prototype, "placeholder");

  __decorate([Bound(), __metadata("design:type", String)], InputFieldProps.prototype, "value");

  __decorate([Bound(), __metadata("design:type", Object)], InputFieldProps.prototype, "textSize");

  __decorate([Bound(), __metadata("design:type", String)], InputFieldProps.prototype, "contrast");

  __decorate([Bound(), __metadata("design:type", Object)], InputFieldProps.prototype, "status");

  __decorate([Bound(), __metadata("design:type", Boolean)], InputFieldProps.prototype, "prePopulateStatus");

  __decorate([Bound(), __metadata("design:type", String)], InputFieldProps.prototype, "label");

  __decorate([Bound(), __metadata("design:type", String)], InputFieldProps.prototype, "inputId");

  __decorate([Bound(), __metadata("design:type", Object)], InputFieldProps.prototype, "maxCharsAllowed");

  __decorate([Bound(), __metadata("design:type", String)], InputFieldProps.prototype, "type");

  __decorate([Bound(), __metadata("design:type", Boolean)], InputFieldProps.prototype, "readOnly");

  __decorate([Bound(), __metadata("design:type", String)], InputFieldProps.prototype, "icon");

  __decorate([Bound(), __metadata("design:type", Object)], InputFieldProps.prototype, "localization");

  __decorate([Bound(), __metadata("design:type", String)], InputFieldProps.prototype, "mask");

  __decorate([Bound(), __metadata("design:type", Boolean)], InputFieldProps.prototype, "errorOnIncompleteMask");

  __decorate([Bound(), __metadata("design:type", String)], InputFieldProps.prototype, "maskErrorMessage");

  __decorate([Bound(), __metadata("design:type", Array)], InputFieldProps.prototype, "suggestions");

  __decorate([Bound(), __metadata("design:type", Boolean)], InputFieldProps.prototype, "selectAllOnFocus");

  __decorate([Bound(), __metadata("design:type", Number)], InputFieldProps.prototype, "maxSuggestions");

  __decorate([Bound(), __metadata("design:type", String)], InputFieldProps.prototype, "visualState");

  return InputFieldProps;
}(ObservablePropsMixin(InputHTMLAttributes));

var InputFieldEvents = function (_super) {
  __extends(InputFieldEvents, _super);

  function InputFieldEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], InputFieldEvents.prototype, "onInputEnter");

  __decorate([Bound(), __metadata("design:type", Function)], InputFieldEvents.prototype, "onIconClick");

  __decorate([Bound(), __metadata("design:type", Function)], InputFieldEvents.prototype, "onSuggestionClick");

  return InputFieldEvents;
}(InputHTMLEvents);
/**
 * Description: Standard InMoment branded InputField.
 */


var InputField = /*#__PURE__*/forwardRef(function (props, ref) {
  var inputRef = useRef(null);
  var suggestionRef = useRef(null);

  var _a = props._controlledState,
      _controlledState = _a === void 0 ? false : _a,
      _b = props.disabled,
      disabled = _b === void 0 ? false : _b,
      placeholder = props.placeholder,
      _c = props.contrast,
      contrast = _c === void 0 ? 'normal' : _c,
      _d = props.textSize,
      textSize = _d === void 0 ? 'normal' : _d,
      value = props.value,
      status = props.status,
      id = props.id,
      inputId = props.inputId,
      label = props.label,
      width = props.width,
      maxLength = props.maxLength,
      icon = props.icon,
      onChange = props.onChange,
      onKeyPress = props.onKeyPress,
      onInputEnter = props.onInputEnter,
      onIconClick = props.onIconClick,
      onBlur = props.onBlur,
      onSuggestionClick = props.onSuggestionClick,
      _onFocus = props.onFocus,
      internalProps = props.internalProps,
      _e = props.prePopulateStatus,
      prePopulateStatus = _e === void 0 ? false : _e,
      maskErrorMessage = props.maskErrorMessage,
      type = props.type,
      readOnly = props.readOnly,
      className = props.className,
      style = props.style,
      observer = props.observer,
      maxCharsAllowed = props.maxCharsAllowed,
      suggestions = props.suggestions,
      _f = props.maxSuggestions,
      maxSuggestions = _f === void 0 ? 5 : _f,
      _g = props.mask,
      mask = _g === void 0 ? '' : _g,
      externalSuggestionsRef = props.suggestionsRef,
      _h = props.localization,
      localization = _h === void 0 ? {} : _h,
      _j = props.errorOnIncompleteMask,
      errorOnIncompleteMask = _j === void 0 ? true : _j,
      _k = props.visualState,
      visualState = _k === void 0 ? 'normal' : _k,
      _l = props.selectAllOnFocus,
      selectAllOnFocus = _l === void 0 ? true : _l,
      ingredients = __rest(props, ["_controlledState", "disabled", "placeholder", "contrast", "textSize", "value", "status", "id", "inputId", "label", "width", "maxLength", "icon", "onChange", "onKeyPress", "onInputEnter", "onIconClick", "onBlur", "onSuggestionClick", "onFocus", "internalProps", "prePopulateStatus", "maskErrorMessage", "type", "readOnly", "className", "style", "observer", "maxCharsAllowed", "suggestions", "maxSuggestions", "mask", "suggestionsRef", "localization", "errorOnIncompleteMask", "visualState", "selectAllOnFocus"]);

  var wrapper = (internalProps || {}).wrapper;

  var _m = wrapper || {},
      divRef = _m.ref,
      divIngredients = __rest(_m, ["ref"]);

  var validType = checkIfTextInputTypeIsValid('InputField', type); // using first a custom inputId for the label if specified, and otherwise defaulting to a generic identifier.

  var _o = __read(useState(inputId ? inputId : (id ? id : uuidv4()) + "-input"), 1),
      finalInputId = _o[0];

  var _p = __read(useState(''), 2),
      text = _p[0],
      setText = _p[1];

  var _q = __read(useState(icon), 2),
      inputIcon = _q[0],
      setInputIcon = _q[1];

  var _r = __read(useState(), 2),
      iconClick = _r[0],
      setIconClick = _r[1];

  var _s = __read(useState(45), 2),
      suggestionHeight = _s[0],
      setSuggestionHeight = _s[1];

  var _t = __read(useState(defaultLocalization), 2),
      localTexts = _t[0],
      setLocalTexts = _t[1];

  var outerStyle = width ? _assign2({
    width: width
  }, style) : style;

  var _u = __read(useMaskedInput(mask, observer), 5),
      handleChange = _u[0],
      maskedValue = _u[1],
      setMaskedValue = _u[2],
      simulateTyping = _u[3],
      maskRef = _u[4];

  var _v = __read(useState(true), 2),
      showSuggestions = _v[0],
      setShowSuggestions = _v[1];

  useEffect(function () {
    if (mask) {
      if (type === 'number' || type === 'email') {
        devOnlyWarn("The Kitchen: (InputField) - A masked input does not support type === " + type + ", it has been changed to text.");
      }
    }
  }, [mask, type]);
  useEffect(function () {
    if (type !== 'password') {
      setInputIcon(icon);
    }
  }, [icon]);

  if (mask && maxCharsAllowed) {
    maxCharsAllowed.max = mask.length;
  }

  var _w = __read(useTextFieldStatus(mask ? maskedValue : text, 'InputField', status, maxCharsAllowed), 3),
      errorState = _w[0],
      setErrorState = _w[1],
      errorStateClass = _w[2];

  useTextFieldWarning('InputField', _controlledState, onChange);
  useLayoutEffect(function () {
    if (type === 'password') {
      setInputIcon('visibility');
      setLocalTexts(_assign2(_assign2({}, localTexts), localization));
      setIconClick(function () {
        return function (icon, setIcon) {
          if (icon === 'visibility') {
            setIcon('visibility_off');
          } else {
            setIcon('visibility');
          }
        };
      });
    }
  }, [type]);
  useLayoutEffect(function () {
    if (suggestionRef.current) {
      setSuggestionHeight(suggestionRef.current.offsetHeight);
    }
  }, [suggestionRef]);
  useEffect(function () {
    if (!_controlledState && !mask) {
      setText(value || '');
    }
  }, [value, _controlledState]);
  useEffect(function () {
    setShowSuggestions(true);
  }, [suggestions]);
  useEffect(function () {
    if (mask) {
      if (countChars(value || '') <= countChars(mask)) {
        var _a = __read(simulateTyping(value || ''), 1),
            newValue = _a[0];

        setMaskedValue(newValue);
      } else {
        var temp = value || '';
        temp = temp.substring(0, countChars(mask));

        var _b = __read(simulateTyping(temp), 1),
            newValue = _b[0];

        setMaskedValue(newValue);
      }
    }
  }, [value]);

  var handleInputFieldChange = function handleInputFieldChange(e) {
    var fireFunction = handleInput(disabled, _controlledState, e, setErrorState, setText, maxCharsAllowed, observer, mask);

    if (mask) {
      handleChange(e, onChange, onInputEnter);
    } else if (fireFunction && onChange) {
      onChange(e);
    }
  };

  var handleEnter = function handleEnter(e) {
    if (!disabled) {
      if (e.key === 'Enter' && inputRef.current) {
        inputRef.current.blur();

        if (onInputEnter) {
          onInputEnter(type === 'number' ? +text : text);
        }
      }

      if (onKeyPress) onKeyPress(e);
    }
  };

  var handleIconClick = function handleIconClick() {
    if (onIconClick) onIconClick();
    if (iconClick) iconClick(inputIcon, setInputIcon);
  };

  var handleBlur = function handleBlur(e) {
    if (mask && maskedValue.length && maskedValue.length !== mask.length && errorOnIncompleteMask) {
      setErrorState({
        state: 'error',
        text: maskErrorMessage
      });
    }

    if (mask && value && value !== maskedValue) {
      setMaskedValue(value);
    }

    if (onBlur) onBlur(e);
  };

  var inputValue = _controlledState ? value || '' : text;
  var contrastClass = contrast === 'high' ? ' kxi-high-contrast' : '';

  var getInputClassList = function getInputClassList() {
    var classes = 'kxi-input';
    classes += ' kxi-border';
    classes += contrastClass;
    classes += errorStateClass;
    classes += " kxi-text-" + textSize;
    classes += visualState === 'condensed' ? " kxi-condensed" : '';
    if (readOnly) classes += ' kxi-readonly';
    return classes;
  };

  var getType = function getType() {
    if (!validType) return undefined;
    var isPasswordVisible = type === 'password' && inputIcon !== 'visibility';
    var isMaskInvalid = mask && (type === 'number' || type === 'email');
    var turnTypetoText = isPasswordVisible || isMaskInvalid;

    if (turnTypetoText) {
      return 'text';
    }

    return type;
  };

  var getMaxLength = function getMaxLength() {
    var max = maxLength;
    if (mask) max = mask.length;else if (maxCharsAllowed) max = maxCharsAllowed.max;
    return max;
  };

  return jsxRuntime_2("div", _assign2({
    "aria-labelledby": value,
    "aria-describedby": placeholder,
    className: "kxi-input-outer-wrapper orca " + (visualState === 'condensed' ? 'kxi-condensed' : ''),
    style: outerStyle
  }, divIngredients, {
    ref: divRef
  }, {
    children: [jsxRuntime_1(Label, {
      contrast: contrast,
      label: label,
      inputId: finalInputId
    }, void 0), inputIcon && jsxRuntime_1(XIIcon, {
      className: "kxi-input-icon " + (visualState === 'condensed' ? 'kxi-condensed' : ''),
      iconSize: 24,
      contrast: contrast,
      icon: inputIcon,
      onClick: handleIconClick
    }, void 0), jsxRuntime_1("input", _assign2({
      ref: mergeRefs([inputRef, ref, maskRef]),
      id: finalInputId,
      className: getInputClassList() + " " + (className || ''),
      disabled: disabled,
      placeholder: placeholder,
      readOnly: readOnly,
      value: mask ? maskedValue : inputValue,
      maxLength: !(maxCharsAllowed === null || maxCharsAllowed === void 0 ? void 0 : maxCharsAllowed.allowOvertype) ? getMaxLength() : undefined,
      onChange: handleInputFieldChange,
      onKeyPress: handleEnter,
      onBlur: handleBlur,
      "data-testid": "inputField",
      type: getType()
    }, ingredients, {
      onFocus: function onFocus(e) {
        if ((inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) && selectAllOnFocus) {
          inputRef.current.select();
        }

        if (_onFocus) {
          _onFocus(e);
        }
      }
    }), void 0), showSuggestions && suggestions && suggestions.length > 0 && jsxRuntime_2("div", _assign2({
      className: "kxi-input-suggestions",
      style: {
        width: width,
        maxHeight: maxSuggestions * suggestionHeight
      },
      ref: externalSuggestionsRef
    }, {
      children: [suggestions.findIndex(function (s) {
        return s.value === inputValue;
      }) === -1 && jsxRuntime_1("div", _assign2({
        className: "kxi-input-suggestion kxi-text-600",
        onClick: function onClick() {
          setShowSuggestions(false);
        }
      }, {
        children: inputValue
      }), "raw-text"), suggestions.map(function (s) {
        return jsxRuntime_1("div", _assign2({
          ref: s.value ? suggestionRef : null,
          className: "kxi-input-suggestion",
          onClick: function onClick() {
            if (onSuggestionClick) onSuggestionClick(s);
            setShowSuggestions(false);
          }
        }, {
          children: jsxRuntime_1("span", {
            children: s.value && inputValue ? boldenSearchText(s.value, inputValue) : s.value
          }, void 0)
        }), s.key);
      })]
    }), void 0), jsxRuntime_1(ErrorStateUI, {
      prePopulateStatus: prePopulateStatus,
      errorStateClass: errorStateClass,
      contrastClass: contrastClass,
      errorState: errorState,
      maxCharsAllowed: maxCharsAllowed,
      disabled: disabled,
      text: mask ? maskedValue : text
    }, void 0)]
  }), void 0);
});

var TextAreaHTMLAttributes = function (_super) {
  __extends(TextAreaHTMLAttributes, _super);

  function TextAreaHTMLAttributes() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], TextAreaHTMLAttributes.prototype, "autoComplete");

  __decorate([Bound(), __metadata("design:type", Boolean)], TextAreaHTMLAttributes.prototype, "autoFocus");

  __decorate([Bound(), __metadata("design:type", Number)], TextAreaHTMLAttributes.prototype, "cols");

  __decorate([Bound(), __metadata("design:type", String)], TextAreaHTMLAttributes.prototype, "dirName");

  __decorate([Bound(), __metadata("design:type", Boolean)], TextAreaHTMLAttributes.prototype, "disabled");

  __decorate([Bound(), __metadata("design:type", String)], TextAreaHTMLAttributes.prototype, "form");

  __decorate([Bound(), __metadata("design:type", Number)], TextAreaHTMLAttributes.prototype, "maxLength");

  __decorate([Bound(), __metadata("design:type", Number)], TextAreaHTMLAttributes.prototype, "minLength");

  __decorate([Bound(), __metadata("design:type", String)], TextAreaHTMLAttributes.prototype, "name");

  __decorate([Bound(), __metadata("design:type", String)], TextAreaHTMLAttributes.prototype, "placeholder");

  __decorate([Bound(), __metadata("design:type", Boolean)], TextAreaHTMLAttributes.prototype, "readOnly");

  __decorate([Bound(), __metadata("design:type", Boolean)], TextAreaHTMLAttributes.prototype, "required");

  __decorate([Bound(), __metadata("design:type", Number)], TextAreaHTMLAttributes.prototype, "rows");

  __decorate([Bound(), __metadata("design:type", Object)], TextAreaHTMLAttributes.prototype, "value");

  __decorate([Bound(), __metadata("design:type", String)], TextAreaHTMLAttributes.prototype, "wrap");

  return TextAreaHTMLAttributes;
}(HTMLAttributes);

var TextAreaHTMLEvents = function (_super) {
  __extends(TextAreaHTMLEvents, _super);

  function TextAreaHTMLEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], TextAreaHTMLEvents.prototype, "onChange");

  return TextAreaHTMLEvents;
}(DOMEvents);

var TextAreaProps = function (_super) {
  __extends(TextAreaProps, _super);

  function TextAreaProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], TextAreaProps.prototype, "placeholder");

  __decorate([Bound(), __metadata("design:type", String)], TextAreaProps.prototype, "value");

  __decorate([Bound(), __metadata("design:type", String)], TextAreaProps.prototype, "contrast");

  __decorate([Bound(), __metadata("design:type", Object)], TextAreaProps.prototype, "textSize");

  __decorate([Bound(), __metadata("design:type", Object)], TextAreaProps.prototype, "status");

  __decorate([Bound(), __metadata("design:type", Boolean)], TextAreaProps.prototype, "prePopulateStatus");

  __decorate([Bound(), __metadata("design:type", String)], TextAreaProps.prototype, "label");

  __decorate([Bound(), __metadata("design:type", String)], TextAreaProps.prototype, "inputId");

  __decorate([Bound(), __metadata("design:type", Object)], TextAreaProps.prototype, "maxCharsAllowed");

  __decorate([Bound(), __metadata("design:type", Number)], TextAreaProps.prototype, "height");

  __decorate([Bound(), __metadata("design:type", Boolean)], TextAreaProps.prototype, "resize");

  __decorate([Bound(), __metadata("design:type", Object)], TextAreaProps.prototype, "localization");

  return TextAreaProps;
}(ObservablePropsMixin(TextAreaHTMLAttributes));

var TextAreaEvents = function (_super) {
  __extends(TextAreaEvents, _super);

  function TextAreaEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return TextAreaEvents;
}(TextAreaHTMLEvents);
/**
 * Description: XI Themed textarea.
 */


var TextArea = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      placeholder = props.placeholder,
      _a = props.resize,
      resize = _a === void 0 ? false : _a,
      label = props.label,
      value = props.value,
      _b = props.contrast,
      contrast = _b === void 0 ? 'normal' : _b,
      _c = props.textSize,
      textSize = _c === void 0 ? 'normal' : _c,
      _d = props.prePopulateStatus,
      prePopulateStatus = _d === void 0 ? false : _d,
      maxCharsAllowed = props.maxCharsAllowed,
      _e = props.disabled,
      disabled = _e === void 0 ? false : _e,
      inputId = props.inputId,
      status = props.status,
      observer = props.observer,
      id = props.id,
      _f = props._controlledState,
      _controlledState = _f === void 0 ? false : _f,
      onChange = props.onChange,
      _onClick = props.onClick,
      style = props.style,
      height = props.height,
      ingredients = __rest(props, ["className", "placeholder", "resize", "label", "value", "contrast", "textSize", "prePopulateStatus", "maxCharsAllowed", "disabled", "inputId", "status", "observer", "id", "_controlledState", "onChange", "onClick", "style", "height"]);

  var _g = __read(useState(inputId ? inputId : (id ? id : uuidv4()) + "-input"), 1),
      finalInputId = _g[0];

  var _h = __read(useState(''), 2),
      text = _h[0],
      setText = _h[1];

  var textAreaRef = useRef(null); // custom hooks

  var _j = __read(useTextFieldStatus(text, 'TextArea', status, maxCharsAllowed), 3),
      errorState = _j[0],
      setErrorState = _j[1],
      errorStateClass = _j[2];

  useTextFieldWarning('TextArea', _controlledState, onChange);
  var resizeClass = resize ? 'kxi-input-resize' : '';
  useEffect(function () {
    if (!_controlledState) {
      setText(value || '');
    }
  }, [value, _controlledState]);

  var handleTextAreaChange = function handleTextAreaChange(e) {
    var fireFunction = handleInput(disabled, _controlledState, e, setErrorState, setText, maxCharsAllowed, observer);

    if (fireFunction && onChange) {
      onChange(e);
    }
  };

  var inputValue = _controlledState ? value || '' : text;
  var contrastClass = "kxi-" + contrast + "-contrast";
  return jsxRuntime_2("div", _assign2({
    className: "kxi-input-outer-wrapper orca"
  }, {
    children: [jsxRuntime_1(Label, {
      contrast: contrast,
      label: label,
      inputId: finalInputId
    }, void 0), jsxRuntime_1("textarea", _assign2({
      style: _assign2(_assign2({}, style), {
        height: height
      }),
      ref: mergeRefs([textAreaRef, ref]),
      id: finalInputId,
      className: "kxi-input kxi-border " + contrastClass + " " + errorStateClass + " " + resizeClass + " " + (className || '') + " kxi-text-" + textSize,
      disabled: disabled,
      placeholder: placeholder,
      value: inputValue,
      onChange: handleTextAreaChange,
      "data-testid": "textArea",
      maxLength: !(maxCharsAllowed === null || maxCharsAllowed === void 0 ? void 0 : maxCharsAllowed.allowOvertype) ? maxCharsAllowed === null || maxCharsAllowed === void 0 ? void 0 : maxCharsAllowed.max : undefined
    }, ingredients, {
      onClick: function onClick(e) {
        if (textAreaRef === null || textAreaRef === void 0 ? void 0 : textAreaRef.current) {
          textAreaRef.current.select();
        }

        if (_onClick) _onClick(e);
      }
    }), void 0), jsxRuntime_1(ErrorStateUI, {
      prePopulateStatus: prePopulateStatus,
      errorStateClass: errorStateClass,
      contrastClass: contrastClass,
      errorState: errorState,
      maxCharsAllowed: maxCharsAllowed,
      disabled: disabled,
      text: text
    }, void 0)]
  }), void 0);
});

var AddTagBox = function AddTagBox(props) {
  var localization = props.localization,
      initialText = props.initialText,
      tagSearch = props.tagSearch,
      _a = props.canDelete,
      canDelete = _a === void 0 ? false : _a,
      onTextChange = props.onTextChange,
      onDeleteClick = props.onDeleteClick,
      onAddTagClick = props.onAddTagClick,
      textValue = props.textValue,
      maxSuggestions = props.maxSuggestions,
      suggestionsRef = props.suggestionsRef,
      inputRef = props.inputRef,
      disabled = props.disabled,
      status = props.status;

  var _b = __read(React__default.useState([]), 2),
      suggestions = _b[0],
      setSuggestions = _b[1];

  var _c = __read(React__default.useState({
    key: undefined,
    value: ''
  }), 2),
      customTag = _c[0],
      setCustomTag = _c[1];

  var _d = __read(React__default.useState(textValue || ''), 2),
      inputValue = _d[0],
      setInputValue = _d[1];

  React__default.useLayoutEffect(function () {
    if (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) {
      inputRef.current.focus();
    }
  }, [initialText]);
  var showDelete = canDelete && inputValue;
  var searchForTags = React__default.useMemo(function () {
    return debounce(function (value) {
      tagSearch && tagSearch(value).then(function (tags) {
        return setSuggestions(tags.map(function (t) {
          return {
            key: t.tagId,
            value: t.tag
          };
        }));
      });
    }, 350);
  }, []);
  React__default.useEffect(function () {
    if (tagSearch && document.activeElement === inputRef.current && customTag.key === undefined) {
      searchForTags(inputValue);
    }
  }, [inputValue]);

  var handleTextChange = function handleTextChange(e) {
    return __awaiter(void 0, void 0, void 0, function () {
      var value;
      return __generator(this, function (_a) {
        value = e.target.value;
        setInputValue(value);
        setCustomTag(function () {
          return {
            key: undefined,
            value: value
          };
        });
        if (onTextChange) onTextChange(value);
        return [2
        /*return*/
        ];
      });
    });
  };

  var handleAddClick = function handleAddClick() {
    if (customTag) onAddTagClick(customTag);
  };

  var handleSuggestionClick = function handleSuggestionClick(kvp) {
    setInputValue(kvp.value);
    setCustomTag(kvp);
    if (onTextChange) onTextChange(kvp.value);
  };

  return jsxRuntime_1("div", _assign2({
    className: "kxi-add-tag-box-position-set",
    ref: suggestionsRef
  }, {
    children: jsxRuntime_2("div", _assign2({
      className: "kxi-add-tag-box-outer " + (disabled ? 'kxi-add-tag-box-disabled' : '')
    }, {
      children: [jsxRuntime_1(InputField, {
        onChange: handleTextChange,
        _controlledState: true,
        ref: inputRef,
        value: inputValue,
        suggestions: suggestions,
        onFocus: function onFocus() {
          return searchForTags(inputValue);
        },
        onSuggestionClick: handleSuggestionClick,
        maxSuggestions: maxSuggestions,
        status: disabled ? status : undefined
      }, void 0), jsxRuntime_2("div", _assign2({
        className: "kxi-add-tag-box-button-div " + (showDelete ? 'kxi-add-tag-box-button-div-with-trash' : 'kxi-add-tag-box-button-div-without-trash')
      }, {
        children: [jsxRuntime_1(DefaultButton, {
          "data-testid": "addTagSave",
          buttonSize: "small",
          text: showDelete ? localization.save : localization.addConfirm,
          onClick: handleAddClick,
          disabled: !(inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) || disabled
        }, void 0), showDelete && jsxRuntime_1(IconButton, {
          icon: "trash",
          "data-testid": "addTagDelete",
          onClick: onDeleteClick
        }, void 0)]
      }), void 0)]
    }), void 0)
  }), void 0);
};

var Tags = function Tags(props) {
  var onTagUpdate = props.onTagUpdate,
      selectedTagInput = props.selectedTagInput,
      onTagClick = props.onTagClick,
      tags = props.tags,
      tagSearch = props.tagSearch,
      localization = props.localization,
      _a = props.showAddTag,
      showAddTag = _a === void 0 ? true : _a,
      maxSuggestions = props.maxSuggestions,
      className = props.className,
      shouldPreventExpressTag = props.shouldPreventExpressTag;
  var add = localization.add,
      cancel = localization.cancel,
      _b = localization.industryTagExistsError,
      industryTagExistsError = _b === void 0 ? 'This already exists as an Industry tag' : _b,
      _c = localization.expressTagExistsError,
      expressTagExistsError = _c === void 0 ? 'This already exists as an Express tag' : _c;

  var _d = __read(React__default.useState(false), 2),
      showAddTagDialog = _d[0],
      setShowAddTagDialog = _d[1];

  var _e = __read(React__default.useState(), 2),
      addTagDialogTagId = _e[0],
      setAddTagDialogTagId = _e[1];

  var _f = __read(React__default.useState(), 2),
      newTagId = _f[0],
      _setNewTagId = _f[1];

  var _g = __read(React__default.useState(''), 2),
      priorValue = _g[0],
      setPriorValue = _g[1];

  var _h = __read(React__default.useState(false), 2),
      existingUserTag = _h[0],
      setExistingUserTag = _h[1];

  var _j = __read(React__default.useState(false), 2),
      canDelete = _j[0],
      setCanDelete = _j[1];

  var _k = __read(React__default.useState(''), 2),
      textValue = _k[0],
      setTextValue = _k[1];

  var _l = __read(React__default.useState(''), 2),
      _ = _l[0],
      forceRerender = _l[1];

  var _m = __read(React__default.useState(false), 2),
      addTagDisabled = _m[0],
      setAddTagDisabled = _m[1];

  var _o = __read(React__default.useState(), 2),
      addTagStatus = _o[0],
      setAddTagStatus = _o[1];

  var _p = __read(React__default.useState(), 2),
      existingTagData = _p[0],
      setExistingTagData = _p[1];

  var inputRef = React__default.useRef(null);
  var suggestionsRef = React__default.useRef(null);
  var tagArrayRef = React__default.useRef([]);
  var newTagIdRef = React__default.useRef(newTagId);
  React__default.useEffect(function () {
    if (cancel) {
      warnIsDeprecated('ExperienceCard / Comment (Tags)', {
        'localization.cancel': {
          value: cancel
        }
      }, 'prop');
    }
  }, [cancel]);

  var setNewTagId = function setNewTagId(data) {
    newTagIdRef.current = data;

    _setNewTagId(data);
  };

  var updateTagArray = function updateTagArray(arr) {
    tagArrayRef.current = arr;
    forceRerender(uuidv4()); // Because TagArray is a ref we lose some of the auto updating abilities
  };

  React__default.useEffect(function () {
    if (tags) {
      var tempTagArr = tags.map(function (tag, i) {
        var _a;

        return _assign2(_assign2({}, tag), {
          selected: (_a = tagArrayRef.current[i]) === null || _a === void 0 ? void 0 : _a.selected,
          tagId: tag.tagId || '',
          _internalTagId: uuidv4()
        });
      });
      updateTagArray(tempTagArr);
    }
  }, [tags]);
  React__default.useEffect(function () {
    if (!showAddTagDialog) {
      setTextValue('');
    }
  }, [showAddTagDialog]);
  React__default.useEffect(function () {
    tagArrayRef.current.forEach(function (tag) {
      if (tag.tagId && (selectedTagInput === null || selectedTagInput === void 0 ? void 0 : selectedTagInput.includes(tag.tagId))) {
        tag.selected = true;
      } else {
        tag.selected = false;
      }
    });
  }, [JSON.stringify(selectedTagInput), JSON.stringify(tagArrayRef.current.filter(function (tag) {
    return !tag.userAdded;
  }).map(function (tag) {
    return tag.tagId;
  }))]);
  React__default.useEffect(function () {
    var tagIndex = tagArrayRef.current.findIndex(function (tag) {
      return tag._internalTagId === addTagDialogTagId && tag.userAdded;
    });

    if (tagIndex >= 0) {
      setTextValue(tagArrayRef.current[tagIndex].tagName);
    }
  }, [addTagDialogTagId]);
  React__default.useEffect(function () {
    setCanDelete(existingUserTag);
  }, [existingUserTag]);

  var addNewTag = function addNewTag() {
    if (!showAddTagDialog) {
      var newTagId_1 = uuidv4();

      var tempTagArray = __spreadArray([], __read(tagArrayRef.current));

      setAddTagDialogTagId(newTagId_1);
      tempTagArray.push({
        tagName: '',
        userAdded: true,
        tagId: '',
        _internalTagId: newTagId_1
      });
      updateTagArray(tempTagArray);
      setNewTagId(newTagId_1);
      setShowAddTagDialog(true);
    }
  };

  var onCancelClick = function onCancelClick() {
    var tempTagArray = __spreadArray([], __read(tagArrayRef.current));

    if (newTagId) {
      tempTagArray.pop();
    } else {
      var tagIndex = tempTagArray.findIndex(function (item) {
        return item._internalTagId === addTagDialogTagId && item.userAdded;
      });

      if (tagIndex >= 0) {
        tempTagArray[tagIndex].tagName = priorValue;
      }
    }

    updateTagArray(tempTagArray);
    setShowAddTagDialog(false);
    setExistingUserTag(false);
    setAddTagDialogTagId(undefined);
    setNewTagId(undefined);
  };

  var isTagDuplicate = function isTagDuplicate(tagText) {
    var duplicateTagIndex = tags.findIndex(function (tagItem) {
      return tagItem.tagName.toLowerCase() === tagText.toLowerCase() && !(existingUserTag && (existingTagData === null || existingTagData === void 0 ? void 0 : existingTagData.tagName.toLowerCase()) === tagText.toLowerCase());
    });
    var hasDuplicate = duplicateTagIndex >= 0;
    return {
      hasDuplicate: hasDuplicate,
      duplicateTag: hasDuplicate ? tags[duplicateTagIndex] : undefined,
      isIndustryTag: hasDuplicate ? !tags[duplicateTagIndex].userAdded : undefined
    };
  };

  var addTagDialogBox = jsxRuntime_1(AddTagBox, {
    initialText: addTagDialogTagId || '',
    tagSearch: tagSearch,
    inputRef: inputRef,
    suggestionsRef: suggestionsRef,
    disabled: addTagDisabled,
    status: addTagStatus,
    onTextChange: function onTextChange(e) {
      var tempTagArray = __spreadArray([], __read(tagArrayRef.current));

      var preventDisable;

      if (shouldPreventExpressTag) {
        preventDisable = shouldPreventExpressTag(e);
      }

      if (preventDisable === 'express' || preventDisable === 'industry') {
        setAddTagDisabled(true);
        setAddTagStatus({
          state: 'error',
          text: preventDisable === 'express' ? expressTagExistsError : industryTagExistsError
        });
      } else {
        var duplicateTag = isTagDuplicate(e);
        var shouldDisable = duplicateTag.hasDuplicate;
        setAddTagDisabled(shouldDisable);
        setAddTagStatus(shouldDisable ? {
          state: 'error',
          text: duplicateTag.isIndustryTag ? industryTagExistsError : expressTagExistsError
        } : undefined);
      }

      var tagIndex = tempTagArray.findIndex(function (item) {
        return item._internalTagId === addTagDialogTagId && item.userAdded;
      });
      var valueToAssign = e;
      setTextValue(valueToAssign);
      tempTagArray[tagIndex].tagName = valueToAssign;
      updateTagArray(tempTagArray);
    },
    onAddTagClick: function onAddTagClick(kvp) {
      var _a, _b, _c;

      var indexUpdated = tagArrayRef.current.findIndex(function (item) {
        return item._internalTagId === addTagDialogTagId && item.userAdded;
      });

      if (newTagId && newTagId !== ((_a = tagArrayRef.current[indexUpdated]) === null || _a === void 0 ? void 0 : _a._internalTagId)) {
        var tempTagArray = __spreadArray([], __read(tagArrayRef.current));

        tempTagArray.pop();
        updateTagArray(tempTagArray);
        if (onTagUpdate) onTagUpdate(tempTagArray, (_b = tagArrayRef.current[indexUpdated]) === null || _b === void 0 ? void 0 : _b.tagId);
      } else {
        if (onTagUpdate) onTagUpdate(tagArrayRef.current, (_c = tagArrayRef.current[indexUpdated]) === null || _c === void 0 ? void 0 : _c.tagId);
      }

      setShowAddTagDialog(false);
      setAddTagDialogTagId(undefined);
      setNewTagId(undefined);
      setExistingUserTag(false);
    },
    canDelete: canDelete,
    onDeleteClick: function onDeleteClick() {
      var indexToDelete = tagArrayRef.current.findIndex(function (item) {
        return item._internalTagId === addTagDialogTagId && item.userAdded;
      });

      if (indexToDelete >= 0) {
        var tempTagArray = __spreadArray([], __read(tagArrayRef.current));

        tempTagArray.splice(indexToDelete, 1);
        if (onTagUpdate) onTagUpdate(tempTagArray, tagArrayRef.current[indexToDelete].tagId);
        updateTagArray(tempTagArray);
        setShowAddTagDialog(false);
        setAddTagDialogTagId(undefined);
        setNewTagId(undefined);
        setExistingUserTag(false);
      }
    },
    localization: localization,
    textValue: textValue,
    maxSuggestions: maxSuggestions
  }, void 0);

  var handleTagClick = function handleTagClick(tag) {
    if (onTagClick) onTagClick(tag);

    if (tag.userAdded) {
      setExistingUserTag(true);
      setExistingTagData(tag);
      setTextValue(tag.tagName);
      setShowAddTagDialog(true);
      setAddTagDialogTagId(tag._internalTagId);
      setPriorValue(tag.tagName);
    } else {
      var tempTagArray = __spreadArray([], __read(tagArrayRef.current));

      var indexToSelect = tempTagArray.findIndex(function (item) {
        return item._internalTagId === tag._internalTagId;
      });

      if (indexToSelect >= 0) {
        tempTagArray[indexToSelect].selected = !tag.selected;
        updateTagArray(tempTagArray);
      }

      setShowAddTagDialog(false);
      setExistingUserTag(false);
      setExistingTagData(undefined);
      setAddTagDialogTagId(undefined);
      forceRerender(uuidv4());
      onCancelClick();
    }
  };

  React__default.useLayoutEffect(function () {
    var handleOutsideClick = function handleOutsideClick(e) {
      var _a;

      if (((_a = suggestionsRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) === false) {
        var tempTagArray = __spreadArray([], __read(tagArrayRef.current));

        if (newTagIdRef.current) {
          tempTagArray.pop();
        } else {
          var tagIndex = tempTagArray.findIndex(function (item) {
            return item._internalTagId === addTagDialogTagId && item.userAdded;
          });

          if (tagIndex >= 0) {
            tempTagArray[tagIndex].tagName = priorValue;
          }
        }

        updateTagArray(tempTagArray);
        setShowAddTagDialog(false);
        setExistingUserTag(false);
        setAddTagDialogTagId(undefined);
        setNewTagId(undefined);
        setAddTagDisabled(false);
        setAddTagStatus(undefined);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return function () {
      return document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [addTagDisabled, priorValue]);
  var displayedTabArray = tagArrayRef.current.map(function (tag) {
    return jsxRuntime_2("div", _assign2({
      className: "kxi-tag-object-wrapper"
    }, {
      children: [jsxRuntime_1(TagItem, _assign2({
        onTagClick: handleTagClick
      }, tag), void 0), tag._internalTagId && tag._internalTagId === addTagDialogTagId ? addTagDialogBox : undefined]
    }), tag.tagId || tag._internalTagId);
  });
  return jsxRuntime_2("div", _assign2({
    className: "kxi-tag-wrapper " + (className || '')
  }, {
    children: [displayedTabArray, showAddTag ? jsxRuntime_2(jsxRuntime_3, {
      children: [jsxRuntime_1("div", _assign2({
        className: "kxi-tag-add-tag-outer-wrapper"
      }, {
        children: jsxRuntime_1("div", _assign2({
          className: "kxi-tag-add-tag-inner-wrapper"
        }, {
          children: jsxRuntime_1(DefaultButton, {
            color: "orca",
            className: "kxi-tag-add-tag-button",
            disabled: !!newTagId,
            text: add,
            isIconLeft: true,
            icon: newTagId ? 'add_circle_filled' : 'add_circle',
            fill: "text",
            onClick: function onClick() {
              return addNewTag();
            },
            "data-testid": "addTagButton"
          }, void 0)
        }), void 0)
      }), void 0), addTagDialogTagId === undefined && showAddTagDialog ? addTagDialogBox : undefined]
    }, void 0) : undefined]
  }), void 0);
};

var getConfidenceAsPercent = function getConfidenceAsPercent(value, displayPercentSign) {
  if (displayPercentSign === void 0) {
    displayPercentSign = true;
  }

  if (value || value === 0) {
    return Number.isInteger(value) ? "" + value + (displayPercentSign ? '%' : '') : "" + Math.floor(value * 100) + (displayPercentSign ? '%' : '');
  }
};
/**
 * This function is the brains of this comment text component. It takes an array of
 * separators and then splices them together chopping and splicing where needed. It
 * mutates the choppedSeparators array (which should be initialized with a text component)
 * and makes it into a fully congruent, non-overlapping array of separators. Each
 * separator has its own tagIds, sentimentIds, and highlighting
 */


var spliceChop = function spliceChop(choppedSeparators, separator, hasWarned, setHasWarned) {
  var separatorToChopIndex = choppedSeparators.findIndex(function (cs) {
    return cs.begin <= separator.begin && cs.end > separator.begin || cs.begin < separator.begin && cs.end >= separator.end;
  });

  if (separatorToChopIndex === -1 && !hasWarned) {
    //intentionally not dev only
    console.warn('The Kitchen: Experience Card Comment - Comment data contains invalid begin or end indexes');

    if (setHasWarned) {
      setHasWarned(true);
    }
  }

  while (separatorToChopIndex >= 0) {
    var separatorToChop = choppedSeparators[separatorToChopIndex];
    var beginSeparator = undefined;
    var endSeparator = undefined;

    if ((separatorToChop === null || separatorToChop === void 0 ? void 0 : separatorToChop.begin) < separator.begin) {
      beginSeparator = _assign2({}, separatorToChop);
      beginSeparator.end = separator.begin;
    }

    var middleSeparator = _assign2({}, separatorToChop);

    middleSeparator.tagIds = middleSeparator.tagIds.concat(separator.tagIds);
    middleSeparator.sentimentIds = middleSeparator.sentimentIds.concat(separator.sentimentIds);
    middleSeparator.highlighted = middleSeparator.highlighted || separator.highlighted;
    middleSeparator.begin = separator.begin;

    if (separatorToChop.end > separator.end) {
      middleSeparator.end = separator.end;
      endSeparator = _assign2({}, separatorToChop);
      endSeparator.begin = separator.end;
    } else if (separatorToChop.end !== separator.end) {
      middleSeparator.end = separatorToChop.end;
      endSeparator = _assign2({}, separator);
      endSeparator.begin = separatorToChop.end;
    }

    choppedSeparators.splice(separatorToChopIndex, 1);
    if (beginSeparator) choppedSeparators.push(beginSeparator);
    if (middleSeparator) choppedSeparators.push(middleSeparator);

    if (endSeparator) {
      if (endSeparator.end <= separator.end) {
        separator = _assign2({}, endSeparator);
        separatorToChopIndex = choppedSeparators.findIndex(function (cs) {
          return cs.begin <= separator.begin && cs.end > separator.begin;
        });
      } else {
        choppedSeparators.push(endSeparator);
        separatorToChopIndex = -1;
      }
    } else {
      separatorToChopIndex = -1;
    }
  }
};

var CommentText = function CommentText(props) {
  var externalId = props.externalId,
      sentimentAnnotations = props.sentimentAnnotations,
      localization = props.localization,
      text = props.text,
      activeTagsInput = props.activeTags,
      combinedTagsInput = props.combinedTags,
      activeSentiments = props.activeSentiments,
      highlightedText = props.highlightedText;

  var mapTagToCombinedTag = function mapTagToCombinedTag(tagInput) {
    return tagInput.map(function (tag) {
      var _a;

      if (tag.id) {
        //if the tag is a `Tag` type transform it into the `combined tag` type
        return {
          tagName: tag.label,
          sentiment: tag.sentiment,
          userAdded: tag.userAdded,
          tagId: tag.id,
          positions: (_a = tag.highlighting) === null || _a === void 0 ? void 0 : _a.map(function (highlight) {
            return {
              beginIndex: highlight.beginIndex,
              endIndex: highlight.endIndex,
              sentimentType: 'tag'
            };
          })
        };
      } else {
        return tag;
      }
    });
  };

  var _a = __read(useState(), 2),
      boxElement = _a[0],
      setBoxElement = _a[1];

  var _b = __read(useState(), 2),
      commentText = _b[0],
      setCommentText = _b[1];

  var _c = __read(useState(undefined), 2),
      activeSentimentId = _c[0],
      setActiveSentimentId = _c[1];

  var _d = __read(useState([]), 2),
      textSlices = _d[0],
      setTextSlices = _d[1];

  var _e = __read(useState([]), 2),
      highlights = _e[0],
      setHighlights = _e[1];

  var _f = __read(useState(false), 2),
      hasWarned = _f[0],
      setHasWarned = _f[1];

  var _g = __read(useState(mapTagToCombinedTag(activeTagsInput)), 2),
      activeTags = _g[0],
      setActiveTags = _g[1];

  var _h = __read(useState(mapTagToCombinedTag(combinedTagsInput)), 2),
      combinedTags = _h[0],
      setCombinedTags = _h[1];

  useEffect(function () {
    setActiveTags(mapTagToCombinedTag(activeTagsInput));
    setCombinedTags(mapTagToCombinedTag(combinedTagsInput));
  }, [activeTagsInput, combinedTagsInput]);
  useEffect(function () {
    if (!highlightedText) {
      setHighlights([]);
      return;
    }

    var rawText = text;
    var delimiter = uuidv4();
    var highlightedTextArr = !Array.isArray(highlightedText) ? [highlightedText.trim()] : __spreadArray([], __read(highlightedText)).map(function (x) {
      return x.trim();
    });
    highlightedTextArr = highlightedTextArr.map(function (value) {
      return escapeRegex(value);
    }); // look for any of the highlighted search words within the raw text

    var regex = new RegExp("(" + highlightedTextArr.join('|') + ")", 'gi');
    var foundLetters = rawText.replace(regex, delimiter + "$1" + delimiter).split(delimiter);
    var newHighlights = foundLetters.map(function (item, i) {
      if (highlightedTextArr.find(function (text) {
        return text.toLowerCase() === escapeRegex(item).toLowerCase();
      })) {
        //count indexes up to the beginning point
        var begin = foundLetters.reduce(function (prev, curr, index) {
          if (index < i) {
            return prev + curr.length;
          }

          return prev;
        }, 0);
        return {
          begin: begin,
          end: begin + item.length
        };
      }
    }).filter(function (item) {
      return item;
    });
    setHighlights(newHighlights);
  }, [highlightedText]);
  useEffect(function () {
    var sentimentBoxPosition = getSentimentBoxPosition();

    if (!sentimentAnnotations) {
      setBoxElement(undefined);
      return;
    }

    var selectedSentimentIndex = sentimentAnnotations.findIndex(function (sentiment) {
      return sentiment.sentimentId === activeSentimentId;
    });

    if (selectedSentimentIndex < 0) {
      setBoxElement(undefined);
      return;
    }

    var _a = sentimentAnnotations[selectedSentimentIndex],
        sentimentConfidence = _a.sentimentConfidence,
        sentimentScore = _a.sentimentScore;
    var hasSentiment = Number.isFinite(sentimentScore);
    var hasConfidence = Number.isFinite(sentimentConfidence);
    var boxElement = jsxRuntime_2("div", _assign2({
      className: "kxi-comment-text-box",
      style: {
        top: sentimentBoxPosition.top,
        left: sentimentBoxPosition.left,
        visibility: sentimentBoxPosition.visibility
      },
      "data-testid": "comment-sentiment-box"
    }, {
      children: [hasSentiment ? jsxRuntime_1("div", _assign2({
        className: "kxi-comment-text-box-inner-text"
      }, {
        children: localization.sentimentScore + ": " + sentimentAnnotations[selectedSentimentIndex].sentimentScore
      }), void 0) : null, hasConfidence ? jsxRuntime_1("div", _assign2({
        className: "kxi-comment-text-box-inner-text"
      }, {
        children: localization.confidenceLevel + ": " + getConfidenceAsPercent(sentimentConfidence)
      }), void 0) : null]
    }), void 0);
    setBoxElement(!hasSentiment && !hasConfidence ? null : boxElement);
  }, [commentText]);
  useEffect(function () {
    formatText();
  }, [textSlices, activeSentimentId, activeTags]);
  useEffect(function () {
    setTextSlices(chopText());
  }, [text, sentimentAnnotations, combinedTags, activeTags, activeSentiments, highlights]);

  var getSentimentBoxPosition = function getSentimentBoxPosition() {
    var defaultRetVal = {
      left: 0,
      visibility: 'hidden',
      top: 0
    };
    var commentRoot = document.getElementById(externalId);

    if (!commentRoot) {
      return defaultRetVal;
    }

    var selectedSentimentDivLefts = Array.from(commentRoot.querySelectorAll('.kxi-comment-text-active')).map(function (item) {
      var _a;

      return item.getBoundingClientRect().left - (((_a = item.parentElement) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().left) || 0);
    });

    if (selectedSentimentDivLefts.length === 0) {
      return defaultRetVal;
    }

    var left = selectedSentimentDivLefts.reduce(function (a, b) {
      return a < b ? a : b;
    });
    var selectedSentimentDivBottoms = Array.from(commentRoot.querySelectorAll('.kxi-comment-text-active')).map(function (item) {
      var _a;

      return item.getBoundingClientRect().bottom - (((_a = item.parentElement) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().top) || 0);
    });

    if (selectedSentimentDivBottoms.length === 0) {
      return defaultRetVal;
    }

    var top = selectedSentimentDivBottoms.reduce(function (a, b) {
      return a < b ? b : a;
    });
    return {
      left: left,
      top: top,
      visibility: 'visible'
    };
  };
  /**
   * This function is the brains of this component. It adds each individual piece into an
   * array with begin and end indexes per tag/sentiment/highlighting. It then takes those
   * separators and chops them up and combines them (spliceChop function). Finally it
   * chops the text and adds it to each chopped section and then sorts by begin index to
   * get the text in the correct order.
   */


  var chopText = function chopText() {
    var tagPositions = [];
    combinedTags.map(function (tag) {
      if (tag.positions) {
        tag.positions.map(function (position) {
          tagPositions.push({
            tagId: tag.tagId,
            begin: position.beginIndex,
            end: position.endIndex
          });
        });
      }
    });
    var separators = [];
    tagPositions.forEach(function (position) {
      separators.push({
        tagIds: [position.tagId],
        sentimentIds: [],
        highlighted: false,
        begin: position.begin,
        end: position.end
      });
    });
    sentimentAnnotations === null || sentimentAnnotations === void 0 ? void 0 : sentimentAnnotations.forEach(function (sentimentAnnotation) {
      separators.push({
        tagIds: [],
        sentimentIds: [sentimentAnnotation.sentimentId],
        highlighted: false,
        begin: sentimentAnnotation.beginIndex,
        end: sentimentAnnotation.endIndex
      });
    });
    highlights.forEach(function (highlight) {
      separators.push({
        tagIds: [],
        sentimentIds: [],
        highlighted: true,
        begin: highlight.begin,
        end: highlight.end
      });
    });
    var choppedSeparators = [{
      tagIds: [],
      sentimentIds: [],
      highlighted: false,
      begin: 0,
      end: text.length
    }];
    separators.forEach(function (separator) {
      spliceChop(choppedSeparators, separator, hasWarned, setHasWarned);
    });
    var choppedText = [];
    choppedSeparators.forEach(function (separator) {
      choppedText.push(_assign2(_assign2({}, separator), {
        text: text.substring(separator.begin, separator.end)
      }));
    });
    return choppedText.sort(function (a, b) {
      return a.begin - b.begin;
    });
  };

  var getTextClass = function getTextClass(slice) {
    var textClass = 'kxi-comment-text-item ';
    textClass += slice.highlighted ? 'kxi-comment-highlighted ' : '';
    var activeSentimentDisplay = activeSentiments.filter(function (sentiment) {
      return slice.sentimentIds.includes(sentiment.sentimentId);
    });

    if (slice.tagIds.length === 0) {
      if (sentimentAnnotations) {
        activeSentimentDisplay.forEach(function (sentiment) {
          textClass += "kxi-comment-text-has-sentiment kxi-" + SentimentEnum[sentiment.sentiment] + " ";
        });
      }
    } else {
      if (activeTags.filter(function (activeTag) {
        return activeTag.tagId && slice.tagIds.includes(activeTag.tagId);
      }).length > 0) {
        textClass += 'kxi-tag-selected ';
      } else {
        textClass += 'kxi-tag ';
      }
    }

    if (activeSentimentId && slice.sentimentIds.includes(activeSentimentId)) {
      textClass += 'kxi-comment-text-active ';

      if (sentimentAnnotations) {
        activeSentimentDisplay.forEach(function (sentiment) {
          textClass += "kxi-" + SentimentEnum[sentiment.sentiment] + " ";
        });
      }
    }

    return textClass;
  };

  var formatText = function formatText() {
    var textElements = [];
    textSlices.forEach(function (slice) {
      var id = uuidv4();
      var element = jsxRuntime_1("div", _assign2({
        className: getTextClass(slice),
        id: uuidv4(),
        onMouseEnter: function onMouseEnter() {
          //if the text is part of an active sentiment then highlight it
          if (activeSentiments.filter(function (sentiment) {
            return slice.sentimentIds.includes(sentiment.sentimentId);
          }).length > 0) {
            setActiveSentimentId(slice.sentimentIds ? activeSentiments.filter(function (sentiment) {
              var _a;

              return (_a = slice.sentimentIds) === null || _a === void 0 ? void 0 : _a.includes(sentiment.sentimentId);
            })[0].sentimentId : undefined);
          }
        },
        onMouseLeave: function onMouseLeave() {
          setActiveSentimentId(undefined);
        }
      }, {
        children: slice.text
      }), 'text-slice-' + id);
      textElements.push(slice.highlighted ? jsxRuntime_2("mark", {
        children: [" ", element]
      }, 'text-slice-mark' + id) : element);
    });
    setCommentText(jsxRuntime_1("div", {
      children: textElements
    }, void 0));
  };

  return jsxRuntime_1("div", _assign2({
    className: "kxi-comment-text"
  }, {
    children: jsxRuntime_2("div", _assign2({
      className: "kxi-comment-text-wrapper"
    }, {
      children: [jsxRuntime_1("div", _assign2({
        className: "kxi-comment-text-box-wrapper"
      }, {
        children: boxElement
      }), void 0), jsxRuntime_1("div", _assign2({
        className: "kxi-visible-text"
      }, {
        children: commentText
      }), void 0)]
    }), void 0)
  }), void 0);
};

var GenericModalProps = function (_super) {
  __extends(GenericModalProps, _super);

  function GenericModalProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Boolean)], GenericModalProps.prototype, "allowPropagation");

  __decorate([Bound(), __metadata("design:type", Boolean)], GenericModalProps.prototype, "isVisualModal");

  __decorate([Bound(), __metadata("design:type", String)], GenericModalProps.prototype, "contrast");

  __decorate([Bound(), __metadata("design:type", Boolean)], GenericModalProps.prototype, "fullScreen");

  __decorate([Bound(), __metadata("design:type", Boolean)], GenericModalProps.prototype, "isVisible");

  __decorate([Bound(), __metadata("design:type", Boolean)], GenericModalProps.prototype, "isCancelVisible");

  __decorate([Bound(), __metadata("design:type", Boolean)], GenericModalProps.prototype, "canScrimClose");

  __decorate([Bound(), __metadata("design:type", Boolean)], GenericModalProps.prototype, "canBackdropClose");

  __decorate([Bound(), __metadata("design:type", String)], GenericModalProps.prototype, "targetElement");

  return GenericModalProps;
}(ObservablePropsMixin(DivHTMLAttributes));

var GenericModalEvents = function () {
  function GenericModalEvents() {}

  __decorate([Bound(), __metadata("design:type", Function)], GenericModalEvents.prototype, "onClose");

  return GenericModalEvents;
}();
/**
 * Description: Modal used for overlaying page, and displaying anything. Only has a background on contrast=high.
 */


var GenericModal = /*#__PURE__*/forwardRef(function (props, ref) {
  var _a = props.fullScreen,
      fullScreen = _a === void 0 ? false : _a,
      _b = props.contrast,
      contrast = _b === void 0 ? 'normal' : _b,
      _c = props.isCancelVisible,
      isCancelVisible = _c === void 0 ? true : _c,
      _d = props.isVisible,
      isVisible = _d === void 0 ? false : _d,
      onClose = props.onClose,
      observer = props.observer,
      hasTranscludedContent = props.hasTranscludedContent,
      hasTranscluded = props.hasTranscluded,
      resetTransclusion = props.resetTransclusion,
      transclude = props.transclude,
      _e = props.allowPropagation,
      allowPropagation = _e === void 0 ? false : _e,
      _f = props.isVisualModal,
      isVisualModal = _f === void 0 ? false : _f,
      _g = props.canScrimClose,
      canScrimClose = _g === void 0 ? false : _g,
      _h = props.canBackdropClose,
      canBackdropClose = _h === void 0 ? true : _h,
      targetElement = props.targetElement,
      ingredients = __rest(props, ["fullScreen", "contrast", "isCancelVisible", "isVisible", "onClose", "observer", "hasTranscludedContent", "hasTranscluded", "resetTransclusion", "transclude", "allowPropagation", "isVisualModal", "canScrimClose", "canBackdropClose", "targetElement"]);

  var _j = __read(useState(isVisible), 2),
      visibility = _j[0],
      setVisibility = _j[1];

  var targetOverlayRef = useRef(null);
  var modalRef = useRef(null);
  useEffect(function () {
    if (visibility === 'fading') {
      if (targetElement && targetOverlayRef.current) {
        targetOverlayRef.current.style.opacity = '0';
      } else if (modalRef.current) {
        modalRef.current.style.opacity = '0';
      }

      setTimeout(function () {
        setVisibility(false);
      }, 400);
    }
  }, [visibility, targetElement]);
  useEffect(function () {
    throwPropErrorMessage('GenericModal', {
      isVisible: isVisible
    });

    if (!isVisible && visibility) {
      setVisibility('fading');
    } else {
      setVisibility(isVisible);
    }

    if (isVisible && transclude) {
      setTimeout(function () {
        transclude();
      }, 1);
    }
  }, [isVisible]);

  var handleClick = function handleClick() {
    if (onClose) {
      onClose();
    }

    setVisibility('fading');

    if (observer) {
      observer.isVisible = false;
    }
  };

  var modal = jsxRuntime_1("div", _assign2({
    role: "dialog",
    "aria-hidden": visibility === false,
    className: "kxi-grey-overlay kxi-generic-modal",
    onClick: function onClick() {
      if (canBackdropClose) {
        handleClick();
      }
    },
    "data-testid": "backdrop"
  }, {
    children: jsxRuntime_2("div", _assign2({
      className: (fullScreen ? 'kxi-generic-modal-fullscreen' : '') + " " + (contrast === 'high' ? 'kxi-high-contrast' : '') + " kxi-modal-container",
      onClick: function onClick(e) {
        if (!allowPropagation) {
          e.stopPropagation();
        }

        if (canScrimClose) {
          handleClick();
        }
      },
      ref: ref
    }, ingredients, {
      "data-testid": "modal-container"
    }, {
      children: [isCancelVisible ? jsxRuntime_1("div", {
        children: isVisualModal ? jsxRuntime_1("div", _assign2({
          role: "button",
          className: "kxi-grey kxi-generic-modal-x-visual",
          onClick: handleClick
        }, {
          children: jsxRuntime_1(XIIcon, {
            icon: "cancel"
          }, void 0)
        }), void 0) : jsxRuntime_1(IconButton, {
          buttonSize: "normal",
          onClick: handleClick,
          icon: "cancel",
          contrast: "normal",
          hasAnimation: false,
          "data-testid": "close-icon",
          className: (contrast === 'high' ? 'kxi-generic-modal-contrast-high-button' : 'kxi-generic-modal-x kxi-high-contrast') + " "
        }, void 0)
      }, void 0) : '', visibility ? props.children ? props.children : jsxRuntime_1(Slot, {
        propsToWatch: [],
        resetTransclusion: resetTransclusion,
        hasTranscluded: hasTranscluded,
        hasTranscludedContent: hasTranscludedContent,
        "data-testid": "slot",
        name: "children"
      }, void 0) : null]
    }), void 0)
  }), void 0);

  var createPartialPortal = function createPartialPortal(content, target) {
    var targetElement = document.querySelector(target);

    if (!targetElement) {
      return null;
    }

    var targetBounds = targetElement.getBoundingClientRect();
    var newContent = jsxRuntime_1("div", _assign2({
      id: "kxi-xi-generic-modal",
      className: "kxi-generic-modal-partial-portal",
      ref: targetOverlayRef,
      style: {
        top: targetBounds.top + document.documentElement.scrollTop,
        left: targetBounds.left + document.documentElement.scrollLeft,
        right: targetBounds.right + document.documentElement.scrollLeft,
        bottom: targetBounds.bottom + document.documentElement.scrollTop,
        height: visibility ? targetBounds.height : 0,
        width: visibility ? targetBounds.width : 0,
        opacity: visibility ? 1 : 0,
        visibility: visibility ? 'initial' : 'hidden'
      }
    }, {
      children: content
    }), void 0);
    return /*#__PURE__*/createPortal(newContent, document.body);
  };

  return targetElement ? createPartialPortal(modal, targetElement) : jsxRuntime_1("div", _assign2({
    className: "kxi-generic-modal-partial-portal kxi-generic-modal-base",
    id: "kxi-xi-generic-modal",
    style: visibility ? undefined : {
      visibility: 'hidden',
      height: 0,
      width: 0,
      opacity: 0
    },
    ref: modalRef
  }, {
    children: modal
  }), void 0);
});

var ImageCarouselItem = function ImageCarouselItem(props) {
  var images = props.images,
      onImagePress = props.onImagePress,
      _a = props.activeIndex,
      activeIndexInput = _a === void 0 ? 0 : _a,
      _b = props.isLarge,
      isLarge = _b === void 0 ? false : _b,
      preventDefault = props.preventDefault; // how many px from the left or right the animation begins/ends with the slide fade.

  var presenceFrom = 46;

  var _c = __read(React__default.useState(activeIndexInput), 2),
      activeIndex = _c[0],
      setActiveIndex = _c[1];

  var _d = __read(React__default.useState(false), 2),
      goingBackwards = _d[0],
      setGoingBackwards = _d[1]; // Bind and unbind events


  React__default.useEffect(function () {
    if (!preventDefault) {
      window.addEventListener('keyup', keyPress);
      return function () {
        window.removeEventListener('keyup', keyPress);
      };
    }
  }, [goingBackwards, activeIndex, preventDefault]);

  var keyPress = function keyPress(event) {
    if (event.keyCode === 39) {
      rightArrowPress();
    } else if (event.keyCode === 37) {
      leftArrowPress();
    }
  };

  React__default.useEffect(function () {
    if (activeIndexInput !== undefined) setActiveIndex(activeIndexInput);
  }, [activeIndexInput]);
  var indicators = images.map(function (_item, index) {
    return jsxRuntime_1("div", {
      className: activeIndex === index ? 'kxi-image-carousel-indicator-active' : 'kxi-image-carousel-indicator-inactive',
      onClick: function onClick() {
        setGoingBackwards(index < activeIndex);
        setActiveIndex(index);
      },
      "data-testid": "image-carousel-indicator-" + index
    }, "image-carousel-indicator-" + index);
  });

  var leftArrowPress = function leftArrowPress() {
    setGoingBackwards(true);
    setActiveIndex(images.length > 0 ? activeIndex > 0 ? activeIndex - 1 : images.length - 1 : 0);
  };

  var rightArrowPress = function rightArrowPress() {
    setGoingBackwards(false);
    setActiveIndex(images.length > 0 ? activeIndex < images.length - 1 ? activeIndex + 1 : 0 : 0);
  };

  return jsxRuntime_2("div", _assign2({
    className: "kxi-image-carousel-wrapper " + (isLarge ? 'kxi-image-carousel-wrapper-large' : '')
  }, {
    children: [jsxRuntime_2("div", _assign2({
      className: "kxi-image-carousel-row-wrapper " + (isLarge ? 'kxi-image-carousel-row-wrapper-large' : '')
    }, {
      children: [jsxRuntime_1("div", _assign2({
        className: "kxi-image-carousel-arrow kxi-image-carousel-arrow-left"
      }, {
        children: jsxRuntime_1(IconButton, {
          icon: "single_arrow_left",
          onClick: leftArrowPress
        }, void 0)
      }), void 0), jsxRuntime_1("div", _assign2({
        className: "kxi-image-carousel-image-size" + (isLarge ? '-large' : '') + " kxi-image-carousel-image-wrapper"
      }, {
        children: jsxRuntime_1(AnimatePresence, {
          children: jsxRuntime_1(motion.img, {
            initial: {
              x: goingBackwards ? presenceFrom * -1 : presenceFrom,
              opacity: 0
            },
            animate: {
              x: 0,
              opacity: 1
            },
            exit: {
              x: goingBackwards ? presenceFrom : presenceFrom * -1,
              opacity: 0
            },
            transition: {
              ease: 'easeInOut',
              duration: 0.5
            },
            className: "kxi-image-carousel-image-size" + (isLarge ? '-large kxi-image-carousel-image-large' : '') + " kxi-image-carousel-image",
            src: images[activeIndex],
            onClick: function onClick() {
              if (onImagePress) onImagePress(images[activeIndex]);
            }
          }, "image-carousel-" + activeIndex)
        }, void 0)
      }), void 0), jsxRuntime_1("div", _assign2({
        className: "kxi-image-carousel-arrow kxi-image-carousel-arrow-right"
      }, {
        children: jsxRuntime_1(IconButton, {
          icon: "single_arrow_right",
          onClick: rightArrowPress
        }, void 0)
      }), void 0)]
    }), void 0), jsxRuntime_1("div", _assign2({
      className: "kxi-image-carousel-indicator-wrapper"
    }, {
      children: indicators
    }), void 0)]
  }), void 0);
};

var ImageCarouselProps = function (_super) {
  __extends(ImageCarouselProps, _super);

  function ImageCarouselProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Array)], ImageCarouselProps.prototype, "images");

  __decorate([Bound(), __metadata("design:type", Number)], ImageCarouselProps.prototype, "activeIndex");

  __decorate([Bound(), __metadata("design:type", String)], ImageCarouselProps.prototype, "indicatorColor");

  __decorate([Bound(), __metadata("design:type", Object)], ImageCarouselProps.prototype, "genericModalProps");

  return ImageCarouselProps;
}(DivHTMLAttributes);

var ImageCarouselEvents = function (_super) {
  __extends(ImageCarouselEvents, _super);

  function ImageCarouselEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], ImageCarouselEvents.prototype, "onImagePress");

  return ImageCarouselEvents;
}(DivHTMLEvents);
/**
 * Description: Convenient Carousel to display all your favorite images.
 */


var ImageCarousel = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var images = props.images,
      _a = props.indicatorColor,
      indicatorColor = _a === void 0 ? 'orca' : _a,
      _onImagePress = props.onImagePress,
      genericModalProps = props.genericModalProps,
      ingredients = __rest(props, ["images", "indicatorColor", "onImagePress", "genericModalProps"]);

  var _b = __read(React__default.useState(false), 2),
      isModalOpen = _b[0],
      setIsModalOpen = _b[1];

  var _c = __read(React__default.useState(0), 2),
      modalActiveImage = _c[0],
      setModalActiveImage = _c[1];

  throwPropErrorMessage('ImageCarousel', {
    images: images
  });
  return jsxRuntime_2("div", _assign2({}, ingredients, {
    className: "" + normalizeColor(indicatorColor),
    ref: ref
  }, {
    children: [jsxRuntime_1(ImageCarouselItem, {
      images: images,
      onImagePress: function onImagePress(image) {
        setIsModalOpen(true);
        var activeImage = images.findIndex(function (item) {
          return item === image;
        });
        activeImage = activeImage >= 0 ? activeImage : 0;
        setModalActiveImage(activeImage);

        if (_onImagePress) {
          _onImagePress(image);
        }
      },
      preventDefault: isModalOpen
    }, void 0), jsxRuntime_1(GenericModal, _assign2({}, genericModalProps, {
      contrast: "high",
      isVisible: isModalOpen,
      fullScreen: true,
      onClose: function onClose() {
        return setIsModalOpen(false);
      }
    }, {
      children: jsxRuntime_1(ImageCarouselItem, {
        images: images,
        activeIndex: modalActiveImage,
        onImagePress: function onImagePress(image) {
          setIsModalOpen(false);

          if (_onImagePress) {
            _onImagePress(image);
          }
        },
        isLarge: true
      }, void 0)
    }), void 0)]
  }), void 0);
});
var white$1 = XIColors.white,
    orca$1 = XIColors.orca;
var colorDisabled$1 = XIColorUsage.colorDisabled;

var SliderProps = function (_super) {
  __extends(SliderProps, _super);

  function SliderProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Number)], SliderProps.prototype, "min");

  __decorate([Bound(), __metadata("design:type", Number)], SliderProps.prototype, "max");

  __decorate([Bound(), __metadata("design:type", String)], SliderProps.prototype, "color");

  __decorate([Bound(), __metadata("design:type", String)], SliderProps.prototype, "contrast");

  __decorate([Bound(), __metadata("design:type", Boolean)], SliderProps.prototype, "disabled");

  __decorate([Bound(), __metadata("design:type", Object)], SliderProps.prototype, "value");

  __decorate([Bound(), __metadata("design:type", String)], SliderProps.prototype, "unit");

  __decorate([Bound(), __metadata("design:type", String)], SliderProps.prototype, "data-qa");

  __decorate([Bound(), __metadata("design:type", Object)], SliderProps.prototype, "endLabels");

  __decorate([Bound(), __metadata("design:type", Number)], SliderProps.prototype, "increment");

  __decorate([Bound(), __metadata("design:type", Object)], SliderProps.prototype, "inflection");

  __decorate([Bound(), __metadata("design:type", Boolean)], SliderProps.prototype, "displayCurrentPosition");

  return SliderProps;
}(ObservableProps);

var SliderEvents = function (_super) {
  __extends(SliderEvents, _super);

  function SliderEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], SliderEvents.prototype, "onSliderChange");

  return SliderEvents;
}(DivHTMLEvents);
/**
 * Description: Range slider allowing you to get input as a number / range of numbers.
 */


var Slider = /*#__PURE__*/forwardRef(function (props, ref) {
  var _a, _b, _c, _d;

  var _e = props.min,
      min = _e === void 0 ? 0 : _e,
      _f = props.max,
      max = _f === void 0 ? 100 : _f,
      _g = props.unit,
      unit = _g === void 0 ? '' : _g,
      type = props.type,
      _h = props.color,
      color = _h === void 0 ? 'CX' : _h,
      onSliderChange = props.onSliderChange,
      _j = props.contrast,
      contrast = _j === void 0 ? 'normal' : _j,
      className = props.className,
      observer = props.observer,
      disabled = props.disabled,
      value = props.value,
      endLabels = props.endLabels,
      _k = props.displayCurrentPosition,
      displayCurrentPosition = _k === void 0 ? true : _k,
      inflection = props.inflection,
      _l = props.increment,
      increment = _l === void 0 ? 1 : _l,
      ingredients = __rest(props, ["min", "max", "unit", "type", "color", "onSliderChange", "contrast", "className", "observer", "disabled", "value", "endLabels", "displayCurrentPosition", "inflection", "increment"]);

  if (type) {
    devOnlyWarn("The Kitchen: You have passed a type, \"" + type + "\" into the Slider component, this will have no effect.");
  }

  var track = useRef(null);
  var cTrack = useRef(null);
  var draggableArea = useRef(null);
  var knob = useRef(null);
  var knob2 = useRef(null);
  var bubble1 = useRef(null);
  var bubble2 = useRef(null);

  var _m = __read(useState(0), 2),
      trackWidth = _m[0],
      setTrackWidth = _m[1];

  var _o = __read(useState(false), 2),
      dragging = _o[0],
      setDragging = _o[1];

  var _p = __read(useState(false), 2),
      bubbleMerge = _p[0],
      setBubbleMerge = _p[1];

  var _q = __read(useState(false), 2),
      dragging2 = _q[0],
      setDragging2 = _q[1];

  var _r = __read(useState(false), 2),
      settingUp = _r[0],
      setSettingUp = _r[1];

  var _s = __read(useState(false), 2),
      active = _s[0],
      setActive = _s[1];

  var _t = __read(useState(false), 2),
      active2 = _t[0],
      setActive2 = _t[1];

  var _u = __read(useState(false), 2),
      knobClicked = _u[0],
      setKnobClicked = _u[1];

  var _v = __read(useState(0), 2),
      x = _v[0],
      setX = _v[1];

  var _w = __read(useState(0), 2),
      x2 = _w[0],
      setX2 = _w[1];

  var _x = __read(useState(Number(min)), 2),
      numMin = _x[0],
      setNumMin = _x[1];

  var _y = __read(useState(Number(max)), 2),
      numMax = _y[0],
      setNumMax = _y[1];

  var _z = __read(useState(numMin), 2),
      left = _z[0],
      setLeft = _z[1];

  var _0 = __read(useState(numMin), 2),
      left2 = _0[0],
      setLeft2 = _0[1];

  var isRange = !!(value && typeof value !== 'number');

  var _1 = __read(useState(0), 2),
      mouseX = _1[0],
      setMouseX = _1[1];

  var _2 = __read(useState(false), 2),
      trackHover = _2[0],
      setTrackHover = _2[1];

  var _3 = __read(useState(false), 2),
      mouseDown = _3[0],
      setMouseDown = _3[1];

  var _4 = __read(useState(false), 2),
      isDraggingFromLeftTrack = _4[0],
      setIsDraggingFromLeftTrack = _4[1];

  var formatNumber = function formatNumber(num) {
    var numDecimalPlaces = 0;
    var numStr = String(increment);

    if (numStr.includes('.')) {
      numDecimalPlaces = numStr.split('.')[1].length;
    }

    return num.toFixed(numDecimalPlaces);
  };

  var getProportionsFromPx = function getProportionsFromPx(point) {
    return fixFloatingPoint(roundToNearest(point / trackWidth * (numMax - numMin), increment) + numMin);
  };

  var roundToNearest = function roundToNearest(input, increment) {
    return Math.round(input / increment) * increment;
  };

  var fixFloatingPoint = function fixFloatingPoint(x) {
    return Number(x.toPrecision(7)); //7 is the max reliable precision for a 32 bit number
  };

  var outOfRangeWarning = function outOfRangeWarning(boundaryError, val0, val1) {
    if (boundaryError === 'swapped' && typeof val0 === 'number' && typeof val1 === 'number') {
      devOnlyWarn("The Kitchen: Your data set is flipped in Slider, value[0] = " + val0 + ", is greater than value[1] = " + val1 + ". It has been flipped back for you as this is unsupported. This may have unintended side effects.");
    } else {
      var boundaryName = boundaryError === 'max' ? 'more' : 'less';
      var boundary = boundaryError === 'max' ? max : min;
      devOnlyError("The Kitchen: You have passed a value (" + val0 + ") into the Slider component that is " + boundaryName + " than the " + boundaryError + " (" + boundary + ").");
    }
  };

  var testRange = function testRange(value) {
    if (value < min) {
      outOfRangeWarning('min', value);
      return min;
    } else if (value > max) {
      outOfRangeWarning('max', value);
      return max;
    } else {
      return value;
    }
  };

  useEffect(function () {
    setNumMin(min);
    setNumMax(max);
  }, [min, max]);
  useEffect(function () {
    var _a;

    var updateMousePosition = function updateMousePosition(evt) {
      var _a, _b;

      var left = (_b = (_a = track === null || track === void 0 ? void 0 : track.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.left;
      var point = Math.floor(evt.clientX - (left || 0));

      if (left) {
        if (!active && !disabled) {
          setMouseX(point);
        }
      }
    };

    var handleMouseDown = function handleMouseDown() {
      setMouseDown(true);
    };

    var handleMouseUp = function handleMouseUp() {
      setActive(false);
      setMouseDown(false);
    };

    window.addEventListener('mousemove', updateMousePosition);
    window.addEventListener('mouseup', handleMouseUp); // eslint-disable-next-line no-unused-expressions

    (_a = track === null || track === void 0 ? void 0 : track.current) === null || _a === void 0 ? void 0 : _a.addEventListener('mousedown', handleMouseDown);
    return function () {
      var _a;

      window.removeEventListener('mousemove', updateMousePosition);
      window.removeEventListener('mouseup', handleMouseUp); // eslint-disable-next-line no-unused-expressions

      (_a = track === null || track === void 0 ? void 0 : track.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('mousedown', handleMouseDown);
    };
  }, []);
  useEffect(function () {
    // this effect controls dragging by simulating events not available
    var newPoint = getProportionsFromPx(mouseX); // checks for mouse down, and within bounds

    if (!disabled && !isRange && mouseDown && newPoint >= numMin && newPoint <= numMax) {
      setX(mouseX);
      setLeft(getProportionsFromPx(mouseX));
    } else if (!disabled && isRange && mouseDown && newPoint >= numMin && newPoint <= numMax) {
      var diffLeft2 = Math.abs(left2 - newPoint);
      var diffLeft = left - newPoint; // which side was clicked

      if (diffLeft2 <= diffLeft) {
        // isDragging checks what side it started to it can't go past the other knob
        if (!isDraggingFromLeftTrack) {
          setX(x2);
          setLeft(left2);
        } else {
          setX2(mouseX);
          setLeft2(newPoint);
        }
      } else if (diffLeft2 >= diffLeft) {
        if (isDraggingFromLeftTrack) {
          setX2(x);
          setLeft2(left);
        } else {
          setX(mouseX);
          setLeft(newPoint);
        }
      }
    }
  }, [mouseX]);
  useEffect(function () {
    var _a, _b;

    if (track.current) setTrackWidth(track.current.clientWidth);

    if (isRange) {
      var bubbleOneWidth = ((_a = bubble1.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0;
      var bubbleTwoWidth = ((_b = bubble2.current) === null || _b === void 0 ? void 0 : _b.offsetWidth) || 0;

      if (x2 + bubbleTwoWidth >= x - bubbleOneWidth && !bubbleMerge) {
        setBubbleMerge(true);
      } else if (x2 + bubbleTwoWidth < x - bubbleOneWidth && bubbleMerge) {
        setBubbleMerge(false);
      }
    }
  }, [x, x2]);
  useEffect(function () {
    setActive(dragging);
  }, [dragging]);
  useEffect(function () {
    setActive2(dragging2);
  }, [dragging2]);
  useEffect(function () {
    if (onSliderChange && !disabled && (dragging || dragging2 || active || active2)) {
      if (Array.isArray(value) && value.length === 2) {
        onSliderChange([left2, left]);

        if (observer) {
          observer.value = [left2, left];
        }
      } else {
        onSliderChange(left);

        if (observer) {
          observer.value = left;
        }
      }
    }
  }, [left, left2]);

  var swapMax = function swapMax() {
    if (numMin > numMax) {
      var m = numMax;
      setNumMax(numMin);
      setNumMin(m);
    }
  };

  useLayoutEffect(function () {
    setSettingUp(true);

    if (typeof value === 'number' && track.current) {
      var tempValue = value; // single

      tempValue = testRange(tempValue);
      setTrackWidth(track.current.clientWidth);
      var xPos = track.current.clientWidth / (numMax - numMin) * (tempValue - numMin);
      setX(xPos >= 0 ? xPos <= track.current.clientWidth ? xPos : track.current.clientWidth : 0);

      if (observer) {
        observer.value = tempValue;
      }

      setLeft(tempValue);
    } else if (Array.isArray(value) && value.length === 2 && track.current) {
      var tempValue = value; // multi

      if (tempValue[0] > tempValue[1]) {
        //flipped array
        outOfRangeWarning('swapped', tempValue[0], tempValue[1]);
        tempValue = [tempValue[1], tempValue[0]];
      }

      tempValue[0] = testRange(tempValue[0]);
      tempValue[1] = testRange(tempValue[1]);
      setTrackWidth(track.current.clientWidth);

      if (Array.isArray(tempValue) && tempValue.length === 2) {
        var xPos = track.current.clientWidth / (numMax - numMin) * (tempValue[1] - numMin);
        var xPos2 = track.current.clientWidth / (numMax - numMin) * (tempValue[0] - numMin);
        setX(xPos >= 0 ? xPos <= track.current.clientWidth ? xPos : track.current.clientWidth : 0);
        setX2(xPos2 >= 0 ? xPos2 <= track.current.clientWidth ? xPos2 : track.current.clientWidth : 0);
        setLeft(tempValue[1]);
        setLeft2(tempValue[0]);

        if (observer) {
          observer.value = [tempValue[0], tempValue[1]];
        }
      } else {
        if (observer) {
          observer.value = [numMin, numMax];
        }

        setX(track.current.clientWidth / (numMax - numMin));
        setX2(0);
        setLeft(numMax);
        setLeft2(numMin);
      } // incorrect number of items

    } else if (Array.isArray(value) && value.length !== 2) {
      devOnlyError("The Kitchen: You have passed in an array to Slider with " + value.length + " elements, instead of 2. Please only place 2 items in the array.");
    }
  }, [value]);
  var onResize = useCallback(function () {
    if (settingUp) {
      setSettingUp(false);
    } else {
      if (track.current) {
        setTrackWidth(track.current.clientWidth);
        setX(track.current.clientWidth / Math.abs(min - max) * Math.abs(min - left));
        if (isRange) setX2(track.current.clientWidth / Math.abs(min - max) * Math.abs(min - left2));
      }
    }
  }, [numMin, numMax, settingUp]);

  var onTrackClick = function onTrackClick(evt) {
    var _a, _b, _c, _d;

    if (!disabled) {
      if (!isRange) {
        setActive(true);
        setTrackHover(false);
        var newLeft = (_b = (_a = track === null || track === void 0 ? void 0 : track.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.left;
        var xCord = evt.clientX - (newLeft || 0);
        setX(xCord);
        setLeft(getProportionsFromPx(xCord));
      } else {
        setActive(true);
        setTrackHover(false);
        var newLeft = (_d = (_c = track === null || track === void 0 ? void 0 : track.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect()) === null || _d === void 0 ? void 0 : _d.left;
        var xCord = evt.clientX - (newLeft || 0);
        var newPoint = getProportionsFromPx(xCord); // less than the left knob
        // setting the dragging so the effect with mouseX knows which side it started

        if (newPoint <= left2) {
          setIsDraggingFromLeftTrack(true);
          setX2(xCord);
          setLeft2(newPoint); // greater than the right knob
        } else if (newPoint >= left) {
          setIsDraggingFromLeftTrack(false);
          setX(xCord);
          setLeft(newPoint); // between the knobs
        } else {
          var diffLeft2 = Math.abs(left2 - newPoint);
          var diffLeft = left - newPoint;

          if (diffLeft2 < diffLeft) {
            setIsDraggingFromLeftTrack(true);
            setX2(xCord);
            setLeft2(newPoint);
          } else {
            setIsDraggingFromLeftTrack(false);
            setX(xCord);
            setLeft(newPoint);
          }
        }
      }
    }
  };

  swapMax();

  var knobStyle = function knobStyle(isActive) {
    return {
      cursor: disabled ? 'auto' : 'pointer',
      left: isActive ? -15 : -8,
      width: isActive ? 30 : 18,
      zIndex: isActive ? 10 : 5
    };
  };

  var getOffset = function getOffset() {
    if (cTrack.current) return cTrack.current.clientWidth / 2;
  };

  var isBubbleActive = disabled ? false : active || active2;
  var bubbleTransform = {
    transform: "translateX(" + (bubbleMerge ? "calc(-" + getOffset() + "px + -50%)" : '-50%') + ") translateX(" + (isBubbleActive ? 13 : 7) + "px"
  };
  var showBubble = trackHover && !active && getProportionsFromPx(mouseX) >= numMin && getProportionsFromPx(mouseX) <= numMax;

  var bubbleStyle = _assign2(_assign2({}, bubbleTransform), {
    background: isBubbleActive ? white$1.primary : 'none',
    border: isBubbleActive ? "2px solid " + getColor(color) : 'none',
    fontWeight: isBubbleActive ? 600 : 400,
    bottom: isBubbleActive ? 28 : 16,
    color: isBubbleActive ? orca$1.primary : undefined
  });

  var bubbleTransformTrackHover = {
    transform: "translateX(-50%) translateX(" + mouseX + "px)"
  };

  var bubbleStyleTwo = _assign2(_assign2({}, bubbleTransformTrackHover), {
    display: showBubble ? 'block' : 'none',
    userSelect: 'none',
    background: white$1.primary,
    border: "2px solid " + (disabled ? colorDisabled$1 : getColor(color)),
    bottom: 16,
    color: isBubbleActive || showBubble ? orca$1.primary : undefined,
    zIndex: 1000
  });

  var getBubbleText = function getBubbleText(isSpace, value1, value2) {
    var doubleValueText;
    var singleValueText;

    if (unit === 'media') {
      value1 = Math.floor(value1);
      value2 = Math.floor(value2);
      var seconds1 = value1 % 60;
      var seconds2 = value2 % 60;
      var minutes1 = Math.floor(value1 / 60);
      var minutes2 = Math.floor(value2 / 60);
      doubleValueText = minutes2 + ":" + ("" + (seconds2 < 10 ? '0' : '') + seconds2) + " to " + minutes1 + ":" + ("" + (seconds1 < 10 ? '0' : '') + seconds1);
      singleValueText = minutes1 + ":" + ("" + (seconds1 < 10 ? '0' : '') + seconds1);
    } else {
      doubleValueText = formatNumber(value2) + " to " + formatNumber(value1) + " " + unit;
      singleValueText = formatNumber(value1) + " " + unit;
    }

    return isSpace ? bubbleMerge && isRange ? singleValueText : doubleValueText : bubbleMerge && isRange ? doubleValueText : singleValueText;
  };

  var contrastClass = contrast === 'high' ? ' kxi-high-contrast' : '';
  var totalScale = max - min;
  var widthPerUnitScale = trackWidth / totalScale;
  var inflectionPointUnitsFromLeft = ((inflection === null || inflection === void 0 ? void 0 : inflection.inflectionPoint) || 0) - min;
  var inflectionPointWidthFromLeft = inflectionPointUnitsFromLeft * widthPerUnitScale;
  var inflectionPointWidthFromRight = trackWidth - inflectionPointWidthFromLeft;
  return jsxRuntime_2("div", _assign2({
    "aria-disabled": disabled,
    role: "slider",
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-valuenow": left,
    className: "kxi-slider-container"
  }, {
    children: [(((_a = endLabels === null || endLabels === void 0 ? void 0 : endLabels.left) === null || _a === void 0 ? void 0 : _a.icon) || ((_b = endLabels === null || endLabels === void 0 ? void 0 : endLabels.left) === null || _b === void 0 ? void 0 : _b.displayValue)) && jsxRuntime_2("div", _assign2({
      className: "kxi-slider-end-label kxi-slider-end-label-left " + contrastClass
    }, {
      children: [endLabels.left.icon && jsxRuntime_1(XIIcon, {
        icon: endLabels.left.icon,
        color: endLabels.left.sentiment || 'orca',
        contrast: contrast
      }, void 0), endLabels.left.displayValue && jsxRuntime_1("p", {
        children: min
      }, void 0)]
    }), void 0), jsxRuntime_2("div", _assign2({
      className: "kxi-slider orca " + (className || ''),
      ref: ref
    }, ingredients, {
      children: [isRange ? jsxRuntime_2("div", _assign2({
        style: {
          display: 'none'
        }
      }, {
        children: [jsxRuntime_1("input", {
          readOnly: true,
          type: "range",
          value: left2,
          name: "slider_value_1"
        }, void 0), jsxRuntime_1("input", {
          readOnly: true,
          type: "range",
          value: left,
          name: "slider_value_2"
        }, void 0)]
      }), void 0) : jsxRuntime_1("input", {
        readOnly: true,
        style: {
          display: 'none'
        },
        type: "range",
        value: left2,
        name: "slider_value"
      }, void 0), jsxRuntime_1(ReactResizeDetector, _assign2({
        refreshMode: "debounce",
        refreshRate: 0,
        handleWidth: true,
        onResize: onResize,
        targetRef: track
      }, {
        children: jsxRuntime_1("div", _assign2({
          className: "kxi-track-bounds",
          ref: track,
          onMouseDown: onTrackClick,
          onMouseUp: function onMouseUp() {
            return setActive(false);
          },
          onMouseOver: function onMouseOver() {
            if (!mouseDown && !knobClicked && !disabled) setTrackHover(true);
          },
          onMouseLeave: function onMouseLeave() {
            if (!mouseDown && !knobClicked) setActive(false);
            setTrackHover(false);
          },
          style: {
            cursor: disabled ? 'auto' : 'pointer'
          }
        }, {
          children: jsxRuntime_2("div", _assign2({
            className: "kxi-track",
            onClick: onTrackClick,
            style: {
              cursor: disabled ? 'auto' : 'pointer'
            }
          }, {
            children: [jsxRuntime_1("div", {
              onClick: onTrackClick,
              className: "kxi-track-completed",
              style: {
                cursor: disabled ? 'auto' : 'pointer',
                background: disabled ? colorDisabled$1 : getColor(color),
                left: isRange ? x2 : 0,
                right: trackWidth - x
              },
              ref: cTrack
            }, void 0), inflection && jsxRuntime_2(jsxRuntime_3, {
              children: [jsxRuntime_1("div", {
                className: "kxi-track-completed kxi-slider-inflection kxi-" + (inflection === null || inflection === void 0 ? void 0 : inflection.sentimentLeft),
                style: {
                  cursor: disabled ? 'auto' : 'pointer',
                  left: x2,
                  right: inflectionPointWidthFromRight > trackWidth - x ? inflectionPointWidthFromRight : trackWidth - x
                }
              }, void 0), jsxRuntime_1("div", {
                className: "kxi-track-completed kxi-slider-inflection kxi-" + (inflection === null || inflection === void 0 ? void 0 : inflection.sentimentRight),
                style: {
                  cursor: disabled ? 'auto' : 'pointer',
                  left: inflectionPointWidthFromLeft > x2 ? inflectionPointWidthFromLeft : x2,
                  right: trackWidth - x
                }
              }, void 0)]
            }, void 0)]
          }), void 0)
        }), void 0)
      }), void 0), isRange && jsxRuntime_1(motion.div, _assign2({
        ref: knob,
        style: {
          position: 'absolute',
          zIndex: 1
        },
        drag: disabled ? false : 'x',
        animate: {
          x: x2
        },
        dragConstraints: {
          left: 0,
          right: x
        },
        dragElastic: 0,
        dragMomentum: false,
        onDragStart: function onDragStart() {
          if (!disabled) {
            setActive2(true);
            setKnobClicked(true);
            setDragging2(true);
          }
        },
        onDrag: function onDrag(e, info) {
          if (!disabled) {
            setX2(info.point.x);
            setLeft2(getProportionsFromPx(info.point.x));
          }
        },
        onDragEnd: function onDragEnd() {
          if (!disabled) {
            setKnobClicked(false);
            setDragging2(false);
          }
        },
        transition: {
          duration: 0,
          ease: 'easeInOut'
        }
      }, {
        children: jsxRuntime_1("div", _assign2({
          "data-testid": "slider_2",
          className: "kxi-knob " + (inflection ? left2 < inflection.inflectionPoint ? "kxi-slider-inflection kxi-" + inflection.sentimentLeft : "kxi-slider-inflection kxi-" + inflection.sentimentRight : '') + " " + (disabled ? 'disabled' : ''),
          style: knobStyle(active2)
        }, {
          children: bubbleMerge || !displayCurrentPosition ? null : jsxRuntime_2(jsxRuntime_3, {
            children: [jsxRuntime_2("div", _assign2({
              className: "kxi-bubble kxi-text-normal" + contrastClass + " " + (isBubbleActive ? 'kxi-bubble-active' : ''),
              style: bubbleStyle
            }, {
              children: [left2, " ", unit]
            }), void 0), jsxRuntime_1("div", _assign2({
              className: "kxi-bubble-space ",
              style: bubbleTransform,
              ref: bubble2
            }, {
              children: getBubbleText(true, left2, left)
            }), void 0)]
          }, void 0)
        }), void 0)
      }), void 0), jsxRuntime_1("div", {
        className: "kxi-draggable-area",
        ref: draggableArea,
        style: {
          left: x2 + 2
        }
      }, void 0), jsxRuntime_1(motion.div, _assign2({
        ref: knob2,
        style: {
          position: 'absolute',
          zIndex: 1
        },
        drag: disabled ? false : 'x',
        animate: {
          x: x
        },
        dragConstraints: {
          left: x2,
          right: trackWidth
        },
        dragElastic: 0,
        dragMomentum: false,
        onDragStart: function onDragStart() {
          if (!disabled) {
            setKnobClicked(true);
            setDragging(true);
          }
        },
        onDrag: function onDrag(e, info) {
          if (!disabled) {
            setX(info.point.x);
            setLeft(getProportionsFromPx(info.point.x));
          }
        },
        onDragEnd: function onDragEnd() {
          if (!disabled) {
            setKnobClicked(false);
            setDragging(false);
          }
        },
        transition: {
          duration: 0,
          ease: 'easeInOut'
        }
      }, {
        children: jsxRuntime_1("div", _assign2({
          "data-testid": "slider_1",
          className: "kxi-knob " + (inflection ? left < inflection.inflectionPoint ? "kxi-slider-inflection kxi-" + inflection.sentimentLeft : "kxi-slider-inflection kxi-" + inflection.sentimentRight : '') + "  " + (disabled ? 'disabled' : ''),
          style: knobStyle(active)
        }, {
          children: displayCurrentPosition && jsxRuntime_2(jsxRuntime_3, {
            children: [jsxRuntime_1("div", _assign2({
              className: "kxi-bubble kxi-text-normal" + contrastClass,
              style: bubbleStyle,
              ref: bubble1
            }, {
              children: bubbleMerge && isRange ? dragging || dragging2 ? formatNumber(left2) + " to " + formatNumber(left) + " " + unit : left2 + " to " + left + " " + unit : (dragging ? formatNumber(left) : left) + " " + unit
            }), void 0), jsxRuntime_1("div", _assign2({
              className: "kxi-bubble-space",
              style: bubbleTransform
            }, {
              children: (displayCurrentPosition || isBubbleActive) && getBubbleText(true, left, left2)
            }), void 0)]
          }, void 0)
        }), void 0)
      }), "slider_1"), displayCurrentPosition && jsxRuntime_1("div", _assign2({
        className: "kxi-bubble kxi-text-normal" + contrastClass,
        style: bubbleStyleTwo
      }, {
        children: formatNumber(getProportionsFromPx(mouseX)) + " " + unit
      }), void 0)]
    }), void 0), (((_c = endLabels === null || endLabels === void 0 ? void 0 : endLabels.right) === null || _c === void 0 ? void 0 : _c.icon) || ((_d = endLabels === null || endLabels === void 0 ? void 0 : endLabels.right) === null || _d === void 0 ? void 0 : _d.displayValue)) && jsxRuntime_2("div", _assign2({
      className: "kxi-slider-end-label kxi-slider-end-label-right " + contrastClass
    }, {
      children: [endLabels.right.icon && jsxRuntime_1(XIIcon, {
        icon: endLabels.right.icon,
        color: endLabels.right.sentiment || 'orca',
        contrast: contrast
      }, void 0), endLabels.right.displayValue && jsxRuntime_1("p", {
        children: max
      }, void 0)]
    }), void 0)]
  }), void 0);
});

var MediaPlayerProps = function (_super) {
  __extends(MediaPlayerProps, _super);

  function MediaPlayerProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Object)], MediaPlayerProps.prototype, "mediaRef");

  __decorate([Bound(), __metadata("design:type", Boolean)], MediaPlayerProps.prototype, "hasFullscreen");

  __decorate([Bound(), __metadata("design:type", Boolean)], MediaPlayerProps.prototype, "finishedLoading");

  __decorate([Bound(), __metadata("design:type", Number)], MediaPlayerProps.prototype, "duration");

  return MediaPlayerProps;
}(DivHTMLAttributes);

var MediaPlayerEvents = function (_super) {
  __extends(MediaPlayerEvents, _super);

  function MediaPlayerEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], MediaPlayerEvents.prototype, "onFullscreen");

  return MediaPlayerEvents;
}(DivHTMLEvents);
/**
 * Description: This is standard button and should be used whenever possible. A small button is also acceptable. Don't use all caps in buttons. Status will override all colors.
 */


var MediaPlayer = /*#__PURE__*/forwardRef(function (props, ref) {
  var mediaRef = props.mediaRef,
      _a = props.duration,
      duration = _a === void 0 ? 0 : _a,
      finishedLoading = props.finishedLoading,
      _b = props.hasFullscreen,
      hasFullscreen = _b === void 0 ? false : _b,
      onFullscreen = props.onFullscreen,
      ingredients = __rest(props, ["mediaRef", "duration", "finishedLoading", "hasFullscreen", "onFullscreen"]);

  var _c = __read(useState(false), 2),
      isPlaying = _c[0],
      setIsPlaying = _c[1];

  var _d = __read(useState(false), 2),
      isMuted = _d[0],
      setIsMuted = _d[1];

  var _e = __read(useState(false), 2),
      isReadyRefresh = _e[0],
      setIsReadyRefresh = _e[1];

  var _f = __read(useState(0), 2),
      currentTime = _f[0],
      setCurrentTime = _f[1];

  var _g = __read(useState(false), 2),
      inputEnabled = _g[0],
      setInputEnabled = _g[1];

  useEffect(function () {
    setInputEnabled(finishedLoading !== false);
  }, [finishedLoading]);

  var setMediaTime = function setMediaTime(time) {
    if (duration && time > duration) time = duration;
    if (duration && time < 0) time = 0;
    if (mediaRef.current) mediaRef.current.currentTime = time;
    setCurrentTime(time);
  };

  useEffect(function () {
    if (mediaRef.current) mediaRef.current.muted = isMuted;
  }, [isMuted]);
  useEffect(function () {
    var _a, _b;

    if (isPlaying) {
      (_a = mediaRef.current) === null || _a === void 0 ? void 0 : _a.play();
    } else {
      (_b = mediaRef.current) === null || _b === void 0 ? void 0 : _b.pause();
    }
  }, [isPlaying]);
  useEffect(function () {
    var interval;
    var media = mediaRef.current;
    if (media) if (isPlaying) {
      interval = setInterval(function () {
        setCurrentTime((media === null || media === void 0 ? void 0 : media.currentTime) || 0);

        if (media && duration && media.currentTime >= duration) {
          clearInterval(interval);
          setIsPlaying(false);
          setIsReadyRefresh(true);
        }
      }, 10);
    }
    return function () {
      clearInterval(interval);
    };
  }, [isPlaying, isReadyRefresh]);
  useEffect(function () {
    var handleKeyPress = function handleKeyPress(e) {
      if (e.key === ' ' || e.key === 'Enter' || e.keyCode === 13 || e.keyCode === 32) {
        playMedia();
      }
    };

    if (inputEnabled) {
      if (mediaRef.current instanceof HTMLVideoElement) {
        document.addEventListener('keydown', handleKeyPress);
      } else if (mediaRef.current instanceof HTMLAudioElement) {
        document.getElementsByClassName('kxi-media-player')[0].addEventListener('keydown', handleKeyPress);
      }
    }

    return function () {
      if (mediaRef.current instanceof HTMLVideoElement) {
        document.removeEventListener('keydown', handleKeyPress);
      } else if (mediaRef.current instanceof HTMLAudioElement) {
        document.getElementsByClassName('kxi-media-player')[0].removeEventListener('keydown', handleKeyPress);
      }
    };
  }, [inputEnabled, isReadyRefresh, isPlaying]);

  var getTimeText = function getTimeText() {
    var _a;

    var current = Math.floor(((_a = mediaRef.current) === null || _a === void 0 ? void 0 : _a.currentTime) || 0);
    var totalDuration = Math.floor(duration || 0);
    var currentSeconds = current % 60;
    var totalDurationSeconds = totalDuration % 60;
    var currentMinutes = Math.floor(current / 60);
    var totalDurationMinutes = Math.floor(totalDuration / 60);
    return currentMinutes + ":" + ("" + (currentSeconds < 10 ? '0' : '') + currentSeconds) + " | " + totalDurationMinutes + ":" + ("" + (totalDurationSeconds < 10 ? '0' : '') + totalDurationSeconds);
  };

  var playMedia = function playMedia() {
    if (inputEnabled) {
      if (isReadyRefresh) {
        setMediaTime(0);
        setIsReadyRefresh(false);
      }

      setIsPlaying(!isPlaying);
    }
  };

  return jsxRuntime_2("div", _assign2({
    className: "kxi-media-player" + (hasFullscreen ? '-fullscreen' : '')
  }, ingredients, {
    ref: ref,
    tabIndex: 0
  }, {
    children: [jsxRuntime_1(XIIcon, {
      className: "kxi-play" + (isReadyRefresh ? ' kxi-replay' : ''),
      icon: isReadyRefresh ? 'refresh' : isPlaying ? 'pause_filled' : 'play_control_filled',
      onClick: function onClick() {
        playMedia();
      },
      tabIndex: 1
    }, void 0), jsxRuntime_1(IconButton, {
      buttonSize: "normal",
      className: "kxi-rewind",
      icon: "rewind_15",
      hasAnimation: false,
      onClick: function onClick() {
        var _a;

        if (inputEnabled) {
          setIsReadyRefresh(false);
          setMediaTime((((_a = mediaRef === null || mediaRef === void 0 ? void 0 : mediaRef.current) === null || _a === void 0 ? void 0 : _a.currentTime) || 0) - 15);
        }
      }
    }, void 0), jsxRuntime_1(IconButton, {
      buttonSize: "normal",
      className: "kxi-forward",
      icon: "forward_30",
      hasAnimation: false,
      onClick: function onClick() {
        var _a;

        if (inputEnabled) {
          setMediaTime((((_a = mediaRef === null || mediaRef === void 0 ? void 0 : mediaRef.current) === null || _a === void 0 ? void 0 : _a.currentTime) || 0) + 30);
          var media = mediaRef === null || mediaRef === void 0 ? void 0 : mediaRef.current;
          if (media && duration && media.currentTime >= duration) setIsReadyRefresh(true);
        }
      }
    }, void 0), jsxRuntime_1("div", _assign2({
      className: "kxi-media-slider"
    }, {
      children: jsxRuntime_1(Slider, {
        max: duration,
        value: +currentTime.toFixed(1),
        disabled: !inputEnabled,
        onSliderChange: function onSliderChange(value) {
          setIsReadyRefresh(false);
          setMediaTime(value);
        },
        displayCurrentPosition: false
      }, void 0)
    }), void 0), jsxRuntime_1("p", _assign2({
      className: "kxi-media-slider-text"
    }, {
      children: getTimeText()
    }), void 0), jsxRuntime_1(IconButton, {
      hasAnimation: false,
      className: "kxi-volume",
      buttonSize: "normal",
      icon: isMuted ? 'volume_off' : 'volume_on',
      onClick: function onClick() {
        if (inputEnabled) setIsMuted(!isMuted);
      }
    }, void 0), hasFullscreen && jsxRuntime_1(IconButton, {
      hasAnimation: false,
      className: "kxi-fullscreen",
      buttonSize: "normal",
      icon: "full_screen",
      onClick: inputEnabled && onFullscreen || undefined
    }, void 0), jsxRuntime_1("div", {
      className: "kxi-background"
    }, void 0)]
  }), void 0);
});

var VideoPlayerProps = function (_super) {
  __extends(VideoPlayerProps, _super);

  function VideoPlayerProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], VideoPlayerProps.prototype, "source");

  __decorate([Bound(), __metadata("design:type", String)], VideoPlayerProps.prototype, "contrast");

  __decorate([Bound(), __metadata("design:type", Number)], VideoPlayerProps.prototype, "height");

  __decorate([Bound(), __metadata("design:type", Number)], VideoPlayerProps.prototype, "width");

  __decorate([Bound(), __metadata("design:type", Object)], VideoPlayerProps.prototype, "genericModalProps");

  return VideoPlayerProps;
}(DivHTMLAttributes);

var VideoPlayerEvents = function (_super) {
  __extends(VideoPlayerEvents, _super);

  function VideoPlayerEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return VideoPlayerEvents;
}(DivHTMLEvents);
/**
 * Description: InMoment themed video player.
 */


var VideoPlayer = /*#__PURE__*/forwardRef(function (props, ref) {
  var source = props.source,
      _a = props.contrast,
      contrast = _a === void 0 ? 'high' : _a,
      _b = props.height,
      height = _b === void 0 ? 122 : _b,
      _c = props.width,
      width = _c === void 0 ? 216 : _c,
      genericModalProps = props.genericModalProps,
      ingredients = __rest(props, ["source", "contrast", "height", "width", "genericModalProps"]);

  var _d = __read(useState(), 2),
      duration = _d[0],
      setDuration = _d[1];

  var _e = __read(useState(false), 2),
      isVisible = _e[0],
      setIsVisible = _e[1];

  var _f = __read(useState(false), 2),
      isFullscreen = _f[0],
      setIsFullscreen = _f[1];

  var _g = __read(useState(true), 2),
      hasNativeControls = _g[0],
      setHasNativeControls = _g[1];

  var _h = __read(useState(false), 2),
      finishedLoading = _h[0],
      setFinishedLoading = _h[1];

  var videoElement = useRef(null);
  var videoWrapper = useRef(null);
  useEffect(function () {
    var handleKeyPress = function handleKeyPress(e) {
      if (e.keyCode === 27 || e.key === 'Escape') {
        setIsVisible(false);
      }
    };

    document.addEventListener('keydown', handleKeyPress);
    return function () {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  function toggleFullScreen() {
    var _a, _b, _c;

    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else if (document.webkitFullscreenElement) {
      document.webkitExitFullscreen();
    } else if ((_a = videoWrapper.current) === null || _a === void 0 ? void 0 : _a.webkitRequestFullscreen) {
      (_b = videoWrapper.current) === null || _b === void 0 ? void 0 : _b.webkitRequestFullscreen();
    } else {
      (_c = videoWrapper.current) === null || _c === void 0 ? void 0 : _c.requestFullscreen();
    }
  }

  return jsxRuntime_2("div", _assign2({
    className: "kxi-video-player"
  }, ingredients, {
    ref: ref
  }, {
    children: [jsxRuntime_2("div", _assign2({
      className: "kxi-thumbnail",
      "data-testid": "video-thumbnail",
      style: {
        height: height + "px",
        width: width + "px"
      },
      onClick: function onClick() {
        return setIsVisible(!isVisible);
      }
    }, {
      children: [jsxRuntime_1("video", _assign2({
        ref: videoElement,
        onCanPlay: function onCanPlay() {
          var _a;

          setDuration((_a = videoElement.current) === null || _a === void 0 ? void 0 : _a.duration);
        }
      }, {
        children: jsxRuntime_1("source", {
          src: source
        }, void 0)
      }), void 0), jsxRuntime_1("div", _assign2({
        className: "kxi-thumbnail-icon"
      }, {
        children: jsxRuntime_1(XIIcon, {
          contrast: contrast,
          icon: "play_control_filled",
          iconSize: 84
        }, void 0)
      }), void 0), jsxRuntime_1("div", {
        className: "kxi-thumbnail-overlay",
        style: {
          height: height + "px",
          width: width + "px"
        }
      }, void 0)]
    }), void 0), jsxRuntime_1(GenericModal, _assign2({}, genericModalProps, {
      isVisible: isVisible,
      onClose: function onClose() {
        return setIsVisible(false);
      },
      allowPropagation: true,
      isVisualModal: true
    }, {
      children: jsxRuntime_2("div", _assign2({
        className: "kxi-video" + (hasNativeControls ? ' kxi-video-native' : '') + (isFullscreen ? ' kxi-video-fullscreen' : ''),
        ref: videoWrapper,
        onClick: function onClick(e) {
          return e.stopPropagation();
        }
      }, {
        children: [jsxRuntime_1("video", _assign2({
          "data-testid": "video-fullScreen",
          controls: true,
          ref: videoElement,
          preload: "metadata",
          onCanPlay: function onCanPlay() {
            var _a;

            setFinishedLoading(true);
            setDuration((_a = videoElement.current) === null || _a === void 0 ? void 0 : _a.duration);

            if (videoElement.current) {
              // Turn off controls with JS to make video accessible with native controls if JS disabled.
              videoElement.current.controls = false;
              setHasNativeControls(false);
            }
          }
        }, {
          children: jsxRuntime_1("source", {
            src: source
          }, void 0)
        }), void 0), !hasNativeControls && jsxRuntime_1(MediaPlayer, {
          duration: duration,
          mediaRef: videoElement,
          hasFullscreen: true,
          onFullscreen: function onFullscreen() {
            setIsFullscreen(!isFullscreen);
            toggleFullScreen();
          },
          finishedLoading: finishedLoading
        }, void 0)]
      }), void 0)
    }), void 0)]
  }), void 0);
});

var AudioPlayerProps = function (_super) {
  __extends(AudioPlayerProps, _super);

  function AudioPlayerProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], AudioPlayerProps.prototype, "source");

  return AudioPlayerProps;
}(DivHTMLAttributes);

var AudioPlayerEvents = function (_super) {
  __extends(AudioPlayerEvents, _super);

  function AudioPlayerEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return AudioPlayerEvents;
}(DivHTMLEvents);
/**
 * Description: InMoment themed audio player.
 */


var AudioPlayer = /*#__PURE__*/forwardRef(function (props, ref) {
  var source = props.source,
      ingredients = __rest(props, ["source"]);

  var _a = __read(useState(), 2),
      duration = _a[0],
      setDuration = _a[1];

  var audioElement = useRef(null);
  return jsxRuntime_2("div", _assign2({
    className: "kxi-audio-player"
  }, ingredients, {
    ref: ref
  }, {
    children: [jsxRuntime_1("audio", _assign2({
      ref: audioElement,
      onCanPlay: function onCanPlay() {
        var _a;

        setDuration((_a = audioElement.current) === null || _a === void 0 ? void 0 : _a.duration);
      },
      "data-testid": "audioPlayer"
    }, {
      children: jsxRuntime_1("source", {
        src: source
      }, void 0)
    }), void 0), jsxRuntime_1(MediaPlayer, {
      duration: duration,
      mediaRef: audioElement
    }, void 0)]
  }), void 0);
});
var TabBarItem = /*#__PURE__*/forwardRef(function (props, ref) {
  var title = props.title,
      id = props.id,
      disabled = props.disabled,
      alert = props.alert,
      tabSpacing = props.tabSpacing,
      _onClick = props.onClick,
      selected = props.selected,
      color = props.color,
      contrast = props.contrast,
      _a = props.maxCharsAllowed,
      maxCharsAllowed = _a === void 0 ? 30 : _a,
      tooltip = props.tooltip,
      onWidthChange = props.onWidthChange,
      style = props.style,
      _b = props.isVisible,
      isVisible = _b === void 0 ? true : _b,
      className = props.className,
      icon = props.icon,
      disabledReason = props.disabledReason,
      category = props.category,
      ingredients = __rest(props, ["title", "id", "disabled", "alert", "tabSpacing", "onClick", "selected", "color", "contrast", "maxCharsAllowed", "tooltip", "onWidthChange", "style", "isVisible", "className", "icon", "disabledReason", "category"]);

  var widthRef = useRef(null);

  var generateText = function generateText() {
    return jsxRuntime_2("div", {
      children: [category ? jsxRuntime_1("div", _assign2({
        style: {
          fontSize: 14
        }
      }, {
        children: "" + (category.length > maxCharsAllowed ? category.substr(0, maxCharsAllowed) + "..." : category)
      }), void 0) : undefined, jsxRuntime_1("div", _assign2({
        style: category ? {
          fontWeight: 'bold'
        } : undefined
      }, {
        children: "" + (title.length > maxCharsAllowed ? title.substr(0, maxCharsAllowed) + "..." : title)
      }), void 0)]
    }, void 0);
  };

  var getTextOverflow = function getTextOverflow() {
    if (disabled && disabledReason && isVisible) {
      if (title.length > maxCharsAllowed || category && category.length > maxCharsAllowed) {
        return jsxRuntime_1(ToolTipWrapper, _assign2({}, tooltip, {
          title: disabledReason + "<br><br><span style=\"font-weight: 200\">" + (category ? category + "<br>" : '') + "</span>" + title
        }, ingredients, {
          style: {
            cursor: 'pointer',
            alignItems: 'center'
          },
          ref: ref
        }, {
          children: generateText()
        }), void 0);
      } else {
        return jsxRuntime_1(ToolTipWrapper, _assign2({}, tooltip, {
          text: "" + disabledReason
        }, ingredients, {
          style: {
            cursor: 'pointer',
            alignItems: 'center'
          },
          ref: ref
        }, {
          children: generateText()
        }), void 0);
      }
    } else if ((title.length > maxCharsAllowed || category && category.length > maxCharsAllowed) && isVisible) {
      return jsxRuntime_1(ToolTipWrapper, _assign2({}, tooltip, {
        title: "<span style=\"font-weight: normal\">" + (category ? category + "</span><br>" : '') + (category ? "<span style=\"font-weight: bold;\">" + title + "</span>" : title) + "</span>"
      }, ingredients, {
        style: {
          cursor: 'pointer',
          alignItems: 'center'
        },
        ref: ref
      }, {
        children: generateText()
      }), void 0);
    } else {
      return jsxRuntime_1("span", {
        children: generateText()
      }, void 0);
    }
  };

  var handleKeyPress = function handleKeyPress(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault(); // prevent page from scrolling on space

      if (_onClick && !disabled) {
        _onClick(id);
      }
    }
  };

  var textOverflow = getTextOverflow();
  var hitBox = jsxRuntime_2("span", _assign2({
    tabIndex: isVisible ? 0 : -1,
    onKeyPress: handleKeyPress,
    onClick: function onClick() {
      if (_onClick && !disabled) {
        _onClick(id);
      }
    }
  }, {
    children: [textOverflow, alert ? jsxRuntime_1("div", {
      role: "alert",
      className: "kxi-tab-bar-alert"
    }, "alertDiv-" + id) : null]
  }), void 0);
  return jsxRuntime_1(ReactResizeDetector, _assign2({
    handleWidth: true,
    onResize: useCallback(function (width) {
      if (onWidthChange && width) {
        onWidthChange(width);
      }
    }, []),
    targetRef: widthRef
  }, {
    children: jsxRuntime_1("div", _assign2({
      ref: mergeRefs([widthRef, ref]),
      className: "kxi-tab-bar-item-wrapper " + (isVisible ? '' : 'kxi-tab-bar-hidden-tab'),
      "data-testid": id
    }, {
      children: jsxRuntime_2("div", _assign2({
        role: "tab",
        "aria-label": "tab",
        "aria-describedby": title,
        "aria-hidden": !isVisible,
        id: "tab-" + id,
        className: (color ? normalizeColor(color) : '') + " " + (contrast === 'high' ? ' kxi-high-contrast' : '') + " kxi-tab-bar-item " + className,
        style: _assign2({
          marginRight: tabSpacing
        }, style)
      }, ingredients, {
        children: [jsxRuntime_1("div", _assign2({
          className: "kxi-tab-bar-text"
        }, {
          children: jsxRuntime_2("div", _assign2({
            className: "kxi-tab-bar-text-container kxi-text-normal " + (disabled ? 'kxi-disabled-alpha' : '')
          }, {
            children: [hitBox, icon]
          }), "textDiv-" + id)
        }), "textContainer-" + id), jsxRuntime_1("div", _assign2({
          className: "kxi-tab-bar-indicator-wrapper"
        }, {
          children: jsxRuntime_1("div", {
            className: "kxi-tab-bar-indicator",
            style: {
              height: selected ? 6 : 0,
              width: selected ? '100%' : 0
            }
          }, "indicatorDiv-" + id)
        }), void 0)]
      }), "innerDiv-" + id)
    }), "outerDiv-" + id)
  }), "resizeDetector-" + id);
});

var HorizontalTabBarProps = function (_super) {
  __extends(HorizontalTabBarProps, _super);

  function HorizontalTabBarProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Array)], HorizontalTabBarProps.prototype, "data");

  __decorate([Bound(), __metadata("design:type", String)], HorizontalTabBarProps.prototype, "color");

  __decorate([Bound(), __metadata("design:type", String)], HorizontalTabBarProps.prototype, "contrast");

  __decorate([Bound(), __metadata("design:type", String)], HorizontalTabBarProps.prototype, "activeTabId");

  __decorate([Bound(), __metadata("design:type", Number)], HorizontalTabBarProps.prototype, "tabSpacing");

  __decorate([Bound(), __metadata("design:type", Boolean)], HorizontalTabBarProps.prototype, "hasTransparentBackground");

  __decorate([Bound(), __metadata("design:type", Boolean)], HorizontalTabBarProps.prototype, "stretch");

  __decorate([Bound(), __metadata("design:type", Number)], HorizontalTabBarProps.prototype, "maxCharsAllowed");

  __decorate([Bound(), __metadata("design:type", Object)], HorizontalTabBarProps.prototype, "tooltip");

  __decorate([Bound(), __metadata("design:type", Object)], HorizontalTabBarProps.prototype, "arrowTooltip");

  __decorate([Bound(), __metadata("design:type", Boolean)], HorizontalTabBarProps.prototype, "componentControlledTabChange");

  __decorate([Bound(), __metadata("design:type", Boolean)], HorizontalTabBarProps.prototype, "moveOnSelectChange");

  __decorate([Bound(), __metadata("design:type", String)], HorizontalTabBarProps.prototype, "moreTabsTemplate");

  return HorizontalTabBarProps;
}(ObservablePropsMixin(DivHTMLAttributes));

var HorizontalTabBarEvents = function (_super) {
  __extends(HorizontalTabBarEvents, _super);

  function HorizontalTabBarEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], HorizontalTabBarEvents.prototype, "onTabChange");

  __decorate([Bound(), __metadata("design:type", Function)], HorizontalTabBarEvents.prototype, "onTabClose");

  __decorate([Bound(), __metadata("design:type", Function)], HorizontalTabBarEvents.prototype, "onTabUnpin");

  return HorizontalTabBarEvents;
}(DivHTMLEvents);
/**
 * Description: Navigational component that contains clickable data.
 */


var HorizontalTabBar = /*#__PURE__*/forwardRef(function (props, ref) {
  var data = props.data,
      color = props.color,
      contrast = props.contrast,
      activeTabId = props.activeTabId,
      tabSpacing = props.tabSpacing,
      hasTransparentBackground = props.hasTransparentBackground,
      stretch = props.stretch,
      _a = props.maxCharsAllowed,
      maxCharsAllowed = _a === void 0 ? 30 : _a,
      tooltip = props.tooltip,
      observer = props.observer,
      _b = props.componentControlledTabChange,
      componentControlledTabChange = _b === void 0 ? true : _b,
      moreTabsTemplate = props.moreTabsTemplate,
      moveOnSelectChange = props.moveOnSelectChange,
      arrowTooltip = props.arrowTooltip,
      onTabChange = props.onTabChange,
      onTabClose = props.onTabClose,
      onTabUnpin = props.onTabUnpin,
      ingredients = __rest(props, ["data", "color", "contrast", "activeTabId", "tabSpacing", "hasTransparentBackground", "stretch", "maxCharsAllowed", "tooltip", "observer", "componentControlledTabChange", "moreTabsTemplate", "moveOnSelectChange", "arrowTooltip", "onTabChange", "onTabClose", "onTabUnpin"]);

  var _c = __read(useState([]), 2),
      tabArray = _c[0],
      setTabArray = _c[1];

  var _d = __read(useState(uuidv4()), 1),
      tabBarId = _d[0];

  var _e = __read(useState(undefined), 2),
      width = _e[0],
      setWidth = _e[1];

  var _f = __read(useState(undefined), 2),
      height = _f[0],
      setHeight = _f[1];

  var _g = __read(useState(undefined), 2),
      selectedTabId = _g[0],
      setSelectedTabId = _g[1];

  var _h = __read(useState(''), 2),
      triggerRerender = _h[0],
      setTriggerRerender = _h[1];

  var _j = __read(useState(0), 2),
      tabsHiddenLeft = _j[0],
      setTabsHiddenLeft = _j[1];

  var _k = __read(useState(0), 2),
      tabsHiddenRight = _k[0],
      setTabsHiddenRight = _k[1];

  var _l = __read(useState(0), 2),
      leftOffset = _l[0],
      setLeftOffset = _l[1];

  var _m = __read(useState(false), 2),
      activeLeft = _m[0],
      setActiveLeft = _m[1];

  var _o = __read(useState(false), 2),
      activeRight = _o[0],
      setActiveRight = _o[1];

  var _p = __read(useState(0), 2),
      remainingSpace = _p[0],
      setRemainingSpace = _p[1];

  var _q = __read(useState(0), 2),
      tabsShown = _q[0],
      setTabsShown = _q[1];

  var _r = __read(useState({}), 2),
      oldData = _r[0],
      setOldData = _r[1];

  var _s = __read(useState(false), 2),
      categoryLayout = _s[0],
      setCategoryLayout = _s[1];

  var _t = __read(useState(''), 2),
      isMoving = _t[0],
      setIsMoving = _t[1];

  var _u = __read(useState(false), 2),
      isInitialRender = _u[0],
      setIsInitialRender = _u[1];

  var widthRef = useRef(null);
  var tabWidths = useRef(null);
  var inputTabArray = useRef(null);
  useEffect(function () {
    setSelectedTabId(activeTabId);
  }, [activeTabId]);
  useEffect(function () {
    if (JSON.stringify(oldData) === JSON.stringify(data)) {
      return;
    }

    var newTabArray = [];
    var newCategoryLayout = false;

    for (var i = 0; i < data.length; i++) {
      var tab = {
        title: data[i].title,
        id: data[i].id,
        category: data[i].category,
        disabled: data[i].disabled,
        disabledReason: data[i].disabledReason,
        alert: data[i].alert,
        isHome: data[i].isHome,
        isPinned: data[i].isPinned,
        isCloseShown: data[i].isCloseShown,
        isSelected: false
      };
      newTabArray.push(tab);

      if (data[i].category) {
        newCategoryLayout = true;
      }
    }

    setTabsHiddenLeft(0);
    setTabsHiddenRight(0);
    setOldData(data);
    setCategoryLayout(newCategoryLayout);
    setIsInitialRender(true);
    setIsMoving(uuidv4());
    inputTabArray.current = newTabArray;
  }, [data]);
  useEffect(function () {
    if (observer) {
      observer.activeTabId = selectedTabId;
    }

    if (moveOnSelectChange) {
      setIsMoving(uuidv4());
    }
  }, [selectedTabId]);
  useLayoutEffect(function () {
    if (isMoving) {
      var tabIndex = tabArray.findIndex(function (tab) {
        return tab.id === selectedTabId;
      });

      if (tabIndex !== -1 && !tabArray[tabIndex].isVisible) {
        if (tabIndex > tabsHiddenLeft) {
          //move to the right one
          setIsMoving(uuidv4());
          onRightClick();
        } else if (tabIndex < tabsHiddenLeft) {
          //the middle can't be hidden but including will mess up small views
          //move to the left one
          setIsMoving(uuidv4());
          setTabsHiddenLeft(tabsHiddenLeft > 0 ? tabsHiddenLeft - 1 : 0);
        }
      } else {
        setIsMoving('');
      }
    }
  }, [isMoving, selectedTabId]);
  useLayoutEffect(function () {
    var _a;

    var newTabArray = (_a = inputTabArray.current) === null || _a === void 0 ? void 0 : _a.map(function (item, i) {
      return _assign2(_assign2({}, item), {
        width: (tabWidths === null || tabWidths === void 0 ? void 0 : tabWidths.current) ? tabWidths.current[i] : 0
      });
    });

    if (newTabArray) {
      processTabArray(newTabArray, width);
    }
  }, [width, tabsHiddenLeft, tabsHiddenRight, JSON.stringify(tabWidths.current), selectedTabId, tabSpacing, JSON.stringify(inputTabArray.current), triggerRerender]);

  var generateIcon = function generateIcon(tab, _onClick) {
    if (tab.isHome) {
      return jsxRuntime_1("div", _assign2({
        style: {
          margin: 6,
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          cursor: 'pointer'
        },
        onClick: function onClick() {
          if (!tab.disabled && _onClick) {
            changeTab(tab.id);
          }
        }
      }, {
        children: jsxRuntime_1(XIIcon, {
          icon: "app_home",
          iconSize: "small",
          contrast: contrast
        }, void 0)
      }), void 0);
    } else if (tab.isPinned) {
      return jsxRuntime_1(IconButton, {
        icon: "pin_filled",
        buttonSize: "small",
        fill: "no-fill",
        contrast: contrast,
        onKeyPress: _onClick,
        onClick: _onClick
      }, void 0);
    } else if (tab.isCloseShown) {
      return jsxRuntime_1(IconButton, {
        icon: "cancel",
        buttonSize: "small",
        fill: "no-fill",
        contrast: contrast,
        onKeyPress: _onClick,
        onClick: _onClick
      }, void 0);
    }
  };
  /**
   * Takes in the tabs with widths and computes what tabs are displayed and which are in the menu
   */


  var processTabArray = function processTabArray(tabs, parentWidth) {
    var _a;

    if (!parentWidth || !((_a = tabs[tabs.length - 1]) === null || _a === void 0 ? void 0 : _a.width) || tabs.findIndex(function (tab) {
      return tab.width === undefined;
    }) !== -1) {
      return;
    }

    var outputTabs = tabs.map(function (tab) {
      return _assign2(_assign2({}, tab), {
        isVisible: false,
        isSelected: tab.id === selectedTabId
      });
    });
    var totalWidth = 0;
    var tabsHiddenRight = 0;
    var hiddenLeftPx = 0;
    var remainingSpace = 0;
    var tabsShown = 0;

    for (var i = 0; i < tabs.length; i++) {
      if (i < tabsHiddenLeft) {
        hiddenLeftPx += tabs[i].width;
        continue;
      }

      if (totalWidth + tabs[i].width > parentWidth || tabs[i].width === undefined) {
        tabsHiddenRight = tabs.length - i;
        remainingSpace = parentWidth - totalWidth;
        break;
      } else {
        totalWidth += tabs[i].width;
        tabsShown += 1;
        outputTabs[i].isVisible = true;
      }
    }

    var noVisibleTabs = outputTabs.every(function (tab) {
      return !tab.isVisible;
    });

    if (noVisibleTabs) {
      outputTabs[tabsHiddenLeft].isVisible = true;
    }

    var activeTabIndex = tabs.findIndex(function (tab) {
      return tab.id === selectedTabId;
    });
    setRemainingSpace(remainingSpace);
    setActiveLeft(activeTabIndex >= 0 && activeTabIndex < tabsHiddenLeft);
    setActiveRight(activeTabIndex >= tabs.length - tabsHiddenRight);
    setTabsHiddenRight(tabsHiddenRight);
    setLeftOffset(hiddenLeftPx);
    setTabArray(outputTabs);
    setTabsShown(tabsShown);

    if (isInitialRender) {
      setIsMoving(uuidv4());
      setIsInitialRender(false);
    }
  };

  var generateRoughTabs = function generateRoughTabs() {
    if (inputTabArray.current) {
      var roughTabsToGenerate = inputTabArray.current.slice();
      var roughTabs = roughTabsToGenerate.map(function (tab) {
        return jsxRuntime_1(TabBarItem, {
          title: tab.title,
          category: tab.category,
          id: "layout-" + tab.id,
          tabSpacing: tabSpacing,
          style: {
            marginRight: tabSpacing
          },
          alert: tab.alert,
          className: "kxi-tab-bar-item-rough",
          onWidthChange: function onWidthChange(width) {
            var _a, _b;

            var inputIndex = (_a = inputTabArray.current) === null || _a === void 0 ? void 0 : _a.findIndex(function (inputTab) {
              return tab.id === inputTab.id;
            });

            if (inputIndex === undefined || inputIndex < 0) {
              return;
            } // We use a useRef to keep the tab widths because updating a ref does not trigger a re-render.
            // This optimizes the code and prevents lost updates


            if (!tabWidths.current) {
              tabWidths.current = new Array((_b = inputTabArray.current) === null || _b === void 0 ? void 0 : _b.length);
            }

            if (tabWidths.current[inputIndex] !== width) {
              setTriggerRerender(uuidv4());
            }

            tabWidths.current[inputIndex] = width;
          },
          color: color,
          tooltip: tooltip,
          selected: tab.isSelected,
          contrast: contrast,
          maxCharsAllowed: maxCharsAllowed,
          disabled: tab.disabled,
          disabledReason: tab.disabledReason,
          icon: generateIcon(tab)
        }, "layout-" + tab.id + "-" + uuidv4());
      });
      return roughTabs;
    }
  };

  var changeTab = function changeTab(tabId) {
    if (componentControlledTabChange) {
      setSelectedTabId(tabId);
    }

    if (onTabChange) {
      onTabChange(tabArray.find(function (tab) {
        return tab.id === tabId;
      }));
    }
  };

  var generateFinalTabs = function generateFinalTabs() {
    var visibleTabs = tabArray.map(function (tab) {
      return jsxRuntime_1(TabBarItem, {
        title: tab.title,
        category: tab.category,
        id: tab.id,
        tabSpacing: tabSpacing,
        color: color,
        onClick: changeTab,
        tooltip: _assign2(_assign2({}, tooltip), {
          usePortal: true
        }),
        alert: tab.alert,
        selected: tab.isSelected,
        contrast: contrast,
        maxCharsAllowed: maxCharsAllowed,
        disabled: tab.disabled || !tab.isVisible,
        disabledReason: tab.disabledReason,
        className: "" + (tab.isVisible ? '' : 'kxi-horizontal-tab-hidden'),
        isVisible: tab.isVisible,
        style: stretch ? {
          height: height
        } : undefined,
        icon: generateIcon(tab, function () {
          if (onTabUnpin && tab.isPinned) {
            onTabUnpin(tab);
          } else if (onTabClose && tab.isCloseShown) {
            onTabClose(tab);
          }
        })
      }, "final-" + tab.id);
    });
    return visibleTabs;
  };

  var generateArrowTooltipText = function generateArrowTooltipText(tabsHidden) {
    if (!moreTabsTemplate) {
      return '';
    }

    var text = moreTabsTemplate;
    text = text.replace(/<%n>/g, "" + tabsHidden);

    if (tabsHidden > 1) {
      text = text.replace(/<%p\[(.*?)]>/g, '$1');
      text = text.replace(/<%s\[(.*?)]>/g, '');
    } else {
      text = text.replace(/<%p\[(.*?)]>/g, '');
      text = text.replace(/<%s\[(.*?)]>/g, '$1');
    }

    return text;
  };

  var generateArrowLeft = function generateArrowLeft() {
    var arrowLeft = jsxRuntime_2("div", _assign2({
      className: "kxi-horizontal-tab-bar-arrow",
      style: {
        width: tabsHiddenLeft === 0 ? '0' : '38px'
      }
    }, {
      children: [jsxRuntime_1(IconButton, {
        icon: "arrow_left",
        onClick: function onClick() {
          setTabsHiddenLeft(tabsHiddenLeft > 0 ? tabsHiddenLeft - 1 : 0);
        },
        contrast: contrast,
        disabled: tabsHiddenLeft === 0
      }, void 0), jsxRuntime_1("div", _assign2({
        className: "kxi-horizontal-tab-bar-arrow-indicator-wrapper " + (color ? normalizeColor(color) : '')
      }, {
        children: jsxRuntime_1("div", {
          className: "kxi-horizontal-tab-bar-arrow-indicator " + (activeLeft ? 'kxi-horizontal-tab-bar-arrow-active' : '') + " " + (contrast === 'high' ? 'kxi-high-contrast' : '')
        }, void 0)
      }), void 0)]
    }), void 0);

    if (moreTabsTemplate && tabsHiddenLeft > 0) {
      return jsxRuntime_1(ToolTipWrapper, _assign2({}, arrowTooltip, {
        title: generateArrowTooltipText(tabsHiddenLeft)
      }, {
        children: arrowLeft
      }), void 0);
    }

    return arrowLeft;
  };

  var onRightClick = function onRightClick() {
    var _a, _b, _c, _d;

    var amountToMove = 1;

    if (((_a = tabArray[tabsHiddenLeft]) === null || _a === void 0 ? void 0 : _a.width) + remainingSpace <= ((_b = tabArray[tabsHiddenLeft + tabsShown]) === null || _b === void 0 ? void 0 : _b.width)) {
      var spaceRequired = remainingSpace;
      var i = void 0;

      for (i = 0; i < tabsShown && spaceRequired < ((_c = tabArray[tabsHiddenLeft + tabsShown]) === null || _c === void 0 ? void 0 : _c.width); i++) {
        spaceRequired += (_d = tabArray[tabsHiddenLeft + i]) === null || _d === void 0 ? void 0 : _d.width;
      }

      amountToMove = i;
    }

    setTabsHiddenLeft(tabsHiddenLeft + amountToMove);
  };

  var generateArrowRight = function generateArrowRight() {
    var arrowRight = jsxRuntime_2("div", _assign2({
      className: "kxi-horizontal-tab-bar-arrow",
      style: {
        width: tabsHiddenRight === 0 ? '0' : '38px'
      }
    }, {
      children: [jsxRuntime_1(IconButton, {
        icon: "arrow_right",
        onClick: onRightClick,
        contrast: contrast,
        disabled: tabsHiddenRight === 0
      }, void 0), jsxRuntime_1("div", _assign2({
        className: "kxi-horizontal-tab-bar-arrow-indicator-wrapper " + (color ? normalizeColor(color) : '')
      }, {
        children: jsxRuntime_1("div", {
          className: "kxi-horizontal-tab-bar-arrow-indicator " + (activeRight ? 'kxi-horizontal-tab-bar-arrow-active' : '') + " " + (contrast === 'high' ? 'kxi-high-contrast' : '')
        }, void 0)
      }), void 0)]
    }), void 0);

    if (moreTabsTemplate && tabsHiddenRight > 0) {
      return jsxRuntime_1(ToolTipWrapper, _assign2({}, arrowTooltip, {
        title: generateArrowTooltipText(tabsHiddenRight)
      }, {
        children: arrowRight
      }), void 0);
    }

    return arrowRight;
  };

  return jsxRuntime_2("div", _assign2({
    role: "toolbar",
    "aria-label": "horizontal tab bar",
    className: "kxi-horizontal-tab-bar " + (hasTransparentBackground ? 'kxi-tab-bar-transparent' : '') + " " + (color ? normalizeColor(color) : '') + " " + (stretch ? 'kxi-stretch-height' : '') + " " + (contrast === 'high' ? ' kxi-high-contrast' : '')
  }, {
    children: [generateArrowLeft(), jsxRuntime_1(ReactResizeDetector, _assign2({
      handleWidth: true,
      onResize: useCallback(function (w, h) {
        setWidth(w);
        setHeight(h);
      }, []),
      targetRef: widthRef
    }, {
      children: jsxRuntime_1("div", _assign2({
        className: "kxi-horizontal-tab-bar-tab-container"
      }, {
        children: jsxRuntime_2("div", _assign2({
          role: "tablist",
          id: tabBarId,
          ref: mergeRefs([widthRef, ref]),
          className: "kxi-tab-bar-wrapper " + (hasTransparentBackground ? 'kxi-tab-bar-transparent' : '') + " " + (color ? normalizeColor(color) : '') + " " + (stretch ? 'kxi-stretch-height' : '') + " " + (contrast === 'high' ? ' kxi-high-contrast' : ''),
          "data-testid": "outerDiv"
        }, ingredients, {
          style: {
            position: 'relative',
            height: stretch ? undefined : categoryLayout ? 64 : 42
          }
        }, {
          children: [jsxRuntime_1("div", _assign2({
            style: {
              left: leftOffset * -1
            },
            className: "kxi-final-tab-wrapper"
          }, {
            children: generateFinalTabs()
          }), void 0), jsxRuntime_1("div", _assign2({
            id: tabBarId + "-layout",
            className: "kxi-tab-bar-layout-rough"
          }, {
            children: generateRoughTabs()
          }), tabBarId + "-layout")]
        }), "overallOuterDiv-" + tabBarId)
      }), void 0)
    }), "resizeDetector-" + tabBarId), generateArrowRight()]
  }), void 0);
});

var TabBarProps = function (_super) {
  __extends(TabBarProps, _super);

  function TabBarProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Array)], TabBarProps.prototype, "data");

  __decorate([Bound(), __metadata("design:type", String)], TabBarProps.prototype, "color");

  __decorate([Bound(), __metadata("design:type", String)], TabBarProps.prototype, "contrast");

  __decorate([Bound(), __metadata("design:type", String)], TabBarProps.prototype, "activeTabId");

  __decorate([Bound(), __metadata("design:type", Number)], TabBarProps.prototype, "tabSpacing");

  __decorate([Bound(), __metadata("design:type", Boolean)], TabBarProps.prototype, "hasTransparentBackground");

  __decorate([Bound(), __metadata("design:type", Boolean)], TabBarProps.prototype, "stretch");

  __decorate([Bound(), __metadata("design:type", Number)], TabBarProps.prototype, "maxTabs");

  __decorate([Bound(), __metadata("design:type", Object)], TabBarProps.prototype, "localization");

  __decorate([Bound(), __metadata("design:type", Number)], TabBarProps.prototype, "maxCharsAllowed");

  __decorate([Bound(), __metadata("design:type", Object)], TabBarProps.prototype, "tooltip");

  __decorate([Bound(), __metadata("design:type", DropdownProps)], TabBarProps.prototype, "dropdown");

  __decorate([Bound(), __metadata("design:type", Boolean)], TabBarProps.prototype, "componentControlledTabChange");

  return TabBarProps;
}(ObservablePropsMixin(DivHTMLAttributes));

var TabBarEvents = function (_super) {
  __extends(TabBarEvents, _super);

  function TabBarEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], TabBarEvents.prototype, "onTabChange");

  return TabBarEvents;
}(DivHTMLEvents);
/**
 * Description: Navigational component that contains clickable data.
 */


var TabBar = /*#__PURE__*/forwardRef(function (props, ref) {
  var data = props.data,
      color = props.color,
      contrast = props.contrast,
      activeTabId = props.activeTabId,
      tabSpacing = props.tabSpacing,
      hasTransparentBackground = props.hasTransparentBackground,
      stretch = props.stretch,
      _a = props.maxTabs,
      maxTabs = _a === void 0 ? 10 : _a,
      _b = props.localization,
      localizationInput = _b === void 0 ? {
    more: 'More'
  } : _b,
      _c = props.maxCharsAllowed,
      maxCharsAllowed = _c === void 0 ? 30 : _c,
      tooltip = props.tooltip,
      observer = props.observer,
      dropdown = props.dropdown,
      _d = props.componentControlledTabChange,
      componentControlledTabChange = _d === void 0 ? true : _d,
      onTabChange = props.onTabChange,
      ingredients = __rest(props, ["data", "color", "contrast", "activeTabId", "tabSpacing", "hasTransparentBackground", "stretch", "maxTabs", "localization", "maxCharsAllowed", "tooltip", "observer", "dropdown", "componentControlledTabChange", "onTabChange"]);

  var _e = __read(useState([]), 2),
      tabArray = _e[0],
      setTabArray = _e[1];

  var _f = __read(useState(uuidv4()), 1),
      tabBarId = _f[0];

  var _g = __read(useState(undefined), 2),
      width = _g[0],
      setWidth = _g[1];

  var _h = __read(useState(undefined), 2),
      height = _h[0],
      setHeight = _h[1];

  var _j = __read(useState(undefined), 2),
      menuWidth = _j[0],
      setMenuWidth = _j[1];

  var _k = __read(useState(undefined), 2),
      selectedTabId = _k[0],
      setSelectedTabId = _k[1];

  var _l = __read(useState({
    more: 'More'
  }), 2),
      localization = _l[0],
      setLocalization = _l[1];

  var _m = __read(useState(''), 2),
      triggerRerender = _m[0],
      setTriggerRerender = _m[1];

  var widthRef = useRef(null);
  var tabWidths = useRef(null);
  var inputTabArray = useRef(null);
  var menuTabRef = useRef(null);
  useEffect(function () {
    warnIsDeprecated('TabBar', {
      component: {
        message: 'TabBar will be replaced by HorizontalTabBar.',
        value: undefined
      }
    }, 'component');
  }, []);
  useEffect(function () {
    if (localizationInput && JSON.stringify(localizationInput) !== JSON.stringify(localization)) {
      setLocalization(localizationInput);
    }
  }, [localizationInput, localization]);
  useEffect(function () {
    setSelectedTabId(activeTabId);
  }, [activeTabId]);
  useEffect(function () {
    var newTabArray = [];

    for (var i = 0; i < data.length; i++) {
      var tab = {
        title: data[i].title,
        id: data[i].id,
        disabled: data[i].disabled,
        alert: data[i].alert,
        isSelected: false
      };
      newTabArray.push(tab);
    }

    inputTabArray.current = newTabArray;
    setTriggerRerender(uuidv4());
  }, [data]);
  useEffect(function () {
    if (observer) {
      observer.activeTabId = selectedTabId;
    }
  }, [selectedTabId]);
  useEffect(function () {
    var _a;

    var newTabArray = (_a = inputTabArray.current) === null || _a === void 0 ? void 0 : _a.map(function (item, i) {
      return _assign2(_assign2({}, item), {
        width: (tabWidths === null || tabWidths === void 0 ? void 0 : tabWidths.current) ? tabWidths.current[i] : 0
      });
    });

    if (newTabArray) {
      setTabArray(processTabArray(newTabArray, width, menuWidth));
    }
  }, [width, JSON.stringify(tabWidths.current), selectedTabId, menuWidth, tabSpacing, JSON.stringify(inputTabArray.current), triggerRerender]);
  /**
   * Takes in the tabs with widths and computes what tabs are displayed and which are in the menu
   */

  var processTabArray = function processTabArray(tabs, parentWidth, menuWidth) {
    var _a;

    if (!parentWidth || !((_a = tabs[0]) === null || _a === void 0 ? void 0 : _a.width) || !menuWidth) {
      return [];
    }

    var outputTabs = tabs.map(function (tab) {
      return _assign2(_assign2({}, tab), {
        isInMenu: false,
        isSelected: tab.id === selectedTabId
      });
    }); //determine if a menu is required

    var isMenuRequired = tabs.length > maxTabs || tabs.reduce(function (previous, tab) {
      return previous + tab.width;
    }, 0) > parentWidth;

    if (!isMenuRequired) {
      return outputTabs;
    } //make sure selected tab and menu are always visible


    var widthRemaining = parentWidth - menuWidth;
    var selectedItemIndex = tabs.findIndex(function (tab) {
      return tab.id === selectedTabId;
    });
    var currentTabs = 0;

    if (selectedItemIndex >= 0) {
      currentTabs++;
      widthRemaining -= tabs[selectedItemIndex].width;

      if (!widthRemaining) {
        return [];
      }
    } //go from 0 to end, skipping selectedItem and determine where to put the tab. Make sure not to exceed max tabs


    for (var i = 0; i < tabs.length; i++) {
      if (i === selectedItemIndex) continue;
      widthRemaining -= tabs[i].width;

      if (currentTabs < maxTabs && !widthRemaining) {
        return [];
      }

      if (widthRemaining <= 0 || currentTabs >= maxTabs) {
        outputTabs[i].isInMenu = true;
      }

      currentTabs++;
    }

    return outputTabs;
  };

  var generateMenu = function generateMenu(rough) {
    if (rough === void 0) {
      rough = false;
    }

    var menu = jsxRuntime_1("div", _assign2({
      ref: rough ? menuTabRef : undefined,
      className: "kxi-menu-item" + (rough ? '-rough' : '')
    }, {
      children: jsxRuntime_1(Dropdown, _assign2({
        data: tabArray.filter(function (tab) {
          return tab.isInMenu;
        }),
        placeholder: localization.more,
        inMenuSearch: true,
        onValueChange: function onValueChange(item) {
          if (!item.disabled) {
            if (componentControlledTabChange) {
              setSelectedTabId(item.id);
            }

            if (onTabChange) {
              onTabChange(tabArray.find(function (tab) {
                return tab.id === item.id;
              }));
            }
          }
        },
        select: "none",
        type: "text",
        color: "orca",
        contrast: contrast,
        localization: localization.dropdown
      }, dropdown), "menuDropdown")
    }), "menuItem");
    return rough ? jsxRuntime_1(ReactResizeDetector, _assign2({
      handleWidth: true,
      onResize: function onResize(width) {
        return setMenuWidth(width);
      },
      targetRef: menuTabRef
    }, {
      children: menu
    }), "resizeDetector-" + (rough ? 'rough-menu' : 'menu')) : menu;
  };

  var generateRoughTabs = function generateRoughTabs() {
    if (inputTabArray.current) {
      var roughTabsToGenerate = inputTabArray.current.slice(0, maxTabs);
      var selectedTabIndex = inputTabArray.current.findIndex(function (tab) {
        return tab.id === selectedTabId;
      });

      if (selectedTabIndex >= maxTabs) {
        roughTabsToGenerate = __spreadArray(__spreadArray([], __read(roughTabsToGenerate)), [inputTabArray.current[selectedTabIndex]]);
      }

      var roughTabs = roughTabsToGenerate.map(function (tab) {
        return jsxRuntime_1(TabBarItem, {
          title: tab.title,
          id: "layout-" + tab.id,
          tabSpacing: tabSpacing,
          style: {
            marginRight: tabSpacing
          },
          alert: tab.alert,
          className: "kxi-tab-bar-item-rough",
          onWidthChange: function onWidthChange(width) {
            var _a, _b;

            var inputIndex = (_a = inputTabArray.current) === null || _a === void 0 ? void 0 : _a.findIndex(function (inputTab) {
              return tab.id === inputTab.id;
            });

            if (inputIndex === undefined || inputIndex < 0) {
              return;
            } // We use a useRef to keep the tab widths because updating a ref does not trigger a re-render.
            // This optimizes the code and prevents lost updates


            if (!tabWidths.current) {
              tabWidths.current = new Array((_b = inputTabArray.current) === null || _b === void 0 ? void 0 : _b.length);
            }

            if (tabWidths.current[inputIndex] !== width) {
              setTriggerRerender(uuidv4());
            }

            tabWidths.current[inputIndex] = width;
          },
          color: color,
          tooltip: tooltip,
          selected: tab.isSelected,
          contrast: contrast,
          maxCharsAllowed: maxCharsAllowed,
          disabled: tab.disabled
        }, "layout-" + tab.id + "-" + uuidv4());
      });
      roughTabs.push(generateMenu(true));
      return roughTabs;
    }
  };

  var generateFinalTabs = function generateFinalTabs() {
    var visibleTabs = tabArray.map(function (tab) {
      return tab.isInMenu ? null : jsxRuntime_1(TabBarItem, {
        title: tab.title,
        id: tab.id,
        tabSpacing: tabSpacing,
        color: color,
        onClick: function onClick(tabId) {
          if (componentControlledTabChange) {
            setSelectedTabId(tabId);
          }

          if (onTabChange) {
            onTabChange(tabArray.find(function (tab) {
              return tab.id === tabId;
            }));
          }
        },
        tooltip: tooltip,
        alert: tab.alert,
        selected: tab.isSelected,
        contrast: contrast,
        maxCharsAllowed: maxCharsAllowed,
        disabled: tab.disabled,
        style: stretch ? {
          height: height
        } : {}
      }, "final-" + tab.id);
    });
    var hasMenu = tabArray.findIndex(function (tab) {
      return tab.isInMenu;
    }) >= 0;
    return jsxRuntime_2(jsxRuntime_3, {
      children: [visibleTabs, hasMenu ? generateMenu() : null]
    }, void 0);
  };

  return jsxRuntime_1(ReactResizeDetector, _assign2({
    handleWidth: true,
    onResize: useCallback(function (w, h) {
      setWidth(w);
      setHeight(h);
    }, []),
    targetRef: widthRef
  }, {
    children: jsxRuntime_2("div", _assign2({
      id: tabBarId,
      ref: mergeRefs([widthRef, ref]),
      className: "kxi-tab-bar " + (hasTransparentBackground ? 'kxi-tab-bar-transparent' : '') + " " + (color ? normalizeColor(color) : '') + " " + (stretch ? 'kxi-stretch-height' : '') + " " + (contrast === 'high' ? ' kxi-high-contrast' : ''),
      "data-testid": "outerDiv"
    }, ingredients, {
      children: [generateFinalTabs(), jsxRuntime_1("div", _assign2({
        id: tabBarId + "-layout",
        className: "kxi-tab-bar-layout-rough"
      }, {
        children: generateRoughTabs()
      }), tabBarId + "-layout")]
    }), "overallOuterDiv-" + tabBarId)
  }), "resizeDetector-" + tabBarId);
});

var VerticalTabBarProps = function (_super) {
  __extends(VerticalTabBarProps, _super);

  function VerticalTabBarProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Array)], VerticalTabBarProps.prototype, "data");

  __decorate([Bound(), __metadata("design:type", String)], VerticalTabBarProps.prototype, "color");

  __decorate([Bound(), __metadata("design:type", String)], VerticalTabBarProps.prototype, "activeTabId");

  __decorate([Bound(), __metadata("design:type", Object)], VerticalTabBarProps.prototype, "tooltipOptions");

  return VerticalTabBarProps;
}(ObservablePropsMixin(DivHTMLAttributes));

var VerticalTabBarEvents = function (_super) {
  __extends(VerticalTabBarEvents, _super);

  function VerticalTabBarEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], VerticalTabBarEvents.prototype, "onTabChange");

  return VerticalTabBarEvents;
}(DivHTMLEvents);
/**
 * Description: A vertical version of the tab bar using icons only
 */


var VerticalTabBar = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      data = props.data,
      activeTabId = props.activeTabId,
      _a = props.color,
      color = _a === void 0 ? 'orca' : _a,
      onTabChange = props.onTabChange,
      tooltipOptions = props.tooltipOptions,
      observer = props.observer,
      ingredients = __rest(props, ["className", "data", "activeTabId", "color", "onTabChange", "tooltipOptions", "observer"]);

  var _b = __read(useState(), 2),
      selectedTabId = _b[0],
      setSelectedTabId = _b[1];

  var _c = __read(useState([]), 2),
      tabList = _c[0],
      setTabList = _c[1];

  useEffect(function () {
    throwPropErrorMessage('VerticalTabBar', {
      data: data
    });
  }, []);
  useEffect(function () {
    setSelectedTabId(activeTabId);
  }, [activeTabId]);
  useEffect(function () {
    if (observer) {
      observer.activeTabId = selectedTabId;
    }
  }, [selectedTabId]);
  useEffect(function () {
    setTabList(data.map(function (tab) {
      return {
        icon: tab.icon,
        hasSeparator: tab.hasSeparator,
        id: tab.id || uuidv4(),
        hint: tab.hint
      };
    }));
  }, [data]);

  var handleKeyPress = function handleKeyPress(e, tab) {
    if (e.key === 'Enter' && (tab === null || tab === void 0 ? void 0 : tab.id)) {
      setSelectedTabId(tab === null || tab === void 0 ? void 0 : tab.id);
      if (onTabChange) onTabChange(tab);
    }
  };

  var generateTabs = function generateTabs(tabs) {
    return tabs.map(function (tab) {
      if (!tab.icon) {
        devOnlyWarn("The Kitchen - Vertical Tab Bar: You have not passed in an icon for tab id " + tab.id + ".");
      }

      var tabDOM = jsxRuntime_2("div", _assign2({
        tabIndex: 0,
        role: !tab.hint && !tab.hasSeparator ? 'tab' : undefined,
        "aria-label": "tab",
        "aria-describedby": tab.hint || tab.icon,
        className: "kxi-vertical-tab-bar-tab " + (tab.id === selectedTabId ? 'kxi-vertical-tab-bar-selected' : '') + " " + normalizeColor(color),
        onClick: function onClick() {
          setSelectedTabId(tab.id);
          if (onTabChange) onTabChange(tab);
        },
        onKeyPress: function onKeyPress(e) {
          return handleKeyPress(e, tab);
        },
        "data-testid": tab.id
      }, {
        children: [jsxRuntime_1("div", {
          className: "kxi-vertical-tab-bar-indicator " + (tab.id === selectedTabId ? 'kxi-vertical-tab-bar-selected' : ''),
          "data-testid": tab.id === selectedTabId ? 'vertical-tab-indicator' : ''
        }, void 0), jsxRuntime_1(XIIcon, {
          icon: tab.icon,
          iconSize: 30
        }, void 0)]
      }), "tab-" + tab.id);

      if (tab.hint) {
        tabDOM = /*#__PURE__*/createElement(ToolTipWrapper, _assign2({
          role: !tab.hasSeparator ? 'tab' : undefined,
          direction: 3
        }, tooltipOptions, {
          text: tab.hint,
          innerStyle: {
            display: undefined,
            width: '100%'
          },
          key: "tabWrapper-" + tab.id
        }), tabDOM);
      }

      if (tab.hasSeparator) {
        tabDOM = jsxRuntime_2("span", _assign2({
          onKeyPress: function onKeyPress(e) {
            return handleKeyPress(e, tab);
          },
          role: "tab",
          className: "kxi-separator-container"
        }, {
          children: [tabDOM, jsxRuntime_1("div", {
            className: "kxi-separator",
            "data-testid": "vertical-tab-separator"
          }, "separator-" + tab.id)]
        }), "separatorContainer-" + tab.id);
      }

      return tabDOM;
    });
  };

  return jsxRuntime_1("div", _assign2({
    role: "tablist"
  }, ingredients, {
    className: "kxi-vertical-tab-bar kxi-stretch-height " + (className || ''),
    ref: ref,
    "data-testid": "vertical-tab-root"
  }, {
    children: generateTabs(tabList)
  }), void 0);
});

var AddTagBox$1 = function AddTagBox(props) {
  var localization = props.localization,
      initialText = props.initialText,
      canDelete = props.canDelete,
      maxSuggestions = props.maxSuggestions,
      tagSearch = props.tagSearch,
      onTextChange = props.onTextChange,
      onDeleteClick = props.onDeleteClick,
      onFinalize = props.onFinalize,
      shouldPreventExpressTag = props.shouldPreventExpressTag;

  var _a = __read(React__default.useState([]), 2),
      suggestions = _a[0],
      setSuggestions = _a[1];

  var _b = __read(React__default.useState(initialText), 2),
      inputValue = _b[0],
      setInputValue = _b[1];

  var _c = __read(React__default.useState(inputValue ? '' : 'empty'), 2),
      preventAddingTag = _c[0],
      setPreventAddingTag = _c[1];

  var _d = __read(React__default.useState(false), 2),
      alternateDirection = _d[0],
      setAlternateDirection = _d[1];

  var _e = __read(React__default.useState(uuidv4()), 1),
      id = _e[0];

  var inputRef = React__default.useRef(null);
  React__default.useLayoutEffect(function () {
    if (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) {
      inputRef.current.focus();
    }
  }, [initialText]);
  var searchForTags = React__default.useMemo(function () {
    return debounce(function (value) {
      tagSearch && tagSearch(value).then(function (tags) {
        return setSuggestions(tags.map(function (t) {
          return {
            key: t.id,
            value: t.label
          };
        }));
      });
    }, 350);
  }, []);
  React__default.useEffect(function () {
    if (tagSearch && document.activeElement === inputRef.current) {
      searchForTags(inputValue);
    }

    if (inputValue && shouldPreventExpressTag) {
      setPreventAddingTag(shouldPreventExpressTag(inputValue));
    } else {
      setPreventAddingTag('');
    }
  }, [inputValue]);
  React__default.useEffect(function () {
    var _a;

    var bounds = (_a = document.getElementById(id)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();

    if (bounds && bounds.x + bounds.width > window.innerWidth) {
      setAlternateDirection(true);
    } else {
      setAlternateDirection(false);
    }
  }, []);

  var handleTextChange = function handleTextChange(e) {
    return __awaiter(void 0, void 0, void 0, function () {
      var value;
      return __generator(this, function (_a) {
        value = e.target.value;
        setInputValue(value);
        onTextChange(value);
        return [2
        /*return*/
        ];
      });
    });
  };

  var handleSuggestionClick = function handleSuggestionClick(kvp) {
    setInputValue(kvp.value);
    onTextChange(kvp.value);
  };

  return jsxRuntime_1("div", _assign2({
    className: "" + (alternateDirection ? '' : 'kxi-add-tag-box-position-set')
  }, {
    children: jsxRuntime_2("div", _assign2({
      className: "kxi-add-tag-box-outer " + (preventAddingTag ? 'kxi-add-tag-box-disabled' : '') + " " + (alternateDirection ? 'kxi-add-tag-box-alternate-direction' : ''),
      id: id
    }, {
      children: [jsxRuntime_1(InputField, {
        onChange: handleTextChange,
        _controlledState: true,
        ref: inputRef,
        value: inputValue,
        suggestions: suggestions && inputValue.length > 0 ? suggestions : undefined,
        onFocus: function onFocus() {
          return searchForTags(inputValue);
        },
        onSuggestionClick: handleSuggestionClick,
        maxSuggestions: maxSuggestions,
        status: preventAddingTag ? {
          state: 'error',
          text: preventAddingTag
        } : undefined
      }, void 0), jsxRuntime_2("div", _assign2({
        className: "kxi-add-tag-box-button-div " + (canDelete ? 'kxi-add-tag-box-button-div-with-trash' : 'kxi-add-tag-box-button-div-without-trash')
      }, {
        children: [jsxRuntime_1(DefaultButton, {
          "data-testid": "addTagSave",
          buttonSize: "small",
          text: canDelete ? localization.save : localization.addConfirm,
          onClick: onFinalize,
          disabled: !(inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) || !!preventAddingTag
        }, void 0), canDelete && jsxRuntime_1(IconButton, {
          icon: "trash",
          "data-testid": "addTagDelete",
          onClick: onDeleteClick
        }, void 0)]
      }), void 0)]
    }), void 0)
  }), void 0);
};

var TagItem$1 = function TagItem(props) {
  var tag = props.tag,
      onTagClick = props.onTagClick,
      selected = props.selected;
  return jsxRuntime_1("div", {
    children: !tag.highlighting || tag.highlighting.length === 0 ? jsxRuntime_2(jsxRuntime_3, {
      children: [jsxRuntime_1(DefaultButton, {
        color: "orca",
        text: "<b>" + (tag.label || ' ') + "</b>",
        fill: "fill",
        tone: "light",
        buttonSize: "small",
        onClick: function onClick() {
          if (onTagClick) onTagClick(tag, selected);
        },
        className: "kxi-tag-item-user-tag kxi-tag-item-button"
      }, void 0), tag.sentiment ? jsxRuntime_1("div", {
        className: "kxi-tag-item-sentiment-bar kxi-" + tag.sentiment,
        "data-testid": "tagSentimentBar"
      }, void 0) : null]
    }, void 0) : jsxRuntime_2(jsxRuntime_3, {
      children: [jsxRuntime_1(DefaultButton, {
        color: "orca",
        text: tag.label,
        fill: selected ? 'fill' : 'outline',
        style: selected ? {
          marginLeft: 1,
          marginRight: 1
        } : undefined,
        buttonSize: "small",
        onClick: function onClick() {
          if (onTagClick) onTagClick(tag, selected);
        },
        className: "kxi-tag-item-button"
      }, void 0), tag.sentiment ? jsxRuntime_1("div", {
        className: "kxi-tag-item-sentiment-bar kxi-" + tag.sentiment,
        "data-testid": "tagSentimentBar"
      }, void 0) : null]
    }, void 0)
  }, void 0);
};

var Tags$1 = function Tags(props) {
  var tagsIncoming = props.tags,
      tabs = props.tabs,
      localization = props.localization,
      maxSuggestions = props.maxSuggestions,
      expanded = props.expanded,
      condensedView = props.condensedView,
      activeTags = props.activeTags,
      onExpand = props.onExpand,
      onTagUpdate = props.onTagUpdate,
      _onTagClick = props.onTagClick,
      onSelectedTagsUpdate = props.onSelectedTagsUpdate,
      onTagSearch = props.onTagSearch,
      shouldPreventExpressTag = props.shouldPreventExpressTag;

  var _a = __read(useState(tabs[0]), 2),
      currentTab = _a[0],
      setCurrentTab = _a[1];

  var _b = __read(useState(activeTags || []), 2),
      selectedTags = _b[0],
      setSelectedTags = _b[1];

  var _c = __read(useState(), 2),
      selectedUserTag = _c[0],
      setSelectedUserTag = _c[1];

  var _d = __read(useState(tagsIncoming), 2),
      tags = _d[0],
      setTags = _d[1];

  useEffect(function () {
    setTags(tagsIncoming);
  }, [tagsIncoming]);
  useEffect(function () {
    onSelectedTagsUpdate(selectedTags);
  }, [selectedTags]);
  useEffect(function () {
    setSelectedTags(activeTags || []);
  }, [activeTags]);
  useEffect(function () {
    if (!selectedUserTag) {
      return;
    }

    var closeTagBox = function closeTagBox(e) {
      var eventPath = e.path;
      var boxWrapper = document.querySelector('.kxi-add-tag-box-outer');

      if (!(eventPath === null || eventPath === void 0 ? void 0 : eventPath.includes(boxWrapper))) {
        if (!(selectedUserTag === null || selectedUserTag === void 0 ? void 0 : selectedUserTag.isNew)) {
          var tagId = tags.findIndex(function (tag) {
            return tag.id === (selectedUserTag === null || selectedUserTag === void 0 ? void 0 : selectedUserTag.id);
          });

          if (tagId >= 0) {
            tags[tagId].label = selectedUserTag === null || selectedUserTag === void 0 ? void 0 : selectedUserTag.initialLabel;
          }
        }

        setSelectedUserTag(undefined);
      }
    };

    document.body.addEventListener('click', closeTagBox);
    return function () {
      document.body.removeEventListener('click', closeTagBox);
    };
  }, [selectedUserTag, condensedView]);
  var addTagDialogBox = jsxRuntime_1(AddTagBox$1, {
    initialText: (selectedUserTag === null || selectedUserTag === void 0 ? void 0 : selectedUserTag.initialLabel) || '',
    tagSearch: onTagSearch,
    onTextChange: function onTextChange(label) {
      setSelectedUserTag(_assign2(_assign2({}, selectedUserTag), {
        label: label
      }));

      if (!(selectedUserTag === null || selectedUserTag === void 0 ? void 0 : selectedUserTag.isNew)) {
        var tagId = tags.findIndex(function (tag) {
          return tag.id === (selectedUserTag === null || selectedUserTag === void 0 ? void 0 : selectedUserTag.id);
        });

        if (tagId >= 0) {
          tags[tagId].label = label;
        }
      }
    },
    onFinalize: function onFinalize() {
      if (tags.map(function (tag) {
        return tag.id;
      }).includes(selectedUserTag.id)) {
        var newTagArr = __spreadArray([], __read(tags));

        var tagIndex = newTagArr.findIndex(function (tag) {
          return tag.id === selectedUserTag.id;
        });

        if (tagIndex !== -1) {
          var updatedArr = __spreadArray(__spreadArray(__spreadArray([], __read(newTagArr.slice(0, tagIndex))), [selectedUserTag]), __read(newTagArr.slice(tagIndex + 1)));

          onTagUpdate(updatedArr, selectedUserTag, 'edit');
          setTags(updatedArr);
        }

        setSelectedUserTag(undefined);
      } else {
        onTagUpdate(__spreadArray(__spreadArray([], __read(tags)), [selectedUserTag]), selectedUserTag, 'add');
        setTags(__spreadArray(__spreadArray([], __read(tags)), [selectedUserTag]));
        setSelectedUserTag(undefined);
      }
    },
    canDelete: !!selectedUserTag && tags.map(function (tag) {
      return tag.id;
    }).includes(selectedUserTag === null || selectedUserTag === void 0 ? void 0 : selectedUserTag.id),
    onDeleteClick: function onDeleteClick() {
      var tagIndex = tags.findIndex(function (tag) {
        return tag.id === selectedUserTag.id;
      });

      if (tagIndex !== -1) {
        var newTags = __spreadArray([], __read(tags));

        newTags.splice(tagIndex, 1);
        onTagUpdate(newTags, selectedUserTag, 'delete');
        setTags(newTags);
      }

      setSelectedUserTag(undefined);
    },
    shouldPreventExpressTag: shouldPreventExpressTag,
    localization: localization,
    maxSuggestions: maxSuggestions
  }, void 0);

  var generateTag = function generateTag(tag) {
    return jsxRuntime_2("div", _assign2({
      className: "kxi-tag-object-wrapper"
    }, {
      children: [jsxRuntime_1(TagItem$1, {
        tag: tag,
        onTagClick: function onTagClick(tag, selected) {
          if (tag.userAdded) {
            setSelectedUserTag(_assign2(_assign2({}, tag), {
              initialLabel: tag.label
            }));
          } else if (tag.highlighting && tag.highlighting.length > 0) {
            _onTagClick(tag, selected);

            var tagIdIndex = selectedTags.findIndex(function (selectedTag) {
              return selectedTag.id === tag.id;
            });

            var newTagSelectedTags = __spreadArray([], __read(selectedTags));

            if (tagIdIndex !== -1) {
              newTagSelectedTags.splice(tagIdIndex, 1);
            } else {
              newTagSelectedTags.push(tag);
            }

            setSelectedTags(newTagSelectedTags);
          }
        },
        selected: selectedTags.findIndex(function (selectedTag) {
          return selectedTag.id === tag.id;
        }) >= 0
      }, void 0), (selectedUserTag === null || selectedUserTag === void 0 ? void 0 : selectedUserTag.id) === tag.id ? addTagDialogBox : null]
    }), tag.tagId || tag._internalTagId);
  };

  var generateInnerTags = function generateInnerTags(tab) {
    return jsxRuntime_2(jsxRuntime_3, {
      children: [tags.map(function (tag) {
        if (tag.tabId === tab.id) {
          return generateTag(tag);
        }
      }), selectedUserTag && !tags.map(function (tag) {
        return tag.id;
      }).includes(selectedUserTag.id) && selectedUserTag.tabId === tab.id ? generateTag(selectedUserTag) : null, (tab === null || tab === void 0 ? void 0 : tab.showAddTag) ? jsxRuntime_1(jsxRuntime_3, {
        children: jsxRuntime_1("div", _assign2({
          className: "kxi-tag-add-tag-outer-wrapper"
        }, {
          children: jsxRuntime_1("div", _assign2({
            className: "kxi-tag-add-tag-inner-wrapper"
          }, {
            children: jsxRuntime_1(DefaultButton, {
              color: "orca",
              className: "kxi-tag-add-tag-button kxi-tag-item-button",
              disabled: !!selectedUserTag,
              text: localization.add,
              isIconLeft: true,
              icon: selectedUserTag && selectedUserTag.tabId === tab.id ? 'add_circle_filled' : 'add_circle',
              buttonSize: "small",
              fill: "text",
              onClick: function onClick() {
                return setSelectedUserTag({
                  id: uuidv4(),
                  label: '',
                  tabId: tab === null || tab === void 0 ? void 0 : tab.id,
                  userAdded: true,
                  isNew: true,
                  initialLabel: ''
                });
              },
              "data-testid": "addTagButton"
            }, void 0)
          }), void 0)
        }), void 0)
      }, void 0) : undefined]
    }, void 0);
  };

  return condensedView ? jsxRuntime_1(jsxRuntime_3, {
    children: tabs.map(function (tab) {
      return jsxRuntime_1(AccordionItem, _assign2({
        title: tab.label + " (" + tags.filter(function (tag) {
          return tag.tabId === tab.id;
        }).length + ")",
        noPadding: true
      }, {
        children: jsxRuntime_1("div", _assign2({
          style: {
            display: 'flex',
            flexWrap: 'wrap'
          }
        }, {
          children: generateInnerTags(tab)
        }), void 0)
      }), void 0);
    })
  }, void 0) : jsxRuntime_2("div", {
    children: [jsxRuntime_1("div", _assign2({
      style: {
        height: 31,
        marginTop: -4,
        marginLeft: -12,
        marginRight: 12
      }
    }, {
      children: jsxRuntime_1(HorizontalTabBar, {
        activeTabId: currentTab === null || currentTab === void 0 ? void 0 : currentTab.id,
        stretch: true,
        data: tabs.map(function (tab) {
          return {
            id: tab.id,
            title: tab.label + " (" + tags.filter(function (tag) {
              return tag.tabId === tab.id;
            }).length + ")"
          };
        }),
        onTabChange: function onTabChange(tab) {
          onExpand();
          var newTabIndex = tabs.findIndex(function (inTab) {
            return inTab.id === tab.id;
          });
          if (newTabIndex !== -1) setCurrentTab(tabs[newTabIndex]);
        }
      }, void 0)
    }), void 0), expanded ? jsxRuntime_2(jsxRuntime_3, {
      children: [jsxRuntime_1("div", {
        style: {
          borderBottom: '1px solid',
          borderColor: XIColors.grey.light[80],
          marginRight: 11.5
        }
      }, void 0), jsxRuntime_1("div", _assign2({
        style: {
          display: 'flex',
          flexWrap: 'wrap'
        }
      }, {
        children: generateInnerTags(currentTab)
      }), void 0)]
    }, void 0) : null]
  }, void 0);
};

var errorOnUndefinedData = function errorOnUndefinedData(annotation) {
  for (var key in annotation) {
    if (annotation['userAdded'] !== true) {
      if (annotation[key] === undefined) {
        throw new Error("The Kitchen: You have passed a tag object to the ExperienceCard that has " + key + " as " + annotation[key] + ", this will cause erroneous behavior in the card.");
      }
    }
  }
};

var CommentProps = function (_super) {
  __extends(CommentProps, _super);

  function CommentProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], CommentProps.prototype, "externalId");

  __decorate([Bound(), __metadata("design:type", String)], CommentProps.prototype, "answerId");

  __decorate([Bound(), __metadata("design:type", Object)], CommentProps.prototype, "promptLabel");

  __decorate([Bound(), __metadata("design:type", String)], CommentProps.prototype, "text");

  __decorate([Bound(), __metadata("design:type", Array)], CommentProps.prototype, "sentimentAnnotations");

  __decorate([Bound(), __metadata("design:type", Array)], CommentProps.prototype, "tagAnnotations");

  __decorate([Bound(), __metadata("design:type", Array)], CommentProps.prototype, "tags");

  __decorate([Bound(), __metadata("design:type", Array)], CommentProps.prototype, "tabs");

  __decorate([Bound(), __metadata("design:type", Function)], CommentProps.prototype, "tagSearch");

  __decorate([Bound(), __metadata("design:type", Function)], CommentProps.prototype, "getTagSuggestions");

  __decorate([Bound(), __metadata("design:type", Number)], CommentProps.prototype, "maxSuggestions");

  __decorate([Bound(), __metadata("design:type", String)], CommentProps.prototype, "audioSrcUrl");

  __decorate([Bound(), __metadata("design:type", Array)], CommentProps.prototype, "imageSrcUrls");

  __decorate([Bound(), __metadata("design:type", Object)], CommentProps.prototype, "videoSrcUrl");

  __decorate([Bound(), __metadata("design:type", Array)], CommentProps.prototype, "mediaActions");

  __decorate([Bound(), __metadata("design:type", Object)], CommentProps.prototype, "genericModalProps");

  __decorate([Bound(), __metadata("design:type", Number)], CommentProps.prototype, "sentimentScore");

  __decorate([Bound(), __metadata("design:type", Object)], CommentProps.prototype, "sentimentConfidence");

  __decorate([Bound(), __metadata("design:type", Boolean)], CommentProps.prototype, "sentimentBarExpanded");

  __decorate([Bound(), __metadata("design:type", Boolean)], CommentProps.prototype, "showMoreMomentsLink");

  __decorate([Bound(), __metadata("design:type", Boolean)], CommentProps.prototype, "addTagVisible");

  __decorate([Bound(), __metadata("design:type", Object)], CommentProps.prototype, "highlightedText");

  __decorate([Bound(), __metadata("design:type", Object)], CommentProps.prototype, "localization");

  __decorate([Bound(), __metadata("design:type", Array)], CommentProps.prototype, "selectedTagIds");

  __decorate([Bound(), __metadata("design:type", Array)], CommentProps.prototype, "selectedSentiments");

  return CommentProps;
}(ObservablePropsMixin(DivHTMLAttributes));

var CommentEvents = function (_super) {
  __extends(CommentEvents, _super);

  function CommentEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], CommentEvents.prototype, "onTagChange");

  __decorate([Bound(), __metadata("design:type", Function)], CommentEvents.prototype, "onTagEvent");

  __decorate([Bound(), __metadata("design:type", Function)], CommentEvents.prototype, "onSentimentClick");

  __decorate([Bound(), __metadata("design:type", Function)], CommentEvents.prototype, "shouldPreventExpressTag");

  __decorate([Bound(), __metadata("design:type", Function)], CommentEvents.prototype, "shouldPreventUserTag");

  return CommentEvents;
}(DivHTMLEvents);
/**
 * Description: ExperienceCard Comment component - exposed as a standalone component.
 */


var Comment = /*#__PURE__*/forwardRef(function (props, ref) {
  var externalId = props.externalId,
      answerId = props.answerId,
      highlightedCommentId = props.highlightedCommentId,
      text = props.text,
      promptLabel = props.promptLabel,
      tagAnnotations = props.tagAnnotations,
      tagSearch = props.tagSearch,
      _a = props.maxSuggestions,
      maxSuggestions = _a === void 0 ? 5 : _a,
      sentimentAnnotations = props.sentimentAnnotations,
      audioSrcUrl = props.audioSrcUrl,
      imageSrcUrls = props.imageSrcUrls,
      videoSrcUrl = props.videoSrcUrl,
      sentimentScore = props.sentimentScore,
      sentimentConfidence = props.sentimentConfidence,
      showMoreMomentsLink = props.showMoreMomentsLink,
      sentimentBarExpanded = props.sentimentBarExpanded,
      _b = props.localization,
      localization = _b === void 0 ? {} : _b,
      observer = props.observer,
      _c = props.addTagVisible,
      addTagVisible = _c === void 0 ? true : _c,
      _d = props._isOnExperienceCard,
      _isOnExperienceCard = _d === void 0 ? false : _d,
      highlightedText = props.highlightedText,
      _e = props.selectedSentiments,
      selectedSentiments = _e === void 0 ? [] : _e,
      _f = props.selectedTagIds,
      selectedTagIds = _f === void 0 ? [] : _f,
      genericModalProps = props.genericModalProps,
      mediaActions = props.mediaActions,
      tags = props.tags,
      _g = props.tabs,
      tabs = _g === void 0 ? [] : _g,
      _setHighlightedCommentId = props._setHighlightedCommentId,
      _internalOnTagChange_deprecated = props._internalOnTagChange_deprecated,
      onTagChange = props.onTagChange,
      onTagEvent = props.onTagEvent,
      onSentimentClick = props.onSentimentClick,
      shouldPreventExpressTag = props.shouldPreventExpressTag,
      shouldPreventUserTag = props.shouldPreventUserTag,
      getTagSuggestions = props.getTagSuggestions;

  var _h = localization.comments,
      comments = _h === void 0 ? {} : _h,
      _j = localization.sentimentButtons,
      sentimentButtons = _j === void 0 ? {} : _j,
      _k = localization.tags,
      tagLocalization = _k === void 0 ? {} : _k,
      _l = localization.emptyCommentText,
      emptyCommentText = _l === void 0 ? 'No comment provided' : _l; // localization defaults

  comments.sentiment = comments.sentiment || 'Sentiment';
  comments.sentimentScore = comments.sentimentScore || 'Sentiment Score';
  comments.andSentiment = comments.andSentiment || 'and Sentiment';
  comments.confidenceLevel = comments.confidenceLevel || 'Confidence Level';
  comments.tags = comments.tags || 'Tags';
  comments.moreMoments = comments.moreMoments || 'More Like This';
  comments.sentiment = comments.sentiment || 'Sentiment';
  comments.confident = comments.confident || 'Confident';
  sentimentButtons.positive = sentimentButtons.positive || 'Positive';
  sentimentButtons.neutral = sentimentButtons.neutral || 'Neutral';
  sentimentButtons.negative = sentimentButtons.negative || 'Negative';
  tagLocalization.add = tagLocalization.add || 'Add Tag';
  tagLocalization.addConfirm = tagLocalization.addConfirm || 'Add Tag';
  tagLocalization.save = tagLocalization.save || 'Save'; // size to switch media queries

  var screenBreakSize = 480;

  var _m = __read(useState(externalId + "-" + uuidv4()), 1),
      uuid = _m[0];

  var _o = __read(useState(sentimentBarExpanded), 2),
      expanded = _o[0],
      setExpanded = _o[1];

  var _p = __read(useState([]), 2),
      combinedTags_deprecated = _p[0],
      setCombinedTags_deprecated = _p[1];

  var _q = __read(useState([]), 2),
      activeSentiments = _q[0],
      setActiveSentiments = _q[1];

  var _r = __read(useState([]), 2),
      highlightedSentiments = _r[0],
      setHighlightedSentiments = _r[1];

  var _s = __read(useState(0), 2),
      totalTagLength_deprecated = _s[0],
      setTotalTagLength_deprecated = _s[1];

  var _t = __read(useState([]), 2),
      activeTags = _t[0],
      setActiveTags = _t[1];

  var _u = __read(useState(false), 2),
      showCondensedView = _u[0],
      setShowCondensedView = _u[1];

  var _v = __read(useState(uuidv4()), 2),
      _forceUpdate = _v[0],
      forceUpdate = _v[1];

  var outerResizeRef = useRef(null);
  var activeTagRef_deprecated = useRef([]);
  var moreSelected = highlightedCommentId === answerId && _isOnExperienceCard;
  useEffect(function () {
    var newHighlightedSentiments = [];
    var newActiveSentiments = activeSentiments;
    newHighlightedSentiments = selectedSentiments;

    _SentimentsOptions.forEach(function (sentiment) {
      if (!selectedSentiments.includes(sentiment) && highlightedSentiments.includes(sentiment)) {
        newActiveSentiments = newActiveSentiments.filter(function (activeSentiment) {
          return SentimentEnum[activeSentiment.sentiment] !== sentiment;
        });
      } else if (selectedSentiments.includes(sentiment) && !highlightedSentiments.includes(sentiment)) {
        var additionalActiveSentiments = (sentimentAnnotations === null || sentimentAnnotations === void 0 ? void 0 : sentimentAnnotations.filter(function (activeSentiment) {
          return SentimentEnum[activeSentiment.sentiment] === sentiment;
        })) || [];
        newActiveSentiments = __spreadArray(__spreadArray([], __read(newActiveSentiments)), __read(additionalActiveSentiments));
      }
    });

    setHighlightedSentiments(newHighlightedSentiments);
    setActiveSentiments(newActiveSentiments);
  }, [JSON.stringify(selectedSentiments)]);
  useEffect(function () {
    if (!combinedTags_deprecated.length) return;
    var newActiveTags = [];
    selectedTagIds.forEach(function (tag) {
      var combinedTagIndex = combinedTags_deprecated.findIndex(function (combinedTags_deprecated) {
        return combinedTags_deprecated.tagId === tag;
      });
      if (combinedTags_deprecated[combinedTagIndex]) newActiveTags.push(combinedTags_deprecated[combinedTagIndex]);
    });
    activeTagRef_deprecated.current = newActiveTags;
    forceUpdate(uuidv4());
  }, [JSON.stringify(selectedTagIds), combinedTags_deprecated]);
  useEffect(function () {
    if (!(tags === null || tags === void 0 ? void 0 : tags.length)) return;
    var newActiveTags = [];
    selectedTagIds.forEach(function (tagId) {
      var tagIndex = tags.findIndex(function (tag) {
        return tag.id === tagId;
      });

      if (tagIndex !== -1) {
        newActiveTags.push(tags[tagIndex]);
      }
    });
    setActiveTags(newActiveTags);
  }, [JSON.stringify(selectedTagIds), tags]); // some tags use the same tag for words at multiple positions. Combine them for singular display

  useEffect(function () {
    var _a;

    var tempCombinedTags = [];

    var _loop_1 = function _loop_1(i) {
      // setting all keys so function will catch undefined properties
      tagAnnotations[i].beginIndex = tagAnnotations[i].beginIndex;
      tagAnnotations[i].endIndex = tagAnnotations[i].endIndex;
      tagAnnotations[i].sentiment = tagAnnotations[i].sentiment;
      tagAnnotations[i].tagId = tagAnnotations[i].tagId;
      tagAnnotations[i].tag = tagAnnotations[i].tag;

      if (!tagAnnotations[i].userAdded) {
        tagAnnotations[i].userAdded = false;
      }

      errorOnUndefinedData(tagAnnotations[i]);
      var beginIndex = tagAnnotations[i].beginIndex || 0;
      var endIndex = tagAnnotations[i].endIndex || 0;
      var sentimentNum = tagAnnotations[i].sentiment || 0;
      var existingTagIndex = tempCombinedTags.findIndex(function (item) {
        return item.tagName === tagAnnotations[i].tag && item.userAdded === tagAnnotations[i].userAdded;
      });

      if (existingTagIndex >= 0) {
        tempCombinedTags[existingTagIndex].positions.push({
          beginIndex: beginIndex,
          endIndex: endIndex,
          sentimentType: 'tag',
          userAdded: tagAnnotations[i].userAdded
        });
      } else {
        tempCombinedTags.push({
          tagName: tagAnnotations[i].tag,
          tagId: tagAnnotations[i].tagId,
          sentiment: SentimentEnum[sentimentNum],
          positions: [{
            beginIndex: beginIndex,
            endIndex: endIndex,
            sentimentType: 'tag',
            userAdded: tagAnnotations[i].userAdded
          }],
          userAdded: tagAnnotations[i].userAdded || false
        });
      }
    };

    for (var i = 0; tagAnnotations && i < ((_a = tagAnnotations === null || tagAnnotations === void 0 ? void 0 : tagAnnotations.length) !== null && _a !== void 0 ? _a : 0); i++) {
      _loop_1(i);
    }

    setCombinedTags_deprecated(tempCombinedTags);
  }, [tagAnnotations]);

  var handleSentimentExpanded = function handleSentimentExpanded() {
    if (_isOnExperienceCard || tags) {
      setExpanded(function (state) {
        return !state;
      });
    } else {
      setExpanded(true);
    }
  };

  useEffect(function () {
    if (_isOnExperienceCard) {
      setExpanded(sentimentBarExpanded);
    } else {
      setExpanded(true);
    }
  }, [sentimentBarExpanded]);

  var handleTagUpdate_deprecated = function handleTagUpdate_deprecated(tags, tagId) {
    setTotalTagLength_deprecated(tags.length || 0);
    var tagAnnotationsCopy = (tagAnnotations === null || tagAnnotations === void 0 ? void 0 : tagAnnotations.filter(function (tag) {
      if (tag.userAdded) return tags.some(function (tagsTag) {
        return tagsTag.tagId === tag.tagId;
      });else return true;
    }).map(function (tag) {
      if (!tag.userAdded) return tag;else return {
        tag: tag.tag,
        userAdded: true,
        tagId: tag.tagId
      };
    })) || [];
    tags.forEach(function (tag) {
      if (tag.userAdded) {
        var annotationTagIndex = tagAnnotationsCopy === null || tagAnnotationsCopy === void 0 ? void 0 : tagAnnotationsCopy.findIndex(function (item) {
          return item.tagId === tag.tagId;
        });

        if (annotationTagIndex < 0) {
          tagAnnotationsCopy.push({
            tag: tag.tagName,
            userAdded: true,
            tagId: tag.tagId
          });
        } else {
          tagAnnotationsCopy[annotationTagIndex].tag = tag.tagName;
        }
      }
    });
    if (observer) observer.tagAnnotations = tagAnnotationsCopy;
    var activeTagIds = activeTagRef_deprecated.current.map(function (tag) {
      return tag.tagId;
    }).filter(function (tagId) {
      return tagId !== undefined;
    });
    if (onTagChange) onTagChange(tagAnnotationsCopy, tagId, answerId, activeTagIds);
    if (_internalOnTagChange_deprecated) _internalOnTagChange_deprecated(tagAnnotationsCopy, tagId, answerId, activeTagIds);
  };

  var handleTagUpdate = function handleTagUpdate(tags, tag, event) {
    if (observer) observer.tags = tags;
    if (onTagEvent) onTagEvent(tags, tag, answerId, activeTags, event);
  };

  var hasMedia = imageSrcUrls && imageSrcUrls.length || audioSrcUrl || videoSrcUrl;

  var returnMedia = function returnMedia() {
    if (imageSrcUrls && imageSrcUrls.length) {
      return jsxRuntime_1(ImageCarousel, {
        images: imageSrcUrls,
        genericModalProps: genericModalProps
      }, void 0);
    } else if (videoSrcUrl) {
      var videoPlayer = jsxRuntime_1(VideoPlayer, {
        source: videoSrcUrl,
        genericModalProps: genericModalProps
      }, void 0);

      if (mediaActions) {
        return jsxRuntime_2("div", {
          children: [videoPlayer, jsxRuntime_1("div", _assign2({
            className: "kxi-media-actions-wrapper"
          }, {
            children: mediaActions.map(function (action) {
              return jsxRuntime_1(IconButton, {
                icon: action.icon,
                onClick: action.onClick,
                tooltip: action.tooltip
              }, void 0);
            })
          }), void 0)]
        }, void 0);
      }

      return videoPlayer;
    } else if (audioSrcUrl) {
      return jsxRuntime_1(AudioPlayer, {
        source: audioSrcUrl
      }, void 0);
    }

    return null;
  };

  var commentOnlyClass = !_isOnExperienceCard ? 'kxi-comment-isolated' : '';
  var sentimentScoreDisplay = typeof sentimentScore === 'number' && !isNaN(sentimentScore) ? ": " + sentimentScore : '';

  var sentimentUpdate = function sentimentUpdate(sentiment, registerClick) {
    if (registerClick === void 0) {
      registerClick = true;
    }

    var newHighlightedSentiments;

    if (highlightedSentiments.includes(sentiment)) {
      //delete all active sentiments
      var newActiveSentiments = activeSentiments.filter(function (activeSentiment) {
        return SentimentEnum[activeSentiment.sentiment] !== sentiment;
      });
      setActiveSentiments(newActiveSentiments);
      newHighlightedSentiments = highlightedSentiments.filter(function (highlightedSentiment) {
        return highlightedSentiment !== sentiment;
      });
    } else {
      var newActiveSentiments = (sentimentAnnotations === null || sentimentAnnotations === void 0 ? void 0 : sentimentAnnotations.filter(function (activeSentiment) {
        return SentimentEnum[activeSentiment.sentiment] === sentiment;
      })) || [];
      setActiveSentiments(__spreadArray(__spreadArray([], __read(newActiveSentiments)), __read(activeSentiments)));
      newHighlightedSentiments = __spreadArray(__spreadArray([], __read(highlightedSentiments)), [sentiment]); //add all inactive sentiments
    }

    setHighlightedSentiments(newHighlightedSentiments);
    if (onSentimentClick && registerClick) onSentimentClick(sentiment);
  };

  var tagUpdate_deprecated = function tagUpdate_deprecated(tag) {
    if (!tag.userAdded) {
      var newActiveTags = __spreadArray([], __read(activeTagRef_deprecated.current));

      var activeTagIndex = newActiveTags.findIndex(function (activeTag) {
        return activeTag.tagId === tag.tagId;
      });

      if (activeTagIndex >= 0) {
        newActiveTags.splice(activeTagIndex, 1);
      } else {
        var combinedTagIndex = combinedTags_deprecated.findIndex(function (activeTag) {
          return activeTag.tagId === tag.tagId;
        });
        newActiveTags.push(combinedTags_deprecated[combinedTagIndex]);
      }

      activeTagRef_deprecated.current = newActiveTags;
      forceUpdate(uuidv4());
      var activeTagIds = activeTagRef_deprecated.current.map(function (tag) {
        return tag.tagId;
      }).filter(function (tagId) {
        return tagId !== undefined;
      });
      if (onTagChange) onTagChange(tagAnnotations || [], tag.tagId, answerId, activeTagIds);
      if (_internalOnTagChange_deprecated) _internalOnTagChange_deprecated(tagAnnotations || [], tag.tagId, answerId, activeTagIds);
    }
  };

  var handleTagClick = function handleTagClick(tag) {
    if (!tag.userAdded) {
      var activeTagIndex = activeTags.findIndex(function (activeTag) {
        return activeTag.id === tag.id;
      });

      if (activeTagIndex >= 0) {
        var outputActive = __spreadArray([], __read(activeTags));

        outputActive.splice(activeTagIndex, 1);
        if (onTagEvent) onTagEvent(tags || [], tag, answerId, outputActive, 'click');
      } else {
        if (onTagEvent) onTagEvent(tags || [], tag, answerId, __spreadArray(__spreadArray([], __read(activeTags)), [tag]), 'click');
      }
    }
  };

  var tagView = jsxRuntime_1(Tags$1, {
    tags: tags || [],
    tabs: tabs,
    localization: tagLocalization,
    maxSuggestions: maxSuggestions,
    onTagUpdate: handleTagUpdate,
    onTagClick: handleTagClick,
    onSelectedTagsUpdate: function onSelectedTagsUpdate(selectedTags) {
      return setActiveTags(selectedTags);
    },
    onTagSearch: getTagSuggestions,
    shouldPreventExpressTag: shouldPreventUserTag,
    expanded: expanded || false,
    onExpand: function onExpand() {
      setExpanded(true);
    },
    activeTags: activeTags || [],
    condensedView: showCondensedView
  }, void 0);
  var sentimentView = jsxRuntime_1(SentimentSection, {
    highlightedSentiments: highlightedSentiments,
    sentimentAnnotations: sentimentAnnotations,
    localization: localization.sentimentButtons,
    hasSeparator: !!tags && !showCondensedView,
    onSentimentClick: sentimentUpdate
  }, void 0);
  return jsxRuntime_1(ReactResizeDetector, _assign2({
    refreshMode: "debounce",
    refreshRate: 0,
    onResize: useCallback(function () {
      return setShowCondensedView(document.body.getBoundingClientRect().width < screenBreakSize);
    }, []),
    handleWidth: true,
    targetRef: outerResizeRef
  }, {
    children: jsxRuntime_2("div", _assign2({
      className: "kxi-comment-wrapper orca " + commentOnlyClass,
      id: uuid,
      ref: mergeRefs([ref, outerResizeRef])
    }, {
      children: [jsxRuntime_2("div", _assign2({
        className: "kxi-comment-header " + (!promptLabel ? 'no-prompt' : '') + " " + (moreSelected ? 'more' : '')
      }, {
        children: [jsxRuntime_1("div", {
          children: promptLabel
        }, void 0), showMoreMomentsLink && _isOnExperienceCard ? jsxRuntime_1("div", _assign2({
          className: "kxi-comment-more-wrapper cx " + (moreSelected ? 'more' : ''),
          onClick: function onClick() {
            if (_setHighlightedCommentId) _setHighlightedCommentId(answerId);
          },
          "data-testid": "more-moments"
        }, {
          children: comments.moreMoments
        }), void 0) : undefined]
      }), void 0), jsxRuntime_2("div", _assign2({
        className: "kxi-comment-body " + (audioSrcUrl && !imageSrcUrls && !videoSrcUrl ? 'show-column' : '') + " " + (!hasMedia ? '' : 'full-width')
      }, {
        children: [jsxRuntime_1("div", {
          children: text.length ? jsxRuntime_1(CommentText, {
            externalId: uuid,
            sentimentAnnotations: sentimentAnnotations,
            localization: comments,
            text: text,
            activeTags: tags ? activeTags : activeTagRef_deprecated.current,
            combinedTags: tags ? tags : combinedTags_deprecated,
            activeSentiments: activeSentiments,
            highlightedText: highlightedText
          }, void 0) : jsxRuntime_1("div", {
            children: emptyCommentText
          }, void 0)
        }, void 0), hasMedia ? jsxRuntime_1("div", _assign2({
          className: "kxi-comment-media-wrapper"
        }, {
          children: returnMedia()
        }), void 0) : null]
      }), void 0), text && showCondensedView && (tags || sentimentAnnotations) ? jsxRuntime_2(Accordion, {
        children: [tags ? tagView : null, sentimentAnnotations ? jsxRuntime_1(AccordionItem, _assign2({
          title: comments.sentiment + " " + sentimentScoreDisplay + " " + (typeof sentimentConfidence === 'number' && !isNaN(sentimentConfidence) ? " (" + getConfidenceAsPercent(sentimentConfidence || 0) + " " + comments.confident + ")" : ''),
          noPadding: true
        }, {
          children: sentimentView
        }), void 0) : null]
      }, void 0) : text && (!showCondensedView && tags || !tags) && (tags || tagAnnotations || sentimentAnnotations) && jsxRuntime_2("div", _assign2({
        className: "kxi-comment-expandable"
      }, {
        children: [(addTagVisible || !!tagAnnotations) && jsxRuntime_1("div", _assign2({
          className: "kxi-comment-tags-wrapper " + (tags ? 'kxi-comment-tags-new' : '') + " " + (sentimentAnnotations ? '' : 'kxi-stretch-width') + " " + (expanded ? 'expanded' : '')
        }, {
          children: jsxRuntime_2("div", _assign2({
            className: "kxi-comment-tag-text"
          }, {
            children: [showCondensedView ? jsxRuntime_2("div", _assign2({
              className: "kxi-comment-tags-header-condensed",
              onClick: handleSentimentExpanded
            }, {
              children: [tagAnnotations && !tags ? jsxRuntime_1("span", _assign2({
                className: "bold"
              }, {
                children: comments.tags + " (" + (totalTagLength_deprecated || combinedTags_deprecated.length || 0) + ") " + comments.andSentiment + sentimentScoreDisplay
              }), void 0) : null, showCondensedView && (sentimentAnnotations || tagAnnotations || addTagVisible) && !tags ? jsxRuntime_1("div", _assign2({
                className: "kxi-comment-expand-arrow " + (expanded ? 'expanded' : ''),
                onClick: handleSentimentExpanded
              }, {
                children: jsxRuntime_1(XIIcon, {
                  className: "single_arrow_down",
                  iconSize: 24,
                  icon: "single_arrow_down"
                }, void 0)
              }), void 0) : undefined]
            }), void 0) : tagAnnotations && !tags ? jsxRuntime_2("div", _assign2({
              className: "kxi-comment-tags-text-wrapper " + commentOnlyClass,
              onClick: handleSentimentExpanded
            }, {
              children: [jsxRuntime_1("span", _assign2({
                className: "bold"
              }, {
                children: comments.tags + " "
              }), void 0), jsxRuntime_2("span", _assign2({
                className: "kxi-comment-tags-count"
              }, {
                children: ["(", totalTagLength_deprecated || combinedTags_deprecated.length || 0, ")"]
              }), void 0)]
            }), void 0) : null, jsxRuntime_1("div", _assign2({
              className: (tagAnnotations && !tags ? 'kxi-comment-tags' : '') + " " + (!expanded && tagAnnotations && !tags ? 'kxi-comment-section-hidden' : '')
            }, {
              children: tagAnnotations && !tags ? jsxRuntime_1(Tags, {
                tags: combinedTags_deprecated,
                showAddTag: addTagVisible,
                localization: tagLocalization,
                selectedTagInput: selectedTagIds,
                maxSuggestions: maxSuggestions,
                onTagUpdate: handleTagUpdate_deprecated,
                onTagClick: tagUpdate_deprecated,
                tagSearch: tagSearch,
                shouldPreventExpressTag: shouldPreventExpressTag
              }, void 0) : tags ? tagView : null
            }), void 0)]
          }), void 0)
        }), void 0), sentimentAnnotations && jsxRuntime_2("div", _assign2({
          className: "kxi-comment-sentiment-section-wrapper " + (tags ? 'kxi-comment-tags-new' : '') + " " + (showCondensedView && !expanded ? 'kxi-comment-sentiment-hide' : ''),
          onClick: handleSentimentExpanded
        }, {
          children: [showCondensedView ? undefined : jsxRuntime_2("div", _assign2({
            className: "kxi-comment-sentiment-text " + (tags ? 'kxi-comment-tags-new' : '') + " " + commentOnlyClass
          }, {
            children: [jsxRuntime_2("span", {
              children: [jsxRuntime_2("span", _assign2({
                className: "bold"
              }, {
                children: [comments.sentiment, sentimentScoreDisplay]
              }), void 0), jsxRuntime_1("span", {
                children: typeof sentimentConfidence === 'number' && !isNaN(sentimentConfidence) ? " (" + getConfidenceAsPercent(sentimentConfidence || 0) + " " + comments.confident + ")" : null
              }, void 0)]
            }, void 0), tags ? jsxRuntime_1("div", _assign2({
              className: "kxi-comment-expand-arrow kxi-comment-tags-new " + (expanded ? 'expanded' : '')
            }, {
              children: jsxRuntime_1(XIIcon, {
                className: "single_arrow_down",
                iconSize: 24,
                icon: "single_arrow_down"
              }, void 0)
            }), void 0) : null]
          }), void 0), jsxRuntime_1("div", _assign2({
            className: "kxi-comment-sentiment-wrapper " + (expanded ? '' : 'kxi-comment-section-hidden'),
            onClick: function onClick(e) {
              return e.stopPropagation();
            }
          }, {
            children: sentimentView
          }), void 0)]
        }), void 0), _isOnExperienceCard && !showCondensedView && (sentimentAnnotations || tagAnnotations || addTagVisible) && !tags ? jsxRuntime_1("div", _assign2({
          className: "kxi-comment-expand-arrow " + (expanded ? 'expanded' : ''),
          onClick: handleSentimentExpanded
        }, {
          children: jsxRuntime_1(XIIcon, {
            className: "single_arrow_down",
            iconSize: 24,
            icon: "single_arrow_down"
          }, void 0)
        }), void 0) : undefined]
      }), void 0)]
    }), void 0)
  }), void 0);
});

var NoteFooter = function NoteFooter(props) {
  var _onClick = props.onClick,
      cancel = props.cancel,
      add = props.add,
      value = props.value;
  return jsxRuntime_2("div", _assign2({
    className: "kxi-note-footer orca"
  }, {
    children: [jsxRuntime_1(DefaultButton, {
      fill: "text",
      text: cancel,
      onClick: function onClick() {
        return _onClick('cancel');
      }
    }, void 0), jsxRuntime_1(DefaultButton, {
      text: add,
      disabled: value === '',
      onClick: function onClick() {
        return _onClick('add');
      }
    }, void 0)]
  }), void 0);
};

var Note = function Note(props) {
  var _a = props.note,
      text = _a.text,
      meta = _a.meta,
      _b = _a.id,
      id = _b === void 0 ? '' : _b,
      _c = props.localization,
      edit = _c.edit,
      cancel = _c.cancel,
      add = _c.add,
      locale = _c.locale,
      youWrote = _c.youWrote,
      index = props.index,
      onNoteChanged = props.onNoteChanged,
      onNoteDelete = props.onNoteDelete;

  var _d = __read(useState(false), 2),
      editingText = _d[0],
      setEditingText = _d[1];

  var _e = __read(useState(text), 2),
      areaText = _e[0],
      setAreaText = _e[1];

  var _f = __read(useState(text), 2),
      value = _f[0],
      setValue = _f[1];

  useEffect(function () {
    setAreaText(text);
  }, [text]);

  var handleButtonClick = function handleButtonClick(type) {
    if (type === 'add') {
      setAreaText(value);
      var noteObj = {
        text: value,
        meta: meta,
        id: id
      };
      onNoteChanged(noteObj, index);
    }

    setEditingText(false);
  };

  var editSpan = jsxRuntime_2("span", _assign2({
    className: "kxi-edit-text cx",
    onClick: function onClick() {
      return setEditingText(true);
    }
  }, {
    children: ["\xA0\xA0", edit]
  }), void 0);
  var mappedMeta = meta.map(function (metaItem, i) {
    var pipe = i !== meta.length - 1 ? '|' : '';
    var dateOptions = {
      day: 'numeric',
      month: 'short'
    };
    var timeOptions = {
      timeStyle: 'short'
    };
    var dateAndMonth = Intl.DateTimeFormat(locale, dateOptions).format(meta[0]);
    var time = Intl.DateTimeFormat(locale, timeOptions).format(meta[0]);
    return jsxRuntime_1("p", {
      children: i === 0 ? jsxRuntime_2(jsxRuntime_3, {
        children: [dateAndMonth, "\xA0\xA0", pipe, "\xA0\xA0", time, "\xA0\xA0", pipe, "\xA0\xA0"]
      }, void 0) : jsxRuntime_2(jsxRuntime_3, {
        children: [" ", meta[1] === 'self' ? youWrote : meta[1], " "]
      }, void 0)
    }, i);
  });
  return jsxRuntime_2("div", _assign2({
    className: "kxi-text-area kxi-text-normal"
  }, {
    children: [jsxRuntime_2("div", _assign2({
      className: "kxi-note-meta kxi-text-small"
    }, {
      children: [jsxRuntime_2("div", _assign2({
        className: "kxi-note-meta-wrapper"
      }, {
        children: [mappedMeta, " ", meta[1] === 'self' && !editingText ? editSpan : null]
      }), void 0), meta[1] === 'self' && !editingText ? jsxRuntime_1("div", _assign2({
        className: "kxi-trash-wrapper"
      }, {
        children: jsxRuntime_1(IconButton, {
          icon: "trash",
          onClick: function onClick() {
            var noteObj = {
              text: value,
              meta: meta,
              id: id
            };
            onNoteDelete(noteObj, index);
          }
        }, void 0)
      }), void 0) : null]
    }), void 0), editingText ? jsxRuntime_1("textarea", {
      onChange: function onChange(e) {
        return setValue(e.target.value);
      },
      value: value
    }, void 0) : jsxRuntime_1("p", _assign2({
      className: "kxi-note-text"
    }, {
      children: areaText
    }), void 0), editingText ? jsxRuntime_1(NoteFooter, {
      value: value,
      add: add,
      cancel: cancel,
      onClick: handleButtonClick
    }, void 0) : null]
  }), void 0);
};

var Notes = function Notes(props) {
  var notesRef = props.notesRef,
      notesWrapperRef = props.notesWrapperRef,
      _a = props.localization,
      localization = _a === void 0 ? {} : _a,
      isAddingNote = props.isAddingNote,
      observer = props.observer,
      _b = props.notesState,
      notesState = _b === void 0 ? [] : _b,
      setIsAddingNote = props.setIsAddingNote,
      _c = props.newNotePlaceholder,
      newNotePlaceholder = _c === void 0 ? 'Type a note and press enter to add.' : _c,
      setNotesState = props.setNotesState,
      setIsNotesOpen = props.setIsNotesOpen,
      onDelete = props.onDelete,
      onChange = props.onChange;
  localization.add = localization.add || 'Add';
  localization.cancel = localization.cancel || 'Cancel';
  localization.notes = localization.notes || 'Notes';
  localization.edit = localization.edit || 'Edit';
  localization.locale = localization.locale || 'en-US';
  localization.youWrote = localization.youWrote || 'You wrote';
  var notesLocalized = localization.notes,
      add = localization.add,
      cancel = localization.cancel;

  var _d = __read(useState(''), 2),
      value = _d[0],
      setValue = _d[1];

  var nextKeypressValid = useRef(true); //This ensures that a race condition does not exist between creating a new note and setting value

  var updateWithNewNote = function updateWithNewNote() {
    var temp = notesState.slice();
    var newItem = {
      text: value,
      meta: [new Date(), 'self']
    };
    temp.push(newItem);
    if (onChange) onChange(temp, '');
    if (observer) observer.notesData = _assign2(_assign2({}, observer.notesData), {
      notes: temp
    });
    setNotesState(temp);
    setValue('');
  };

  var updateNotes = function updateNotes(obj, i) {
    var temp = notesState.slice();
    temp[i] = obj;
    if (observer) observer.notesData = _assign2(_assign2({}, observer.notesData), {
      notes: temp
    });
    if (onChange) onChange(temp, temp[i].id || '');
    setNotesState(temp);
  };

  var deleteNotes = function deleteNotes(_obj, i) {
    var temp = notesState.slice();
    var deletedObj = temp[i];
    temp.splice(i, 1);
    if (onDelete) onDelete(temp, deletedObj.id || '');
  };

  useEffect(function () {
    setValue('');
  }, [isAddingNote]);

  var handleButtonClick = function handleButtonClick(type) {
    if (type === 'add') {
      updateWithNewNote();
    } else {
      setIsAddingNote(false);
      setIsNotesOpen(false);
    }
  };

  var handleKeyPress = function handleKeyPress(e) {
    if (e.key === 'Enter' || e.keyCode === 13) {
      handleButtonClick('add');
      nextKeypressValid.current = false;
    }
  };

  var mappedNotes = notesState.map(function (note, i) {
    return jsxRuntime_1(Note, {
      note: note,
      localization: localization,
      index: i,
      onNoteChanged: updateNotes,
      onNoteDelete: deleteNotes
    }, i);
  });
  var newNote = jsxRuntime_2("div", _assign2({
    className: "kxi-new-note"
  }, {
    children: [jsxRuntime_1("textarea", {
      ref: notesRef,
      value: value,
      placeholder: newNotePlaceholder,
      onChange: function onChange(e) {
        if (nextKeypressValid.current) setValue(e.target.value);else nextKeypressValid.current = true;
      },
      onKeyPress: handleKeyPress
    }, void 0), jsxRuntime_1(NoteFooter, {
      value: value,
      add: add,
      cancel: cancel,
      onClick: handleButtonClick
    }, void 0)]
  }), void 0);
  return jsxRuntime_2("div", _assign2({
    ref: notesWrapperRef,
    className: "kxi-notes-wrapper text-wrapper orca"
  }, {
    children: [(notesState.length || isAddingNote) && jsxRuntime_1("p", _assign2({
      className: "kxi-notes-header-text"
    }, {
      children: jsxRuntime_1("strong", {
        children: notesLocalized
      }, void 0)
    }), void 0), mappedNotes, isAddingNote ? newNote : null]
  }), void 0);
};

var CondensedExperienceCardProps = function (_super) {
  __extends(CondensedExperienceCardProps, _super);

  function CondensedExperienceCardProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Object)], CondensedExperienceCardProps.prototype, "comment");

  __decorate([Bound(), __metadata("design:type", String)], CondensedExperienceCardProps.prototype, "title");

  __decorate([Bound(), __metadata("design:type", String)], CondensedExperienceCardProps.prototype, "bannerSentiment");

  __decorate([Bound(), __metadata("design:type", String)], CondensedExperienceCardProps.prototype, "caseState");

  __decorate([Bound(), __metadata("design:type", String)], CondensedExperienceCardProps.prototype, "dueDateSentiment");

  __decorate([Bound(), __metadata("design:type", String)], CondensedExperienceCardProps.prototype, "dueDateTitle");

  __decorate([Bound(), __metadata("design:type", Number)], CondensedExperienceCardProps.prototype, "dropdownDirection");

  __decorate([Bound(), __metadata("design:type", Boolean)], CondensedExperienceCardProps.prototype, "hasAttachments");

  __decorate([Bound(), __metadata("design:type", Array)], CondensedExperienceCardProps.prototype, "iconButtons");

  __decorate([Bound(), __metadata("design:type", Boolean)], CondensedExperienceCardProps.prototype, "isFavorite");

  __decorate([Bound(), __metadata("design:type", Boolean)], CondensedExperienceCardProps.prototype, "isInteractable");

  __decorate([Bound(), __metadata("design:type", Boolean)], CondensedExperienceCardProps.prototype, "isOverdue");

  __decorate([Bound(), __metadata("design:type", Boolean)], CondensedExperienceCardProps.prototype, "isSelectable");

  __decorate([Bound(), __metadata("design:type", Boolean)], CondensedExperienceCardProps.prototype, "selected");

  __decorate([Bound(), __metadata("design:type", Boolean)], CondensedExperienceCardProps.prototype, "isTruncated");

  __decorate([Bound(), __metadata("design:type", Array)], CondensedExperienceCardProps.prototype, "kabobOptions");

  __decorate([Bound(), __metadata("design:type", Object)], CondensedExperienceCardProps.prototype, "localization");

  __decorate([Bound(), __metadata("design:type", Number)], CondensedExperienceCardProps.prototype, "newMessageCount");

  __decorate([Bound(), __metadata("design:type", Array)], CondensedExperienceCardProps.prototype, "meta");

  __decorate([Bound(), __metadata("design:type", Number)], CondensedExperienceCardProps.prototype, "titleScore");

  __decorate([Bound(), __metadata("design:type", String)], CondensedExperienceCardProps.prototype, "titleSentiment");

  __decorate([Bound(), __metadata("design:type", Object)], CondensedExperienceCardProps.prototype, "dueDateTooltip");

  __decorate([Bound(), __metadata("design:type", String)], CondensedExperienceCardProps.prototype, "highlightedText");

  __decorate([Bound(), __metadata("design:type", Boolean)], CondensedExperienceCardProps.prototype, "hasNotes");

  __decorate([Bound(), __metadata("design:type", Object)], CondensedExperienceCardProps.prototype, "notesData");

  return CondensedExperienceCardProps;
}(ObservablePropsMixin(DivHTMLAttributes));

var CondensedExperienceCardEvents = function (_super) {
  __extends(CondensedExperienceCardEvents, _super);

  function CondensedExperienceCardEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], CondensedExperienceCardEvents.prototype, "onAttachmentsClick");

  __decorate([Bound(), __metadata("design:type", Function)], CondensedExperienceCardEvents.prototype, "onCardClick");

  __decorate([Bound(), __metadata("design:type", Function)], CondensedExperienceCardEvents.prototype, "onKabobChange");

  __decorate([Bound(), __metadata("design:type", Function)], CondensedExperienceCardEvents.prototype, "onSelectedChange");

  __decorate([Bound(), __metadata("design:type", Function)], CondensedExperienceCardEvents.prototype, "onNotesChange");

  __decorate([Bound(), __metadata("design:type", Function)], CondensedExperienceCardEvents.prototype, "onNotesDelete");

  return CondensedExperienceCardEvents;
}(DivHTMLEvents);
/**
 * Description: A more condensed version of the Experience Card.
 */


var CondensedExperienceCard = /*#__PURE__*/forwardRef(function (props, ref) {
  var _a = props.bannerSentiment,
      bannerSentiment = _a === void 0 ? 'neutral' : _a,
      caseState = props.caseState,
      className = props.className,
      comment = props.comment,
      _b = props.dueDateSentiment,
      dueDateSentiment = _b === void 0 ? 'neutral' : _b,
      dueDateTitle = props.dueDateTitle,
      dropdownDirection = props.dropdownDirection,
      hasAttachments = props.hasAttachments,
      _c = props.iconButtons,
      iconButtons = _c === void 0 ? [] : _c,
      isFavorite = props.isFavorite,
      _d = props.isInteractable,
      isInteractable = _d === void 0 ? true : _d,
      isOverdue = props.isOverdue,
      _e = props.isTruncated,
      isTruncated = _e === void 0 ? false : _e,
      _f = props.isSelectable,
      isSelectable = _f === void 0 ? true : _f,
      selected = props.selected,
      kabobOptions = props.kabobOptions,
      _g = props.meta,
      meta = _g === void 0 ? [] : _g,
      _h = props.newMessageCount,
      newMessageCount = _h === void 0 ? 0 : _h,
      observer = props.observer,
      title = props.title,
      _j = props.hasNotes,
      hasNotes = _j === void 0 ? false : _j,
      _k = props.notesData,
      notesData = _k === void 0 ? {} : _k,
      titleScore = props.titleScore,
      _l = props.titleSentiment,
      titleSentiment = _l === void 0 ? 'neutral' : _l,
      dueDateTooltip = props.dueDateTooltip,
      highlightedText = props.highlightedText,
      onAttachmentsClick = props.onAttachmentsClick,
      onCardClick = props.onCardClick,
      onKabobChange = props.onKabobChange,
      onSelectedChange = props.onSelectedChange,
      onNotesChange = props.onNotesChange,
      onNotesDelete = props.onNotesDelete,
      ingredients = __rest(props, ["bannerSentiment", "caseState", "className", "comment", "dueDateSentiment", "dueDateTitle", "dropdownDirection", "hasAttachments", "iconButtons", "isFavorite", "isInteractable", "isOverdue", "isTruncated", "isSelectable", "selected", "kabobOptions", "meta", "newMessageCount", "observer", "title", "hasNotes", "notesData", "titleScore", "titleSentiment", "dueDateTooltip", "highlightedText", "onAttachmentsClick", "onCardClick", "onKabobChange", "onSelectedChange", "onNotesChange", "onNotesDelete"]);

  var _m = props.localization || {},
      _o = _m.dueDate,
      dueDate = _o === void 0 ? 'Due in' : _o,
      _p = _m.attachments,
      attachments = _p === void 0 ? 'View Attachments' : _p,
      _q = _m.details,
      details = _q === void 0 ? 'View Details' : _q,
      notes = _m.notes;

  var _r = __read(useState(false), 2),
      checkedState = _r[0],
      setCheckedState = _r[1];

  var _s = __read(useState(comment.text), 2),
      commentMarkup = _s[0],
      setCommentMarkup = _s[1];

  var caseIsClosed = caseState === 'closed';
  useEffect(function () {
    throwPropErrorMessage('CondensedExperienceCard', {
      comment: comment,
      title: title
    });
  }, []);

  var _t = useNotes(notesData, hasNotes, true),
      notesState = _t.notesState,
      notesPlaceholder = _t.placeholder,
      setNotesState = _t.setNotesState,
      setIsNotesOpen = _t.setIsNotesOpen,
      isAddingNote = _t.isAddingNote,
      setIsAddingNotes = _t.setIsAddingNotes,
      notesRef = _t.notesRef,
      notesWrapperRef = _t.notesWrapperRef,
      displayNotes = _t.displayNotes;

  useEffect(function () {
    setCheckedState(!!selected);
  }, [selected]);

  var handleCheck = function handleCheck(e) {
    setCheckedState(function (v) {
      if (observer) observer.selected = !v;
      if (onSelectedChange) onSelectedChange(e);
      return !v;
    });
  };

  var _u = __read(useHighlightText(highlightedText), 2),
      rawTextRef = _u[0],
      highlightedCommentText = _u[1];

  useLayoutEffect(function () {
    if (comment.tagAnnotations) {
      var spanStart_1 = '<span class="kxi-text-shadow orca">';
      var spanEnd_1 = '</span>';
      var modifications_1 = 0;
      var newCommentMarkup_1 = commentMarkup;
      comment.tagAnnotations.sort(function (a, b) {
        return a.beginIndex - b.beginIndex;
      }).forEach(function (annotation) {
        var beginIndex = annotation.beginIndex + modifications_1 * (spanStart_1.length + spanEnd_1.length);
        var endIndex = annotation.endIndex + modifications_1 * (spanStart_1.length + spanEnd_1.length);
        var stringStart = newCommentMarkup_1.slice(0, beginIndex);
        var stringMiddle = newCommentMarkup_1.slice(beginIndex, endIndex);
        var stringEnd = newCommentMarkup_1.slice(endIndex, newCommentMarkup_1.length);
        newCommentMarkup_1 = "" + stringStart + spanStart_1 + stringMiddle + spanEnd_1 + stringEnd;
        modifications_1++;
      });
      setCommentMarkup(newCommentMarkup_1);
    }
  }, [comment]);

  var getDueDate = function getDueDate() {
    var inner = jsxRuntime_2(jsxRuntime_3, {
      children: [!caseIsClosed && jsxRuntime_1(XIIcon, {
        icon: "clock",
        color: dueDateSentiment
      }, void 0), jsxRuntime_1("span", _assign2({
        className: "kxi-title kxi-text-600" + (kabobOptions ? ' kxi-kabob-menu' : '')
      }, {
        children: "" + dueDateTitle
      }), void 0)]
    }, void 0);
    return dueDateTooltip ? jsxRuntime_1(ToolTipWrapper, _assign2({}, dueDateTooltip, {
      children: inner
    }), void 0) : inner;
  };

  var textClassName = "kxi-comment-area" + (isTruncated ? " kxi-truncated" + (hasAttachments ? '' : ' kxi-truncated-details') : '');
  return jsxRuntime_1("div", _assign2({}, ingredients, {
    className: "kxi-condensed-experience-card " + (caseState ? '' : "kxi-" + bannerSentiment + " kxi-color-accent") + " kxi-normal-contrast " + (className || ''),
    ref: ref,
    onClick: isInteractable ? onCardClick : undefined
  }, {
    children: jsxRuntime_2("div", _assign2({
      className: "kxi-background-area" + (isInteractable ? ' kxi-interactable' : '') + " " + (isOverdue ? 'kxi-negative kxi-overdue' : isInteractable ? 'cx' : 'kxi-neutral') + (caseState ? " kxi-case-" + caseState : '') + (kabobOptions ? ' kxi-with-kabob' : '') + (isTruncated && !hasAttachments ? " kxi-truncated" : '')
    }, {
      children: [jsxRuntime_2("div", _assign2({
        className: "kxi-title-area"
      }, {
        children: [isSelectable && jsxRuntime_1(Checkbox, {
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          checked: checkedState,
          onChange: handleCheck
        }, void 0), titleScore !== undefined && jsxRuntime_1("span", _assign2({
          className: "kxi-title-score kxi-title kxi-" + titleSentiment
        }, {
          children: titleScore
        }), void 0), jsxRuntime_1("span", _assign2({
          className: titleScore ? undefined : "kxi-title" + (caseIsClosed ? '' : ' kxi-text-600') + " kxi-" + titleSentiment
        }, {
          children: title
        }), void 0)]
      }), void 0), jsxRuntime_2("div", _assign2({
        className: "kxi-title-area kxi-due-date kxi-" + dueDateSentiment
      }, {
        children: [dueDateTitle && jsxRuntime_2(jsxRuntime_3, {
          children: [!caseIsClosed && jsxRuntime_1("span", _assign2({
            className: "kxi-text-600"
          }, {
            children: dueDate + ": "
          }), void 0), getDueDate()]
        }, void 0), kabobOptions && jsxRuntime_1(Dropdown, {
          type: "icon",
          internalProps: {
            iconButton: {
              icon: 'kabob'
            }
          },
          direction: 5,
          color: "orca",
          data: kabobOptions,
          select: "none",
          onValueChange: onKabobChange
        }, void 0), iconButtons.length > 0 && jsxRuntime_1("div", _assign2({
          className: "kxi-title-area kxi-quick-actions kxi-icon-buttons-wrapper"
        }, {
          children: jsxRuntime_1(IconButtons, {
            notesRef: notesRef,
            notesWrapperRef: notesWrapperRef,
            isAddingNote: isAddingNote,
            isNotesOpen: displayNotes,
            isCondensedExperienceCard: true,
            limitIconButtonOverride: false,
            limitedIconButtonNumber: 4,
            iconButtons: iconButtons,
            tooltipDirection: 6,
            dropdownDirection: dropdownDirection,
            isFavorite: isFavorite,
            setIsAddingNote: setIsAddingNotes,
            setIsNotesOpen: setIsNotesOpen,
            setKabobActiveClick: function setKabobActiveClick() {}
          }, void 0)
        }), void 0)]
      }), void 0), !caseIsClosed && jsxRuntime_2(jsxRuntime_3, {
        children: [jsxRuntime_2("div", _assign2({
          className: "kxi-meta kxi-text-small"
        }, {
          children: [mapMeta(meta), newMessageCount > 0 && jsxRuntime_2(jsxRuntime_3, {
            children: [jsxRuntime_2("span", {
              children: ["" + (meta.length > 0 ? ' | ' : ''), jsxRuntime_1(CustomPill, {
                text: newMessageCount.toString(),
                color: "CX"
              }, void 0)]
            }, void 0), jsxRuntime_1(XIIcon, {
              icon: "email"
            }, void 0)]
          }, void 0)]
        }), void 0), jsxRuntime_1("div", {
          ref: rawTextRef,
          className: textClassName + ' kxi-visible-text',
          dangerouslySetInnerHTML: {
            __html: DOMPurify.sanitize(commentMarkup)
          }
        }, void 0), jsxRuntime_1("div", _assign2({
          className: textClassName + ' kxi-comment-highlighted kxi-warning'
        }, {
          children: highlightedCommentText
        }), void 0), hasAttachments && jsxRuntime_2("div", _assign2({
          className: "kxi-footer-area"
        }, {
          children: [jsxRuntime_1(XIIcon, {
            icon: "attach",
            color: "disabled"
          }, void 0), jsxRuntime_1("span", _assign2({
            className: "kxi-attachments",
            onClick: function onClick(e) {
              e.stopPropagation();
              if (onAttachmentsClick) onAttachmentsClick();
            }
          }, {
            children: attachments
          }), void 0)]
        }), void 0)]
      }, void 0), displayNotes ? jsxRuntime_1(Notes, {
        notesState: notesState,
        notesRef: notesRef,
        notesWrapperRef: notesWrapperRef,
        hasNotes: hasNotes,
        localization: notes,
        isAddingNote: isAddingNote,
        newNotePlaceholder: notesPlaceholder,
        onChange: onNotesChange,
        setIsAddingNote: setIsAddingNotes,
        setIsNotesOpen: setIsNotesOpen,
        setNotesState: setNotesState,
        onDelete: onNotesDelete,
        observer: observer
      }, void 0) : null, jsxRuntime_1("span", _assign2({
        onClick: isInteractable ? undefined : onCardClick,
        className: "cx kxi-footer-area kxi-details" + (isTruncated && !hasAttachments && caseState !== 'closed' ? " kxi-truncated" : '')
      }, {
        children: details
      }), void 0)]
    }), void 0)
  }), void 0);
});

var ExperienceCardProps = function (_super) {
  __extends(ExperienceCardProps, _super);

  function ExperienceCardProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Boolean)], ExperienceCardProps.prototype, "addTagVisible");

  __decorate([Bound(), __metadata("design:type", Number)], ExperienceCardProps.prototype, "titleScore");

  __decorate([Bound(), __metadata("design:type", String)], ExperienceCardProps.prototype, "sentiment");

  __decorate([Bound(), __metadata("design:type", Number)], ExperienceCardProps.prototype, "dropdownDirection");

  __decorate([Bound(), __metadata("design:type", String)], ExperienceCardProps.prototype, "title");

  __decorate([Bound(), __metadata("design:type", String)], ExperienceCardProps.prototype, "subtitle");

  __decorate([Bound(), __metadata("design:type", String)], ExperienceCardProps.prototype, "subtitleLogo");

  __decorate([Bound(), __metadata("design:type", Boolean)], ExperienceCardProps.prototype, "selectable");

  __decorate([Bound(), __metadata("design:type", Boolean)], ExperienceCardProps.prototype, "selected");

  __decorate([Bound(), __metadata("design:type", Boolean)], ExperienceCardProps.prototype, "isFavorite");

  __decorate([Bound(), __metadata("design:type", Boolean)], ExperienceCardProps.prototype, "collapsed");

  __decorate([Bound(), __metadata("design:type", String)], ExperienceCardProps.prototype, "highlightedCommentId");

  __decorate([Bound(), __metadata("design:type", Array)], ExperienceCardProps.prototype, "meta");

  __decorate([Bound(), __metadata("design:type", Array)], ExperienceCardProps.prototype, "comments");

  __decorate([Bound(), __metadata("design:type", Array)], ExperienceCardProps.prototype, "iconButtons");

  __decorate([Bound(), __metadata("design:type", Object)], ExperienceCardProps.prototype, "notesData");

  __decorate([Bound(), __metadata("design:type", Boolean)], ExperienceCardProps.prototype, "hasNotes");

  __decorate([Bound(), __metadata("design:type", Object)], ExperienceCardProps.prototype, "viewDetailsButton");

  __decorate([Bound(), __metadata("design:type", Object)], ExperienceCardProps.prototype, "footerButton");

  __decorate([Bound(), __metadata("design:type", Object)], ExperienceCardProps.prototype, "headerButton");

  __decorate([Bound(), __metadata("design:type", Number)], ExperienceCardProps.prototype, "maxSuggestions");

  __decorate([Bound(), __metadata("design:type", Object)], ExperienceCardProps.prototype, "localization");

  return ExperienceCardProps;
}(ObservablePropsMixin(DivHTMLAttributes));

var ExperienceCardEvents = function (_super) {
  __extends(ExperienceCardEvents, _super);

  function ExperienceCardEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], ExperienceCardEvents.prototype, "onSelectionChange");

  __decorate([Bound(), __metadata("design:type", Function)], ExperienceCardEvents.prototype, "onNotesChange");

  __decorate([Bound(), __metadata("design:type", Function)], ExperienceCardEvents.prototype, "onMoreClick");

  __decorate([Bound(), __metadata("design:type", Function)], ExperienceCardEvents.prototype, "onMarkValidClick");

  __decorate([Bound(), __metadata("design:type", Function)], ExperienceCardEvents.prototype, "onTagChange");

  __decorate([Bound(), __metadata("design:type", Function)], ExperienceCardEvents.prototype, "onNotesDelete");

  __decorate([Bound(), __metadata("design:type", Function)], ExperienceCardEvents.prototype, "onTagEvent");

  return ExperienceCardEvents;
}(DivHTMLEvents);
/**
 * Description: Smart Experience Card - highly configurable for all your Experience needs.
 */


var ExperienceCard = /*#__PURE__*/forwardRef(function (props, ref) {
  var titleScore = props.titleScore,
      _a = props.sentiment,
      sentiment = _a === void 0 ? '' : _a,
      subtitleLogo = props.subtitleLogo,
      title = props.title,
      subtitle = props.subtitle,
      selected = props.selected,
      _b = props.meta,
      meta = _b === void 0 ? [] : _b,
      _c = props.selectable,
      selectable = _c === void 0 ? true : _c,
      highlightedCommentId = props.highlightedCommentId,
      isFavorite = props.isFavorite,
      _d = props.iconButtons,
      iconButtons = _d === void 0 ? [] : _d,
      viewDetailsButton = props.viewDetailsButton,
      footerButton = props.footerButton,
      headerButton = props.headerButton,
      _e = props.localization,
      localization = _e === void 0 ? {} : _e,
      observer = props.observer,
      collapsed = props.collapsed,
      _f = props.comments,
      comments = _f === void 0 ? [] : _f,
      _g = props.hasNotes,
      hasNotes = _g === void 0 ? false : _g,
      _h = props.notesData,
      notesData = _h === void 0 ? {} : _h,
      _j = props.addTagVisible,
      addTagVisible = _j === void 0 ? true : _j,
      _k = props.maxSuggestions,
      maxSuggestions = _k === void 0 ? 5 : _k,
      onSelectionChange = props.onSelectionChange,
      onNotesChange = props.onNotesChange,
      onMoreClick = props.onMoreClick,
      onMarkValidClick = props.onMarkValidClick,
      onTagChange = props.onTagChange,
      onNotesDelete = props.onNotesDelete,
      onTagEvent = props.onTagEvent,
      dropdownDirection = props.dropdownDirection,
      ingredients = __rest(props, ["titleScore", "sentiment", "subtitleLogo", "title", "subtitle", "selected", "meta", "selectable", "highlightedCommentId", "isFavorite", "iconButtons", "viewDetailsButton", "footerButton", "headerButton", "localization", "observer", "collapsed", "comments", "hasNotes", "notesData", "addTagVisible", "maxSuggestions", "onSelectionChange", "onNotesChange", "onMoreClick", "onMarkValidClick", "onTagChange", "onNotesDelete", "onTagEvent", "dropdownDirection"]);

  var headerBtn = (footerButton === null || footerButton === void 0 ? void 0 : footerButton.text) ? _assign2({}, footerButton) : (headerButton === null || headerButton === void 0 ? void 0 : headerButton.text) ? _assign2({}, headerButton) : undefined;
  useEffect(function () {
    if (footerButton === null || footerButton === void 0 ? void 0 : footerButton.text) {
      devOnlyWarn('The Kitchen: The footerButton will be deprecated in a later release. Please change your configuration to use `headerButton` for your Experience Card.');

      if (!(footerButton === null || footerButton === void 0 ? void 0 : footerButton.onClick)) {
        devOnlyWarn('The Kitchen: You did not pass an onClick event to the footerButton on the ExperienceCard. Was this intended?');
      }
    }
  }, [footerButton]);
  useEffect(function () {
    if ((headerButton === null || headerButton === void 0 ? void 0 : headerButton.text) && !(headerButton === null || headerButton === void 0 ? void 0 : headerButton.onClick)) {
      devOnlyWarn('The Kitchen: You did not pass an onClick event to the headerButton on the ExperienceCard. Was this intended?');
    }
  }, [headerButton]);
  useEffect(function () {
    if (!(viewDetailsButton === null || viewDetailsButton === void 0 ? void 0 : viewDetailsButton.onClick)) {
      devOnlyWarn('The Kitchen: You did not pass an onClick event to the viewDetailsButton on the ExperienceCard. Was this intended?');
    }
  }, [viewDetailsButton]);

  var _l = useNotes(notesData, hasNotes),
      notesState = _l.notesState,
      notesPlaceholder = _l.placeholder,
      setNotesState = _l.setNotesState,
      setIsNotesOpen = _l.setIsNotesOpen,
      isAddingNote = _l.isAddingNote,
      setIsAddingNotes = _l.setIsAddingNotes,
      notesRef = _l.notesRef,
      notesWrapperRef = _l.notesWrapperRef,
      displayNotes = _l.displayNotes;

  var _m = __read(useState(''), 2),
      highlightedCommentIdState = _m[0],
      setHighlightedCommentIdState = _m[1];

  useEffect(function () {
    setHighlightedCommentIdState(highlightedCommentId || '');
  }, [highlightedCommentId]);

  var handleMoreMomentsClick = function handleMoreMomentsClick(id) {
    if (id === highlightedCommentIdState) {
      setHighlightedCommentIdState(undefined);
      if (observer) observer.highlightedCommentId = undefined;
      if (onMoreClick) onMoreClick(undefined);
    } else {
      setHighlightedCommentIdState(id);
      if (observer) observer.highlightedCommentId = id;
      if (onMoreClick) onMoreClick(id);
    }
  };

  var showHighlightedState = false;
  var hasInitialPromptLabel = false;
  var mappedComments = comments.map(function (comment, i) {
    if (comment.answerId === highlightedCommentIdState) showHighlightedState = true;

    var onIndividualCommentTagChange = comment.onTagChange,
        rest = __rest(comment, ["onTagChange"]);

    if (comment.promptLabel && i === 0) {
      hasInitialPromptLabel = true;
    }

    var handleTagChange_deprecated = function handleTagChange_deprecated(tags, tagId, answerId, selectedTagIds) {
      var index = comments.findIndex(function (item) {
        return item.answerId === answerId;
      });
      var tempArr = comments.slice();
      tempArr[index].tagAnnotations = tags;
      if (onIndividualCommentTagChange) onIndividualCommentTagChange(tags, tagId, answerId, selectedTagIds);
      if (observer) observer.comments = tempArr;
    };

    return jsxRuntime_1(Comment, _assign2({
      localization: localization,
      highlightedCommentId: highlightedCommentIdState,
      addTagVisible: addTagVisible,
      _setHighlightedCommentId: handleMoreMomentsClick,
      _internalOnTagChange_deprecated: handleTagChange_deprecated,
      _isOnExperienceCard: true,
      onTagChange: onTagChange,
      maxSuggestions: maxSuggestions,
      onTagEvent: onTagEvent
    }, rest), i);
  });
  var isHighlightedClass = showHighlightedState ? 'kxi-selected' : '';
  return jsxRuntime_2("div", _assign2({
    className: "kxi-experience-card orca " + isHighlightedClass + " " + (collapsed ? 'collapsed' : '') + " " + (sentiment === 'invalid' ? 'kxi-invalid' : !sentiment ? 'kxi-no-sentiment' : '')
  }, ingredients, {
    ref: ref
  }, {
    children: [jsxRuntime_1(ExperienceHeader, {
      title: title,
      titleScore: titleScore,
      selected: selected,
      sentiment: sentiment,
      viewDetailsButton: viewDetailsButton,
      localization: localization,
      headerButton: headerBtn,
      selectable: selectable,
      iconButtons: iconButtons,
      subtitle: subtitle,
      subtitleLogo: subtitleLogo,
      isFavorite: isFavorite,
      dropdownDirection: dropdownDirection,
      onMarkValidClick: onMarkValidClick,
      onSelectionChange: onSelectionChange,
      meta: meta,
      hasSeparator: false,
      observer: observer,
      _notesData: {
        isAddingNote: isAddingNote,
        isNotesOpen: displayNotes,
        notesRef: notesRef,
        notesWrapperRef: notesWrapperRef,
        setIsAddingNote: setIsAddingNotes,
        setIsNotesOpen: setIsNotesOpen
      }
    }, void 0), hasInitialPromptLabel ? jsxRuntime_1("div", {
      className: "kxi-extra-header-padding"
    }, void 0) : null, sentiment !== 'invalid' && jsxRuntime_1("div", _assign2({
      className: "kxi-inner-wrapper"
    }, {
      children: collapsed ? null : jsxRuntime_2(jsxRuntime_3, {
        children: [jsxRuntime_1("div", _assign2({
          className: (selectable ? 'kxi-comment-indent-left' : '') + " kxi-comments-wrapper"
        }, {
          children: mappedComments
        }), void 0), displayNotes ? jsxRuntime_1(Notes, {
          notesState: notesState,
          notesRef: notesRef,
          notesWrapperRef: notesWrapperRef,
          hasNotes: hasNotes,
          localization: localization.notes,
          isAddingNote: isAddingNote,
          newNotePlaceholder: notesPlaceholder,
          onChange: onNotesChange,
          setIsAddingNote: setIsAddingNotes,
          setIsNotesOpen: setIsNotesOpen,
          setNotesState: setNotesState,
          observer: observer,
          onDelete: onNotesDelete
        }, void 0) : null]
      }, void 0)
    }), void 0)]
  }), void 0);
});
var _ExperienceCardIconButtonTypesOptions = ['dropdown', 'tooltip', 'favorite', 'notes'];
var _ExperienceCardSentimentsOptions = ['positive', 'neutral', 'negative', 'invalid'];
var _ExperienceCardLogosOptions = ['inmoment_favicon_blue', 'inmoment_favicon_orca', 'inmoment_favicon_purple', 'inmoment_favicon_teal'];
var _ExperienceCardCasesOptions = ['open', 'closed'];

var BasicTileProps = function (_super) {
  __extends(BasicTileProps, _super);

  function BasicTileProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Number)], BasicTileProps.prototype, "padding");

  __decorate([Bound(), __metadata("design:type", String)], BasicTileProps.prototype, "color");

  __decorate([Bound(), __metadata("design:type", Boolean)], BasicTileProps.prototype, "hasBorder");

  __decorate([Bound(), __metadata("design:type", Boolean)], BasicTileProps.prototype, "hasTopBar");

  __decorate([Bound(), __metadata("design:type", Boolean)], BasicTileProps.prototype, "disabled");

  __decorate([Bound(), __metadata("design:type", Boolean)], BasicTileProps.prototype, "isInteractive");

  __decorate([Bound(), __metadata("design:type", Boolean)], BasicTileProps.prototype, "stretch");

  return BasicTileProps;
}(DivHTMLAttributes);

var BasicTileEvents = function (_super) {
  __extends(BasicTileEvents, _super);

  function BasicTileEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return BasicTileEvents;
}(DivHTMLEvents);
/**
 * Description: Tile that has a generic wrapper, that you can pass anything inside of as children of the component.
 */


var BasicTile = /*#__PURE__*/forwardRef(function (props, ref) {
  var padding = props.padding,
      disabled = props.disabled,
      style = props.style,
      _a = props.color,
      color = _a === void 0 ? 'orca' : _a,
      hasBorder = props.hasBorder,
      resetTransclusion = props.resetTransclusion,
      hasTranscluded = props.hasTranscluded,
      hasTranscludedContent = props.hasTranscludedContent,
      stretch = props.stretch,
      children = props.children,
      _b = props.isInteractive,
      isInteractive = _b === void 0 ? true : _b,
      className = props.className,
      _c = props.hasTopBar,
      hasTopBar = _c === void 0 ? true : _c,
      onClick = props.onClick,
      ingredients = __rest(props, ["padding", "disabled", "style", "color", "hasBorder", "resetTransclusion", "hasTranscluded", "hasTranscludedContent", "stretch", "children", "isInteractive", "className", "hasTopBar", "onClick"]);

  delete ingredients.transclude;

  var generateClassList = function generateClassList() {
    var classList = (className || '') + " kxi-basic-tile kxi-tile-shadows " + normalizeColor(color);
    if (stretch) classList += ' kxi-stretch';
    if (!children) classList += ' kxi-basic-tile-no-children';
    if (hasBorder) classList += ' kxi-basic-tile-border';
    if (disabled || !isInteractive) classList += ' kxi-tile-non-interactive';
    if (!hasTopBar) classList += ' kxi-basic-tile-no-top-bar';
    return classList;
  };

  var handleClick = function handleClick(e) {
    if (!disabled && onClick) onClick(e);
  };

  return jsxRuntime_1("div", _assign2({
    role: "region",
    "aria-disabled": disabled,
    "data-testid": "basic-tile",
    tabIndex: 0,
    className: generateClassList(),
    style: _assign2(_assign2({}, style), {
      padding: padding
    })
  }, ingredients, {
    ref: ref,
    onClick: handleClick
  }, {
    children: children ? children : jsxRuntime_1(Slot, {
      propsToWatch: [],
      resetTransclusion: resetTransclusion,
      hasTranscluded: hasTranscluded,
      hasTranscludedContent: hasTranscludedContent,
      "data-testid": "slot",
      name: "children"
    }, void 0)
  }), void 0);
});

var Wave = function Wave(props) {
  var opacity = props.opacity,
      top = props.top,
      left = props.left,
      cloud = props.cloud,
      testId = props.testId;
  return jsxRuntime_1("svg", _assign2({
    className: "kxi-wave-tile-waves " + normalizeColor(cloud),
    "data-testid": testId,
    style: {
      top: top,
      left: left
    },
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsxRuntime_1("path", {
      d: "M130.34467,0C185.69017,0,217.118,25.192,269.199,25.192,321.279,25.192,371.906,0,422.775,0,473.643,0,533.96,25.192,575.381,25.192,616.803,25.192,312.485,0,712.485,0V50.385H.562s-2.602-13.72,3.391-16.23C65.148,8.526,94.97768,0,130.34467,0Z",
      opacity: opacity
    }, void 0)
  }), void 0);
};

var WaveTileProps = function (_super) {
  __extends(WaveTileProps, _super);

  function WaveTileProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], WaveTileProps.prototype, "title");

  __decorate([Bound(), __metadata("design:type", String)], WaveTileProps.prototype, "subtitle");

  __decorate([Bound(), __metadata("design:type", String)], WaveTileProps.prototype, "size");

  __decorate([Bound(), __metadata("design:type", String)], WaveTileProps.prototype, "icon");

  __decorate([Bound(), __metadata("design:type", String)], WaveTileProps.prototype, "color");

  __decorate([Bound(), __metadata("design:type", Boolean)], WaveTileProps.prototype, "isActive");

  __decorate([Bound(), __metadata("design:type", Boolean)], WaveTileProps.prototype, "hasWave");

  __decorate([Bound(), __metadata("design:type", Boolean)], WaveTileProps.prototype, "hideSubtitleOnMobile");

  return WaveTileProps;
}(ButtonHTMLAttributes);

var WaveTileEvents = function (_super) {
  __extends(WaveTileEvents, _super);

  function WaveTileEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return WaveTileEvents;
}(ButtonHTMLEvents);
/**
 * Description: Standard, convenient tile that shows a lovely wave.
 */


var WaveTile = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      subtitle = props.subtitle,
      title = props.title,
      _a = props.size,
      size = _a === void 0 ? 'large' : _a,
      _b = props.isActive,
      isActive = _b === void 0 ? false : _b,
      _c = props.hasWave,
      hasWave = _c === void 0 ? true : _c,
      icon = props.icon,
      _d = props.color,
      color = _d === void 0 ? 'CX' : _d,
      hideSubtitleOnMobile = props.hideSubtitleOnMobile,
      onMouseOver = props.onMouseOver,
      onMouseLeave = props.onMouseLeave,
      ingredients = __rest(props, ["className", "subtitle", "title", "size", "isActive", "hasWave", "icon", "color", "hideSubtitleOnMobile", "onMouseOver", "onMouseLeave"]);

  useEffect(function () {
    throwPropErrorMessage('WaveTile', {
      title: title,
      subtitle: subtitle,
      icon: icon
    });
  }, []);

  var _e = __read(useState(-96), 2),
      firstWave = _e[0],
      setFirstWave = _e[1];

  var _f = __read(useState(-20), 2),
      secondWave = _f[0],
      setSecondWave = _f[1];

  var _g = __read(useState(-115), 2),
      thirdWave = _g[0],
      setThirdWave = _g[1];

  var handleHover = function handleHover(e) {
    setFirstWave(-212);
    setSecondWave(20);
    setThirdWave(-75);
    if (onMouseOver) onMouseOver(e);
  };

  var handleLeave = function handleLeave(e) {
    setFirstWave(-96);
    setSecondWave(-20);
    setThirdWave(-115);
    if (onMouseLeave) onMouseLeave(e);
  };

  var waveTop = size === 'large' ? -100 : -120;
  return jsxRuntime_2("button", _assign2({
    className: "kxi-button kxi-tile-shadows kxi-tile kxi-tile-button kxi-" + size + " kxi-" + (isActive ? 'active' : 'inactive') + " " + (className || '') + " " + normalizeColor(color) + " " + (hasWave ? 'kxi-wave-tile-wave' : ''),
    onMouseOver: handleHover,
    onMouseLeave: handleLeave
  }, ingredients, {
    ref: ref
  }, {
    children: [hasWave && jsxRuntime_2(jsxRuntime_3, {
      children: [jsxRuntime_1(Wave, {
        top: waveTop,
        left: firstWave,
        opacity: 1,
        cloud: color,
        testId: "Wave 1"
      }, void 0), jsxRuntime_1(Wave, {
        top: waveTop,
        left: secondWave,
        opacity: 0.2,
        cloud: color,
        testId: "Wave 2"
      }, void 0), jsxRuntime_1(Wave, {
        top: waveTop,
        left: thirdWave,
        opacity: 0.2,
        cloud: color,
        testId: "Wave 3"
      }, void 0)]
    }, void 0), jsxRuntime_1("div", _assign2({
      className: "kxi-wave-tile-mobile-icon"
    }, {
      children: size === 'large' && icon && jsxRuntime_1(XIIcon, {
        icon: icon,
        iconSize: 30,
        contrast: isActive ? 'high' : 'normal'
      }, void 0)
    }), void 0), jsxRuntime_2("div", _assign2({
      className: "kxi-wave-tile-body kxi-padding-left-normal kxi-padding-right-normal"
    }, {
      children: [size === 'large' && icon && jsxRuntime_1(XIIcon, {
        icon: icon,
        iconSize: 60
      }, void 0), title]
    }), void 0), jsxRuntime_2("div", _assign2({
      className: "kxi-wave-tile-footer kxi-align-center " + (isActive ? normalizeColor(color) : '') + " " + (hideSubtitleOnMobile ? 'kxi-wave-tile-subtitle-hidden' : '')
    }, {
      children: [jsxRuntime_1("span", _assign2({
        className: "kxi-wave-tile-subtitle"
      }, {
        children: subtitle
      }), void 0), size === 'large' && jsxRuntime_1(XIIcon, {
        icon: "arrow_right",
        contrast: isActive ? 'high' : 'normal',
        iconSize: 30
      }, void 0)]
    }), void 0), jsxRuntime_1("div", _assign2({
      className: "kxi-wave-tile-mobile " + (isActive ? normalizeColor(color) : '')
    }, {
      children: jsxRuntime_1(XIIcon, {
        icon: "arrow_right",
        contrast: isActive ? 'high' : 'normal',
        iconSize: 30
      }, void 0)
    }), void 0)]
  }), void 0);
});
var _WaveTileSizeOptions = ['small', 'large'];
highchartsAccessibility(Highcharts);
Highcharts.theme = {
  chart: {
    height: null
  },
  legend: {
    itemStyle: {
      color: XIColors.orca.primary,
      fontWeight: '400',
      fontFamily: 'IBM Plex Sans',
      fontSize: '12px'
    },
    itemHoverStyle: {
      color: XIColors.orca.light[30]
    },
    itemHiddenStyle: {
      color: XIColors.grey.light[60]
    },
    title: {
      style: {
        color: XIColors.orca.light[30],
        fontWeight: '400',
        fontFamily: 'IBM Plex Sans',
        fontSize: '12px'
      },
      text: 'Optional Title Text'
    },
    align: 'left'
  },
  xAxis: [{
    labels: {
      style: {
        color: XIColors.orca.light[30],
        fontWeight: '400',
        fontFamily: 'IBM Plex Sans',
        fontSize: '12px'
      },
      align: 'center'
    },
    gridLineDashStyle: 'Dash',
    tickLength: 8,
    gridLineColor: XIColors.grey.light[90],
    gridLineWidth: 1,
    lineColor: XIColors.grey.light[90],
    title: {
      text: 'Optional Title Text',
      style: {
        color: XIColors.orca.light[30],
        fontWeight: '400',
        fontFamily: 'IBM Plex Sans',
        fontSize: '14px'
      }
    }
  }],
  yAxis: [{
    labels: {
      style: {
        color: XIColors.orca.light[30],
        fontSize: '12px',
        fontWeight: '400',
        fontFamily: 'IBM Plex Sans'
      },
      align: 'center'
    },
    gridLineDashStyle: 'Solid',
    tickLength: 8,
    gridLineColor: XIColors.grey.light[90],
    gridLineWidth: 1,
    title: {
      style: {
        color: XIColors.orca.light[30],
        fontWeight: '400',
        fontFamily: 'IBM Plex Sans',
        fontSize: '14px'
      }
    }
  }],
  tooltip: {
    backgroundColor: XIColorUsage.silver,
    borderRadius: 6,
    borderColor: XIColors.grey.light[80],
    borderWidth: 1,
    padding: 8,
    shadow: false,
    shape: 'callout',
    style: {
      color: XIColors.orca.primary,
      fontWeight: '400',
      fontFamily: 'IBM Plex Sans',
      fontSize: '14px'
    }
  }
};
Highcharts.setOptions(Highcharts.theme);

var BarVariantChartProps = function (_super) {
  __extends(BarVariantChartProps, _super);

  function BarVariantChartProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Object)], BarVariantChartProps.prototype, "chartSettings");

  __decorate([Bound(), __metadata("design:type", String)], BarVariantChartProps.prototype, "title");

  __decorate([Bound(), __metadata("design:type", Boolean)], BarVariantChartProps.prototype, "semiboldTitle");

  __decorate([Bound(), __metadata("design:type", String)], BarVariantChartProps.prototype, "subtitle");

  __decorate([Bound(), __metadata("design:type", String)], BarVariantChartProps.prototype, "type");

  __decorate([Bound(), __metadata("design:type", Boolean)], BarVariantChartProps.prototype, "isStacked");

  __decorate([Bound(), __metadata("design:type", Object)], BarVariantChartProps.prototype, "seriesDataLabelOptions");

  __decorate([Bound(), __metadata("design:type", Array)], BarVariantChartProps.prototype, "seriesColors");

  __decorate([Bound(), __metadata("design:type", Object)], BarVariantChartProps.prototype, "xAxisSettings");

  __decorate([Bound(), __metadata("design:type", Object)], BarVariantChartProps.prototype, "yAxisSettings");

  __decorate([Bound(), __metadata("design:type", Array)], BarVariantChartProps.prototype, "data");

  __decorate([Bound(), __metadata("design:type", Object)], BarVariantChartProps.prototype, "secondaryYAxisSettings");

  __decorate([Bound(), __metadata("design:type", Object)], BarVariantChartProps.prototype, "secondaryYData");

  __decorate([Bound(), __metadata("design:type", String)], BarVariantChartProps.prototype, "legendTitle");

  __decorate([Bound(), __metadata("design:type", Boolean)], BarVariantChartProps.prototype, "legendVisibility");

  __decorate([Bound(), __metadata("design:type", Boolean)], BarVariantChartProps.prototype, "containerView");

  __decorate([Bound(), __metadata("design:type", Boolean)], BarVariantChartProps.prototype, "stretch");

  __decorate([Bound(), __metadata("design:type", Number)], BarVariantChartProps.prototype, "chartId");

  return BarVariantChartProps;
}(DivHTMLAttributes);

var BarVariantChartEvents = function (_super) {
  __extends(BarVariantChartEvents, _super);

  function BarVariantChartEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return BarVariantChartEvents;
}(DivHTMLEvents);
/**
 * Description: Chart with all bar variant varieties - Line, Bar & Column
 */


var BarVariantChart = /*#__PURE__*/forwardRef(function (props, ref) {
  var _a;

  var _b, _c, _d;

  var chartSettings = props.chartSettings,
      title = props.title,
      _e = props.semiboldTitle,
      semiboldTitle = _e === void 0 ? true : _e,
      subtitle = props.subtitle,
      _f = props.type,
      type = _f === void 0 ? 'column' : _f,
      isStacked = props.isStacked,
      seriesDataLabelOptions = props.seriesDataLabelOptions,
      seriesColors = props.seriesColors,
      xAxisSettings = props.xAxisSettings,
      yAxisSettings = props.yAxisSettings,
      secondaryYAxisSettings = props.secondaryYAxisSettings,
      secondaryYData = props.secondaryYData,
      _g = props.data,
      data = _g === void 0 ? [] : _g,
      legendTitle = props.legendTitle,
      _h = props.legendVisibility,
      legendVisibility = _h === void 0 ? true : _h,
      containerView = props.containerView,
      stretch = props.stretch,
      _j = props.chartId,
      chartId = _j === void 0 ? 0 : _j,
      ingredients = __rest(props, ["chartSettings", "title", "semiboldTitle", "subtitle", "type", "isStacked", "seriesDataLabelOptions", "seriesColors", "xAxisSettings", "yAxisSettings", "secondaryYAxisSettings", "secondaryYData", "data", "legendTitle", "legendVisibility", "containerView", "stretch", "chartId"]);

  var _k = __read(useState(false), 2),
      chartSettingsWarned = _k[0],
      setChartSettingsWarned = _k[1];

  var _l = __read(useState(Number("16.000" + chartId + "1")), 1),
      id = _l[0];

  useEffect(function () {
    if (chartSettings && !chartSettingsWarned) {
      warnIsDeprecated('BarVariantChart', {
        chartSettings: {
          message: 'Single `chartSettings` should be replaced with individually set props.',
          value: {
            chartSettings: chartSettings
          }
        }
      }, 'prop');
      setChartSettingsWarned(true);
    }
  }, [chartSettings]);
  useEffect(function () {
    onResize();
  }, [stretch]);
  var xAxis = (chartSettings === null || chartSettings === void 0 ? void 0 : chartSettings.xAxisSettings) || xAxisSettings;
  var xAxisLabels = xAxis === null || xAxis === void 0 ? void 0 : xAxis.labels;
  var yAxis = (chartSettings === null || chartSettings === void 0 ? void 0 : chartSettings.yAxisSettings) || yAxisSettings;
  var yAxisLabels = yAxis === null || yAxis === void 0 ? void 0 : yAxis.labels;
  var secondaryYAxis = (chartSettings === null || chartSettings === void 0 ? void 0 : chartSettings.secondaryYAxisSettings) || secondaryYAxisSettings;
  var secondaryYDataConfig = (chartSettings === null || chartSettings === void 0 ? void 0 : chartSettings.secondaryYData) || secondaryYData;
  var typeConfig = (chartSettings === null || chartSettings === void 0 ? void 0 : chartSettings.type) || type;
  var isStackedConfig = ((_b = chartSettings === null || chartSettings === void 0 ? void 0 : chartSettings.seriesOptions) === null || _b === void 0 ? void 0 : _b.isStacked) || isStacked;
  var dataConfig = (chartSettings === null || chartSettings === void 0 ? void 0 : chartSettings.data) || data;
  var seriesDataLabelsConfig = ((_c = chartSettings === null || chartSettings === void 0 ? void 0 : chartSettings.seriesOptions) === null || _c === void 0 ? void 0 : _c.dataLabels) || seriesDataLabelOptions;
  var chartTitle = (chartSettings === null || chartSettings === void 0 ? void 0 : chartSettings.title) || title;
  var chartSubtitle = (chartSettings === null || chartSettings === void 0 ? void 0 : chartSettings.subTitle) || subtitle;
  var outerResizeRef = useRef(null);

  var chartData = __spreadArray([], __read(dataConfig));

  if (secondaryYDataConfig) {
    var secondaryObject = _assign2(_assign2({}, secondaryYDataConfig), {
      type: 'line',
      yAxis: 1
    });

    chartData = __spreadArray(__spreadArray([], __read(chartData)), [secondaryObject]);
  }

  var chartOptions = {
    chart: {
      type: typeConfig
    },
    colors: ((_d = chartSettings === null || chartSettings === void 0 ? void 0 : chartSettings.seriesOptions) === null || _d === void 0 ? void 0 : _d.colors) || seriesColors,
    credits: {
      enabled: false
    },
    title: undefined,
    subtitle: undefined,
    legend: {
      align: 'right',
      enabled: (chartSettings === null || chartSettings === void 0 ? void 0 : chartSettings.legendVisibility) || legendVisibility,
      title: {
        text: (chartSettings === null || chartSettings === void 0 ? void 0 : chartSettings.legendTitle) || legendTitle
      }
    },
    xAxis: [{
      categories: xAxis === null || xAxis === void 0 ? void 0 : xAxis.categories,
      title: {
        text: xAxisLabels === null || xAxisLabels === void 0 ? void 0 : xAxisLabels.axisTitle,
        enabled: xAxisLabels === null || xAxisLabels === void 0 ? void 0 : xAxisLabels.axisTitleEnabled,
        style: {
          fontSize: (xAxisLabels === null || xAxisLabels === void 0 ? void 0 : xAxisLabels.axisTitleFontSize) ? xAxisLabels === null || xAxisLabels === void 0 ? void 0 : xAxisLabels.axisTitleFontSize : '14px'
        }
      },
      labels: {
        enabled: xAxisLabels === null || xAxisLabels === void 0 ? void 0 : xAxisLabels.axisNumbersEnabled,
        style: {
          color: xAxisLabels === null || xAxisLabels === void 0 ? void 0 : xAxisLabels.color
        }
      },
      tickColor: xAxisLabels === null || xAxisLabels === void 0 ? void 0 : xAxisLabels.color,
      lineColor: xAxisLabels === null || xAxisLabels === void 0 ? void 0 : xAxisLabels.color,
      gridLineWidth: (xAxis === null || xAxis === void 0 ? void 0 : xAxis.showGridLines) || (xAxis === null || xAxis === void 0 ? void 0 : xAxis.showGridLines) === undefined ? 1 : 0 // make the gridlines show if not set explicitly

    }],
    yAxis: [{
      min: (yAxis === null || yAxis === void 0 ? void 0 : yAxis.min) ? yAxis === null || yAxis === void 0 ? void 0 : yAxis.min : undefined,
      max: (yAxis === null || yAxis === void 0 ? void 0 : yAxis.max) ? yAxis === null || yAxis === void 0 ? void 0 : yAxis.max : undefined,
      title: {
        text: yAxisLabels === null || yAxisLabels === void 0 ? void 0 : yAxisLabels.axisTitle,
        enabled: yAxisLabels === null || yAxisLabels === void 0 ? void 0 : yAxisLabels.axisTitleEnabled,
        style: {
          fontSize: (yAxisLabels === null || yAxisLabels === void 0 ? void 0 : yAxisLabels.axisTitleFontSize) ? yAxisLabels.axisTitleFontSize : '14px'
        }
      },
      labels: {
        enabled: yAxisLabels === null || yAxisLabels === void 0 ? void 0 : yAxisLabels.axisNumbersEnabled,
        style: {
          color: yAxisLabels === null || yAxisLabels === void 0 ? void 0 : yAxisLabels.color
        }
      },
      lineColor: (yAxisLabels === null || yAxisLabels === void 0 ? void 0 : yAxisLabels.color) || XIColors.grey.light[90],
      gridLineWidth: (yAxis === null || yAxis === void 0 ? void 0 : yAxis.showGridLines) || (yAxis === null || yAxis === void 0 ? void 0 : yAxis.showGridLines) === undefined ? 1 : 0 // make the gridlines show if not set explicitly

    }, {
      min: (secondaryYAxis === null || secondaryYAxis === void 0 ? void 0 : secondaryYAxis.min) ? secondaryYAxis.min : undefined,
      max: (secondaryYAxis === null || secondaryYAxis === void 0 ? void 0 : secondaryYAxis.max) ? secondaryYAxis.max : undefined,
      title: {
        text: secondaryYAxis === null || secondaryYAxis === void 0 ? void 0 : secondaryYAxis.labels.axisTitle,
        enabled: secondaryYAxis === null || secondaryYAxis === void 0 ? void 0 : secondaryYAxis.labels.axisTitleEnabled,
        style: {
          color: secondaryYAxis === null || secondaryYAxis === void 0 ? void 0 : secondaryYAxis.labels.color
        }
      },
      labels: {
        style: {
          color: secondaryYAxis === null || secondaryYAxis === void 0 ? void 0 : secondaryYAxis.labels.color
        }
      },
      opposite: true
    }],
    plotOptions: (_a = {}, _a[typeConfig] = {
      dataLabels: {
        enabled: (seriesDataLabelsConfig === null || seriesDataLabelsConfig === void 0 ? void 0 : seriesDataLabelsConfig.enabled) === false ? false : true,
        backgroundColor: (seriesDataLabelsConfig === null || seriesDataLabelsConfig === void 0 ? void 0 : seriesDataLabelsConfig.showBackground) ? 'rgba(255, 255, 255, 0.7)' : 'transparent',
        style: {
          fontSize: seriesDataLabelsConfig === null || seriesDataLabelsConfig === void 0 ? void 0 : seriesDataLabelsConfig.fontSize,
          textOutline: '0px',
          fontWeight: '100'
        }
      },
      stacking: typeConfig === 'line' ? false : isStackedConfig
    }, _a),
    series: chartData,
    tooltip: {
      distance: id
    }
  };
  var onResize = useCallback(function (width) {
    Highcharts.charts.forEach(function (chart) {
      var _a;

      if (((_a = chart === null || chart === void 0 ? void 0 : chart.options.tooltip) === null || _a === void 0 ? void 0 : _a.distance) === id && stretch) {
        if (width) {
          chart === null || chart === void 0 ? void 0 : chart.setSize(width - 24); //remove padding from width
        } else if (outerResizeRef.current) {
          chart === null || chart === void 0 ? void 0 : chart.setSize(outerResizeRef.current.getBoundingClientRect().width - 24); //remove padding from width
        } else {
          chart === null || chart === void 0 ? void 0 : chart.reflow();
          chart === null || chart === void 0 ? void 0 : chart.setSize(null, null);
        }
      } else {
        chart === null || chart === void 0 ? void 0 : chart.reflow();
        chart === null || chart === void 0 ? void 0 : chart.setSize(null, null);
      }
    });
  }, [stretch]);
  var chart = jsxRuntime_1(ReactResizeDetector, _assign2({
    onResize: onResize,
    refreshMode: "debounce",
    refreshRate: 0,
    targetRef: outerResizeRef
  }, {
    children: jsxRuntime_2("div", _assign2({
      className: "kxi-chart-wrapper kxi-chart-container orca kxi-stretch " + (stretch ? 'kxi-stretch-chart' : '') + " " + (!containerView ? 'kxi-border' : '')
    }, ingredients, {
      ref: mergeRefs([ref, outerResizeRef])
    }, {
      children: [jsxRuntime_2("div", _assign2({
        className: "kxi-chart-header"
      }, {
        children: [jsxRuntime_1("h5", _assign2({
          className: "" + (semiboldTitle ? 'kxi-text-600' : '')
        }, {
          children: chartTitle
        }), void 0), chartSubtitle ? jsxRuntime_1("h6", _assign2({
          className: "kxi-grey kxi-text-small"
        }, {
          children: chartSubtitle
        }), void 0) : null]
      }), void 0), jsxRuntime_1("div", _assign2({
        className: "kxi-chart"
      }, {
        children: jsxRuntime_1(HighchartsReact, {
          highcharts: Highcharts,
          options: chartOptions
        }, void 0)
      }), void 0)]
    }), void 0)
  }), void 0);
  return containerView ? jsxRuntime_1(BasicTile, _assign2({
    color: "orca",
    stretch: true,
    padding: 0,
    className: "kxi-chart-container " + (stretch ? 'kxi-stretch-chart' : '') + " "
  }, {
    children: chart
  }), void 0) : chart;
});

var BigNumberProps = function (_super) {
  __extends(BigNumberProps, _super);

  function BigNumberProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], BigNumberProps.prototype, "title");

  __decorate([Bound(), __metadata("design:type", Boolean)], BigNumberProps.prototype, "semiboldTitle");

  __decorate([Bound(), __metadata("design:type", String)], BigNumberProps.prototype, "titleIcon");

  __decorate([Bound(), __metadata("design:type", Object)], BigNumberProps.prototype, "colors");

  __decorate([Bound(), __metadata("design:type", String)], BigNumberProps.prototype, "subtitle");

  __decorate([Bound(), __metadata("design:type", Array)], BigNumberProps.prototype, "links");

  __decorate([Bound(), __metadata("design:type", Boolean)], BigNumberProps.prototype, "useCondensedPadding");

  __decorate([Bound(), __metadata("design:type", Number)], BigNumberProps.prototype, "bigNumber");

  __decorate([Bound(), __metadata("design:type", String)], BigNumberProps.prototype, "bigNumberAlignment");

  __decorate([Bound(), __metadata("design:type", String)], BigNumberProps.prototype, "bigNumberFontSize");

  __decorate([Bound(), __metadata("design:type", Boolean)], BigNumberProps.prototype, "showPercent");

  __decorate([Bound(), __metadata("design:type", Boolean)], BigNumberProps.prototype, "isInteractive");

  __decorate([Bound(), __metadata("design:type", Boolean)], BigNumberProps.prototype, "selected");

  __decorate([Bound(), __metadata("design:type", Array)], BigNumberProps.prototype, "dropdownData");

  __decorate([Bound(), __metadata("design:type", String)], BigNumberProps.prototype, "contextText");

  __decorate([Bound(), __metadata("design:type", String)], BigNumberProps.prototype, "contextNumberSize");

  __decorate([Bound(), __metadata("design:type", Array)], BigNumberProps.prototype, "contextData");

  __decorate([Bound(), __metadata("design:type", String)], BigNumberProps.prototype, "contextDataAlignment");

  __decorate([Bound(), __metadata("design:type", Boolean)], BigNumberProps.prototype, "showContextTrendArrows");

  __decorate([Bound(), __metadata("design:type", Object)], BigNumberProps.prototype, "localization");

  __decorate([Bound(), __metadata("design:type", Boolean)], BigNumberProps.prototype, "containerlessView");

  __decorate([Bound(), __metadata("design:type", String)], BigNumberProps.prototype, "locale");

  return BigNumberProps;
}(ObservablePropsMixin(DivHTMLAttributes));

var BigNumberEvents = function (_super) {
  __extends(BigNumberEvents, _super);

  function BigNumberEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], BigNumberEvents.prototype, "onValueChange");

  return BigNumberEvents;
}(DivHTMLEvents);
/**
 * Description: Component displaying various numbers in a big fashion. Card onClick event will only fire if isInteractive is true.
 */


var BigNumber = /*#__PURE__*/forwardRef(function (props, ref) {
  var wrapperRef = useRef(null);
  var contextDataRef = useRef(null);
  var bigNumberRef = useRef(null);

  var className = props.className,
      _a = props.containerlessView,
      containerlessView = _a === void 0 ? false : _a,
      title = props.title,
      _b = props.semiboldTitle,
      semiboldTitle = _b === void 0 ? true : _b,
      titleIcon = props.titleIcon,
      _c = props.colors,
      colors = _c === void 0 ? {} : _c,
      _d = props.links,
      links = _d === void 0 ? [] : _d,
      useCondensedPadding = props.useCondensedPadding,
      subtitle = props.subtitle,
      selected = props.selected,
      _e = props.isInteractive,
      isInteractive = _e === void 0 ? false : _e,
      bigNumber = props.bigNumber,
      _f = props.bigNumberAlignment,
      bigNumberAlignment = _f === void 0 ? 'center' : _f,
      _g = props.bigNumberFontSize,
      bigNumberFontSize = _g === void 0 ? 'big' : _g,
      _h = props.showPercent,
      showPercent = _h === void 0 ? false : _h,
      _j = props.dropdownData,
      dropdownData = _j === void 0 ? [] : _j,
      contextText = props.contextText,
      _k = props.contextNumberSize,
      contextNumberSize = _k === void 0 ? 'big' : _k,
      _l = props.contextData,
      contextData = _l === void 0 ? [] : _l,
      _m = props.contextDataAlignment,
      contextDataAlignment = _m === void 0 ? 'center' : _m,
      _o = props.showContextTrendArrows,
      showContextTrendArrows = _o === void 0 ? true : _o,
      _p = props.localization,
      localization = _p === void 0 ? {} : _p,
      observer = props.observer,
      onClick = props.onClick,
      onValueChange = props.onValueChange,
      _q = props.locale,
      locale = _q === void 0 ? 'en-US' : _q,
      hasTranscludedContent = props.hasTranscludedContent,
      resetTransclusion = props.resetTransclusion,
      hasTranscluded = props.hasTranscluded,
      children = props.children,
      ingredients = __rest(props, ["className", "containerlessView", "title", "semiboldTitle", "titleIcon", "colors", "links", "useCondensedPadding", "subtitle", "selected", "isInteractive", "bigNumber", "bigNumberAlignment", "bigNumberFontSize", "showPercent", "dropdownData", "contextText", "contextNumberSize", "contextData", "contextDataAlignment", "showContextTrendArrows", "localization", "observer", "onClick", "onValueChange", "locale", "hasTranscludedContent", "resetTransclusion", "hasTranscluded", "children"]);

  var _r = colors.title,
      titleColor = _r === void 0 ? 'orca' : _r,
      _s = colors.titleIcon,
      titleIconColor = _s === void 0 ? 'orca' : _s,
      _t = colors.bigNumber,
      bigNumberColor = _t === void 0 ? 'orca' : _t;
  var _u = localization.noDataFound,
      noDataFound = _u === void 0 ? 'No Data Found' : _u;
  var hasData = !!bigNumber || bigNumber === 0;
  var hasDropdown = !!dropdownData.length;
  var contextNumberIsBig = contextNumberSize === 'big';

  var _v = __read(useState(false), 2),
      isSelected = _v[0],
      setIsSelected = _v[1];

  var _w = __read(useState(0), 2),
      width = _w[0],
      setWidth = _w[1];

  var _x = __read(useState(0), 2),
      fontWidth = _x[0],
      setFontWidth = _x[1];

  var _y = __read(useState(false), 2),
      shrinkFont = _y[0],
      setShrinkFont = _y[1];

  var _z = __read(useState(0), 2),
      contextWrapperWidth = _z[0],
      setContextWrapperWidth = _z[1];

  var _0 = __read(useState(0), 2),
      contextNumberWidth = _0[0],
      setContextNumberWidth = _0[1];

  useEffect(function () {
    if (isInteractive) {
      if (selected !== undefined) setIsSelected(selected);
    }
  }, [selected]);
  useEffect(function () {
    if (contextData.length > 3) {
      devOnlyWarn('The Kitchen: You have passed in more than the maximum number of contexts to the BigNumber component - only 3 will be displayed.');
    }
  }, [contextData]);
  var prevWidthRef = usePrevious(width);
  useEffect(function () {
    setShrinkFont(fontWidth > width);
  }, [fontWidth, width]);
  var mappedLinks = links.map(function (link, i) {
    var pipe = i !== links.length - 1 ? ' | ' : '';
    var text = link.text,
        href = link.href;
    return jsxRuntime_2("span", {
      children: [jsxRuntime_1("a", _assign2({
        className: "cx kxi-text-normal",
        href: href,
        target: "_blank",
        rel: "noreferrer"
      }, {
        children: text
      }), void 0), pipe]
    }, i);
  });

  var setLargestNumberSize = function setLargestNumberSize(newWidth) {
    if (newWidth > contextNumberWidth) {
      setContextNumberWidth(newWidth);
    }
  };

  var isContextGroupStacked = function isContextGroupStacked() {
    /*
      if the context number width (with icon) is greater than 55% of the context wrapper width,
      stack the groups instead of having them on rows;
      Stacked class is on the whole wrapper because if one row should be stacked, stack all the rows
    */
    return contextNumberWidth / contextWrapperWidth > 0.55;
  };

  var mappedContextData = contextData.filter(function (v, i) {
    return i < 3;
  }).map(function (context, j) {
    var _a, _b, _c;

    return jsxRuntime_1(ToolTipWrapper, _assign2({
      usePortal: true
    }, context.tooltip, {
      slotName: children && ((_a = context === null || context === void 0 ? void 0 : context.tooltip) === null || _a === void 0 ? void 0 : _a.slotName) ? "_reactChild_" + ((_b = context === null || context === void 0 ? void 0 : context.tooltip) === null || _b === void 0 ? void 0 : _b.slotName) : (_c = context === null || context === void 0 ? void 0 : context.tooltip) === null || _c === void 0 ? void 0 : _c.slotName,
      _reactSlot: children,
      enabled: context.tooltip !== undefined,
      _hasTranscludedContent: hasTranscludedContent,
      _resetTransclusion: resetTransclusion,
      _hasTranscluded: hasTranscluded
    }, {
      children: jsxRuntime_2("div", _assign2({
        className: "kxi-big-number-context " + (contextNumberIsBig ? 'kxi-big-number-large-context' : '')
      }, {
        children: [jsxRuntime_1("p", _assign2({
          className: "kxi-big-number-context-heading kxi-gray"
        }, {
          children: context.heading
        }), void 0), jsxRuntime_2("div", _assign2({
          style: {
            width: contextDataAlignment === 'right' ? contextNumberWidth : ''
          },
          className: "kxi-big-number-context-icon-wrapper " + (contextNumberIsBig ? 'kxi-text-large' : 'kxi-text-normal')
        }, {
          children: [showContextTrendArrows ? jsxRuntime_1(XIIcon, {
            icon: context.icon,
            color: context.color,
            iconSize: contextNumberIsBig ? 30 : 24
          }, void 0) : null, jsxRuntime_2("p", _assign2({
            ref: function ref(contextDataNumberRef) {
              setLargestNumberSize(((contextDataNumberRef === null || contextDataNumberRef === void 0 ? void 0 : contextDataNumberRef.getBoundingClientRect().width) || 0) + (contextNumberIsBig ? 30 : 24));
            },
            className: "" + normalizeColor(context.color || 'orca')
          }, {
            children: [context.contextNumber, context.isPercentage ? '%' : '']
          }), void 0)]
        }), void 0)]
      }), j)
    }), void 0);
  });

  var handleClick = function handleClick(e) {
    if (isInteractive) {
      setIsSelected(function (v) {
        if (observer) observer.selected = !v;
        return !v;
      });
      if (onClick) onClick(e);
    }
  };

  var getComponentSize = function getComponentSize() {
    if (width > 768) {
      return 'large';
    } else if (width > 336) {
      return 'normal';
    } else {
      return 'small';
    }
  };
  /*
    returns a (localized) shortened version of large numbers
    1,000 => 1k
    10,500 => 11k
  */


  var abbreviateNumber = function abbreviateNumber(num) {
    num = Math.trunc(num);
    var abbrevNum = num.toString();
    var suffixes = ['', 'k', 'm', 'b', 't'];
    var suffixNum = Math.floor(abbrevNum.length / 3); // I need to turn it back into a number so it can be localized

    var preciseNum = parseFloat((suffixNum !== 0 ? num / Math.pow(1000, suffixNum) : num).toPrecision(2));
    var localizedNum = preciseNum.toLocaleString(locale);
    abbrevNum = localizedNum + suffixes[suffixNum];
    return abbrevNum;
  };

  var getClassList = function getClassList() {
    var list = "kxi-big-number-wrapper kxi-stretch kxi-big-number-" + getComponentSize(); // check for undefined for backwards compatibility

    if (useCondensedPadding || useCondensedPadding === undefined && prevWidthRef - 12 < 335) {
      list += ' kxi-big-number-condensed-padding';
    }

    if (containerlessView) list += ' kxi-border kxi-grey';

    if (isInteractive) {
      list += ' kxi-big-number-interactive';
      if (isSelected) list += ' kxi-big-number-selected';
    }

    if (className) list += " " + className;
    return list;
  };

  var noData = jsxRuntime_1("p", _assign2({
    className: " kxi-text-normal kxi-text-600"
  }, {
    children: noDataFound
  }), "no-data");
  var bigNumberText = Number(bigNumber).toLocaleString(locale);
  var largeNumberThreshold = 999;
  var bigNumberColorClass = normalizeColor(bigNumberColor);
  var bigNumberDisplay = noData;

  if (hasData) {
    bigNumberDisplay = jsxRuntime_2("h1", _assign2({
      ref: bigNumberRef,
      className: bigNumberColorClass,
      style: shrinkFont ? {
        transform: "scale(" + (width / fontWidth > 1 ? 1 : width / fontWidth) + ")"
      } : {}
    }, {
      children: [bigNumber && bigNumber > largeNumberThreshold ? abbreviateNumber(bigNumber) : bigNumberText, showPercent ? '%' : '']
    }), "big-number-display");
  }

  var bigNumberChart = jsxRuntime_1(ReactResizeDetector, _assign2({
    onResize: useCallback(function (width) {
      return setWidth(width);
    }, []),
    handleWidth: true,
    targetRef: wrapperRef,
    refreshMode: "debounce",
    refreshRate: 3
  }, {
    children: jsxRuntime_2("div", _assign2({}, ingredients, {
      onClick: handleClick,
      className: getClassList(),
      ref: mergeRefs([wrapperRef, ref])
    }, {
      children: [jsxRuntime_2("div", _assign2({
        className: "kxi-big-number-header"
      }, {
        children: [jsxRuntime_2("div", _assign2({
          className: "kxi-big-number-info"
        }, {
          children: [jsxRuntime_2("div", _assign2({
            className: "kxi-big-number-title " + (titleIcon ? 'icon' : '')
          }, {
            children: [titleIcon ? jsxRuntime_1(XIIcon, {
              icon: titleIcon,
              color: titleIconColor
            }, void 0) : null, jsxRuntime_1("h6", _assign2({
              className: (semiboldTitle ? 'kxi-text-600' : '') + "  " + normalizeColor(titleColor)
            }, {
              children: title
            }), void 0)]
          }), void 0), jsxRuntime_1("p", _assign2({
            className: "kxi-big-number-subtitle kxi-grey"
          }, {
            children: subtitle
          }), void 0)]
        }), void 0), jsxRuntime_1("div", _assign2({
          className: "kxi-big-number-menu"
        }, {
          children: hasDropdown ? jsxRuntime_1(Dropdown, {
            type: "icon",
            select: "none",
            color: "orca",
            internalProps: {
              iconButton: {
                icon: 'kabob',
                buttonSize: 'normal'
              }
            },
            data: dropdownData,
            onValueChange: onValueChange
          }, void 0) : null
        }), void 0)]
      }), void 0), jsxRuntime_1("hr", {
        className: "kxi-big-number-hr kxi-grey"
      }, void 0), jsxRuntime_1("div", _assign2({
        className: "kxi-big-number-links"
      }, {
        children: mappedLinks
      }), void 0), jsxRuntime_1("div", _assign2({
        className: "kxi-big-number-main kxi-big-number-" + bigNumberFontSize + "-font"
      }, {
        children: jsxRuntime_1(ReactResizeDetector, _assign2({
          onResize: useCallback(function (w) {
            return setFontWidth(w);
          }, []),
          handleWidth: true,
          targetRef: bigNumberRef,
          refreshMode: "debounce",
          refreshRate: 0
        }, {
          children: jsxRuntime_2(jsxRuntime_3, {
            children: [jsxRuntime_2("div", _assign2({
              className: "kxi-big-number-metric-wrapper kxi-big-number-align-" + bigNumberAlignment
            }, {
              children: [bigNumberDisplay, jsxRuntime_1("p", _assign2({
                className: "kxi-big-number-context-text kxi-grey"
              }, {
                children: contextText
              }), "context-text")]
            }), void 0), contextData.length > 0 ? jsxRuntime_1(ReactResizeDetector, _assign2({
              onResize: function onResize(w) {
                return setContextWrapperWidth(w || 0);
              },
              handleWidth: true,
              targetRef: contextDataRef,
              refreshMode: "debounce",
              refreshRate: 0
            }, {
              children: jsxRuntime_1("div", _assign2({
                ref: contextDataRef,
                className: "kxi-big-number-context-data-wrapper kxi-grey kxi-big-number-context-align-" + contextDataAlignment + " " + (isContextGroupStacked() ? 'kxi-big-number-stacked-context' : '')
              }, {
                children: mappedContextData
              }), "context-data")
            }), void 0) : null]
          }, void 0)
        }), void 0)
      }), void 0)]
    }), void 0)
  }), void 0);
  return containerlessView ? bigNumberChart : jsxRuntime_1(BasicTile, _assign2({
    color: "orca",
    stretch: true,
    padding: 0,
    isInteractive: isInteractive,
    className: "kxi-big-number-container"
  }, {
    children: bigNumberChart
  }), void 0);
});

function getSlot(name, props, style) {
  if (props.children) {
    return React__default.Children.toArray(props.children).filter(function (c) {
      return c.props.slot === name;
    });
  } else {
    return jsxRuntime_1(Slot, {
      name: name,
      hasTranscludedContent: props.hasTranscludedContent,
      resetTransclusion: props.resetTransclusion,
      propsToWatch: [],
      hasTranscluded: props.hasTranscluded,
      style: style
    }, void 0);
  }
}

var HighchartsAngularStyle = 'width: 100%; height: 100%; display: block; overflow: visible;';
var HighchartsDefaultTheme = {
  chart: {
    reflow: true,
    events: {
      load: function load(event) {
        setTimeout(function () {
          event.target.reflow();
        }, 100);
      }
    }
  },
  credits: {
    enabled: false
  },
  legend: {
    itemStyle: {
      color: XIColors.orca.primary,
      fontWeight: '400',
      fontFamily: 'IBM Plex Sans',
      fontSize: '12px'
    },
    itemHoverStyle: {
      color: XIColors.orca.light[30]
    },
    itemHiddenStyle: {
      color: XIColors.grey.light[60]
    },
    title: {
      style: {
        color: XIColors.orca.light[30],
        fontWeight: '400',
        fontFamily: 'IBM Plex Sans',
        fontSize: '12px'
      },
      text: 'Optional Title Text'
    },
    align: 'left'
  },
  title: false,
  subtitle: false,
  xAxis: [{
    labels: {
      style: {
        color: XIColors.orca.light[30],
        fontWeight: '400',
        fontFamily: 'IBM Plex Sans',
        fontSize: '12px'
      },
      align: 'center'
    },
    gridLineDashStyle: 'Dash',
    tickLength: 8,
    gridLineColor: XIColors.grey.light[90],
    gridLineWidth: 1,
    lineColor: XIColors.grey.light[90],
    title: {
      text: 'Optional Title Text',
      style: {
        color: XIColors.orca.light[30],
        fontWeight: '400',
        fontFamily: 'IBM Plex Sans',
        fontSize: '14px'
      }
    }
  }],
  yAxis: [{
    labels: {
      style: {
        color: XIColors.orca.light[30],
        fontSize: '12px',
        fontWeight: '400',
        fontFamily: 'IBM Plex Sans'
      },
      align: 'center'
    },
    gridLineDashStyle: 'Solid',
    tickLength: 8,
    gridLineColor: XIColors.grey.light[90],
    gridLineWidth: 1,
    title: {
      style: {
        color: XIColors.orca.light[30],
        fontWeight: '400',
        fontFamily: 'IBM Plex Sans',
        fontSize: '14px'
      }
    }
  }],
  tooltip: {
    backgroundColor: XIColorUsage.silver,
    borderRadius: 6,
    borderColor: XIColors.grey.light[80],
    borderWidth: 1,
    padding: 8,
    shadow: false,
    shape: 'callout',
    style: {
      color: XIColors.orca.primary,
      fontWeight: '400',
      fontFamily: 'IBM Plex Sans',
      fontSize: '14px'
    }
  }
};

var HighchartsStyleMerge = function HighchartsStyleMerge() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  if (!Array.isArray(args)) return args;

  var recursiveMerge = function recursiveMerge(base, override) {
    var output = base;
    if (override === null) return null;
    Object.keys(override).forEach(function (element) {
      if (Array.isArray(override[element])) {
        if (typeof base[element] === 'object') {
          output[element] = recursiveMerge(base[element], override[element]);
        } else {
          output[element] = __spreadArray(__spreadArray([], __read(base[element] || [])), __read(override[element]));
        }
      } else if (typeof override[element] === 'object') {
        output[element] = recursiveMerge(base[element] || {}, override[element]);
      } else {
        output[element] = override[element];
      }
    });
    return output;
  };

  var output = {};
  args.reduce(function (prev, curr) {
    return recursiveMerge(prev, curr);
  }, output);
  return output;
};

var ChartWrapperProps = function (_super) {
  __extends(ChartWrapperProps, _super);

  function ChartWrapperProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], ChartWrapperProps.prototype, "title");

  __decorate([Bound(), __metadata("design:type", Boolean)], ChartWrapperProps.prototype, "semiboldTitle");

  __decorate([Bound(), __metadata("design:type", String)], ChartWrapperProps.prototype, "subtitle");

  __decorate([Bound(), __metadata("design:type", Boolean)], ChartWrapperProps.prototype, "containerView");

  __decorate([Bound(), __metadata("design:type", Object)], ChartWrapperProps.prototype, "maxHeight");

  __decorate([Bound(), __metadata("design:type", Number)], ChartWrapperProps.prototype, "minChartHeight");

  __decorate([Bound(), __metadata("design:type", Boolean)], ChartWrapperProps.prototype, "hasSeparatorBar");

  return ChartWrapperProps;
}(DivHTMLAttributes);

var ChartWrapperEvents = function (_super) {
  __extends(ChartWrapperEvents, _super);

  function ChartWrapperEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return ChartWrapperEvents;
}(DivHTMLEvents);
/**
 * Description: This component wraps a Highchart chart component (not included) to provide standard looking charts
 */


var ChartWrapper = /*#__PURE__*/forwardRef(function (props, ref) {
  var title = props.title,
      _a = props.semiboldTitle,
      semiboldTitle = _a === void 0 ? true : _a,
      subtitle = props.subtitle,
      _b = props.containerView,
      containerView = _b === void 0 ? false : _b,
      _c = props.maxHeight,
      maxHeight = _c === void 0 ? 'auto' : _c,
      showSentimentButtons = props.showSentimentButtons,
      customHeaderSlot = props.customHeaderSlot,
      showSearchBar = props.showSearchBar,
      hasTranscludedContent = props.hasTranscludedContent,
      hasTranscluded = props.hasTranscluded,
      interceptClose = props.interceptClose,
      hasSeparatorBar = props.hasSeparatorBar,
      resetTransclusion = props.resetTransclusion,
      className = props.className,
      searchBoxOptions = props.searchBoxOptions,
      minChartHeight = props.minChartHeight,
      ingredients = __rest(props, ["title", "semiboldTitle", "subtitle", "containerView", "maxHeight", "showSentimentButtons", "customHeaderSlot", "showSearchBar", "hasTranscludedContent", "hasTranscluded", "interceptClose", "hasSeparatorBar", "resetTransclusion", "className", "searchBoxOptions", "minChartHeight"]);

  var getSlotProps = function getSlotProps() {
    return {
      children: props.children,
      hasTranscludedContent: hasTranscludedContent,
      resetTransclusion: resetTransclusion,
      hasTranscluded: hasTranscluded
    };
  };

  var innerWrapper = jsxRuntime_2("div", _assign2({}, ingredients, {
    style: {
      maxHeight: maxHeight
    },
    className: "kxi-chart-wrapper kxi-chart-container kxi-stretch kxi-chart-wrapper-component orca " + (!containerView ? 'kxi-border' : '') + " " + (className || ''),
    ref: ref
  }, {
    children: [jsxRuntime_2("div", _assign2({
      className: "kxi-chart-wrapper-header"
    }, {
      children: [jsxRuntime_2("div", _assign2({
        className: "kxi-chart-wrapper-header-content"
      }, {
        children: [jsxRuntime_2("div", {
          children: [jsxRuntime_1("h5", _assign2({
            className: "" + (semiboldTitle ? 'kxi-text-600' : '')
          }, {
            children: title
          }), void 0), subtitle ? jsxRuntime_1("h6", _assign2({
            className: "kxi-grey kxi-text-small"
          }, {
            children: subtitle
          }), void 0) : null]
        }, void 0), jsxRuntime_1("div", {
          children: getSlot('filter', getSlotProps())
        }, void 0)]
      }), void 0), jsxRuntime_1("div", {
        children: getSlot('header', getSlotProps())
      }, void 0), hasSeparatorBar ? jsxRuntime_1("hr", {
        className: "kxi-grey kxi-chart-wrapper-hr"
      }, void 0) : null]
    }), void 0), jsxRuntime_1("div", _assign2({
      className: "kxi-chart-wrapper-body"
    }, {
      children: jsxRuntime_1("div", _assign2({
        className: "kxi-chart-wrapper-wrapper",
        style: {
          minHeight: minChartHeight
        }
      }, {
        children: getSlot('chart', getSlotProps(), {
          height: '100%'
        })
      }), void 0)
    }), void 0)]
  }), void 0);
  return containerView ? jsxRuntime_1(BasicTile, _assign2({
    color: "orca",
    stretch: true,
    padding: 0,
    style: {
      maxHeight: maxHeight
    },
    className: "kxi-chart-container"
  }, {
    children: innerWrapper
  }), void 0) : innerWrapper;
});
highchartsAccessibility(Highcharts);

var PieChartProps = function (_super) {
  __extends(PieChartProps, _super);

  function PieChartProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Object)], PieChartProps.prototype, "chartSettings");

  __decorate([Bound(), __metadata("design:type", String)], PieChartProps.prototype, "title");

  __decorate([Bound(), __metadata("design:type", Boolean)], PieChartProps.prototype, "semiboldTitle");

  __decorate([Bound(), __metadata("design:type", String)], PieChartProps.prototype, "subtitle");

  __decorate([Bound(), __metadata("design:type", String)], PieChartProps.prototype, "legendTitle");

  __decorate([Bound(), __metadata("design:type", Boolean)], PieChartProps.prototype, "legendVisibility");

  __decorate([Bound(), __metadata("design:type", Object)], PieChartProps.prototype, "seriesDataLabelOptions");

  __decorate([Bound(), __metadata("design:type", Array)], PieChartProps.prototype, "seriesColors");

  __decorate([Bound(), __metadata("design:type", Array)], PieChartProps.prototype, "data");

  __decorate([Bound(), __metadata("design:type", Boolean)], PieChartProps.prototype, "containerView");

  return PieChartProps;
}(DivHTMLAttributes);

var PieChartEvents = function (_super) {
  __extends(PieChartEvents, _super);

  function PieChartEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return PieChartEvents;
}(DivHTMLEvents);
/**
 * Description: Pie Chart
 */


var PieChart = /*#__PURE__*/forwardRef(function (props, ref) {
  var _a, _b;

  var chartSettings = props.chartSettings,
      title = props.title,
      _c = props.semiboldTitle,
      semiboldTitle = _c === void 0 ? true : _c,
      subtitle = props.subtitle,
      legendTitle = props.legendTitle,
      _d = props.legendVisibility,
      legendVisibility = _d === void 0 ? true : _d,
      seriesDataLabelOptions = props.seriesDataLabelOptions,
      seriesColors = props.seriesColors,
      data = props.data,
      containerView = props.containerView,
      ingredients = __rest(props, ["chartSettings", "title", "semiboldTitle", "subtitle", "legendTitle", "legendVisibility", "seriesDataLabelOptions", "seriesColors", "data", "containerView"]);

  if (chartSettings) {
    warnIsDeprecated('PieChart', {
      chartSettings: {
        message: 'Single `chartSettings` should be replaced with individually set props.',
        value: {
          chartSettings: chartSettings
        }
      }
    }, 'prop');
  }

  var chartTitle = (chartSettings === null || chartSettings === void 0 ? void 0 : chartSettings.title) || title;
  var chartSubtitle = (chartSettings === null || chartSettings === void 0 ? void 0 : chartSettings.subtitle) || subtitle;
  var seriesColorsConfig = ((_a = chartSettings === null || chartSettings === void 0 ? void 0 : chartSettings.seriesOptions) === null || _a === void 0 ? void 0 : _a.colors) || seriesColors;
  var dataLabelsConfig = ((_b = chartSettings === null || chartSettings === void 0 ? void 0 : chartSettings.seriesOptions) === null || _b === void 0 ? void 0 : _b.dataLabels) || seriesDataLabelOptions;
  var dataConfig = (chartSettings === null || chartSettings === void 0 ? void 0 : chartSettings.data) || data;
  var outerResizeRef = useRef(null);
  var chartOptions = {
    chart: {
      type: 'pie'
    },
    colors: seriesColorsConfig || [XIColors.orca.primary],
    credits: {
      enabled: false
    },
    title: undefined,
    subtitle: undefined,
    legend: {
      align: 'right',
      enabled: (chartSettings === null || chartSettings === void 0 ? void 0 : chartSettings.legendVisibility) || legendVisibility,
      title: {
        text: (chartSettings === null || chartSettings === void 0 ? void 0 : chartSettings.legendTitle) || legendTitle
      }
    },
    plotOptions: {
      pie: {
        dataLabels: {
          enabled: (dataLabelsConfig === null || dataLabelsConfig === void 0 ? void 0 : dataLabelsConfig.enabled) === false ? false : true,
          style: {
            fontSize: dataLabelsConfig === null || dataLabelsConfig === void 0 ? void 0 : dataLabelsConfig.fontSize
          }
        },
        showInLegend: true
      }
    },
    series: dataConfig
  };
  var onResize = useCallback(function () {
    Highcharts.charts.forEach(function (chart) {
      chart === null || chart === void 0 ? void 0 : chart.reflow();
    });
  }, []);
  var chart = jsxRuntime_1(ReactResizeDetector, _assign2({
    onResize: onResize,
    refreshMode: "debounce",
    refreshRate: 0,
    targetRef: outerResizeRef
  }, {
    children: jsxRuntime_2("div", _assign2({
      className: "kxi-chart-wrapper kxi-chart-container orca kxi-stretch " + (!containerView ? 'kxi-border' : '')
    }, ingredients, {
      ref: mergeRefs([ref, outerResizeRef])
    }, {
      children: [jsxRuntime_2("div", _assign2({
        className: "kxi-chart-header"
      }, {
        children: [jsxRuntime_1("h5", _assign2({
          className: "" + (semiboldTitle ? 'kxi-text-600' : '')
        }, {
          children: chartTitle
        }), void 0), chartSubtitle ? jsxRuntime_1("h6", _assign2({
          className: "kxi-grey"
        }, {
          children: chartSubtitle
        }), void 0) : null]
      }), void 0), jsxRuntime_1("div", _assign2({
        className: "kxi-chart"
      }, {
        children: jsxRuntime_1(HighchartsReact, {
          highcharts: Highcharts,
          options: chartOptions
        }, void 0)
      }), void 0)]
    }), void 0)
  }), void 0);
  return containerView ? jsxRuntime_1(BasicTile, _assign2({
    color: "orca",
    stretch: true,
    padding: 0,
    className: "kxi-chart-container"
  }, {
    children: chart
  }), void 0) : chart;
});
var CHART_TYPE;

(function (CHART_TYPE) {
  CHART_TYPE["LINE"] = "line";
  CHART_TYPE["BAR"] = "bar";
  CHART_TYPE["COLUMN"] = "column";
})(CHART_TYPE || (CHART_TYPE = {}));

var CHART_FONT_SIZES;

(function (CHART_FONT_SIZES) {
  CHART_FONT_SIZES["SMALL"] = "8px";
  CHART_FONT_SIZES["DEFAULT"] = "11px";
  CHART_FONT_SIZES["MEDIUM"] = "13px";
  CHART_FONT_SIZES["LARGE"] = "15px";
  CHART_FONT_SIZES["EXTRA_LARGE"] = "17px";
})(CHART_FONT_SIZES || (CHART_FONT_SIZES = {}));

var _BarVariantTypesOptions = ['line', 'bar', 'column'];
var _BigNumberSizesOptions = ['small', 'big'];
var _BigNumberAlignmentsOptions = ['center', 'right'];
var _BigNumberColorsOptions = ['orca', 'positive', 'negative', 'neutral'];

var AppSideDisplayProps = function (_super) {
  __extends(AppSideDisplayProps, _super);

  function AppSideDisplayProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], AppSideDisplayProps.prototype, "icon");

  __decorate([Bound(), __metadata("design:type", String)], AppSideDisplayProps.prototype, "text");

  __decorate([Bound(), __metadata("design:type", String)], AppSideDisplayProps.prototype, "color");

  __decorate([Bound(), __metadata("design:type", String)], AppSideDisplayProps.prototype, "title");

  return AppSideDisplayProps;
}(DivHTMLAttributes);

var AppSideDisplayEvents = function (_super) {
  __extends(AppSideDisplayEvents, _super);

  function AppSideDisplayEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return AppSideDisplayEvents;
}(DivHTMLEvents);
/**
 * Description: Shows a large blue box with an icon, placed on the App Pages. Size is it's parent's container.
 */


var AppSideDisplay = /*#__PURE__*/forwardRef(function (props, ref) {
  var icon = props.icon,
      className = props.className,
      _a = props.color,
      color = _a === void 0 ? 'CX' : _a,
      title = props.title,
      text = props.text,
      children = props.children,
      ingredients = __rest(props, ["icon", "className", "color", "title", "text", "children"]);

  useEffect(function () {
    throwPropErrorMessage('AppSideDisplay', {
      icon: icon
    });
  }, [icon]);
  return jsxRuntime_2("div", _assign2({
    className: normalizeColor(color) + " kxi-gradient " + (className || '') + " kxi-app-side-display-clear-container"
  }, ingredients, {
    ref: ref
  }, {
    children: [jsxRuntime_2("div", _assign2({
      className: "kxi-app-side-display-content-container"
    }, {
      children: [jsxRuntime_1("div", _assign2({
        style: {
          marginBottom: 24,
          width: 72,
          height: 72
        }
      }, {
        children: jsxRuntime_1(XIAppIcon, {
          icon: icon
        }, void 0)
      }), void 0), title && jsxRuntime_1("h2", {
        children: title
      }, void 0), text && jsxRuntime_1("div", _assign2({
        className: "kxi-app-side-display-body-text"
      }, {
        children: jsxRuntime_1("p", {
          children: text
        }, void 0)
      }), void 0)]
    }), void 0), jsxRuntime_1("div", _assign2({
      className: "kxi-app-side-display-button-wrapper"
    }, {
      children: children
    }), void 0)]
  }), void 0);
});

var DrawerProps = function (_super) {
  __extends(DrawerProps, _super);

  function DrawerProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], DrawerProps.prototype, "size");

  __decorate([Bound(), __metadata("design:type", Boolean)], DrawerProps.prototype, "open");

  __decorate([Bound(), __metadata("design:type", String)], DrawerProps.prototype, "color");

  __decorate([Bound(), __metadata("design:type", Boolean)], DrawerProps.prototype, "silverBg");

  __decorate([Bound(), __metadata("design:type", String)], DrawerProps.prototype, "closeButtonIcon");

  __decorate([Bound(), __metadata("design:type", Boolean)], DrawerProps.prototype, "interceptClose");

  return DrawerProps;
}(ObservablePropsMixin(DivHTMLAttributes));

var DrawerEvents = function (_super) {
  __extends(DrawerEvents, _super);

  function DrawerEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], DrawerEvents.prototype, "onClose");

  return DrawerEvents;
}(DivHTMLEvents);
/**
 * Description: Generic drawer component that animates out from the right side of the screen, place whatever you want inside!
 */


var Drawer = /*#__PURE__*/forwardRef(function (props, ref) {
  var _a = props.color,
      color = _a === void 0 ? 'CX' : _a,
      _b = props.size,
      size = _b === void 0 ? 'large' : _b,
      _c = props.open,
      open = _c === void 0 ? false : _c,
      _d = props.silverBg,
      silverBg = _d === void 0 ? false : _d,
      observer = props.observer,
      hasTranscludedContent = props.hasTranscludedContent,
      _e = props.closeButtonIcon,
      closeButtonIcon = _e === void 0 ? 'cancel' : _e,
      hasTranscluded = props.hasTranscluded,
      interceptClose = props.interceptClose,
      resetTransclusion = props.resetTransclusion,
      onClose = props.onClose,
      ingredients = __rest(props, ["color", "size", "open", "silverBg", "observer", "hasTranscludedContent", "closeButtonIcon", "hasTranscluded", "interceptClose", "resetTransclusion", "onClose"]);

  delete ingredients.transclude;

  var _f = __read(useState(false), 2),
      isOpen = _f[0],
      setIsOpen = _f[1];

  var _g = __read(useState(false), 2),
      isSliderOpen = _g[0],
      setIsSliderOpen = _g[1];

  useEffect(function () {
    var idOne, idTwo;

    var timerOne = function timerOne() {
      return setTimeout(function () {
        setIsSliderOpen(function () {
          return open;
        });
      }, 100);
    };

    var timerTwo = function timerTwo() {
      return setTimeout(function () {
        setIsOpen(function () {
          return open;
        });
      }, 500);
    };

    if (open) {
      setIsOpen(function () {
        return open;
      });
      idOne = timerOne();
    } else {
      setIsSliderOpen(function () {
        return open;
      });
      idTwo = timerTwo();
    }

    return function () {
      clearTimeout(idOne);
      clearTimeout(idTwo);
    };
  }, [open]);

  var handleClose = function handleClose() {
    if (interceptClose) {
      if (onClose) onClose();
    } else {
      setIsSliderOpen(false);
      setTimeout(function () {
        setIsOpen(false);

        if (observer) {
          observer.open = false;
        }

        if (onClose) {
          onClose();
        }
      }, 500);
    }
  };

  var getSlotProps = function getSlotProps() {
    return {
      children: props.children,
      hasTranscludedContent: hasTranscludedContent,
      resetTransclusion: resetTransclusion,
      hasTranscluded: hasTranscluded
    };
  };

  return /*#__PURE__*/createPortal(jsxRuntime_1("div", _assign2({
    role: "dialog",
    "aria-hidden": !isOpen,
    "data-testid": "drawer-wrapper",
    id: "kxi-xi-drawer",
    className: "kxi-drawer-wrapper kxi-grey-overlay " + (isOpen ? 'open' : '')
  }, {
    children: jsxRuntime_2("div", _assign2({
      "data-testid": "drawer",
      className: "kxi-drawer kxi-" + size + " " + (isSliderOpen ? 'open' : '') + " " + (silverBg ? 'kxi-drawer-silver-background' : '')
    }, ingredients, {
      ref: ref
    }, {
      children: [jsxRuntime_2("div", _assign2({
        "data-testid": "drawer-header",
        className: "kxi-drawer-header " + normalizeColor(color)
      }, {
        children: [jsxRuntime_1(IconButton, {
          className: "kxi-drawer-close-button",
          icon: closeButtonIcon,
          onClick: handleClose
        }, void 0), jsxRuntime_1("div", _assign2({
          className: "kxi-drawer-title"
        }, {
          children: getSlot('title', getSlotProps())
        }), void 0), jsxRuntime_1("div", _assign2({
          className: "kxi-drawer-menu"
        }, {
          children: getSlot('menu', getSlotProps())
        }), void 0)]
      }), void 0), jsxRuntime_1("div", _assign2({
        className: "kxi-drawer-body"
      }, {
        children: getSlot('body', getSlotProps())
      }), void 0), jsxRuntime_1("div", _assign2({
        className: "kxi-drawer-footer"
      }, {
        children: getSlot('footer', getSlotProps())
      }), void 0)]
    }), void 0)
  }), void 0), document.body);
});

var SidePanelProps = function (_super) {
  __extends(SidePanelProps, _super);

  function SidePanelProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Boolean)], SidePanelProps.prototype, "open");

  __decorate([Bound(), __metadata("design:type", String)], SidePanelProps.prototype, "closeButtonIcon");

  __decorate([Bound(), __metadata("design:type", String)], SidePanelProps.prototype, "openButtonIcon");

  __decorate([Bound(), __metadata("design:type", Boolean)], SidePanelProps.prototype, "interceptClose");

  __decorate([Bound(), __metadata("design:type", Boolean)], SidePanelProps.prototype, "interceptOpen");

  __decorate([Bound(), __metadata("design:type", Number)], SidePanelProps.prototype, "panelWidth");

  __decorate([Bound(), __metadata("design:type", Number)], SidePanelProps.prototype, "closedPanelWidth");

  return SidePanelProps;
}(ObservablePropsMixin(DivHTMLAttributes));

var SidePanelEvents = function (_super) {
  __extends(SidePanelEvents, _super);

  function SidePanelEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], SidePanelEvents.prototype, "onClose");

  __decorate([Bound(), __metadata("design:type", Function)], SidePanelEvents.prototype, "onOpen");

  return SidePanelEvents;
}(DivHTMLEvents);
/**
 * Description: Left side panel that allows you to control the internal components!
 */


var SidePanel = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _a = props.open,
      open = _a === void 0 ? false : _a,
      observer = props.observer,
      hasTranscludedContent = props.hasTranscludedContent,
      _b = props.closeButtonIcon,
      closeButtonIcon = _b === void 0 ? 'single_arrow_left' : _b,
      _c = props.openButtonIcon,
      openButtonIcon = _c === void 0 ? 'single_arrow_right' : _c,
      hasTranscluded = props.hasTranscluded,
      _d = props.interceptClose,
      interceptClose = _d === void 0 ? false : _d,
      _e = props.interceptOpen,
      interceptOpen = _e === void 0 ? false : _e,
      resetTransclusion = props.resetTransclusion,
      _f = props.panelWidth,
      panelWidth = _f === void 0 ? 300 : _f,
      _g = props.closedPanelWidth,
      closedPanelWidth = _g === void 0 ? 50 : _g,
      onClose = props.onClose,
      onOpen = props.onOpen,
      ingredients = __rest(props, ["open", "observer", "hasTranscludedContent", "closeButtonIcon", "openButtonIcon", "hasTranscluded", "interceptClose", "interceptOpen", "resetTransclusion", "panelWidth", "closedPanelWidth", "onClose", "onOpen"]);

  delete ingredients.transclude;

  var _h = __read(React__default.useState(false), 2),
      isOpen = _h[0],
      setIsOpen = _h[1];

  var windowDims = useWindowSize();
  React__default.useEffect(function () {
    setIsOpen(open);
  }, [open]);

  var getSlotProps = function getSlotProps() {
    return {
      children: props.children,
      hasTranscludedContent: hasTranscludedContent,
      resetTransclusion: resetTransclusion,
      hasTranscluded: hasTranscluded
    };
  };

  var iconClick = function iconClick() {
    setIsOpen(function (v) {
      // closing
      if (v) {
        if (onClose) onClose();

        if (interceptClose) {
          return v;
        } else {
          if (observer) {
            observer.open = false;
          }

          return !v;
        } // opening

      } else {
        if (onOpen) onOpen();

        if (interceptOpen) {
          return v;
        } else {
          if (observer) {
            observer.open = true;
          }

          return !v;
        }
      }
    });
  };

  var width;

  if (windowDims.size === 'mobile') {
    width = isOpen ? '100%' : 0;
  } else {
    width = isOpen ? panelWidth : closedPanelWidth;
  }

  return jsxRuntime_2(jsxRuntime_3, {
    children: [jsxRuntime_2("div", _assign2({
      "data-testid": includeTestId('side-panel-wrapper'),
      className: "kxi-side-panel-wrapper " + (isOpen ? 'open' : '')
    }, {
      children: [jsxRuntime_2("div", _assign2({
        "data-testid": includeTestId('side-panel'),
        className: "kxi-side-panel"
      }, ingredients, {
        ref: ref,
        style: {
          minWidth: width,
          width: width
        }
      }, {
        children: [jsxRuntime_1("div", _assign2({
          "data-testid": includeTestId('panel-header'),
          className: "kxi-side-panel-header"
        }, {
          children: jsxRuntime_1(IconButton, {
            className: "kxi-side-panel-toggle-button",
            icon: isOpen ? closeButtonIcon : openButtonIcon,
            onClick: iconClick
          }, void 0)
        }), void 0), getSlot('side-panel', getSlotProps())]
      }), void 0), jsxRuntime_1("div", _assign2({
        className: "kxi-side-panel-main-content"
      }, {
        children: getSlot('main-content', getSlotProps())
      }), void 0)]
    }), void 0), jsxRuntime_1("div", {
      className: "kxi-grey-overlay"
    }, void 0)]
  }, void 0);
});
var _DrawerSizesOptions = ['small', 'large'];

var SuggestionItem = function SuggestionItem(props) {
  var itemText = props.itemText,
      typedText = props.typedText,
      onClick = props.onClick;

  var _a = __read(useState(''), 2),
      preTypedText = _a[0],
      setPreTypedText = _a[1];

  var _b = __read(useState(''), 2),
      displayedTypedText = _b[0],
      setDisplayedTypedText = _b[1];

  var _c = __read(useState(''), 2),
      postTypedText = _c[0],
      setPostTypedText = _c[1];

  useEffect(function () {
    var lowercaseItemText = itemText.toLowerCase();
    var strIndex = lowercaseItemText.indexOf(typedText.toLowerCase());

    if (strIndex > -1) {
      setPreTypedText(itemText.substring(0, strIndex));
      setDisplayedTypedText(itemText.substring(strIndex, strIndex + typedText.length));
      setPostTypedText(itemText.substring(strIndex + typedText.length));
    } else {
      setPreTypedText(itemText);
      setDisplayedTypedText('');
      setPostTypedText('');
    }
  }, [typedText]);

  var onSuggestionClick = function onSuggestionClick() {
    onClick(itemText);
  };

  return jsxRuntime_2("div", _assign2({
    role: "listitem",
    className: "kxi-suggestion",
    onMouseDown: onSuggestionClick
  }, {
    children: [jsxRuntime_1("span", _assign2({
      className: "kxi-text-600"
    }, {
      children: preTypedText
    }), void 0), jsxRuntime_1("span", {
      children: displayedTypedText
    }, void 0), jsxRuntime_1("span", _assign2({
      className: "kxi-text-600"
    }, {
      children: postTypedText
    }), void 0)]
  }), void 0);
};

var orca$2 = XIColors.orca,
    white$2 = XIColors.white,
    grey = XIColors.grey;
var colorError$1 = XIColorUsage.colorError;

var SearchBoxProps = function (_super) {
  __extends(SearchBoxProps, _super);

  function SearchBoxProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], SearchBoxProps.prototype, "placeholder");

  __decorate([Bound(), __metadata("design:type", String)], SearchBoxProps.prototype, "value");

  __decorate([Bound(), __metadata("design:type", Boolean)], SearchBoxProps.prototype, "isFiredOnEnter");

  __decorate([Bound(), __metadata("design:type", String)], SearchBoxProps.prototype, "contrast");

  __decorate([Bound(), __metadata("design:type", Object)], SearchBoxProps.prototype, "textSize");

  __decorate([Bound(), __metadata("design:type", Boolean)], SearchBoxProps.prototype, "hasOutline");

  __decorate([Bound(), __metadata("design:type", String)], SearchBoxProps.prototype, "outline");

  __decorate([Bound(), __metadata("design:type", Array)], SearchBoxProps.prototype, "data");

  __decorate([Bound(), __metadata("design:type", Number)], SearchBoxProps.prototype, "maxSuggestions");

  __decorate([Bound(), __metadata("design:type", Number)], SearchBoxProps.prototype, "maxLength");

  __decorate([Bound(), __metadata("design:type", Object)], SearchBoxProps.prototype, "status");

  __decorate([Bound(), __metadata("design:type", String)], SearchBoxProps.prototype, "componentSize");

  __decorate([Bound(), __metadata("design:type", Boolean)], SearchBoxProps.prototype, "stretch");

  __decorate([Bound(), __metadata("design:type", String)], SearchBoxProps.prototype, "type");

  return SearchBoxProps;
}(ObservablePropsMixin(InputHTMLAttributes));

var SearchBoxEvents = function (_super) {
  __extends(SearchBoxEvents, _super);

  function SearchBoxEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], SearchBoxEvents.prototype, "onCancelClick");

  __decorate([Bound(), __metadata("design:type", Function)], SearchBoxEvents.prototype, "onChangeOverride");

  __decorate([Bound(), __metadata("design:type", Function)], SearchBoxEvents.prototype, "onSuggestionClick");

  return SearchBoxEvents;
}(InputHTMLEvents);
/**
 * Description: InMoment branded text input field to be used as a search field.
 */


var SearchBox = /*#__PURE__*/forwardRef(function (props, ref) {
  var placeholder = props.placeholder,
      _a = props.hasOutline,
      hasOutline = _a === void 0 ? true : _a,
      outline = props.outline,
      _b = props.contrast,
      contrast = _b === void 0 ? 'normal' : _b,
      _c = props.textSize,
      textSize = _c === void 0 ? 'normal' : _c,
      status = props.status,
      value = props.value,
      onChangeOverride = props.onChangeOverride,
      _d = props.disabled,
      disabled = _d === void 0 ? false : _d,
      isFiredOnEnter = props.isFiredOnEnter,
      onCancelClick = props.onCancelClick,
      type = props.type,
      _onChange = props.onChange,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      onKeyDown = props.onKeyDown,
      className = props.className,
      maxLength = props.maxLength,
      data = props.data,
      _e = props.maxSuggestions,
      maxSuggestions = _e === void 0 ? 4 : _e,
      observer = props.observer,
      _f = props.componentSize,
      componentSize = _f === void 0 ? 'normal' : _f,
      onSuggestionClick = props.onSuggestionClick,
      stretch = props.stretch,
      ingredients = __rest(props, ["placeholder", "hasOutline", "outline", "contrast", "textSize", "status", "value", "onChangeOverride", "disabled", "isFiredOnEnter", "onCancelClick", "type", "onChange", "onFocus", "onBlur", "onKeyDown", "className", "maxLength", "data", "maxSuggestions", "observer", "componentSize", "onSuggestionClick", "stretch"]);

  var initialSuggestionArray = [];
  var node = useRef(null);

  var _g = __read(useState(props.value || ''), 2),
      searchText = _g[0],
      setSearchText = _g[1];

  var _h = __read(useState(false), 2),
      hoverState = _h[0],
      setHoverState = _h[1];

  var _j = __read(useState(false), 2),
      focusState = _j[0],
      setFocusState = _j[1];

  var _k = __read(useState(false), 2),
      cancelHover = _k[0],
      setCancelHover = _k[1];

  var _l = __read(useState(data), 2),
      suggestionData = _l[0],
      setSuggestionData = _l[1];

  var _m = __read(useState(initialSuggestionArray), 2),
      topSuggestions = _m[0],
      setTopSuggestions = _m[1];

  useEffect(function () {
    if (!maxLength || !value || (value === null || value === void 0 ? void 0 : value.length) <= maxLength) {
      setSearchText(value || '');
    }
  }, [value]);
  useEffect(function () {
    setSuggestionData(data);
  }, [data]); // Filter the suggestions down and map them to SuggestionItems
  // Items that start with the search term are ranked higher than those that just merely contain the search term

  useEffect(function () {
    if (suggestionData) {
      var likelyMatch = suggestionData.filter(function (suggestionItem) {
        var _a;

        return ((_a = suggestionItem.text) === null || _a === void 0 ? void 0 : _a.toLowerCase().indexOf(searchText.toLowerCase())) > 0;
      });
      var bestMatch = suggestionData.filter(function (suggestionItem) {
        var _a;

        return ((_a = suggestionItem.text) === null || _a === void 0 ? void 0 : _a.toLowerCase().indexOf(searchText.toLowerCase())) === 0 && suggestionItem.text !== searchText;
      });

      if (bestMatch.length >= maxSuggestions) {
        setTopSuggestions(mapSuggestions(bestMatch.slice(0, maxSuggestions)));
      } else {
        var concatSuggestions = bestMatch;
        concatSuggestions = concatSuggestions.concat(likelyMatch.slice(0, maxSuggestions - bestMatch.length));
        setTopSuggestions(mapSuggestions(concatSuggestions));
      }
    } else {
      setTopSuggestions(undefined);
    }
  }, [searchText]);

  var mapSuggestions = function mapSuggestions(suggestions) {
    return suggestions.map(function (suggestion, i) {
      return jsxRuntime_1(SuggestionItem, {
        itemText: suggestion.text,
        typedText: searchText,
        onClick: function onClick(itemText) {
          setSearchText(itemText);
          if (observer) observer.value = itemText;

          if (onSuggestionClick) {
            if (suggestion.id) onSuggestionClick(suggestion.text, suggestion.id);else onSuggestionClick(suggestion.text);
          }

          if (onChangeOverride) {
            devOnlyWarn('The Kitchen: Usage of onChangeOverride on the SearchBox component for suggestion items – is deprecated. Please use onSuggestionClick instead.');
            onChangeOverride(searchText);
          }
        }
      }, i);
    });
  };

  var updateText = function updateText(val) {
    if (!disabled) {
      if (!maxLength || val.length <= maxLength) {
        setSearchText(val);

        if (observer) {
          observer.value = val;
        }
      }

      if (onChangeOverride && !isFiredOnEnter) onChangeOverride(val);
    }
  };

  var active = checkIfTextInputTypeIsValid('SearchBox', type);

  var handleKeyPressed = function handleKeyPressed(e) {
    if (!disabled) {
      // checks whether the pressed key is {'Enter'}
      if (e.keyCode === 13) {
        if (onChangeOverride) onChangeOverride(searchText);

        if (node && node.current) {
          node.current.blur();
        }
      }
    }

    if (onKeyDown) onKeyDown(e);
  };

  var cancelFn = function cancelFn() {
    if (observer) {
      observer.value = '';
    }

    if (onCancelClick) {
      onCancelClick();
    }

    if (onChangeOverride) {
      onChangeOverride('');
    }

    setSearchText('');
    setHoverState(false);
    setCancelHover(false);
  };

  var handleFocus = function handleFocus(e) {
    setFocusState(true);
    if (onFocus) onFocus(e);
  };

  var handleBlur = function handleBlur(e) {
    setFocusState(false);
    changeOutline(false);
    if (onBlur) onBlur(e);
  };

  var changeOutline = function changeOutline(state) {
    if (!disabled) {
      setHoverState(state);
    }
  };

  var standardVariant = contrast === 'high' ? white$2.light[60] : grey.light[60];
  var focusVariant = contrast === 'high' ? white$2.primary : orca$2.primary;
  var errorColor = colorError$1;

  if (status) {
    errorColor = switchColorBasedOnWarning(status.state);
  }

  var searchIconColor;

  if (contrast === 'high' && (!hasOutline || outline === 'none') && !disabled) {
    searchIconColor = white$2.light[15];
  } else {
    if (focusState || hoverState && !disabled) {
      searchIconColor = status ? errorColor : focusVariant;
    } else {
      searchIconColor = status ? errorColor : standardVariant;
    }
  }

  return jsxRuntime_2("div", _assign2({
    className: "kxi-search-box orca kxi-" + componentSize + (contrast === 'high' ? ' kxi-high-contrast' : '') + " " + (className || '') + " " + (stretch ? 'kxi-stretch-width' : '') + " " + (outline === 'underline' ? 'kxi-bottom-border' : '') + " "
  }, {
    children: [jsxRuntime_1("div", _assign2({
      className: "kxi-search-icon"
    }, {
      children: !searchText ? jsxRuntime_1(XIIcon, {
        contrast: contrast,
        iconSize: componentSize === 'normal' ? 24 : 30,
        icon: "search"
      }, void 0) : jsxRuntime_1(CloseIcon, {
        disabled: disabled,
        contrast: contrast,
        cancelFn: cancelFn,
        changeOutline: changeOutline,
        cancelHover: cancelHover,
        setCancelHover: setCancelHover,
        size: componentSize === 'normal' ? 24 : 30
      }, void 0)
    }), void 0), jsxRuntime_1("input", _assign2({
      "aria-label": placeholder,
      role: "searchbox",
      "aria-disabled": disabled,
      className: (hasOutline && !outline || outline === 'outline' ? ' kxi-border' : '') + " " + (status ? " kxi-" + status.state : '') + " kxi-text-" + textSize + " " + (className || ''),
      type: active ? type : 'search',
      color: searchIconColor,
      ref: mergeRefs([node, ref]),
      onKeyDown: handleKeyPressed,
      onBlur: handleBlur,
      onFocus: handleFocus,
      value: searchText,
      placeholder: placeholder,
      onChange: function onChange(e) {
        updateText(e.target.value);
        if (_onChange) _onChange(e);
      },
      readOnly: disabled,
      disabled: disabled
    }, ingredients), void 0), jsxRuntime_1(AnimatePresence, {
      children: searchText && focusState && (topSuggestions === null || topSuggestions === void 0 ? void 0 : topSuggestions.length) !== 0 && jsxRuntime_1(motion.div, _assign2({
        initial: {
          opacity: 0
        },
        animate: {
          opacity: 1
        },
        exit: {
          opacity: 0
        },
        transition: {
          duration: 0.1
        },
        className: "kxi-suggestion-wrapper"
      }, {
        children: jsxRuntime_1("div", _assign2({
          "aria-hidden": !searchText && (topSuggestions === null || topSuggestions === void 0 ? void 0 : topSuggestions.length) === 0,
          role: "list"
        }, {
          children: topSuggestions
        }), void 0)
      }), void 0)
    }, void 0), status ? jsxRuntime_1("span", _assign2({
      className: status ? " kxi-" + status.state : ''
    }, {
      children: status.text
    }), void 0) : null]
  }), void 0);
});

var ListProps = function (_super) {
  __extends(ListProps, _super);

  function ListProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], ListProps.prototype, "color");

  __decorate([Bound(), __metadata("design:type", String)], ListProps.prototype, "select");

  __decorate([Bound(), __metadata("design:type", Boolean)], ListProps.prototype, "hasSearch");

  __decorate([Bound(), __metadata("design:type", Boolean)], ListProps.prototype, "hasDragging");

  __decorate([Bound(), __metadata("design:type", Object)], ListProps.prototype, "value");

  __decorate([Bound(), __metadata("design:type", String)], ListProps.prototype, "label");

  __decorate([Bound(), __metadata("design:type", Object)], ListProps.prototype, "localization");

  __decorate([Bound(), __metadata("design:type", Object)], ListProps.prototype, "internalProps");

  __decorate([Bound(), __metadata("design:type", Object)], ListProps.prototype, "status");

  __decorate([Bound(), __metadata("design:type", String)], ListProps.prototype, "contrast");

  return ListProps;
}(ObservablePropsMixin(UListHTMLAttributes));

var ListEvents = function (_super) {
  __extends(ListEvents, _super);

  function ListEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], ListEvents.prototype, "onChange");

  return ListEvents;
}(UListHTMLEvents);
/**
 * Description: Displays a list of items in a pretty way.
 */


var List = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
      color = props.color,
      label = props.label,
      _a = props.select,
      select = _a === void 0 ? 'none' : _a,
      _b = props.contrast,
      contrast = _b === void 0 ? 'normal' : _b,
      _c = props.hasSearch,
      hasSearch = _c === void 0 ? false : _c,
      hasDragging = props.hasDragging,
      onChange = props.onChange,
      status = props.status,
      internalProps = props.internalProps,
      className = props.className,
      _d = props.value,
      value = _d === void 0 ? [] : _d,
      observer = props.observer,
      localization = props.localization,
      resetTransclusion = props.resetTransclusion,
      hasTranscluded = props.hasTranscluded,
      hasTranscludedContent = props.hasTranscludedContent,
      ingredients = __rest(props, ["children", "color", "label", "select", "contrast", "hasSearch", "hasDragging", "onChange", "status", "internalProps", "className", "value", "observer", "localization", "resetTransclusion", "hasTranscluded", "hasTranscludedContent"]);

  delete ingredients.transclude;

  var _e = __read(useState(value), 2),
      activeValues = _e[0],
      setActiveValues = _e[1];

  var _f = __read(useState(''), 2),
      searchValue = _f[0],
      setSearchValue = _f[1];

  var _g = __read(useState(true), 2),
      initialRender = _g[0],
      setInitialRender = _g[1];

  var _h = __read(useState(localization), 2),
      outputLocalization = _h[0],
      setOutputLocalization = _h[1];

  var _j = __read(useState(color), 2),
      outputColor = _j[0],
      setOutputColor = _j[1];

  var isMulti = ['multi', 'multiple'].indexOf(select) >= 0;
  useEffect(function () {
    setOutputLocalization(localization);
    setOutputColor(color);
  }, [localization, color]);
  useEffect(function () {
    var singleValue = Number.isInteger(activeValues[0]) ? activeValues[0] : [];
    if (!initialRender && onChange) onChange(select === 'single' ? singleValue : activeValues);
    if (initialRender) setInitialRender(false);
  }, [activeValues]);
  useEffect(function () {
    if (internalProps) setSearchValue(internalProps.searchBox.value);
  }, [internalProps]);
  useEffect(function () {
    var e_1, _a;

    if (!hasChildren(children)) {
      return;
    }

    var _loop_1 = function _loop_1(val) {
      children.filter(function (child) {
        return child.props.value === val;
      }).forEach(function (child) {
        return child.props.checked = true;
      });
    };

    try {
      for (var value_1 = __values(value), value_1_1 = value_1.next(); !value_1_1.done; value_1_1 = value_1.next()) {
        var val = value_1_1.value;

        _loop_1(val);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (value_1_1 && !value_1_1.done && (_a = value_1["return"])) _a.call(value_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  }, [value]);
  var mergedChildren = Children.map(children, function (child) {
    if ( /*#__PURE__*/isValidElement(child)) {
      var childOnClick_1 = child.props.onClick;

      var onClick = function onClick(e) {
        var value = e.currentTarget.value;
        if (!value && value !== 0) value = e.currentTarget.getAttribute('value');

        if (select !== 'none') {
          var newValue = void 0;

          if (activeValues.indexOf(value) >= 0) {
            newValue = __spreadArray([], __read(activeValues.filter(function (v) {
              return v !== value;
            })));
          } else {
            newValue = isMulti ? __spreadArray(__spreadArray([], __read(activeValues)), [value]) : [value];
          }

          if (onChange) {
            onChange(newValue);
          }

          setActiveValues(newValue);

          if (observer) {
            observer.value = newValue;
          }
        }

        if (childOnClick_1) {
          childOnClick_1(e);
        }
      };

      var props_1 = {
        select: select,
        onClick: onClick
      };

      if (outputColor !== undefined) {
        props_1.color = outputColor;
      }

      if (hasDragging !== undefined) {
        props_1.hasDragging = hasDragging;
      }

      var clone = /*#__PURE__*/cloneElement(child, props_1);
      return clone;
    }

    return child;
  });

  var onChangeOverride = function onChangeOverride(text) {
    if (internalProps && internalProps.searchBox.onChangeOverride) {
      internalProps.searchBox.onChangeOverride(text);
    }

    setSearchValue(text);
  };

  var contrastClass = contrast === 'high' ? ' kxi-high-contrast' : '';
  var errorStateClass = (status === null || status === void 0 ? void 0 : status.state) ? " kxi-" + status.state : '';
  return jsxRuntime_2(jsxRuntime_3, {
    children: [jsxRuntime_1("label", _assign2({
      className: "kxi-label kxi-text-normal"
    }, {
      children: label
    }), void 0), jsxRuntime_2("ul", _assign2({
      className: "kxi-list-wrapper " + normalizeColor(color || 'orca') + " " + errorStateClass + " " + contrastClass + " " + (className || ''),
      ref: ref
    }, ingredients, {
      children: [hasSearch && jsxRuntime_1("div", _assign2({
        className: "kxi-list-search"
      }, {
        children: jsxRuntime_1(SearchBox, _assign2({
          hasOutline: false,
          value: searchValue
        }, internalProps === null || internalProps === void 0 ? void 0 : internalProps.searchBox, {
          onChangeOverride: onChangeOverride,
          ref: null,
          stretch: true
        }), void 0)
      }), void 0), hasChildren(children) ? mergedChildren : jsxRuntime_1(Slot, {
        name: "children",
        hasTranscludedContent: hasTranscludedContent,
        resetTransclusion: resetTransclusion,
        propsToWatch: [select, hasSearch, color],
        hasTranscluded: hasTranscluded
      }, void 0), hasSearch && !hasChildren(children) && jsxRuntime_2("div", _assign2({
        className: "kxi-list-no-results-found kxi-text-xlarge",
        id: "no-results-div",
        onMouseDown: function onMouseDown(e) {
          return e.preventDefault();
        }
      }, {
        children: [outputLocalization && outputLocalization.noResultsFound ? outputLocalization.noResultsFound : 'No Results Found', jsxRuntime_1(DefaultButton, {
          onClick: function onClick() {
            var _a;

            setSearchValue('');

            if ((_a = internalProps === null || internalProps === void 0 ? void 0 : internalProps.searchBox) === null || _a === void 0 ? void 0 : _a.onChangeOverride) {
              internalProps.searchBox.onChangeOverride('');
            }
          },
          className: "kxi-clear-button",
          contrast: contrast,
          color: color,
          text: outputLocalization && outputLocalization.clearSearch ? outputLocalization.clearSearch : 'Clear Search'
        }, void 0)]
      }), void 0)]
    }), void 0), status && status.text ? jsxRuntime_2("div", _assign2({
      className: "kxi-status-container " + contrastClass
    }, {
      children: [status.state === 'error' && jsxRuntime_1(XIIcon, {
        iconSize: "normal",
        icon: "warning_filled",
        color: status === null || status === void 0 ? void 0 : status.state
      }, void 0), ' ', jsxRuntime_1("div", _assign2({
        className: "kxi-status-label kxi-left " + errorStateClass
      }, {
        children: status.text
      }), void 0)]
    }), void 0) : '']
  }, void 0);
});

var LiHTMLAttributes = function (_super) {
  __extends(LiHTMLAttributes, _super);

  function LiHTMLAttributes() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return LiHTMLAttributes;
}(HTMLAttributes);

var LiHTMLEvents = function (_super) {
  __extends(LiHTMLEvents, _super);

  function LiHTMLEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return LiHTMLEvents;
}(DOMEvents);

var ListItemProps = function (_super) {
  __extends(ListItemProps, _super);

  function ListItemProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Object)], ListItemProps.prototype, "value");

  __decorate([Bound(), __metadata("design:type", Boolean)], ListItemProps.prototype, "checked");

  __decorate([Bound(), __metadata("design:type", Boolean)], ListItemProps.prototype, "disabled");

  __decorate([Bound(), __metadata("design:type", String)], ListItemProps.prototype, "select");

  __decorate([Bound(), __metadata("design:type", Boolean)], ListItemProps.prototype, "hasDragging");

  __decorate([Bound(), __metadata("design:type", String)], ListItemProps.prototype, "color");

  return ListItemProps;
}(ObservablePropsMixin(LiHTMLAttributes));

var ListItemEvents = function (_super) {
  __extends(ListItemEvents, _super);

  function ListItemEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return ListItemEvents;
}(LiHTMLEvents);
/**
 * Description: For use inside of the List component, this contains an individual item.
 */


var ListItem = /*#__PURE__*/forwardRef(function (props, ref) {
  var _a = props.disabled,
      disabled = _a === void 0 ? false : _a,
      value = props.value,
      _b = props.select,
      select = _b === void 0 ? 'none' : _b,
      hasDragging = props.hasDragging,
      _c = props.color,
      color = _c === void 0 ? 'CX' : _c,
      checked = props.checked,
      onClick = props.onClick,
      observer = props.observer,
      resetTransclusion = props.resetTransclusion,
      hasTranscluded = props.hasTranscluded,
      hasTranscludedContent = props.hasTranscludedContent,
      _d = props._canBeDeselected,
      _canBeDeselected = _d === void 0 ? true : _d,
      ingredients = __rest(props, ["disabled", "value", "select", "hasDragging", "color", "checked", "onClick", "observer", "resetTransclusion", "hasTranscluded", "hasTranscludedContent", "_canBeDeselected"]);

  delete ingredients.transclude;
  var children = props.children ? props.children : jsxRuntime_1(Slot, {
    name: "children",
    propsToWatch: [select, value],
    hasTranscludedContent: hasTranscludedContent,
    resetTransclusion: resetTransclusion,
    hasTranscluded: hasTranscluded
  }, void 0);

  var _e = __read(useState(checked), 2),
      isChecked = _e[0],
      setIsChecked = _e[1];

  var isMulti = ['multi', 'multiple'].indexOf(select) >= 0;
  useEffect(function () {
    throwPropErrorMessage('ListItem', {
      value: value
    });
  }, [value]);
  useEffect(function () {
    if (checked !== undefined && isChecked !== checked) {
      setIsChecked(checked);
    }
  }, [checked]);

  var handleOnClick = function handleOnClick(e) {
    if (select !== 'none' && _canBeDeselected) {
      if (observer) {
        observer.checked = !isChecked;
      }

      setIsChecked(function (c) {
        return !c;
      });
    }

    if (onClick) onClick(e);
    e.preventDefault();
    e.stopPropagation();
  };

  var handleCheckKeyPress = function handleCheckKeyPress(e) {
    if (disabled === true) return;

    if (e.key === 'Enter') {
      if (observer) observer.checked = !isChecked;
      setIsChecked(function (c) {
        return !c;
      });
    }
  };

  var multiPadding = isMulti ? 12 : 18;
  var itemStyle = {
    paddingLeft: hasDragging ? 3 : multiPadding,
    cursor: disabled ? 'auto' : 'pointer'
  };
  var classNames = "kxi-list-item ";
  if (disabled) classNames += 'disabled ';
  if (isMulti) classNames += 'multi ';
  if (color && isChecked && !isMulti && !disabled) classNames += "active";
  return jsxRuntime_2("li", _assign2({
    className: classNames,
    ref: ref,
    value: value,
    style: itemStyle
  }, ingredients, {
    onClick: function onClick(e) {
      if (!disabled) {
        handleOnClick(e);
        e.preventDefault();
        e.stopPropagation();
      }
    },
    "data-testid": "listItem",
    "data-is-checked": isChecked
  }, {
    children: [hasDragging && jsxRuntime_1("div", _assign2({
      style: {
        paddingRight: 3
      }
    }, {
      children: jsxRuntime_1(XIIcon, {
        icon: "drag_handle",
        color: disabled ? 'disabled' : 'orca'
      }, void 0)
    }), void 0), isMulti && jsxRuntime_1("div", _assign2({
      style: {
        paddingRight: 6,
        height: 18
      }
    }, {
      children: jsxRuntime_1(Checkbox, {
        checked: isChecked,
        disabled: disabled,
        color: color,
        onKeyPress: handleCheckKeyPress
      }, void 0)
    }), void 0), jsxRuntime_1("div", _assign2({
      className: "kxi-list-item-wrapper " + (disabled ? 'disabled' : ''),
      style: {
        opacity: disabled ? '0.5' : '1',
        userSelect: disabled ? 'none' : 'auto'
      }
    }, {
      children: jsxRuntime_1("div", _assign2({
        style: {
          width: '100%',
          userSelect: 'none'
        }
      }, {
        children: children
      }), void 0)
    }), void 0), !isMulti && isChecked && jsxRuntime_1("div", _assign2({
      style: {
        paddingRight: 6
      }
    }, {
      children: jsxRuntime_1(XIIcon, {
        icon: "circle_check_filled",
        color: color
      }, void 0)
    }), void 0)]
  }), value);
});

Date.prototype.addDays = function (days) {
  var value = this.valueOf();
  var date = new Date(value);
  date.setDate(date.getDate() + days);
  return date;
}; // gets dates in between two dates


var getDates = function getDates(startDate, stopDate) {
  var dateArray = [];
  var currentDate = startDate;

  while (currentDate <= stopDate) {
    dateArray.push(new Date(currentDate));
    currentDate = currentDate.addDays(1);
  }

  return dateArray;
};

var returnShortDayArray = function returnShortDayArray(locale) {
  var currDate = new Date();
  var DAYS = [0, 1, 2, 3, 4, 5, 6]; // It's not straightforward to start at Sunday, so get seven consecutive days
  // and sort them by day of the week afterward.

  var mappedDays = DAYS.map(function (day) {
    var date = new Date(currDate.getFullYear(), currDate.getMonth(), day);
    return {
      dayOfWeek: date.getDay(),
      localization: Intl.DateTimeFormat(locale, {
        weekday: 'narrow'
      }).format(date)
    };
  });
  return mappedDays.sort(function (first, second) {
    return first.dayOfWeek - second.dayOfWeek;
  });
};

var formatControlledInput = function formatControlledInput(e, property, propertySetter, locale, separator) {
  var value = e.target.value; // if isTyping is false, then they are deleting instead of typing

  var isTyping = value.length > property.length;

  if (!isTyping) {
    propertySetter(value);
    return;
  }

  var newLetter = value[value.length - 1];
  var typingSection = getTypingSection(value, locale, separator);

  switch (typingSection.section) {
    case 'DD':
      if (newLetter === separator && typingSection.sectionData.length > 0 && typingSection.hasAdditional) {
        //allow a slash when length > 0 and there are more sections
        propertySetter(value);
      } else if (Number(typingSection.sectionData) > 3 && typingSection.sectionData.length === 1) {
        //fast forward to the next section when an impossible 2 digit number is entered
        if (typingSection.hasAdditional) {
          propertySetter("" + value + separator);
        } else {
          propertySetter(value);
        }
      } else if ((typingSection.sectionData === '0' || Number(typingSection.sectionData)) && typingSection.sectionData.length === 1) {
        // allow a leading 0
        propertySetter(value);
      } else if (Number(typingSection.sectionData) && typingSection.sectionData.length === 2) {
        // fast forward onto the next section once this section is filled out
        if (typingSection.hasAdditional) {
          propertySetter("" + value + separator);
        } else {
          propertySetter(value);
        }
      } else if (Number(typingSection.sectionData.slice(0, 2)) && typingSection.sectionData.length > 2 && typingSection.hasAdditional) {
        // if the user gets themselves into a position where they must enter a '/' allow
        // them a way out
        propertySetter("" + value.slice(0, value.length - 1) + separator);
      }

      break;

    case 'MM':
      if (newLetter === separator && typingSection.sectionData.length > 0 && typingSection.hasAdditional) {
        propertySetter(value);
      } else if (Number(typingSection.sectionData) > 1 && typingSection.sectionData.length === 1) {
        if (typingSection.hasAdditional) {
          propertySetter("" + value + separator);
        } else {
          propertySetter(value);
        }
      } else if ((typingSection.sectionData === '0' || Number(typingSection.sectionData)) && typingSection.sectionData.length === 1) {
        propertySetter(value);
      } else if (Number(typingSection.sectionData) && typingSection.sectionData.length === 2) {
        if (typingSection.hasAdditional) {
          propertySetter("" + value + separator);
        } else {
          propertySetter(value);
        }
      } else if (Number(typingSection.sectionData.slice(0, 2)) && typingSection.sectionData.length > 2 && typingSection.hasAdditional) {
        propertySetter("" + value.slice(0, value.length - 1) + separator);
      }

      break;

    case 'YYYY':
      if (newLetter === separator && (typingSection.sectionData.length === 2 || typingSection.sectionData.length === 4) && typingSection.hasAdditional) {
        propertySetter(value);
      } else if (Number(typingSection.sectionData) && typingSection.sectionData.length < 4) {
        propertySetter(value);
      } else if (Number(typingSection.sectionData) && typingSection.sectionData.length === 4) {
        if (typingSection.hasAdditional) {
          propertySetter("" + value + separator);
        } else {
          propertySetter(value);
        }
      } else if (Number(typingSection.sectionData.slice(0, 2)) && typingSection.sectionData.length > 2 && typingSection.hasAdditional) {
        propertySetter("" + value.slice(0, value.length - 1) + separator);
      }

      break;
  }
};

var getTypingSection = function getTypingSection(value, locale, separator) {
  var placeholder = extractDateFormatPlaceholder(locale, separator);
  var numSlashes = value.slice(0, value.length - 1).split(separator).length;
  var splitPlaceholder = placeholder.split(separator);
  return {
    section: splitPlaceholder[numSlashes - 1],
    hasAdditional: numSlashes < 3,
    sectionData: value.split(separator)[numSlashes - 1]
  };
};

var formatDateMDY = function formatDateMDY(dateString, locale, separator) {
  var dates = dateString.split(separator);
  var localeString = extractDateFormatPlaceholder(locale, separator);
  var locales = localeString.split(separator);
  var month = Number(dates[locales.findIndex(function (loc) {
    return loc === 'MM';
  })]);
  var day = Number(dates[locales.findIndex(function (loc) {
    return loc === 'DD';
  })]);
  var year = Number(dates[locales.findIndex(function (loc) {
    return loc === 'YYYY';
  })]);

  if (!month || !day || !year || month <= 0 || month > 12 || day <= 0 || day > 31 || year <= 0) {
    return undefined;
  }

  return month + "/" + day + "/" + year;
};

var extractDateFormatPlaceholder = function extractDateFormatPlaceholder(locale, separator) {
  var testDate = new Date(1999, 5);
  var dateString = testDate.toLocaleDateString(locale, {
    month: '2-digit',
    year: 'numeric',
    day: '2-digit'
  });
  dateString = dateString.replace('1999', 'YYYY');
  dateString = dateString.replace('06', 'MM');
  dateString = dateString.replace('01', 'DD');
  dateString = dateString.replace(/\//g, separator);
  return dateString;
};

var formatDateObject = function formatDateObject(date, locale, separator) {
  if (locale === void 0) {
    locale = 'en-us';
  }

  if (typeof date === 'string') {
    date = new Date(date);
  }

  return {
    dateString: date.toLocaleDateString(locale, {
      month: '2-digit',
      year: 'numeric',
      day: '2-digit'
    }).replace(/\//g, separator),
    monthString: date.toLocaleDateString(locale, {
      month: '2-digit'
    }),
    dayString: date.toLocaleDateString(locale, {
      day: '2-digit'
    }),
    yearString: date.toLocaleDateString(locale, {
      year: 'numeric'
    })
  };
};

var getInitialDates = function getInitialDates(dateObject) {
  var dateArray = [];
  var selectedDateRange = dateObject.selectedDateRange;
  var initialDateTemp = new Date();
  initialDateTemp = selectedDateRange.first || new Date();
  var initialDate = new Date(initialDateTemp); // initial date is getting reset, so it's a running update.
  // back one

  initialDate.setMonth(initialDate.getMonth() - 1, 1);
  var zero = new Date(initialDate); // current

  initialDate.setMonth(initialDate.getMonth() + 1, 1);
  var first = new Date(initialDate); // next

  initialDate.setMonth(initialDate.getMonth() + 1, 1);
  var second = new Date(initialDate); // two forward

  initialDate.setMonth(initialDate.getMonth() + 1, 1);
  var third = new Date(initialDate);
  dateArray.push(zero, first, second, third);
  return dateArray;
};

var orca$3 = XIColors.orca,
    grey$1 = XIColors.grey,
    white$3 = XIColors.white;
var today = new Date();
today.setHours(0, 0, 0, 0);

var CalendarGrid = function CalendarGrid(props) {
  var setDateRange = props.setDateRange,
      dateRange = props.dateRange,
      dates = props.dates,
      date = props.date,
      handleDateClick = props.handleDateClick,
      selectedDates = props.selectedDates,
      contrast = props.contrast,
      mouseToggle = props.mouseToggle,
      locale = props.locale,
      minDate = props.minDate,
      maxDate = props.maxDate;

  var _a = __read(useState(), 2),
      hoveredDate = _a[0],
      setHoveredDate = _a[1];

  var mappedDays = returnShortDayArray(locale).map(function (_a) {
    var dayOfWeek = _a.dayOfWeek,
        localization = _a.localization;
    return jsxRuntime_1("p", _assign2({
      className: "kxi-text-small kxi-text-center kxi-text-300 kxi-calendar-day"
    }, {
      children: localization
    }), dayOfWeek);
  });
  var mappedDates = dates.map(function (dateNumber, i) {
    //  date is just to get the month - and it reassigns the date with the appropriate number.
    var curr = new Date(date.getFullYear(), date.getMonth(), dateNumber);
    var disabled = curr < minDate || curr > maxDate;
    var daysInMonth = new Date(curr.getFullYear(), curr.getMonth() + 1, 0).getDate(); // we don't want curr highlighted if dateNumber is merely a placeholder

    curr = dateNumber === ' ' ? new Date(NaN) : curr;
    var day = curr.getDay();
    var monthDate = curr.getDate();
    var first = selectedDates.first,
        last = selectedDates.last;
    var background = '';
    var highlighted = [];
    var isSund = day === 0;
    var isSat = day === 6;
    var isFirst = monthDate === 1;
    var isSameDay = today.getDate() === monthDate;
    var isSameMonth = today.getMonth() === curr.getMonth();
    var isSameYear = today.getFullYear() === curr.getFullYear();
    var isSameAll = isSameDay && isSameMonth && isSameYear && (hoveredDate === null || hoveredDate === void 0 ? void 0 : hoveredDate.valueOf()) !== today.valueOf();
    var borders = {
      borderTopLeftRadius: isSund || isFirst || isSameAll ? '50%' : '0%',
      borderBottomLeftRadius: isSund || isFirst || isSameAll ? '50%' : '0%',
      borderTopRightRadius: isSat || isSameAll ? '50%' : '0%',
      borderBottomRightRadius: isSat || isSameAll ? '50%' : '0%'
    };
    var highlightSpan = false; // setting the orca span for to go on top of hovered

    if (hoveredDate && !disabled) {
      if (hoveredDate.getMonth() === curr.getMonth() && hoveredDate.getFullYear() === curr.getFullYear() && hoveredDate.getDate() === curr.getDate()) {
        highlightSpan = true;
      }
    } // still working on optimizing, loops through and finds ranges that should be highlighted


    if (first && !disabled) {
      dateRange.forEach(function (d) {
        // loop++;
        if (d.valueOf() === curr.valueOf()) {
          highlighted.push(i);
        }
      });
    }

    if (highlighted.includes(i) && dateNumber !== ' ') {
      var border = "1px solid " + grey$1.light[80];

      if (isSameAll) {
        borders.borderTopLeftRadius = '0%';
        borders.borderTopRightRadius = '0%';
        borders.borderBottomRightRadius = '0%';
        borders.borderBottomLeftRadius = '0%';
      }

      if (!last) {
        borders.borderTop = border;
        borders.borderBottom = border;
        borders.borderLeft = isSund || isFirst ? border : '';
        borders.borderRight = isSat ? border : '';
      } else {
        background = contrast === 'normal' ? orca$3.light[80] : orca$3.light[40];
      }
    } // creating the flag for the highlighted span to go on top of the first and last divs in the date range


    if (first) {
      if (curr.valueOf() === first.valueOf()) {
        borders.borderTopLeftRadius = '50%';
        borders.borderBottomLeftRadius = '50%';
        highlightSpan = true;
      }
    }

    if (last) {
      curr.setHours(23, 59, 59, 999);

      if (curr.valueOf() === last.valueOf()) {
        borders.borderTopRightRadius = '50%';
        borders.borderBottomRightRadius = '50%';
        highlightSpan = true;
      }
    }

    if (curr.getDate() === daysInMonth) {
      borders.borderTopRightRadius = '50%';
      borders.borderBottomRightRadius = '50%';
    } // prevents right side border from showing on the hovered item;


    if (hoveredDate) {
      if (hoveredDate.valueOf() === curr.valueOf() && !last) {
        borders.borderTopRightRadius = '50%';
        borders.borderBottomRightRadius = '50%';
      }
    }

    var inactiveDateSpanColor = contrast === 'normal' ? orca$3.primary : white$3.primary;

    if (disabled) {
      inactiveDateSpanColor = contrast === 'normal' ? grey$1.light[80] : grey$1.light[15];
    }

    var dateSpanStyles = _assign2(_assign2({
      color: inactiveDateSpanColor
    }, borders), {
      background: background
    });

    var classNames = "kxi-date-span ";
    if (dateNumber === ' ') classNames += 'kxi-hidden-date-span ';

    if (first) {
      classNames += disabled ? 'kxi-date-disabled ' : 'kxi-second-date-hover ';
    } else {
      classNames += disabled ? 'kxi-date-disabled ' : 'kxi-first-date-hover ';
    }

    if (isSameAll && !highlighted.includes(i)) {
      classNames += "kxi-todays-date-" + contrast + " ";
    }

    return jsxRuntime_2("div", _assign2({
      className: classNames,
      "data-testid": dateNumber !== ' ' && includeTestId(Intl.DateTimeFormat().format(new Date(date.getFullYear(), date.getMonth(), +dateNumber))),
      style: dateSpanStyles,
      onMouseOver: function onMouseOver() {
        if (first) {
          setHoveredDate(curr);
        }
      },
      onMouseDown: function onMouseDown() {
        if (!disabled) handleDateClick(date, dateNumber);
      }
    }, {
      children: [highlightSpan ? jsxRuntime_1("p", _assign2({
        style: {
          height: '100%',
          width: '100%',
          background: contrast === 'normal' ? orca$3.primary : white$3.primary,
          borderRadius: '50%',
          position: 'absolute',
          color: contrast === 'normal' ? white$3.primary : orca$3.primary,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          margin: 0
        }
      }, {
        children: dateNumber
      }), void 0) : '', jsxRuntime_1("p", _assign2({
        style: {
          color: 'inherit'
        }
      }, {
        children: dateNumber
      }), void 0)]
    }), i);
  }); // controls the hover coloring of the dates

  useEffect(function () {
    // only highlights if the first date is selected and something is being hovered
    if (selectedDates.first && hoveredDate && !selectedDates.last) {
      setDateRange(getDates(selectedDates.first, hoveredDate));
    }

    if (selectedDates.first && selectedDates.last) {
      setDateRange(getDates(selectedDates.first, selectedDates.last));
    }
  }, [hoveredDate, mouseToggle, selectedDates]);
  return jsxRuntime_2("div", _assign2({
    className: "kxi-calendar-grid-wrapper",
    onMouseLeave: function onMouseLeave() {
      return setHoveredDate(null);
    }
  }, {
    children: [mappedDays, jsxRuntime_1("hr", {
      className: "kxi-calendar-hr"
    }, void 0), mappedDates]
  }), void 0);
};

var orca$4 = XIColors.orca,
    white$4 = XIColors.white;
var monthNumbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
var yearNumberDiff = [-11, -10, -9, -8, -7, -6, -5, -4, -3, -2, -1, 0];

var CalendarModal = function CalendarModal(props) {
  var locale = props.locale,
      minDate = props.minDate,
      maxDate = props.maxDate,
      date = props.date,
      contrast = props.contrast,
      yearDiff = props.yearDiff,
      isMonth = props.isMonth,
      index = props.index,
      _a = props.selectedRangeDates,
      first = _a.first,
      last = _a.last,
      onDateClick = props.onDateClick;
  var mappedDates = [];
  var highlight = contrast === 'normal' ? orca$4.primary : white$4.primary;
  var matchedTextColor = contrast === 'normal' ? white$4.primary : orca$4.primary;

  if (isMonth) {
    var monthOptions_1 = {
      month: 'short'
    };
    mappedDates = monthNumbers.map(function (month, i) {
      var text = Intl.DateTimeFormat(locale, monthOptions_1).format(new Date(date.setMonth(month)));
      var year = date.getFullYear(); // setting limit to the very end of the month, so that the min works properly

      var limit = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      limit.setHours(23, 59, 59, 999);
      var disabled = false;

      if (limit.valueOf() < minDate.valueOf() || date.valueOf() > maxDate.valueOf()) {
        disabled = true;
      }

      var match = false;

      if (first && date.getMonth() === first.getMonth() && year === first.getFullYear()) {
        match = true;
      }

      if (last && date.getMonth() === last.getMonth() && year === last.getFullYear()) {
        match = true;
      }

      var buttonTextColor = contrast === 'normal' ? 'orca' : 'disabled';

      if (disabled) {
        // counter-intuitive, but due to the background color it ends up being correct.
        buttonTextColor = contrast === 'normal' ? 'disabled' : 'orca';
      }

      var headingButtonStyle = {
        margin: 6,
        flexBasis: '25%',
        height: 'unset',
        justifyContent: 'center',
        borderRadius: 66,
        background: match ? highlight : '',
        color: match ? matchedTextColor : ''
      };
      return jsxRuntime_1(HeadingButton, {
        className: "kxi-modal-heading-button",
        contrast: contrast,
        level: 3,
        title: text.toUpperCase(),
        onClick: function onClick() {
          return onDateClick(month, year);
        },
        color: buttonTextColor,
        style: headingButtonStyle,
        disabled: disabled
      }, i);
    });
  } else {
    var yearOptions_1 = {
      year: 'numeric'
    };
    mappedDates = yearNumberDiff.map(function (number, i) {
      var dateCopy = new Date();
      dateCopy.setFullYear(dateCopy.getFullYear() + yearDiff);
      var year = dateCopy.getFullYear() + number;
      var month = dateCopy.getMonth();
      var disabled = false;

      if (year < minDate.getFullYear() || year > maxDate.getFullYear()) {
        disabled = true;
      }

      var text = Intl.DateTimeFormat(locale, yearOptions_1).format(new Date(dateCopy.setFullYear(year)));
      var buttonTextColor = contrast === 'normal' ? 'orca' : 'disabled';

      if (disabled) {
        // counter-intuitive, but due to the background color it ends up being correct.
        buttonTextColor = contrast === 'normal' ? 'disabled' : 'orca';
      }

      var match = false;

      if (first && year === first.getFullYear()) {
        match = true;
      }

      if (last && year === last.getFullYear()) {
        match = true;
      }

      var headingButtonStyle = {
        margin: 6,
        flexBasis: '25%',
        height: 'unset',
        justifyContent: 'center',
        borderRadius: 66,
        background: match ? highlight : '',
        color: match ? matchedTextColor : ''
      };
      return jsxRuntime_1(HeadingButton, {
        className: "kxi-modal-heading-button",
        contrast: contrast,
        level: 3,
        title: text,
        style: headingButtonStyle,
        onClick: function onClick() {
          return onDateClick(month, year);
        },
        color: buttonTextColor,
        disabled: disabled
      }, i);
    });
  }

  return jsxRuntime_1("div", _assign2({
    className: "kxi-calendar-modal-wrapper"
  }, {
    children: jsxRuntime_1("div", _assign2({
      className: "kxi-calendar-modal-option-wrapper"
    }, {
      children: mappedDates
    }), void 0)
  }), index);
};

var jumpYear = 12;

var Calendars = function Calendars(props) {
  var selectedRangeDates = props.selectedRangeDates,
      dateArray = props.dateArray,
      modalType = props.modalType,
      contrast = props.contrast,
      locale = props.locale,
      minDate = props.minDate,
      maxDate = props.maxDate,
      isStartFocused = props.isStartFocused,
      generateId = props.generateId,
      setSelectedRangeDates = props.setSelectedRangeDates,
      setDateArray = props.setDateArray,
      setIsStartFocused = props.setIsStartFocused,
      setModalType = props.setModalType,
      onDateClick = props.onDateClick;

  var _a = __read(useState([]), 2),
      dateRange = _a[0],
      setDateRange = _a[1];

  var _b = __read(useState(new Date().toString()), 2),
      mouseToggle = _b[0],
      setMouseToggle = _b[1];

  var _c = __read(useState(false), 2),
      disabled = _c[0],
      setDisabled = _c[1];

  var _d = __read(useState(0), 2),
      yearDiff = _d[0],
      setYearDiff = _d[1];

  var _e = __read(useState(true), 2),
      hasTransition = _e[0],
      setHasTransition = _e[1];

  useEffect(function () {
    if (selectedRangeDates.first && selectedRangeDates.last) setSelectedRangeDates(selectedRangeDates);
  }, [selectedRangeDates]);
  useEffect(function () {
    var timeoutIdOne = setTimeout(function () {
      setDisabled(false);
    }, 500);
    var timeoutIdTwo = setTimeout(function () {
      return setHasTransition(true);
    }, 100);
    return function () {
      clearTimeout(timeoutIdOne);
      clearTimeout(timeoutIdTwo);
    };
  }, [disabled, hasTransition]);
  var calendarWidth = 328;
  var padding = 12;
  var defaultWidths = [-calendarWidth - padding * 2, 0, calendarWidth + padding + 12, calendarWidth * 2 + padding * 2 // right hidden
  ];

  var toggleDisabled = function toggleDisabled() {
    setDisabled(true);
  };

  var handleYearClick = function handleYearClick(month, year) {
    var newDate = new Date(year, month);
    var copy = [];
    copy.push(new Date(newDate.getFullYear(), newDate.getMonth() - 1));
    copy.push(new Date(newDate.getFullYear(), newDate.getMonth()));
    copy.push(new Date(newDate.getFullYear(), newDate.getMonth() + 1));
    copy.push(new Date(newDate.getFullYear(), newDate.getMonth() + 2));
    setDateArray(copy);
    setModalType('month');
  };

  var handleMonthClick = function handleMonthClick(month, year) {
    var date = new Date(year, month);
    date.setHours(0, 0, 0, 0);
    setModalType('day');
    setDateArray(getInitialDates({
      selectedDateRange: {
        first: date,
        last: undefined
      }
    }));
    setHasTransition(false);
  };

  var onRight = function onRight() {
    // prevents spam clicking
    toggleDisabled();
    var copy = dateArray.slice();
    copy[0] = copy[1];
    copy[1] = copy[2];
    copy[2] = copy[3];
    var newDateCopy = new Date(copy[2]);
    newDateCopy.setMonth(newDateCopy.getMonth() + 1);
    copy[3] = new Date(newDateCopy);
    setDateArray(copy);
  };

  var onMonthRight = function onMonthRight(years) {
    // instead of updating the year chart based on clicked date, it will base it on
    // todays date + the yearDiff - that way the current date will always stay in the
    // same spot on the grid
    if (years === jumpYear) {
      setYearDiff(function (v) {
        return v + jumpYear;
      });
    }

    var copy = dateArray.slice();
    copy[0] = new Date(copy[0].getFullYear() + years, copy[0].getMonth());
    copy[1] = new Date(copy[1].getFullYear() + years, copy[1].getMonth());
    copy[2] = new Date(copy[2].getFullYear() + years, copy[2].getMonth());
    copy[3] = new Date(copy[3].getFullYear() + years, copy[3].getMonth());
    setDateArray(copy);
  };

  var onLeft = function onLeft() {
    // prevents spam clicking
    toggleDisabled();
    var copy = dateArray.slice();
    copy[3] = copy[2];
    copy[2] = copy[1];
    copy[1] = copy[0];
    var newDateCopy = new Date(copy[1]);
    newDateCopy.setMonth(newDateCopy.getMonth() - 1);
    copy[0] = new Date(newDateCopy);
    setDateArray(copy);
  };

  var onMonthLeft = function onMonthLeft(years) {
    // instead of updating the year chart based on clicked date, it will base it on
    // todays date + the yearDiff - that way the current date will always stay in the
    // same spot on the grid
    if (years === jumpYear) {
      setYearDiff(function (v) {
        return v - jumpYear;
      });
    }

    var copy = dateArray.slice();
    copy[0] = new Date(copy[0].getFullYear() - years, copy[0].getMonth());
    copy[1] = new Date(copy[1].getFullYear() - years, copy[1].getMonth());
    copy[2] = new Date(copy[2].getFullYear() - years, copy[2].getMonth());
    copy[3] = new Date(copy[3].getFullYear() - years, copy[3].getMonth());
    setDateArray(copy);
  };

  var handleDateRangeClick = function handleDateRangeClick(date, day) {
    var _a;

    setMouseToggle(new Date().toString());
    generateId();
    var clicked = new Date(date.getFullYear(), date.getMonth(), day);
    var clickedValue = clicked.valueOf();
    var dateToSet = {
      first: undefined,
      last: undefined
    };

    if (isStartFocused) {
      if (selectedRangeDates.last && clickedValue > selectedRangeDates.last.valueOf()) {
        dateToSet.first = clicked;
        dateToSet.last = undefined;
      } else {
        dateToSet.first = clicked;
        dateToSet.last = selectedRangeDates.last;
      }

      if (setIsStartFocused) setIsStartFocused(false);
    } else {
      if (selectedRangeDates.first && clickedValue < ((_a = selectedRangeDates.first) === null || _a === void 0 ? void 0 : _a.valueOf())) {
        dateToSet.first = clicked;
        dateToSet.last = undefined;
      } else {
        dateToSet.first = selectedRangeDates.first;
        clicked.setHours(23, 59, 59, 999);
        dateToSet.last = clicked;
      }
    }

    setSelectedRangeDates(dateToSet);
    if (onDateClick) onDateClick(dateToSet);
  };

  var populateArray = function populateArray(day, currTotal) {
    // how many numbers are displayed in the grid
    var length = 42;
    var originalDay = day;
    var date = 1;
    var arr = new Array(length);

    for (var i = day; i < arr.length; i++) {
      // populating up until the last day of the current month
      if (date <= currTotal) {
        arr[i] = date;
        date++;
      }
    } // adding in the prior days of the month


    for (var j = originalDay - 1; j >= 0; j--) {
      arr[j] = ' ';
    }

    return arr;
  };

  var dateOptions = {
    month: 'short',
    year: 'numeric'
  };
  var mappedCalendars = dateArray.map(function (date, i) {
    var monthAndYear = Intl.DateTimeFormat(locale, dateOptions).format(date);
    var day = new Date(date.getFullYear(), date.getMonth(), 1);
    var totalDaysCurr = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    var populatedArray = populateArray(day.getDay(), totalDaysCurr);
    var gridStyles = {
      left: defaultWidths[i],
      height: modalType === 'day' ? '100%' : '80%'
    };

    var handleHeadingButtonClick = function handleHeadingButtonClick() {
      setModalType(function (preValue) {
        switch (preValue) {
          case 'day':
            return 'month';

          case 'month':
            return 'year';

          default:
            return 'day';
        }
      });
      setHasTransition(false);
    };

    var display = jsxRuntime_1("div", {}, void 0);
    var title = '';

    switch (modalType) {
      case 'day':
        display = jsxRuntime_1(CalendarGrid, {
          contrast: contrast,
          minDate: minDate,
          maxDate: maxDate,
          locale: locale,
          dateRange: dateRange,
          setDateRange: setDateRange,
          mouseToggle: mouseToggle,
          selectedDates: selectedRangeDates,
          date: date,
          dates: populatedArray,
          handleDateClick: handleDateRangeClick
        }, void 0);
        title = monthAndYear.toUpperCase();
        break;

      case 'month':
      case 'year':
      default:
        display = jsxRuntime_1(CalendarModal, {
          contrast: contrast,
          minDate: minDate,
          maxDate: maxDate,
          locale: locale,
          date: new Date(date),
          isMonth: modalType === 'month',
          yearDiff: yearDiff,
          index: i,
          onDateClick: modalType === 'month' ? handleMonthClick : handleYearClick,
          selectedRangeDates: selectedRangeDates
        }, void 0);
        title = modalType === 'month' ? date.getFullYear().toString() : '';
    }

    return jsxRuntime_2("div", _assign2({
      className: "kxi-grids-wrapper " + (hasTransition ? 'kxi-calendar-transition' : ''),
      "aria-hidden": i === 1 ? false : true,
      "data-testid": i === 1 ? includeTestId('active-calendar') : undefined,
      style: gridStyles
    }, {
      children: [jsxRuntime_2("div", _assign2({
        className: "kxi-calendars-title",
        id: "kx-calendar-title"
      }, {
        children: [title ? null : jsxRuntime_1("div", {
          style: {
            height: 20
          }
        }, void 0), jsxRuntime_1(HeadingButton, {
          className: "kxi-stretch-width",
          dangerouslySetInnerHTML: {
            __html: DOMPurify.sanitize("<span class=\"kxi-calendar-html\">" + title.replace(' ', '<br/>') + "</span>")
          },
          color: contrast === 'normal' ? 'orca' : 'white',
          level: 1,
          weight: "normal",
          size: "body",
          style: {
            display: 'flex',
            justifyContent: 'center'
          },
          onClick: handleHeadingButtonClick
        }, i)]
      }), void 0), display]
    }), date.toString());
  });

  var leftArrowFn = function leftArrowFn() {
    return onLeft();
  };

  var rightArrowFn = function rightArrowFn() {
    return onRight();
  };

  if (modalType === 'month') {
    leftArrowFn = function leftArrowFn() {
      return onMonthLeft(1);
    };

    rightArrowFn = function rightArrowFn() {
      return onMonthRight(1);
    };
  } else if (modalType === 'year') {
    rightArrowFn = function rightArrowFn() {
      return onMonthRight(jumpYear);
    };

    leftArrowFn = function leftArrowFn() {
      return onMonthLeft(jumpYear);
    };
  }

  var isLeftArrowDisabled = false;
  var isRightArrowDisabled = false; // disabled arrows based on min and max dates

  if (modalType === 'day') {
    var currDate = dateArray[1];
    var minLimit = new Date(currDate.getFullYear(), currDate.getMonth(), 0);
    var maxLimit = new Date(currDate.getFullYear(), currDate.getMonth() + 1, 0);
    minLimit.setHours(23, 59, 59, 59);
    maxLimit.setHours(23, 59, 59, 59);

    if (minLimit.valueOf() < minDate.valueOf()) {
      isLeftArrowDisabled = true;
    }

    if (maxLimit.valueOf() > maxDate.valueOf()) {
      isRightArrowDisabled = true;
    }
  } else if (modalType === 'month') {
    var currDate = dateArray[1];
    var endOfLastYear = new Date(currDate.getFullYear() - 1, 11, 31);
    var startOfNextYear = new Date(currDate.getFullYear() + 1, 0, 1);
    endOfLastYear.setHours(23, 59, 59, 59);

    if (endOfLastYear.valueOf() < minDate.valueOf()) {
      isLeftArrowDisabled = true;
    }

    if (startOfNextYear.valueOf() > maxDate.valueOf()) {
      isRightArrowDisabled = true;
    }
  } else if (modalType === 'year') {
    var beginningOfTimeFrame = new Date(new Date().getFullYear(), 0, 1);
    var endOfTimeFrame = new Date(new Date().getFullYear(), 11, 31);
    beginningOfTimeFrame.setFullYear(beginningOfTimeFrame.getFullYear() + yearDiff - 11);
    endOfTimeFrame.setFullYear(endOfTimeFrame.getFullYear() + yearDiff);

    if (beginningOfTimeFrame.valueOf() < minDate.valueOf()) {
      isLeftArrowDisabled = true;
    }

    if (endOfTimeFrame.valueOf() > maxDate.valueOf()) {
      isRightArrowDisabled = true;
    }
  }

  var arrowDisabledClass = "kxi-arrow-disabled";
  var contrastClass = "" + (contrast === 'high' ? 'kxi-high-contrast' : '');
  return jsxRuntime_2("div", _assign2({
    className: "kxi-calendars-wrapper",
    "data-testid": includeTestId('calendars-wrapper'),
    onMouseLeave: function onMouseLeave() {
      return setMouseToggle(new Date().toString());
    }
  }, {
    children: [mappedCalendars, jsxRuntime_1("div", _assign2({
      className: "kxi-calendar-arrow-wrapper kxi-calendar-arrow-left " + contrastClass
    }, {
      children: jsxRuntime_1(IconButton, {
        className: "kxi-calendar-arrow " + (isLeftArrowDisabled || disabled ? arrowDisabledClass : ''),
        disabled: isLeftArrowDisabled || disabled,
        contrast: contrast,
        hasState: false,
        icon: "single_arrow_left",
        size: 30,
        onClick: leftArrowFn
      }, void 0)
    }), void 0), jsxRuntime_1("div", _assign2({
      className: "kxi-calendar-arrow-wrapper kxi-calendar-arrow-right " + contrastClass
    }, {
      children: jsxRuntime_1(IconButton, {
        className: "kxi-calendar-arrow " + (isRightArrowDisabled || disabled ? arrowDisabledClass : ''),
        disabled: isRightArrowDisabled || disabled,
        hasState: false,
        contrast: contrast,
        icon: "single_arrow_right",
        size: 30,
        onClick: rightArrowFn
      }, void 0)
    }), void 0)]
  }), void 0);
}; // past date functions


var getPastWeeks = function getPastWeeks(week) {
  var day = lastWeek.getDay();
  var weekStart = new Date(week.getFullYear(), week.getMonth(), week.getDate() - day);
  var weekEnd = new Date(week.getFullYear(), week.getMonth(), week.getDate() + (6 - day));
  weekEnd.setHours(23, 59, 59, 999);
  return {
    weekStart: weekStart,
    weekEnd: weekEnd
  };
};

var getPastMonths = function getPastMonths(month) {
  var monthStart = new Date(month.getFullYear(), month.getMonth(), 1);
  var monthEnd = new Date(month.getFullYear(), month.getMonth() + 1, 0);
  monthEnd.setHours(23, 59, 59, 999);
  return {
    monthStart: monthStart,
    monthEnd: monthEnd
  };
}; // the end month gets set one extra, because 0 in the date constructor goes back to the last day of the previous month
// going back three months to ensure last quarter.


var getPastQuarters = function getPastQuarters(quarter) {
  var quarterStart, quarterEnd;

  switch (quarter.getMonth()) {
    case 0:
    case 1:
    case 2:
      quarterStartMonth = 0;
      quarterEndMonth = 3;
      break;

    case 3:
    case 4:
    case 5:
      quarterStartMonth = 3;
      quarterEndMonth = 6;
      break;

    case 6:
    case 7:
    case 8:
      quarterStartMonth = 6;
      quarterEndMonth = 9;
      break;

    default:
      quarterStartMonth = 9;
      quarterEndMonth = 11;
  }

  if (quarterEndMonth === 11) {
    quarterStart = new Date(lastMonth.getFullYear(), quarterStartMonth, 1);
    quarterEnd = new Date(lastMonth.getFullYear() + 1, 0, 0);
    quarterEnd.setHours(23, 59, 59, 999);
  } else {
    quarterStart = new Date(lastMonth.getFullYear(), quarterStartMonth, 1);
    quarterEnd = new Date(lastMonth.getFullYear(), quarterEndMonth, 0);
    quarterEnd.setHours(23, 59, 59, 999);
  }

  return {
    quarterStart: quarterStart,
    quarterEnd: quarterEnd
  };
}; // date initializers


var currDate = new Date();
currDate.setHours(0, 0, 0, 0);
var currYear = currDate.getFullYear();
var yesterday = new Date();
yesterday.setHours(0, 0, 0, 0);
var lastWeek = new Date();
var lastFourWeeks = new Date();
var thisWeek = new Date();
var lastQuarter = new Date();
var thisQuarter = new Date(); //day

yesterday.setDate(yesterday.getDate() - 1);
var lastYear = new Date(currDate.getFullYear() - 1, currDate.getMonth());
var lastSeven = new Date(currDate.getFullYear(), currDate.getMonth(), currDate.getDate() - 6);
var last30 = new Date(currDate.getFullYear(), currDate.getMonth(), currDate.getDate() - 29); // week

lastWeek.setDate(currDate.getDate() - 7 * 1);
lastFourWeeks.setDate(currDate.getDate() - 7 * 4);

var _a = getPastWeeks(thisWeek),
    thisWeekStart = _a.weekStart,
    thisWeekEnd = _a.weekEnd;

var _b = getPastWeeks(lastWeek),
    lastWeekStart = _b.weekStart,
    lastWeekEnd = _b.weekEnd;

var fourWeeksStart = getPastWeeks(lastFourWeeks).weekStart; // month

var currMonth = currDate.getMonth();
var threeMonths = currDate.getMonth() - 2;
var lastMonth = new Date(currYear, currMonth, 0);
var lastThreeMonths = new Date(currYear, threeMonths, 0);

var _c = getPastMonths(currDate),
    thisMonthStart = _c.monthStart,
    thisMonthEnd = _c.monthEnd;

var _d = getPastMonths(lastMonth),
    lastMonthStart = _d.monthStart,
    lastMonthEnd = _d.monthEnd;

var threeMonthStart = getPastMonths(lastThreeMonths).monthStart; // quarter

var quarterStartMonth = 0;
var quarterEndMonth = 0;
lastQuarter.setMonth(lastQuarter.getMonth() - 3);

var _e = getPastQuarters(lastQuarter),
    lastQuarterStart = _e.quarterStart,
    lastQuarterEnd = _e.quarterEnd;

var _f = getPastQuarters(thisQuarter),
    thisQuarterStart = _f.quarterStart,
    thisQuarterEnd = _f.quarterEnd;

var defaultCalendarPreselectedOptions = [{
  title: 'Today',
  first: new Date(currDate),
  last: new Date(currDate),
  id: '_today',
  isSelected: false
}, {
  title: 'Yesterday',
  first: new Date(yesterday),
  last: new Date(yesterday),
  id: '_yesterday',
  isSelected: false
}, {
  title: 'Last 7 Days',
  first: new Date(lastSeven),
  last: new Date(currDate),
  id: '_last7Days',
  isSelected: false
}, {
  title: 'Last 30 Days',
  first: new Date(last30),
  last: new Date(currDate),
  id: '_last30Days',
  isSelected: false
}, {
  title: 'This Week',
  first: new Date(thisWeekStart),
  last: new Date(thisWeekEnd),
  id: '_thisWeek',
  isSelected: false
}, {
  title: 'Last Week',
  first: new Date(lastWeekStart),
  last: new Date(lastWeekEnd),
  id: '_lastWeek',
  isSelected: false
}, {
  title: 'Last 4 Weeks',
  first: new Date(fourWeeksStart),
  last: new Date(lastWeekEnd),
  id: '_last4Weeks',
  isSelected: false
}, {
  title: 'This Month',
  first: new Date(thisMonthStart),
  last: new Date(thisMonthEnd),
  id: '_thisMonth',
  isSelected: false
}, {
  title: 'Last Month',
  first: new Date(lastMonthStart),
  last: new Date(lastMonthEnd),
  id: '_lastMonth',
  isSelected: false
}, {
  title: 'Last 3 Months',
  first: new Date(threeMonthStart),
  last: new Date(lastMonthEnd),
  id: '_last3Months',
  isSelected: false
}, {
  title: 'This Quarter',
  first: new Date(thisQuarterStart),
  last: new Date(thisQuarterEnd),
  id: '_thisQuarter',
  isSelected: false
}, {
  title: 'Last Quarter',
  first: new Date(lastQuarterStart),
  last: new Date(lastQuarterEnd),
  id: '_lastQuarter',
  isSelected: false
}, {
  title: 'This Year',
  first: new Date(currDate.getFullYear(), 0, 1),
  last: new Date(currDate.getFullYear(), 11, 31),
  id: '_thisYear',
  isSelected: false
}, {
  title: 'Last Year',
  first: new Date(lastYear.getFullYear(), 0, 1),
  last: new Date(lastYear.getFullYear(), 11, 31),
  id: '_lastYear',
  isSelected: false
}];
var DefaultPreselectedCalendarListIds;

(function (DefaultPreselectedCalendarListIds) {
  DefaultPreselectedCalendarListIds["TODAY"] = "_today";
  DefaultPreselectedCalendarListIds["YESTERDAY"] = "_yesterday";
  DefaultPreselectedCalendarListIds["LAST_7_DAYS"] = "_last7Days";
  DefaultPreselectedCalendarListIds["LAST_30_DAYS"] = "_last30Days";
  DefaultPreselectedCalendarListIds["THIS_WEEK"] = "_thisWeek";
  DefaultPreselectedCalendarListIds["LAST_WEEK"] = "_lastWeek";
  DefaultPreselectedCalendarListIds["LAST_4_WEEKS"] = "_last4Weeks";
  DefaultPreselectedCalendarListIds["THIS_MONTH"] = "_thisMonth";
  DefaultPreselectedCalendarListIds["LAST_MONTH"] = "_lastMonth";
  DefaultPreselectedCalendarListIds["LAST_3_MONTHS"] = "_last3Months";
  DefaultPreselectedCalendarListIds["THIS_QUARTER"] = "_thisQuarter";
  DefaultPreselectedCalendarListIds["LAST_QUARTER"] = "_lastQuarter";
  DefaultPreselectedCalendarListIds["THIS_YEAR"] = "_thisYear";
  DefaultPreselectedCalendarListIds["LAST_YEAR"] = "_lastYear";
})(DefaultPreselectedCalendarListIds || (DefaultPreselectedCalendarListIds = {}));

var defaultPreselectedCalendarListOptions = [{
  title: 'Today',
  first: new Date(currDate),
  last: new Date(currDate),
  id: DefaultPreselectedCalendarListIds.TODAY
}, {
  title: 'Yesterday',
  first: new Date(yesterday),
  last: new Date(yesterday),
  id: DefaultPreselectedCalendarListIds.YESTERDAY
}, {
  title: 'Last 7 Days',
  first: new Date(lastSeven),
  last: new Date(currDate),
  id: DefaultPreselectedCalendarListIds.LAST_7_DAYS
}, {
  title: 'Last 30 Days',
  first: new Date(last30),
  last: new Date(currDate),
  id: DefaultPreselectedCalendarListIds.LAST_30_DAYS
}, {
  title: 'This Week',
  first: new Date(thisWeekStart),
  last: new Date(thisWeekEnd),
  id: DefaultPreselectedCalendarListIds.THIS_WEEK
}, {
  title: 'Last Week',
  first: new Date(lastWeekStart),
  last: new Date(lastWeekEnd),
  id: DefaultPreselectedCalendarListIds.LAST_WEEK
}, {
  title: 'Last 4 Weeks',
  first: new Date(fourWeeksStart),
  last: new Date(lastWeekEnd),
  id: DefaultPreselectedCalendarListIds.LAST_4_WEEKS
}, {
  title: 'This Month',
  first: new Date(thisMonthStart),
  last: new Date(thisMonthEnd),
  id: DefaultPreselectedCalendarListIds.THIS_MONTH
}, {
  title: 'Last Month',
  first: new Date(lastMonthStart),
  last: new Date(lastMonthEnd),
  id: DefaultPreselectedCalendarListIds.LAST_MONTH
}, {
  title: 'Last 3 Months',
  first: new Date(threeMonthStart),
  last: new Date(lastMonthEnd),
  id: DefaultPreselectedCalendarListIds.LAST_3_MONTHS
}, {
  title: 'This Quarter',
  first: new Date(thisQuarterStart),
  last: new Date(thisQuarterEnd),
  id: DefaultPreselectedCalendarListIds.THIS_QUARTER
}, {
  title: 'Last Quarter',
  first: new Date(lastQuarterStart),
  last: new Date(lastQuarterEnd),
  id: DefaultPreselectedCalendarListIds.LAST_QUARTER
}, {
  title: 'This Year',
  first: new Date(currDate.getFullYear(), 0, 1),
  last: new Date(currDate.getFullYear(), 11, 31),
  id: DefaultPreselectedCalendarListIds.THIS_YEAR
}, {
  title: 'Last Year',
  first: new Date(lastYear.getFullYear(), 0, 1),
  last: new Date(lastYear.getFullYear(), 11, 31),
  id: DefaultPreselectedCalendarListIds.LAST_YEAR
}];
var nullDates = {
  first: undefined,
  last: undefined
};
var colorDisabled$2 = XIColorUsage.colorDisabled;
var white$5 = XIColors.white;

var ToggleTextProps = function (_super) {
  __extends(ToggleTextProps, _super);

  function ToggleTextProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Boolean)], ToggleTextProps.prototype, "stretch");

  __decorate([Bound(), __metadata("design:type", String)], ToggleTextProps.prototype, "leftText");

  __decorate([Bound(), __metadata("design:type", String)], ToggleTextProps.prototype, "rightText");

  __decorate([Bound(), __metadata("design:type", Object)], ToggleTextProps.prototype, "status");

  __decorate([Bound(), __metadata("design:type", String)], ToggleTextProps.prototype, "color");

  __decorate([Bound(), __metadata("design:type", String)], ToggleTextProps.prototype, "label");

  __decorate([Bound(), __metadata("design:type", String)], ToggleTextProps.prototype, "contrast");

  __decorate([Bound(), __metadata("design:type", String)], ToggleTextProps.prototype, "side");

  return ToggleTextProps;
}(ObservablePropsMixin(ButtonHTMLAttributes));

var ToggleTextEvents = function (_super) {
  __extends(ToggleTextEvents, _super);

  function ToggleTextEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], ToggleTextEvents.prototype, "onToggle");

  return ToggleTextEvents;
}(ButtonHTMLEvents);
/**
 * Description: Works like ToggleSwitch, but with customizable text.
 */


var ToggleText = /*#__PURE__*/forwardRef(function (props, ref) {
  var leftText = props.leftText,
      rightText = props.rightText,
      _a = props.disabled,
      disabled = _a === void 0 ? false : _a,
      _b = props.color,
      color = _b === void 0 ? 'orca' : _b,
      _c = props.contrast,
      contrast = _c === void 0 ? 'normal' : _c,
      onToggle = props.onToggle,
      onMouseDown = props.onMouseDown,
      onMouseUp = props.onMouseUp,
      onMouseOut = props.onMouseOut,
      onClick = props.onClick,
      status = props.status,
      className = props.className,
      _d = props.side,
      side = _d === void 0 ? 'left' : _d,
      stretch = props.stretch,
      label = props.label,
      observer = props.observer,
      ingredients = __rest(props, ["leftText", "rightText", "disabled", "color", "contrast", "onToggle", "onMouseDown", "onMouseUp", "onMouseOut", "onClick", "status", "className", "side", "stretch", "label", "observer"]);

  var isLeftOn = side === 'left';

  var _e = __read(useState(isLeftOn), 2),
      on = _e[0],
      setOn = _e[1];

  var _f = __read(useState(0), 2),
      primaryWidth = _f[0],
      setPrimaryWidth = _f[1];

  var _g = __read(useState(0), 2),
      secondaryWidth = _g[0],
      setSecondaryWidth = _g[1];

  var primaryTextWrapper = useRef(null);
  var secondaryTextWrapper = useRef(null);
  var wrapper = useRef(null);
  useEffect(function () {
    if (primaryTextWrapper.current && secondaryTextWrapper.current) {
      setPrimaryWidth(primaryTextWrapper.current.offsetWidth);
      setSecondaryWidth(secondaryTextWrapper.current.offsetWidth);
    }
  }, [stretch, leftText, rightText, label]);
  useEffect(function () {
    if (isLeftOn !== on) {
      setOn(isLeftOn);
    }
  }, [side]);

  var handleClick = function handleClick(e) {
    if (!disabled) {
      setOn(function (v) {
        return !v;
      });

      if (observer) {
        observer.side = on ? 'right' : 'left';
      }

      if (onToggle) onToggle(!on ? leftText : rightText);
    }

    if (onClick) onClick(e);
  };

  var handleMouseDown = function handleMouseDown(e) {
    if (!disabled) {
      on ? setPrimaryWidth(primaryWidth + 12) : setSecondaryWidth(secondaryWidth + 12);
    }

    if (onMouseDown) onMouseDown(e);
  };

  var handleMouseUp = function handleMouseUp(e) {
    if (primaryTextWrapper.current && secondaryTextWrapper.current && !disabled) {
      on ? setPrimaryWidth(primaryTextWrapper.current.offsetWidth) : setSecondaryWidth(secondaryTextWrapper.current.offsetWidth);
    }

    if (onMouseUp) onMouseUp(e);
  };

  var handleMouseOut = function handleMouseOut(e) {
    if (e.target === wrapper.current && !disabled) {
      if (primaryTextWrapper.current && secondaryTextWrapper.current) {
        setPrimaryWidth(primaryTextWrapper.current.offsetWidth);
        setSecondaryWidth(secondaryTextWrapper.current.offsetWidth);
      }
    }

    if (onMouseOut) onMouseOut(e);
  };

  var backgroundColor = contrast === 'normal' ? getColor(color) : white$5.primary;
  var disabledClass = disabled ? ' kxi-disabled' : '';
  var stretchClass = stretch ? ' kxi-stretch' : '';
  var contrastClass = contrast === 'high' ? ' kxi-high-contrast' : '';
  return jsxRuntime_2("div", _assign2({
    "aria-label": "toggle text",
    "aria-describedby": label || leftText + " " + rightText + " toggle",
    className: "kxi-switch" + disabledClass + stretchClass + " orca"
  }, {
    children: [label ? jsxRuntime_1("label", _assign2({
      className: "kxi-label" + contrastClass
    }, {
      children: label
    }), void 0) : null, jsxRuntime_2("button", _assign2({
      className: "kxi-toggle-switch-button kxi-border" + (status ? " kxi-" + status : '') + contrastClass + stretchClass + disabledClass + " " + (className || ''),
      "aria-disabled": disabled,
      ref: mergeRefs([wrapper, ref]),
      disabled: disabled,
      onClick: handleClick,
      onMouseDown: handleMouseDown,
      onMouseUp: handleMouseUp,
      onMouseOut: handleMouseOut
    }, ingredients, {
      children: [jsxRuntime_1(motion.div, {
        transition: {
          duration: 0.1,
          ease: 'easeOut'
        },
        initial: {
          opacity: 1
        },
        className: "kxi-toggle",
        style: {
          backgroundColor: disabled ? colorDisabled$2 : backgroundColor,
          minWidth: on ? primaryWidth : secondaryWidth,
          left: on ? '0.1875rem' : 'unset',
          right: on ? 'unset' : '0.1875rem',
          originX: 0.5,
          originY: !on ? 0 : 1
        },
        animate: true
      }, void 0), jsxRuntime_1("div", _assign2({
        role: "switch",
        "aria-checked": on,
        className: "orca kxi-toggle-text" + (on ? '-black' : '-white') + stretchClass,
        ref: primaryTextWrapper
      }, {
        children: leftText
      }), void 0), jsxRuntime_1("div", _assign2({
        role: "switch",
        "aria-checked": on,
        className: "orca kxi-toggle-text" + (on ? '-white' : '-black') + stretchClass,
        ref: secondaryTextWrapper
      }, {
        children: rightText
      }), void 0)]
    }), void 0)]
  }), void 0);
});
var Popout = /*#__PURE__*/forwardRef(function (props, ref) {
  var _a = props.direction,
      direction = _a === void 0 ? 6 : _a,
      _b = props.margin,
      margin = _b === void 0 ? 6 : _b,
      _c = props.isVisible,
      isVisible = _c === void 0 ? false : _c,
      children = props.children,
      _d = props.hasPortal,
      hasPortal = _d === void 0 ? true : _d,
      className = props.className,
      parentRef = props.parentRef,
      _e = props.isMobile,
      isMobile = _e === void 0 ? false : _e,
      onExternalClick = props.onExternalClick,
      ingredients = __rest(props, ["direction", "margin", "isVisible", "children", "hasPortal", "className", "parentRef", "isMobile", "onExternalClick"]);

  var popoutRef = useRef(null);
  useEffect(function () {
    var onExternalClickListener = function onExternalClickListener(e) {
      var _a;

      if (!onExternalClick || !isVisible) {
        return;
      }

      if (popoutRef.current && !((_a = e.composedPath()) === null || _a === void 0 ? void 0 : _a.includes(popoutRef.current))) {
        onExternalClick(e);
      }
    };

    document.addEventListener('mousedown', onExternalClickListener, true);
    return function () {
      return document.removeEventListener('mousedown', onExternalClickListener, true);
    };
  }, [onExternalClick, isVisible]);

  var getMobileMenuPosition = function getMobileMenuPosition(direction) {
    if (!(parentRef === null || parentRef === void 0 ? void 0 : parentRef.current) || !popoutRef.current) {
      return {
        top: 0,
        left: 0
      };
    }

    var upDirs = [1, 3, 4, 8, 11, 12];
    var parentElement = parentRef.current.getBoundingClientRect();
    var menuStartTop = ((parentElement === null || parentElement === void 0 ? void 0 : parentElement.top) || 0) + document.documentElement.scrollTop;
    var dropdownHeight = (parentElement === null || parentElement === void 0 ? void 0 : parentElement.height) || 0;
    var menuHeight = popoutRef.current.clientHeight;

    if (upDirs.includes(direction)) {
      return {
        top: menuStartTop - menuHeight - margin * 2,
        left: 0
      };
    } else {
      return {
        top: menuStartTop + dropdownHeight,
        left: 0
      };
    }
  };

  var getMenuPosition = function getMenuPosition(direction) {
    if (!(parentRef === null || parentRef === void 0 ? void 0 : parentRef.current) || !popoutRef.current) {
      return {
        top: 0,
        left: 0
      };
    }

    if (isMobile) {
      return getMobileMenuPosition(direction);
    }

    var parentElement = parentRef === null || parentRef === void 0 ? void 0 : parentRef.current;
    var menuStartTop = 0;
    var menuStartLeft = 0;

    if (hasPortal) {
      menuStartTop = ((parentElement === null || parentElement === void 0 ? void 0 : parentElement.getBoundingClientRect().top) || 0) + document.documentElement.scrollTop;
      menuStartLeft = ((parentElement === null || parentElement === void 0 ? void 0 : parentElement.getBoundingClientRect().left) || 0) + document.documentElement.scrollLeft;
    }

    var dropdownWidth = (parentElement === null || parentElement === void 0 ? void 0 : parentElement.getBoundingClientRect().width) || 0;
    var dropdownHeight = (parentElement === null || parentElement === void 0 ? void 0 : parentElement.getBoundingClientRect().height) || 0;

    var _a = popoutRef.current.getBoundingClientRect(),
        menuWidth = _a.width,
        menuHeight = _a.height; //vertical alignments


    var bottomAbove = menuHeight * -1 + menuStartTop - margin * 2;
    var topLevel = menuStartTop - margin;
    var middle = menuStartTop + dropdownHeight / 2 - menuHeight / 2 - margin;
    var bottomLevel = bottomAbove + dropdownHeight + margin;
    var topBelow = menuStartTop + dropdownHeight + margin; //horizontal alignments

    var rightAligned = menuStartLeft - menuWidth + dropdownWidth - margin;
    var rightEdge = menuStartLeft + dropdownWidth + margin;
    var centered = menuStartLeft + dropdownWidth / 2 - menuWidth / 2 - margin;
    var leftAligned = menuStartLeft - margin;
    var leftEdge = menuStartLeft - menuWidth - margin * 2;

    switch (direction) {
      case 1:
        return {
          top: bottomAbove,
          left: rightAligned
        };

      case 2:
        return {
          top: topLevel,
          left: rightEdge
        };

      case 3:
        return {
          top: middle,
          left: rightEdge
        };

      case 4:
        return {
          top: bottomLevel,
          left: rightEdge
        };

      case 5:
        return {
          top: topBelow,
          left: rightAligned
        };

      case 6:
        return {
          top: topBelow,
          left: centered
        };

      case 7:
        return {
          top: topBelow,
          left: leftAligned
        };

      case 8:
        return {
          top: bottomLevel,
          left: leftEdge
        };

      case 9:
        return {
          top: middle,
          left: leftEdge
        };

      case 10:
        return {
          top: topLevel,
          left: leftEdge
        };

      case 11:
        return {
          top: bottomAbove,
          left: leftAligned
        };

      case 12:
        return {
          top: bottomAbove,
          left: centered
        };

      default:
        return {
          top: topBelow,
          left: leftAligned
        };
    }
  };

  var willOverlap = function willOverlap(direction) {
    var _a, _b;

    if (!(parentRef === null || parentRef === void 0 ? void 0 : parentRef.current) || !popoutRef.current) {
      return false;
    }

    var scrollBarWidth = document.documentElement.offsetWidth - document.documentElement.clientWidth || margin; //note: calc does not work on macs because scroll bar is an overlay

    var parentElement = (_a = parentRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    var pos = getMenuPosition(direction);
    var menuHeight = popoutRef.current.clientHeight;
    var menuWidth = (_b = popoutRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth;
    var isTooFarAbove, isTooFarBelow, isTooFarLeft, isTooFarRight;

    if (hasPortal) {
      isTooFarAbove = pos.top - document.documentElement.scrollTop < 0;
      isTooFarBelow = pos.top + menuHeight + scrollBarWidth > document.documentElement.clientHeight + document.documentElement.scrollTop;
      isTooFarRight = pos.left + menuWidth + scrollBarWidth > document.documentElement.clientWidth + document.documentElement.scrollLeft;
      isTooFarLeft = pos.left < document.documentElement.scrollLeft;
    } else {
      isTooFarAbove = pos.top + parentElement.top < 0;
      isTooFarBelow = parentElement.top + pos.top + menuHeight + scrollBarWidth > document.documentElement.clientHeight;
      isTooFarRight = parentElement.left + pos.left + menuWidth + scrollBarWidth > document.documentElement.clientWidth;
      isTooFarLeft = pos.left + parentElement.left < 0;
    }

    return isTooFarAbove || isTooFarBelow || isTooFarRight || isTooFarLeft;
  };

  var testDirGroup = function testDirGroup(dirGroup) {
    var newDirection = undefined;
    dirGroup.every(function (dir) {
      if (!willOverlap(dir)) {
        newDirection = dir;
        return false;
      }

      return true;
    });
    return newDirection;
  };

  var findBestDirection = function findBestDirection() {
    var newDirection = undefined;
    var directionGroups = [[11, 12, 1], [2, 3, 4], [5, 6, 7], [8, 9, 10]];

    if (willOverlap(direction)) {
      var groupIndex = directionGroups.findIndex(function (dir) {
        return dir.includes(direction);
      });
      newDirection = testDirGroup(directionGroups[groupIndex]);

      if (!newDirection) {
        switch (groupIndex) {
          case 0:
            //up dirs, test down first then right then left
            return testDirGroup(directionGroups[2]) || testDirGroup(directionGroups[1]) || testDirGroup(directionGroups[3]) || direction;

          case 1:
            //right dirs, test left then down then up
            return testDirGroup(directionGroups[3]) || testDirGroup(directionGroups[2]) || testDirGroup(directionGroups[0]) || direction;

          case 2:
            //down dirs, test up then right then left
            return testDirGroup(directionGroups[0]) || testDirGroup(directionGroups[1]) || testDirGroup(directionGroups[3]) || direction;

          case 3:
            //left dirs, test right then down then up
            return testDirGroup(directionGroups[1]) || testDirGroup(directionGroups[2]) || testDirGroup(directionGroups[0]) || direction;

          default:
            return direction;
        }
      } else {
        return newDirection;
      }
    } else {
      return direction;
    }
  };

  var generateStructure = function generateStructure(direction) {
    var position = getMenuPosition(direction);
    return jsxRuntime_1(AnimatePresence, {
      children: jsxRuntime_1("div", _assign2({}, ingredients, {
        className: className,
        style: {
          position: 'absolute',
          top: position.top,
          left: position.left,
          zIndex: 100
        },
        ref: mergeRefs([popoutRef, ref])
      }, {
        children: children
      }), void 0)
    }, void 0);
  };

  var menuComponent = generateStructure(findBestDirection());
  return isVisible ? hasPortal || isMobile ? /*#__PURE__*/createPortal(menuComponent, document.getElementsByTagName('body')[0]) : menuComponent : jsxRuntime_1("div", _assign2({
    className: "kxi-popout-menu-hidden-wrapper"
  }, {
    children: jsxRuntime_1("div", _assign2({
      className: "kxi-popout-menu-hidden"
    }, {
      children: menuComponent
    }), void 0)
  }), void 0);
});

var CalendarProps = function (_super) {
  __extends(CalendarProps, _super);

  function CalendarProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Object)], CalendarProps.prototype, "data");

  __decorate([Bound(), __metadata("design:type", Array)], CalendarProps.prototype, "groups");

  __decorate([Bound(), __metadata("design:type", String)], CalendarProps.prototype, "mode");

  __decorate([Bound(), __metadata("design:type", String)], CalendarProps.prototype, "outline");

  __decorate([Bound(), __metadata("design:type", Date)], CalendarProps.prototype, "maxDate");

  __decorate([Bound(), __metadata("design:type", Date)], CalendarProps.prototype, "minDate");

  __decorate([Bound(), __metadata("design:type", String)], CalendarProps.prototype, "locale");

  __decorate([Bound(), __metadata("design:type", String)], CalendarProps.prototype, "contrast");

  __decorate([Bound(), __metadata("design:type", Object)], CalendarProps.prototype, "checkedListId");

  __decorate([Bound(), __metadata("design:type", String)], CalendarProps.prototype, "listColor");

  __decorate([Bound(), __metadata("design:type", Boolean)], CalendarProps.prototype, "hasInternalPadding");

  __decorate([Bound(), __metadata("design:type", Boolean)], CalendarProps.prototype, "popoutView");

  __decorate([Bound(), __metadata("design:type", Number)], CalendarProps.prototype, "direction");

  __decorate([Bound(), __metadata("design:type", Boolean)], CalendarProps.prototype, "condensedPopoutDropper");

  __decorate([Bound(), __metadata("design:type", Object)], CalendarProps.prototype, "localization");

  return CalendarProps;
}(ObservablePropsMixin(DivHTMLAttributes));

var CalendarEvents = function (_super) {
  __extends(CalendarEvents, _super);

  function CalendarEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], CalendarEvents.prototype, "onDateClick");

  __decorate([Bound(), __metadata("design:type", Function)], CalendarEvents.prototype, "onValueChange");

  __decorate([Bound(), __metadata("design:type", Function)], CalendarEvents.prototype, "onDateError");

  __decorate([Bound(), __metadata("design:type", Function)], CalendarEvents.prototype, "onToggle");

  return CalendarEvents;
}(DOMEvents);

function isCheckedListIdValid(id) {
  return typeof id === 'string' ? id !== '' : id === null;
}
/**
 * Description: Standard XI themed Custom Date Range selector.
 */


var Calendar = /*#__PURE__*/forwardRef(function (props, ref) {
  var today = new Date();
  var defaultMaxDate = new Date(today.getFullYear(), today.getMonth() + 2);

  var _a = props.data,
      data = _a === void 0 ? {} : _a,
      groups = props.groups,
      _b = props.outline,
      outline = _b === void 0 ? 'none' : _b,
      _c = props.mode,
      mode = _c === void 0 ? 'fixed' : _c,
      observer = props.observer,
      _d = props.localization,
      localization = _d === void 0 ? {} : _d,
      _e = props.minDate,
      minDate = _e === void 0 ? new Date('01/01/1970') : _e,
      _f = props.maxDate,
      maxDate = _f === void 0 ? defaultMaxDate : _f,
      className = props.className,
      checkedListId = props.checkedListId,
      _g = props.popoutView,
      popoutView = _g === void 0 ? false : _g,
      _h = props.direction,
      direction = _h === void 0 ? 6 : _h,
      _j = props.condensedPopoutDropper,
      condensedPopoutDropper = _j === void 0 ? false : _j,
      _k = props.hasInternalPadding,
      hasInternalPadding = _k === void 0 ? true : _k,
      _l = props.contrast,
      contrast = _l === void 0 ? 'normal' : _l,
      _m = props.locale,
      locale = _m === void 0 ? 'en-US' : _m,
      onDateClick = props.onDateClick,
      onValueChange = props.onValueChange,
      onDateError = props.onDateError,
      onToggle = props.onToggle,
      ingredients = __rest(props, ["data", "groups", "outline", "mode", "observer", "localization", "minDate", "maxDate", "className", "checkedListId", "popoutView", "direction", "condensedPopoutDropper", "hasInternalPadding", "contrast", "locale", "onDateClick", "onValueChange", "onDateError", "onToggle"]);

  var newMinDate = new Date(minDate);
  var newMaxDate = new Date(maxDate);
  var dateRange = data.dateRange,
      initialDateRange = data.initialDateRange,
      preselectedOptions = data.preselectedOptions,
      preselectedCalendarListOptionsInput = data.preselectedCalendarListOptions;

  var _o = __read(useState(defaultPreselectedCalendarListOptions), 2),
      preselectedCalendarListOptions = _o[0],
      setPreselectedCalendarListOptions = _o[1];

  var defaultCheckedListId = useMemo(function () {
    var _a;

    return isCheckedListIdValid(checkedListId) ? checkedListId : ((_a = preselectedCalendarListOptions[0]) === null || _a === void 0 ? void 0 : _a.id) || DefaultPreselectedCalendarListIds.TODAY;
  }, [checkedListId, preselectedCalendarListOptions]);
  var custom = localization.custom,
      _p = localization.separator,
      separator = _p === void 0 ? '/' : _p,
      _q = localization.firstInputPlaceholder,
      firstInputPlaceholder = _q === void 0 ? extractDateFormatPlaceholder(locale, separator) : _q,
      _r = localization.secondInputPlaceholder,
      secondInputPlaceholder = _r === void 0 ? extractDateFormatPlaceholder(locale, separator) : _r,
      _s = localization.startDate,
      startDate = _s === void 0 ? 'Start Date' : _s,
      _t = localization.endDate,
      endDate = _t === void 0 ? 'End Date' : _t,
      _u = localization.errorString,
      errorString = _u === void 0 ? 'Invalid Date' : _u,
      _v = localization.leftText,
      leftText = _v === void 0 ? 'Relative' : _v,
      _w = localization.rightText,
      rightText = _w === void 0 ? 'Fixed' : _w,
      _x = localization.to,
      to = _x === void 0 ? 'to' : _x,
      _y = localization.applyBtn,
      applyBtn = _y === void 0 ? 'Apply' : _y,
      _z = localization.cancelBtn,
      cancelBtn = _z === void 0 ? 'Cancel' : _z,
      _0 = localization.noSelection,
      noSelection = _0 === void 0 ? 'No selection' : _0; // warnings

  useEffect(function () {
    warnIsDeprecated('Calendar', {
      'data.preselectedOptions': {
        message: 'Use data.preselectedCalendarListOptions instead.',
        value: preselectedOptions
      }
    }, 'prop');
    warnIsDeprecated('Calendar', {
      'data.dateRange': {
        message: 'Use data.initialDateRange instead.',
        value: dateRange
      }
    }, 'prop');

    if (!preselectedCalendarListOptionsInput && preselectedOptions) {
      setPreselectedCalendarListOptions(preselectedOptions.map(function (option) {
        return _assign2(_assign2({}, option), {
          id: option.id || uuidv4()
        });
      }));
    } else if (preselectedCalendarListOptionsInput) {
      setPreselectedCalendarListOptions(preselectedCalendarListOptionsInput.map(function (option) {
        return _assign2(_assign2({}, option), {
          id: "" + (option.id || uuidv4())
        });
      }));
    } else {
      setPreselectedCalendarListOptions(defaultPreselectedCalendarListOptions);
    }
  }, [data]);
  useEffect(function () {
    warnIsDeprecated('Calendar', {
      groups: {
        value: groups
      }
    }, 'prop');
  }, [groups]);
  useEffect(function () {
    warnIsDeprecated('Calendar', {
      onDateClick: {
        message: 'Use onValueChange instead.',
        value: onDateClick
      }
    }, 'prop');
  }, [onDateClick]);
  useEffect(function () {
    warnIsDeprecated('Calendar', {
      custom: {
        value: custom
      }
    }, 'prop');
  }, [custom]); // won't change

  var _1 = __read(useState('startDate'), 1),
      startLabelId = _1[0];

  var _2 = __read(useState('endDate'), 1),
      endLabelId = _2[0]; // Calendar Side


  var _3 = __read(useState(initialDateRange || dateRange || {
    first: undefined,
    last: undefined
  }), 2),
      selectedDateRange = _3[0],
      setSelectedDateRange = _3[1];

  var _4 = __read(useState(''), 2),
      firstDateFormatted = _4[0],
      setFirstDateFormatted = _4[1];

  var _5 = __read(useState(''), 2),
      lastDateFormatted = _5[0],
      setLastDateFormatted = _5[1];

  var _6 = __read(useState(null), 2),
      firstDateStatus = _6[0],
      setFirstDateStatus = _6[1];

  var _7 = __read(useState(null), 2),
      lastDateStatus = _7[0],
      setLastDateStatus = _7[1];

  var _8 = __read(useState('day'), 2),
      modalType = _8[0],
      setModalType = _8[1];

  var _9 = __read(useState(true), 2),
      isStartFocused = _9[0],
      setIsStartFocused = _9[1]; // List Side


  var _10 = __read(useState(defaultCheckedListId), 2),
      checkedListIdState = _10[0],
      setCheckedListIdState = _10[1];

  var _11 = __read(useState(preselectedCalendarListOptions), 2),
      listState = _11[0],
      setListState = _11[1];

  var _12 = __read(useState(function () {
    var checkedIndex = listState.findIndex(function (listItem) {
      return listItem.id === checkedListIdState;
    });
    var tempDate = checkedIndex === -1 ? new Date() : listState[checkedIndex].first;
    return formatDateObject(tempDate, locale, separator).dateString;
  }), 2),
      firstListDateFormatted = _12[0],
      setFirstListDateFormatted = _12[1];

  var _13 = __read(useState(function () {
    var checkedIndex = listState.findIndex(function (listItem) {
      return listItem.id === checkedListIdState;
    });
    var tempDate = checkedIndex === -1 ? new Date() : listState[checkedIndex].last;
    return formatDateObject(tempDate, locale, separator).dateString;
  }), 2),
      lastListDateFormatted = _13[0],
      setLastListDateFormatted = _13[1]; // Entire Component


  var _14 = __read(useState(mode), 2),
      modeState = _14[0],
      setModeState = _14[1];

  var initialDateObject = {
    selectedDateRange: selectedDateRange
  };

  var _15 = __read(useState(getInitialDates(initialDateObject)), 2),
      dateArray = _15[0],
      setDateArray = _15[1]; // needed for when the calendar is in a modal, as the onValueChange emitter should not fire
  // unless the user has hit apply


  var _16 = __read(useState({
    dates: {
      first: undefined,
      last: undefined
    },
    mode: mode
  }), 2),
      selectedValueObj = _16[0],
      setSelectedValueObj = _16[1];

  var _17 = __read(useState(false), 2),
      hasBeenModified = _17[0],
      setHasBeenModified = _17[1];

  var dropperRef = useRef(null);

  var _18 = __read(useState(false), 2),
      isPopoutOpen = _18[0],
      setIsPopoutOpen = _18[1];

  useEffect(function () {
    var index = listState.findIndex(function (item) {
      return item.id === checkedListIdState;
    });

    if (index !== -1) {
      setFirstListDateFormatted(formatDateObject(listState[index].first, locale, separator).dateString);
      setLastListDateFormatted(formatDateObject(listState[index].last, locale, separator).dateString);
    }
  }, [checkedListIdState, listState, locale, separator]);
  useEffect(function () {
    setFirstListDateFormatted(function () {
      var checkedIndex = listState.findIndex(function (listItem) {
        return listItem.id === checkedListIdState;
      });
      var tempDate = checkedIndex === -1 ? new Date() : listState[checkedIndex].first;
      return formatDateObject(tempDate, locale, separator).dateString;
    });
    setLastListDateFormatted(function () {
      var checkedIndex = listState.findIndex(function (listItem) {
        return listItem.id === checkedListIdState;
      });
      var tempDate = checkedIndex === -1 ? new Date() : listState[checkedIndex].last;
      return formatDateObject(tempDate, locale, separator).dateString;
    });
  }, [listState]);
  useEffect(function () {
    setModeState(mode);
  }, [mode]);
  useEffect(function () {
    if (isCheckedListIdValid(checkedListId)) {
      setCheckedListIdState(checkedListId);
    }
  }, [checkedListId]);
  var prevSelectedRangeRef = useRef();
  var listRef = useRef(null);
  useEffect(function () {
    prevSelectedRangeRef.current = selectedDateRange;
  });
  var prevRef = prevSelectedRangeRef.current;
  var prevSelectedValueRef = useRef();
  useEffect(function () {
    prevSelectedValueRef.current = selectedValueObj;
  }); // shifts the visible focus onto the current month

  var handleInputFieldFocus = function handleInputFieldFocus(isFirst) {
    if (isFirst && selectedDateRange.first) {
      var currDate = new Date(selectedDateRange.first);
      var copyArray = [];
      copyArray.push(new Date(currDate.getFullYear(), currDate.getMonth() - 1, 1));
      copyArray.push(new Date(currDate.getFullYear(), currDate.getMonth(), 1));
      copyArray.push(new Date(currDate.getFullYear(), currDate.getMonth() + 1, 1));
      copyArray.push(new Date(currDate.getFullYear(), currDate.getMonth() + 2, 1));
      setDateArray(copyArray);
      setModalType('day');
    } else if (!isFirst && selectedDateRange.last) {
      var currDate = new Date(selectedDateRange.last);
      var copyArray = [];
      copyArray.push(new Date(currDate.getFullYear(), currDate.getMonth() - 1, 1));
      copyArray.push(new Date(currDate.getFullYear(), currDate.getMonth(), 1));
      copyArray.push(new Date(currDate.getFullYear(), currDate.getMonth() + 1, 1));
      copyArray.push(new Date(currDate.getFullYear(), currDate.getMonth() + 2, 1));
      setDateArray(copyArray);
      setModalType('day');
    }
  };

  var handleListChange = function handleListChange(value) {
    if (Number.isInteger(value)) {
      var clicked = listState[value];
      var first = clicked.first,
          last = clicked.last,
          id = clicked.id,
          title = clicked.title;
      if (first) setFirstListDateFormatted(formatDateObject(first, locale, separator).dateString);
      if (last) setLastListDateFormatted(formatDateObject(last, locale, separator).dateString);
      setCheckedListIdState(id);

      if (observer) {
        observer.checkedListId = id;
      }

      if (!popoutView && onValueChange) onValueChange({
        first: first,
        last: last
      }, title, id);
      setHasBeenModified(true);
    }
  };

  var updateInputField = function updateInputField(e, isFirst) {
    var inputDate = e.target.value ? new Date(e.target.value) : undefined;
    var first = selectedDateRange.first,
        last = selectedDateRange.last;
    var dateToCompare = isFirst ? first : last; // only triggers if there's a difference

    if ((inputDate === null || inputDate === void 0 ? void 0 : inputDate.valueOf()) !== (dateToCompare === null || dateToCompare === void 0 ? void 0 : dateToCompare.valueOf())) {
      var dateToUse = formatDateMDY(isFirst ? firstDateFormatted : lastDateFormatted, locale, separator);
      var isValid = false;
      var date = void 0;

      if (dateToUse) {
        date = new Date(dateToUse);
        isValid = date >= newMinDate && date <= newMaxDate;
      }

      if (isValid && date) {
        isFirst ? setFirstDateStatus(null) : setLastDateStatus(null);

        if (isFirst) {
          if (selectedDateRange.last && date > selectedDateRange.last) {
            selectedDateRange.last = undefined;
            setLastDateFormatted('');
          }

          var dates = {
            first: date,
            last: selectedDateRange.last
          };
          setSelectedDateRange(dates);

          if (!popoutView) {
            if (onValueChange) onValueChange(dates);else if (onDateClick) onDateClick(dates);
          }
        } else {
          date.setHours(23, 59, 59, 999);

          if (selectedDateRange.first && date < selectedDateRange.first) {
            selectedDateRange.first = undefined;
            setFirstDateFormatted('');
          }

          var dates = {
            first: selectedDateRange.first,
            last: date
          };
          setSelectedDateRange(dates);

          if (!popoutView) {
            if (onValueChange) onValueChange(dates);else if (onDateClick) onDateClick(dates);
          }
        }
      } else {
        if (isFirst) {
          setFirstDateStatus({
            state: 'error',
            text: errorString
          });

          if (lastDateStatus && lastDateStatus.state === 'error') {
            if (onDateError) onDateError({
              first: errorString,
              last: errorString
            });
          } else {
            if (onDateError) onDateError({
              first: errorString,
              last: last
            });
          }
        } else {
          setLastDateStatus({
            state: 'error',
            text: errorString
          });

          if (firstDateStatus && firstDateStatus.state === 'error') {
            if (onDateError) onDateError({
              first: errorString,
              last: errorString
            });
          } else {
            if (onDateError) onDateError({
              first: first,
              last: errorString
            });
          }
        }
      }

      setHasBeenModified(true);
    }
  };

  var handleToggle = function handleToggle() {
    setModeState(function (v) {
      var newMode = v === 'relative' ? 'fixed' : 'relative';

      if (observer) {
        observer.mode = newMode;
      }

      if (onToggle) onToggle(newMode);
      return newMode;
    });
  };

  var handleDateClick = function handleDateClick(dates) {
    if (!popoutView) {
      if (onValueChange) onValueChange(dates);else if (onDateClick) onDateClick(dates);
    } else {
      setHasBeenModified(true);
    }
  };

  useEffect(function () {
    var _a, _b;

    var first = selectedDateRange.first,
        last = selectedDateRange.last;

    if (!first && !last) {
      setFirstDateFormatted('');
      setLastDateFormatted('');
    }

    if (first) {
      var dateString = formatDateObject(first, locale, separator).dateString;
      setFirstDateFormatted(dateString);
      setFirstDateStatus(null); // special case to update current month view in every date change besides when a last date is clicked

      if ((prevRef === null || prevRef === void 0 ? void 0 : prevRef.last) && last || !(prevRef === null || prevRef === void 0 ? void 0 : prevRef.first) && !(prevRef === null || prevRef === void 0 ? void 0 : prevRef.last)) {
        var firstsEqual = ((_a = prevRef === null || prevRef === void 0 ? void 0 : prevRef.first) === null || _a === void 0 ? void 0 : _a.valueOf()) === (first === null || first === void 0 ? void 0 : first.valueOf());
        var lastsEqual = ((_b = prevRef === null || prevRef === void 0 ? void 0 : prevRef.last) === null || _b === void 0 ? void 0 : _b.valueOf()) === (last === null || last === void 0 ? void 0 : last.valueOf()); // if the start date changes, but the last date does not - show last month.

        if (!firstsEqual && lastsEqual) {
          handleInputFieldFocus(false); // if both change - show the first month.
        } else if (!firstsEqual) {
          handleInputFieldFocus(true);
        }
      }

      if (!last) {
        setLastDateFormatted('');
        setLastDateStatus(null);
      }
    }

    if (last) {
      var dateString = formatDateObject(last, locale, separator).dateString;
      setLastDateFormatted(dateString);
      handleInputFieldFocus(false);
      setLastDateStatus(null);
    }
  }, [selectedDateRange, separator, locale]);

  var setInitialDates = function setInitialDates(dates) {
    var first = dates.first,
        last = dates.last;

    if (first && last) {
      try {
        first.setHours(0, 0, 0, 0);
        last.setHours(23, 59, 59, 999);
        setSelectedDateRange({
          first: first,
          last: last
        });
      } catch (_a) {
        devOnlyError('Dates passed are invalid');
      }
    }

    setSelectedDateRange(dates);
  };

  useEffect(function () {
    if (dateRange) {
      setInitialDates(dateRange);
    }

    handleInputFieldFocus(true);
  }, [dateRange]);
  useEffect(function () {
    if (initialDateRange) {
      setInitialDates(initialDateRange);
    }
  }, [initialDateRange]);
  useEffect(function () {
    if (preselectedCalendarListOptions) {
      setListState(preselectedCalendarListOptions);
    }
  }, [preselectedCalendarListOptions]);
  useEffect(function () {
    if (!listRef.current) return;
    var activeElement = checkedListIdState && listRef.current.querySelector("#" + CSS.escape(checkedListIdState));
    if (!activeElement) return;
    var activeOffset = activeElement.offsetTop;
    var activeHeight = activeElement.getBoundingClientRect().height;
    var heightOfBox = listRef.current.getBoundingClientRect().height;
    var offsetOfBox = listRef.current.offsetTop;
    var scroll = listRef.current.scrollTop; //if the element is not currently visible

    if (activeOffset - scroll > heightOfBox || activeOffset < scroll) {
      listRef.current.scrollTo({
        top: activeOffset - offsetOfBox,
        behavior: 'smooth'
      });
    } else if (activeOffset - scroll + activeHeight > heightOfBox) {
      //if the element is only partially visible
      listRef.current.scrollTo({
        top: scroll + activeHeight,
        behavior: 'smooth'
      });
    }
  }, [checkedListIdState, modeState, isPopoutOpen]); // need this function to be passed down because it always needs to set the dates, and pass the results via props (prevents stale data)

  var generateID = function generateID() {
    setSelectedDateRange(nullDates);
  };

  var classNames = className || '';
  classNames += contrast === 'high' ? 'kxi-high-contrast' : '';
  if (hasInternalPadding) classNames += ' kxi-calendar-padding';
  classNames += " kxi-calendar-component-wrapper kxi-" + outline + " orca";
  var mappedList = listState.map(function (option, i) {
    return jsxRuntime_1(ListItem, _assign2({
      checked: option.id === checkedListIdState,
      value: i.toString(),
      id: option.id,
      onClick: function onClick() {
        return handleListChange(i);
      },
      _canBeDeselected: false
    }, {
      children: option.title
    }), i);
  });

  var dropperValue = function dropperValue() {
    var valueText;

    if (modeState === 'fixed') {
      var startDate_1 = firstDateFormatted ? firstDateFormatted : firstInputPlaceholder;
      var endDate_1 = lastDateFormatted ? lastDateFormatted : secondInputPlaceholder;
      valueText = startDate_1 && endDate_1 ? startDate_1 + " - " + endDate_1 : '';
    } else if (modeState === 'relative') {
      var selectedRelativeRange = listState.find(function (listItem) {
        return listItem.id === checkedListIdState;
      });
      valueText = (selectedRelativeRange === null || selectedRelativeRange === void 0 ? void 0 : selectedRelativeRange.title) || '';
    }

    return valueText && jsxRuntime_1("span", _assign2({
      className: "kxi-text-normal kxi-calendar-dropper-value"
    }, {
      children: valueText
    }), void 0);
  };

  var isApplyDisabled = function isApplyDisabled() {
    var startDate = firstDateFormatted.length > 0;
    var endDate = lastDateFormatted.length > 0; // make sure range if they have half the date range started that they complete the range before being able to apply

    var partialRange = modeState === 'fixed' && (!startDate && endDate || startDate && !endDate);
    return partialRange || !hasBeenModified;
  };

  var calendarView = jsxRuntime_2("div", _assign2({
    ref: ref,
    className: classNames
  }, ingredients, {
    "data-testid": "0"
  }, {
    children: [jsxRuntime_2("div", _assign2({
      className: "kxi-calendar-input-wrapper"
    }, {
      children: [jsxRuntime_1("div", _assign2({
        className: "kxi-calendar-switch-wrapper"
      }, {
        children: jsxRuntime_1(ToggleText, {
          side: modeState === 'fixed' ? 'right' : 'left',
          contrast: contrast,
          stretch: true,
          leftText: leftText,
          rightText: rightText,
          onToggle: handleToggle
        }, void 0)
      }), void 0), modeState === 'fixed' ? jsxRuntime_2("div", _assign2({
        className: "kxi-calendar-labels kxi-text-small orca"
      }, {
        children: [jsxRuntime_1("label", _assign2({
          htmlFor: startLabelId
        }, {
          children: startDate
        }), void 0), jsxRuntime_1("label", _assign2({
          htmlFor: endLabelId
        }, {
          children: endDate
        }), void 0)]
      }), void 0) : null, jsxRuntime_2("div", _assign2({
        className: "kxi-calendar-input-fields " + (modeState === 'relative' ? 'kxi-calendar-list' : '')
      }, {
        children: [modeState === 'fixed' ? jsxRuntime_1(InputField, {
          _controlledState: true,
          inputId: startLabelId,
          contrast: contrast,
          onChange: function onChange(e) {
            return formatControlledInput(e, firstDateFormatted, setFirstDateFormatted, locale, separator);
          },
          value: firstDateFormatted,
          status: firstDateStatus,
          onClick: function onClick() {
            return setIsStartFocused(true);
          },
          onBlur: function onBlur(e) {
            return updateInputField(e, true);
          },
          onFocus: function onFocus() {
            setIsStartFocused(true);
            handleInputFieldFocus(true);
          },
          maxLength: 10,
          placeholder: firstInputPlaceholder,
          className: "kxi-calendar-input " + (isStartFocused ? 'kxi-focused' : ''),
          width: "50%",
          prePopulateStatus: true,
          "data-testid": "kxi-calendar-first"
        }, void 0) : checkedListIdState && jsxRuntime_1("p", _assign2({
          className: "kxi-calendar-dark kxi-text-small kxi-text-600"
        }, {
          children: firstListDateFormatted
        }), void 0), modeState === 'relative' && checkedListIdState === null ? jsxRuntime_1("p", _assign2({
          className: "kxi-text-small orca"
        }, {
          children: noSelection
        }), void 0) : jsxRuntime_1("p", _assign2({
          className: "kxi-text-xsmall orca"
        }, {
          children: to
        }), void 0), modeState === 'fixed' ? jsxRuntime_1(InputField, {
          _controlledState: true,
          inputId: endLabelId,
          contrast: contrast,
          onChange: function onChange(e) {
            return formatControlledInput(e, lastDateFormatted, setLastDateFormatted, locale, separator);
          },
          status: lastDateStatus,
          value: lastDateFormatted,
          onClick: function onClick() {
            return setIsStartFocused(false);
          },
          onBlur: function onBlur(e) {
            return updateInputField(e, false);
          },
          onFocus: function onFocus() {
            setIsStartFocused(false);
            handleInputFieldFocus(false);
          },
          maxLength: 10,
          placeholder: secondInputPlaceholder,
          className: "kxi-calendar-input " + (!isStartFocused ? 'kxi-focused' : ''),
          width: "50%",
          prePopulateStatus: true,
          "data-testid": "kxi-calendar-last"
        }, void 0) : checkedListIdState && jsxRuntime_1("p", _assign2({
          className: "kxi-calendar-dark kxi-text-small kxi-text-600"
        }, {
          children: lastListDateFormatted
        }), void 0)]
      }), void 0)]
    }), void 0), jsxRuntime_1("div", _assign2({
      className: "kxi-calendar-wrapper " + (modeState === 'relative' ? 'kxi-calendar-list' : '') + "  " + (contrast === 'high' ? 'kxi-high-contrast' : '')
    }, {
      children: modeState === 'fixed' ? jsxRuntime_1(Calendars, {
        dateArray: dateArray,
        setDateArray: setDateArray,
        modalType: modalType,
        isStartFocused: isStartFocused,
        setModalType: setModalType,
        minDate: newMinDate,
        maxDate: newMaxDate,
        locale: locale,
        contrast: contrast,
        selectedRangeDates: selectedDateRange,
        setIsStartFocused: setIsStartFocused,
        setSelectedRangeDates: function setSelectedRangeDates(dates) {
          if (popoutView && !isPopoutOpen) return;
          setSelectedDateRange(dates);
        },
        onDateClick: handleDateClick,
        generateId: generateID
      }, void 0) : jsxRuntime_1(List, _assign2({
        select: "single",
        className: "kxi-text-small",
        contrast: contrast,
        ref: listRef
      }, {
        children: mappedList
      }), void 0)
    }), void 0)]
  }), void 0);

  var onCancel = function onCancel() {
    var _a, _b, _c;

    setIsPopoutOpen(false);
    setSelectedDateRange(((_a = selectedValueObj.dates) === null || _a === void 0 ? void 0 : _a.first) && ((_b = selectedValueObj.dates) === null || _b === void 0 ? void 0 : _b.last) ? selectedValueObj.dates : dateRange || initialDateRange || {
      first: undefined,
      last: undefined
    });
    setCheckedListIdState((selectedValueObj === null || selectedValueObj === void 0 ? void 0 : selectedValueObj.id) || checkedListId || ((_c = preselectedCalendarListOptions[0]) === null || _c === void 0 ? void 0 : _c.id) || DefaultPreselectedCalendarListIds.TODAY);
    setModeState(selectedValueObj.mode || mode);
  };

  var popoutCalendar = jsxRuntime_2("div", _assign2({
    className: "kxi-calendar-popout-wrapper",
    ref: dropperRef
  }, {
    children: [jsxRuntime_2("div", _assign2({
      className: "kxi-calendar-popout-dropper kxi-input kxi-border orca " + (condensedPopoutDropper ? 'kxi-condensed' : ''),
      onClick: function onClick() {
        return setIsPopoutOpen(!isPopoutOpen);
      }
    }, {
      children: [dropperValue(), jsxRuntime_1("span", _assign2({
        className: "kxi-calendar-popout-dropper-icon"
      }, {
        children: jsxRuntime_1(XIIcon, {
          icon: "calendar",
          iconSize: 24
        }, void 0)
      }), void 0)]
    }), void 0), jsxRuntime_1(Popout, _assign2({
      className: "kxi-card-shadow",
      parentRef: dropperRef,
      isVisible: isPopoutOpen,
      direction: direction,
      onExternalClick: onCancel
    }, {
      children: jsxRuntime_2(jsxRuntime_3, {
        children: [calendarView, jsxRuntime_2("div", _assign2({
          className: "kxi-calendar-popout-footer-buttons kxi-grey"
        }, {
          children: [jsxRuntime_1(DefaultButton, {
            color: "orca",
            buttonSize: "normal",
            text: cancelBtn,
            fill: "no-fill",
            onClick: function onClick() {
              var _a, _b;

              setIsPopoutOpen(false);
              setSelectedDateRange(((_a = selectedValueObj.dates) === null || _a === void 0 ? void 0 : _a.first) && ((_b = selectedValueObj.dates) === null || _b === void 0 ? void 0 : _b.last) ? selectedValueObj.dates : dateRange || initialDateRange || {
                first: undefined,
                last: undefined
              });
              setCheckedListIdState((selectedValueObj === null || selectedValueObj === void 0 ? void 0 : selectedValueObj.id) || defaultCheckedListId);
              setModeState(selectedValueObj.mode || mode);
            }
          }, void 0), jsxRuntime_1(DefaultButton, {
            color: "orca",
            buttonSize: "normal",
            text: applyBtn,
            fill: "fill",
            disabled: isApplyDisabled(),
            onClick: function onClick() {
              setIsPopoutOpen(false);
              setHasBeenModified(false);

              if (modeState === 'fixed') {
                setSelectedValueObj({
                  dates: selectedDateRange,
                  id: undefined,
                  title: undefined,
                  mode: modeState
                });
                if (onValueChange) onValueChange(selectedDateRange);
              } else if (modeState === 'relative') {
                var selectedItem = listState.find(function (x) {
                  return x.id === checkedListIdState;
                });
                var title = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.title;
                var first = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.first;
                var last = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.last;
                setSelectedValueObj(_assign2({
                  dates: {
                    first: first,
                    last: last
                  },
                  title: title,
                  mode: modeState
                }, checkedListIdState ? {
                  id: checkedListIdState
                } : {}));
                onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange({
                  first: first,
                  last: last
                }, title, checkedListIdState !== null && checkedListIdState !== void 0 ? checkedListIdState : undefined);
              }
            }
          }, void 0)]
        }), void 0)]
      }, void 0)
    }), void 0)]
  }), void 0);
  return !popoutView ? calendarView : popoutCalendar;
}); // giving the consumer access

var ColorPickerKnobProps = function (_super) {
  __extends(ColorPickerKnobProps, _super);

  function ColorPickerKnobProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return ColorPickerKnobProps;
}(DivHTMLAttributes);

var ColorPickerKnob = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      color = props.color,
      ingredients = __rest(props, ["className", "color"]);

  return jsxRuntime_1("div", _assign2({}, ingredients, {
    className: "kxi-color-picker-knob-wrapper " + (className || ''),
    ref: ref
  }, {
    children: jsxRuntime_1("div", {
      className: "kxi-color-picker-knob"
    }, void 0)
  }), void 0);
});

var ColorPickerGradientPlaneProps = function (_super) {
  __extends(ColorPickerGradientPlaneProps, _super);

  function ColorPickerGradientPlaneProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return ColorPickerGradientPlaneProps;
}(DivHTMLAttributes);

var ColorPickerGradientPlaneEvents = function (_super) {
  __extends(ColorPickerGradientPlaneEvents, _super);

  function ColorPickerGradientPlaneEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return ColorPickerGradientPlaneEvents;
}(DivHTMLEvents);
/**
 * Description: The 2d plane that will be the visual representation of the selected color and can be used to select a color.
 */


var ColorPickerGradientPlane = function ColorPickerGradientPlane(props) {
  var hue = props.hue,
      initialValue = props.initialValue,
      _onMouseDown = props.onMouseDown,
      onColorChange = props.onColorChange;

  var _a = __read(useState("rgba(" + hue.red + ", " + hue.green + ", " + hue.blue + ", 1)"), 2),
      base = _a[0],
      setBase = _a[1];

  var canvasRef = useRef(null);
  var selectedPosition = useRef();
  var knobRef = useRef(null);
  var planeRef = useRef(null);
  var mouseDown = useRef(false);

  var _b = __read(useState(0), 2),
      top = _b[0],
      setTop = _b[1];

  var _c = __read(useState(0), 2),
      left = _c[0],
      setLeft = _c[1];

  useEffect(function () {
    var onMouseUp = function onMouseUp() {
      mouseDown.current = false;
    };

    var onMouseMove = function onMouseMove(event) {
      if (mouseDown.current) {
        selectedPositionMovement(event);
      }
    };

    window.addEventListener('mouseup', onMouseUp);
    window.addEventListener('mousemove', onMouseMove);
    return function () {
      window.removeEventListener('mouseup', onMouseUp);
      window.removeEventListener('mousemove', onMouseMove);
    };
  }, []);
  useEffect(function () {
    var _a, _b;

    var min = Math.min(Math.min(Number(initialValue.red), Number(initialValue.green)), Number(initialValue.blue));
    var max = Math.max(Math.max(Number(initialValue.red), Number(initialValue.green)), Number(initialValue.blue));
    var xPct = max ? 1 - min / max : 0;
    var yPct = 1 - max / 255;
    var boundingClient = ((_a = canvasRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) || {
      width: 0,
      height: 0
    };
    var x = boundingClient.width * xPct;
    var y = boundingClient.height * yPct;
    selectedPosition.current = {
      x: x,
      y: y
    };
    draw();
    var knobClient = (_b = knobRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
    setTop((y || 0) + ((knobClient === null || knobClient === void 0 ? void 0 : knobClient.height) || 0) / 2);
    setLeft((x || 0) + ((knobClient === null || knobClient === void 0 ? void 0 : knobClient.width) || 0) / 2);
  }, [initialValue]);
  useEffect(function () {
    setBase("rgba(" + hue.red + ", " + hue.green + ", " + hue.blue + ", 1)");
  }, [hue]);
  useEffect(function () {
    var _a;

    draw();

    if (selectedPosition.current && !((_a = planeRef.current) === null || _a === void 0 ? void 0 : _a.closest('.kxi-popout-menu-hidden')) && onColorChange) {
      onColorChange(getColorAtPosition(selectedPosition.current.x, selectedPosition.current.y));
    }
  }, [base]); // main function for adding gradients and drawing the selector for the canvas.

  var draw = function draw() {
    if (!canvasRef.current) {
      return;
    }

    var ctx = canvasRef.current.getContext('2d');

    if (!ctx) {
      return;
    }

    var width = canvasRef.current.width;
    var height = canvasRef.current.height;
    ctx.fillStyle = base;
    ctx.fillRect(0, 0, width, height);
    ctx.imageSmoothingEnabled = false;
    var whiteGrad = ctx.createLinearGradient(0, 0, width, 0);
    whiteGrad.addColorStop(0.01, 'rgba(255, 255, 255, 1)');
    whiteGrad.addColorStop(1, 'rgba(255, 255, 255, 0)');
    ctx.fillStyle = whiteGrad;
    ctx.fillRect(0, 0, width, height);
    var blackGrad = ctx.createLinearGradient(0, 0, 0, height);
    blackGrad.addColorStop(0.01, 'rgba(0, 0, 0, 0)');
    blackGrad.addColorStop(1, 'rgba(0, 0, 0, 1)');
    ctx.fillStyle = blackGrad;
    ctx.fillRect(0, 0, width, height);
  }; // getting the current rgba value of selected position on plane.


  var getColorAtPosition = function getColorAtPosition(x, y) {
    if (x === void 0) {
      x = 0;
    }

    if (y === void 0) {
      y = 0;
    }

    var defaultColor = {
      red: 0,
      green: 0,
      blue: 0,
      alpha: 1
    };

    if (!canvasRef.current) {
      return defaultColor;
    }

    var ctx = canvasRef.current.getContext('2d');

    if (!ctx) {
      return defaultColor;
    }

    var boundingBox = canvasRef.current.getBoundingClientRect();
    x = x < 0 ? 0 : x >= boundingBox.width ? boundingBox.width - 1 : x;
    y = y < 0 ? 0 : y > boundingBox.height ? boundingBox.height : y;
    var imageData = ctx.getImageData(x, y, 1, 1).data;
    return {
      red: imageData[0],
      green: imageData[1],
      blue: imageData[2],
      alpha: 1
    };
  };

  var selectedPositionMovement = function selectedPositionMovement(event) {
    var _a;

    if (!canvasRef.current || !knobRef.current) {
      return;
    }

    selectedPosition.current = {
      x: event.offsetX,
      y: event.offsetY
    };
    var canvasClient = canvasRef.current.getBoundingClientRect();
    var knobClient = knobRef.current.getBoundingClientRect();
    var y = event.clientY + (knobClient.height || 0) / 2 - canvasClient.top;
    var x = event.clientX + (knobClient.width || 0) / 2 - canvasClient.left;
    y = y > canvasClient.height + knobClient.height / 2 ? canvasClient.height + knobClient.height / 2 : y < 0 + knobClient.height / 2 ? 0 + knobClient.height / 2 : y;
    x = x > canvasClient.width + knobClient.width / 2 ? canvasClient.width + knobClient.width / 2 : x < 0 + knobClient.width / 2 ? 0 + knobClient.width / 2 : x;
    setTop(y);
    setLeft(x);

    if (!((_a = planeRef.current) === null || _a === void 0 ? void 0 : _a.closest('.kxi-popout-menu-hidden'))) {
      if (onColorChange) onColorChange(getColorAtPosition(x - knobClient.width / 2, y - knobClient.height / 2));
    }
  };

  var selectedPositionMovementNative = function selectedPositionMovementNative(event) {
    var _a, _b, _c;

    selectedPosition.current = {
      x: event.nativeEvent.offsetX,
      y: event.nativeEvent.offsetY
    };
    setTop(event.nativeEvent.offsetY + (((_a = knobRef === null || knobRef === void 0 ? void 0 : knobRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height) || 0) / 2);
    setLeft(event.nativeEvent.offsetX + (((_b = knobRef === null || knobRef === void 0 ? void 0 : knobRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().width) || 0) / 2);

    if (!((_c = planeRef.current) === null || _c === void 0 ? void 0 : _c.closest('.kxi-popout-menu-hidden')) && onColorChange) {
      onColorChange(getColorAtPosition(event.nativeEvent.offsetX, event.nativeEvent.offsetY));
    }
  };

  return jsxRuntime_2("div", _assign2({
    className: "kxi-2d-picker-wrapper orca",
    ref: planeRef
  }, {
    children: [jsxRuntime_1("canvas", {
      className: "kxi-2d-picker",
      "data-testid": "color-picker-canvas",
      ref: canvasRef,
      width: "370",
      height: "196",
      onMouseUp: function onMouseUp() {
        mouseDown.current = false;
      },
      onMouseDown: function onMouseDown(event) {
        mouseDown.current = true;
        selectedPositionMovementNative(event);
        if (_onMouseDown) _onMouseDown();
      }
    }, void 0), jsxRuntime_1(ColorPickerKnob, {
      "data-testid": "color-picker-2d-knob",
      style: {
        position: 'absolute',
        top: top,
        left: left,
        pointerEvents: 'none'
      },
      ref: knobRef
    }, void 0)]
  }), void 0);
};

var normalizeRGBAColor = function normalizeRGBAColor(rgba) {
  return {
    red: Number(rgba.red),
    green: Number(rgba.green),
    blue: Number(rgba.blue),
    alpha: Number(rgba.alpha)
  };
};

var getColorFromValue = function getColorFromValue(value, isAlphaSlider, alphaColor) {
  if (isAlphaSlider === void 0) {
    isAlphaSlider = false;
  }

  var outputValue = {
    red: 255,
    green: 255,
    blue: 255,
    alpha: 1
  };

  if (!isAlphaSlider) {
    switch (Math.floor(value / 60)) {
      //4.25 = 255/60 (value / degree change)
      case 0:
        outputValue.blue = 0;
        outputValue.green = Math.round(value * 4.25);
        break;

      case 1:
        outputValue.blue = 0;
        outputValue.red = Math.round(255 - (value - 60) * 4.25);
        break;

      case 2:
        outputValue.blue = Math.round((value - 120) * 4.25);
        outputValue.red = 0;
        break;

      case 3:
        outputValue.green = Math.round(255 - (value - 180) * 4.25);
        outputValue.red = 0;
        break;

      case 4:
        outputValue.green = 0;
        outputValue.red = Math.round((value - 240) * 4.25);
        break;

      case 5:
        outputValue.green = 0;
        outputValue.blue = Math.round(255 - (value - 300) * 4.25);
        break;

      case 6:
        outputValue.blue = 0;
        outputValue.green = 0;
        break;
    }
  } else {
    if (alphaColor) {
      outputValue = _assign2(_assign2({}, normalizeRGBAColor(alphaColor)), {
        alpha: value
      });
    }
  }

  return outputValue;
};

var ColorSlider = function ColorSlider(props) {
  var className = props.className,
      _a = props.isAlphaSlider,
      isAlphaSlider = _a === void 0 ? false : _a,
      _b = props.initialValue,
      initialValue = _b === void 0 ? 1 : _b,
      _c = props.alphaColor,
      alphaColor = _c === void 0 ? {
    red: 255,
    green: 0,
    blue: 0,
    alpha: 1
  } : _c,
      onChange = props.onChange,
      _onMouseDown = props.onMouseDown,
      _onMouseUp = props.onMouseUp,
      ingredients = __rest(props, ["className", "isAlphaSlider", "initialValue", "alphaColor", "onChange", "onMouseDown", "onMouseUp"]);

  var track = useRef(null);
  var knob = useRef(null);

  var _d = __read(useState(false), 2),
      sliding = _d[0],
      setSliding = _d[1];

  var _e = __read(useState(0), 2),
      mouseY = _e[0],
      setMouseY = _e[1]; //keeps track of the mouse position always


  var _f = __read(useState(0), 2),
      sliderPosition = _f[0],
      setSliderPosition = _f[1];

  var _g = __read(useState(0), 2),
      slideStart = _g[0],
      setSlideStart = _g[1];

  var sliderRef = useRef(null);
  var newSliderPosition = 0;
  useEffect(function () {
    var _a, _b;

    if (initialValue > 0) {
      var trackHeight = (((_a = track === null || track === void 0 ? void 0 : track.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height) || 0) - 2;
      var knobHeight = ((_b = knob === null || knob === void 0 ? void 0 : knob.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().height) || 0;
      var useableTrack = trackHeight - knobHeight;

      if (isAlphaSlider) {
        newSliderPosition = (1 - initialValue) * useableTrack;
      } else {
        newSliderPosition = initialValue / 360 * useableTrack;
      }

      setSliderPosition(newSliderPosition);
    }

    var updateMousePosition = function updateMousePosition(event) {
      setMouseY(event.clientY);
    };

    var stopSliding = function stopSliding(event) {
      setSliding(false);
    };

    window.addEventListener('mousemove', updateMousePosition);
    window.addEventListener('mouseup', stopSliding);
    return function () {
      window.removeEventListener('mousemove', updateMousePosition);
      window.addEventListener('mouseup', stopSliding);
    };
  }, []);
  useEffect(function () {
    var _a, _b;

    var trackHeight = (((_a = track === null || track === void 0 ? void 0 : track.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height) || 0) - 2;
    var knobHeight = ((_b = knob === null || knob === void 0 ? void 0 : knob.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().height) || 0;
    var useableTrack = trackHeight - knobHeight;

    if (isAlphaSlider) {
      if (initialValue === 100) {
        newSliderPosition = 100 * useableTrack;
      } else {
        newSliderPosition = (1 - initialValue) * useableTrack;
      }
    } else {
      newSliderPosition = initialValue / 360 * useableTrack;
    }

    setSliderPosition(newSliderPosition);
  }, [initialValue]);
  useEffect(function () {
    var _a, _b, _c, _d, _e;

    var top = (_b = (_a = track === null || track === void 0 ? void 0 : track.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.top;
    var height = (_d = (_c = track === null || track === void 0 ? void 0 : track.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect()) === null || _d === void 0 ? void 0 : _d.height;
    var knobHeight = ((_e = knob === null || knob === void 0 ? void 0 : knob.current) === null || _e === void 0 ? void 0 : _e.getBoundingClientRect().height) || 0;

    if (sliding && top && height && knobHeight) {
      height -= 2; //account for border

      var point = Math.floor(mouseY - (top || 0));
      var newSliderPosition_1 = point - slideStart;

      if (newSliderPosition_1 < 0) {
        newSliderPosition_1 = 0;
      } else if (newSliderPosition_1 > height - knobHeight) {
        newSliderPosition_1 = height - knobHeight;
      }

      setSliderPosition(newSliderPosition_1);
    }
  }, [sliding, mouseY, slideStart]);
  useEffect(function () {
    var _a, _b;

    if (sliding) {
      var top_1 = ((_b = (_a = knob === null || knob === void 0 ? void 0 : knob.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.top) || 0;
      setSlideStart(mouseY - top_1 + 1);
    }
  }, [sliding]);
  useEffect(function () {
    var _a, _b, _c;

    var trackHeight = (((_a = track === null || track === void 0 ? void 0 : track.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height) || 0) - 2;
    var knobHeight = ((_b = knob === null || knob === void 0 ? void 0 : knob.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().height) || 0;
    var useableTrack = trackHeight - knobHeight;
    var value = 0;

    if (isAlphaSlider) {
      value = 1 - sliderPosition / useableTrack;
    } else {
      value = sliderPosition / useableTrack * 360;
    }

    var color = getColorFromValue(value, isAlphaSlider, alphaColor);

    if (onChange && !((_c = sliderRef.current) === null || _c === void 0 ? void 0 : _c.closest('.kxi-popout-menu-hidden'))) {
      onChange(color, isAlphaSlider ? 0 : value);
    }
  }, [sliderPosition]);
  return jsxRuntime_1("div", _assign2({}, ingredients, {
    className: "kxi-color-slider-wrapper orca " + (className || ''),
    ref: sliderRef
  }, {
    children: jsxRuntime_2("div", _assign2({
      ref: track,
      className: "kxi-color-slider-track " + (isAlphaSlider ? 'kxi-color-slider-alpha' : 'kxi-color-slider-hue')
    }, {
      children: [jsxRuntime_1(ColorPickerKnob, {
        style: {
          position: 'absolute',
          top: sliderPosition,
          zIndex: 2
        },
        "data-testid": "color-picker-knob",
        onMouseDown: function onMouseDown() {
          setSliding(true);

          if (_onMouseDown) {
            _onMouseDown();
          }
        },
        onMouseUp: function onMouseUp() {
          setSliding(false);

          if (_onMouseUp) {
            _onMouseUp();
          }
        },
        ref: knob
      }, void 0), jsxRuntime_1("div", {
        className: "kxi-color-slider-overlay",
        style: isAlphaSlider ? {
          background: "linear-gradient(rgba(" + alphaColor.red + "," + alphaColor.green + "," + alphaColor.blue + ",1), rgba(" + alphaColor.red + "," + alphaColor.green + "," + alphaColor.blue + ", 0))"
        } : undefined,
        onMouseDown: function onMouseDown(event) {
          var _a, _b, _c;

          var top = ((_b = (_a = track === null || track === void 0 ? void 0 : track.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.top) || 0;
          var knobOffset = (((_c = knob.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect().height) || 0) / 2 + 2;
          setSliderPosition(event.clientY - top - knobOffset);
          setSliding(true);

          if (_onMouseDown) {
            _onMouseDown();
          }
        },
        onMouseUp: function onMouseUp() {
          if (_onMouseUp) {
            _onMouseUp();
          }
        }
      }, void 0)]
    }), void 0)
  }), void 0);
};

var ColorPickerProps = function (_super) {
  __extends(ColorPickerProps, _super);

  function ColorPickerProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Object)], ColorPickerProps.prototype, "initialColor");

  __decorate([Bound(), __metadata("design:type", Object)], ColorPickerProps.prototype, "selectedColor");

  __decorate([Bound(), __metadata("design:type", Number)], ColorPickerProps.prototype, "direction");

  __decorate([Bound(), __metadata("design:type", String)], ColorPickerProps.prototype, "inputType");

  __decorate([Bound(), __metadata("design:type", Boolean)], ColorPickerProps.prototype, "hexContainsAlpha");

  __decorate([Bound(), __metadata("design:type", Object)], ColorPickerProps.prototype, "localization");

  return ColorPickerProps;
}(ObservablePropsMixin(DivHTMLAttributes));

var ColorPickerEvents = function (_super) {
  __extends(ColorPickerEvents, _super);

  function ColorPickerEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], ColorPickerEvents.prototype, "onColorChange");

  return ColorPickerEvents;
}(DivHTMLEvents);
/**
 * Description: Allows the user to pick a color from an 2d chart
 */


var ColorPicker = /*#__PURE__*/forwardRef(function (props, ref) {
  var initialColor = props.initialColor,
      selectedColor = props.selectedColor,
      _onColorChange = props.onColorChange,
      hexContainsAlpha = props.hexContainsAlpha,
      className = props.className,
      observer = props.observer,
      _a = props.direction,
      direction = _a === void 0 ? 7 : _a,
      _b = props.inputType,
      inputType = _b === void 0 ? 'RGB' : _b,
      _c = props.localization,
      localization = _c === void 0 ? {} : _c,
      ingredients = __rest(props, ["initialColor", "selectedColor", "onColorChange", "hexContainsAlpha", "className", "observer", "direction", "inputType", "localization"]);

  var defaultColor = {
    red: 226,
    green: 226,
    blue: 226,
    alpha: 1
  };

  var _d = __read(useState(0), 2),
      hue = _d[0],
      setHue = _d[1];

  var _e = __read(useState(defaultColor), 2),
      rgba = _e[0],
      setRGBA = _e[1];

  var _f = __read(useState(false), 2),
      isPortalVisible = _f[0],
      setPortalVisibility = _f[1];

  var _g = __read(useState(inputType), 2),
      colorType = _g[0],
      setColorType = _g[1];

  var _h = __read(useState({
    red: 255,
    green: 0,
    blue: 0,
    alpha: 1
  }), 2),
      initialValue = _h[0],
      setInitialValue = _h[1];

  var _j = __read(useState({
    red: 255,
    green: 0,
    blue: 0,
    alpha: 1
  }), 2),
      rgbHue = _j[0],
      setRgbHue = _j[1];

  var squareRef = useRef(null);
  var disableColorChange = useRef(false);
  var popoutRef = useRef(null);
  var alphaRef = useRef(1);

  var _k = __read(useState(false), 2),
      hueControl = _k[0],
      setHueControl = _k[1];

  var _l = __read(useState(false), 2),
      hexError = _l[0],
      setHexError = _l[1];

  var _m = __read(useState(false), 2),
      alphaControl = _m[0],
      setAlphaControl = _m[1];

  var _o = __read(useState(''), 2),
      hexValue = _o[0],
      setHexValue = _o[1];

  var _p = __read(useState(false), 2),
      hasGeneratedWarning = _p[0],
      setHasGeneratedWarning = _p[1];

  var _q = __read(useState(false), 2),
      initialized = _q[0],
      setInitialized = _q[1];

  var _r = localization.red,
      red = _r === void 0 ? 'R' : _r,
      _s = localization.green,
      green = _s === void 0 ? 'G' : _s,
      _t = localization.blue,
      blue = _t === void 0 ? 'B' : _t,
      _u = localization.alpha,
      alpha = _u === void 0 ? 'A' : _u,
      _v = localization.rgb,
      rgb = _v === void 0 ? 'RGB' : _v,
      _w = localization.hex,
      hex = _w === void 0 ? 'HEX' : _w;
  useEffect(function () {
    if (initialColor) {
      warnIsDeprecated('Color Picker', {
        initialColor: {
          value: initialColor
        }
      }, 'prop');
    }
  }, [initialColor]);
  useEffect(function () {
    setColorType(inputType);
  }, [inputType]);
  useEffect(function () {
    var onWindowClick = function onWindowClick(e) {
      if (popoutRef.current) {
        var eventPath = e.composedPath();
        var popout = popoutRef.current; // const eventPathIds = eventPath.map((value: any) => value.id);

        if (!(eventPath === null || eventPath === void 0 ? void 0 : eventPath.includes(popout)) && !(eventPath === null || eventPath === void 0 ? void 0 : eventPath.includes(squareRef.current))) {
          setPortalVisibility(false);
        }
      }
    };

    if (isPortalVisible) {
      disableColorChange.current = false;
      window.addEventListener('mousedown', onWindowClick);
    } else {
      window.removeEventListener('mousedown', onWindowClick);
    }
  }, [isPortalVisible]);
  useEffect(function () {
    var color = getInternalColor();
    setRGBA(color);
    setInitialValue(color);
    setHue(getHue(Number(color.red), Number(color.green), Number(color.blue)));
    setInitialized(true);
  }, [initialColor, selectedColor]);
  useEffect(function () {
    setRgbHue(getColorFromValue(hue, false));
  }, [hue]);
  useEffect(function () {
    if (observer && initialized) {
      if (typeof selectedColor === 'string') {
        observer.selectedColor = RGBAtoHex(rgba);
      } else {
        observer.selectedColor = rgba;
      }
    }

    setHexValue(RGBAtoHex(rgba));
    alphaRef.current = Number(rgba.alpha);
  }, [rgba]);

  var getInternalColor = function getInternalColor() {
    var color = initialColor ? initialColor : selectedColor;

    if (color) {
      if (typeof color === 'string') {
        color = hexToRGB(color);

        if (!color) {
          color = {
            red: 255,
            green: 0,
            blue: 0,
            alpha: 1
          };
        }
      }

      return validateRGBA(color) || defaultColor;
    }

    return defaultColor;
  };

  var validateRGBA = function validateRGBA(color) {
    if (!color.red && color.red !== 0 || isNaN(Number(color.red)) || !color.green && color.green !== 0 || isNaN(Number(color.green)) || !color.blue && color.blue !== 0 || isNaN(Number(color.blue)) || !color.alpha && color.alpha !== 0 || isNaN(Number(color.alpha))) {
      if (!hasGeneratedWarning) {
        console.warn('Invalid color provided to color picker component');
        setHasGeneratedWarning(true);
      }

      return undefined;
    }

    var putColorInBounds = function putColorInBounds(color, isAlpha) {
      if (isAlpha === void 0) {
        isAlpha = false;
      }

      if (isAlpha) {
        if (color <= 1 && color >= 0) {
          return color;
        } else if (color < 0) {
          if (!hasGeneratedWarning) {
            console.warn('Invalid color provided to color picker component');
          }

          return 0;
        } else {
          if (!hasGeneratedWarning) {
            console.warn('Invalid color provided to color picker component');
          }

          return 1;
        }
      } else {
        if (color <= 255 && color >= 0) {
          return color;
        } else if (color < 0) {
          if (!hasGeneratedWarning) {
            console.warn('Invalid color provided to color picker component');
          }

          return 0;
        } else {
          if (!hasGeneratedWarning) {
            console.warn('Invalid color provided to color picker component');
          }

          return 255;
        }
      }
    };

    var validColor = {
      red: putColorInBounds(color.red),
      green: putColorInBounds(color.green),
      blue: putColorInBounds(color.blue),
      alpha: putColorInBounds(color.alpha, true)
    };
    return validColor;
  };

  var RGBAtoHex = function RGBAtoHex(color) {
    var red, green, blue, alpha;
    red = Number(color.red).toString(16);
    green = Number(color.green).toString(16);
    blue = Number(color.blue).toString(16);
    alpha = Math.floor(Number(color.alpha) * 255).toString(16);
    if (red.length === 1) red = '0' + red;
    if (green.length === 1) green = '0' + green;
    if (blue.length === 1) blue = '0' + blue;
    if (alpha.length === 1) alpha = '0' + alpha;
    return '#' + red + green + blue + (hexContainsAlpha ? alpha : '');
  };

  var hexToRGB = function hexToRGB(hexInput) {
    var isValid = /^#?[0-9,a-f,A-F]{8}$|^#?[0-9,a-f,A-F]{6}$|^#?[0-9,a-f,A-F]{3,4}$/.test(hexInput);

    if (!isValid) {
      return undefined;
    }

    hexInput = hexInput.replace('#', '');
    var red, green, blue, alpha;

    switch (hexInput.length) {
      case 3:
        red = parseInt("" + hexInput.substr(0, 1) + hexInput.substr(0, 1), 16);
        green = parseInt("" + hexInput.substr(1, 1) + hexInput.substr(1, 1), 16);
        blue = parseInt("" + hexInput.substr(2, 1) + hexInput.substr(2, 1), 16);
        alpha = 1;
        break;

      case 4:
        red = parseInt("" + hexInput.substr(0, 1) + hexInput.substr(0, 1), 16);
        green = parseInt("" + hexInput.substr(1, 1) + hexInput.substr(1, 1), 16);
        blue = parseInt("" + hexInput.substr(2, 1) + hexInput.substr(2, 1), 16);
        alpha = parseInt("" + hexInput.substr(3, 1) + hexInput.substr(3, 1), 16) / 255;
        break;

      case 6:
        red = parseInt("" + hexInput.substr(0, 2), 16);
        green = parseInt("" + hexInput.substr(2, 2), 16);
        blue = parseInt("" + hexInput.substr(4, 2), 16);
        alpha = 1;
        break;

      case 8:
        red = parseInt("" + hexInput.substr(0, 2), 16);
        green = parseInt("" + hexInput.substr(2, 2), 16);
        blue = parseInt("" + hexInput.substr(4, 2), 16);
        alpha = parseInt("" + hexInput.substr(6, 2), 16) / 255;
        break;
    }

    return isValidColor(red, green, blue, alpha) ? {
      red: red,
      green: green,
      blue: blue,
      alpha: alpha
    } : undefined;
  };

  var isValidColor = function isValidColor(red, green, blue, alpha) {
    return isValidColorChannel(red) && isValidColorChannel(green) && isValidColorChannel(blue) && isValidColorChannel(alpha);
  };

  var isValidColorChannel = function isValidColorChannel(color) {
    return !(!color && color !== 0 || isNaN(color));
  };

  var getHue = function getHue(red, green, blue) {
    var min = Math.min(Math.min(red, green), blue);
    var max = Math.max(Math.max(red, green), blue);

    if (min === max) {
      return hue;
    }

    var newHue = 0;

    if (max === red) {
      newHue = (green - blue) / (max - min);
    } else if (max === green) {
      newHue = 2 + (blue - red) / (max - min);
    } else {
      newHue = 4 + (red - green) / (max - min);
    }

    newHue = newHue * 60;
    if (newHue < 0) newHue = newHue + 360;
    return Math.round(newHue);
  };

  var colorPickerPortal = jsxRuntime_2(jsxRuntime_3, {
    children: [jsxRuntime_2("div", _assign2({
      role: "dialog",
      "aria-hidden": !isPortalVisible,
      className: "kxi-color-selector-container",
      "data-testid": "color-picker-modal"
    }, {
      children: [jsxRuntime_1(ColorPickerGradientPlane, {
        hue: rgbHue,
        initialValue: initialValue,
        onColorChange: function onColorChange(e) {
          if (!disableColorChange.current) {
            var newRGB = {
              red: e.red,
              green: e.green,
              blue: e.blue,
              alpha: alphaRef.current
            };
            setRGBA(newRGB);
            setHexError(false);

            if (_onColorChange) {
              _onColorChange(newRGB);
            }
          }
        },
        onMouseDown: function onMouseDown() {
          disableColorChange.current = false;
        }
      }, void 0), jsxRuntime_1(ColorSlider, {
        "data-testid": "color-picker-hue",
        alphaColor: rgba,
        initialValue: hueControl ? undefined : hue,
        onChange: function onChange(_, hue) {
          if (!disableColorChange.current) {
            setHue(hue);
            setHexError(false);
          }
        },
        onMouseDown: function onMouseDown() {
          disableColorChange.current = false;
          setHueControl(true);
        },
        onMouseUp: function onMouseUp() {
          setHueControl(false);
        }
      }, void 0), jsxRuntime_1(ColorSlider, {
        "data-testid": "color-picker-alpha",
        isAlphaSlider: true,
        initialValue: alphaControl ? undefined : Number(rgba.alpha),
        alphaColor: rgba,
        onChange: function onChange(event) {
          if (!disableColorChange.current) {
            var newRGB = normalizeRGBAColor(_assign2(_assign2({}, rgba), {
              alpha: event.alpha
            }));
            setRGBA(newRGB);

            if (_onColorChange) {
              _onColorChange(newRGB);
            }

            setHexError(false);
          }
        },
        onMouseDown: function onMouseDown() {
          disableColorChange.current = false;
          setAlphaControl(true);
        },
        onMouseUp: function onMouseUp() {
          setAlphaControl(false);
        }
      }, void 0)]
    }), void 0), inputType !== 'none' ? jsxRuntime_2("div", _assign2({
      className: "kxi-color-selector-container inputs"
    }, {
      children: [jsxRuntime_1("div", {
        className: "kxi-menu-color-square",
        style: {
          backgroundColor: "rgba(" + rgba.red + ", " + rgba.green + ", " + rgba.blue + ", " + rgba.alpha + ")"
        }
      }, void 0), jsxRuntime_1(Dropdown, {
        data: [{
          title: rgb,
          id: 'RGB',
          isSelected: colorType === 'RGB'
        }, {
          title: hex,
          id: 'HEX',
          isSelected: colorType === 'HEX'
        }],
        select: "single",
        className: "kxi-color-type",
        onValueChange: function onValueChange(e) {
          setColorType(e.id);
        },
        elementsToDisableScroll: [],
        style: {
          marginRight: 5
        }
      }, void 0), colorType === 'RGB' ? jsxRuntime_2(jsxRuntime_3, {
        children: [jsxRuntime_1(InputField, {
          className: "kxi-color-input",
          "data-testid": "red",
          value: rgba.red.toString(),
          label: red,
          mask: "999",
          errorOnIncompleteMask: false,
          onFocus: function onFocus() {
            disableColorChange.current = true;
          },
          onBlur: function onBlur() {
            disableColorChange.current = false;
          },
          onInput: function onInput(event) {
            if (isNaN(event.target.value)) {
              return;
            }

            var value = Number(event.target.value);

            if (value > 255) {
              value = 255;
            } else if (value < 0) {
              value = 0;
            }

            var newRGB = normalizeRGBAColor(_assign2(_assign2({}, rgba), {
              red: value
            }));
            setRGBA(newRGB);

            if (_onColorChange) {
              _onColorChange(newRGB);
            }

            setInitialValue(_assign2(_assign2({}, rgba), {
              red: value
            }));
            setHue(getHue(value, Number(rgba.green), Number(rgba.blue)));
          },
          style: {
            marginRight: 5
          }
        }, void 0), jsxRuntime_1(InputField, {
          className: "kxi-color-input",
          "data-testid": "green",
          value: rgba.green.toString(),
          label: green,
          mask: "999",
          errorOnIncompleteMask: false,
          onFocus: function onFocus() {
            disableColorChange.current = true;
          },
          onBlur: function onBlur() {
            disableColorChange.current = false;
          },
          onInput: function onInput(event) {
            if (isNaN(event.target.value)) {
              return;
            }

            var value = Number(event.target.value);

            if (value > 255) {
              value = 255;
            } else if (value < 0) {
              value = 0;
            }

            var newRGB = normalizeRGBAColor(_assign2(_assign2({}, rgba), {
              green: value
            }));
            setRGBA(newRGB);

            if (_onColorChange) {
              _onColorChange(newRGB);
            }

            setInitialValue(_assign2(_assign2({}, rgba), {
              green: value
            }));
            setHue(getHue(Number(rgba.red), value, Number(rgba.blue)));
          },
          style: {
            marginRight: 5
          }
        }, void 0), jsxRuntime_1(InputField, {
          className: "kxi-color-input",
          "data-testid": "blue",
          value: rgba.blue.toString(),
          label: blue,
          mask: "999",
          errorOnIncompleteMask: false,
          onFocus: function onFocus() {
            disableColorChange.current = true;
          },
          onBlur: function onBlur() {
            disableColorChange.current = false;
          },
          onInput: function onInput(event) {
            if (isNaN(event.target.value)) {
              return;
            }

            var value = Number(event.target.value);

            if (value > 255) {
              value = 255;
            } else if (value < 0) {
              value = 0;
            }

            var newRGB = normalizeRGBAColor(_assign2(_assign2({}, rgba), {
              blue: value
            }));
            setRGBA(newRGB);

            if (_onColorChange) {
              _onColorChange(newRGB);
            }

            setInitialValue(_assign2(_assign2({}, rgba), {
              blue: value
            }));
            setHue(getHue(Number(rgba.red), Number(rgba.green), value));
          },
          style: {
            marginRight: 5
          }
        }, void 0)]
      }, void 0) : jsxRuntime_1(jsxRuntime_3, {
        children: jsxRuntime_1(InputField, {
          className: "kxi-hex-color-input " + (hexContainsAlpha ? 'kxi-hex-has-alpha' : ''),
          "data-testid": "hex",
          value: hexValue,
          label: "#",
          status: hexError ? {
            state: 'error'
          } : undefined,
          onFocus: function onFocus() {
            disableColorChange.current = true;
          },
          onBlur: function onBlur() {
            disableColorChange.current = false;
            setHexValue(RGBAtoHex(rgba));
          },
          onInput: function onInput(event) {
            setHexValue(event.target.value);
            var hexOutput = hexToRGB(event.target.value);

            if (hexOutput) {
              if (_onColorChange) {
                _onColorChange(hexOutput);
              }

              setRGBA(hexOutput);
              setInitialValue(hexOutput);
              setHue(getHue(Number(hexOutput.red), Number(hexOutput.green), Number(hexOutput.blue)));
              setHexError(false);
            } else {
              setHexError(true);
            }
          },
          style: {
            marginRight: 5
          }
        }, void 0)
      }, void 0), (!hexContainsAlpha || colorType === 'RGB') && jsxRuntime_1(InputField, {
        "data-testid": "alpha",
        className: "kxi-color-input",
        label: alpha,
        value: Math.round(Number(rgba.alpha) * 100).toString(),
        min: 0,
        max: 100,
        mask: "999",
        errorOnIncompleteMask: false,
        onBlur: function onBlur() {
          if (!rgba.alpha && rgba.alpha !== 0) {
            var newRGB = normalizeRGBAColor(_assign2(_assign2({}, rgba), {
              alpha: 1
            }));
            setRGBA(newRGB);

            if (_onColorChange) {
              _onColorChange(newRGB);
            }
          }
        },
        onInput: function onInput(event) {
          if (isNaN(event.target.value)) {
            return;
          }

          var value = Number(event.target.value);

          if (value > 100) {
            value = 100;
          } else if (value < 0) {
            value = 0;
          }

          var newRGB = normalizeRGBAColor(_assign2(_assign2({}, rgba), {
            alpha: value / 100
          }));
          setRGBA(newRGB);

          if (_onColorChange) {
            _onColorChange(newRGB);
          }
        }
      }, void 0)]
    }), void 0) : jsxRuntime_1("div", {
      style: {
        marginBottom: '12px'
      }
    }, void 0)]
  }, void 0);
  return jsxRuntime_2("div", {
    children: [jsxRuntime_1("div", _assign2({
      className: "kxi-color-square-wrapper",
      "aria-haspopup": true,
      tabIndex: 0
    }, {
      children: jsxRuntime_1("div", {
        className: "kxi-color-square",
        "data-testid": "color-picker-square",
        style: {
          backgroundColor: "rgba(" + rgba.red + ", " + rgba.green + ", " + rgba.blue + ", " + rgba.alpha + ")"
        },
        onClick: function onClick(e) {
          disableColorChange.current = true;
          setInitialValue(rgba);
          setHue(getHue(Number(rgba.red), Number(rgba.green), Number(rgba.blue)));
          setPortalVisibility(!isPortalVisible);
        },
        ref: squareRef
      }, void 0)
    }), void 0), jsxRuntime_1(Popout, _assign2({
      parentRef: squareRef,
      isVisible: isPortalVisible,
      className: "kxi-color-picker " + (className || ''),
      ref: mergeRefs([popoutRef, ref]),
      direction: direction
    }, ingredients, {
      children: colorPickerPortal
    }), void 0)]
  }, void 0);
});

var DatePickerProps = function (_super) {
  __extends(DatePickerProps, _super);

  function DatePickerProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Date)], DatePickerProps.prototype, "minDate");

  __decorate([Bound(), __metadata("design:type", Date)], DatePickerProps.prototype, "maxDate");

  __decorate([Bound(), __metadata("design:type", String)], DatePickerProps.prototype, "locale");

  __decorate([Bound(), __metadata("design:type", Date)], DatePickerProps.prototype, "dateValue");

  __decorate([Bound(), __metadata("design:type", Object)], DatePickerProps.prototype, "status");

  __decorate([Bound(), __metadata("design:type", String)], DatePickerProps.prototype, "placeholder");

  return DatePickerProps;
}(InputFieldProps);

var DatePickerEvents = function (_super) {
  __extends(DatePickerEvents, _super);

  function DatePickerEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], DatePickerEvents.prototype, "onDateChange");

  return DatePickerEvents;
}(InputFieldEvents);
/**
 * Description: Standard InMoment branded Date Picker.
 */


var DatePicker = /*#__PURE__*/forwardRef(function (props, ref) {
  var today = new Date(); // arbitrarily setting it 2 months in the future to avoid a bug (revert back to default max date being today after BZ-5944)

  var defaultMaxDate = new Date(today.getFullYear(), today.getMonth() + 2);

  var _a = props.minDate,
      minDate = _a === void 0 ? new Date('01/01/1970') : _a,
      _b = props.maxDate,
      maxDate = _b === void 0 ? defaultMaxDate : _b,
      className = props.className,
      onDateChange = props.onDateChange,
      onClick = props.onClick,
      onChange = props.onChange,
      onBlur = props.onBlur,
      _onIconClick = props.onIconClick,
      observer = props.observer,
      value = props.value,
      dateValue = props.dateValue,
      _c = props.locale,
      locale = _c === void 0 ? 'en-US' : _c,
      _d = props.contrast,
      contrast = _d === void 0 ? 'normal' : _d,
      status = props.status,
      placeholder = props.placeholder,
      ingredients = __rest(props, ["minDate", "maxDate", "className", "onDateChange", "onClick", "onChange", "onBlur", "onIconClick", "observer", "value", "dateValue", "locale", "contrast", "status", "placeholder"]);

  var intl = new Intl.DateTimeFormat(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });

  var _e = __read(useState(), 2),
      regex = _e[0],
      setRegex = _e[1];

  var _f = __read(useState(), 2),
      fullRegex = _f[0],
      setFullRegex = _f[1];

  var _g = __read(useState(false), 2),
      isOpen = _g[0],
      setIsOpen = _g[1];

  var _h = __read(useState(false), 2),
      isDateSelecting = _h[0],
      setIsDateSelecting = _h[1];

  var _j = __read(useState(nullDates), 2),
      selectedRangeDates = _j[0],
      setSelectedRangeDates = _j[1];

  var initialDateObject = {
    selectedDateRange: selectedRangeDates
  };

  var _k = __read(useState(getInitialDates(initialDateObject)), 2),
      dateArray = _k[0],
      setDateArray = _k[1];

  var _l = __read(useState('day'), 2),
      modalType = _l[0],
      setModalType = _l[1]; // need this function to be passed down because it always needs to set the dates, and pass the results via props


  var generateID = function generateID() {
    setSelectedRangeDates(nullDates);
  };

  useLayoutEffect(function () {
    if (value !== undefined) {
      devOnlyWarn('The Kitchen: you are using the value property of the Date Picker.  You should use the dateValue property as it is type safe.');
    }

    var parts = intl.formatToParts().filter(function (p) {
      return p.type !== 'literal';
    });
    var set1 = '',
        set2 = '',
        set3 = '';
    var transInitial = {
      day: '(0?[1-9]?|[12][0-9]|3[01])?(?!\\d)',
      month: '(0?[1-9]?|1[0-2])?(?!\\d)',
      year: '(\\d{0,4})?(?!\\d)'
    };
    var transSecondary = {
      day: '(0?[1-9]|[12][0-9]|3[01])[-/.]',
      month: '(0?[1-9]|1[0-2])[-/.]',
      year: '(\\d{1,4})[-/.]'
    };
    parts.forEach(function (p, i) {
      switch (i) {
        case 0:
          set1 += transInitial[p.type];
          set2 += transSecondary[p.type];
          set3 += transSecondary[p.type];
          break;

        case 1:
          set2 += transInitial[p.type];
          set3 += transSecondary[p.type];
          break;

        case 2:
          set3 += transInitial[p.type];
          break;
      }
    });
    setFullRegex(new RegExp("^(" + set3 + ")$"));
    setRegex(new RegExp("^(" + set3 + ")$|^(" + set2 + ")$|^(" + set1 + ")$"));
  }, []);

  var _m = __read(useState(dateValue ? intl.format(dateValue) : ''), 2),
      text = _m[0],
      setText = _m[1];

  var handleInput = function handleInput(e) {
    var newText = e.target.value;

    if (regex === null || regex === void 0 ? void 0 : regex.test(newText)) {
      setText(function () {
        return newText;
      });
      var textAsDate = new Date(newText);

      if (fullRegex === null || fullRegex === void 0 ? void 0 : fullRegex.test(newText)) {
        setDateArray(getInitialDates({
          selectedDateRange: {
            first: textAsDate,
            last: undefined
          }
        }));
        updateDateRange(textAsDate);
        textAsDate.setHours(0, 0, 0, 0);
        if (onDateChange) onDateChange(textAsDate);

        if (observer) {
          observer.dateValue = textAsDate;
        }
      } else {
        if (observer) {
          observer.dateValue = undefined;
        }
      }

      if (onChange) onChange(e);
    }
  };

  var onWindowClick = function onWindowClick(e) {
    var eventPath = e.path;
    var datePickerWrapper = document.querySelector('.kxi-date-picker-wrapper');
    if (!(eventPath === null || eventPath === void 0 ? void 0 : eventPath.includes(datePickerWrapper))) setIsOpen(false);
  };

  useEffect(function () {
    if (isOpen) window.addEventListener('click', onWindowClick);else {
      window.removeEventListener('click', onWindowClick);
    }
    return function () {
      window.removeEventListener('click', onWindowClick);
    };
  }, [isOpen]);
  useEffect(function () {
    setText(dateValue ? intl.format(dateValue) : '');
  }, [dateValue, locale]);

  var handleClick = function handleClick(e) {
    e.stopPropagation();
    setIsOpen(true);
    if (onClick) onClick(e);
  };

  var handleBlur = function handleBlur(e) {
    if (text === '' || isDateSelecting) return;
    ensureValidDate();
    if (onBlur) onBlur(e);
  };

  var handleDateClick = function handleDateClick(dates) {
    updateDateRange(dates.first);
    setText(function () {
      return intl.format(dates.first);
    });
    setIsOpen(false);
    dates.first.setHours(0, 0, 0, 0);
    if (onDateChange) onDateChange(dates.first);

    if (observer) {
      observer.dateValue = dates.first;
    }
  };

  var updateDateRange = function updateDateRange(date) {
    var endOfDay = new Date(date);
    endOfDay.setHours(23, 59, 59, 999);
    setSelectedRangeDates({
      first: date,
      last: endOfDay
    });
  };

  var ensureValidDate = function ensureValidDate() {
    var textAsDate = new Date(text);
    var formattedDate = intl.format(textAsDate);
    setIsOpen(function () {
      return false;
    });

    if (text !== formattedDate) {
      setText(function () {
        return formattedDate;
      });
      textAsDate.setHours(0, 0, 0, 0);
      if (onDateChange) onDateChange(textAsDate);

      if (observer) {
        observer.dateValue = textAsDate;
      }
    }
  };

  var getDateFormat = function getDateFormat() {
    var _a;

    var trans = {
      day: 'DD',
      month: 'MM',
      year: 'YYYY'
    };
    var parts = intl.formatToParts();
    var literal = (_a = parts.find(function (p) {
      return p.type === 'literal';
    })) === null || _a === void 0 ? void 0 : _a.value;
    return parts.filter(function (p) {
      return p.type !== 'literal';
    }).map(function (p) {
      return trans[p.type];
    }).join(literal);
  };

  return jsxRuntime_2("div", _assign2({
    className: "kxi-date-picker-wrapper"
  }, {
    children: [jsxRuntime_1(InputField, _assign2({
      _controlledState: true,
      onClick: function onClick(e) {
        return handleClick(e);
      },
      onChange: function onChange(e) {
        return handleInput(e);
      },
      onBlur: function onBlur(e) {
        handleBlur(e);
      },
      onIconClick: function onIconClick() {
        setIsOpen(function (open) {
          return !open;
        });
        if (_onIconClick) _onIconClick();
      },
      icon: "calendar",
      value: text,
      className: "kxi-date-picker " + className,
      contrast: contrast,
      placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : getDateFormat(),
      status: status,
      ref: ref
    }, ingredients), void 0), isOpen && jsxRuntime_1(motion.div, _assign2({
      initial: {
        opacity: 0
      },
      animate: {
        opacity: 1
      },
      exit: {
        opacity: 0
      },
      transition: {
        duration: 0.075
      },
      onMouseDown: function onMouseDown() {
        setIsDateSelecting(true);
      },
      onMouseUp: function onMouseUp() {
        setIsDateSelecting(false);
      },
      className: "kxi-dropdown-menu orca kxi-normal-contrast"
    }, {
      children: jsxRuntime_1(Calendars, {
        dateArray: dateArray,
        setDateArray: setDateArray,
        modalType: modalType,
        setModalType: setModalType,
        minDate: minDate,
        maxDate: maxDate,
        locale: locale,
        contrast: contrast,
        selectedRangeDates: selectedRangeDates,
        setSelectedRangeDates: setSelectedRangeDates,
        onDateClick: handleDateClick,
        generateId: generateID,
        isStartFocused: true
      }, void 0)
    }), void 0)]
  }), void 0);
});

var DraggableItem = function DraggableItem(props) {
  var getTTOverflow = props.getTTOverflow,
      localization = props.localization,
      _a = props.draggable,
      draggable = _a === void 0 ? true : _a,
      item = props.item,
      moveOne = props.moveOne,
      moveItem = props.moveItem,
      dragEnd = props.dragEnd,
      index = props.index,
      style = props.style,
      _b = props.tabIndexStart,
      tabIndexStart = _b === void 0 ? 0 : _b;
  var isDragging = React__default.useRef(false);
  var ref = React__default.useRef(null);

  var _c = __read(React__default.useState(false), 2),
      draggedRecent = _c[0],
      setDraggedRecent = _c[1];

  var _d = __read(React__default.useState(false), 2),
      drag2 = _d[0],
      setDrag2 = _d[1];

  var wrapperClick = function wrapperClick() {
    if (!draggedRecent) moveOne(false, item.id);
  };

  var wrapperKeyDown = function wrapperKeyDown(e) {
    if (e.keyCode === 13 || e.keyCode === 32) {
      moveOne(false, item.id);
    }
  };

  var displayItem = function displayItem() {
    return jsxRuntime_2(jsxRuntime_3, {
      children: [draggable && jsxRuntime_1(XIIcon, {
        icon: "drag_handle",
        style: {
          marginRight: 6,
          paddingTop: 2
        }
      }, void 0), item.component || getTTOverflow(item, index, true, isDragging.current), !drag2 && jsxRuntime_1("div", _assign2({
        className: "kxi-picker-button"
      }, {
        children: jsxRuntime_1(DefaultButton, {
          disabled: item.disabled || false,
          hasShadows: true,
          text: (localization === null || localization === void 0 ? void 0 : localization.removeButton) || defaultText.removeButton,
          onClick: function onClick() {
            if (draggedRecent) moveOne(false, item.id);
          },
          buttonSize: "small",
          fill: "fill",
          color: "orca",
          tabIndex: -1
        }, void 0)
      }), void 0)]
    }, void 0);
  };

  return draggable ? jsxRuntime_1(motion.div, _assign2({
    ref: ref,
    initial: {
      opacity: 1
    },
    animate: true,
    drag: "y",
    dragConstraints: {
      top: 0,
      bottom: 0
    },
    dragElastic: 1,
    transition: {
      ease: 'easeInOut',
      duration: 0.075
    },
    onDrag: function onDrag(e, _a) {
      var point = _a.point;
      moveItem && moveItem(index, point.y);
      setDrag2(true);
    },
    onDragStart: function onDragStart() {
      setDraggedRecent(true);
      isDragging.current = true;
    },
    onDragEnd: function onDragEnd() {
      setTimeout(function () {
        setDraggedRecent(false);
      }, 100);
      isDragging.current = false;
      setDrag2(false);

      if (dragEnd) {
        dragEnd();
      }
    },
    className: "kxi-picker-list-item-selected " + (drag2 ? 'kxi-picker-list-item-dragging' : ''),
    style: _assign2({
      cursor: item.disabled ? 'auto' : 'pointer',
      top: index * 36
    }, style),
    onClick: wrapperClick,
    onKeyDown: wrapperKeyDown,
    tabIndex: index + tabIndexStart
  }, {
    children: displayItem()
  }), void 0) : jsxRuntime_1("div", _assign2({
    ref: ref,
    className: "kxi-picker-list-item-selected kxi-picker-list-item-no-dragging",
    style: _assign2({
      cursor: item.disabled ? 'auto' : 'pointer',
      top: index * 36
    }, style),
    onClick: wrapperClick,
    onKeyDown: wrapperKeyDown,
    tabIndex: index + tabIndexStart
  }, {
    children: displayItem()
  }), void 0);
};

var ToolTipOverflowText = function ToolTipOverflowText(props) {
  var text = props.text,
      title = props.title,
      tooltip = props.tooltip,
      _a = props.disabled,
      disabled = _a === void 0 ? false : _a,
      _b = props.willAccountForIcon,
      willAccountForIcon = _b === void 0 ? false : _b,
      _c = props.spaceOnRight,
      spaceOnRight = _c === void 0 ? 0 : _c,
      style = props.style,
      boldedText = props.boldedText,
      ingredients = __rest(props, ["text", "title", "tooltip", "disabled", "willAccountForIcon", "spaceOnRight", "style", "boldedText"]);

  var textRef = useRef(null);
  var onResize = useCallback(function () {
    if (textRef === null || textRef === void 0 ? void 0 : textRef.current) {
      setOverflow(textRef.current.clientWidth < textRef.current.scrollWidth);
      setToolTipWidth(textRef.current.clientWidth - 12);
    }
  }, []);

  var _d = __read(useState(false), 2),
      overflow = _d[0],
      setOverflow = _d[1];

  var _e = __read(useState(undefined), 2),
      toolTipWidth = _e[0],
      setToolTipWidth = _e[1];

  useEffect(function () {
    onResize();
  }, []);

  var BoldText = function BoldText(text, bolded) {
    if (text) {
      var textArray_1 = text.split(bolded);
      return textArray_1.map(function (item, index) {
        return jsxRuntime_2("span", {
          children: [item, index !== textArray_1.length - 1 && jsxRuntime_1("b", {
            children: bolded
          }, void 0)]
        }, "ttoverflow_" + item + "_" + index);
      });
    }
  };

  var textOverflow = jsxRuntime_1("p", _assign2({
    ref: textRef,
    className: "kxi-tooltip-overflow-text",
    color: disabled ? 'disabled' : undefined
  }, {
    children: boldedText ? BoldText(title, boldedText) : title
  }), void 0);
  return jsxRuntime_1(ReactResizeDetector, _assign2({
    refreshMode: "debounce",
    refreshRate: 0,
    handleWidth: true,
    onResize: onResize
  }, {
    children: overflow || text ? // this fragment is necessary to avoid a console error - see https://github.com/maslianok/react-resize-detector/issues/113
    jsxRuntime_1(jsxRuntime_3, {
      children: jsxRuntime_1(ToolTipWrapper, _assign2({}, tooltip, {
        boldedText: boldedText,
        text: text ? text : overflow ? title : undefined,
        title: overflow && text ? title : undefined,
        style: _assign2({
          display: 'block',
          width: "calc(100% - " + (willAccountForIcon ? 24 + spaceOnRight : spaceOnRight) + "px)",
          height: '100%',
          whiteSpace: 'nowrap'
        }, style),
        innerStyle: {
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          height: '100%'
        },
        maxWidth: toolTipWidth,
        usePortal: true,
        space: 12
      }, ingredients, {
        children: textOverflow
      }), void 0)
    }, void 0) : textOverflow
  }), void 0);
};

var LeftRightPickerProps = function (_super) {
  __extends(LeftRightPickerProps, _super);

  function LeftRightPickerProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], LeftRightPickerProps.prototype, "title");

  __decorate([Bound(), __metadata("design:type", Object)], LeftRightPickerProps.prototype, "data");

  __decorate([Bound(), __metadata("design:type", Object)], LeftRightPickerProps.prototype, "availableLoaderSettings");

  __decorate([Bound(), __metadata("design:type", Object)], LeftRightPickerProps.prototype, "selectedLoaderSettings");

  __decorate([Bound(), __metadata("design:type", Number)], LeftRightPickerProps.prototype, "selectedItemsThreshold");

  __decorate([Bound(), __metadata("design:type", Object)], LeftRightPickerProps.prototype, "localization");

  __decorate([Bound(), __metadata("design:type", Boolean)], LeftRightPickerProps.prototype, "dragAndDropEnabled");

  __decorate([Bound(), __metadata("design:type", Function)], LeftRightPickerProps.prototype, "compareFunction");

  return LeftRightPickerProps;
}(DivHTMLAttributes);

var defaultText = {
  available: 'Available',
  addButton: 'Add',
  removeButton: 'Remove',
  addAll: 'Add All',
  selected: 'Selected',
  removeAll: 'Remove All',
  searchPlaceholder: 'Search',
  results: 'Results'
};

var LeftRightPickerEvents = function (_super) {
  __extends(LeftRightPickerEvents, _super);

  function LeftRightPickerEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], LeftRightPickerEvents.prototype, "onItemsChanged");

  return LeftRightPickerEvents;
}(DivHTMLEvents);
/**
 * Description: Move items from one side of any given list to another, all done from within the component.
 */


var LeftRightPicker = /*#__PURE__*/forwardRef(function (props, ref) {
  var title = props.title,
      data = props.data,
      onItemsChanged = props.onItemsChanged,
      className = props.className,
      localization = props.localization,
      availableLoaderSettings = props.availableLoaderSettings,
      selectedLoaderSettings = props.selectedLoaderSettings,
      _a = props.selectedItemsThreshold,
      selectedItemsThreshold = _a === void 0 ? 30 : _a,
      _b = props.dragAndDropEnabled,
      dragAndDropEnabled = _b === void 0 ? true : _b,
      compareFunction = props.compareFunction,
      ingredients = __rest(props, ["title", "data", "onItemsChanged", "className", "localization", "availableLoaderSettings", "selectedLoaderSettings", "selectedItemsThreshold", "dragAndDropEnabled", "compareFunction"]);

  var _c = __read(useState(0), 2),
      available = _c[0],
      setAvailable = _c[1];

  var _d = __read(useState(0), 2),
      selected = _d[0],
      setSelected = _d[1];

  var _e = __read(useState([]), 2),
      availableItems = _e[0],
      setAvailableItems = _e[1];

  var _f = __read(useState([]), 2),
      selectedItems = _f[0],
      setSelectedItems = _f[1];

  var _g = __read(useState(), 2),
      selectedIComponents = _g[0],
      setSelectedIComponents = _g[1];

  var _h = __read(useState([]), 2),
      queryItems = _h[0],
      setQueryItems = _h[1];

  var _j = __read(useState(0), 2),
      resultCount = _j[0],
      setResultCount = _j[1];

  var _k = __read(useState([]), 2),
      selectedQueryItems = _k[0],
      setSelectedQueryItems = _k[1];

  var _l = __read(useState(0), 2),
      selectedResultCount = _l[0],
      setSelectedResultCount = _l[1];

  var _m = __read(useState(''), 2),
      query = _m[0],
      setQuery = _m[1];

  var _o = __read(useState(0), 2),
      availableFixedListHeight = _o[0],
      setAvailableFixedListHeight = _o[1];

  var _p = __read(useState(0), 2),
      selectedFixedListHeight = _p[0],
      setSelectedFixedListHeight = _p[1];

  var innerWrapper = useRef(null);
  var textWrapper = useRef(null);
  var leftWrapper = useRef(null);
  var rightWrapper = useRef(null);
  var availableLoader = useRef(null);
  var selectedLoader = useRef(null);
  useEffect(function () {
    var ids = [];
    var initialAvailableItems = [];
    var initialSelectedItems = [];

    if (data.initialAvailableItems) {
      for (var i = 0; i < data.initialAvailableItems.length; i++) {
        if (data.initialAvailableItems[i].id) {
          var pickerItem = data.initialAvailableItems[i];
          pickerItem.id = data.initialAvailableItems[i].id.toString();
          ids.push(pickerItem.id);
          initialAvailableItems.push(pickerItem);
        } else {
          var pickerItem = data.initialAvailableItems[i];
          pickerItem.id = uuidv4();
          initialAvailableItems.push(pickerItem);
        }
      }
    }

    if (data.initialSelectedItems) {
      for (var i = 0; i < data.initialSelectedItems.length; i++) {
        if (data.initialSelectedItems[i].id) {
          var pickerItem = data.initialSelectedItems[i];
          pickerItem.id = data.initialSelectedItems[i].id.toString();
          ids.push(pickerItem.id);
          initialSelectedItems.push(pickerItem);
        } else {
          var pickerItem = data.initialSelectedItems[i];
          pickerItem.id = uuidv4();
          initialSelectedItems.push(pickerItem);
        }
      }
    }

    var duplicates = ids.filter(function (item, index) {
      return ids.indexOf(item) !== index;
    });

    if (duplicates.length > 0) {
      devOnlyError("Items with duplicate IDs detected in LR Picker. \nDuplicate IDs detected: " + JSON.stringify(duplicates));
    }

    setAvailableItems(sortItems(initialAvailableItems));
    setSelectedItems(initialSelectedItems);
    setQueryItems(sortItems(initialAvailableItems));
  }, [data, compareFunction]);

  var findIndex = function findIndex(index, yOffset) {
    var target = index;
    var top = index * 36;
    var height = 36;
    var bottom = top + height; // If moving down

    if (yOffset > 0) {
      if (index + 1 >= selectedItems.length) return index;
      var swapOffset = distance(bottom, (index + 1) * 36 + 18) + 18;
      if (yOffset > swapOffset) target = index + 1; // If moving up
    } else if (yOffset < 0) {
      if (index - 1 < 0) return index;
      var prevBottom = (index - 1) * 36 + 36;
      var swapOffset = distance(top, prevBottom - 18) + 18;
      if (yOffset < -swapOffset) target = index - 1;
    }

    return clamp(0, selectedItems.length, target);
  };

  var moveItem = function moveItem(i, dragOffset) {
    var _a, _b; // Scroll list if needed


    if (rightWrapper.current) {
      var containerHeight = (_a = rightWrapper.current) === null || _a === void 0 ? void 0 : _a.clientHeight;
      var indexLength = Math.floor((containerHeight || 0) / 36);
      var amountScrolledBottom = (_b = rightWrapper.current) === null || _b === void 0 ? void 0 : _b.scrollTop;
      var minIndexScrolled = Math.floor(amountScrolledBottom / 36);
      var maxIndexScrolled = minIndexScrolled + indexLength;
      if (i < minIndexScrolled + 3 && dragOffset < 10) rightWrapper.current.scrollTo(0, amountScrolledBottom - 8);
      if (i > maxIndexScrolled - 3 && dragOffset > 10) rightWrapper.current.scrollTo(0, amountScrolledBottom + 8);
    }

    if (selectedItems.length < selectedItemsThreshold) {
      var targetIndex = findIndex(i, dragOffset);
      if (targetIndex !== i) setSelectedItems(arrayMove(selectedItems, i, targetIndex));
    }
  };

  var dragEnd = function dragEnd() {
    if (onItemsChanged) onItemsChanged(sortItems(availableItems), selectedItems);
  };

  var defaultSort = function defaultSort(a, b) {
    var nameA = a.title.toUpperCase();
    var nameB = b.title.toUpperCase();
    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    return 0;
  };

  var sortItems = function sortItems(items) {
    return items.sort(compareFunction ? compareFunction : defaultSort);
  };

  var tabIndexStart = 20;
  useEffect(function () {
    var selectedItemComponents = query && query !== '' ? selectedQueryItems : selectedItems;
    selectedItemComponents.map(function (item, index) {
      var ttDirectDisabled = selectedItems.length > 4 && index > selectedItems.length - 3 ? 1 : 5;
      return jsxRuntime_1(DraggableItem, {
        moveItem: moveItem,
        localization: localization,
        index: index,
        item: item,
        moveOne: moveOne,
        ttDirectDisabled: ttDirectDisabled,
        getTTOverflow: getTTOverflow,
        dragEnd: dragEnd,
        tabIndexStart: tabIndexStart + 2
      }, "LRPicker_Selected_Item_" + item.id);
    });
    setSelectedIComponents(selectedItemComponents);
  }, [selectedItems, selectedQueryItems, query]);

  var moveOne = function moveOne(willMoveToSelected, id) {
    var copy = __spreadArray([], __read(willMoveToSelected ? availableItems : selectedItems));

    var index = copy.findIndex(function (i) {
      return "" + i.id === "" + id && !i.disabled;
    });

    if (index > -1) {
      var item = copy.splice(index, 1)[0];
      var selected_1 = willMoveToSelected ? __spreadArray(__spreadArray([], __read(selectedItems)), [item]) : __spreadArray([], __read(copy));
      var available_1 = sortItems(willMoveToSelected ? __spreadArray([], __read(copy)) : __spreadArray(__spreadArray([], __read(availableItems)), [item]));
      setAvailableItems(available_1);
      setSelectedItems(selected_1);
      if (onItemsChanged) onItemsChanged(sortItems(available_1), selected_1);
    }
  };

  var moveAll = function moveAll(willMoveToSelected) {
    var copy = __spreadArray([], __read(willMoveToSelected ? availableItems : selectedItems));

    var remaining = [];
    copy.forEach(function (i) {
      var itemInQueryItems = query && query !== '' ? willMoveToSelected ? queryItems.findIndex(function (queryItem) {
        return queryItem.id === i.id;
      }) > -1 : selectedQueryItems.findIndex(function (queryItem) {
        return queryItem.id === i.id;
      }) > -1 : true;
      if (i.disabled || !itemInQueryItems) remaining.push(i);
    });
    remaining.forEach(function (i) {
      return copy.splice(copy.indexOf(i), 1);
    });
    var selected = sortItems(willMoveToSelected ? __spreadArray(__spreadArray([], __read(selectedItems)), __read(copy)) : remaining);
    var available = sortItems(willMoveToSelected ? remaining : __spreadArray(__spreadArray([], __read(copy)), __read(availableItems)));
    setSelectedItems(selected);
    setAvailableItems(available);
    if (onItemsChanged) onItemsChanged(sortItems(available), selected);
  };

  var getTTOverflow = function getTTOverflow(item, index, willAccountForIcon, isDragging) {
    if (isDragging === void 0) {
      isDragging = false;
    }

    var ttDirectTextOverflow = availableItems.length > 4 && index > availableItems.length - 3 ? 1 : 7;
    return jsxRuntime_1(jsxRuntime_3, {
      children: isDragging ? jsxRuntime_1("p", _assign2({
        className: "kxi-tooltip-overflow-text",
        color: item.disabled ? 'disabled' : undefined
      }, {
        children: item.title
      }), void 0) : jsxRuntime_1(ToolTipOverflowText, {
        disabled: item.disabled,
        title: item.title,
        text: item.tooltip,
        style: {
          position: 'relative'
        },
        tooltip: {
          text: item.title,
          direction: ttDirectTextOverflow
        },
        spaceOnRight: 72,
        willAccountForIcon: willAccountForIcon
      }, void 0)
    }, void 0);
  };

  useEffect(function () {
    setAvailable(availableItems.length);
    setSelected(selectedItems.length);

    if (availableLoader.current) {
      availableLoader.current.resetloadMoreItemsCache();
    }

    if (selectedLoader.current) {
      selectedLoader.current.resetloadMoreItemsCache();
    }
  }, [availableItems, selectedItems]);

  var AvailableRow = function AvailableRow(_a) {
    var index = _a.index,
        style = _a.style;
    var item = queryItems[index];
    return jsxRuntime_2(motion.div, _assign2({
      className: "kxi-picker-list-item-available",
      style: _assign2({
        cursor: item.disabled ? 'auto' : 'pointer'
      }, style),
      onClick: function onClick() {
        return moveOne(true, item.id);
      },
      tabIndex: index + tabIndexStart + 2,
      onKeyDown: function onKeyDown(e) {
        if (e.keyCode === 13 || e.keyCode === 32) {
          moveOne(true, item.id);
        }
      },
      animate: true
    }, {
      children: [item.component || getTTOverflow(item, index), jsxRuntime_1("div", _assign2({
        className: "kxi-picker-button",
        tabIndex: -1
      }, {
        children: jsxRuntime_1(DefaultButton, {
          disabled: item.disabled || false,
          hasShadows: true,
          text: (localization === null || localization === void 0 ? void 0 : localization.addButton) || defaultText.addButton,
          onClick: function onClick(e) {
            e.stopPropagation();
            moveOne(true, item.id);
          },
          buttonSize: "small",
          fill: "fill",
          color: "orca",
          tabIndex: -1
        }, void 0)
      }), void 0)]
    }), "LRPicker_Available_Item_" + item.id);
  };

  var getAvailableList = function getAvailableList() {
    if (availableLoaderSettings) {
      var isItemLoaded = availableLoaderSettings.isItemLoaded,
          itemCount = availableLoaderSettings.itemCount,
          loadMoreItems = availableLoaderSettings.loadMoreItems,
          threshold = availableLoaderSettings.threshold,
          minimumBatchSize = availableLoaderSettings.minimumBatchSize;
      return jsxRuntime_1(InfiniteLoader, _assign2({
        ref: availableLoader,
        isItemLoaded: isItemLoaded,
        itemCount: itemCount,
        loadMoreItems: loadMoreItems,
        threshold: threshold,
        minimumBatchSize: minimumBatchSize
      }, {
        children: function children(_a) {
          var onItemsRendered = _a.onItemsRendered,
              ref = _a.ref;
          return jsxRuntime_1(FixedSizeList, _assign2({
            height: availableFixedListHeight,
            itemCount: queryItems.length,
            itemSize: 36,
            width: "100%",
            onItemsRendered: onItemsRendered,
            ref: ref
          }, {
            children: AvailableRow
          }), void 0);
        }
      }), void 0);
    } else {
      return jsxRuntime_1(FixedSizeList, _assign2({
        height: availableFixedListHeight,
        itemCount: queryItems.length,
        itemSize: 36,
        width: "100%"
      }, {
        children: AvailableRow
      }), void 0);
    }
  };

  var getSelectedList = function getSelectedList() {
    if (selectedIComponents && selectedIComponents.length > selectedItemsThreshold) {
      if (selectedLoaderSettings) {
        var isItemLoaded = selectedLoaderSettings.isItemLoaded,
            itemCount = selectedLoaderSettings.itemCount,
            loadMoreItems = selectedLoaderSettings.loadMoreItems,
            threshold = selectedLoaderSettings.threshold,
            minimumBatchSize = selectedLoaderSettings.minimumBatchSize;
        return jsxRuntime_1(InfiniteLoader, _assign2({
          ref: selectedLoader,
          isItemLoaded: isItemLoaded,
          itemCount: itemCount,
          loadMoreItems: loadMoreItems,
          threshold: threshold,
          minimumBatchSize: minimumBatchSize
        }, {
          children: function children(_a) {
            var onItemsRendered = _a.onItemsRendered,
                ref = _a.ref;
            return jsxRuntime_1(FixedSizeList, _assign2({
              height: selectedFixedListHeight,
              itemCount: selectedItems.length,
              itemSize: 36,
              width: "100%",
              onItemsRendered: onItemsRendered,
              ref: ref
            }, {
              children: SelectedRow
            }), void 0);
          }
        }), void 0);
      } else {
        return jsxRuntime_1(FixedSizeList, _assign2({
          height: selectedFixedListHeight,
          itemCount: selectedItems.length,
          itemSize: 36,
          width: "100%"
        }, {
          children: SelectedRow
        }), void 0);
      }
    } else {
      var items_1 = query && query !== '' ? selectedQueryItems : selectedItems;
      return items_1.map(function (item) {
        var index = items_1.indexOf(item);
        var ttDirectDisabled = items_1.length > 4 && index > items_1.length - 3 ? 1 : 5;
        return jsxRuntime_1(DraggableItem, {
          draggable: dragAndDropEnabled && !(query && query !== ''),
          moveItem: moveItem,
          localization: localization,
          index: index,
          item: item,
          moveOne: moveOne,
          dragEnd: dragEnd,
          ttDirectDisabled: ttDirectDisabled,
          getTTOverflow: getTTOverflow,
          tabIndexStart: tabIndexStart + 2
        }, "LRPicker_Selected_Item_" + item.id);
      });
    }
  };

  var SelectedRow = function SelectedRow(_a) {
    var index = _a.index,
        style = _a.style;
    var item = selectedItems[index];
    var ttDirectDisabled = selectedItems.length > 4 && index > selectedItems.length - 3 ? 1 : 5;
    return jsxRuntime_1(DraggableItem, {
      draggable: false,
      localization: localization,
      index: index,
      item: item,
      moveOne: moveOne,
      ttDirectDisabled: ttDirectDisabled,
      getTTOverflow: getTTOverflow,
      style: style,
      tabIndexStart: tabIndexStart + 2
    }, "LRPicker_Selected_Item_" + item.id);
  }; // used for searching entire available list, with search queries


  useEffect(function () {
    var tempResultCount = 0;
    var tempSelectedResultsCount = 0;
    var itemsMatchingQuery = [];
    var selectedItemsMatchingQuery = [];

    if (query !== '') {
      availableItems.forEach(function (item) {
        // avoided using another array for O(n) search time
        var searchTags = item.searchTags ? __spreadArray(__spreadArray([], __read(item.searchTags)), [item.title]).join(' ') : item.title;

        if (searchTags.toLowerCase().includes(query.toLowerCase())) {
          tempResultCount++;
          itemsMatchingQuery.push(item);
        }
      });
      selectedItems.forEach(function (item) {
        var searchTags = item.searchTags ? __spreadArray(__spreadArray([], __read(item.searchTags)), [item.title]).join(' ') : item.title;

        if (searchTags.toLowerCase().includes(query.toLowerCase())) {
          tempSelectedResultsCount++;
          selectedItemsMatchingQuery.push(item);
        }
      });
    } else {
      itemsMatchingQuery = availableItems;
      tempResultCount = availableItems.length;
      selectedItemsMatchingQuery = selectedItems;
      tempSelectedResultsCount = selectedItems.length;
    }

    setQueryItems(itemsMatchingQuery);
    setResultCount(tempResultCount);
    setSelectedQueryItems(selectedItemsMatchingQuery);
    setSelectedResultCount(tempSelectedResultsCount);
  }, [query, availableItems]);
  return jsxRuntime_2("div", _assign2({
    className: "kxi-picker kxi-neutral " + (className || '')
  }, ingredients, {
    ref: ref || innerWrapper
  }, {
    children: [title ? jsxRuntime_1("p", _assign2({
      className: "kxi-picker-text",
      ref: textWrapper
    }, {
      children: title
    }), void 0) : null, jsxRuntime_2("div", _assign2({
      className: "kxi-picker-content"
    }, {
      children: [jsxRuntime_1("div", _assign2({
        className: "kxi-picker-search"
      }, {
        children: jsxRuntime_1(SearchBox, {
          onCancelClick: function onCancelClick() {
            return setQuery('');
          },
          onChangeOverride: setQuery,
          placeholder: (localization === null || localization === void 0 ? void 0 : localization.searchPlaceholder) || defaultText.searchPlaceholder,
          hasOutline: false
        }, void 0)
      }), void 0), jsxRuntime_2("div", _assign2({
        className: "kxi-picker-header-container"
      }, {
        children: [jsxRuntime_2("div", _assign2({
          className: "kxi-picker-header"
        }, {
          children: [jsxRuntime_1("p", _assign2({
            className: "kxi-picker-header-text"
          }, {
            children: query !== '' && resultCount !== available ? resultCount + " " + ((localization === null || localization === void 0 ? void 0 : localization.results) || defaultText.results) : available + " " + ((localization === null || localization === void 0 ? void 0 : localization.available) || defaultText.available)
          }), void 0), jsxRuntime_1(DefaultButton, {
            text: (localization === null || localization === void 0 ? void 0 : localization.addAll) || defaultText.addAll,
            onClick: function onClick() {
              return moveAll(true);
            },
            buttonSize: "small",
            fill: "fill",
            color: "orca",
            tabIndex: tabIndexStart
          }, void 0)]
        }), void 0), jsxRuntime_2("div", _assign2({
          className: "kxi-picker-header"
        }, {
          children: [jsxRuntime_1("p", _assign2({
            className: "kxi-picker-header-text"
          }, {
            children: query !== '' && selectedResultCount !== selected ? selectedResultCount + " " + ((localization === null || localization === void 0 ? void 0 : localization.results) || defaultText.results) : selected + " " + ((localization === null || localization === void 0 ? void 0 : localization.selected) || defaultText.selected)
          }), void 0), jsxRuntime_1(DefaultButton, {
            text: (localization === null || localization === void 0 ? void 0 : localization.removeAll) || defaultText.removeAll,
            onClick: function onClick() {
              return moveAll(false);
            },
            buttonSize: "small",
            fill: "fill",
            color: "orca",
            tabIndex: tabIndexStart + 1
          }, void 0)]
        }), void 0)]
      }), void 0), jsxRuntime_2("div", _assign2({
        className: "kxi-picker-items-wrapper"
      }, {
        children: [jsxRuntime_1("div", _assign2({
          className: "kxi-picker-items"
        }, {
          children: jsxRuntime_1(ReactResizeDetector, _assign2({
            onResize: function onResize(_width, height) {
              return setAvailableFixedListHeight(height !== null && height !== void 0 ? height : 0);
            }
          }, {
            children: jsxRuntime_1("div", _assign2({
              className: "kxi-picker-items-inner",
              ref: leftWrapper
            }, {
              children: getAvailableList()
            }), void 0)
          }), void 0)
        }), void 0), jsxRuntime_1("div", _assign2({
          className: "kxi-picker-items"
        }, {
          children: jsxRuntime_1(ReactResizeDetector, _assign2({
            onResize: function onResize(_width, height) {
              return setSelectedFixedListHeight(height !== null && height !== void 0 ? height : 0);
            }
          }, {
            children: jsxRuntime_1("div", _assign2({
              className: "kxi-picker-items-inner",
              ref: rightWrapper
            }, {
              children: getSelectedList()
            }), void 0)
          }), void 0)
        }), void 0)]
      }), void 0)]
    }), void 0)]
  }), void 0);
});

var TreePickerOption = function TreePickerOption(props) {
  var color = props.color,
      option = props.option,
      ignoreQuery = props.ignoreQuery,
      collapsed = props.collapsed,
      query = props.query,
      level = props.level,
      selectedIds = props.selectedIds,
      removeSelectedIds = props.removeSelectedIds,
      addSelectedIds = props.addSelectedIds;

  var _a = __read(useState(!!option.id && selectedIds.includes(option.id)), 2),
      checked = _a[0],
      setChecked = _a[1];

  useLayoutEffect(function () {
    if (option.id) setChecked(selectedIds.includes(option.id));
  }, [selectedIds]);

  var onClick = function onClick(e) {
    if (option.id) {
      if (checked) {
        removeSelectedIds([option.id]);
      } else {
        addSelectedIds([option.id]);
      }
    }

    e.stopPropagation();
    e.preventDefault();
  };

  return jsxRuntime_2("div", _assign2({
    className: "kxi-tree-picker-option" + (ignoreQuery && !collapsed ? '' : option.title.includes(query) ? '' : ' kxi-tree-picker-collapsed'),
    style: {
      paddingLeft: 42 + level * 12
    },
    onClick: onClick
  }, {
    children: [option.id && jsxRuntime_1(Checkbox, {
      color: color,
      checked: checked,
      onClick: onClick
    }, void 0), jsxRuntime_1("div", _assign2({
      className: "kxi-text-wrapper"
    }, {
      children: jsxRuntime_1(ToolTipOverflowText, {
        title: option.title,
        tooltip: {
          text: option.title
        },
        spaceOnRight: 36,
        boldedText: query
      }, void 0)
    }), void 0)]
  }), void 0);
};

var TreePickerItem = function TreePickerItem(props) {
  var category = props.category,
      color = props.color,
      hasGreyBackground = props.hasGreyBackground,
      level = props.level,
      containsQuery = props.containsQuery,
      query = props.query,
      parentSelectedIds = props.parentSelectedIds,
      addToParentIds = props.addToParentIds,
      forceSelectAll = props.forceSelectAll,
      removeFromParentIds = props.removeFromParentIds,
      updateForceSelectAll = props.updateForceSelectAll,
      setPickerIds = props.setPickerIds;

  var _a = __read(useState(query), 2),
      internalQuery = _a[0],
      setInternalQuery = _a[1];

  var _b = __read(useState(false), 2),
      collapsed = _b[0],
      setCollapsed = _b[1];

  var _c = __read(useState(false), 2),
      ignoreQuery = _c[0],
      setIgnoreQuery = _c[1];

  var _d = __read(useState(true), 2),
      firstIgnoredQuery = _d[0],
      setFirstIgnoredQuery = _d[1];

  var _e = __read(useState([]), 2),
      selectedIds = _e[0],
      setSelectedIds = _e[1];

  var _f = __read(useState(forceSelectAll), 2),
      forceSelect = _f[0],
      setForceSelect = _f[1];

  var _g = __read(useState(false), 2),
      indeterminateChecked = _g[0],
      setIndeterminateChecked = _g[1];

  useEffect(function () {
    setIndeterminateChecked(selectedIds.length > 0);
  }, [selectedIds]);
  useEffect(function () {
    setInternalQuery(query);
    if (collapsed) setCollapsed(false);
    setIgnoreQuery(false);
    setFirstIgnoredQuery(true);
  }, [query]);
  useEffect(function () {
    var selected = __spreadArray([], __read(category.options.filter(function (x) {
      return x.title.includes(internalQuery);
    }).map(function (x) {
      return x.id || '';
    })));

    setForceSelect(forceSelectAll);

    if (forceSelectAll || forceSelectAll === undefined && forceSelect) {
      addSelectedIds(selected);
      if (addToParentIds) addToParentIds(selected);
      setForceSelect(forceSelectAll);
      if (updateForceSelectAll) updateForceSelectAll(null);else setForceSelect(null);
    } else if (forceSelectAll === false || forceSelectAll === undefined && forceSelect === false) {
      removeSelectedIds(selected);
      setSelectedIds([]);
    }
  }, [forceSelectAll, forceSelect]);

  var addSelectedIds = function addSelectedIds(ids) {
    setSelectedIds(function (previousState) {
      return __spreadArray(__spreadArray([], __read(previousState.filter(function (x) {
        return !ids.includes(x);
      }))), __read(ids));
    });
    setPickerIds(function (previousState) {
      return __spreadArray(__spreadArray([], __read(previousState.filter(function (x) {
        return !ids.includes(x);
      }))), __read(ids));
    });
    if (addToParentIds) addToParentIds(ids);
  };

  var removeSelectedIds = function removeSelectedIds(ids) {
    setSelectedIds(function (previousState) {
      return previousState.filter(function (x) {
        return !ids.includes(x);
      });
    });
    setPickerIds(function (previousState) {
      return previousState.filter(function (x) {
        return !ids.includes(x);
      });
    });
    if (removeFromParentIds) removeFromParentIds(ids);
  };

  var getChildrenLength = function getChildrenLength(cat) {
    var length = 0;
    if (cat.subcategories && cat.subcategories.length > 0) cat.subcategories.forEach(function (subCat) {
      return length += getChildrenLength(subCat);
    });
    length += cat.options.length;
    return length;
  };

  var onTitleClick = function onTitleClick(e) {
    var getLengthOfOptions = function getLengthOfOptions(cat, withQuery) {
      var returnNum = cat.options.filter(function (x) {
        return x.title.includes(internalQuery);
      }).length;

      if (cat.subcategories) {
        cat.subcategories.forEach(function (subCat) {
          returnNum += getLengthOfOptions(subCat);
        });
      }

      return returnNum;
    };

    var areAllSelected = selectedIds.length === getLengthOfOptions(category);
    var areAllQuerySelected = selectedIds.length === getLengthOfOptions(category);

    if (areAllSelected || areAllQuerySelected) {
      setForceSelect(false);
    } else {
      setForceSelect(true);
    }

    if (parentSelectedIds && addToParentIds && removeFromParentIds) {
      areAllSelected ? removeFromParentIds(category.options.map(function (y) {
        return y.id || '';
      })) : addToParentIds(category.options.map(function (x) {
        return x.id || '';
      }));
    }

    e.stopPropagation();
    e.preventDefault();
  };

  var hasItemsHidden = function hasItemsHidden(cat) {
    if (internalQuery === '') return false;
    if (cat.options.filter(function (x) {
      return x.title.includes(internalQuery);
    }).length !== cat.options.length) return true;

    if (cat.subcategories && cat.subcategories.length > 0) {
      if (cat.subcategories.find(function (subcat) {
        return hasItemsHidden(subcat);
      })) {
        return true;
      }
    }

    return false;
  };

  return jsxRuntime_2("div", _assign2({
    className: "kxi-tree-picker-item kxi-grey " + (hasGreyBackground ? 'kxi-active' : '')
  }, {
    children: [jsxRuntime_2("div", _assign2({
      className: "kxi-tree-picker-option" + (containsQuery(category) || category.title.includes(internalQuery) ? '' : ' kxi-tree-picker-collapsed'),
      style: {
        paddingLeft: 6 + level * 12
      },
      onClick: onTitleClick
    }, {
      children: [jsxRuntime_1(XIIcon, {
        icon: collapsed || hasItemsHidden(category) ? 'tree_picker_expand' : 'tree_picker_collapse',
        onClick: function onClick(e) {
          if (internalQuery === '') {
            setCollapsed(!collapsed);
          } else {
            if (firstIgnoredQuery) {
              setIgnoreQuery(true);
              setFirstIgnoredQuery(false);
              setCollapsed(false);
              setInternalQuery('');
            } else {
              setCollapsed(!collapsed);
            }
          }

          e.stopPropagation();
        }
      }, void 0), jsxRuntime_1(Checkbox, {
        color: color,
        isIndeterminate: selectedIds.length !== getChildrenLength(category),
        checked: indeterminateChecked,
        onClick: function onClick(e) {
          setIndeterminateChecked(selectedIds.length > 0);
          setForceSelect(true);
          e.stopPropagation();
        }
      }, void 0), jsxRuntime_1("div", _assign2({
        className: "kxi-text-wrapper"
      }, {
        children: jsxRuntime_1(ToolTipOverflowText, {
          title: category.title,
          tooltip: {
            text: category.title
          },
          spaceOnRight: 48,
          boldedText: internalQuery
        }, void 0)
      }), void 0)]
    }), void 0), jsxRuntime_2("div", _assign2({
      className: collapsed ? 'kxi-tree-picker-collapsed' : undefined
    }, {
      children: [category.options.map(function (option, i) {
        return jsxRuntime_1(TreePickerOption, {
          option: option,
          color: color,
          ignoreQuery: ignoreQuery,
          query: internalQuery,
          collapsed: collapsed,
          level: level,
          selectedIds: selectedIds,
          addSelectedIds: addSelectedIds,
          removeSelectedIds: removeSelectedIds
        }, "cat_" + category.id + "_opt_" + option.id + "_" + i);
      }), category.subcategories && category.subcategories.map(function (cat, i) {
        return jsxRuntime_1(TreePickerItem, {
          category: cat,
          hasGreyBackground: hasGreyBackground,
          color: color,
          level: level + 1,
          containsQuery: containsQuery,
          query: internalQuery,
          addToParentIds: addSelectedIds,
          removeFromParentIds: removeSelectedIds,
          parentSelectedIds: selectedIds,
          forceSelectAll: forceSelect,
          updateForceSelectAll: setForceSelect,
          setPickerIds: setPickerIds
        }, "cat_" + category.id + "subcat_" + cat.id + "_" + i);
      })]
    }), void 0)]
  }), void 0);
};

var TreePickerProps = function (_super) {
  __extends(TreePickerProps, _super);

  function TreePickerProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Array)], TreePickerProps.prototype, "categories");

  __decorate([Bound(), __metadata("design:type", String)], TreePickerProps.prototype, "color");

  __decorate([Bound(), __metadata("design:type", Boolean)], TreePickerProps.prototype, "stretch");

  return TreePickerProps;
}(DivHTMLAttributes);

var TreePickerEvents = function (_super) {
  __extends(TreePickerEvents, _super);

  function TreePickerEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], TreePickerEvents.prototype, "onItemsChanged");

  return TreePickerEvents;
}(DivHTMLEvents);
/**
 * Description: A picker of items sorted by categories.
 */


var TreePicker = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      children = props.children,
      categories = props.categories,
      _a = props.color,
      color = _a === void 0 ? 'CX' : _a,
      _b = props.stretch,
      stretch = _b === void 0 ? false : _b,
      resetTransclusion = props.resetTransclusion,
      hasTranscluded = props.hasTranscluded,
      hasTranscludedContent = props.hasTranscludedContent,
      onItemsChanged = props.onItemsChanged,
      ingredients = __rest(props, ["className", "children", "categories", "color", "stretch", "resetTransclusion", "hasTranscluded", "hasTranscludedContent", "onItemsChanged"]);

  var _c = __read(useState(''), 2),
      query = _c[0],
      setQuery = _c[1];

  var _d = __read(useState(true), 2),
      hasResults = _d[0],
      setHasResults = _d[1];

  var _e = __read(useState(), 2),
      categoriesWithIds = _e[0],
      setCategoriesWithIds = _e[1];

  var _f = __read(useState([]), 2),
      selectedIds = _f[0],
      setSelectedIds = _f[1];

  useEffect(function () {
    throwPropErrorMessage('TreePicker', {
      categories: categories
    });
  }, []);
  useEffect(function () {
    var setIds = function setIds(cats) {
      var returnCats = [];
      cats.forEach(function (cat) {
        var copyCat = _assign2({}, cat);

        var newOptions = [];
        copyCat.options.forEach(function (option) {
          newOptions = option.id ? __spreadArray(__spreadArray([], __read(newOptions)), [option]) : __spreadArray(__spreadArray([], __read(newOptions)), [_assign2(_assign2({}, option), {
            id: uuidv4()
          })]);
        });
        copyCat = _assign2(_assign2({}, copyCat), {
          options: newOptions
        });

        if (copyCat.subcategories && copyCat.subcategories.length > 0) {
          copyCat = _assign2(_assign2({}, copyCat), {
            subcategories: setIds(copyCat.subcategories)
          });
        }

        returnCats = cat.id === undefined ? __spreadArray(__spreadArray([], __read(returnCats)), [_assign2(_assign2({}, copyCat), {
          id: uuidv4()
        })]) : __spreadArray(__spreadArray([], __read(returnCats)), [copyCat]);
      });
      return returnCats;
    };

    setCategoriesWithIds(setIds(categories));
  }, [categories]);
  useEffect(function () {
    setHasResults(query === '' ? true : (categoriesWithIds === null || categoriesWithIds === void 0 ? void 0 : categoriesWithIds.find(function (cat) {
      return containsQuery(cat);
    })) !== undefined);
  }, [query]);
  useEffect(function () {
    if (onItemsChanged) onItemsChanged(selectedIds);
  }, [selectedIds]);

  var containsQuery = function containsQuery(item) {
    if (query === '') return true;
    if (item.title.includes(query)) return true;
    if (item.options.find(function (option) {
      return option.title.includes(query);
    }) !== undefined) return true;

    if (item.subcategories && item.subcategories.length > 0) {
      if (item.subcategories.find(function (subcategory) {
        return containsQuery(subcategory);
      }) !== undefined) return true;
    }

    return false;
  };

  return jsxRuntime_2("div", _assign2({}, ingredients, {
    className: "kxi-tree-picker" + (stretch ? ' kxi-stretch' : '') + " " + (className || ''),
    ref: ref
  }, {
    children: [jsxRuntime_1("div", _assign2({
      className: "kxi-search"
    }, {
      children: jsxRuntime_1(SearchBox, {
        hasOutline: false,
        stretch: true,
        onChange: function onChange(e) {
          return setQuery(e.target.value);
        },
        onCancelClick: function onCancelClick() {
          return setQuery('');
        }
      }, void 0)
    }), void 0), jsxRuntime_2("div", _assign2({
      className: "kxi-tree-picker-content"
    }, {
      children: [categoriesWithIds && categoriesWithIds.map(function (cat, index) {
        return jsxRuntime_1(TreePickerItem, {
          category: cat,
          color: color,
          hasGreyBackground: index % 2 === 0,
          level: 0,
          query: query,
          containsQuery: containsQuery,
          setPickerIds: setSelectedIds,
          parentSelectedIds: selectedIds
        }, "tree_picker_" + cat.id + "_" + index);
      }), jsxRuntime_1("div", _assign2({
        style: {
          display: hasResults ? 'none' : 'block'
        },
        className: "kxi-grey kxi-no-results" + (stretch ? ' kxi-stretch' : '')
      }, {
        children: children ? children : jsxRuntime_1(Slot, {
          propsToWatch: [],
          resetTransclusion: resetTransclusion,
          hasTranscluded: hasTranscluded,
          hasTranscludedContent: hasTranscludedContent,
          "data-testid": "slot",
          name: "children"
        }, void 0)
      }), void 0)]
    }), void 0)]
  }), void 0);
});
var _CalendarOutlinesOptions = ['shadow', 'border', 'none'];
var _CalendarModesOptions = ['relative', 'fixed'];

var RadioProps = function (_super) {
  __extends(RadioProps, _super);

  function RadioProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Boolean)], RadioProps.prototype, "checked");

  __decorate([Bound(), __metadata("design:type", String)], RadioProps.prototype, "color");

  __decorate([Bound(), __metadata("design:type", String)], RadioProps.prototype, "contrast");

  __decorate([Bound(), __metadata("design:type", String)], RadioProps.prototype, "inputId");

  __decorate([Bound(), __metadata("design:type", String)], RadioProps.prototype, "label");

  __decorate([Bound(), __metadata("design:type", Boolean)], RadioProps.prototype, "isLabelLeft");

  __decorate([Bound(), __metadata("design:type", Object)], RadioProps.prototype, "status");

  return RadioProps;
}(ObservablePropsMixin(InputHTMLAttributes));

var RadioEvents = function (_super) {
  __extends(RadioEvents, _super);

  function RadioEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return RadioEvents;
}(InputHTMLEvents);
/**
 * Description: Standard InMoment branded Radio button, works the same as an HTML radio button.
 */


var Radio = /*#__PURE__*/forwardRef(function (props, ref) {
  var radioEl = useRef();

  var _a = props.color,
      color = _a === void 0 ? 'orca' : _a,
      _b = props.contrast,
      contrast = _b === void 0 ? 'normal' : _b,
      disabled = props.disabled,
      label = props.label,
      isLabelLeft = props.isLabelLeft,
      _c = props.tabIndex,
      tabIndex = _c === void 0 ? 0 : _c,
      inputId = props.inputId,
      id = props.id,
      internalProps = props.internalProps,
      status = props.status,
      checked = props.checked,
      observer = props.observer,
      name = props.name,
      _onChange = props.onChange,
      _onClick = props.onClick,
      ingredients = __rest(props, ["color", "contrast", "disabled", "label", "isLabelLeft", "tabIndex", "inputId", "id", "internalProps", "status", "checked", "observer", "name", "onChange", "onClick"]);

  var wrapper = (internalProps || {}).wrapper;

  var _d = __read(useState(uuidv4()), 2),
      finalInputId = _d[0],
      setFinalInputId = _d[1];

  var _e = __read(useState(new Event('deselect')), 1),
      event = _e[0];

  useEffect(function () {
    var el = document === null || document === void 0 ? void 0 : document.getElementById(finalInputId);

    if (el && checked !== undefined) {
      el.checked = checked;
    }

    var runDeselect = function runDeselect(e) {
      if (observer) {
        observer.checked = e.target.checked;
      }
    };

    el.addEventListener('deselect', runDeselect, false);
    return function () {
      return el.removeEventListener('deselect', runDeselect);
    };
  }, [checked, finalInputId]);
  useEffect(function () {
    var finalInputId;
    if (inputId && ("" + inputId).trim() !== '') finalInputId = ("" + inputId).trim();else if (id && ("" + id).trim() !== '') finalInputId = ("" + id).trim();else finalInputId = uuidv4() + "-input";
    setFinalInputId(finalInputId);
  }, [id, inputId]);
  var wrapperClasses = 'kxi-radio-wrapper';
  var labelClasses = 'kxi-radio-label orca';
  var radioClasses = 'kxi-radio kxi-border';
  wrapperClasses += isLabelLeft ? ' kxi-label-left' : '';

  if (disabled) {
    if (contrast !== 'high') {
      labelClasses += ' disabled';
    }

    radioClasses += ' disabled';
  } else if (status) {
    radioClasses += " kxi-" + status;
  } else {
    radioClasses += " " + normalizeColor(color);
  }

  if (contrast === 'high') {
    labelClasses += ' kxi-high-contrast';
    radioClasses += ' kxi-high-contrast';
  }

  return jsxRuntime_2("div", _assign2({
    className: wrapperClasses
  }, wrapper, {
    "data-testid": includeTestId('radio-wrapper')
  }, {
    children: [label && jsxRuntime_1("label", _assign2({
      id: "label-" + finalInputId,
      htmlFor: finalInputId,
      className: labelClasses,
      "data-testid": includeTestId('radio-label')
    }, {
      children: label
    }), void 0), jsxRuntime_1("input", _assign2({
      "data-testid": includeTestId('radio'),
      className: radioClasses,
      disabled: disabled,
      id: finalInputId,
      type: "radio",
      tabIndex: tabIndex,
      ref: mergeRefs([radioEl, ref]),
      name: name
    }, ingredients, {
      onChange: function onChange(e) {
        if (observer) {
          observer.checked = e.target.checked;
        }

        if (_onChange) {
          _onChange(e);
        }
      },
      onClick: function onClick(e) {
        var radios = document.querySelectorAll('input[type=radio]');
        radios.forEach(function (radio) {
          if (!radio.checked && radio.name === name && radio.id !== finalInputId) {
            radio.dispatchEvent(event);
          }
        });
        if (_onClick) _onClick(e);
      }
    }), void 0)]
  }), void 0);
});

var ToggleSwitchProps = function (_super) {
  __extends(ToggleSwitchProps, _super);

  function ToggleSwitchProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], ToggleSwitchProps.prototype, "color");

  __decorate([Bound(), __metadata("design:type", Boolean)], ToggleSwitchProps.prototype, "isToggled");

  __decorate([Bound(), __metadata("design:type", String)], ToggleSwitchProps.prototype, "contrast");

  __decorate([Bound(), __metadata("design:type", Boolean)], ToggleSwitchProps.prototype, "stretch");

  __decorate([Bound(), __metadata("design:type", String)], ToggleSwitchProps.prototype, "label");

  __decorate([Bound(), __metadata("design:type", Boolean)], ToggleSwitchProps.prototype, "isLabelInline");

  __decorate([Bound(), __metadata("design:type", Boolean)], ToggleSwitchProps.prototype, "isLabelLeft");

  __decorate([Bound(), __metadata("design:type", Object)], ToggleSwitchProps.prototype, "status");

  return ToggleSwitchProps;
}(ObservablePropsMixin(ButtonHTMLAttributes));

var ToggleSwitchEvents = function (_super) {
  __extends(ToggleSwitchEvents, _super);

  function ToggleSwitchEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], ToggleSwitchEvents.prototype, "onToggle");

  return ToggleSwitchEvents;
}(ButtonHTMLEvents);
/**
 * Description: Classic InMoment branded ToggleSwitch.
 */


var ToggleSwitch = /*#__PURE__*/forwardRef(function (props, ref) {
  var _a = props.color,
      color = _a === void 0 ? 'orca' : _a,
      className = props.className,
      isToggled = props.isToggled,
      disabled = props.disabled,
      style = props.style,
      onToggle = props.onToggle,
      status = props.status,
      label = props.label,
      _b = props.isLabelInline,
      isLabelInline = _b === void 0 ? true : _b,
      isLabelLeft = props.isLabelLeft,
      _c = props.contrast,
      contrast = _c === void 0 ? 'normal' : _c,
      stretch = props.stretch,
      observer = props.observer,
      _d = props.id,
      id = _d === void 0 ? uuidv4() : _d,
      ingredients = __rest(props, ["color", "className", "isToggled", "disabled", "style", "onToggle", "status", "label", "isLabelInline", "isLabelLeft", "contrast", "stretch", "observer", "id"]);

  var _e = __read(useState(isToggled), 2),
      on = _e[0],
      setOn = _e[1];

  var _f = __read(useState(2.25), 2),
      width = _f[0],
      setWidth = _f[1];

  var _g = __read(useState(false), 2),
      mouseDown = _g[0],
      setMouseDown = _g[1];

  useLayoutEffect(function () {
    setOn(isToggled);
  }, [isToggled]);

  var handleMouseDown = function handleMouseDown() {
    setWidth(3.375);
    setMouseDown(true);
  };

  var handleMouseUp = function handleMouseUp() {
    setMouseDown(false);
    setWidth(2.25);
    if (observer) observer.isToggled = !on;
    if (onToggle) onToggle(!on);
    setOn(!on);
  };

  var getButtonClasses = function getButtonClasses() {
    var buttonClasses = 'kxi-switch-button kxi-border ';
    buttonClasses += isLabelLeft && isLabelInline ? 'kxi-label-left-inline ' : ' ';
    buttonClasses += !isLabelLeft && isLabelInline ? 'kxi-label-right-inline ' : ' ';
    buttonClasses += status && contrast !== 'high' ? "kxi-" + status + " " : ' ';
    return buttonClasses;
  };

  var getLabelClasses = function getLabelClasses() {
    var labelClasses = '';
    labelClasses += contrast === 'high' ? 'kxi-high-contrast ' : '';
    labelClasses += isLabelInline ? 'kxi-label-inline ' : ' ';
    labelClasses += isLabelLeft ? ' ' : 'label-right ';
    labelClasses += stretch ? 'kxi-stretch-width ' : ' ';
    return labelClasses;
  };

  var getSwitchClasses = function getSwitchClasses() {
    var switchClasses = 'kxi-switch-handle ';
    switchClasses += status ? "kxi-switch-status kxi-" + status + " " : ' ';
    switchClasses += !on ? 'kxi-switch-off ' : ' ';
    switchClasses += contrast === 'high' ? 'kxi-high-contrast ' : '';
    return switchClasses;
  };

  var getTextClasses = function getTextClasses() {
    var textClasses = '';
    textClasses += status ? "kxi-" + status + " " : ' ';
    textClasses += contrast === 'high' && status ? 'kxi-switch-text-status ' : '';
    return textClasses;
  };

  return jsxRuntime_2("div", _assign2({
    "aria-label": "toggle switch",
    "aria-describedby": label || 'on off toggle',
    className: normalizeColor(color) + " " + (className || '') + " kxi-switch " + getLabelClasses()
  }, {
    children: [jsxRuntime_1("label", _assign2({
      htmlFor: id,
      className: "kxi-label " + getLabelClasses()
    }, {
      children: label
    }), void 0), jsxRuntime_1("button", _assign2({
      role: "switch",
      "aria-checked": on,
      "aria-disabled": disabled
    }, ingredients, {
      id: id,
      className: getButtonClasses(),
      style: _assign2({}, style),
      onMouseDown: handleMouseDown,
      onMouseUp: handleMouseUp,
      onMouseLeave: function onMouseLeave() {
        if (mouseDown) setWidth(2.25);
      },
      disabled: disabled,
      ref: ref
    }, {
      children: jsxRuntime_1(motion.div, _assign2({
        transition: {
          duration: 0.1,
          ease: 'easeOut'
        },
        className: getSwitchClasses(),
        style: {
          width: width + "rem"
        }
      }, {
        children: jsxRuntime_1("span", _assign2({
          className: getTextClasses()
        }, {
          children: on ? 'ON' : 'OFF'
        }), void 0)
      }), void 0)
    }), void 0)]
  }), void 0);
});
var _OnOffOptions = ['on', 'off'];
var _SideOptions = ['left', 'right'];

var TableProps = function (_super) {
  __extends(TableProps, _super);

  function TableProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], TableProps.prototype, "title");

  __decorate([Bound(), __metadata("design:type", String)], TableProps.prototype, "subtitle");

  __decorate([Bound(), __metadata("design:type", Boolean)], TableProps.prototype, "semiboldTitle");

  __decorate([Bound(), __metadata("design:type", Array)], TableProps.prototype, "headerData");

  __decorate([Bound(), __metadata("design:type", Array)], TableProps.prototype, "rowData");

  __decorate([Bound(), __metadata("design:type", Boolean)], TableProps.prototype, "sortable");

  __decorate([Bound(), __metadata("design:type", Number)], TableProps.prototype, "total");

  __decorate([Bound(), __metadata("design:type", Boolean)], TableProps.prototype, "containerView");

  return TableProps;
}(DivHTMLAttributes);

var TableEvents = function (_super) {
  __extends(TableEvents, _super);

  function TableEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], TableEvents.prototype, "onSort");

  return TableEvents;
}(DivHTMLEvents);
/**
 * Description: A standard table component that can display data in a formatted way.
 */


var Table = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      title = props.title,
      subtitle = props.subtitle,
      _a = props.semiboldTitle,
      semiboldTitle = _a === void 0 ? true : _a,
      sortable = props.sortable,
      _b = props.onSort,
      onSort = _b === void 0 ? undefined : _b,
      headerData = props.headerData,
      _c = props.rowData,
      rowData = _c === void 0 ? [] : _c,
      containerView = props.containerView,
      ingredients = __rest(props, ["className", "title", "subtitle", "semiboldTitle", "sortable", "onSort", "headerData", "rowData", "containerView"]);

  var _d = __read(useState(0), 2),
      width = _d[0],
      setWidth = _d[1];

  var _e = __read(useState({
    key: '',
    dir: ''
  }), 2),
      activeSort = _e[0],
      setActiveSort = _e[1];

  var wrapperRef = useRef(null);
  useEffect(function () {
    if (onSort && sortable) onSort(activeSort.key, activeSort.dir);
  }, [activeSort]);

  var changeSort = function changeSort(key) {
    var dir = 'asc';

    if (activeSort && key === activeSort.key) {
      if (activeSort.dir === 'asc') dir = 'desc';else {
        setActiveSort({
          key: '',
          dir: ''
        });
        return;
      }
    }

    setActiveSort({
      key: key,
      dir: dir
    });
  };

  var table = jsxRuntime_1(ReactResizeDetector, _assign2({
    onResize: useCallback(function (width) {
      return setWidth(width);
    }, []),
    handleWidth: true,
    targetRef: wrapperRef,
    refreshMode: "debounce",
    refreshRate: 0
  }, {
    children: jsxRuntime_2("div", _assign2({}, ingredients, {
      className: "kxi-table-wrapper " + (className || ''),
      ref: mergeRefs([wrapperRef, ref])
    }, {
      children: [jsxRuntime_2("div", _assign2({
        className: "kxi-table-header"
      }, {
        children: [title ? jsxRuntime_1("h5", _assign2({
          className: "" + (semiboldTitle ? 'kxi-text-600' : '')
        }, {
          children: title
        }), void 0) : null, subtitle ? jsxRuntime_1("h6", _assign2({
          className: "orca"
        }, {
          children: subtitle
        }), void 0) : null]
      }), void 0), jsxRuntime_2("table", _assign2({
        className: "kxi-table kxi-grey"
      }, {
        children: [jsxRuntime_1("thead", {
          children: jsxRuntime_1("tr", {
            children: headerData.map(function (header) {
              return jsxRuntime_1("td", _assign2({
                className: "" + (onSort && sortable ? 'kxi-table-header-sortable' : ''),
                style: {
                  width: width / headerData.length,
                  background: header.bgColor || '',
                  color: header.textColor || ''
                },
                id: header.id,
                onClick: onSort && sortable ? function () {
                  return changeSort(header.field);
                } : undefined
              }, {
                children: jsxRuntime_2("div", {
                  children: [jsxRuntime_1("span", {
                    children: header.title
                  }, void 0), activeSort.dir && header.field === activeSort.key ? jsxRuntime_1(XIIcon, {
                    style: {
                      color: header.textColor || XIColors.orca.primary
                    },
                    icon: activeSort.dir === 'asc' ? 'sort_order_asc' : 'sort_order_desc',
                    iconSize: 18
                  }, void 0) : jsxRuntime_1("span", {
                    style: {
                      width: 18,
                      height: 18
                    }
                  }, void 0) // styling so the icon doesn't shift the column
                  ]
                }, void 0)
              }), header.id);
            })
          }, void 0)
        }, void 0), jsxRuntime_1("tbody", {
          children: rowData.map(function (row) {
            return jsxRuntime_1("tr", _assign2({
              id: row.id
            }, {
              children: headerData.map(function (header, idx) {
                return jsxRuntime_1("td", _assign2({
                  style: {
                    maxWidth: width / headerData.length
                  }
                }, {
                  children: row[header.field]
                }), row[header.field]);
              })
            }), row.id);
          })
        }, void 0)]
      }), void 0)]
    }), void 0)
  }), void 0);
  return containerView ? jsxRuntime_1(BasicTile, _assign2({
    color: "orca",
    stretch: true,
    padding: 0
  }, {
    children: table
  }), void 0) : table;
});

var ToolTipContentProps = function (_super) {
  __extends(ToolTipContentProps, _super);

  function ToolTipContentProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], ToolTipContentProps.prototype, "text");

  __decorate([Bound(), __metadata("design:type", String)], ToolTipContentProps.prototype, "link");

  __decorate([Bound(), __metadata("design:type", Object)], ToolTipContentProps.prototype, "tooltip");

  __decorate([Bound(), __metadata("design:type", String)], ToolTipContentProps.prototype, "iconSize");

  return ToolTipContentProps;
}(DivHTMLAttributes);

var ToolTipContentEvents = function (_super) {
  __extends(ToolTipContentEvents, _super);

  function ToolTipContentEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return ToolTipContentEvents;
}(DivHTMLEvents);
/**
 * Description: Render this tooltip, and have a convenient informational popup!
 */


var ToolTipContent = /*#__PURE__*/forwardRef(function (props, ref) {
  var text = props.text,
      link = props.link,
      iconSize = props.iconSize,
      tooltip = props.tooltip,
      ingredients = __rest(props, ["text", "link", "iconSize", "tooltip"]);

  var _a = __read(useState(false), 2),
      isOpen = _a[0],
      setIsOpen = _a[1];

  throwPropErrorMessage('ToolTipContent', {
    tooltip: tooltip
  });
  return jsxRuntime_1(ToolTipWrapper, _assign2({}, tooltip, ingredients, {
    ref: ref,
    onOpenChange: setIsOpen
  }, {
    children: text && link ? jsxRuntime_1("a", _assign2({
      className: "kxi-tooltip-link",
      href: link
    }, {
      children: text
    }), void 0) : jsxRuntime_1(XIIcon, {
      iconSize: iconSize,
      icon: tooltip.isOpenOnClick && isOpen ? 'info_filled' : 'info'
    }, void 0)
  }), void 0);
});

var AppTitleBarProps = function (_super) {
  __extends(AppTitleBarProps, _super);

  function AppTitleBarProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", String)], AppTitleBarProps.prototype, "text");

  __decorate([Bound(), __metadata("design:type", String)], AppTitleBarProps.prototype, "color");

  __decorate([Bound(), __metadata("design:type", String)], AppTitleBarProps.prototype, "icon");

  __decorate([Bound(), __metadata("design:type", String)], AppTitleBarProps.prototype, "appIcon");

  __decorate([Bound(), __metadata("design:type", Boolean)], AppTitleBarProps.prototype, "disableButton");

  __decorate([Bound(), __metadata("design:type", Boolean)], AppTitleBarProps.prototype, "isTextButton");

  return AppTitleBarProps;
}(ObservablePropsMixin(DivHTMLAttributes));
/**
 * Description: Previously GradientTopBar, this slick gradient bar can display icons, texts, and anything you want in a cloud-based fashion.
 */


var AppTitleBarEvents = function (_super) {
  __extends(AppTitleBarEvents, _super);

  function AppTitleBarEvents() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Bound(), __metadata("design:type", Function)], AppTitleBarEvents.prototype, "onButtonClick");

  return AppTitleBarEvents;
}(DivHTMLEvents);

var AppTitleBar = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
      color = props.color,
      icon = props.icon,
      text = props.text,
      onButtonClick = props.onButtonClick,
      _a = props.isTextButton,
      isTextButton = _a === void 0 ? true : _a,
      appIcon = props.appIcon,
      style = props.style,
      className = props.className,
      disableButton = props.disableButton,
      hasTranscludedContent = props.hasTranscludedContent,
      hasTranscluded = props.hasTranscluded,
      resetTransclusion = props.resetTransclusion,
      ingredients = __rest(props, ["children", "color", "icon", "text", "onButtonClick", "isTextButton", "appIcon", "style", "className", "disableButton", "hasTranscludedContent", "hasTranscluded", "resetTransclusion"]);

  delete ingredients.transclude;
  var textToDisplay = isTextButton ? jsxRuntime_1(HeadingButton, {
    title: text,
    onClick: onButtonClick,
    color: "white",
    contrast: "high",
    wrap: "nowrap",
    size: 2,
    weight: 300,
    className: "kxi-title-bar-heading " + (icon || appIcon ? '' : 'kxi-title-bar-no-icon'),
    disabled: disableButton
  }, void 0) : jsxRuntime_1("p", _assign2({
    role: "heading",
    className: "kxi-high-contrast kxi-text-large kxi-text-400 kxi-text-wrap-nowrap " + (icon || appIcon ? 'kxi-with-icon' : '')
  }, {
    children: text
  }), void 0);
  return jsxRuntime_2("div", _assign2({
    role: "banner",
    style: _assign2({}, style),
    className: "kxi-title-bar kxi-gradient " + (className || '') + " " + (color ? normalizeColor(color) : '')
  }, ingredients, {
    ref: ref
  }, {
    children: [jsxRuntime_1("div", _assign2({
      className: "kxi-title-wrapper " + (!textToDisplay || !text ? 'no-text' : '')
    }, {
      children: jsxRuntime_2("div", _assign2({
        className: "kxi-title-reserved " + (!textToDisplay || !text ? 'no-text' : '')
      }, {
        children: [(icon || appIcon) && jsxRuntime_2("div", _assign2({
          role: "" + (isTextButton ? 'button' : 'img'),
          className: "kxi-title-bar-icon " + (isTextButton ? 'kxi-pointer' : ''),
          onClick: isTextButton ? onButtonClick : undefined
        }, {
          children: [icon && !appIcon && jsxRuntime_1(XIIcon, {
            icon: icon,
            iconSize: 30,
            contrast: "high"
          }, void 0), appIcon && jsxRuntime_1(XIAppIcon, {
            icon: appIcon,
            iconSize: 30
          }, void 0)]
        }), void 0), text && textToDisplay]
      }), void 0)
    }), void 0), jsxRuntime_1("div", _assign2({
      className: "kxi-child-content " + ((!textToDisplay || !text) && !icon && !appIcon ? 'kxi-no-padding' : '')
    }, {
      children: children ? children : jsxRuntime_1(Slot, {
        propsToWatch: [],
        resetTransclusion: resetTransclusion,
        hasTranscluded: hasTranscluded,
        hasTranscludedContent: hasTranscludedContent,
        name: "children"
      }, void 0)
    }), void 0)]
  }), void 0);
});

var KitchenComponent = function (_super) {
  __extends(KitchenComponent, _super);

  function KitchenComponent() {
    var _this = _super.call(this) || this;

    _this._propKeys = [];
    _this._eventKeys = [];
    /**
     * This function gets all of the names of the `@Bound()` properties for this component.  It traverses the inheritance
     *  tree to make sure it gets everything
     * @param obj: The existing array of named properties
     * @returns: Array of the named properties on this object
     */

    _this.propKeys = function (obj) {
      if (obj === void 0) {
        obj = _this.properties;
      }

      if (_this._propKeys.length !== 0 && obj === _this.properties) {
        return _this._propKeys;
      }

      var proto = obj.__proto__;

      if (proto.constructor.name === 'Object') {
        return _this._propKeys;
      }

      _this._propKeys = __spreadArray([], __read(new Set(__spreadArray(__spreadArray([], __read(_this._propKeys)), __read(Object.keys(proto))))));
      return _this.propKeys(proto);
    };
    /**
     * This function gets all of the names of the `@Bound()` events for this component.  It traverses the inheritance
     *  tree to make sure it gets everything
     * @param obj: The existing array of named events
     * @returns: Array of the named events on this object
     */


    _this.eventKeys = function (obj) {
      if (obj === void 0) {
        obj = _this.events;
      }

      if (_this._eventKeys.length !== 0 && obj === _this.events) {
        return _this._eventKeys;
      }

      var proto = obj.__proto__;

      if (proto.constructor.name === 'Object') {
        return _this._eventKeys;
      }

      _this._eventKeys = __spreadArray([], __read(new Set(__spreadArray(__spreadArray([], __read(_this._eventKeys)), __read(Object.keys(proto))))));
      return _this.eventKeys(proto);
    };

    _this.internalProperties = {};
    _this.observing = false; // Determine if the component has been mounted

    _this.mounted = false; // Determine if the component has transcluded it's content

    _this.hasTranscluded = false; // Set to true if the web component has slotted items it needs to transclude

    _this.canTransclude = false; // Set up the observer to watch if the HTML attributes on the web component are changed

    _this.observer = new MutationObserver(function (changes) {
      var changedAttributes = Array.from(new Set(changes.map(function (c) {
        return c.attributeName || '';
      })));
      var attrInProps = changedAttributes.some(function (c) {
        return _this.propKeys().includes(c);
      }); // If the attribute is a bound attribute, then update the component

      if (attrInProps) {
        _this.update();
      }
    });
    return _this;
  } // Callback for when the web component shows up on the page and is in the dom


  KitchenComponent.prototype.connectedCallback = function () {
    var _this = this;

    this.setupExternalObservableProperties();
    this.propObserver = this.generateObserver(); // wait for page rendering in order to mount only once *after* any pending page actions have executed (i.e. angular views)

    setTimeout(function () {
      _this.mount();

      _this.observer.observe(_this, {
        attributes: true
      }); // This is here to prevent any errors with Angular attempting to apply a style to this root element.
      // Some angular libraries attempt to set a property on the style in javascript and `this.style` is `undefined` at this level


      if (!_this.style) _this.style = {};
    }, 1);
  };

  KitchenComponent.prototype.mount = function () {
    var _this = this;

    var _a;

    this.mounted = true;
    this.initializeTransclusion(); // generate the transclusion props to pass through to the react component.  React can memoize the slot so it does
    //  not over re-render the component

    var transclusionProps = this.canTransclude ? {
      hasTranscludedContent: ((_a = this.transcludedContent) === null || _a === void 0 ? void 0 : _a.length) > 0,
      hasTranscluded: this.hasTranscluded,
      resetTransclusion: function resetTransclusion() {
        _this.hasTranscluded = false;

        _this.cleanupTranscludedContent();
      },
      transclude: function transclude() {
        _this.transcludeContent();
      }
    } : undefined; // Render the react component

    ReactDOM__default.render(jsxRuntime_1(React__default.StrictMode, {
      children: jsxRuntime_1(this.renderer, _assign2({}, _assign2(_assign2({}, _assign2(_assign2({}, this.getProps()), {
        constructor: undefined
      })), transclusionProps)), void 0)
    }, void 0), this); // if we have content to transclude, do that now.

    if (this.canTransclude) {
      this.transcludeContent();
    }
  };

  KitchenComponent.prototype.update = function () {
    this.mount();
  }; // when the component is unloaded from the dom


  KitchenComponent.prototype.disconnectedCallback = function () {
    this.unmount();
    this.observer.disconnect();
  }; // clean up our component


  KitchenComponent.prototype.unmount = function () {
    this.mounted = false;
    this.cleanupTranscludedContent();
    ReactDOM__default.unmountComponentAtNode(this);
  };

  KitchenComponent.prototype.getProps = function () {
    var _this = this;

    var props = {}; // set the observer if the component will allow two-way binding
    // eslint-disable-next-line no-prototype-builtins

    if (this.properties.hasOwnProperty('observer')) {
      // If you are looking here for why the observer isn't set check the observable props mixin
      props.observer = this.propObserver;
    } // initialize all of the property values so we can send them to react


    this.propKeys().forEach(function (attrName) {
      // if the property value is set by JS, grab it
      // eslint-disable-next-line no-prototype-builtins
      if (_this.hasOwnProperty(attrName) && _this[attrName] !== undefined) {
        props[attrName] = _this[attrName];
      } else {
        // if the property value is set through HTML attributes, grab it
        var attribute = _this.attributes.getNamedItem(attrName);

        if (attribute) {
          var value = _this.convertAttributeValue(attribute.value);

          props[attrName] = value;
        }
      }
    }); // initialize the events that will be raised out through the web component
    // all events are routed through here so we can intercept, clean up, and re-raise them as custom events.

    this.eventKeys().forEach(function (key) {
      props[key] = function () {
        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        } // if there is 0 or 1 event argument, just pass it along


        if (args.length === 0 || args.length === 1) {
          _this.dispatchEvent(new CustomEvent(key, {
            detail: args === null || args === void 0 ? void 0 : args[0]
          }));
        } else {
          var params_1 = _this["__" + key + "Params__"]; // if the web component has named values for the event parameters, use those

          if (params_1) {
            var mappedArgs = args.reduce(function (accum, cur, i) {
              var _a;

              return _assign2(_assign2({}, accum), (_a = {}, _a[params_1[i]] = cur, _a));
            }, {});

            _this.dispatchEvent(new CustomEvent(key, {
              detail: mappedArgs
            }));
          } else {
            // otherwise, pass them back as an array.
            _this.dispatchEvent(new CustomEvent(key, {
              detail: args
            }));
          }
        }
      };
    }); // If the app attempts to send in styling as a string, remove it.  React will not accept this.
    // we can probably do something to try and map this to an object at some point.

    if (props['style'] && typeof props['style'] === 'string') {
      devOnlyWarn("You have attempted to set the style as a string: " + props['style'] + " on " + this.tagName + ".  This property will not be passed through to the component.");
      delete props['style'];
    }

    return props;
  };
  /**
   * For every property that we have on this component, set up a listener so if the value changes, we can update
   *  the component
   */


  KitchenComponent.prototype.setupExternalObservableProperties = function () {
    var _this = this;

    this.propKeys().forEach(function (attrName) {
      // eslint-disable-next-line no-prototype-builtins
      if (!_this.hasOwnProperty(attrName)) {
        Object.defineProperty(_this, attrName, {
          get: function get() {
            return _this.internalProperties[attrName];
          },
          set: function set(val) {
            if (_this.internalProperties[attrName] !== val) {
              _this.internalProperties[attrName] = val;

              if ((!_this.observing || _this.remountOnObservedChange) && _this.mounted) {
                _this.update();
              }
            }
          }
        });
      }
    });
  };
  /**
   * convert the HTML attribute string value to it's actual value.
   */


  KitchenComponent.prototype.convertAttributeValue = function (value) {
    if (value === 'true' || value === 'false') {
      value = value === 'true';
    } else if (!isNaN(value) && value !== '') {
      value = +value;
    } else if (/^{.*}/.exec(value)) {
      value = JSON.parse(value);
    }

    return value;
  };
  /**
   * Find all of the immediate children elements with a `slot` attribute so we can grab references to them
   * The Render will remove them
   */


  KitchenComponent.prototype.initializeTransclusion = function () {
    var _a, _b; // if we have child nodes, but we have not gotten the transcluded content references yet


    if (this.childNodes && this.childNodes.length > 0 && !this.transcludedContent) {
      this.transcludedContent = [];

      for (var x = 0; x < this.childNodes.length; x++) {
        var node = this.childNodes.item(x); // grab the child if it has a `slot` attribute

        if ((_b = (_a = node.firstChild) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.hasAttribute('slot')) {
          this.canTransclude = true;
          this.transcludedContent.push(node);
        }
      }
    }
  };
  /**
   * Transclude the content for this component
   */


  KitchenComponent.prototype.transcludeContent = function () {
    var _this = this;

    var _a, _b; // if we have content to transclude


    if (this.transcludedContent.length > 0) {
      // if we have already transcluded, or the component has no slots, bail out here
      if (this.hasTranscluded || this.querySelectorAll('slot').length === 0 && !this.hasReactPortal) {
        return;
      } // mark as having been transcluded


      this.hasTranscluded = true; // see if we don't want this to be managed by the kitchen component
      // I don't recall why I added this, but this will prevent the preTranscludeContent from being ran.

      var unmanaged = this.hasAttribute('unmanaged');

      if (this.preTranscludeContent && !unmanaged) {
        // run the preTranscludeContent and get the cleanup function
        this.transcludeCleanup = this.preTranscludeContent(this, this.getProps(), this.transcludedContent); // set up an observer so we know if the children have changed

        this.transcludeObserver = new MutationObserver(function () {
          if (_this.transcludeCleanup) {
            _this.transcludeCleanup();
          }

          _this.transcludeCleanup = _this.preTranscludeContent(_this, _this.getProps(), _this.transcludedContent);
        });
        this.transcludeObserver.observe(this.transcludedContent[0], {
          childList: true
        });
      } // for each of our items that have a `slot` attribute, put them in the correct slot


      for (var x = 0; x < this.transcludedContent.length; x++) {
        var node = this.transcludedContent[x];

        if ((_b = (_a = node.firstChild) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.hasAttribute('slot')) {
          var slotName = node.firstChild.parentElement.getAttribute('slot');
          var parentElement = this.hasReactPortal ? document.querySelector("#kxi-" + this.tagName.toLowerCase()) : this;
          var slot = parentElement === null || parentElement === void 0 ? void 0 : parentElement.querySelector("slot[name=" + slotName + "]");
          if (slot) slot.appendChild(node);
        }
      } // if we're removing empty slots, remove them now.


      if (this.removeEmptySlots) {
        var emptySlots = this.querySelectorAll("slot:empty");
        emptySlots.forEach(function (slot) {
          var _a; // eslint-disable-next-line no-unused-expressions


          (_a = slot.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(slot);
        });
      }
    }
  };
  /**
   * Clean up the component and it's transcluded content
   */


  KitchenComponent.prototype.cleanupTranscludedContent = function () {
    if (this.transcludeCleanup) {
      this.transcludeCleanup();
    }

    if (this.transcludeObserver) {
      this.transcludeObserver.disconnect();
    }
  };
  /**
   * Generate the observer prop
   */


  KitchenComponent.prototype.generateObserver = function () {
    var _this = this;

    var observer = {};
    this.propKeys().forEach(function (attrName) {
      Object.defineProperty(observer, attrName, {
        // any time the observer has a property that changes, call the `observeChange
        set: function set(val) {
          _this.observeChange(attrName, val);
        }
      });
    });
    return observer;
  };
  /**
   * Whenever an observed property changes
   * @param propName The property name
   * @param propValue The property value
   */


  KitchenComponent.prototype.observeChange = function (propName, propValue) {
    // set the observing flag
    this.observing = true; // set the internal value

    this[propName] = propValue;
    var s = new CustomEvent(propName + "-change", {
      bubbles: false,
      cancelable: false,
      detail: propValue
    }); // Dispatch this as a custom event.  This is being caught in `the-kitchen-angular` library and used for 2-way binding

    this.dispatchEvent(s); // unset the observing flag

    this.observing = false;
  };
  /**
   * Define the web component.  Do not error if it gets defined twice.
   */


  KitchenComponent.define = function () {
    if (customElements.get(this.tag) === undefined) {
      customElements.define(this.tag, this);
    } else {
      devOnlyWarn("The Kitchen: Web Component " + this.tag + " is already defined.");
    }
  };

  return KitchenComponent;
}(HTMLElement);

var AccordionComponent = function (_super) {
  __extends(AccordionComponent, _super);

  function AccordionComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = Accordion;
    _this.properties = new AccordionProps();
    _this.events = new AccordionEvents();
    return _this;
  }

  AccordionComponent.tag = 'xi-accordion';
  return AccordionComponent;
}(KitchenComponent);

var AccordionItemComponent = function (_super) {
  __extends(AccordionItemComponent, _super);

  function AccordionItemComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = AccordionItem;
    _this.properties = new AccordionItemProps();
    _this.events = new AccordionItemEvents();
    return _this;
  }

  AccordionItemComponent.tag = 'xi-accordion-item';
  return AccordionItemComponent;
}(KitchenComponent);

var AlertInlineMainComponent = function (_super) {
  __extends(AlertInlineMainComponent, _super);

  function AlertInlineMainComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = AlertInlineMain;
    _this.properties = new AlertInlineMainProps();
    _this.events = new AlertInlineMainEvents();
    return _this;
  }

  AlertInlineMainComponent.tag = 'xi-alert-inline-main';
  return AlertInlineMainComponent;
}(KitchenComponent);

var SnackBarComponent = function (_super) {
  __extends(SnackBarComponent, _super);

  function SnackBarComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = SnackBar;
    _this.properties = new SnackBarProps();
    _this.events = new SnackBarEvents();
    return _this;
  }

  SnackBarComponent.tag = 'xi-snack-bar';
  return SnackBarComponent;
}(KitchenComponent);

var SuccessToasterComponent = function (_super) {
  __extends(SuccessToasterComponent, _super);

  function SuccessToasterComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = SuccessToaster;
    _this.properties = new SuccessToasterProps();
    _this.events = new SuccessToasterEvents();
    return _this;
  }

  SuccessToasterComponent.tag = 'xi-success-toaster';
  return SuccessToasterComponent;
}(KitchenComponent);

var WarningPopupComponent = function (_super) {
  __extends(WarningPopupComponent, _super);

  function WarningPopupComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = WarningPopup;
    _this.remountOnObservedChange = true;
    _this.properties = new WarningPopupProps();
    _this.events = new WarningPopupEvents();
    return _this;
  }

  WarningPopupComponent.tag = 'xi-warning-popup';
  return WarningPopupComponent;
}(KitchenComponent);

var CheckboxComponent = function (_super) {
  __extends(CheckboxComponent, _super);

  function CheckboxComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.remountOnObservedChange = true;
    _this.renderer = Checkbox;
    _this.properties = new CheckboxProps();
    _this.events = new CheckboxEvents();
    return _this;
  }

  CheckboxComponent.tag = 'xi-checkbox';
  return CheckboxComponent;
}(KitchenComponent);

var DefaultButtonComponent = function (_super) {
  __extends(DefaultButtonComponent, _super);

  function DefaultButtonComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = DefaultButton;
    _this.properties = new DefaultButtonProps();
    _this.events = new DefaultButtonEvents();
    return _this;
  }

  DefaultButtonComponent.tag = 'xi-default-button';
  return DefaultButtonComponent;
}(KitchenComponent);

var FABComponent = function (_super) {
  __extends(FABComponent, _super);

  function FABComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = FAB;
    _this.properties = new FABProps();
    _this.events = new FABEvents();
    return _this;
  }

  FABComponent.tag = 'xi-fab';
  return FABComponent;
}(KitchenComponent);

var FilterButtonComponent = function (_super) {
  __extends(FilterButtonComponent, _super);

  function FilterButtonComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = FilterButton;
    _this.properties = new FilterButtonProps();
    _this.events = new FilterButtonEvents();
    return _this;
  }

  FilterButtonComponent.tag = 'xi-filter-button';
  return FilterButtonComponent;
}(KitchenComponent);

var HeadingButtonComponent = function (_super) {
  __extends(HeadingButtonComponent, _super);

  function HeadingButtonComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = HeadingButton;
    _this.properties = new HeadingButtonProps();
    _this.events = new HeadingButtonEvents();
    return _this;
  }

  HeadingButtonComponent.tag = 'xi-heading-button';
  return HeadingButtonComponent;
}(KitchenComponent);

var IconButtonComponent = function (_super) {
  __extends(IconButtonComponent, _super);

  function IconButtonComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = IconButton;
    _this.properties = new IconButtonProps();
    _this.events = new IconButtonEvents();
    return _this;
  }

  IconButtonComponent.tag = 'xi-icon-button';
  return IconButtonComponent;
}(KitchenComponent);

var SentimentButtonComponent = function (_super) {
  __extends(SentimentButtonComponent, _super);

  function SentimentButtonComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.remountOnObservedChange = true;
    _this.renderer = SentimentButton;
    _this.properties = new SentimentButtonProps();
    _this.events = new SentimentButtonEvents();
    return _this;
  }

  SentimentButtonComponent.tag = 'xi-sentiment-button';
  return SentimentButtonComponent;
}(KitchenComponent);

var CommentComponent = function (_super) {
  __extends(CommentComponent, _super);

  function CommentComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.remountOnObservedChange = true;
    _this.renderer = Comment;
    _this.properties = new CommentProps();
    _this.events = new CommentEvents();
    return _this;
  }

  CommentComponent.tag = 'xi-comment';
  return CommentComponent;
}(KitchenComponent);

var CondensedExperienceCardComponent = function (_super) {
  __extends(CondensedExperienceCardComponent, _super);

  function CondensedExperienceCardComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = CondensedExperienceCard;
    _this.properties = new CondensedExperienceCardProps();
    _this.events = new CondensedExperienceCardEvents();
    return _this;
  }

  CondensedExperienceCardComponent.tag = 'xi-condensed-experience-card';
  return CondensedExperienceCardComponent;
}(KitchenComponent);

var ExperienceCardComponent = function (_super) {
  __extends(ExperienceCardComponent, _super);

  function ExperienceCardComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.remountOnObservedChange = true;
    _this.renderer = ExperienceCard;
    _this.properties = new ExperienceCardProps();
    _this.events = new ExperienceCardEvents();
    return _this;
  }

  ExperienceCardComponent.tag = 'xi-experience-card';
  return ExperienceCardComponent;
}(KitchenComponent);

var ExperienceHeaderComponent = function (_super) {
  __extends(ExperienceHeaderComponent, _super);

  function ExperienceHeaderComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = ExperienceHeader;
    _this.properties = new ExperienceHeaderProps();
    _this.events = new ExperienceHeaderEvents();
    return _this;
  }

  ExperienceHeaderComponent.tag = 'xi-experience-header';
  return ExperienceHeaderComponent;
}(KitchenComponent);

var ChartWrapperComponent = function (_super) {
  __extends(ChartWrapperComponent, _super);

  function ChartWrapperComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = ChartWrapper;
    _this.remountOnObservedChange = true;
    _this.removeEmptySlots = true;
    _this.properties = new ChartWrapperProps();
    _this.events = new ChartWrapperEvents();
    return _this;
  }

  ChartWrapperComponent.tag = 'xi-chart-wrapper';
  return ChartWrapperComponent;
}(KitchenComponent);

var BarVariantChartComponent = function (_super) {
  __extends(BarVariantChartComponent, _super);

  function BarVariantChartComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = BarVariantChart;
    _this.properties = new BarVariantChartProps();
    _this.events = new BarVariantChartEvents();
    return _this;
  }

  BarVariantChartComponent.tag = 'xi-bar-variant-chart';
  return BarVariantChartComponent;
}(KitchenComponent);

var BigNumberComponent = function (_super) {
  __extends(BigNumberComponent, _super);

  function BigNumberComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.remountOnObservedChange = true;
    _this.renderer = BigNumber;
    _this.properties = new BigNumberProps();
    _this.events = new BigNumberEvents();
    return _this;
  }

  BigNumberComponent.tag = 'xi-big-number';
  return BigNumberComponent;
}(KitchenComponent);

var PieChartComponent = function (_super) {
  __extends(PieChartComponent, _super);

  function PieChartComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = PieChart;
    _this.properties = new PieChartProps();
    _this.events = new PieChartEvents();
    return _this;
  }

  PieChartComponent.tag = 'xi-pie-chart';
  return PieChartComponent;
}(KitchenComponent);

var AppSideDisplayComponent = function (_super) {
  __extends(AppSideDisplayComponent, _super);

  function AppSideDisplayComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = AppSideDisplay;
    _this.properties = new AppSideDisplayProps();
    _this.events = new AppSideDisplayEvents();
    return _this;
  }

  AppSideDisplayComponent.tag = 'xi-app-side-display';
  return AppSideDisplayComponent;
}(KitchenComponent);

var DrawerComponent = function (_super) {
  __extends(DrawerComponent, _super);

  function DrawerComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.remountOnObservedChange = true;
    _this.removeEmptySlots = true;
    _this.renderer = Drawer;
    _this.properties = new DrawerProps();
    _this.events = new DrawerEvents();
    _this.hasReactPortal = true;
    return _this;
  }

  DrawerComponent.tag = 'xi-drawer';
  return DrawerComponent;
}(KitchenComponent);

var SidePanelComponent = function (_super) {
  __extends(SidePanelComponent, _super);

  function SidePanelComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.remountOnObservedChange = true;
    _this.removeEmptySlots = true;
    _this.renderer = SidePanel;
    _this.properties = new SidePanelProps();
    _this.events = new SidePanelEvents();
    return _this;
  }

  SidePanelComponent.tag = 'xi-side-panel';
  return SidePanelComponent;
}(KitchenComponent);

var DropdownComponent = function (_super) {
  __extends(DropdownComponent, _super);

  function DropdownComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = Dropdown;
    _this.properties = new DropdownProps();
    _this.events = new DropdownEvents();
    return _this;
  }

  DropdownComponent.tag = 'xi-dropdown';
  return DropdownComponent;
}(KitchenComponent);

var ListComponent = function (_super) {
  __extends(ListComponent, _super);

  function ListComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = List;
    _this.properties = new ListProps();
    _this.events = new ListEvents();

    _this.preTranscludeContent = function (el, props, transcludedContent) {
      var _a;

      var select = ((_a = props === null || props === void 0 ? void 0 : props.select) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) || 'none';
      var color = props === null || props === void 0 ? void 0 : props.color;
      var listValue = props.value;
      var observer = props.observer;
      var slotContent = transcludedContent[0];
      var listItems = [];

      if (select === 'single' && Array.isArray(listValue)) {
        listValue = listValue[0];
        observer.value = listValue;
      } else if (['multi', 'multiple'].indexOf(select) >= 0 && !Array.isArray(listValue)) {
        listValue = [listValue];
        observer.value = listValue;
      }

      var liCheckedChange = function liCheckedChange(e) {
        var value = e.target.value;

        if (select === 'single') {
          if (listValue === value) {
            observer.value = null;
            listValue = null;
          } else {
            listItems.filter(function (li) {
              return li.value !== value && li.checked;
            }).forEach(function (li) {
              return li.checked = false;
            });
            observer.value = value;
            listValue = value;
          }
        } else {
          if (!listValue || listValue.length === 0) {
            listValue = [value];
          } else if (listValue.indexOf(value) >= 0) {
            listValue = __spreadArray([], __read(listValue.filter(function (v) {
              return v !== value;
            })));
          } else {
            listValue = __spreadArray(__spreadArray([], __read(listValue)), [value]);
          }

          observer.value = __spreadArray([], __read(listValue));
        }
      };

      for (var index = 0; index < slotContent.children.length; index++) {
        var element = slotContent.children.item(index);

        if (element && element.tagName.toLocaleLowerCase() === 'xi-list-item') {
          listItems.push(element);
          element.addEventListener('checked-change', liCheckedChange);

          if (select !== undefined) {
            var elementProps = element;
            var value = elementProps.value;
            element.setAttribute('select', select);

            if (select === 'single') {
              if (value === listValue) {
                elementProps.checked = true;
              } else {
                elementProps.checked = false;
              }
            } else {
              if (listValue && listValue.indexOf(value) >= 0) {
                elementProps.checked = true;
              } else {
                elementProps.checked = false;
              }
            }
          }

          if (color !== undefined) {
            element.setAttribute('color', color);
          }
        }
      }

      if (props.hasSearch) {
        var noResultsDiv = el.querySelector('#no-results-div');

        if (noResultsDiv) {
          if (slotContent.children.length > 0) {
            noResultsDiv.style.display = 'none';
          } else {
            noResultsDiv.style.display = '';
          }
        }
      }

      return function () {
        listItems.forEach(function (li) {
          return li.removeEventListener('checked-change', liCheckedChange);
        });
      };
    };

    return _this;
  }

  ListComponent.tag = 'xi-list';
  return ListComponent;
}(KitchenComponent);

var ListItemComponent = function (_super) {
  __extends(ListItemComponent, _super);

  function ListItemComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.remountOnObservedChange = true;
    _this.renderer = ListItem;
    _this.properties = new ListItemProps();
    _this.events = new ListItemEvents();
    return _this;
  }

  ListItemComponent.tag = 'xi-list-item';
  return ListItemComponent;
}(KitchenComponent);

var AudioPlayerComponent = function (_super) {
  __extends(AudioPlayerComponent, _super);

  function AudioPlayerComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = AudioPlayer;
    _this.properties = new AudioPlayerProps();
    _this.events = new AudioPlayerEvents();
    return _this;
  }

  AudioPlayerComponent.tag = 'xi-audio-player';
  return AudioPlayerComponent;
}(KitchenComponent);

var ImageCarouselComponent = function (_super) {
  __extends(ImageCarouselComponent, _super);

  function ImageCarouselComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = ImageCarousel;
    _this.properties = new ImageCarouselProps();
    _this.events = new ImageCarouselEvents();
    return _this;
  }

  ImageCarouselComponent.tag = 'xi-image-carousel';
  return ImageCarouselComponent;
}(KitchenComponent);

var VideoPlayerComponent = function (_super) {
  __extends(VideoPlayerComponent, _super);

  function VideoPlayerComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = VideoPlayer;
    _this.properties = new VideoPlayerProps();
    _this.events = new VideoPlayerEvents();
    return _this;
  }

  VideoPlayerComponent.tag = 'xi-video-player';
  return VideoPlayerComponent;
}(KitchenComponent);

var GenericModalComponent = function (_super) {
  __extends(GenericModalComponent, _super);

  function GenericModalComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = GenericModal;
    _this.remountOnObservedChange = true;
    _this.properties = new GenericModalProps();
    _this.events = new GenericModalEvents();
    _this.hasReactPortal = true;
    _this.removeEmptySlots = true;
    return _this;
  }

  GenericModalComponent.tag = 'xi-generic-modal';
  return GenericModalComponent;
}(KitchenComponent);

var CalendarComponent = function (_super) {
  __extends(CalendarComponent, _super);

  function CalendarComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = Calendar;
    _this.properties = new CalendarProps();
    _this.events = new CalendarEvents();
    return _this;
  }

  CalendarComponent.tag = 'xi-calendar';
  return CalendarComponent;
}(KitchenComponent);

var ColorPickerComponent = function (_super) {
  __extends(ColorPickerComponent, _super);

  function ColorPickerComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = ColorPicker;
    _this.properties = new ColorPickerProps();
    _this.events = new ColorPickerEvents();
    return _this;
  }

  ColorPickerComponent.tag = 'xi-color-picker';
  return ColorPickerComponent;
}(KitchenComponent);

var DatePickerComponent = function (_super) {
  __extends(DatePickerComponent, _super);

  function DatePickerComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = DatePicker;
    _this.properties = new DatePickerProps();
    _this.events = new DatePickerEvents();
    return _this;
  }

  DatePickerComponent.tag = 'xi-date-picker';
  return DatePickerComponent;
}(KitchenComponent);

var LeftRightPickerComponent = function (_super) {
  __extends(LeftRightPickerComponent, _super);

  function LeftRightPickerComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.__onItemsChangedParams__ = ['availableItems', 'selectedItems'];
    _this.renderer = LeftRightPicker;
    _this.properties = new LeftRightPickerProps();
    _this.events = new LeftRightPickerEvents();
    return _this;
  }

  LeftRightPickerComponent.tag = 'xi-left-right-picker';
  return LeftRightPickerComponent;
}(KitchenComponent);

var TreePickerComponent = function (_super) {
  __extends(TreePickerComponent, _super);

  function TreePickerComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = TreePicker;
    _this.properties = new TreePickerProps();
    _this.events = new TreePickerEvents();
    return _this;
  }

  TreePickerComponent.tag = 'xi-tree-picker';
  return TreePickerComponent;
}(KitchenComponent);

var CloudPillComponent = function (_super) {
  __extends(CloudPillComponent, _super);

  function CloudPillComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = CloudPill;
    _this.properties = new CloudPillProps();
    _this.events = new CloudPillEvents();
    return _this;
  }

  CloudPillComponent.tag = 'xi-cloud-pill';
  return CloudPillComponent;
}(KitchenComponent);

var CustomPillComponent = function (_super) {
  __extends(CustomPillComponent, _super);

  function CustomPillComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = CustomPill;
    _this.properties = new CustomPillProps();
    _this.events = new CustomPillEvents();
    return _this;
  }

  CustomPillComponent.tag = 'xi-custom-pill';
  return CustomPillComponent;
}(KitchenComponent);

var RadioComponent = function (_super) {
  __extends(RadioComponent, _super);

  function RadioComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = Radio;
    _this.properties = new RadioProps();
    _this.remountOnObservedChange = true;
    _this.events = new RadioEvents();
    return _this;
  }

  RadioComponent.tag = 'xi-radio';
  return RadioComponent;
}(KitchenComponent);

var SearchBoxComponent = function (_super) {
  __extends(SearchBoxComponent, _super);

  function SearchBoxComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = SearchBox;
    _this.properties = new SearchBoxProps();
    _this.events = new SearchBoxEvents();
    return _this;
  }

  SearchBoxComponent.tag = 'xi-search-box';
  return SearchBoxComponent;
}(KitchenComponent);

var SliderComponent = function (_super) {
  __extends(SliderComponent, _super);

  function SliderComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = Slider;
    _this.properties = new SliderProps();
    _this.events = new SliderEvents();
    return _this;
  }

  SliderComponent.tag = 'xi-slider';
  return SliderComponent;
}(KitchenComponent);

var ToggleSwitchComponent = function (_super) {
  __extends(ToggleSwitchComponent, _super);

  function ToggleSwitchComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.remountOnObservedChange = true;
    _this.renderer = ToggleSwitch;
    _this.properties = new ToggleSwitchProps();
    _this.events = new ToggleSwitchEvents();
    return _this;
  }

  ToggleSwitchComponent.tag = 'xi-toggle-switch';
  return ToggleSwitchComponent;
}(KitchenComponent);

var ToggleTextComponent = function (_super) {
  __extends(ToggleTextComponent, _super);

  function ToggleTextComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.remountOnObservedChange = true;
    _this.renderer = ToggleText;
    _this.properties = new ToggleTextProps();
    _this.events = new ToggleTextEvents();
    return _this;
  }

  ToggleTextComponent.tag = 'xi-toggle-text';
  return ToggleTextComponent;
}(KitchenComponent);

var HorizontalTabBarComponent = function (_super) {
  __extends(HorizontalTabBarComponent, _super);

  function HorizontalTabBarComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = HorizontalTabBar;
    _this.properties = new HorizontalTabBarProps();
    _this.events = new HorizontalTabBarEvents();
    return _this;
  }

  HorizontalTabBarComponent.tag = 'xi-horizontal-tab-bar';
  return HorizontalTabBarComponent;
}(KitchenComponent);

var TabBarComponent = function (_super) {
  __extends(TabBarComponent, _super);

  function TabBarComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = TabBar;
    _this.properties = new TabBarProps();
    _this.events = new TabBarEvents();
    return _this;
  }

  TabBarComponent.tag = 'xi-tab-bar';
  return TabBarComponent;
}(KitchenComponent);

var VerticalTabBarComponent = function (_super) {
  __extends(VerticalTabBarComponent, _super);

  function VerticalTabBarComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = VerticalTabBar;
    _this.properties = new VerticalTabBarProps();
    _this.events = new VerticalTabBarEvents();
    return _this;
  }

  VerticalTabBarComponent.tag = 'xi-vertical-tab-bar';
  return VerticalTabBarComponent;
}(KitchenComponent);

var TableComponent = function (_super) {
  __extends(TableComponent, _super);

  function TableComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = Table;
    _this.properties = new TableProps();
    _this.events = new TableEvents();
    return _this;
  }

  TableComponent.tag = 'xi-table';
  return TableComponent;
}(KitchenComponent);

var EditableTextComponent = function (_super) {
  __extends(EditableTextComponent, _super);

  function EditableTextComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = EditableText;
    _this.properties = new EditableTextProps();
    _this.events = new EditableTextEvents();
    return _this;
  }

  EditableTextComponent.tag = 'xi-editable-text';
  return EditableTextComponent;
}(KitchenComponent);

var InputFieldComponent = function (_super) {
  __extends(InputFieldComponent, _super);

  function InputFieldComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = InputField;
    _this.properties = new InputFieldProps();
    _this.events = new InputFieldEvents();
    return _this;
  }

  InputFieldComponent.tag = 'xi-input-field';
  return InputFieldComponent;
}(KitchenComponent);

var TextAreaComponent = function (_super) {
  __extends(TextAreaComponent, _super);

  function TextAreaComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = TextArea;
    _this.properties = new TextAreaProps();
    _this.events = new TextAreaEvents();
    return _this;
  }

  TextAreaComponent.tag = 'xi-text-area';
  return TextAreaComponent;
}(KitchenComponent);

var BasicTileComponent = function (_super) {
  __extends(BasicTileComponent, _super);

  function BasicTileComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = BasicTile;
    _this.properties = new BasicTileProps();
    _this.events = new BasicTileEvents();
    return _this;
  }

  BasicTileComponent.tag = 'xi-basic-tile';
  return BasicTileComponent;
}(KitchenComponent);

var WaveTileComponent = function (_super) {
  __extends(WaveTileComponent, _super);

  function WaveTileComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = WaveTile;
    _this.properties = new WaveTileProps();
    _this.events = new WaveTileEvents();
    return _this;
  }

  WaveTileComponent.tag = 'xi-wave-tile';
  return WaveTileComponent;
}(KitchenComponent);

var ToolTipContentComponent = function (_super) {
  __extends(ToolTipContentComponent, _super);

  function ToolTipContentComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = ToolTipContent;
    _this.properties = new ToolTipContentProps();
    _this.events = new ToolTipContentEvents();
    return _this;
  }

  ToolTipContentComponent.tag = 'xi-tool-tip-content';
  return ToolTipContentComponent;
}(KitchenComponent);

var AppTitleBarComponent = function (_super) {
  __extends(AppTitleBarComponent, _super);

  function AppTitleBarComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = AppTitleBar;
    _this.properties = new AppTitleBarProps();
    _this.events = new AppTitleBarEvents();
    return _this;
  }

  AppTitleBarComponent.tag = 'xi-app-title-bar';
  return AppTitleBarComponent;
}(KitchenComponent);

var XIAnimationComponent = function (_super) {
  __extends(XIAnimationComponent, _super);

  function XIAnimationComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = XIAnimation;
    _this.properties = new XIAnimationProps();
    _this.events = new XIAnimationEvents();
    return _this;
  }

  XIAnimationComponent.tag = 'xi-animation';
  return XIAnimationComponent;
}(KitchenComponent);

var XIAppIconComponent = function (_super) {
  __extends(XIAppIconComponent, _super);

  function XIAppIconComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = XIAppIcon;
    _this.properties = new XIAppIconProps();
    _this.events = new XIAppIconEvents();
    return _this;
  }

  XIAppIconComponent.tag = 'xi-app-icon';
  return XIAppIconComponent;
}(KitchenComponent);

var XIIconComponent = function (_super) {
  __extends(XIIconComponent, _super);

  function XIIconComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = XIIcon;
    _this.properties = new XIIconProps();
    _this.events = new XIIconEvents();
    return _this;
  }

  XIIconComponent.tag = 'xi-icon';
  return XIIconComponent;
}(KitchenComponent);

var XISVGComponent = function (_super) {
  __extends(XISVGComponent, _super);

  function XISVGComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderer = XISVG;
    _this.properties = new XISVGProps();
    _this.events = new XISVGEvents();
    return _this;
  }

  XISVGComponent.tag = 'xi-svg';
  return XISVGComponent;
}(KitchenComponent); // IMPORTANT: This file is auto generated.


watchForEvents();
export { Accordion, AccordionComponent, AccordionEvents, AccordionItem, AccordionItemComponent, AccordionItemEvents, AccordionItemProps, AccordionProps, AlertInlineMain, AlertInlineMainComponent, AlertInlineMainEvents, AlertInlineMainProps, AppSideDisplay, AppSideDisplayComponent, AppSideDisplayEvents, AppSideDisplayProps, AppTitleBar, AppTitleBarComponent, AppTitleBarEvents, AppTitleBarProps, AudioPlayer, AudioPlayerComponent, AudioPlayerEvents, AudioPlayerProps, BarVariantChart, BarVariantChartComponent, BarVariantChartEvents, BarVariantChartProps, BasicTile, BasicTileComponent, BasicTileEvents, BasicTileProps, BigNumber, BigNumberComponent, BigNumberEvents, BigNumberProps, CHART_FONT_SIZES, CHART_TYPE, Calendar, CalendarComponent, CalendarEvents, CalendarProps, ChartWrapper, ChartWrapperComponent, ChartWrapperEvents, ChartWrapperProps, Checkbox, CheckboxComponent, CheckboxEvents, CheckboxProps, CloudPill, CloudPillComponent, CloudPillEvents, CloudPillProps, ColorPicker, ColorPickerComponent, ColorPickerEvents, ColorPickerProps, Comment, CommentComponent, CommentEvents, CommentProps, CondensedExperienceCard, CondensedExperienceCardComponent, CondensedExperienceCardEvents, CondensedExperienceCardProps, CustomPill, CustomPillComponent, CustomPillEvents, CustomPillProps, DatePicker, DatePickerComponent, DatePickerEvents, DatePickerProps, DefaultButton, DefaultButtonComponent, DefaultButtonEvents, DefaultButtonProps, DefaultPreselectedCalendarListIds, Drawer, DrawerComponent, DrawerEvents, DrawerProps, Dropdown, DropdownButtonAlignment, DropdownComponent, DropdownEvents, DropdownProps, EditableText, EditableTextComponent, EditableTextEvents, EditableTextProps, EnumClouds, EnumErrorStates, EnumLottiesProd, ExperienceCard, ExperienceCardComponent, ExperienceCardEvents, ExperienceCardProps, ExperienceHeader, ExperienceHeaderComponent, ExperienceHeaderEvents, ExperienceHeaderProps, FAB, FABComponent, FABEvents, FABProps, FilterButton, FilterButtonComponent, FilterButtonEvents, FilterButtonProps, GenericModal, GenericModalComponent, GenericModalEvents, GenericModalProps, HeadingButton, HeadingButtonComponent, HeadingButtonEvents, HeadingButtonProps, HighchartsAngularStyle, HighchartsDefaultTheme, HighchartsStyleMerge, HorizontalTabBar, HorizontalTabBarComponent, HorizontalTabBarEvents, HorizontalTabBarProps, IconButton, IconButtonComponent, IconButtonEvents, IconButtonProps, ImageCarousel, ImageCarouselComponent, ImageCarouselEvents, ImageCarouselProps, InputField, InputFieldComponent, InputFieldEvents, InputFieldProps, LeftRightPicker, LeftRightPickerComponent, LeftRightPickerEvents, LeftRightPickerProps, List, ListComponent, ListEvents, ListItem, ListItemComponent, ListItemEvents, ListItemProps, ListProps, MotionDiv, PieChart, PieChartComponent, PieChartEvents, PieChartProps, Radio, RadioComponent, RadioEvents, RadioProps, SearchBox, SearchBoxComponent, SearchBoxEvents, SearchBoxProps, SelectAllState, SentimentButton, SentimentButtonComponent, SentimentButtonEvents, SentimentButtonProps, SentimentEnum, SidePanel, SidePanelComponent, SidePanelEvents, SidePanelProps, Slider, SliderComponent, SliderEvents, SliderProps, SnackBar, SnackBarComponent, SnackBarEvents, SnackBarProps, SuccessToaster, SuccessToasterComponent, SuccessToasterEvents, SuccessToasterProps, TabBar, TabBarComponent, TabBarEvents, TabBarProps, Table, TableComponent, TableEvents, TableProps, TextArea, TextAreaComponent, TextAreaEvents, TextAreaProps, ToggleSwitch, ToggleSwitchComponent, ToggleSwitchEvents, ToggleSwitchProps, ToggleText, ToggleTextComponent, ToggleTextEvents, ToggleTextProps, ToolTipContent, ToolTipContentComponent, ToolTipContentEvents, ToolTipContentProps, ToolTipWrapper, TreePicker, TreePickerComponent, TreePickerEvents, TreePickerProps, VerticalTabBar, VerticalTabBarComponent, VerticalTabBarEvents, VerticalTabBarProps, VideoPlayer, VideoPlayerComponent, VideoPlayerEvents, VideoPlayerProps, WarningPopup, WarningPopupComponent, WarningPopupEvents, WarningPopupProps, WaveTile, WaveTileComponent, WaveTileEvents, WaveTileProps, XIAnimation, XIAnimationComponent, XIAnimationEvents, XIAnimationProps, XIAppIcon, XIAppIconComponent, XIAppIconEvents, XIAppIconProps, XIColorUsage, XIColors, XIGradients, XIIcon, XIIconComponent, XIIconEvents, XIIconProps, XISVG, XISVGComponent, XISVGEvents, XISVGProps, XIShadowsDown, XIShadowsLeft, XIShadowsRight, XIShadowsUp, XITransitions, _AdminOptions, _AlertsColorsOptions, _AppIconsColorOptions, _AppIconsOptions, _AppIconsWhiteOptions, _BarVariantTypesOptions, _BigNumberAlignmentsOptions, _BigNumberColorsOptions, _BigNumberSizesOptions, _ButtonColorsOptions, _ButtonInputType, _ButtonSizesOptions, _ButtonTypesOptions, _CXICOptions, _CXOptions, _CalendarModesOptions, _CalendarOutlinesOptions, _ClockDirectionOptions, _CloudsOptions, _ColorNamesOptions, _ColorsOptions, _ComponentSizesOptions, _ContrastsOptions, _DisabledOptions, _DrawerSizesOptions, _DropdownButtonTypesOptions, _DropdownSelectsOptions, _EXOptions, _ErrorStatesOptions, _ExperienceCardCasesOptions, _ExperienceCardIconButtonTypesOptions, _ExperienceCardLogosOptions, _ExperienceCardSentimentsOptions, _FabSizesOptions, _FilterButtonFocus, _FilterButtonTypes, _IconColorsOptions, _IconsOptions, _InvalidOptions, _LeftRightOptions, _LottiesOptions, _MXOptions, _MenuButtonSizesOptions, _OnOffOptions, _PXOptions, _SVGsOptions, _SentimentsOptions, _ShadowsOptions, _SideOptions, _SnackBarModesOptions, _StatusColorNamesOptions, _SystemOptions, _TextAlignmentsOptions, _TextColorsOptions, _TextInputTypeOptions, _TextLevelsOptions, _TextSizesOptions, _TextWeightsOptions, _TextWrapsOptions, _TonesOptions, _WaveTileSizeOptions, _WhiteOptions, _XICloudsOptions, defaultCalendarPreselectedOptions, defaultLocalization, defaultPreselectedCalendarListOptions, defaultText, fns };